/* webapp/script.js v8.0 - FULL STABLE VERSION */

// 🖼 ФАЗА 2 (техдолг, 03.09.2026): локальные заглушки изображений.
// Раньше по файлу было разбросано семь захардкоженных ссылок на сторонние
// сервисы-заглушки — via.placeholder.com (/100, /150, /600x300, /800x400) и
// placehold.co. Проблема не столько в самих сервисах, сколько в том, ГДЕ они
// стояли: PLACEHOLDER_LOT подставляется в списках лотов и в img.onerror, то
// есть на экране с 20 карточками без фото (или с битыми фото площадки) это
// было до 20 запросов к чужому домену, который отвечает медленно и время от
// времени лежит целиком. Теперь оба файла отдаются с нашего же домена
// (webapp/placeholder-avatar.svg, webapp/placeholder-lot.svg), весят меньше
// килобайта и масштабируются под любой размер без потерь.
// Константы, а не строки по месту, — чтобы заглушку можно было поменять в
// одной точке, а не искать по всему файлу, как это было до сих пор.
const PLACEHOLDER_AVATAR = '/static/placeholder-avatar.svg';
const PLACEHOLDER_LOT = '/static/placeholder-lot.svg';

// ДОБАВЛЕНО (TASK4 4.5, DESIGN_MASTER_PROMPT.md §6, TASK4_HOME_PROMPT.md §6):
// категорийные заглушки — 7 SVG в webapp/placeholders/ (раздаются как
// /static/placeholders/*.svg через тот же StaticFiles-маунт WEBAPP_DIR, что
// и placeholder-lot.svg; см. api_server.py). Только для сайта:
// renderLotCardSite (4.6) и renderLotRow (thumb) — createCard()/Mini App
// продолжают использовать PLACEHOLDER_LOT (§12, эта карта туда не идёт).
// 'Прочее' в l.category приходит с заглавной буквы (OTHER_CATEGORY в
// taxonomy.py, единственное исключение среди канонических категорий) —
// toLowerCase() сводит её к общему ключу словаря, отдельного case не нужно.
const CATEGORY_PLACEHOLDERS = {
    'авто': '/static/placeholders/auto.svg',
    'квартиры': '/static/placeholders/apartment.svg',
    'дома': '/static/placeholders/house.svg',
    'участки': '/static/placeholders/land.svg',
    'коммерция': '/static/placeholders/commercial.svg',
    'паркинг': '/static/placeholders/parking.svg',
    'прочее': '/static/placeholders/other.svg',
};
function getPlaceholderFor(category) {
    const key = (category || '').toLowerCase();
    return CATEGORY_PLACEHOLDERS[key] || CATEGORY_PLACEHOLDERS['прочее'];
}

// 🔥 P0 аудита фронтенда: фото лотов с etp.adilet.gov.kz хотлинкались в
// оригинальном разрешении — до 1.3 МБ на миниатюру. Платного решения
// (Cloudflare Images/Workers) нет — денег на это нет, — поэтому ресайз идёт
// через собственный бесплатный прокси на этом же сервере (/api/img,
// Pillow), см. api_server.py::image_proxy. Sauda уже отдаёт свои фото через
// собственный ресайз-прокси (sauda.e-qazyna.kz/image-proxy/...) — трогать
// не нужно, поэтому список хостов — только ETP.
// TASK9 9.5: sauda.e-qazyna.kz добавлен — измерено с прод-сервера
// (curl -sI, с браузерным User-Agent/Referer и без), хост отдаёт
// идентичный ответ в обоих случаях, не блокирует серверные запросы без
// заголовков. Тот же _IMG_PROXY_ALLOWED_HOSTS в api_server.py.
const IMG_PROXY_HOSTS = ['etp.adilet.gov.kz', 'sauda.e-qazyna.kz'];
function proxyImg(url, w) {
    if (!url) return url;
    try {
        const u = new URL(url, location.href);
        if (IMG_PROXY_HOSTS.includes(u.hostname)) {
            return `/api/img?url=${encodeURIComponent(url)}&w=${w}`;
        }
    } catch (e) { /* некорректный URL — отдаём как есть, сработает onerror на <img> */ }
    return url;
}

const tg = window.Telegram.WebApp;
// ДОБАВЛЕНО (аудит "мини-апп ведёт себя как сайт"): tg.ready() не вызывался
// нигде в проекте. Это сигнал "интерфейс готов" — пока его нет, Telegram
// дольше держит собственный сплэш поверх приложения. Должен идти первым,
// до остальных вызовов SDK.
tg.ready();
tg.expand();
tg.setHeaderColor('#0f172a');
tg.setBackgroundColor('#0f172a');

// ДОБАВЛЕНО (тот же аудит): вертикальные свайпы отключаем СРАЗУ и на всё
// приложение, а не только внутри карты, как было раньше. Свайп вниз по
// прокрученному экрану закрывал мини-апп посреди работы — главное, из-за
// чего он ощущался веб-страницей, а не приложением.
//
// IS_TELEGRAM объявлен ниже по файлу, поэтому здесь смотрим на tg.initData
// напрямую — это ровно то же условие.
//
// Флаг нужен из-за closeMapModal(): он безусловно звал enableVerticalSwipes()
// и первым же закрытием карты возвращал свайпы на весь остаток сеанса,
// отменяя это отключение. См. парную правку там.
let SWIPES_DISABLED_GLOBALLY = false;
if (tg.initData && tg.isVersionAtLeast && tg.isVersionAtLeast('7.7') && tg.disableVerticalSwipes) {
    tg.disableVerticalSwipes();
    SWIPES_DISABLED_GLOBALLY = true;
}

// 🔥 НАЙДЕНО (аудит "пустой тост на карте лотов", подтверждено вживую через
// Playwright): tg.showAlert()/tg.showConfirm() из официального
// telegram-web-app.js ВСЕГДА делегируют в showPopup(), а тот требует Bot API
// ≥6.2 — при более старой версии не показывает никакой fallback, а бросает
// необработанное исключение "WebAppMethodUnsupported". Вне настоящего
// Telegram (сайт, обычный браузер) tg.version всегда "6.0" (SDK не знает,
// что работает не в клиенте), поэтому КАЖДЫЙ вызов showAlert/showConfirm на
// сайте до сих пор падал в консоль без единого пикселя UI — ни ошибки
// фильтра, ни лимит тарифа, ни подтверждение "убрать завершённые из
// избранного" на сайте никто не видел (кнопка "Рядом" на карте — из-за этого
// же исключения — вдобавок навсегда оставалась disabled, см. requestNearMe).
// В самом Telegram версия клиента почти всегда ≥6.2, так что там код ниже
// не подменяет ничего — оригинальные методы Telegram остаются как есть.
if (!tg.isVersionAtLeast || !tg.isVersionAtLeast('6.2')) {
    tg.showAlert = (message, callback) => {
        window.alert(message);
        if (callback) callback();
    };
    tg.showConfirm = (message, callback) => {
        const confirmed = window.confirm(message);
        if (callback) callback(confirmed);
    };
}

// 🔐 ВХОД: два источника личности пользователя, один и тот же аккаунт.
// 1. Внутри Telegram Mini App — tg.initDataUnsafe.user.id доступен сразу,
//    initData подписывается Telegram заново при каждом открытии (backend
//    проверяет её на каждый чувствительный запрос — см. api_server.py).
// 2. В обычном браузере (сайт-площадка, вне Telegram) — initData пустая.
//    Личность подтверждается ОДИН РАЗ через Telegram Login Widget (см.
//    #screen-login в index.html и renderLoginGate() ниже), после чего
//    сервер сам выдаёт сессионную куку и мы узнаём userId через
//    GET /api/auth/session. До этого момента userId неизвестен — поэтому
//    let, а не const, как было раньше.
let userId = tg.initDataUnsafe?.user?.id;
const IS_TELEGRAM = Boolean(tg.initData);
// Отчёт об анализе рисуется КЛАССИЧЕСКОЙ разметкой (partials/report_classic.html) на обеих поверхностях —
// владелец, 2026-10-27: люди просили вернуть вид, который был в Mini App до 2026-10-01 (19a209f). Ветки
// REPORT_LEGACY_MARKUP в renderInAppReport() — та самая разметка; блоки, где она показывала сырые цифры и слова
// ИИ (обоснование цены, подписи сценариев, рынок 20/60/20, аналоги ИИ, шаблонное «Имеются обременения»), теперь
// берут данные движка / писателя / выборки объявлений (classic* ниже). Отчёт v2 (renderInAppReportSite(),
// renderReportV2(), редактор финмодели) остаётся в коде и не вызывается; вернуть его — false здесь +
// screens/analysis.html в обеих оболочках + убрать class="report-classic" в base.html.
const REPORT_LEGACY_MARKUP = true;
// НАЙДЕНО (жалоба "мелькает окно входа при переключении вкладок",
// 03.09.2026): в браузере (вне Telegram) userId остаётся undefined до тех
// пор, пока не отработает асинхронная проверка сессионной куки в
// ensureAuthenticated() (см. ниже, GET /api/auth/session). Если посетитель
// кликал по Избранному/Базе AI/Профилю в это окно — до ответа сервера —
// switchScreen() видел "userId ещё не задан" как "гость без сессии" и на
// мгновение показывал экран входа, а через мгновение ensureAuthenticated()
// дозагружался и сам же его прятал: со стороны это выглядело как мелькание.
// authChecked отличает "мы ещё не знаем" от "мы точно знаем, что гость" —
// switchScreen() ждёт его, а не решает по ещё неполным данным.
let authChecked = false;

// 🔥 Единственный "переключатель" между компактным мобильным видом Mini App
// и Dashboard/SaaS-видом сайта (сайдбар, топбар — см. webapp/dashboard.css).
// Один и тот же index.html/script.js обслуживает оба контекста (см.
// api_server.py::_render_app) — разница только в вёрстке под этим классом,
// никакой отдельной логики или дублирующего JS-файла для сайта нет.
document.documentElement.classList.toggle('is-browser', !IS_TELEGRAM);
document.documentElement.classList.toggle('is-miniapp', IS_TELEGRAM);  // см. комментарий в partials/base.html

// 🔐 Криптографическая подпись пользовательских запросов.
// Backend (require_self/require_admin/login_user в api_server.py) проверяет
// подлинность запроса по заголовку X-Telegram-Init-Data (подписанная ботом
// строка initData), а НЕ доверяет query/body-параметрам (включая user_id)
// как таковым. Раньше заголовок ставился только для /api/admin*,
// /api/billing/buy и /api/auth/login — а ~30 остальных пользовательских
// ручек (/api/user/{id}, /api/analyze, /api/favorites/*, /api/lots и т.д.)
// принимали user_id из query/body без проверки происхождения запроса вовсе.
// Теперь backend требует эту проверку (см. require_self) везде, где читаются
// или списываются личные данные, — так что заголовок должен уходить на
// КАЖДЫЙ запрос к /api/, а не на отдельный список ручек.
// Вне Telegram (браузер) tg.initData всегда пустая строка — backend в этом
// случае падает на проверку сессионной куки (Telegram Login Widget, см.
// #screen-login), так что пустой заголовок здесь ничего не ломает.
const _nativeFetch = window.fetch.bind(window);
window.fetch = (input, init = {}) => {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    if (url.startsWith('/api/')) {
        init = {
            ...init,
            headers: { ...(init.headers || {}), 'X-Telegram-Init-Data': tg.initData || '' }
        };
    }
    return _nativeFetch(input, init);
};

// --- MOTION INFRASTRUCTURE (Phase 1) ---
// Единый флаг: уважаем системную настройку "меньше анимаций" везде, где
// добавляется GSAP-анимация. Каждый новый gsap-вызов ниже обёрнут в
// if (!REDUCE_MOTION) {...} else {...мгновенная установка финального состояния...}
const REDUCE_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
// GSAP может не подгрузиться (сеть/CDN) — вся анимационная логика ниже
// защищена проверкой typeof gsap, чтобы падение CDN никогда не ломало
// навигацию/рендер данных (см. гайдлайны Phase 1-4).
// ДОБАВЛЕНО (Stage 4, критический путь): подгрузка стороннего скрипта по
// требованию. Возвращает промис, который резолвится, когда скрипт выполнен;
// повторные вызовы с тем же адресом переиспользуют первый промис, поэтому
// файл скачивается ровно один раз, сколько бы раз его ни попросили.
//
// Нужен для Chart.js: во всём файле он используется в одном месте — графике
// финансовой модели внутри отчёта по лоту, — а весит ~200 КБ. Держать его в
// критическом пути каждой загрузки ради экрана, который открывает
// меньшинство сессий, незачем.
const _loadedScripts = new Map();
function loadScriptOnce(url) {
    if (_loadedScripts.has(url)) return _loadedScripts.get(url);
    const p = new Promise((resolve, reject) => {
        const el = document.createElement('script');
        el.src = url;
        el.async = true;
        el.onload = () => resolve();
        el.onerror = () => {
            // Снимаем из кэша: сеть могла моргнуть, следующая попытка
            // должна иметь право сходить заново, а не залипнуть навсегда.
            _loadedScripts.delete(url);
            reject(new Error('Не удалось загрузить ' + url));
        };
        document.head.appendChild(el);
    });
    _loadedScripts.set(url, p);
    return p;
}

// ИЗМЕНЕНО (P2.3 аудита, 11.09.2026): раньше адрес был без версии
// (".../npm/chart.js" — jsdelivr резолвил в "latest" на момент запроса,
// то есть график мог молча получить breaking-changes новой мажорной версии
// без единой правки в этом файле) и с внешнего CDN. Теперь зафиксированная
// версия (4.5.1 — та, что реально была "latest" на момент самохостинга) из
// /static/vendor — версия в самом пути, отдельного ?v= не нужно: смена
// версии = новая папка = новый URL, кэш сам инвалидируется.
const CHART_JS_URL = '/static/vendor/chart.js/4.5.1/chart.umd.min.js';

const HAS_GSAP = () => typeof gsap !== 'undefined';

// Универсальный counter-up хелпер: анимирует число от 0 (или текущего) до
// target и пишет его в el.textContent через formatFn на каждом кадре.
// Используется для score-кольца (Phase 4) и финансовых показателей.
function animateCountUp(el, target, opts = {}) {
    const duration = opts.duration || 0.7;
    const ease = opts.ease || 'power2.out';
    const formatFn = opts.formatFn || (v => Math.round(v).toString());
    if (!el) return;
    // document.hidden: вкладка/вебвью сейчас не в фокусе — requestAnimationFrame
    // (на котором держится GSAP-тикер) в таком состоянии либо не тикает вовсе,
    // либо тикает очень редко, и число застревает на промежуточном значении на
    // неопределённое время. Не начинаем анимацию впустую — сразу пишем финал.
    // !IS_TELEGRAM (TASK7 7.3, §10 MUST NOT): "motion on money is decoration" —
    // на сайте всегда статично, тем же путём, что и уже существующий
    // reduce-motion фолбэк (не новая ветка поведения, а расширение условия,
    // Mini App не тронут).
    if (REDUCE_MOTION || !HAS_GSAP() || document.hidden || !IS_TELEGRAM) {
        el.textContent = formatFn(target);
        return;
    }
    try {
        const obj = { val: 0 };
        gsap.to(obj, {
            val: target,
            duration,
            ease,
            onUpdate: () => { el.textContent = formatFn(obj.val); },
            onComplete: () => { el.textContent = formatFn(target); }
        });
    } catch (e) {
        el.textContent = formatFn(target);
    }
}

// Stagger-reveal для только что добавленных карточек в грид (Phase 3).
// Вызывается ПОСЛЕ appendChild(fragment) с массивом/NodeList свежедобавленных
// элементов. На больших пачках (>20) анимация пропускается — сразу видимое
// состояние, чтобы не создавать jank на слабых устройствах.
function revealNewCards(cards) {
    const list = Array.from(cards || []);
    if (!list.length) return;
    // document.hidden — см. комментарий в animateCountUp: без активного тикера
    // gsap.from() просто применит стартовое opacity:0 и застрянет там навсегда
    // (карточки остаются невидимыми/полупрозрачными до следующего взаимодействия).
    if (REDUCE_MOTION || !HAS_GSAP() || document.hidden || list.length > 20) {
        list.forEach(c => { c.style.opacity = '1'; c.style.transform = 'none'; });
        return;
    }
    try {
        gsap.from(list, { opacity: 0, y: 12, duration: 0.35, stagger: 0.05, ease: 'power1.out' });
    } catch (e) {
        list.forEach(c => { c.style.opacity = '1'; c.style.transform = 'none'; });
    }
}

// 🛡 Safety net: если вкладка/Telegram-вебвью была свёрнута или потеряла фокус
// (а с ней и тикер GSAP) ровно в момент, когда шла одна из анимаций выше (или
// любая другая gsap-анимация в приложении — кросс-фейд экранов, индикатор
// нав-бара, "перелёт" фото карточки и т.д.), элемент может навсегда остаться в
// промежуточном визуальном состоянии: частично прозрачная карточка, "недокру-
// ченное" число, съехавший индикатор. При возврате видимости страницы —
// принудительно домотка ВСЕХ активных GSAP-анимаций до финального кадра.
document.addEventListener('visibilitychange', () => {
    if (document.hidden || !HAS_GSAP()) return;
    try {
        gsap.globalTimeline.getChildren(true, true, true).forEach(tween => {
            try { tween.progress(1); } catch (_) { /* отдельный твин не должен ронять остальные */ }
        });
    } catch (_) { /* сам GSAP недоступен/сломан — ничего не делаем, приложение и так работает без анимаций */ }
});

// Shared-element "flight": клонирует изображение карточки, накладывает
// визуальный клон поверх реального контента (position:fixed, z-index выше
// модалки) и анимирует его geometry от rect карточки до rect модалки.
// Настоящие sourceEl/targetEl не трогаем — это чисто визуальный оверлей,
// который не блокирует и не задерживает реальное открытие модалки/загрузку данных.
function flyImageTransition(sourceEl, targetEl) {
    if (!sourceEl || !targetEl || REDUCE_MOTION || !HAS_GSAP() || document.hidden) return;
    let ghost = null;
    try {
        const srcRect = sourceEl.getBoundingClientRect();
        if (srcRect.width < 4 || srcRect.height < 4) return; // элемент не виден/не отрендерен — не летим из ниоткуда

        ghost = sourceEl.cloneNode(true);
        ghost.removeAttribute('id');
        ghost.style.position = 'fixed';
        ghost.style.left = srcRect.left + 'px';
        ghost.style.top = srcRect.top + 'px';
        ghost.style.width = srcRect.width + 'px';
        ghost.style.height = srcRect.height + 'px';
        ghost.style.margin = '0';
        ghost.style.zIndex = '9999';
        ghost.style.pointerEvents = 'none';
        ghost.style.borderRadius = getComputedStyle(sourceEl).borderRadius;
        ghost.style.objectFit = 'cover';
        ghost.style.transform = 'none';
        document.body.appendChild(ghost);

        const activeGhost = ghost;
        // Целевой rect берём на СЛЕДУЮЩЕМ кадре — к моменту вызова этой
        // функции модалка уже должна быть в DOM и видима (display/opacity),
        // но её layout может ещё не осесть (напр. transition на open).
        requestAnimationFrame(() => {
            try {
                const dstRect = targetEl.getBoundingClientRect();
                if (dstRect.width < 4 || dstRect.height < 4) { activeGhost.remove(); return; }
                gsap.to(activeGhost, {
                    left: dstRect.left,
                    top: dstRect.top,
                    width: dstRect.width,
                    height: dstRect.height,
                    borderRadius: getComputedStyle(targetEl).borderRadius,
                    duration: 0.45,
                    ease: 'power2.inOut',
                    onComplete: () => { try { activeGhost.remove(); } catch (_) {} }
                });
            } catch (e) {
                try { activeGhost.remove(); } catch (_) {}
            }
        });
    } catch (e) {
        // Любая ошибка — просто убираем возможный "осиротевший" клон и
        // ничего не ломаем: обычное открытие модалки как раньше.
        try { if (ghost) ghost.remove(); } catch (_) {}
    }
}

// --- GLOBAL STATE ---
let state = {
    site: 'all', category: 'all', query: '', currentLot: null, currentPdfUrl: '',
    minPrice: null, maxPrice: null, sort: 'date_desc', auctionType: 'all',
    region: 'all', yearMin: null, yearMax: null, roomsMin: null, roomsMax: null,
    areaMin: null, areaMax: null, model: 'all',
    // Фаза 4 (геокодирование): режим "Рядом со мной" в ОСНОВНОМ списке лотов
    // (не путать с картой — там своя независимая логика через
    // userGeoCoords/loadLotsForMap). Отдельный флаг, а не значение
    // state.sort, потому что бэкенд при near_lat/near_lon игнорирует sort_by
    // целиком (см. get_filtered_lots) — держать это в одном поле было бы
    // путаницей между "чем сортируем" и "включён ли режим расстояния".
    nearMe: false,
    offset: 0,
    limit: 20,
    isLoading: false,
    hasMore: true
};

// TASK5 5.2 (§3): query/verdict — новые поля рейла сайта (поиск + фильтр по
// вердикту), клиентские, над уже загруженным lotsCache — новых запросов к
// /api/favorites не добавляется.
let favState = { site: 'all', category: 'all', sort: 'added_desc', query: '', verdict: 'all', lotsCache: [] };
// D3 (DESIGN_UPGRADE_PROMPT.md §6, ⌘K палитра): лоты, реально отрисованные
// на Главной прямо сейчас (заполняется в loadLots()) — источник мгновенных
// клиентских совпадений в палитре, до того как долетит сетевой поиск.
let cmdkLoadedLots = [];
let searchTimeout;
let pollingInterval = null; // Глобальный таймер для опроса статуса
let userProfile = null;
// --- ГЛОБАЛЬНЫЕ ПЕРЕМЕННЫЕ ПОДПИСКИ ---
// TASK44 44.1: периоды и скидки приходят с сервера (window.PREMIUM_PRICING из pricing_catalog.py), в этом файле их числовой копии нет.
let billingPeriod = ((window.PREMIUM_PRICING || {}).periods || [3])[0];
let selectedProduct = 'sub_premium'; // TASK29: renderPlans() переводит на розницу, если Premium этому пользователю не продаётся. TASK26 26.2b: по умолчанию Premium (window.PLANS_ON_SALE) — раньше 'sub_basic', и «Оплатить» без тапа по карточке слал заказ Basic -> 400 «тариф не продаётся»; sub_premium, retail_30...
let isActionLocked = false;
let myFinancialChart = null;
let currentAiReport = null;
// ДОБАВЛЕНО (§5.4 DESIGN_MASTER_PROMPT.md): lot_id, ожидающий рендера при
// следующем вызове window.switchScreen('analysis') — см. её же комментарий
// в wrapped switchScreen ниже по файлу и loadAnalysisScreen(). На window,
// а не module-scope let: workspace-bootstrap.js — отдельный <script>-файл
// (не модуль) и выставляет её же перед boot-вызовом switchScreen('analysis').
window.pendingAnalysisLotId = null;
let currentLotRequest = null; // Контроллер для отмены старых запросов
let currentGlobalRequest = null;

// --- Фаза 4: сравнение лотов (premium) ---
let compareMode = false;          // включён ли режим выбора лотов в "Мои анализы"
let compareSelection = [];        // выбранные lot_id (максимум MAX_COMPARE_LOTS)
let lastAnalysesHistory = [];     // последняя загруженная история анализов — чтобы перерисовывать список при выборе без повторного fetch
const MAX_COMPARE_LOTS = 3;

// 🛡 Безопасная обертка для API-запросов
async function safeApiCall(url, options = {}) {
    try {
        const response = await fetch(url, options);
        
        // Если сервер вернул ошибку (500, 502, 404 и т.д.)
        if (!response.ok) {
            console.error(`[API Error] ${response.status} на URL: ${url}`);
            return { error: true, status: response.status };
        }
        
        // Защита от кривого JSON (если Nginx вернул HTML)
        const text = await response.text();
        try {
            return text ? JSON.parse(text) : {};
        } catch (e) {
            console.error('[JSON Parse Error]', e, text.substring(0, 100));
            return { error: true, status: 'parsing_error' };
        }
    } catch (error) {
        // Ошибка сети (нет интернета, CORS и т.д.)
        console.error('[Network Error]', error);
        return { error: true, status: 'network_failed' };
    }
}

// Новые цены подписок (Только месячные интервалы)
// 26.08: Premium поднят с 29890 до 34990 — на старой цене разрыв Pro→Premium
// был всего +27% денег за буквально безлимит (Pro упирается в 150 отчетов),
// из-за чего любой Pro-пользователь у потолка получал безлимит почти даром.
// Теперь разрыв ~49%, апгрейд остаётся привлекательным, но перестаёт быть
// математически очевидным на первом же месяце использования Pro.
// TASK44 44.1: цены за месяц — из каталога (window.PREMIUM_PRICING.price_1m), не копия.
const PRICES_1M = (window.PREMIUM_PRICING || {}).price_1m || {};

// Вспомогательная функция для красивой цены (199 000 ₸)
const formatMoney = (amount) => {
    return new Intl.NumberFormat('ru-RU').format(Math.round(amount)) + ' ₸';
};

// Форматирование чисел с разделителями тысяч
const formatNumber = (num) => {
    return new Intl.NumberFormat('ru-RU').format(num);
};

// ДОБАВЛЕНО (P3.2 аудита, 12.09.2026): опции региона строятся из ответа API,
// а не статичны — раньше эту сборку делал сам loadRegions() один раз для
// #regionSelect. Десктопной колонке (home_desktop.html) нужен второй select
// с той же живой опцией "сколько лотов в регионе" — тянуть /api/regions
// ВТОРОЙ раз ради того же ответа было бы лишним запросом на каждое изменение
// фильтра, поэтому сборка вынесена в отдельную функцию: один fetch в
// loadRegions() ниже, populateRegionSelect() просто применяет уже
// полученный response к любому переданному <select>.
function populateRegionSelect(selectEl, response, currentValue) {
    selectEl.innerHTML = '';
    if (!response.regions || !response.regions.length) return;

    // Находим элемент "Весь Казахстан" (первый элемент в массиве)
    const allKazakhstan = response.regions.find(region => region.id === 'all');

    // Добавляем "Весь Казахстан" как первую опцию
    if (allKazakhstan) {
        const allOption = document.createElement('option');
        allOption.value = allKazakhstan.id;
        allOption.textContent = `${allKazakhstan.name} (${formatNumber(allKazakhstan.count)})`;
        allOption.className = 'bg-[#0f172a] text-white font-bold';
        selectEl.appendChild(allOption);
    } else {
        // Fallback на случай, если API не вернул "all"
        const allOption = document.createElement('option');
        allOption.value = 'all';
        allOption.textContent = 'Весь Казахстан';
        allOption.className = 'bg-[#0f172a] text-white font-bold';
        selectEl.appendChild(allOption);
    }

    // Остальные регионы (без "all")
    const regionsToAdd = response.regions.filter(region => region.id !== 'all');

    // Группируем регионы: мегаполисы и области
    const megapolises = regionsToAdd.filter(region =>
        ['Astana', 'Almaty', 'Shymkent'].includes(region.id)
    );
    const oblasts = regionsToAdd.filter(region =>
        !['Astana', 'Almaty', 'Shymkent'].includes(region.id)
    );

    // Добавляем мегаполисы
    if (megapolises.length > 0) {
        const optgroup = document.createElement('optgroup');
        optgroup.label = 'Мегаполисы';
        optgroup.className = 'bg-[#0f172a] text-gray-400';

        megapolises.forEach(region => {
            const option = document.createElement('option');
            option.value = region.id;
            option.textContent = `${region.name} (${formatNumber(region.count)})`;
            option.className = 'text-white';
            optgroup.appendChild(option);
        });

        selectEl.appendChild(optgroup);
    }

    // Добавляем области
    if (oblasts.length > 0) {
        const optgroup = document.createElement('optgroup');
        optgroup.label = 'Области';
        optgroup.className = 'bg-[#0f172a] text-gray-400';

        oblasts.forEach(region => {
            const option = document.createElement('option');
            option.value = region.id;
            option.textContent = `${region.display_name} (${formatNumber(region.count)})`;
            option.className = 'text-white';
            optgroup.appendChild(option);
        });

        selectEl.appendChild(optgroup);
    }

    // Восстанавливаем выбранное значение, если оно все еще существует
    if (currentValue && selectEl.querySelector(`option[value="${currentValue}"]`)) {
        selectEl.value = currentValue;
    } else {
        // По умолчанию выбираем "Весь Казахстан"
        selectEl.value = 'all';
    }
}

// --- ДИНАМИЧЕСКАЯ ЗАГРУЗКА РЕГИОНОВ ---
async function loadRegions() {
    try {
        const regionSelect = document.getElementById('regionSelect');
        // ДОБАВЛЕНО (P3.2 аудита): десктопная копия — см. комментарий у
        // populateRegionSelect() выше. Может не существовать (Mini App,
        // мобильный браузер, или пока десктопная колонка ещё не отрендерена) —
        // тогда просто не заполняется, второй ошибки/побочного эффекта нет.
        const regionSelectDesktop = document.getElementById('regionSelectDesktop');
        const loadingIndicator = document.getElementById('regionLoading');

        if (!regionSelect) return;

        // Показываем индикатор загрузки
        if (loadingIndicator) loadingIndicator.classList.remove('hidden');

        // Сохраняем текущее выбранное значение. 2026-10-29: регион из адреса страницы (restoreHomeFiltersFromUrl) уже в
        // state, а в статичном select такой опции ещё нет — тогда берём state.region.
        const hasOpt = [...regionSelect.options].some((o) => o.value === state.region);
        const currentValue = (state.region && state.region !== 'all' && !hasOpt) ? state.region : regionSelect.value;

        // Загружаем регионы с API
        const response = await safeApiCall(`/api/regions?site=${state.site || 'all'}&category=${state.category || 'all'}`);

        if (response.error) {
            console.error('Ошибка загрузки регионов:', response);
            // Оставляем статический список как fallback
            return;
        }

        populateRegionSelect(regionSelect, response, currentValue);
        if (regionSelectDesktop) populateRegionSelect(regionSelectDesktop, response, currentValue);

        if (response.regions && response.regions.length > 0) {
            // Обновляем состояние
            state.region = regionSelect.value;

            console.log(`✅ Загружено ${response.regions.length - 1} регионов с актуальными лотами, всего лотов: ${response.total}`);
        }

    } catch (error) {
        console.error('Ошибка при загрузке регионов:', error);
    } finally {
        const loadingIndicator = document.getElementById('regionLoading');
        if (loadingIndicator) loadingIndicator.classList.add('hidden');
    }
}

// Функция для обновления регионов при изменении фильтров
function updateRegionsOnFilterChange() {
    // Используем debounce чтобы не делать слишком много запросов
    if (window.regionUpdateTimeout) {
        clearTimeout(window.regionUpdateTimeout);
    }
    
    window.regionUpdateTimeout = setTimeout(() => {
        loadRegions();
    }, 500); // Задержка 500ms
}

// Простой форматтер абзацев (используется, например, для final_verdict_reasoning,
// который не размечен на '**Лейбл:**'-подразделы, в отличие от экспертных блоков
// ниже) — перенос строк ИИ превращается в отступы между абзацами.
function formatText(text) {
    return text ? text.replace(/\n/g, '<br><br>') : 'Информация отсутствует';
}

// --- ЭКСПЕРТНОЕ ЗАКЛЮЧЕНИЕ (Анализ документов / Юридический статус) ---
// Подсвечивает ключевые факты внутри текста ИИ-заключения: суммы/валюту,
// проценты, даты, ссылки на статьи законов и прямые цитаты в кавычках —
// чтобы длинный связный текст читался как разметанный экспертный отчёт,
// а не сплошное полотно.
function highlightFacts(text) {
    if (!text) return '';
    return text
        // деньги: "49.7 млн тенге", "120 000 ₸", "$1 200"
        .replace(/(\d[\d\s]{0,12}(?:[.,]\d+)?\s?(?:млн|млрд|тыс\.?)?\s?(?:тенге|тг|₸|USD|\$))/gi, '<span class="cite-figure">$1</span>')
        // проценты
        .replace(/(\d+(?:[.,]\d+)?\s?%)/g, '<span class="cite-figure">$1</span>')
        // даты dd.mm.yyyy
        .replace(/(\d{1,2}\.\d{2}\.\d{4})/g, '<span class="cite-figure">$1</span>')
        // ссылки на статьи законов: "ст. 37", "статья 74"
        .replace(/(ст(?:атья|\.)?\s?№?\s?\d+[а-я0-9\-]*(?:\s(?:ГК\s?РК|Закона\s?РК))?)/gi, '<span class="cite-law">$1</span>')
        // прямые цитаты в кавычках-ёлочках
        .replace(/(«[^»]{3,160}»)/g, '<span class="cite-quote">$1</span>');
}

// Иконки phosphor-icons по ключевым словам в лейбле подраздела ('**Лейбл:** текст')
function iconForExpertLabel(label) {
    const l = (label || '').toLowerCase();
    if (l.includes('комплект')) return 'ph-stack';
    if (l.includes('наход')) return 'ph-magnifying-glass';
    if (l.includes('противоречи')) return 'ph-warning-circle';
    if (l.includes('полнот') || l.includes('оценка')) return 'ph-seal-check';
    if (l.includes('статус')) return 'ph-info';
    if (l.includes('обременени') || l.includes('арест')) return 'ph-lock-key';
    if (l.includes('основани')) return 'ph-gavel';
    if (l.includes('риск') || l.includes('рекоменд')) return 'ph-shield-warning';
    return 'ph-dot-outline';
}

// Разбирает текст ИИ-заключения ('document_analysis_reasoning'/
// 'legal_analysis_reasoning', ai/schemas.py) на подразделы по маркерам
// '**Лейбл:** текст'. Возвращает [{label, body}] (label === null для
// преамбулы/старого формата без маркеров) -- общий парсер для
// renderExpertSection() (Telegram) и renderExpertRowsSite() (TASK15
// 15.3, сайт).
function splitExpertMarkers(text) {
    if (!text) return [];
    const markerRe = /\*\*(.+?):\*\*/g;
    const matches = [...text.matchAll(markerRe)];
    if (matches.length === 0) return [{ label: null, body: text.trim() }];
    const blocks = [];
    const preamble = text.slice(0, matches[0].index).trim();
    if (preamble) blocks.push({ label: null, body: preamble });
    matches.forEach((m, idx) => {
        const label = m[1].trim();
        const start = m.index + m[0].length;
        const end = idx + 1 < matches.length ? matches[idx + 1].index : text.length;
        blocks.push({ label, body: text.slice(start, end).trim() });
    });
    return blocks;
}

// Рендерит подразделы как карточки с иконкой и uppercase-лейблом (старая
// разметка, Telegram Mini App, байт-в-байт — сайт больше не вызывает эту
// функцию, см. renderExpertRowsSite() ниже, TASK15 15.3).
function renderExpertSection(text) {
    if (!text) return '<div class="expert-block__text"><p>Информация отсутствует</p></div>';
    const toParagraphs = (body) => body
        .split(/\n{1,}/).map(s => s.trim()).filter(Boolean)
        .map(p => `<p>${highlightFacts(p)}</p>`).join('');
    return splitExpertMarkers(text).map(({ label, body }) => label
        ? `
            <div class="expert-block">
                <div class="expert-block__label"><i class="ph-bold ${iconForExpertLabel(label)}"></i> ${label}</div>
                <div class="expert-block__text">${toParagraphs(body)}</div>
            </div>
        `
        : `<div class="expert-block"><div class="expert-block__text">${toParagraphs(body)}</div></div>`
    ).join('');
}

// --- SKELETON LOADER ---
// ИСПРАВЛЕНО (замечание "на сайте список дёргается при подгрузке"): заглушка
// жила своей жизнью — миниатюра была прибита к 80x80, тогда как карточка лота
// под сайт выросла до 96x96, а на широких экранах вообще перестраивается в
// вертикальную (140px, с 1024px — 220px). Из-за этого в момент замены заглушек
// настоящими карточками список прыгал, и тем сильнее, чем шире окно.
//
// Чинится не подгонкой чисел, а теми же классами-хуками, что у настоящей
// карточки: lot-card на корне, lot-card-thumb на миниатюре, lot-card-body на
// теле. После этого ВСЕ правила карточки применяются к заглушке сами —
// и уменьшение до 80x80 внутри Telegram (html:not(.is-browser) в style.css),
// и вертикальная раскладка сайта с 640px, и 220px с 1024px из dashboard.css.
// Отдельно поддерживать размеры заглушки больше не нужно: она следует за
// карточкой по определению.
function getSkeletonHTML() {
    return `
    <div class="glass-card lot-card p-3 rounded-2xl flex items-start gap-3 animate-pulse border border-white/5 bg-[#1e293b]/50">
        <div class="lot-card-thumb w-24 h-24 min-w-[6rem] rounded-xl bg-white/10 flex-shrink-0"></div>
        <div class="lot-card-body flex-1 min-w-0 flex flex-col gap-1 py-0.5">
            <div class="min-h-[2.2rem] space-y-1">
                <div class="h-3 bg-white/10 rounded w-full"></div>
                <div class="h-3 bg-white/10 rounded w-2/3"></div>
            </div>
            <div class="h-[15px] flex items-center"><div class="h-2.5 bg-white/5 rounded w-1/2"></div></div>
            <div class="h-[15px] flex items-center"><div class="h-2.5 bg-white/5 rounded w-2/5"></div></div>
            <div class="flex flex-col gap-0.5 mt-auto">
                <div class="skeleton-price flex items-center"><div class="h-4 bg-white/10 rounded w-24"></div></div>
                <div class="h-[21px] flex items-center"><div class="h-4 bg-white/10 rounded-lg w-28"></div></div>
            </div>
        </div>
    </div>`;
}

// Единый шаблон пустого/ошибочного состояния сетки лотов — раньше это была
// голая серая строка текста без иконки и без возможности что-то сделать
// (UX-гайдлайн: пустое состояние должно объяснять причину и давать действие).
function emptyStateHtml(icon, title, subtitle = '', actionHtml = '') {
    return `<div class="col-span-full flex flex-col items-center justify-center text-center py-16 px-6">
        <div class="w-16 h-16 rounded-2xl bg-white/5 border border-white/10 flex items-center justify-center mb-4">
            <i class="ph-bold ${icon} text-3xl text-[#94a3b8]"></i>
        </div>
        <p class="text-sm font-bold text-gray-300">${title}</p>
        ${subtitle ? `<p class="text-xs text-[#94a3b8] mt-1.5 max-w-[260px] leading-relaxed">${subtitle}</p>` : ''}
        ${actionHtml ? `<div class="mt-4">${actionHtml}</div>` : ''}
    </div>`;
}

function showLoader(gridId) {
    const grid = document.getElementById(gridId);
    if (grid) grid.innerHTML = getSkeletonHTML().repeat(5);
}

// TASK4 4.8 (§9): сетевая ошибка на уже непустой сетке лотов не должна стирать
// то, что уже отрисовано (пользователь листает список — обрыв сети не повод
// заново показывать пустое состояние поверх реальных карточек). Минимальный
// тост — единственное такое всплывающее уведомление в вебаппе на сегодня,
// новой системы поверх него не строим.
let toastTimer = null;
function showToast(message) {
    let el = document.getElementById('appToast');
    if (!el) {
        el = document.createElement('div');
        el.id = 'appToast';
        el.className = 'app-toast';
        document.body.appendChild(el);
    }
    el.textContent = message;
    el.classList.add('visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('visible'), 3000);
}

// =================================================================
// 🔥 CORE BUTTON LOGIC (ЕДИНЫЙ ЦЕНТР УПРАВЛЕНИЯ КНОПКОЙ)
// =================================================================

function updateButtonState(status, position = 1, pdfUrl = null) {
    const btn = document.getElementById('analyzeBtn');

    if (!btn) return;

    // Сброс классов и обработчиков для основной кнопки
    btn.className = "flex-1 h-14 w-full py-4 rounded-xl font-bold text-sm flex justify-center items-center gap-2 shadow-lg transition-all border border-white/10 min-w-0";
    btn.onclick = null;
    btn.disabled = false;

    if (status === 'completed') {
        // ✅ СТАТУС: ГОТОВО
        btn.classList.add('bg-blue-600', 'hover:bg-blue-500', 'text-white', 'shadow-blue-900/40');
        btn.innerHTML = '<i class="ph-bold ph-sparkle text-xl"></i> ОТКРЫТЬ АНАЛИЗ';
        btn.onclick = () => {
            if (currentAiReport) {
                openAnalysisModal();
            } else if (pdfUrl) {
                openPdf(pdfUrl);
            }
        };
    }
    else if (status === 'processing') {
        // 🧠 СТАТУС: ДУМАЕТ
        btn.classList.add('bg-indigo-600', 'text-white', 'cursor-wait');
        btn.innerHTML = `
            <div class="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin"></div>
            <span>AI анализирует...</span>`;
        btn.disabled = true;
    }
    else if (status === 'queued' || status === 'pending') {
        // ⏳ СТАТУС: ОЧЕРЕДЬ
        btn.classList.add('bg-blue-600/80', 'text-white', 'cursor-wait');
        btn.innerHTML = `
            <div class="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"></div>
            <span>Очередь: <b>#${position}</b></span>`;
        btn.disabled = true;
    }
    else if (status === 'failed') {
        // ❌ СТАТУС: ОШИБКА
        btn.classList.add('bg-red-500', 'text-white');
        btn.innerHTML = '<i class="ph-bold ph-arrow-counter-clockwise"></i> Сбой. Повторить?';
        btn.onclick = startAnalysis;
    } 
    else {
        // 🚀 СТАТУС: ГОТОВ К ЗАПУСКУ (По умолчанию) — единственный акцент приложения
        btn.classList.add('bg-accent', 'text-accent-ink');
        btn.innerHTML = `
            <span class="text-[13px] flex items-center gap-2 mb-0.5 whitespace-nowrap"><i class="ph-bold ph-file-pdf text-lg"></i> ПОЛНЫЙ ОТЧЕТ</span>
            <span class="text-[10px] opacity-70 font-normal whitespace-nowrap">PDF + Стратегия</span>
        `;
        btn.onclick = startAnalysis;
    }
}

// 0. ВХОД С САЙТА (обычный браузер, вне Telegram Mini App) ---------------
//
// Внутри Mini App личность известна сразу (tg.initDataUnsafe.user.id) и
// ничего дополнительно спрашивать не нужно. В браузере — нет: сначала надо
// проверить, не входил ли этот посетитель уже (сессионная кука от прошлого
// раза, см. /api/auth/session на бэкенде), а если нет — показать кнопку
// "Войти через Telegram" и остановить загрузку остального интерфейса до
// успешного входа. Вызывается один раз из window.onload, ДО loadLots()
// и остальной инициализации ниже.
async function ensureAuthenticated() {
    if (IS_TELEGRAM) return true; // Mini App — есть initData, спрашивать нечего

    try {
        const res = await fetch('/api/auth/session');
        if (res.ok) {
            const data = await res.json();
            userId = data.user_id;
            // Инлайн-скрипт в index.html оптимистично показал экран входа
            // ещё до этой проверки (см. комментарий там) — куки хватило,
            // прячем его обратно.
            const screen = document.getElementById('screen-login');
            if (screen) screen.style.display = 'none';
            authChecked = true;

            // НАЙДЕНО (жалоба "мигает при каждом переключении вкладки",
            // подтверждено вживую через DevTools → Cookies: настоящая
            // session-кука была, а ad_lh — нет): ad_lh выставляется ТОЛЬКО
            // в момент входа (см. _set_session_cookie в api_server.py) — у
            // сессий, начатых до появления этой куки в коде, её никогда не
            // будет, и оптимистичная проверка в инлайн-скрипте (см. её
            // комментарий в app_shell.html) обречена мигать при КАЖДОЙ
            // полной перезагрузке страницы, пока пользователь не перелогинится
            // заново. Раз сессия только что подтверждена сервером как
            // настоящая — самое время самим дописать недостающую подсказку,
            // не дожидаясь повторного входа. Не httpOnly и не секрет (как и
            // на бэкенде) — обычная JS-доступная кука, максимум на то же
            // время, что и сама сессия (30 дней, см. SESSION_MAX_AGE_SECONDS).
            if (!/(?:^|; )ad_lh=1(?:;|$)/.test(document.cookie)) {
                document.cookie = 'ad_lh=1; path=/; max-age=' + (30 * 24 * 3600) + '; SameSite=Lax' + (location.protocol === 'https:' ? '; Secure' : '');
            }
            return true;
        }
    } catch (e) {
        console.error('Проверка сессии не удалась:', e);
    }

    // ДОБАВЛЕНО (анонимный просмотр лотов, фаза 1 интерфейсного аудита):
    // раньше отсутствие сессии всегда означало renderLoginGate() + return
    // false — а window.onload останавливал ВСЮ загрузку интерфейса на этом
    // ("if (!authed) return;", см. ниже) — это и был тот самый сайт из
    // аудита, где 100% публичной поверхности было формой входа. Теперь
    // отсутствие сессии само по себе не блокирует: прячем оптимистично
    // показанный инлайн-скриптом экран входа (см. index.html) и продолжаем
    // как анонимный посетитель — userId остаётся пустым, а каждое личное
    // действие (AI-отчёт, избранное, профиль/база/история) точечно вызывает
    // renderLoginGate() там, где происходит попытка (см. startAnalysis(),
    // toggleDetailFav(), switchScreen()) — гейт остаётся ровно там же, где
    // и должен быть по смыслу продукта: на отчёте и личных данных, а не на
    // самом каталоге лотов.
    const screen = document.getElementById('screen-login');
    if (screen) screen.style.display = 'none';
    userId = null;
    authChecked = true;
    // TASK4 4.8 (§9, F-01): анонимный посетитель — сайдбарная карточка
    // "Инвестор · 0 анализов" подписывалась под несуществующий аккаунт;
    // на широком сайте (см. dashboard.css) это была карточка отсутствующего
    // пользователя вместо приглашения войти. Элементы могут отсутствовать
    // в DOM (Mini App сайдбара не рендерит вовсе).
    // ИНЛАЙН style.display, не .classList('hidden'): .sidebar-user/.btn-block
    // сами задают display:flex с той же специфичностью, что и общий
    // .hidden{display:none} (Tailwind) — а dashboard.css/style.css
    // подключены ПОСЛЕ tailwind.build.css (см. partials/base.html), значит
    // побеждают в каскаде при равном приоритете. Инлайн-стиль побеждает
    // всегда, тем же приёмом уже пользуется #screen-login выше.
    const sidebarCard = document.getElementById('sidebarUserCard');
    const sidebarCta = document.getElementById('sidebarLoginCta');
    const sidebarSkeleton = document.getElementById('sidebarUserSkeleton'); // ДОБАВЛЕНО (TASK5 5.6, F-01)
    if (sidebarSkeleton) sidebarSkeleton.style.display = 'none';
    if (sidebarCard) sidebarCard.style.display = 'none';
    if (sidebarCta) sidebarCta.style.display = 'flex';
    return true;
}

// Показывает экран входа (#screen-login, см. index.html) и один раз
// подставляет в него настоящий Telegram Login Widget — виджет должен быть
// вставлен как <script> с data-атрибутами, поэтому создаём тег вручную,
// а не рендерим его как обычную разметку.
//
// nextLabel — ДОБАВЛЕНО (TASK8 8.3, §III.6, F-04): человекочитаемое имя
// того, ради чего вызван гейт («Профиль», заголовок лота через
// formatLotTitleSite и т.п.) — сам вызывающий код уже знает его в момент
// вызова (никакого нового API/эндпоинта не нужно). Необязательный: гейт,
// вызванный без повода (например, при первом визите), просто не
// показывает строку "Вы вернётесь на:".
function renderLoginGate(nextLabel) {
    const screen = document.getElementById('screen-login');
    if (!screen) return;
    screen.style.display = 'flex';

    // ИСПРАВЛЕНО (ревью 8.5): раньше "Вы вернётесь на:" было статикой в
    // разметке (login.html), а скрывался только вложенный <span> через
    // класс — при пустом nextLabel параграф оставался в DOM непустым
    // ("Вы вернётесь на: "), просто visually hidden. Теперь и префикс, и
    // сам label пишет один textContent — при отсутствии nextLabel
    // параграф действительно пуст, а не спрятан текст.
    const hint = document.getElementById('loginNextHint');
    if (hint) {
        if (nextLabel) {
            hint.textContent = `Вы вернётесь на: ${nextLabel}`;
            hint.classList.remove('hidden');
        } else {
            hint.textContent = '';
            hint.classList.add('hidden');
        }
    }

    const holder = document.getElementById('telegramLoginWidget');
    if (holder && !holder.hasChildNodes()) {
        if (!window.BOT_USERNAME) {
            // Бэкенд не смог получить username бота при старте (см.
            // BOT_USERNAME в api_server.py) — показываем понятный текст
            // вместо тихо не появившейся кнопки.
            const fallback = document.getElementById('loginWidgetFallback');
            if (fallback) fallback.style.display = 'block';
        } else {
            const widgetScript = document.createElement('script');
            widgetScript.src = 'https://telegram.org/js/telegram-widget.js?22';
            widgetScript.async = true;
            widgetScript.setAttribute('data-telegram-login', window.BOT_USERNAME);
            widgetScript.setAttribute('data-size', 'large');
            widgetScript.setAttribute('data-radius', '12');
            widgetScript.setAttribute('data-auth-url', `${location.origin}/auth/telegram/callback`);
            widgetScript.setAttribute('data-request-access', 'write');
            holder.appendChild(widgetScript);
        }
    }

    // /auth/telegram/callback редиректит сюда с ?login_error=1, если
    // Telegram прислал невалидную/просроченную подпись (см. api_server.py).
    if (new URLSearchParams(location.search).get('login_error')) {
        const err = document.getElementById('loginError');
        if (err) err.style.display = 'block';
    }
}

// 1. АВТОМАТИЧЕСКАЯ РЕГИСТРАЦИЯ ПРИ ЗАПУСКЕ
async function authUser() {
    if (!userId) return;

    try {
        if (IS_TELEGRAM) {
            // Внутри Mini App — регистрируем/подтверждаем через подписанную
            // initData (заголовок ставит monkey-patched fetch выше). В
            // браузере регистрация уже произошла на /auth/telegram/callback
            // в момент входа (см. ensureAuthenticated выше) — вызывать
            // /api/auth/login там незачем, она и не примет запрос без
            // initData.
            const user = tg.initDataUnsafe?.user || {};
            await fetch('/api/auth/login', {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({
                    user_id: userId,
                    first_name: user.first_name || "User",
                    username: user.username || ""
                })
            });
        }

        // 2. 🔥 ЗАПРАШИВАЕМ ПОЛНЫЙ ПРОФИЛЬ (с командой и балансом)
        const profileRes = await fetch(`/api/user/${userId}?t=${Date.now()}`);
        
        if (profileRes.ok) {
            userProfile = await profileRes.json();
            
            // 🛑 ПРОВЕРКА НА БАН (ДОЛЖНА БЫТЬ ЗДЕСЬ!)
            if (userProfile.is_banned) {
                document.body.innerHTML = `
                    <div class="flex flex-col items-center justify-center h-screen text-center p-6 bg-[#0f172a] relative z-[9999]">
                        <div class="w-24 h-24 rounded-full bg-red-500/10 flex items-center justify-center mb-6 border border-red-500/20">
                            <i class="ph-fill ph-warning text-5xl text-red-500"></i>
                        </div>
                        <h1 class="text-white text-2xl font-bold tracking-widest mb-2">ДОСТУП ЗАКРЫТ</h1>
                        <p class="text-gray-400 text-sm mb-8 font-medium">Ваш аккаунт заблокирован за нарушение правил сервиса.</p>
                        <button onclick="tg.close()" class="px-8 py-3 bg-white/10 text-white rounded-xl font-bold active:scale-95 transition-all">Закрыть приложение</button>
                    </div>
                `;
                return; // Полностью останавливаем загрузку интерфейса
            }

            // 📱 НОМЕР ТЕЛЕФОНА ОБЯЗАТЕЛЕН (решение продукта, 26.08) — нужен для связи
            // со службой поддержки. Telegram не отдаёт номер без явного шаринга
            // пользователем, поэтому блокируем интерфейс экраном-запросом, пока его нет.
            if (!userProfile.phone_number) {
                renderPhoneGate();
                return;
            }

            // Убран стрей console.log("DEBUG PROFILE LOADED:", userProfile) — печатал
            // весь объект профиля (баланс, план, телефон) в консоль браузера у
            // каждого обычного пользователя в проде (см. интерфейсный аудит,
            // раздел 03: "console.log в проде"). Отладочная точка входа осталась
            // (см. updateProfileUI() ниже), просто без утечки в открытую консоль.
            // TASK29 29.3: можно ли этому пользователю купить Premium — решает
            // сервер (bot/billing_access.py), сюда приходит готовый ответ.
            // Нет поля (старый бэкенд) — остаётся значение из шаблона.
            if (userProfile.premium_sale) {
                window.PLANS_ON_SALE = userProfile.premium_sale.allowed ? ['premium'] : [];
            }
            // TASK44 44.3: срок закрытия продажи приходит только тем, кто покупает через окно (группа / открытая продажа).
            window.PREMIUM_SALE_ENDS_AT = userProfile.premium_sale_ends_at || null;
            renderSaleTimer();
            updateProfileUI();
            if (!IS_TELEGRAM) updateProfileUISite();
            // D5 (DESIGN_UPGRADE_PROMPT.md §6, "Мои сценарии"): та же точка,
            // где мы впервые узнаём userId авторизованного пользователя —
            // раньше сохранённые фильтры были не видны, пока их не открыть
            // отдельной модалкой; строка чипов под тулбаром Главной подтягивает
            // их сразу же (см. её комментарий в home.html).
            loadScenarioChips();
        }
    } catch (e) {
        console.error("Auth/Profile load failed:", e);
    }
}

// 📱 ЭКРАН-ЗАПРОС НОМЕРА ТЕЛЕФОНА (блокирует весь остальной интерфейс, пока
// пользователь не поделится номером — см. authUser() выше и main.py::handle_shared_contact,
// куда Telegram доставляет Contact-сообщение в ответ на requestContact() ниже).
function renderPhoneGate(statusText) {
    document.body.innerHTML = `
        <div class="flex flex-col items-center justify-center h-screen text-center p-6 bg-[#0f172a] relative z-[9999]">
            <div class="w-24 h-24 rounded-full bg-blue-500/10 flex items-center justify-center mb-6 border border-blue-500/20">
                <i class="ph-fill ph-phone text-5xl text-blue-400"></i>
            </div>
            <h1 class="text-white text-2xl font-bold tracking-widest mb-2">НУЖЕН НОМЕР ТЕЛЕФОНА</h1>
            <p class="text-gray-400 text-sm mb-2 font-medium max-w-xs">
                Чтобы пользоваться приложением, поделитесь номером телефона — он нужен только
                для связи со службой поддержки по вашему аккаунту.
            </p>
            <p class="text-[#94a3b8] text-xs mb-8 max-w-xs">Нажимая кнопку, вы соглашаетесь передать свой номер телефона боту.</p>
            <button id="sharePhoneBtn" onclick="requestPhoneNumber()" class="px-8 py-3 bg-blue-600 text-white rounded-xl font-bold active:scale-95 transition-all mb-3">
                📱 Поделиться номером
            </button>
            <p id="phoneGateStatus" class="text-[#94a3b8] text-xs mt-2 min-h-[1em]">${statusText || ''}</p>
        </div>
    `;
}

function requestPhoneNumber() {
    const statusEl = document.getElementById('phoneGateStatus');
    const btn = document.getElementById('sharePhoneBtn');

    if (!tg.requestContact) {
        // tg.requestContact доступен только внутри настоящего Telegram-клиента.
        // Два разных случая одной и той же причины: либо это браузер (сайт,
        // вне Mini App) — там метода нет никогда, либо устаревшая версия
        // Telegram. В обоих случаях номер можно поделиться только через бота —
        // это тот же аккаунт (userId — Telegram ID, общий для сайта и бота).
        const botLink = window.BOT_USERNAME ? `https://t.me/${window.BOT_USERNAME}` : null;
        const hint = IS_TELEGRAM
            ? 'Ваша версия Telegram устарела — обновите приложение и попробуйте снова, либо напишите /start боту и поделитесь номером через кнопку в чате.'
            : (botLink
                ? `Поделиться номером можно только внутри Telegram. Откройте ${botLink}, нажмите /start и поделитесь номером кнопкой в чате — после этого вернитесь на сайт и обновите страницу.`
                : 'Поделиться номером можно только внутри Telegram. Откройте бота, нажмите /start и поделитесь номером кнопкой в чате — после этого вернитесь на сайт и обновите страницу.');
        if (statusEl) statusEl.innerText = hint;
        if (IS_TELEGRAM) { showPhoneChatFallback('Ваша версия Telegram не открывает окно номера.'); startPhoneWatch(); }
        return;
    }

    if (btn) { btn.disabled = true; btn.classList.add('opacity-50'); }
    if (statusEl) statusEl.innerText = 'Ожидаем подтверждения...';

    // 2026-11-03 (пользователь висел на «Ожидаем подтверждения...» часами): у части клиентов Telegram окно requestContact
    // не открывается и ответ не приходит никогда. Поэтому: (1) номер ждём сразу, не дожидаясь ответа окна — контакт мог
    // уйти боту и без него; (2) через 8 с без ответа — кнопка снова активна и есть запасной путь через чат с ботом.
    let answered = false;
    startPhoneWatch();
    setTimeout(() => {
        if (answered) return;
        if (btn) { btn.disabled = false; btn.classList.remove('opacity-50'); }
        showPhoneChatFallback('Окно Telegram не открылось?');
    }, 8000);

    tg.requestContact((shared) => {
        answered = true;
        if (!shared) {
            if (statusEl) statusEl.innerText = 'Без номера продолжить нельзя. Нажмите кнопку ещё раз, когда будете готовы поделиться.';
            if (btn) { btn.disabled = false; btn.classList.remove('opacity-50'); }
            return;
        }
        // Контакт летит боту отдельным сообщением (main.py::handle_shared_contact),
        // а не напрямую сюда в JS — поэтому ждём, пока бэкенд его обработает.
        if (statusEl) statusEl.innerText = 'Номер получен, сохраняем...';
        setTimeout(() => showPhoneChatFallback('Номер не сохранился?'), 15000);
    });
}

// Запасной путь: чат с ботом, /start phone -> обычная кнопка «Поделиться номером» (main.py::send_phone_request).
function showPhoneChatFallback(lead) {
    const statusEl = document.getElementById('phoneGateStatus');
    if (!statusEl || document.getElementById('phoneChatBtn') || !window.BOT_USERNAME) return;
    statusEl.innerText = `${lead} Поделитесь номером в чате с ботом — кнопкой внизу чата, затем вернитесь сюда.`;
    statusEl.insertAdjacentHTML('afterend', '<button id="phoneChatBtn" onclick="openPhoneChat()" class="mt-4 px-6 py-2.5 bg-white/10 text-white rounded-xl font-bold active:scale-95 transition-all">Поделиться через чат с ботом</button>');
}

window.openPhoneChat = () => {
    const link = `https://t.me/${window.BOT_USERNAME}?start=phone`;
    if (tg.openTelegramLink) tg.openTelegramLink(link); else window.open(link, '_blank');
};

// Пока виден экран номера — раз в 2 с спрашиваем профиль (до 10 минут) и сразу при возврате в приложение:
// номер мог прийти и через окно, и через чат с ботом. Есть номер — перезагружаем страницу целиком.
let phoneWatchTimer = null;
function startPhoneWatch() {
    if (phoneWatchTimer) return;
    const until = Date.now() + 10 * 60 * 1000;
    const tick = async () => {
        if (await phoneNumberSaved()) { location.reload(); return; }
        phoneWatchTimer = Date.now() < until ? setTimeout(tick, 2000) : null;
    };
    phoneWatchTimer = setTimeout(tick, 1500);
    document.addEventListener('visibilitychange', async () => {
        if (document.visibilityState === 'visible' && await phoneNumberSaved()) location.reload();
    });
}

async function phoneNumberSaved() {
    try {
        const res = await fetch(`/api/user/${userId}?t=${Date.now()}`);
        if (!res.ok) return false;
        const fresh = await res.json();
        return !!fresh.phone_number;
    } catch (e) {
        console.error("phoneNumberSaved failed:", e);
        return false;
    }
}

// D2 (DESIGN_UPGRADE_PROMPT.md §5.4): копирование ID аккаунта из шапки
// профиля — нужен, когда пишешь в поддержку и просят номер. Без
// navigator.clipboard (http без TLS, очень старый WebView) тихо ничего не
// делает — это удобство, а не критичное действие, показывать ошибку не за что.
window.copyProfileUserId = async (btn) => {
    if (!userProfile?.user_id || !navigator.clipboard) return;
    try {
        await navigator.clipboard.writeText(String(userProfile.user_id));
    } catch (e) { return; }
    if (window.Telegram?.WebApp?.HapticFeedback) tg.HapticFeedback.notificationOccurred('success');
    const icon = btn.querySelector('i');
    if (!icon) return;
    const original = icon.className;
    icon.className = 'ph-bold ph-check text-pos';
    setTimeout(() => { icon.className = original; }, 1200);
};

// 2. ОБНОВЛЕНИЕ UI ПРОФИЛЯ
function updateProfileUI() {
    if(!userProfile) return;
    
    // Аватар и Имя
    const photo = tg.initDataUnsafe?.user?.photo_url || PLACEHOLDER_AVATAR;
    document.getElementById('profileAvatar').src = photo;
    document.getElementById('profileName').innerText = userProfile.first_name || 'Инвестор';
    document.getElementById('userIdDisplay').innerText = userProfile.user_id;

    // 🔥 БЕЙДЖ ПЛАНА (Приоритет новой колонке plan_id)
    const plan = (userProfile.plan_id && userProfile.plan_id !== 'free') ? userProfile.plan_id : (userProfile.subscription_plan || 'free');
    
    const badge = document.getElementById('profilePlanBadge');
    const planNames = { 'free': 'FREE', 'basic': 'BASIC', 'pro': 'PRO', 'premium': 'PREMIUM' };
    // Цвета приведены к тем же тонам, что и карточки тарифов в renderPlans()
    // (PRO — вторичный синий приложения #3B5EDB, PREMIUM — фирменное золото),
    // раньше здесь был отдельный, не совпадающий набор (жёлтый/фиолетовый).
    const planColors = { 'free': 'text-gray-400', 'basic': 'text-white', 'pro': 'text-[#6B8AE8]', 'premium': 'text-[#E8B84B]' };
    
    // Реферальная система "Premium-родитель -> 1 участник" убрана (см. main.py,
    // api_client/teams.py), колонка users.parent_id удалена (26.08) — метку
    // "(TEAM)" больше не показываем никому.
    // ИЗМЕНЕНО (TASK8 8.1, §III.5, E-02): "FREE PLAN"-бейдж с raw-hex цветом —
    // IS_TELEGRAM-ветка байт-в-байт; сайт — голое имя тарифа (definition-
    // строка «Тариф», значение уже подписано как таковое в profile_desktop.html),
    // без " PLAN"/uppercase/raw hex классов.
    if (IS_TELEGRAM) {
        badge.innerText = (planNames[plan] || 'FREE') + ' PLAN';
        badge.className = `inline-flex items-center gap-1 px-2 py-0.5 rounded-md bg-white/10 text-[10px] font-bold uppercase tracking-wider mb-6 ${planColors[plan] || 'text-gray-400'}`;
    } else {
        badge.innerText = planNames[plan] || 'FREE';
        badge.className = 'text-body font-mono-nums text-primary';
    }

    // Балансы
    const weeklyBalance = userProfile.balance_weekly || 0;
    
    // 🔥 НОВАЯ ЛОГИКА ЗАМОРОЗКИ (Считаем на фронтенде, игнорируем ошибку бэкенда)
    // Заморожено = тариф бесплатный, а кредиты (sub) есть на балансе
    const isFrozen = (plan === 'free' && weeklyBalance > 0);

    const weeklyEl = document.getElementById('balanceWeekly');
    const lockIcon = document.getElementById('lockIcon');
    const weeklyCard = document.getElementById('weeklyCard');
    const weeklyLabel = document.getElementById('weeklyLabel');

    // TASK27 (owner, 2026-09-30): Premium снова «безлимит» (3000 в месяц, не
    // копится — см. pricing_catalog.py::NEW_PREMIUM_CAP), откат TASK23 23.1b.
    if (plan === 'premium') {
        // TASK8 8.1, E-02: символ «∞» как значение запрещён (constitution
        // §III.5) — сайт пишет словом, Mini App — иконкой, как до TASK23.
        weeklyEl.innerHTML = IS_TELEGRAM ? '<i class="ph-bold ph-infinity text-3xl"></i>' : 'безлимит';
    } else {
        // 26.08: баланс теперь хранится напрямую в анализах (1 = 1 отчёт) —
        // раньше здесь было "кредитов / 30", множитель убран вместе с
        // вырезанным продуктом "вердикт".
        // ИЗМЕНЕНО (TASK8 8.2, ревью): голое число без разряда ("33575") на
        // сайте — сайт пишет через formatNumber() (тот же ru-RU форматтер,
        // что везде на сайте), Mini App — как было, без изменений.
        weeklyEl.innerText = IS_TELEGRAM ? weeklyBalance : formatNumber(weeklyBalance);
    }
    document.getElementById('balanceRetail').innerText = IS_TELEGRAM ? (userProfile.balance_retail || 0) : formatNumber(userProfile.balance_retail || 0);

    // 🔥 Дублируем в сайдбар (виден только на десктопе вне Telegram, см.
    // dashboard.css) — те же данные, что и на вкладке "Профиль", без
    // отдельного запроса: элементы могут отсутствовать в DOM (внутри
    // Telegram сайдбара нет вовсе), поэтому проверка на null обязательна.
    const sidebarCard = document.getElementById('sidebarUserCard');
    const sidebarCta = document.getElementById('sidebarLoginCta');
    const sidebarSkeleton = document.getElementById('sidebarUserSkeleton'); // ДОБАВЛЕНО (TASK5 5.6, F-01)
    if (sidebarSkeleton) sidebarSkeleton.style.display = 'none';
    if (sidebarCard) sidebarCard.style.display = '';
    if (sidebarCta) sidebarCta.style.display = 'none';
    const sbName = document.getElementById('sidebarUserName');
    if (sbName) sbName.innerText = userProfile.first_name || 'Инвестор';
    // TASK4 4.8 (§9): строка баланса в сайдбаре показывала "∞ анализов"
    // даже для PREMIUM — бессмысленно рядом с самим планом на бейдже
    // профиля. Показываем план + оставшиеся дни подписки (например,
    // "PREMIUM · 12 дн"), а не количество анализов, которое уже видно на
    // вкладке "Профиль"/в полосе баланса.
    const sbBalanceLine = document.getElementById('sidebarBalanceLine');
    if (sbBalanceLine) {
        let planText = planNames[plan] || 'FREE';
        if (plan !== 'free' && userProfile.plan_expires_at) {
            const days = Math.max(0, Math.ceil((new Date(userProfile.plan_expires_at) - Date.now()) / 86400000));
            planText += ` · ${days} дн`;
        }
        sbBalanceLine.innerHTML = `<i class="ph-fill ph-seal-check"></i> ${escapeHtml(planText)}`;
    }

    // ВИЗУАЛ ЗАМОРОЗКИ
    // ИЗМЕНЕНО (TASK8 8.1, §6.2): ярлык был ALL CAPS ("ЗАМОРОЖЕНО"/"НА
    // МЕСЯЦ") — uppercase на сайте разрешён только в .text-table-head.
    // IS_TELEGRAM — байт-в-байт; сайт — sentence case + токен-цвет (status-
    // neg при заморозке — это реальная семантика, не декорация).
    if (isFrozen) {
        lockIcon.classList.remove('hidden');
        if (IS_TELEGRAM) {
            weeklyEl.classList.add('text-[#94a3b8]'); // Делаем цифру серой
            weeklyEl.classList.remove('text-white');
            weeklyCard.classList.add('border-red-500/30'); // Красная рамка
            weeklyLabel.innerText = "ЗАМОРОЖЕНО";
            weeklyLabel.classList.remove('text-blue-400');
            weeklyLabel.classList.add('text-red-400');
        } else {
            weeklyLabel.innerText = 'Заморожено';
            weeklyLabel.style.color = 'var(--status-neg)';
        }
    } else {
        lockIcon.classList.add('hidden');
        if (IS_TELEGRAM) {
            weeklyEl.classList.add('text-white');
            weeklyEl.classList.remove('text-[#94a3b8]');
            weeklyCard.classList.remove('border-red-500/30');
            weeklyLabel.innerText = "НА МЕСЯЦ"; // Обновили текст
            weeklyLabel.classList.add('text-blue-400');
            weeklyLabel.classList.remove('text-red-400');
        } else {
            // ИЗМЕНЕНО (TASK8 8.2, ревью): «На месяц» → «Кредиты в месяц» —
            // слово «кредиты» пришло от плиток (E-02), не потерялось в
            // definition-строке.
            weeklyLabel.innerText = 'Кредиты в месяц';
            weeklyLabel.style.color = '';
        }
    }

    // ЛОГИКА КОМАНДЫ
    const teamSec = document.getElementById('teamSection');
    
    // Показываем блок ТОЛЬКО если тариф PREMIUM. Раньше здесь ещё проверялось
    // "и это Владелец (нет parent_id)" — колонка parent_id удалена (26.08) вместе
    // с остальной убранной реферальной системой, различать владельца/гостя больше
    // нечем (да и не нужно — деплинк /start invite_<id> уже не обрабатывается,
    // см. main.py).
    if (plan === 'premium') {
        if (teamSec) teamSec.classList.remove('hidden');
        
        const maxSlots = 1; // Только 1 партнер для Premium
        const usedSlots = (userProfile.team_members || []).length;
        const available = Math.max(0, maxSlots - usedSlots);
        
        const teamLabel = document.getElementById('teamSlotsLabel');
        if (teamLabel) teamLabel.innerText = `Доступно мест: ${available} из ${maxSlots}`;
        
        const inviteBtn = teamSec ? teamSec.querySelector('button') : null;
        if (inviteBtn) {
            inviteBtn.style.opacity = (available === 0) ? '0.5' : '1';
            inviteBtn.disabled = (available === 0);
        }
    } else {
        if (teamSec) teamSec.classList.add('hidden');
    }

    // Таймер начисления
    if (userProfile.next_reset_at && !isFrozen && plan !== 'free') {
        const resetDate = new Date(userProfile.next_reset_at);
        // Защита от NaN, если дата некорректная
        let daysLeft = Math.ceil((resetDate - new Date()) / (1000 * 60 * 60 * 24));
        if (daysLeft < 0) daysLeft = 0;
        // ИЗМЕНЕНО (TASK8 8.2, ревью): «Осталось 9 дн.» — сайт пишет «сброс
        // через 9 дн» (подпись строки «Кредиты в месяц», не отдельная
        // «висящая» строка — позиция решена CSS/разметкой, не текстом).
        // Mini App/Главная (stripReset читает этот же innerText) — без
        // изменений.
        document.getElementById('weeklyResetLabel').innerText = IS_TELEGRAM ? `Осталось ${daysLeft} дн.` : `сброс через ${daysLeft} дн`;
    } else if (isFrozen) {
         // TASK29: «Продлите» — только если продлить можно (ex-Basic/Pro — нельзя).
         document.getElementById('weeklyResetLabel').innerText = premiumOnSale() ? "Продлите подписку!" : "Подписка закончилась";
    } else {
        document.getElementById('weeklyResetLabel').innerText = "Нет подписки";
    }

    // 🔥 Метрик-стрип на Главной (виден только на десктопе вне Telegram, см.
    // #desktopMetricStrip в dashboard.css) — три цифры, которые уже есть в
    // userProfile к моменту вызова updateProfileUI(), без единого нового
    // запроса к API. Специально НЕ добавлены "Избранное"/"Проанализировано":
    // на Главной эти данные ещё не загружены (см. blueprint-план, раздел 04) —
    // добавлять их означало бы либо дублировать отдельный fetch (уже не
    // вёрстка), либо показывать нули до перехода на другой экран.
    // TASK27: Premium снова «безлимит» (сайт — словом, см. constitution §III.5).
    const stripBalance = document.getElementById('stripBalanceValue');
    if (stripBalance) stripBalance.innerText = plan === 'premium' ? (IS_TELEGRAM ? '∞' : 'безлимит') : (weeklyBalance + (userProfile.balance_retail || 0));
    const stripPlan = document.getElementById('stripPlanValue');
    if (stripPlan) stripPlan.innerText = planNames[plan] || 'FREE';
    const stripReset = document.getElementById('stripResetValue');
    if (stripReset) stripReset.innerText = document.getElementById('weeklyResetLabel').innerText;

    // TASK4 4.2 (DESIGN_MASTER_PROMPT.md §7.1): лок на кнопке «Карта»
    // десктопного тулбара — тот же isPremiumUser(), что и у #mapPaywall в
    // openMapModal(), без второй копии условия. Видим по умолчанию в
    // разметке (гость/ещё не загруженный профиль) — прячем только если
    // реально PREMIUM.
    const mapLock = document.getElementById('mapLockDesktop');
    if (mapLock) mapLock.classList.toggle('hidden', isPremiumUser());
    // ДОБАВЛЕНО (TASK5 5.4, §5): тот же приём на кнопке «Сравнить» Моих
    // анализов — сравнение лотов тоже PREMIUM-фича (toggleCompareMode()
    // выше уже проверяет isPremiumUser() перед входом в режим, это только
    // визуальный лок, видимый до клика).
    const compareLock = document.getElementById('analysesCompareLock');
    if (compareLock) compareLock.classList.toggle('hidden', isPremiumUser());
    applyPremiumEntryPoints();

    // ЛОГИКА АДМИНА
    if (userProfile.is_admin) {
        // P2.2 аудита: на сайте кнопка теперь вообще не попадает в разметку
        // для не-админов (см. profile.html) — на getElementById здесь это
        // не влияет (для админа сервер её отрендерил), null-проверка на
        // случай рассинхрона серверной сессии и клиентского userProfile.
        document.getElementById('adminPanelBtn')?.classList.remove('hidden');
        // ИЗМЕНЕНО (TASK8 8.1, E-02): «GOD MODE» запрещено конституцией —
        // сайт пишет «PREMIUM · администратор» как обычную definition-
        // строку, без красной плашки. Mini App — байт-в-байт как было.
        const planBadgeEl = document.getElementById('profilePlanBadge');
        if (IS_TELEGRAM) {
            planBadgeEl.innerText = "GOD MODE";
            planBadgeEl.className = "inline-flex items-center gap-1 px-2 py-0.5 rounded-md bg-red-500/20 text-[10px] font-bold uppercase tracking-wider text-red-400 mb-6 border border-red-500/50";
        } else {
            planBadgeEl.innerText = 'PREMIUM · администратор';
            planBadgeEl.className = 'text-body font-mono-nums text-primary';
        }
    }

    // ДОБАВЛЕНО (Профиль → Биллинг, "текущий тариф крупно и понятно"):
    // те же поля userProfile, что и выше для карточки в "Обзоре" — без
    // отдельного запроса.
    renderBillingPlanCard(plan, planNames, weeklyBalance, isFrozen);
}

function renderBillingPlanCard(plan, planNames, weeklyBalance, isFrozen) {
    const badge = document.getElementById('billingPlanBadge');
    const statusEl = document.getElementById('billingPlanStatus');
    const discountEl = document.getElementById('billingPlanDiscount');
    if (!badge || !statusEl || !discountEl) return;

    // ИЗМЕНЕНО (TASK8 8.2, найдено живым скриншотом): та же className-
    // перезапись, что profilePlanBadge в updateProfileUI() (8.1) — эту
    // (billingPlanBadge) я тогда пропустил. IS_TELEGRAM байт-в-байт; сайт —
    // голое имя тарифа, без " PLAN"/uppercase/raw hex.
    const planColors = { 'free': 'text-gray-400', 'basic': 'text-white', 'pro': 'text-[#6B8AE8]', 'premium': 'text-[#E8B84B]' };
    if (IS_TELEGRAM) {
        badge.innerText = (planNames[plan] || 'FREE') + ' PLAN';
        badge.className = `inline-flex items-center gap-1 px-2 py-0.5 rounded-md bg-white/10 text-[10px] font-bold uppercase tracking-wider ${planColors[plan] || 'text-gray-400'}`;
    } else {
        badge.innerText = planNames[plan] || 'FREE';
        badge.className = 'text-body font-mono-nums text-primary';
    }

    // TASK27: Premium снова «Безлимитные анализы» (откат TASK23 23.1b).
    const retailBalance = userProfile.balance_retail || 0;
    const balanceText = plan === 'premium'
        ? 'Безлимитные анализы'
        : `Баланс: ${weeklyBalance} на месяц + ${retailBalance} вечных`;

    if (plan === 'free') {
        statusEl.innerText = isFrozen
            ? `Подписка закончилась. ${balanceText}.`
            : `Нет активной подписки. ${balanceText}.`;
    } else if (userProfile.plan_expires_at) {
        statusEl.innerText = `Активен до ${fmtDateLong(userProfile.plan_expires_at)} — ${balanceText}.`;
    } else {
        statusEl.innerText = `Активен. ${balanceText}.`;
    }

    const discountPct = Number(userProfile.active_discount_percent) || 0;
    const discountExpires = userProfile.active_discount_expires_at ? new Date(userProfile.active_discount_expires_at) : null;
    if (discountPct > 0 && discountExpires && discountExpires > new Date()) {
        // ИЗМЕНЕНО (TASK8, §8.2 "нет эмодзи нигде"): 🎁 убран на сайте через
        // emo() (тот же гейт, что уже используется на странице анализа,
        // Задача 7); Mini App — байт-в-байт.
        discountEl.innerText = `${emo('🎁 ')}Скидка ${discountPct}% на продление действует до ${fmtDateLong(userProfile.active_discount_expires_at)}`;
        discountEl.classList.remove('hidden');
    } else {
        discountEl.classList.add('hidden');
    }
}

// ДОБАВЛЕНО (TASK8 8.1, §III.5, "Профиль — sub-nav 200 + колонка ≤880").
// Вызывается из того же места, что updateProfileUI(), сразу после неё, под
// !IS_TELEGRAM — тот же приём, что renderInAppReportSite()/populateLotDetailSite()
// (Задачи 6/7): строит НОВЫЙ, site-only контент напрямую из userProfile,
// не читая уже написанные общие узлы.
function updateProfileUISite() {
    if (!userProfile) return;
    const headerNameEl = document.getElementById('profileHeaderName');
    if (headerNameEl) headerNameEl.textContent = userProfile.first_name || '';

    // ИЗМЕНЕНО (TASK8 8.2, ревью, §III.5): "avatar 48 (initial letter on
    // --bg-raised if no photo)" — #profileAvatar на сайте div, не img (см.
    // profile_desktop.html); буква — первый символ имени, заглавная.
    const avatarLetterEl = document.getElementById('profileAvatarLetter');
    if (avatarLetterEl) {
        const name = userProfile.first_name || '';
        avatarLetterEl.textContent = name ? name.trim().charAt(0).toUpperCase() : '?';
    }

    const plan = (userProfile.plan_id && userProfile.plan_id !== 'free') ? userProfile.plan_id : (userProfile.subscription_plan || 'free');
    const expiryRow = document.getElementById('profilePlanExpiryRow');
    const expiryEl = document.getElementById('profilePlanExpiry');
    if (expiryRow && expiryEl) {
        if (plan !== 'free' && userProfile.plan_expires_at) {
            expiryEl.textContent = fmtDateLong(userProfile.plan_expires_at);
            expiryRow.classList.remove('hidden');
        } else {
            expiryRow.classList.add('hidden');
        }
    }
}

window.shareInvite = () => {
    if (!userProfile) return;

    // Проверка "участник команды не может приглашать" убрана вместе с parent_id
    // (26.08) — деплинк /start invite_<id> в боте больше не обрабатывается
    // (см. main.py), так что приглашение всё равно ни к чему не приводит.

    const plan = userProfile.plan_id;
    const team = userProfile.team_members || []; 
    let maxSlots = 0;
    
    if (plan === 'premium') maxSlots = 1;
    
    if (maxSlots === 0) {
        tg.showAlert("Приглашения доступны только на тарифе PREMIUM.");
        return;
    }
    
    if (team.length >= maxSlots) {
        tg.showAlert(`У вас заняты все места (${team.length} из ${maxSlots}).\nЧтобы пригласить нового человека, удалите старого через поддержку.`);
        return;
    }

    const botUsername = "auctiondetectivebot";
    const text = `🎁 Привет! Я дарю тебе доступ к Auction Detective (Тариф ${plan.toUpperCase()}).\n\nВместе мы сможем анализировать лоты. Активируй по ссылке:`;
    const inviteLink = `https://t.me/${botUsername}?start=invite_${userId}`;
    
    const url = `https://t.me/share/url?url=${encodeURIComponent(inviteLink)}&text=${encodeURIComponent(text)}`;
    tg.openTelegramLink(url);
}

// Домен, на котором крутится etp_api (public /share/{token} эндпоинт из api_server.py)
const REPORT_SHARE_DOMAIN = "https://auctiondetective.kz";

// Открывает ссылку либо через Telegram WebApp API, либо (если tg.openLink недоступен —
// например, приложение открыто вне Telegram) через обычный window.open как запасной вариант.
function openExternalLink(url) {
    if (tg && typeof tg.openLink === 'function') {
        tg.openLink(url);
    } else {
        window.open(url, '_blank');
    }
}

// Формирует ссылку на публичный отчет по share_token текущего лота.
// print=true добавляет ?print=1 — сервер вернёт скрипт автопечати
// (см. report_template.html), чтобы сразу открылся диалог "Сохранить как PDF".
function getReportShareUrl(print) {
    const token = state.currentLot?.share_token;
    if (!token) return null;
    return `${REPORT_SHARE_DOMAIN}/share/${token}${print ? '?print=1' : ''}`;
}

// Кнопка "Поделиться" в шапке анализа. В Mini App — открывает публичную
// страницу отчёта (не требует авторизации, ей же можно переслать кому
// угодно). На сайте (§5.4 DESIGN_MASTER_PROMPT.md) у отчёта теперь есть
// собственный адрес /workspace/analysis/{id} — "поделиться" копирует ЕГО в
// буфер обмена, а не открывает /share/{token} во внешней вкладке; сама
// публичная /share/{token} никуда не делась — downloadInAppPdf() ниже
// продолжает пользоваться именно ей для печати/PDF.
window.shareReport = () => {
    if (!IS_TELEGRAM) {
        const lotId = state.currentLot?.id;
        if (!lotId) return;
        const pageUrl = `${window.location.origin}/workspace/analysis/${lotId}`;
        if (!navigator.clipboard) return;
        navigator.clipboard.writeText(pageUrl).then(() => {
            const icon = document.querySelector('#btnShareReport i');
            if (!icon) return;
            const original = icon.className;
            icon.className = 'ph-bold ph-check';
            setTimeout(() => { icon.className = original; }, 1200);
        }).catch(() => {});
        return;
    }

    const shareUrl = getReportShareUrl(false);

    if (!shareUrl) {
        tg.showAlert("Ссылка еще формируется. Пожалуйста, подождите завершения анализа.");
        return;
    }

    if (tg.HapticFeedback) tg.HapticFeedback.impactOccurred('medium');
    openExternalLink(shareUrl);
};

// Кнопка "Скачать PDF" в шапке анализа. В Telegram WebView надёжного нативного
// "Сохранить файл" нет, поэтому вместо генерации PDF внутри мини-аппа мы
// открываем ту же публичную /share/{token} страницу во внешнем браузере
// (Safari/Chrome), где она сама вызывает window.print() — на телефоне и на ПК
// это даёт системный диалог печати с опцией "Сохранить как PDF".
window.downloadInAppPdf = () => {
    const pdfUrl = getReportShareUrl(true);

    if (!pdfUrl) {
        tg.showAlert("Отчет еще формируется. Пожалуйста, подождите завершения анализа.");
        return;
    }

    if (tg.HapticFeedback) tg.HapticFeedback.impactOccurred('medium');
    openExternalLink(pdfUrl);
};

// 1. ЗАПУСК АНАЛИЗА
async function startAnalysis() {
    if (!state.currentLot) return;

    // ДОБАВЛЕНО (анонимный просмотр лотов, фаза 1 интерфейсного аудита):
    // это и есть сама граница гейта — карточки и факты по лоту теперь
    // открыты анонимному посетителю (см. ensureAuthenticated()), но заказ
    // AI-отчёта требует входа: это платное персональное действие
    // (списывает баланс конкретного пользователя, см. /api/analyze), а
    // не просмотр каталога.
    if (!IS_TELEGRAM && !userId) {
        renderLoginGate(formatLotTitleSite(state.currentLot).primary);
        return;
    }

    // 1. Проверяем блокировку (если уже выполняется - прерываем)
    if (isActionLocked) return;
    
    // 2. Включаем блокировку
    isActionLocked = true;
    
    tg.HapticFeedback.notificationOccurred('success');
    updateButtonState('queued', '...'); 

    try {
        const r = await fetch('/api/analyze', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
                user_id: userId,
                lot_id: state.currentLot.id,
                lot_title: state.currentLot.title
            })
        });
        
        // ⛔️ ОБРАБОТКА ОШИБКИ ОПЛАТЫ (402)
        if (r.status === 402) {
            updateButtonState('failed'); // Сброс кнопки
            openSubscription(); // Открываем окно оплаты
            tg.showAlert("Анализы закончились. Пополните баланс.");
            return; // Выходим из функции, но блок finally всё равно выполнится!
        }

        const d = await r.json();

        if (d.status === 'cached') {
            // 🔥 Сохраняем кэшированный отчет для модалки In-App аналитики
            if (d.raw_report) currentAiReport = d.raw_report;
            if (d.share_token && state.currentLot) state.currentLot.share_token = d.share_token;
            updateButtonState('completed', 0, d.pdf_url);
        } else {
            updateButtonState('queued', d.position);
            startPolling(state.currentLot.id);
            // Если успех - обновляем профиль, чтобы счетчик уменьшился
            authUser(); 
        }
        
    } catch (e) {
        console.error(e);
        updateButtonState('failed');
    } finally {
        // 3. СНИМАЕМ БЛОКИРОВКУ (Сработает всегда: при успехе, ошибке или статусе 402)
        isActionLocked = false;
    }
}



// 4. ЛОГИКА ПОДПИСКИ
// --- ЛОГИКА МОДАЛКИ ПОКУПКИ ---

function openSubscription() {
    const m = document.getElementById('subModal');

    // 🔥 ДОБАВЬТЕ ЭТУ СТРОКУ (Выносит модалку поверх блокирующего экрана)
    m.style.zIndex = '10000';
    m.style.display = 'flex'; // Сначала показываем
    // Небольшая задержка, чтобы сработал transition
    setTimeout(() => {
        m.classList.remove('translate-y-full');
    }, 10);
    renderPlans();
}

function closeSub() {
    const m = document.getElementById('subModal');
    m.classList.add('translate-y-full'); // Плавно уезжает вниз
    // Скрываем после окончания анимации
    setTimeout(() => {
        m.style.display = 'none';
    }, 300);
}

// TASK44 44.3: обратный отсчёт до закрытия продажи Premium (окно продаж, premium_sale_ends_at). Сервер — истина:
// на нуле карточка Premium и переключатель срока исчезают, как при выключенных продажах, а покупка после конца
// получит обычный 400 «Premium сейчас недоступен».
// 2026-10-29: тот же таймер считает и до конца скидок за срок (PREMIUM_PRICING.discounts_end_at) — на нуле
// Premium остаётся в продаже по полной цене, а открывается розница (endDiscounts).
let saleTimerHandle = null;
function formatSaleCountdown(ms) {
    const total = Math.max(0, Math.floor(ms / 1000));
    const d = Math.floor(total / 86400);
    const hms = [Math.floor(total % 86400 / 3600), Math.floor(total % 3600 / 60), total % 60]
        .map((n) => String(n).padStart(2, '0')).join(':');
    return d > 0 ? `${d} д ${hms}` : hms;
}
function formatAstanaDateTime(iso) {
    return new Intl.DateTimeFormat('ru-RU', {
        timeZone: 'Asia/Almaty', day: '2-digit', month: '2-digit', year: 'numeric',
        hour: '2-digit', minute: '2-digit', hourCycle: 'h23',
    }).format(new Date(iso)).replace(',', '');
}
function renderSaleTimer() {
    const box = document.getElementById('premiumSaleTimer');
    if (saleTimerHandle) { clearInterval(saleTimerHandle); saleTimerHandle = null; }
    const windowEnd = window.PREMIUM_SALE_ENDS_AT ? new Date(window.PREMIUM_SALE_ENDS_AT).getTime() : NaN;
    const discountsEndIso = (window.PREMIUM_PRICING || {}).discounts_end_at;
    const discountsEnd = discountsEndIso ? new Date(discountsEndIso).getTime() : NaN;
    // Раньше наступающий край: закрытие продажи важнее конца скидок.
    const isWindow = !isNaN(windowEnd) && (isNaN(discountsEnd) || windowEnd <= discountsEnd);
    const end = isWindow ? windowEnd : discountsEnd;
    const endIso = isWindow ? window.PREMIUM_SALE_ENDS_AT : discountsEndIso;
    const onEnd = isWindow ? closeSaleWindow : endDiscounts;
    const onSale = (window.PLANS_ON_SALE || []).includes('premium');
    if (!onSale || isNaN(end)) {
        if (box) box.classList.add('hidden');
        return;
    }
    if (end <= Date.now()) return onEnd();
    if (box) {
        const title = isWindow ? 'Продажа Premium для потока закрывается через' : 'Скидки на Premium заканчиваются через';
        box.innerHTML = `<div class="text-caption text-secondary">${title}</div>`
            + '<div class="sale-timer-value font-mono-nums" id="premiumSaleTimerValue"></div>'
            + `<div class="text-caption text-secondary">до <span class="font-mono-nums">${formatAstanaDateTime(endIso)}</span> по Астане</div>`;
        box.classList.remove('hidden');
    }
    const tick = () => {
        const left = end - Date.now();
        if (left <= 0) return onEnd();
        const value = document.getElementById('premiumSaleTimerValue');
        if (value) value.textContent = formatSaleCountdown(left);
    };
    tick();
    saleTimerHandle = setInterval(tick, 1000);
}
function closeSaleWindow() {
    if (saleTimerHandle) { clearInterval(saleTimerHandle); saleTimerHandle = null; }
    window.PLANS_ON_SALE = [];
    window.PREMIUM_SALE_ENDS_AT = null;
    const box = document.getElementById('premiumSaleTimer');
    if (box) box.classList.add('hidden');
    const modal = document.getElementById('subModal');
    if (modal && modal.style.display !== 'none') renderPlans();
}
// Те же правила, что client_pricing() после DISCOUNTS_END_AT: скидок за срок нет, розница в продаже.
function endDiscounts() {
    if (saleTimerHandle) { clearInterval(saleTimerHandle); saleTimerHandle = null; }
    window.PREMIUM_PRICING = { ...(window.PREMIUM_PRICING || {}), discounts: {}, discounts_end_at: null, retail_on_sale: true };
    const box = document.getElementById('premiumSaleTimer');
    if (box) box.classList.add('hidden');
    const modal = document.getElementById('subModal');
    if (modal && modal.style.display !== 'none') { renderPlans(); updateCheckout(); }
}

// TASK44 44.1: кнопки периода строятся из window.PREMIUM_PRICING.periods — «3 мес −25 %», «6 мес −30 %», «1 год −40 %».
function renderPeriodToggle() {
    const box = document.getElementById('billingPeriodToggle');
    if (!box) return;
    const pp = window.PREMIUM_PRICING || {};
    const periods = pp.periods || [];
    if (periods.length && !periods.includes(billingPeriod)) billingPeriod = periods[0];
    const label = (m) => m === 12 ? '1 год' : `${m} мес`;
    const signature = JSON.stringify([periods, pp.discounts || {}]);
    if (box.dataset.built === signature) { window.setBillingPeriod(billingPeriod, true); return; }  // не пересоздаём: ползунок анимируется
    box.dataset.built = signature;
    box.innerHTML = '<div class="toggle-bg" id="billingToggleBg"></div>' + periods.map((m) => {
        const pct = Number((pp.discounts || {})[m]) || 0;
        const badge = pct ? `<span class="period-badge text-micro font-mono-nums">−${pct} %</span>` : '';
        return `<button type="button" onclick="setBillingPeriod(${m})" id="btnPeriod${m}" class="billing-btn flex-1 relative z-10 py-2 text-caption font-semibold flex flex-col items-center justify-center gap-1"><span>${label(m)}</span>${badge}</button>`;
    }).join('');
    window.setBillingPeriod(billingPeriod, true);
}

window.setBillingPeriod = (months, geometryOnly) => {
    billingPeriod = months;
    
    // Анимация ползунка.
    // ИЗМЕНЕНО (жалоба "почини анимацию переключателя срока подписки"): раньше
    // здесь была лесенка из четырёх if с захардкоженными 0/100/200/300%, а
    // ширину ползунка задавал CSS отдельно — и они разошлись, когда кнопок
    // стало четыре вместо трёх (разбор — в комментарии у .toggle-bg в
    // style.css). Теперь и ширина, и шаг считаются от ФАКТИЧЕСКОГО числа
    // кнопок в разметке, поэтому добавление ещё одного периода не требует
    // править ни это место, ни CSS.
    //
    // translateX в процентах считается от собственной ширины элемента —
    // именно поэтому ширина обязана совпадать с шириной кнопки, иначе промах
    // копится с каждым шагом.
    const bg = document.getElementById('billingToggleBg');
    const periodButtons = [...document.querySelectorAll('.billing-btn')];
    const activeIndex = periodButtons.findIndex(b => b.id === `btnPeriod${months}`);
    if (bg && periodButtons.length && activeIndex >= 0) {
        // Кнопка = (W - 8px padding контейнера) / N: ширина ползунка считается от
        // числа кнопок, поэтому смещение translateX(N*100%) не копит промах.
        bg.style.width = `calc(${(100 / periodButtons.length).toFixed(4)}% - ${(8 / periodButtons.length).toFixed(4)}px)`;
        bg.style.transform = `translateX(${activeIndex * 100}%)`;
    }

    document.querySelectorAll('.billing-btn').forEach(b => b.classList.remove('active'));
    document.getElementById(`btnPeriod${months}`)?.classList.add('active');

    if (geometryOnly) return;
    renderPlans();
    updateCheckout();
}

// Выбор плана (подписки)
window.selectPlan = (planKey) => {
    selectedProduct = `sub_${planKey}`;
    // Снимаем выделение с розницы
    document.querySelectorAll('.plan-card').forEach(c => c.classList.remove('selected'));
    
    // Выделяем текущий
    const card = document.getElementById(`card_${planKey}`);
    if(card) card.classList.add('selected');
    
    updateCheckout();
}

// --- РОЗНИЦА: КАЛЬКУЛЯТОР КОЛИЧЕСТВА ---
// 2026-10-29 (владелец): розница — 2 000 ₸ за анализ при любом количестве (кривая «чем больше, тем дешевле»
// 1690 → 499 ₸ убрана) и продаётся только после конца скидок на Premium (pricing_catalog.DISCOUNTS_END_AT).
// Цена и флаг продажи приходят с сервера в window.PREMIUM_PRICING, сервер проверяет сумму заказа.
let retailQty = 1;
const RETAIL_MAX_QTY = 999;       // разумный верхний предел ввода, тот же в pricing_catalog.py

function retailOnSale() {
    return Boolean((window.PREMIUM_PRICING || {}).retail_on_sale);
}

function calculateRetailPrice(qty) {
    qty = Math.max(1, Math.floor(Number(qty) || 1));
    const unit = Number((window.PREMIUM_PRICING || {}).retail_unit_price) || 0;
    return { qty, total: unit * qty, pricePerUnit: unit };
}

function pluralReports(n) {
    const n1 = n % 10, n2 = n % 100;
    if (n2 >= 11 && n2 <= 14) return 'Отчетов';
    if (n1 === 1) return 'Отчет';
    if (n1 >= 2 && n1 <= 4) return 'Отчета';
    return 'Отчетов';
}

// Общий хелпер для русских склонений по числу (1/2-4/5+), та же логика,
// что pluralReports() выше, но параметризованная под любое слово —
// используется соцдоказательством на карточке лота (detailSocialProof).
function plural(n, one, few, many) {
    const n1 = n % 10, n2 = n % 100;
    if (n2 >= 11 && n2 <= 14) return many;
    if (n1 === 1) return one;
    if (n1 >= 2 && n1 <= 4) return few;
    return many;
}

// Соцдоказательство: "N инвесторов уже посмотрели" + "N лотов проанализировано
// за неделю" (lotData.view_count / lotData.weekly_analyzed_count приходят с
// бэкенда, см. api_server.py::get_lot_details). Показываем только ненулевые
// цифры — пустая или "0" социальная плашка выглядит хуже, чем её отсутствие.
// Используется и в карточке лота (до анализа), и в самом отчёте AI — оба
// места получают эти поля из одного и того же объекта лота (state.currentLot).
function renderSocialProof(lotData, containerId, viewElId, weeklyElId) {
    const container = document.getElementById(containerId);
    const viewCountEl = document.getElementById(viewElId);
    const weeklyCountEl = document.getElementById(weeklyElId);
    if (!container || !viewCountEl || !weeklyCountEl || !lotData) return;

    let anyVisible = false;
    if (lotData.view_count > 0) {
        viewCountEl.innerHTML = `<i class="ph-fill ph-eye text-[#94a3b8]"></i> ${lotData.view_count} ${plural(lotData.view_count, 'инвестор', 'инвестора', 'инвесторов')} уже смотрели этот лот`;
        viewCountEl.classList.remove('hidden');
        anyVisible = true;
    } else {
        viewCountEl.classList.add('hidden');
    }
    if (lotData.weekly_analyzed_count > 0) {
        weeklyCountEl.innerHTML = `<i class="ph-fill ph-chart-line-up text-[#94a3b8]"></i> ${lotData.weekly_analyzed_count} ${plural(lotData.weekly_analyzed_count, 'лот', 'лота', 'лотов')} проанализировано за неделю`;
        weeklyCountEl.classList.remove('hidden');
        anyVisible = true;
    } else {
        weeklyCountEl.classList.add('hidden');
    }
    container.classList.toggle('hidden', !anyVisible);
}

function clampRetailQty(n) {
    n = Math.floor(Number(n) || 1);
    if (!Number.isFinite(n) || n < 1) n = 1;
    if (n > RETAIL_MAX_QTY) n = RETAIL_MAX_QTY;
    return n;
}

// Выделяет карточку калькулятора розницы и снимает выделение с тарифов —
// тот же паттерн, что раньше был у selectRetail() для фиксированных пакетов.
window.focusRetailCalculator = () => {
    document.querySelectorAll('.plan-card').forEach(c => c.classList.remove('selected'));
    const card = document.getElementById('card_retail_calc');
    if (card) card.classList.add('selected');
    selectedProduct = `retail_${retailQty}`;
    updateCheckout();
}

function updateRetailCalculatorDisplay() {
    const totalEl = document.getElementById('retailTotalPrice');
    const perUnitEl = document.getElementById('retailPerUnitPrice');
    const input = document.getElementById('retailQtyInput');
    if (!totalEl || !perUnitEl || !input) return;

    const { pricePerUnit, total } = calculateRetailPrice(retailQty);
    totalEl.innerText = formatMoney(total);
    perUnitEl.innerText = `${formatMoney(pricePerUnit)}/шт`;
    input.value = retailQty;
}

// Кнопки +1/+5/+10 слева и справа от поля ввода
window.adjustRetailQty = (delta) => {
    retailQty = clampRetailQty(retailQty + delta);
    updateRetailCalculatorDisplay();
    focusRetailCalculator();
}

// Ручной ввод количества в поле
window.onRetailQtyInput = (val) => {
    retailQty = clampRetailQty(val);
    updateRetailCalculatorDisplay();
    focusRetailCalculator();
}

function calculatePriceInfo(productId, period) {
    let finalPrice = 0, basePrice = 0, upgradeDiscount = 0;
    let itemName = '', isUpgrade = false, periodDiscountPercent = 0, tagDiscountPercent = 0, effectiveDiscountPercent = 0;

    if (productId.startsWith('retail_')) {
        const qty = clampRetailQty(parseInt(productId.split('_')[1], 10) || 1);
        const { total } = calculateRetailPrice(qty);
        finalPrice = total;
        itemName = `${qty} AI-${pluralReports(qty)}`;
        basePrice = finalPrice;
    } else {
        const planId = productId.replace('sub_', '');
        const pricePerMonth = PRICES_1M[planId] || 0;

        basePrice = pricePerMonth * period;

        // Апгрейд определяем заранее (до скидки за период): активный платный
        // тариф, покупка выше рангом, срок ещё не истёк. Апгрейды не должны
        // получать скидку за период (25%/30%/40%) — она задумана как стимул
        // предоплаты НОВОМУ или продлевающему клиенту, а не как бонус поверх
        // уже действующего про-рата зачёта остатка. Тег/промо-скидка
        // (active_discount_percent) при этом продолжает применяться.
        const planRanks = { 'free': 0, 'basic': 1, 'pro': 2, 'premium': 3 };
        const currentPlan = (userProfile?.plan_id && userProfile.plan_id !== 'free') ? userProfile.plan_id : 'free';
        const currentRank = planRanks[currentPlan] || 0;
        const targetRank = planRanks[planId] || 0;
        let daysLeft = 0;
        if (currentRank > 0 && targetRank > currentRank && userProfile?.plan_expires_at) {
            const expires = new Date(userProfile.plan_expires_at);
            const now = new Date();
            daysLeft = Math.max(0, Math.ceil((expires - now) / (1000 * 60 * 60 * 24)));
        }
        const isUpgradePurchase = currentRank > 0 && targetRank > currentRank && daysLeft > 0;

        if (!isUpgradePurchase) {
            // TASK44 44.1: скидка за период — из каталога (pricing_catalog.py::PERIOD_DISCOUNT_PERCENT),
            // тот же словарь сервер использует при проверке цены заказа в /api/billing/kaspi.
            periodDiscountPercent = Number(((window.PREMIUM_PRICING || {}).discounts || {})[period]) || 0;
        }

        // Единственная админская скидка, кроме скидки за период — активная
        // скидка пользователя (users.active_discount_percent), которую
        // атомарно выставляют RPC-функции при присвоении тега или
        // погашении промокода. Считаем её "живой", только если не истёк срок.
        const rawTagDiscount = Number(userProfile?.active_discount_percent) || 0;
        const discExpiresAt = userProfile?.active_discount_expires_at;
        const tagDiscountAlive = rawTagDiscount > 0 && (!discExpiresAt || new Date(discExpiresAt) > new Date());
        tagDiscountPercent = tagDiscountAlive ? rawTagDiscount : 0;

        // Скидки не складываются — берём большую из двух, чтобы не уйти в минус
        effectiveDiscountPercent = Math.max(periodDiscountPercent, tagDiscountPercent);
        finalPrice = Math.round(basePrice * (1 - effectiveDiscountPercent / 100));

        itemName = `Подписка ${planId.toUpperCase()} на ${period} мес.`;

        // Логика Pro-Rata апгрейда (учет остатка)
        if (isUpgradePurchase) {
            const oldPrice = PRICES_1M[currentPlan] || 0;
            const pricePerDay = oldPrice / 30;
            upgradeDiscount = Math.floor(daysLeft * pricePerDay);

            if (upgradeDiscount > 0) {
                isUpgrade = true;
                finalPrice = Math.max(0, finalPrice - upgradeDiscount);
                itemName += ` [Учтен остаток: -${formatMoney(upgradeDiscount)}]`;
            }
        }
    }
    return { finalPrice, basePrice, isUpgrade, upgradeDiscount, itemName, periodDiscountPercent, tagDiscountPercent, effectiveDiscountPercent };
}

function renderPlans() {
    const container = document.getElementById('plansContainer');
    container.innerHTML = '';

    renderPeriodToggle();
    renderSaleTimer();
    const plans = [
        { 
            id: 'basic', name: 'BASIC', color: 'text-white', totalReports: 40,
            bgClass: 'bg-white/5 border border-white/10 hover:bg-white/10',
            features: [
                { icon: 'ph-files', text: '40 AI-отчетов', high: true },
                { icon: 'ph-trend-down', text: 'Себестоимость отчета: ...', high: true, isDynamicCost: true },
                { icon: 'ph-database', text: 'Без доступа к базе анализов' },
                { icon: 'ph-eye', text: 'Не видит статусы и оценки лотов', },
                { icon: 'ph-scales', text: 'Без сравнения лотов' },
                { icon: 'ph-hourglass', text: 'Обычная очередь анализа' },

            ]
        },
        {
            // Раньше PRO/PREMIUM красились в дефолтные Tailwind indigo/purple —
            // выбивались из навy+gold стиля всего приложения. PRO переведён на
            // тот же вторичный синий (#3B5EDB / --accent-2), которым уже
            // подсвечены бейджи ETP/Sauda и цены по всему приложению — он уже
            // "свой" для этой палитры, просто раньше не использовался тут.
            id: 'pro', name: 'PRO', color: 'text-[#6B8AE8]', best: true, totalReports: 150,
            bgClass: 'bg-[#3B5EDB]/10 border border-[#3B5EDB]/30 hover:bg-[#3B5EDB]/20',
            features: [
                { icon: 'ph-files', text: '150 AI-отчетов', high: true },
                { icon: 'ph-trend-down', text: 'Себестоимость отчета: ...', high: true, isDynamicCost: true },
                { icon: 'ph-database', text: 'Доступ к базе анализов', high: true },
                { icon: 'ph-eye', text: 'Видит ВСЕ статусы и оценки лотов', high: true },
                { icon: 'ph-scales', text: 'Без сравнения лотов' },
                { icon: 'ph-hourglass', text: 'Обычная очередь анализа' },

            ]
        },
        {
            // PREMIUM — фирменное золото приложения (#E8B84B/#A16207), а не
            // произвольный purple: старший тариф теперь тематически читается
            // как "золотой уровень", в одном языке с остальным UI.
            // TASK27 (owner, 2026-09-30): снова безлимит (3000/мес), откат TASK23 23.1b.
            // Число синхронизировано с NEW_PREMIUM_CAP в bot/pricing_catalog.py
            // (tests_test_pricing_catalog_matches_script.py ловит расхождение).
            id: 'premium', name: 'PREMIUM', premium: true, color: 'text-accent', totalReports: 3000,
            bgClass: 'bg-accent/10 border border-accent/40 hover:border-accent/60',
            features: [
                { icon: 'ph-infinity', text: 'Безлимитные AI-отчёты', high: true },
                { icon: 'ph-trend-down', text: 'Себестоимость отчета стремится к 0 ₸', high: true, isCostZero: true },
                { icon: 'ph-database', text: 'Доступ к базе анализов', high: true },
                { icon: 'ph-eye', text: 'Видит ВСЕ статусы и оценки лотов', high: true },
                { icon: 'ph-scales', text: 'Сравнение лотов бок о бок', high: true },
                { icon: 'ph-crown', text: 'Высший приоритет в очереди анализа', high: true },
                { icon: 'ph-map-pin', text: 'Карта лотов ("рядом со мной")', high: true },

            ]
        }
    ];

    // TASK23 23.1: единственная точка правки — window.PLANS_ON_SALE (см. её
    // же комментарий в partials/base.html), сейчас = ["premium"]. Basic/Pro
    // остаются в массиве выше (нужны для владельцев уже купленных подписок —
    // renderBillingPlanCard()/профиль их всё ещё показывают), просто не
    // предлагаются к НОВОЙ покупке в этой модалке.
    const onSale = (window.PLANS_ON_SALE || []);
    const plansForSale = plans.filter(p => onSale.includes(p.id));

    // TASK29 29.3: Premium этому пользователю не продаётся — модалка только
    // про пакеты анализов: без переключателя срока, без карточек тарифов,
    // розница выбрана сразу (иначе «Оплатить» указывала бы на Premium).
    // Без розницы (retailOnSale() — до конца скидок) и без Premium продавать нечего: строка «Сейчас покупка недоступна»,
    // кнопка оплаты скрыта.
    const retailOnly = plansForSale.length === 0 && retailOnSale();
    const nothingForSale = plansForSale.length === 0 && !retailOnSale();
    const subTitle = document.getElementById('subModalTitle');
    if (subTitle) subTitle.innerText = retailOnly ? 'Пакеты анализов' : 'Тарифы';
    const subCrown = document.getElementById('subModalCrown');
    if (subCrown) subCrown.classList.toggle('hidden', retailOnly || nothingForSale);
    const periodToggle = document.getElementById('billingPeriodToggle');
    // style.display, не .hidden: у .billing-toggle своё display:flex в style.css.
    if (periodToggle) periodToggle.style.display = (retailOnly || nothingForSale) ? 'none' : '';
    container.style.display = (retailOnly || nothingForSale) ? 'none' : '';
    const noSaleNote = document.getElementById('noSaleNote');
    if (noSaleNote) {
        noSaleNote.classList.toggle('hidden', !nothingForSale);
        noSaleNote.textContent = userProfile ? 'Сейчас покупка недоступна.' : 'Войдите, чтобы оформить Premium.';
    }
    document.getElementById('retailDivider')?.classList.toggle('hidden', !retailOnSale());
    document.getElementById('card_retail_calc')?.classList.toggle('hidden', !retailOnSale());
    const checkout = document.getElementById('subCheckout');
    if (checkout) checkout.style.display = nothingForSale ? 'none' : '';
    if (!retailOnSale() && selectedProduct.startsWith('retail_')) selectedProduct = 'sub_premium';
    if (retailOnly && !selectedProduct.startsWith('retail_')) {
        selectedProduct = `retail_${retailQty}`;
        const retailCard = document.getElementById('card_retail_calc');
        if (retailCard) retailCard.classList.add('selected');
    }

    // TASK26 26.2b: выбор, оставшийся от НЕ продающегося тарифа (значение по
    // умолчанию, старый выбор), заменяем первым продающимся — иначе кнопка
    // «Оплатить» отправит sub_basic_N/sub_pro_N и сервер ответит 400. Розница
    // (retail_*) не затрагивается.
    if (selectedProduct.startsWith('sub_') && !onSale.includes(selectedProduct.replace('sub_', '')) && plansForSale.length) {
        selectedProduct = `sub_${plansForSale[0].id}`;
    }

    plansForSale.forEach(p => {
        const calc = calculatePriceInfo('sub_' + p.id, billingPeriod);

        let discountLabel = '';
        if (calc.effectiveDiscountPercent > 0 && calc.tagDiscountPercent > calc.periodDiscountPercent) {
            // Тег/промо-скидка выигрывает у скидки за период — выделяем её отдельным цветом
            discountLabel = `<span class="bg-red-500/20 border border-red-500/50 text-red-400 text-[9px] px-2 py-0.5 rounded-full ml-2 font-bold tracking-wider">-${calc.effectiveDiscountPercent}% АКЦИЯ</span>`;
        } else if (calc.effectiveDiscountPercent > 0) {
            discountLabel = `<span class="bg-emerald-500/20 border border-emerald-500/50 text-emerald-400 text-[9px] px-2 py-0.5 rounded-full ml-2 font-bold tracking-wider">−${calc.effectiveDiscountPercent} %</span>`;
        }

        const isSelected = selectedProduct === `sub_${p.id}`;
        const activeClass = isSelected ? 'ring-2 ring-white/60 bg-white/10 scale-[1.02]' : '';

        // Раньше карточка перечисляла ВСЕ пункты, включая то, чего в тарифе НЕТ
        // (тусклые серые строки "Без доступа к базе анализов" и т.п.) — во всех
        // трёх карточках повторялся почти один и тот же список "недоступного",
        // из-за чего глазу приходилось вычитывать разницу между тарифами вместо
        // того, чтобы сразу её увидеть, и сам экран растягивался на лишний
        // скролл. Теперь показываем только то, что тариф РЕАЛЬНО даёт (f.high) —
        // BASIC короче, PRO длиннее, PREMIUM самый полный список: сама длина
        // карточки уже читается как "чем выше тариф, тем больше возможностей",
        // без необходимости показывать вычеркнутые пункты.
        let featuresHtml = '';
        p.features.filter(f => f.high).forEach(f => {
            let itemText = f.text;
            let iconColor = p.id === 'basic' ? 'text-gray-400' : (p.id === 'pro' ? 'text-[#6B8AE8]' : 'text-[#E8B84B]');

            if (f.isDynamicCost) {
                const totalReportsInPeriod = p.totalReports * billingPeriod;
                const costPerReport = Math.round(calc.finalPrice / totalReportsInPeriod);
                itemText = `Себестоимость отчета: ~<b class="text-white">${costPerReport} ₸</b>`;
                iconColor = 'text-emerald-400';
            }

            const textClass = isSelected ? 'text-gray-100' : 'text-gray-300';
            featuresHtml += `<div class="flex items-center gap-3 ${textClass} text-xs font-medium py-0.5"><i class="ph-fill ${f.icon} ${iconColor} text-sm"></i> <span>${itemText}</span></div>`;
        });

        const oldPriceHtml = calc.finalPrice < calc.basePrice 
            ? `<div class="text-[11px] text-red-400/80 font-bold line-through mt-1">${formatMoney(calc.basePrice)}</div>` 
            : '';

        const upgradeHtml = calc.isUpgrade 
            ? `<div class="mt-2"><span class="text-[10px] text-emerald-400 font-bold bg-emerald-400/10 px-2.5 py-1 rounded-md border border-emerald-500/20 uppercase tracking-wider">Ваш остаток: -${formatMoney(calc.upgradeDiscount)}</span></div>`
            : '';

        container.innerHTML += `
        <div onclick="selectPlan('${p.id}')" id="card_${p.id}" class="plan-card ${p.bgClass} ${activeClass} p-5 rounded-[24px] relative cursor-pointer transition-all duration-300 active:scale-[0.98]">
            ${p.best ? '<div class="absolute -top-3 left-1/2 -translate-x-1/2 bg-info text-white text-[9px] font-bold px-4 py-1 rounded-full tracking-widest border border-info/30">РЕКОМЕНДУЕМ</div>' : ''}
            ${p.premium ? '<div class="absolute -top-3 left-1/2 -translate-x-1/2 bg-accent text-accent-ink text-[9px] font-bold px-4 py-1 rounded-full tracking-widest border border-accent/40">МАКСИМАЛЬНЫЙ</div>' : ''}

            <div class="flex justify-between items-start mb-4">
                <div class="flex items-center"><span class="font-bold text-lg ${p.color} tracking-widest">${p.name}</span>${discountLabel}</div>
                <div class="text-right flex flex-col items-end"><div class="font-bold text-white text-xl leading-none tracking-tight">${formatMoney(calc.finalPrice)}</div>${oldPriceHtml}</div>
            </div>
            ${upgradeHtml}
            <div class="mt-4 border-t border-white/10 pt-4 space-y-2.5">${featuresHtml}</div>
        </div>`;
    });

    // renderPlans() рисует карточки с уже выбранным по умолчанию тарифом
    // (selectedProduct = sub_premium), но нижний чек-аут блок с ценой обновляет
    // только updateCheckout() — а её раньше никто не вызывал при первом открытии
    // экрана подписки. В итоге карточка BASIC подсвечивалась как выбранная, а
    // в футере всё равно висело "Basic Plan / 0 ₸" из статичной вёрстки, пока
    // пользователь не тапнет по уже выбранной карточке ещё раз.
    updateCheckout();

    // Синхронизируем калькулятор розницы с текущим retailQty — на случай,
    // если экран подписки переоткрывается без перезагрузки страницы (значение
    // retailQty из прошлого открытия должно быть видно сразу, а не только
    // после первого взаимодействия с калькулятором).
    updateRetailCalculatorDisplay();
}

function updateCheckout() {
    if (!selectedProduct) return;

    const calc = calculatePriceInfo(selectedProduct, billingPeriod);
    document.getElementById('selectedPlanName').innerText = calc.itemName.split(' [')[0];
    document.getElementById('selectedPlanPrice').innerText = formatMoney(calc.finalPrice);
    document.getElementById('checkoutBtn').innerHTML = 'Оплатить с Kaspi.kz <i class="ph-bold ph-arrow-right text-lg"></i>';

    // Апгрейды не получают скидку за период (см. calculatePriceInfo) — бейджи
    // -25%/-30%/-40% на переключателе срока живут на уровне модалки, а не
    // карточки тарифа, поэтому прячем их именно тут, когда выбранная покупка
    // определилась как апгрейд, чтобы бейдж не обещал скидку, которой в цене нет.
    document.querySelectorAll('.billing-btn .period-badge').forEach(badge => {
        badge.style.display = calc.isUpgrade ? 'none' : '';
    });
}

// --- ОПЛАТА KASPI ---
// ⚠️ УДАЛЕНО: window.processKaspiPayment был тестовым стабом, который через
// setTimeout ИМИТИРОВАЛ успешный вебхук Kaspi и сразу дергал /api/billing/buy
// напрямую с клиента — без единой проверки реальной оплаты. Функция висела
// на window (значит, была вызываема из консоли браузера, если открыть
// webapp вне Telegram) и, что важнее, /api/billing/buy на бэкенде до этого
// вообще не требовал прав админа — то есть ЛЮБОЙ пользователь мог вызвать
// её и начислить себе платную подписку бесплатно. Ни один элемент
// интерфейса эту функцию не вызывал (кнопка оплаты вызывает payWithKaspi(),
// см. ниже — тот самый настоящий ручной флоу с подтверждением админом).
// Дыру в /api/billing/buy закрыли на бэкенде через require_admin(); саму
// функцию-стаб убрали, чтобы её нельзя было случайно вызвать или снова
// на неё что-то навесить.

// Выносим переменные на уровень модуля, чтобы ими можно было управлять извне
let pollingTimer = null; 
let pollFails = 0;     // Счетчик ошибок сети/сервера (как у тебя было)
let pollAttempts = 0;  // Счетчик успешных попыток для умного увеличения интервала

async function startPolling(lotId) {
    // Очищаем предыдущий таймер, если функция вызвана повторно
    if (pollingTimer) clearTimeout(pollingTimer);
    
    try {
        // Добавляем timestamp, чтобы браузер не кэшировал ответ
        const r = await fetch(`/api/analysis/status?user_id=${userId}&lot_id=${lotId}&t=${Date.now()}`);
        
        if (!r.ok) {
            pollFails++;
            console.warn(`Poll fail ${pollFails}/5`);
            if (pollFails > 5) { // Сдаемся после 5 ошибок подряд
                updateButtonState('failed');
                return; // 🛑 Выходим, таймер больше не запускается
            }
            // Если не сдались, ждем чуть дольше (3 сек) и пробуем снова
            pollingTimer = setTimeout(() => startPolling(lotId), 3000);
            return;
        }
        
        pollFails = 0; // Сброс счетчика ошибок при успешном ответе
        const d = await r.json();
        
        if (d.status === 'completed') {
            tg.HapticFeedback.notificationOccurred('success');
            
            if (d.raw_report) currentAiReport = d.raw_report;
            if (state.currentLot) state.currentLot.share_token = d.share_token; // 🔥 Сохраняем токен
            updateButtonState('completed', 0, d.pdf_url);
            
            // 🔥 ОБНОВЛЕНИЕ БЕЙДЖА (Твой код без изменений)
            try {
                const freshRes = await fetch(`/api/lot/${lotId}?user_id=${userId}&t=${Date.now()}`);
                const freshLot = await freshRes.json();
                
                if (freshLot && freshLot.recommendation_status) {
                    const rc = getRecBadgeData(freshLot.recommendation_status, freshLot.recommendation_score);
                    const badgeContainer = document.getElementById('detailRecBadgeContainer');
                    if (badgeContainer) {
                        badgeContainer.innerHTML = `<span class="badge-rec ${rc.class} text-xs px-3 py-1.5 border backdrop-blur-md rounded-lg flex items-center gap-1.5"><i class="ph-fill ${rc.icon} text-sm"></i> ${rc.text}</span>`;
                    }

                    if (state.currentLot && state.currentLot.id == lotId) {
                        state.currentLot.recommendation_status = freshLot.recommendation_status;
                    }
                }
            } catch (e) {
                console.error("Ошибка обновления бейджа:", e);
            }
            
            return; // 🛑 Выходим. Анализ завершен, поллинг останавливается.
        }
        else if (d.status === 'failed') {
            updateButtonState('failed');
            return; // 🛑 Выходим при ошибке ИИ.
        } 
        else {
            // Статус processing или queued
            updateButtonState(d.status, d.position);
            
            // 🔥 УМНЫЙ ИНТЕРВАЛ (Adaptive Backoff)
            // Начинаем с 2000мс, каждая попытка прибавляет 500мс, максимум - 5000мс
            pollAttempts++;
            const delay = Math.min(2000 + (pollAttempts * 500), 5000);
            
            // Запускаем следующий опрос
            pollingTimer = setTimeout(() => startPolling(lotId), delay);
        }
    } catch (e) {
        console.error("Poll error", e);
        pollFails++;
        if (pollFails > 5) {
            updateButtonState('failed');
            return;
        }
        pollingTimer = setTimeout(() => startPolling(lotId), 3000);
    }
}

// 🔥 ВАЖНО: Добавь эту функцию и вызывай ее, когда юзер закрывает модалку с лотом 
// (например, в функции closeLotModal)
function stopPolling() {
    if (pollingTimer) {
        clearTimeout(pollingTimer);
        pollingTimer = null;
    }
    pollFails = 0;
    pollAttempts = 0;
}

// =================================================================
// MAIN UI LOGIC
// =================================================================

async function loadLots(append = false) {
    // 1. Проверки: не грузим, если уже заняты пагинацией или лотов больше нет
    if (state.isLoading && append) return; 
    if (append && !state.hasMore) return;
    
    // 🔥 ОТМЕНЯЕМ СТАРЫЙ ЗАПРОС, ЕСЛИ ЭТО НОВЫЙ ПОИСК
    if (!append && currentLotRequest) {
        currentLotRequest.abort();
    }
    
    state.isLoading = true;
    const g = document.getElementById('homeGrid');
    // TASK4 4.8 (§9): запоминаем ДО того, как showLoader() затрёт сетку
    // скелетонами — иначе в catch() скелетон-карточки (тоже дети .homeGrid)
    // ошибочно считались бы "есть что терять" и сетевая ошибка навсегда
    // подвисала бы на скелетоне вместо пустого состояния с "Повторить".
    const hadRealContent = !!(g && g.children.length > 0 && !g.querySelector('.animate-pulse'));

    if (!append) {
        syncHomeFiltersToUrl();
        state.offset = 0;
        state.hasMore = true;
        showLoader('homeGrid'); // Включаем наш скелетон!
        currentLotRequest = new AbortController(); // Создаем новый контроллер
    }

    try {
        const params = new URLSearchParams({
            query: state.query,
            category: state.category,
            site: state.site,
            sort: state.sort,
            region: state.region,
            auction_type: state.auctionType,
            limit: state.limit,
            offset: state.offset
        });
        // ДОБАВЛЕНО (анонимный просмотр лотов): userId бывает пустым — гость
        // ещё не входил через Telegram (см. ensureAuthenticated()). Раньше
        // user_id был обязательным параметром на бэкенде, поэтому userId
        // здесь был гарантированно задан к этому моменту; теперь
        // /api/lots?user_id= не передаём вовсе, а не шлём буквальную строку
        // "null" — FastAPI отличает "параметра нет" (Optional[int] = None,
        // анонимный каталог) от "параметр есть, но не число" (422).
        if (userId) params.append('user_id', userId);

        // Добавляем необязательные параметры
        if (state.minPrice) params.append('min_price', state.minPrice);
        if (state.maxPrice) params.append('max_price', state.maxPrice);

        // "Рядом со мной" в основном списке (не карта) — см. state.nearMe.
        // userGeoCoords объявлена ниже по файлу, но к моменту вызова
        // loadLots() (после полной загрузки скрипта) уже присвоена.
        if (state.nearMe && userGeoCoords) {
            params.append('near_lat', userGeoCoords.lat);
            params.append('near_lon', userGeoCoords.lon);
        }

        // Динамические параметры категорий
        if (state.category === 'авто') {
            if (state.yearMin) params.append('year_min', state.yearMin);
            if (state.yearMax) params.append('year_max', state.yearMax);
            if (state.model && state.model !== 'all') params.append('model', state.model);
        }
        else if (['квартиры', 'дома', 'коммерция', 'паркинг'].includes(state.category)) {
            if (state.areaMin) params.append('area_min', state.areaMin);
            if (state.areaMax) params.append('area_max', state.areaMax);
            
            // Комнаты отправляем только для жилой недвижимости
            if (['квартиры', 'дома'].includes(state.category)) {
                if (state.roomsMin) params.append('rooms_min', state.roomsMin);
                if (state.roomsMax) params.append('rooms_max', state.roomsMax);
            }
        }
        else if (state.category === 'участки') {
            if (state.areaMin) params.append('area_min', state.areaMin);
            if (state.areaMax) params.append('area_max', state.areaMax);
        }


        // 🔥 ДОБАВЛЯЕМ СИГНАЛ ОТМЕНЫ В FETCH
        const fetchOptions = !append ? { signal: currentLotRequest.signal } : {};
        const r = await fetch(`/api/lots?${params.toString()}`, fetchOptions);
        
        // Обязательно проверяем статус ответа
        if (!r.ok) {
             throw new Error(`HTTP error! status: ${r.status}`);
        }
        
        const d = await r.json();

        // D3 (DESIGN_UPGRADE_PROMPT.md §6, ⌘K палитра): "лоты — клиентски по
        // уже загруженной странице" буквально означает эту же переменную —
        // никакого отдельного стейта/запроса ради палитры не заводим.
        cmdkLoadedLots = append ? cmdkLoadedLots.concat(d) : d;

        // Очищаем скелетон только когда пришли реальные данные
        if (!append) g.innerHTML = '';

        // ДОБАВЛЕНО (аудит "бесконечная лента без счётчика", 05.09.2026,
        // продолжение): X-Total-Count считается только на первой странице
        // (offset===0, см. get_lots() в api_server.py) — на подгрузке
        // прокруткой (append===true) заголовка нет вообще, и это ожидаемо:
        // общее число не меняется от того, что подгрузили ещё одну страницу
        // того же фильтра, повторно спрашивать бэкенд незачем.
        if (!append) {
            const totalHeader = r.headers.get('X-Total-Count');
            state.totalCount = totalHeader !== null ? parseInt(totalHeader, 10) : null;
        }

        // Логика "Конец списка"
        if (d.length < state.limit) {
            state.hasMore = false;
        }

        // TASK4 4.6 (§4): десктопный сайт вне Telegram рисует
        // renderLotCardSite() (новая карточка Главной), иначе — createCard()
        // (мобильный сайт/Mini App, не меняется).
        const useSiteCard = !IS_TELEGRAM && isWideBrowser();
        const fragment = document.createDocumentFragment();
        const newCards = d.map(x => useSiteCard ? renderLotCardSite(x) : createCard(x));
        newCards.forEach(c => fragment.appendChild(c));
        g.appendChild(fragment);
        revealNewCards(newCards); // Phase 3: stagger fade+y только для новой пачки

        // TASK4 4.7 (DESIGN_MASTER_PROMPT.md §7.5, TASK4_HOME_PROMPT.md §7):
        // renderHomeTableRows() (отдельный движок таблицы, 120px миниатюры,
        // заголовок обрезан на 25 символах, без срока/типа торгов) удалена —
        // таблица Главной теперь строится тем же renderLotRow()/
        // LOT_ROW_CELL_RENDERERS, что Избранное/База AI/Мои анализы (§5.1
        // канона, "ЕДИНАЯ СТРОКА ЛОТА"). Та же страница данных, что и
        // карточки — на мобильном/в Telegram результат не виден (dashboard.css
        // прячет #homeTableWrap там же, где и раньше).
        const tableBody = document.getElementById('homeTableBody');
        if (tableBody) {
            if (!append) tableBody.innerHTML = '';
            const tableFragment = document.createDocumentFragment();
            d.forEach((l) => {
                const tr = renderLotRow(l, {
                    tag: 'tr',
                    columns: ['thumb', 'title', 'site', 'price', 'region', 'deadline', 'verdict'],
                    getId: (x) => x.id,
                    titleMeta: (x) => {
                        const t = (x.type_trading || '').toLowerCase();
                        const type = t.includes('пониж') ? 'На понижение' : (t.includes('повыш') ? 'На повышение' : '');
                        return type ? `<span class="lot-row-meta">${escapeHtml(type)}</span>` : '';
                    },
                    // ИЗМЕНЕНО (TASK5 5.1, §2 п.8): раньше клик навешивался
                    // вручную снаружи (tr.addEventListener) — строка не получала
                    // клавиатурную доступность (tabindex/role/Enter), которую
                    // renderLotRow() теперь добавляет сам, но только когда
                    // ctx.onClick передан. Ссылка совпадает с дефолтом
                    // (/workspace/lot/{id}) — ctx.href не передаём отдельно.
                    onClick: (x) => { window.location.href = `/workspace/lot/${x.id}`; },
                });
                tableFragment.appendChild(tr);
            });
            tableBody.appendChild(tableFragment);
            attachSparklines(tableBody); // D4 — та же точка подключения, что была в renderHomeTableRows()
        }

        if (d.length > 0) {
            state.offset += d.length;
        }
        updateLotsCounter();

        // Если ничего не нашли — TASK4 4.8 (§9): два разных пустых состояния.
        // "Фильтры активны" переиспользует countActiveRailFilters() (тот же
        // счётчик, что у "Сбросить · N" в футере рейла, 4.3) + категорию/
        // площадку, которые в рейл не входят; кнопка сброса — тот же
        // resetFilters(), что там же. Иначе (список пуст без единого
        // применённого фильтра) — это не "не найдено", а "ещё не загрузили".
        if (d.length === 0 && !append) {
            const filtersActive = countActiveRailFilters() > 0 || state.category !== 'all' || state.site !== 'all';
            if (filtersActive) {
                g.innerHTML = emptyStateHtml(
                    'ph-funnel-x',
                    'По этим фильтрам лотов нет',
                    'Попробуйте ослабить условия — регион, цену, тип аукциона.',
                    `<button onclick="resetFilters()" class="btn-block btn-ghost text-xs px-4" style="width:auto;">Сбросить фильтры</button>`
                );
                const tbody = document.getElementById('homeTableBody');
                if (tbody) tbody.innerHTML = '<tr><td colspan="7" class="lot-row-empty">По этим фильтрам лотов нет — попробуйте ослабить условия.</td></tr>';
            } else {
                g.innerHTML = emptyStateHtml(
                    'ph-tray',
                    'Лоты ещё не загружены',
                    'Попробуйте обновить страницу.',
                    `<button onclick="loadLots(false)" class="btn-block btn-secondary text-xs px-4" style="width:auto;">Обновить</button>`
                );
                const tbody = document.getElementById('homeTableBody');
                if (tbody) tbody.innerHTML = '<tr><td colspan="7" class="lot-row-empty">Лоты ещё не загружены.</td></tr>';
            }
        }

    } catch (e) {
        // Игнорируем ошибку, если мы сами отменили запрос
        if (e.name === 'AbortError') {
            console.log("Предыдущий запрос отменен, ждем новый...");
            return; // Выходим, не меняя isLoading
        }
        console.error("Ошибка загрузки лотов:", e);
        if (!append) {
            // TASK4 4.8 (§9): сетевая ошибка не должна стирать уже отрисованные
            // карточки (например, "Обновить" на непустой сетке словил обрыв
            // сети) — тост вместо замены содержимого. Пустое состояние с
            // "Повторить" остаётся только когда сетке и правда нечего терять.
            if (hadRealContent) {
                showToast('Не удалось обновить список — проверьте соединение.');
            } else {
                g.innerHTML = emptyStateHtml(
                    'ph-wifi-slash',
                    'Не удалось загрузить лоты',
                    'Проверьте соединение с интернетом и попробуйте ещё раз.',
                    `<button onclick="loadLots(false)" class="btn-block btn-secondary text-xs px-4" style="width:auto;">Повторить</button>`
                );
                const tbody = document.getElementById('homeTableBody');
                if (tbody) tbody.innerHTML = '<tr><td colspan="7" class="lot-row-empty">Не удалось загрузить лоты. Проверьте соединение и попробуйте ещё раз.</td></tr>';
            }
        }
    } finally {
        state.isLoading = false;
    }
}

// ДОБАВЛЕНО (аудит "бесконечная лента без счётчика", 05.09.2026, продолжение):
// #homeLotsCounter существует только в браузере на широком экране (см. её же
// комментарий в app_shell.html рядом с #homeViewToggle) — в Mini App и на
// мобильном узла нет вообще, поэтому функция тихо выходит, если не найдёт
// контейнер, а не пытается что-то создать/показать поверх мобильной ленты.
function updateLotsCounter() {
    const el = document.getElementById('homeLotsCounter');
    if (!el) return;
    if (state.totalCount == null) { el.textContent = ''; return; }
    const shown = Math.min(state.offset, state.totalCount);
    el.textContent = `Показано ${formatNumber(shown)} из ${formatNumber(state.totalCount)}`;
}

// ДОБАВЛЕНО (обратная связь 03.09.2026, "не знаю как мне скроллить рекомендации"):
// на десктопе у карусели #recommendationsGrid нет очевидного способа прокрутки
// мышью (это не тачпад со свайпом) — стрелки в разметке (#recsScrollLeft/Right,
// index.html, видны только в html.is-browser) вызывают эту функцию.
function scrollRecommendations(direction) {
    const grid = document.getElementById('recommendationsGrid');
    if (!grid) return;
    const card = grid.querySelector(':scope > *');
    // Шаг прокрутки — примерно ширина одной карточки + отступ, чтобы стрелка
    // сдвигала карусель на "один лот", а не на произвольное значение.
    const step = card ? (card.getBoundingClientRect().width + 16) : 300;
    grid.scrollBy({ left: direction * step * 2, behavior: 'smooth' });
}

// Compact «Подобрано для вас» card (2026-10-28, owner): <a href> like the site
// grid card (real navigation, Ctrl-click), in the Mini App the same
// #detailModal as createCard().
function renderRecCardCompact(l) {
    const el = document.createElement('a');
    el.href = `/workspace/lot/${l.id}`;
    el.className = 'rec-card snap-start';
    el.setAttribute('data-lot-id', l.id);
    const img = proxyImg(l.image_url, 160) || getPlaceholderFor(l.category);
    const fallbackImg = getPlaceholderFor(l.category);
    const titleInfo = formatLotTitleSite(l);
    const title = escapeHtml(titleInfo.primary);
    const isLease = l.attributes && l.attributes.deal_type === 'lease';
    el.title = titleInfo.secondary || titleInfo.primary;
    el.innerHTML = `
        <img class="rec-card-thumb" src="${img}" alt="" onerror="this.onerror=null;this.src='${fallbackImg}';" referrerpolicy="no-referrer" loading="lazy">
        <span class="rec-card-body">
            <span class="rec-card-title">${title}</span>
            <span class="rec-card-price font-mono-nums">${isLease ? '<span class="rec-card-lease">аренда </span>' : ''}${escapeHtml(formatMoney(l.start_price))}</span>
        </span>`;
    if (IS_TELEGRAM) {
        el.addEventListener('click', (ev) => {
            ev.preventDefault();
            openModal(l.id, el.querySelector('img'));
        });
    }
    return el;
}

async function loadRecommendations() {
    if (!userId) return;
    
    try {
        const res = await fetch(`/api/recommendations?user_id=${userId}&limit=5`);
        const lots = await res.json();
        
        const wrapper = document.getElementById('recommendationsWrapper');
        const grid = document.getElementById('recommendationsGrid');
        
        if (!lots || lots.length === 0) {
            wrapper.classList.add('hidden');
            return;
        }
        
        wrapper.classList.remove('hidden');
        grid.innerHTML = '';
        
        // TASK4 4.6 (§4): "тот же builder рисует карточки в карусели
        // «Подобрано для вас», с фиксированной шириной 248px" — та же
        // ширина, что у карточки сетки на minmax(248px,1fr) (§6.4).
        // 2026-10-28 (owner, variant A): the full-size cards took ~27 % of
        // the screen and pushed the catalog down to one visible row — now
        // one compact card (photo · title · price) on every surface, five
        // in one row on a wide site, a swipeable strip elsewhere (.rec-card,
        // style.css).
        const fragment = document.createDocumentFragment();
        const newCards = [];
        lots.forEach((lot) => {
            const card = renderRecCardCompact(lot);
            fragment.appendChild(card);
            newCards.push(card);
        });

        grid.appendChild(fragment);
        revealNewCards(newCards); // Phase 3: stagger fade+y
    } catch (e) {
        console.error("Ошибка загрузки рекомендаций:", e);
    }
}

// --- ПОДПИСЬ К ЦЕНЕ ЛОТА: "Текущая цена" вводила в заблуждение ---
// В lots (БД) нет отдельной колонки "живая цена аукциона прямо сейчас" — есть
// только start_price (стартовая/оценочная) и, после завершения торгов,
// final_price (у самого лота final_price на фронте не показывается — только
// в истории прошлых торгов). Значит число, которое мы показываем весь день,
// пока лот открыт, — это ВСЕГДА start_price, и раньше оно везде подписывалось
// "Текущая цена" независимо от типа торгов. Для "на понижение" (лот из этого
// разбора — Toyota Camry, отчёт AI сформирован ДО начала торгов) это читалось
// так, будто цена уже упала до этого значения, хотя это ещё не начавшийся
// потолок. Единая функция — чтобы подпись в карточке лота и в шапке AI-отчёта
// не разъезжались.
function getPriceLabel(typeTrading) {
    const t = (typeTrading || '').toLowerCase();
    if (t.includes('понижение')) return 'Стартовая цена (потолок, будет падать)';
    if (t.includes('повышение')) return 'Стартовая цена (минимум, будет расти)';
    if (t.includes('прям')) return 'Цена продажи';
    return 'Стартовая цена';
}

// --- КОНТЕКСТ ДЛЯ ИСТОРИИ ПРОШЛЫХ ТОРГОВ ---
// Раньше в блоке "История прошлых торгов" каждая прошлая сделка подписывалась
// одинаково ("Архив торгов") и падение цены интерпретировалось как однозначно
// хороший знак — без учёта ТИПА торгов. Но % падения означает разное на разных
// типах: на "понижение" цена стартует высоко и снижается по регламенту — большое
// падение может значить просто, что аукцион долго не находил покупателя (слабый
// спрос), а не выгодную сделку. На "повышение" цена растёт от минимума —
// "падения" там в норме не бывает, а рост цены — признак конкуренции покупателей.
// "Прямая продажа" — торгов вообще не было, % падения не показателен.
function getAuctionTypeShort(auctionType) {
    const t = (auctionType || '').toLowerCase();
    if (t.includes('понижение')) return 'Торги на понижение';
    if (t.includes('повышение')) return 'Торги на повышение';
    if (t.includes('прям')) return 'Прямая продажа';
    return 'Архив торгов';
}

function getHistoricalContextNote(auctionType, dropVal) {
    const t = (auctionType || '').toLowerCase();
    if (t.includes('понижение')) {
        if (dropVal >= 40) return 'Большое падение на "понижение" — вероятно, слабый спрос на аналог.';
        if (dropVal > 0) return 'Умеренное падение — спрос на аналог был близок к стартовой цене.';
        return 'Продано почти по старту — высокий спрос на аналог.';
    }
    if (t.includes('повышение')) {
        if (dropVal < 0) return 'Цена выросла в ходе торгов — был спрос выше минимума.';
        return 'Продано по стартовой цене — конкуренции покупателей не было.';
    }
    if (t.includes('прям')) {
        return 'Прямая продажа без торгов — % изменения цены здесь не показателен.';
    }
    return '';
}

// --- OPEN MODAL (ENTRY POINT FOR DETAILS) ---
// ДОБАВЛЕНО (платформенный план, фаза 5, /lot/{id}): updateUrl — открытие
// модалки теперь может менять адресную строку на /lot/{id} (постоянная,
// шарибельная ссылка на лот — см. read_lot_page() в api_server.py). По
// умолчанию true (обычный клик по карточке/строке таблицы). false передаётся
// из двух мест, где URL уже правильный и пушить его ещё раз не нужно:
// 1) автооткрытие при заходе прямо на /lot/{id} (см. window.onload ниже);
// 2) обработчик popstate ниже, при нажатии "назад" в браузере. Вне браузера
// (Telegram Mini App) history вообще не трогается — там нет адресной строки.
// ДОБАВЛЕНО (§5.4 DESIGN_MASTER_PROMPT.md, "сайт — не приложение"): общая
// точка заполнения карточки лота по уже загруженным данным — раньше это
// был кусок в середине openModal(), теперь используется и оттуда (Mini App,
// модалка), и из loadLotScreen() (сайт, страница /workspace/lot/{id}) — id
// внутри разметки одинаковые в обоих партиалах (§4.7), сама функция не
// знает и не должна знать, куда именно она пишет. Единственное отличие
// между площадками — что делает кнопка "ОТКРЫТЬ АНАЛИЗ": в Mini App это
// onclick, открывающий #analysisModal; на сайте — обычная <a href> на
// /workspace/analysis/{id} (реальная навигация, без оверлеев, см. §5.4).
function populateLotDetail(l) {
    const detailTitleInfo = formatLotTitle(l);
        // Заголовок в шапке #screen-lot (сайт) — есть только там, в модалке
        // Mini App (detail.html) такого элемента нет, поэтому null-safe.
        const lotHeaderTitleEl = document.getElementById('lotHeaderTitle');
        if (lotHeaderTitleEl) lotHeaderTitleEl.textContent = detailTitleInfo.primary;
        const img = document.getElementById('detailImg');
        img.src = proxyImg(l.image_url, 960) || '';
        img.alt = detailTitleInfo.primary || 'Фото лота';
        // onerror срабатывает на каждом битом фото площадки — раньше каждое
        // такое отправляло пользователя за картинкой на placehold.co.
        img.onerror = () => { img.src = PLACEHOLDER_LOT; };
        const detailTitleEl = document.getElementById('detailTitle');
        detailTitleEl.innerText = detailTitleInfo.primary;
        const detailCodeEl = document.getElementById('detailTitleCode');
        if (detailCodeEl) {
            if (detailTitleInfo.code) {
                detailCodeEl.textContent = `№ ${detailTitleInfo.code}`;
                detailCodeEl.style.display = 'block';
                detailTitleEl.classList.remove('mb-4');
                detailTitleEl.classList.add('mb-1');
            } else {
                detailCodeEl.style.display = 'none';
                detailTitleEl.classList.remove('mb-1');
                detailTitleEl.classList.add('mb-4');
            }
        }
        document.getElementById('detailPrice').innerText = formatMoney(l.start_price);
        // Владелец, 2026-11-03: у лотов права аренды — тоже «Стартовая цена»,
        // без «Ставки аренды (N мес.)» (было TASK10 10.3).
        document.getElementById('detailPriceLabel').innerText = getPriceLabel(l.type_trading);
        document.getElementById('detailLink').href = l.url;
        // D9: см. её же комментарий в detail.html и у provenanceAgo() выше.
        const freshnessEl = document.getElementById('detailPriceFreshness');
        if (freshnessEl) {
            const ago = provenanceAgo(l.updated_at);
            freshnessEl.innerText = ago ? `Данные площадки: обновлено ${ago}` : '';
        }

        // Соцдоказательство карточки лота (до анализа). Общая логика с блоком
        // отчёта AI живёт в renderSocialProof() — см. её определение выше.
        renderSocialProof(l, 'detailSocialProof', 'detailViewCount', 'detailWeeklyCount');

        // Бейдж источника
        const isE = l.url && l.url.includes('adilet');
        const b = document.getElementById('detailBadge');
        b.innerText = isE ? 'ETP ADILET' : 'E-QAZYNA';
        b.className = `px-3 py-1.5 rounded-lg text-[10px] uppercase tracking-wider badge-solid ${isE ? 'bg-blue-500/20 text-blue-300 border-blue-500/30' : 'bg-purple-500/20 text-purple-300 border-purple-500/30'}`;
        
        // Бейдж рекомендации
        const rc = getRecBadgeData(l.recommendation_status || 'requires_analysis', l.recommendation_score);
        document.getElementById('detailRecBadgeContainer').innerHTML = `<span class="badge-rec ${rc.class} text-xs px-3 py-1.5 border backdrop-blur-md rounded-lg flex items-center gap-1.5"><i class="ph-fill ${rc.icon} text-sm"></i> ${rc.text}</span>`;
        
        // Детали таблицы
        document.getElementById('detailDate').innerText = formatDate(l.publication_date);
        // D1: та же функция чипа срочности, что у карточки/таблиц — единый
        // визуальный язык дедлайна на всех поверхностях (см. deadlineChip()).
        document.getElementById('detailDeadline').innerHTML = renderDeadlineChipHtml(l.application_deadline);
        document.getElementById('detailAuctionDate').innerText = formatDate(l.trade_date || l.auction_start_date || l.auction_date);
        document.getElementById('detailNumber').innerText = l.registered_number || '-';
        document.getElementById('detailStatus').innerText = l.process_status || '-';
        document.getElementById('detailLocation').innerText = l.location || '-';
        
        // 1. Тип объекта (Категория из вашей БД)
        document.getElementById('detailType').innerText = l.category || '-';
        
        // 2. Метод торгов (из вашей новой колонки type_trading)
        const typeTrading = l.type_trading || '-';
        const methodEl = document.getElementById('detailMethod');
        methodEl.innerText = typeTrading;
        
        // 🔥 Бонус: красивая цветовая подсветка для удобства инвестора
        if (typeTrading.toLowerCase().includes('повышение')) {
            // Если на повышение — красным цветом (маржи меньше)
            methodEl.className = 'attr-value text-red-400 font-bold';
        } else if (typeTrading.toLowerCase().includes('понижение')) {
            // Если на понижение — зеленым цветом (наш выбор!)
            methodEl.className = 'attr-value text-green-400 font-bold';
        } else {
            // Стандартный цвет, если тип не определен
            methodEl.className = 'attr-value text-white font-medium';
        }
        
        // Гарантийный взнос
        const g = lotGuaranteeAmount(l);
        document.getElementById('detailGuarantee').innerText = g > 0 ? formatMoney(g) : 'Не указан';
        
        // Описание
        const rawDesc = l.description || 'Описание не указано продавцом';
        document.getElementById('detailDesc').innerHTML = rawDesc.replace(/\n/g, '<br>');
        
        // Избранное
        const fb = document.querySelector('#detailFavBtn i');
        fb.className = l.is_favorite ? 'ph-fill ph-heart text-3xl text-red-500' : 'ph-bold ph-heart text-3xl text-gray-400';

        // --- ДОКУМЕНТЫ ---
        const docs = l.documents || [];
        const docContainer = document.getElementById('detailDocsContainer');
        const docLabel = document.getElementById('docCountLabel');
        const wrapper = document.getElementById('docsWrapper');
        const caret = document.getElementById('docsCaret');

        wrapper.classList.remove('open');
        caret.classList.remove('rotate');
        docLabel.innerText = docs.length > 0 ? `${docs.length} ${getDocTerm(docs.length)}` : 'Нет документов';

        if (docs.length > 0) {
            docContainer.innerHTML = ''; 
            docs.forEach((doc, index) => {
                const url = typeof doc === 'string' ? doc : doc.url;
                const name = typeof doc === 'object' && doc.name ? doc.name : `Документ #${index + 1}`;
                
                const docBtn = document.createElement('button');
                docBtn.className = "w-full flex items-center justify-between p-3 rounded-xl hover:bg-white/10 transition-all group border border-white/5 bg-white/5 mb-2";
                docBtn.onclick = () => tg.openLink(url);

                docBtn.innerHTML = `
                    <div class="flex items-center gap-3 min-w-0">
                        <div class="w-8 h-8 rounded-lg bg-blue-500/20 flex items-center justify-center text-blue-400">
                            <i class="ph-bold ph-file-pdf"></i>
                        </div>
                        <span class="text-xs text-gray-200 truncate font-medium">${name}</span>
                    </div>
                    <i class="ph-bold ph-arrow-square-out text-[#94a3b8] group-hover:text-white"></i>
                `;
                docContainer.appendChild(docBtn);
            });
        }

        // --- 🔥 ИСПРАВЛЕНИЕ БАГА: ПОКАЗ ВЕРДИКТА ---
        const verdictBlock = document.getElementById('verdictBlock');
        const verdictText = document.getElementById('verdictText');
        
        // Скрываем по умолчанию
        verdictBlock.classList.add('hidden');

        // Если сервер вернул ai_verdict (значит он куплен и готов) — показываем сразу!
        if (l.ai_verdict) {
            verdictText.innerText = l.ai_verdict;
            verdictBlock.classList.remove('hidden');
        }

        // --- ЛОГИКА КНОПОК ---
        const btnContainer = document.getElementById('actionButtonsContainer');
        // 🔥 ПРИНУДИТЕЛЬНО СНИМАЕМ БЛОКИРОВКИ при открытии окна
        btnContainer.classList.remove('opacity-50', 'pointer-events-none');
        isActionLocked = false;
        const status = l.analysis_status; // 'completed', 'verdict_only', 'processing' или null

        // 🔥 СОХРАНЯЕМ ОТЧЕТ ГЛОБАЛЬНО ДЛЯ КНОПКИ
        currentAiReport = null; 
        if (l.raw_report) currentAiReport = l.raw_report;

        // ВАРИАНТ 1: ПОЛНЫЙ АНАЛИЗ ГОТОВ. 'verdict_only' — статус от вырезанного
        // 26.08 продукта "купить только вердикт"; старые записи с этим статусом
        // теперь тоже считаются полным доступом (см. api_server.py, Сценарий А).
        if (status === 'completed' || status === 'verdict_only') {
            // §5.4: на сайте это настоящая ссылка на /workspace/analysis/{id}
            // (реальная навигация, полная перезагрузка) — не onclick,
            // открывающий оверлей. В Mini App — как и раньше, свой модальный
            // отчёт, там нет ни адресной строки, ни отдельной страницы.
            // ИЗМЕНЕНО (TASK6 6.2, §4 п.4): сайт-ветка — токены/.btn-block
            // .btn-primary (§7.1), текст Title Case «Открыть анализ», не
            // ALL CAPS (§8.2). Telegram-ветка НЕ ТРОГАЕТСЯ ни строкой —
            // тот же raw-hex/ALL CAPS, что и был, см. diff hunk в отчёте.
            btnContainer.innerHTML = IS_TELEGRAM
                ? `<button id="analyzeBtn" onclick="currentAiReport ? openAnalysisModal() : openPdf('${l.pdf_url}')" class="w-full bg-accent text-accent-ink py-4 rounded-xl font-bold text-sm flex justify-center items-center gap-2 active:scale-95 transition-all border border-white/10">
                    <i class="ph-bold ph-sparkle text-xl"></i> ОТКРЫТЬ АНАЛИЗ
                </button>`
                : `<a id="analyzeBtn" href="/workspace/analysis/${l.id}" class="btn-block btn-primary">
                    <i class="ph-bold ph-sparkle"></i> Открыть анализ
                </a>`;
        }

        // ВАРИАНТ 2: НИЧЕГО НЕ КУПЛЕНО.
        // ИЗМЕНЕНО (TASK6 6.2, §2/§4 п.4, C-02): сайт-ветка теперь ОТДЕЛЬНАЯ —
        // раньше здесь был один и тот же банер "ПОЛНЫЙ ОТЧЕТ · PDF +
        // Стратегия" безусловно для обеих площадок (два визуальных языка
        // кнопки на одной странице — банер здесь и обычная кнопка выше,
        // конституция §7.1 разрешает только одну gold-кнопку на экран).
        // Telegram-ветка — байт-в-байт то же, что было (см. diff hunk в
        // отчёте); стоимость в кредитах на сайте неизвестна клиенту
        // (startAnalysis()/сервер её не отдают заранее) — просто
        // «Запустить AI-анализ», без цифры (TASK6 §4 п.4: "do not hardcode
        // a price").
        else if (IS_TELEGRAM) {
             btnContainer.innerHTML = `
                <button id="analyzeBtn" onclick="startAnalysis()" class="w-full bg-accent text-accent-ink py-4 rounded-xl font-bold text-sm flex flex-col justify-center items-center active:scale-[0.98] transition-all border border-white/10 min-w-0">
                    <span class="text-[13px] flex items-center gap-2 mb-0.5 whitespace-nowrap"><i class="ph-bold ph-file-pdf text-lg"></i> ПОЛНЫЙ ОТЧЕТ</span>
                    <span class="text-[10px] opacity-70 font-normal whitespace-nowrap">PDF + Стратегия (1 анализ)</span>
                </button>
            `;
        } else {
            btnContainer.innerHTML = `
                <button id="analyzeBtn" onclick="startAnalysis()" class="btn-block btn-primary">
                    <i class="ph-bold ph-magic-wand"></i> Запустить AI-анализ
                </button>
            `;
        }

        return img;
}

// ДОБАВЛЕНО (TASK6 6.1, TASK6_LOT_PROMPT.md §0/§9): populateLotDetail() выше —
// общая с Mini App (partials/modals/detail.html) функция, её саму не трогаем
// (кроме явно выделенной сайт-ветки #actionButtonsContainer, TASK6 6.2).
// populateLotDetailSite(l) — ВСЁ, что нужно только сайту: вызывается сразу
// после populateLotDetail(l), только из loadLotScreen() (та зовётся только
// для /workspace/lot/{id}, Mini App использует openModal()) — !IS_TELEGRAM
// здесь скорее документирует контракт, чем реально нужен как рантайм-гвард.
function populateLotDetailSite(l) {
    // §2: заголовок шапки — formatLotTitleSite(l), не formatLotTitle() (та
    // уже отработала внутри populateLotDetail() чуть выше, значение в
    // #lotHeaderTitle просто перезаписывается). Полный сырой title — в
    // title="", как и у остальных мест сайта (§8.3).
    const titleInfo = formatLotTitleSite(l);
    const headerTitleEl = document.getElementById('lotHeaderTitle');
    if (headerTitleEl) {
        headerTitleEl.textContent = titleInfo.primary;
        headerTitleEl.title = titleInfo.secondary || '';
    }

    // §3, C-03: "no photo → the category SVG, no empty square" — img.src=''
    // (l.image_url пуст) не всегда стреляет onerror (пустой src не всегда
    // трактуется браузером как ошибка загрузки) — проверяем явно, а не
    // полагаемся только на onerror. populateLotDetail() выше уже поставил
    // свой onerror → PLACEHOLDER_LOT (общий с Mini App, единая заглушка без
    // категорий) — здесь переопределяем на getPlaceholderFor(l.category),
    // сайт различает категории (§8.4).
    const img = document.getElementById('detailImg');
    if (img) {
        const fallback = getPlaceholderFor(l.category);
        if (!l.image_url) img.src = fallback;
        img.onerror = () => { img.onerror = null; img.src = fallback; };
    }

    const isE = l.url && l.url.includes('adilet');

    // ДОБАВЛЕНО (TASK6 6.2, §4 п.1): полоска вердикта — только когда лот
    // реально проанализирован (тот же isRecAnalyzed(), что и везде на
    // сайте), НИКОГДА «ТРЕБУЕТ АНАЛИЗА» (constitution §7.4). Целевая цена —
    // только когда raw_report реально пришёл (гость/без покупки — его нет
    // вовсе, l.raw_report тогда null, см. api_server.py::get_lot_details) —
    // тот же расчёт target_purchase_price/фолбэк, что updateTldrStrip()
    // (script.js) уже использует на самом отчёте, не изобретаю второй.
    const strip = document.getElementById('lotVerdictStrip');
    if (strip) {
        if (isRecAnalyzed(l.recommendation_status, l.recommendation_score)) {
            const rc = getRecBadgeData(l.recommendation_status, l.recommendation_score);
            let targetHtml = '';
            const fin = l.raw_report && l.raw_report.financials;
            if (fin) {
                let tp = fin.target_purchase_price;
                if (tp === undefined) {
                    const repair = fin.estimated_repair_cost || 0;
                    const taxes = fin.taxes_and_fees !== undefined ? fin.taxes_and_fees : (fin.additional_costs || 0);
                    tp = (fin.total_investment || 0) - repair - taxes;
                    if (tp < 0) tp = fin.start_price || 0;
                }
                if (tp) targetHtml = `<span class="text-caption text-secondary">целевая <span class="font-mono-nums text-primary">${formatMoney(tp)}</span></span>`;
            }
            // ИСПРАВЛЕНО (TASK6 6.6, п.2, §7.4): только число, моно, без «/100»
            // (fmtScore() добавляет «/100» — тот конвенции конституции не
            // соответствует, тот же принцип уже соблюдён в .lot-row-cell--verdict,
            // см. регресс-блок 21 «ни одна ячейка не содержит /100»).
            const scoreNum = typeof l.recommendation_score === 'number' ? String(l.recommendation_score) : '—';
            strip.innerHTML = `<span class="badge-rec ${rc.class}">${escapeHtml(rc.label)}</span><span class="font-mono-nums text-primary lot-verdict-score">${escapeHtml(scoreNum)}</span>${targetHtml}`;
            strip.classList.remove('hidden');
        } else {
            strip.classList.add('hidden');
        }
    }

    // ДОБАВЛЕНО (TASK6 6.2, §4 п.2, C-07): подпись под ценой — тип торгов
    // текстом, без цвета. TASK10 10.1 (переоткрытие TASK9 9.4 — предыдущее
    // "not available" было неверным: шаг/взнос лежат в /api/lot/{id} как
    // step_pct/deposit_pct, см. postgres_client.py::get_lot_by_id): «·
    // шаг N%» добавляется к подписи, когда step_pct пришёл с бэкенда —
    // «шаг снижения» для торгов на понижение (tradeStep — "Величина
    // снижения цены"), просто «шаг» для повышения (priceStep — "Величина
    // повышения цены").
    const fmtPctSite = (v) => (v % 1 === 0 ? v : v.toFixed(1)).toString().replace('.', ',');
    const priceTermsEl = document.getElementById('lotPriceTerms');
    if (priceTermsEl) {
        const t = (l.type_trading || '').toLowerCase();
        const isDown = t.includes('понижение');
        let text = isDown ? 'на понижение'
            : t.includes('повышение') ? 'на повышение'
            : (l.type_trading || '');
        if (typeof l.step_pct === 'number') {
            text += ` · ${isDown ? 'шаг снижения' : 'шаг'} ${fmtPctSite(l.step_pct)} %`;
        }
        priceTermsEl.textContent = text;
    }

    // ДОБАВЛЕНО (TASK6 6.2, §4 п.3): терм-сетка — строка видна только когда
    // значение есть (§7.7). TASK10 10.1: «5% · 260 000 ₸», когда бэкенд
    // прислал deposit_pct (bidAssurance из детального JSON лота) — сама
    // сумма гарантийного взноса (g) не изменилась, только подпись перед ней.
    const g = lotGuaranteeAmount(l);
    let guaranteeText = g > 0 ? formatMoney(g) : null;
    if (guaranteeText && typeof l.deposit_pct === 'number') {
        guaranteeText = `${fmtPctSite(l.deposit_pct)} % · ${guaranteeText}`;
    }
    setLotTermRow('lotTermGuarantee', 'lotTermGuaranteeValue', guaranteeText);

    const dl = deadlineChip(l.application_deadline);
    if (l.application_deadline && dl) {
        const dateStr = new Date(l.application_deadline).toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit', year: 'numeric' });
        const toneClass = DEADLINE_TONE_CLASS[dl.tone] || 'text-secondary';
        setLotTermRow('lotTermDeadline', 'lotTermDeadlineValue', `<span class="${toneClass}">до ${escapeHtml(dateStr)}, ${escapeHtml(dl.text)}</span>`, true);
    } else {
        setLotTermRow('lotTermDeadline', 'lotTermDeadlineValue', null);
    }

    const tradeDateText = fmtDateTime(l.trade_date || l.auction_start_date || l.auction_date);
    setLotTermRow('lotTermTrade', 'lotTermTradeValue', tradeDateText);

    const siteHtml = `<span class="badge-solid ${isE ? 'bg-etp' : 'bg-sauda'}">${isE ? 'ETP' : 'SAUDA'}</span>${l.registered_number ? ` <span class="font-mono-nums">№ ${escapeHtml(l.registered_number)}</span>` : ''}`;
    setLotTermRow('lotTermSite', 'lotTermSiteValue', siteHtml, true);

    // §4 п.3: "ghost «Карта» when lat/lon exist → openMapModal() centred on
    // the lot" — с 2026-10-28 карта умеет открываться на лоте (openMapModal({lotId})),
    // а lat/lon — это точка самого участка (bot/geo/coords.py), не геокодер. Карта — PREMIUM.
    const regionText = l.location ? escapeHtml(l.location) : '';
    const canMap = l.lat != null && l.lon != null && l.category !== 'авто' && isPremiumUser();
    setLotTermRow('lotTermRegion', 'lotTermRegionValue', regionText
        ? `${regionText}${canMap ? ` <button type="button" class="btn-ghost sm lot-term-map-btn" onclick="openMapModal({ lotId: '${escapeHtml(String(l.id))}' })"><i class="ph-bold ph-map-pin"></i>На карте</button>` : ''}`
        : null, true);

    setLotTermRow('lotTermStatus', 'lotTermStatusValue', l.process_status || null);

    // C-12: боилерплейт ETP "Имеются обременения" — здесь, в отличие от
    // флага карточки (hasExplicitEncumbrance(), TASK4 4.6b), боилерплейт
    // ЗАСЧИТЫВАЕТСЯ как факт (§8.5/4.6b решение прямо это требует: "this is
    // the place for it") — карточке он был шумом (53/53 ETP-лотов, не
    // отличает конкретный лот), странице лота — единственное место, где он
    // вообще показан пользователю. Отрицания ("без обременений",
    // "обременения: нет") по-прежнему исключены — та же проверка, что и в
    // hasExplicitEncumbrance().
    const encRow = document.getElementById('lotTermEncumbrance');
    const encValue = document.getElementById('lotTermEncumbranceValue');
    if (encRow && encValue) {
        const hasEnc = hasEncumbranceMentionSite(l.description);
        encValue.textContent = hasEnc ? 'есть' : 'не указано';
        encRow.classList.toggle('lot-term-encumbrance-active', hasEnc);
        encValue.onclick = hasEnc ? () => {
            const target = document.getElementById('lotDescription');
            if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } : null;
    }

    // §4 п.4: "Открыть на ЕТП ↗" / "Открыть на Sauda ↗" — populateLotDetail()
    // выше уже поставил href; здесь только подпись (сама кнопка не трогает
    // текст программно нигде, кроме этого места).
    const linkLabel = document.getElementById('detailLinkLabel');
    if (linkLabel) linkLabel.textContent = isE ? 'Открыть на ЕТП' : 'Открыть на Sauda';

    // TASK6 6.3, §5: описание (клэмп-тоггл) и документы (тип/размер) — сайт
    // перерисовывает то, что populateLotDetail() уже заполнил простым
    // текстом/кнопками.
    initLotDescriptionToggle();
    renderLotDocsSite(l);
}

// TASK14 14.4/14.4b (FINANCE_ENGINE_SPEC.md §9, spec §8's GET
// /api/lot/{id}/model): the lot page's compact «Условия входа» --
// bot/finance/'s deterministic platform-only model (no user_id sent here
// -> the endpoint's own guest branch, dry_finance(ai_inputs=None): no
// market estimate, no AI cost lines, only what the auction rules
// themselves determine), never an LLM call.
//
// 14.4b (owner correction, live on sauda_337929758637000000): the guest
// model's sale price is a PLACEHOLDER (no AI market estimate -> falls
// back to appraisal, finance/model.py::compute) -- max_bid derived from
// it is a specific, wrong-looking number (28 781 373 ₸ shown for a
// 13-16M Hiace), never rendered here again; #lotEntryConditionsHint names
// the limitation instead. deposit_pct/step_pct/step_mode now come from
// PurchaseResult itself (finance/model.py -- 14.4b added them there),
// the engine's own resolved PlatformInputs values, not the raw lot dict
// (l.step_pct/l.deposit_pct are ETP-only scraped fields, silently None
// for every real Sauda lot -- found live exactly on this test lot).
// TASK29 29.4: одна точка чтения гарантийного взноса из строки лота —
// для строки «Гарантийный взнос» в шапке лота (сайт и Mini App) и для
// карточки «Условия входа», чтобы одна карточка не показывала два числа.
function lotGuaranteeAmount(l) {
    if (!l) return null;
    let g = l.guarantee_amount || l.guarantee_fee;
    if (!g && l.additional_params) g = l.additional_params['Гарантийный взнос'];
    if (typeof g === 'string') g = parseFloat(g.replace(/[^0-9.]/g, ''));
    return g > 0 ? g : null;
}

async function loadLotEntryConditions(lotId, lot = null) {
    const wrap = document.getElementById('lotEntryConditions');
    const body = document.getElementById('lotEntryConditionsBody');
    const hint = document.getElementById('lotEntryConditionsHint');
    if (!wrap || !body) return;
    const showNothing = () => { wrap.classList.add('hidden'); if (hint) hint.classList.add('hidden'); };
    try {
        const r = await fetch(`/api/lot/${lotId}/model`);
        if (!r.ok) { showNothing(); return; }
        const data = await r.json();
        const m = data && data.model;
        if (!m || !m.purchase) { showNothing(); return; }

        const fmtPctLot = (v) => (v % 1 === 0 ? v : v.toFixed(1)).toString().replace('.', ',');
        const rows = [];

        // 14.4b: step_pct/step_mode/deposit_pct come from PurchaseResult
        // (finance/model.py) -- the engine's own resolved PlatformInputs
        // values (including Sauda's п.46 5%-compound default), not the
        // raw lot dict. l.step_pct/l.deposit_pct are ETP-only scraped
        // fields and silently None for every real Sauda lot, which is
        // why these rows never appeared there before.
        // TASK29 29.4: «Гарантийный взнос» (как в строке шапки лота). Сумма —
        // из строки лота, если она там есть (тот же lotGuaranteeAmount(), что у
        // шапки), иначе расчёт движка; 0/нет — «нет данных», а не «0 ₸
        // (засчитывается в оплату)», которое читалось как «взнос не нужен».
        const lotG = lotGuaranteeAmount(lot);
        const engineG = m.capital && m.capital.deposit_locked > 0 ? m.capital.deposit_locked : null;
        if (lotG) {
            const pct = typeof lot.deposit_pct === 'number' ? `${fmtPctLot(lot.deposit_pct)}\u00a0% \u00b7 ` : '';
            rows.push({ label: 'Гарантийный взнос', value: `${pct}${fmMoney(lotG)} (в счёт оплаты)` });
        } else if (engineG) {
            const pct = typeof m.purchase.deposit_pct === 'number' ? `${fmtPctLot(m.purchase.deposit_pct)}\u00a0% \u00b7 ` : '';
            rows.push({ label: 'Гарантийный взнос', value: `${pct}${fmMoney(engineG)} (в счёт оплаты)` });
        } else {
            rows.push({ label: 'Гарантийный взнос', value: 'нет данных' });
        }
        if (typeof m.purchase.step_pct === 'number') {
            const modeLabel = m.purchase.step_mode === 'compound' ? 'сложный' : 'от оценки';
            rows.push({ label: 'Шаг', value: `${fmtPctLot(m.purchase.step_pct)}\u00a0% (${modeLabel})` });
        }
        // TASK16 16.0.1: ETP shows its real last step here, not the
        // unreachable regulatory floor -- see fmFloorLabelPrice.
        const { price: floorLabelPrice, isLastStep: floorIsLastStep } = fmFloorLabelPrice(m);
        if (floorLabelPrice != null) {
            rows.push({ label: floorIsLastStep ? 'Последний шаг' : 'Пол', value: fmMoney(floorLabelPrice) });
        }
        const atFloor = floorLabelPrice != null && m.purchase.price === floorLabelPrice;
        const priceLabel = atFloor
            ? (floorIsLastStep ? 'Цена на последнем шаге' : 'Цена на полу')
            : (m.purchase.step_k != null ? `Цена на шаге ${m.purchase.step_k}` : 'Цена входа');
        rows.push({ label: priceLabel, value: fmMoney(m.purchase.price) });
        if (typeof m.purchase.availability_pct === 'number' && m.purchase.availability_pct < 100) {
            rows.push({ label: 'Доступна с вероятностью', value: `${m.purchase.availability_pct} %` });
        }
        if (!rows.length) { showNothing(); return; }

        body.innerHTML = rows.map(row => `<div class="lot-term-row">
            <span class="text-caption text-secondary">${row.label}</span>
            <span class="text-body text-primary font-mono-nums">${row.value}</span>
        </div>`).join('');
        wrap.classList.remove('hidden');
        if (hint) hint.classList.remove('hidden');
    } catch (e) {
        console.error('Ошибка загрузки условий входа:', e);
        showNothing();
    }
}

// ДОБАВЛЕНО (TASK6 6.2): строка терм-сетки панели — видна только когда есть
// значение (§7.7 "rows only when the value exists"), values допускают HTML
// (badge/цвет чипа) через isHtml.
function setLotTermRow(rowId, valueId, value, isHtml = false) {
    const row = document.getElementById(rowId);
    const valueEl = document.getElementById(valueId);
    if (!row || !valueEl) return;
    if (!value) {
        row.classList.add('hidden');
        return;
    }
    if (isHtml) valueEl.innerHTML = value; else valueEl.textContent = value;
    row.classList.remove('hidden');
}

// ДОБАВЛЕНО (TASK6 6.2, C-12): та же природа проверки, что hasExplicitEncumbrance()
// (TASK4 4.6b, script.js — оставлена как есть, её использует карточка), но
// БЕЗ вычитания шаблонной строки площадки — здесь, на странице лота,
// боилерплейт "Имеются обременения" и есть ответ (§8.5 решение), не шум.
// Отрицания ("без обременений"/"обременения: нет"/пустое значение после
// лейбла) по-прежнему не считаются фактом.
function hasEncumbranceMentionSite(description) {
    const d = (description || '').trim();
    if (!d) return false;
    if (!/обремен/i.test(d)) return false;
    if (/без\s+обременени|обременени[а-яё]*\s*[:\-–—]?\s*(нет|отсутств)|не\s+имеется\s+обременени/i.test(d)) return false;
    if (/обременени[а-яё]*\s*[:\-–—]?\s*[;.,]/i.test(d)) return false;
    return true;
}

// ДОБАВЛЕНО (TASK6 6.3, §5): «Показать всё»/«Свернуть» под описанием —
// кнопка видна ТОЛЬКО когда текст реально не помещается в 4 строки клэмпа
// (dashboard.css, -webkit-line-clamp) — иначе кнопка была бы бесполезной
// декорацией. requestAnimationFrame — клэмп применяется браузером после
// текущего кадра, scrollHeight/clientHeight до него ещё не разошлись.
function initLotDescriptionToggle() {
    const desc = document.getElementById('detailDesc');
    const btn = document.getElementById('lotDescToggle');
    if (!desc || !btn) return;
    desc.classList.remove('expanded');
    btn.textContent = 'Показать всё';
    requestAnimationFrame(() => {
        const overflowing = desc.scrollHeight > desc.clientHeight + 2;
        btn.classList.toggle('hidden', !overflowing);
    });
    btn.onclick = () => {
        const expanded = desc.classList.toggle('expanded');
        btn.textContent = expanded ? 'Свернуть' : 'Показать всё';
    };
}

// ДОБАВЛЕНО (TASK6 6.3, §5): документы — сайт перерисовывает
// #detailDocsContainer поверх того, что уже построил populateLotDetail()
// (общий с Mini App, простые кнопки без типа/размера) — тип иконки
// приоритетно берёт doc.file_type (есть в payload, ETP), фолбэк — по
// расширению имени; размер — только если реально есть в payload (сейчас
// нет ни у ETP, ни у Sauda — задел на будущее, не выдумываем данные).
// #docCountLabel/#docsWrapper/#docsToggleBtn/#docsCaret — те же id,
// toggleDocs() (общая) не переписана.
function renderLotDocsSite(l) {
    const docs = l.documents || [];
    const container = document.getElementById('detailDocsContainer');
    const wrapper = document.getElementById('docsWrapper');
    if (!container || !wrapper) return;

    if (!docs.length) {
        container.innerHTML = '';
        wrapper.classList.remove('open');
        document.getElementById('docsCaret')?.classList.remove('rotate');
        updateLotDocsLabel();
        return;
    }

    // ИСПРАВЛЕНО (TASK6 6.6, п.3): doc.file_type у ETP всегда "pdf" —
    // проверено вживую на реальных .jpeg-вложениях (backend-баг, не наш) —
    // поэтому иконка ТОЛЬКО по расширению имени, file_type больше не
    // спрашиваем: pdf → ph-file-pdf, jpg/jpeg/png/webp → ph-file-image,
    // doc/docx/xls/xlsx → ph-file-text, иначе ph-file.
    const iconFor = (doc, name) => {
        const n = (name || '').toLowerCase();
        if (n.endsWith('.pdf')) return 'ph-file-pdf';
        if (/\.(jpe?g|png|webp)$/i.test(n)) return 'ph-file-image';
        if (/\.(docx?|xlsx?)$/i.test(n)) return 'ph-file-text';
        return 'ph-file';
    };
    const formatSize = (bytes) => {
        const n = Number(bytes);
        if (!n || n <= 0) return '';
        if (n < 1024 * 1024) return `${Math.round(n / 1024)} КБ`;
        return `${(n / (1024 * 1024)).toFixed(1)} МБ`;
    };

    container.innerHTML = docs.map((doc, i) => {
        const url = typeof doc === 'string' ? doc : doc.url;
        const name = (typeof doc === 'object' && doc.name) ? doc.name : `Документ ${i + 1}`;
        const size = typeof doc === 'object' ? formatSize(doc.size || doc.file_size) : '';
        return `<a href="${escapeHtml(url)}" target="_blank" rel="noopener" class="lot-doc-row" title="${escapeHtml(name)}">
            <i class="ph-bold ${iconFor(doc, name)} lot-doc-icon"></i>
            <span class="lot-doc-name">${escapeHtml(name)}</span>
            ${size ? `<span class="text-caption text-tertiary font-mono-nums">${size}</span>` : ''}
            <span class="btn-ghost sm lot-doc-open">Открыть <i class="ph-bold ph-arrow-square-out"></i></span>
        </a>`;
    }).join('');

    // §5: "Default expanded when N ≤ 5, collapsed with «Показать N
    // документов» otherwise".
    wrapper.classList.toggle('open', docs.length <= 5);
    updateLotDocsLabel();
}

// ДОБАВЛЕНО (TASK6 6.3, §5): подпись кнопки-тоггла документов — «Документы ·
// N» раскрыто, «Показать N документов» свёрнуто. Вызывается из
// renderLotDocsSite() (первая отрисовка) и из onclick #docsToggleBtn в
// lot.html (после toggleDocs(), та не знает про этот текст).
function updateLotDocsLabel() {
    const label = document.getElementById('docCountLabel');
    const wrapper = document.getElementById('docsWrapper');
    if (!label || !wrapper) return;
    const n = (state.currentLot?.documents || []).length;
    label.textContent = wrapper.classList.contains('open') ? `Документы · ${n}` : `Показать ${n} ${getDocTerm(n)}`;
}

// ДОБАВЛЕНО (TASK6 6.3, §5, C-10): текстовые описания событий истории для
// сайта — без эмодзи, значения в .font-mono-nums. Отдельная от
// describeHistoryEvent() (та общая с Mini App, не переписана — открывается
// из openModal(), см. её вызов loadLotHistory()) функция, не ветка внутри
// неё — иначе пришлось бы протаскивать признак площадки через всю цепочку
// collapseHistoryEvents()/summarizeHistory(), тоже общих.
function describeHistoryEventSite(ev) {
    const fmt = (v) => {
        if (v === null || v === undefined || v === 'None') return '—';
        const n = Number(v);
        return !isNaN(n) && n > 1000 ? `<span class="font-mono-nums">${formatMoney(n)}</span>` : escapeHtml(String(v));
    };
    switch (ev.event_type) {
        case 'price_changed':
            return `Цена изменена: ${fmt(ev.old_value)} → ${fmt(ev.new_value)}`;
        case 'status_changed':
            return `Статус торгов изменён: ${escapeHtml(ev.old_value || '—')} → ${escapeHtml(ev.new_value || '—')}`;
        case 'auction_closed':
            return `Торги завершены / лот снят с публикации`;
        case 'auction_reopened':
            return `Лот снова активен`;
        case 'deadline_changed':
            return `Срок приёма заявок изменён: <span class="font-mono-nums">${escapeHtml(formatDate(ev.old_value) || '—')}</span> → <span class="font-mono-nums">${escapeHtml(formatDate(ev.new_value) || '—')}</span>`;
        case 'guarantee_changed':
            return `Гарантийный взнос изменён: ${fmt(ev.old_value)} → ${fmt(ev.new_value)}`;
        case 'winner_recorded': {
            const name = ev.meta?.name;
            const bin = ev.meta?.bin;
            if (!name && !bin) return `Победитель торгов зафиксирован`;
            return `Победитель торгов: ${escapeHtml(name || 'без имени')}${bin ? ` (БИН/ИИН <span class="font-mono-nums">${escapeHtml(bin)}</span>)` : ''}`;
        }
        // ИЗМЕНЕНО (TASK6 6.3, ревью владельца): было ♻️ + отдельная подсветка
        // в summarizeHistory() (см. loadLotHistorySite() ниже — тот саммари
        // на сайте не вызывается вовсе) — здесь просто строка, «похожесть»
        // мельком, моно-числом, без баннера.
        case 'relisted': {
            const prevId = ev.meta?.previous_lot_id;
            const similarity = ev.meta?.similarity;
            const simText = typeof similarity === 'number' ? ` (совпадение <span class="font-mono-nums">${Math.round(similarity * 100)}%</span>)` : '';
            return `Похоже на повторное выставление лота${prevId ? ` <span class="font-mono-nums">#${escapeHtml(String(prevId))}</span>` : ''}${simText}`;
        }
        default:
            return `Изменение: ${escapeHtml(ev.old_value || '—')} → ${escapeHtml(ev.new_value || '—')}`;
    }
}

// Тот же алгоритм схлопывания подряд идущих одинаковых записей, что
// collapseHistoryEvents() (общая, script.js выше) — своя копия только
// потому, что desc здесь берётся из describeHistoryEventSite(), не из
// эмодзи-версии.
function collapseHistoryEventsSite(events) {
    const collapsed = [];
    for (const ev of events) {
        const desc = describeHistoryEventSite(ev);
        const prev = collapsed[collapsed.length - 1];
        if (prev && prev.desc === desc && prev.event_type === ev.event_type) {
            prev.count += 1;
            prev.firstAt = ev.created_at;
        } else {
            collapsed.push({ desc, event_type: ev.event_type, lastAt: ev.created_at, firstAt: ev.created_at, count: 1 });
        }
    }
    return collapsed;
}

// ДОБАВЛЕНО (TASK6 6.3, §5, C-04): site-only аналог loadLotHistory() (та не
// тронута — общая с Mini App, см. её вызов в openModal()); вызывается ВМЕСТО
// неё из loadLotScreen() (site-only точка входа). Дроп no-op событий
// (old===new, строково-нормализовано — тот самый "20 идентичных событий
// срока подачи", C-04) ДО схлопывания повторов — иначе шумные записи считал
// бы за реальные, раздувая count. Backend debt (не чинится здесь):
// _record_lot_changes (парсер) не должен писать такие события вовсе, см.
// итоговый отчёт. Пусто после фильтра → секция скрыта целиком, не «нет
// изменений» (§9 MUST).
async function loadLotHistorySite(lotId) {
    const container = document.getElementById('lotHistorySection');
    const list = document.getElementById('lotHistoryList');
    if (!container || !list) return;
    container.classList.add('hidden');

    try {
        const r = await fetch(`/api/lot/${lotId}/history`);
        if (!r.ok) return;
        const events = await r.json();
        if (!events || !events.length) return;

        // УДАЛЕНО (TASK9 9.2): клиентский фильтр но-опов («старое»/«новое» —
        // РАЗНЫЕ строки для ОДНОГО и того же момента, "2026-09-24
        // 05:00:00+00:00" vs "2026-09-24 10:00:00" — backend терял офсет
        // при сравнении таймзон). Корень (_normalize_deadline_for_compare/
        // _record_lot_changes, parser/shared/database/postgres_db.py)
        // исправлен — событие не пишется вовсе, если нормализованные
        // old/new совпадают, — фильтровать на клиенте больше нечего.
        // collapseHistoryEventsSite() остаётся — она про другое (схлопывает
        // ПОДРЯД ИДУЩИЕ повторы одного и того же настоящего изменения в
        // "×N", не про обнаружение но-опов).
        container.classList.remove('hidden');
        list.innerHTML = collapseHistoryEventsSite(events).map((item) => {
            const rel = fmtDate(item.lastAt);
            const abs = fmtDateTime(item.lastAt) || '';
            // ИЗМЕНЕНО (TASK6 6.3, ревью владельца): «1×» не показываем —
            // счётчик только при count>=2 (то же условие, что уже было у
            // count>1 — переписано явно, чтобы не полагаться на то, что
            // ">1" и ">=2" для целых совпадают случайно).
            const countHtml = item.count >= 2 ? ` <span class="text-tertiary font-mono-nums">×${item.count}</span>` : '';
            return `<div class="lot-history-row" title="${escapeHtml(abs)}">
                <span class="text-caption text-tertiary font-mono-nums lot-history-date">${escapeHtml(rel)}</span>
                <span class="text-body text-secondary">${item.desc}${countHtml}</span>
            </div>`;
        }).join('');
    } catch (e) {
        console.error('[loadLotHistorySite]', e); // второстепенная секция — не показываем ошибку пользователю
    }
}

// ДОБАВЛЕНО (TASK6 6.4, §6, P3): «Похожие лоты» — 4 карточки renderLotCardSite()
// (переиспользована как есть, TASK4 4.4 — не переписана) по category+region
// текущего лота минус сам лот; блок скрыт целиком при <2 результатах (0-1
// "похожих" не несут смысла как отдельный блок). Region — тот же приём, что
// уже использует region-ячейка renderLotRow() (первый сегмент до запятой в
// l.location, script.js:LOT_ROW_CELL_RENDERERS.region) — /api/lots?region=
// принимает и этот сырой текст ("г. Астана"), и канонический id ("Astana",
// см. /api/regions) с одинаковым результатом (проверено вживую), второй
// маппинг заводить не пришлось. Никакого нового API — тот же /api/lots.
async function loadSimilarLots(l) {
    const section = document.getElementById('lotSimilarSection');
    const grid = document.getElementById('lotSimilarGrid');
    if (!section || !grid) return;
    section.classList.add('hidden');
    if (!l.category) return;

    const region = (l.location || '').split(',')[0].trim();
    const params = new URLSearchParams({ category: l.category, limit: 5 });
    if (region) params.set('region', region);

    try {
        const r = await fetch(`/api/lots?${params.toString()}`);
        if (!r.ok) return;
        const lots = (await r.json()).filter((x) => String(x.id) !== String(l.id)).slice(0, 4);
        if (lots.length < 2) return;

        grid.innerHTML = '';
        const fragment = document.createDocumentFragment();
        lots.forEach((x) => fragment.appendChild(renderLotCardSite(x)));
        grid.appendChild(fragment);
        section.classList.remove('hidden');
    } catch (e) {
        console.error('[loadSimilarLots]', e); // второстепенная секция — не показываем ошибку пользователю
    }
}

// ДОБАВЛЕНО (TASK6 6.1, §2): «Поделиться» в шапке лота — если анализ уже
// есть (completed/verdict_only — та же граница, что и у CTA чуть ниже),
// делится ссылкой НА ОТЧЁТ через существующий shareReport() (та сама решает
// !IS_TELEGRAM/копирует /workspace/analysis/{id}); иначе копирует ссылку на
// САМУ страницу лота — у shareReport() такого пути нет (она всегда собирает
// analysis-URL), поэтому здесь отдельная, короткая ветка.
window.shareLotPage = () => {
    // Вызывается только из #btnShareLot (lot.html, site-only) — IS_TELEGRAM
    // здесь всегда false, отдельная ветка не нужна.
    const status = state.currentLot?.analysis_status;
    if (status === 'completed' || status === 'verdict_only') {
        // shareReport() (сайт-ветка) копирует /workspace/analysis/{id} и
        // ищет иконку-галочку по #btnShareReport (кнопка шапки отчёта, не
        // существует на странице лота) — молча не находит, поэтому свой
        // toast вместо несработавшей бы подсветки иконки.
        shareReport();
        showToast('Ссылка скопирована');
        return;
    }
    if (!navigator.clipboard) return;
    navigator.clipboard.writeText(window.location.href).then(() => {
        showToast('Ссылка скопирована');
    }).catch(() => {});
};

// Mini App: карточка лота — модалка #detailModal. sourceImgEl/updateUrl —
// параметры, значимые только здесь (shared-element перелёт картинки,
// пропуск pushState при программном переходе из popstate — последнего
// больше нет на сайте, см. §5.4, но сигнатура не менялась ради Mini App
// call-сайтов). На сайте эта функция больше не вызывается ни из одного
// места — там реальная навигация на /workspace/lot/{id}, см. loadLotScreen().
async function openModal(id, sourceImgEl = null, updateUrl = true) {
    try {
        // 1. Сбрасываем старый поллинг
        if (pollingInterval) {
            clearInterval(pollingInterval);
            pollingInterval = null;
        }

        // 2. Запрашиваем свежие данные (с timestamp, чтобы избежать кэша браузера)
        // ДОБАВЛЕНО (анонимный просмотр лотов): userId может быть пустым —
        // см. комментарий в loadLots() про то, почему "не передавать
        // параметр" и "передать буквальную строку null/undefined" для
        // Optional[int] на бэкенде это разные вещи.
        const detailUrl = `/api/lot/${id}?t=${Date.now()}` + (userId ? `&user_id=${userId}` : '');
        const r = await fetch(detailUrl);
        const l = await r.json();
        state.currentLot = l;

        const img = populateLotDetail(l);

        // Показываем модалку
        document.getElementById('detailModal').classList.add('open');
        tg.BackButton.show();
        // ИСПРАВЛЕНО (05.09.2026, лот теперь может открываться ПОВЕРХ
        // карты — см. buildLotPinElement()): tg.BackButton.onClick() у
        // настоящего Telegram-SDK добавляет обработчик, а не заменяет
        // предыдущий — если карта уже вызывала onClick(closeMapModal), тот
        // обработчик остался бы висеть и сработал бы ВМЕСТЕ с closeModal по
        // одному нажатию "назад" (закрыло бы разом и лот, и карту). offClick
        // безопасен, даже если такого обработчика не было.
        tg.BackButton.offClick(closeMapModal);
        tg.BackButton.onClick(closeModal);

        // Shared-element "перелёт" картинки из карточки в hero-изображение
        // модалки — чисто визуальный оверлей поверх уже открытой модалки,
        // ничего не блокирует и не задерживает.
        flyImageTransition(sourceImgEl, img);

        loadLotHistory(id); // не блокируем открытие модалки — грузим отдельно

    } catch (e) {
        console.error("Ошибка открытия модалки:", e);
    }
}

// ДОБАВЛЕНО (§5.4 DESIGN_MASTER_PROMPT.md, "сайт — не приложение"):
// заполняет #screen-lot данными лота — сайтовый аналог openModal(), без
// модалки/BackButton/pushState. Общая точка для прямого захода на
// /workspace/lot/{id} (workspace-bootstrap.js, см. её комментарий) — других
// вызовов на сайте нет, все клики по лоту теперь настоящая навигация
// (location.href), а не SPA-переход.
async function loadLotScreen(lotId) {
    try {
        const detailUrl = `/api/lot/${lotId}?t=${Date.now()}` + (userId ? `&user_id=${userId}` : '');
        const r = await fetch(detailUrl);
        const l = await r.json();
        state.currentLot = l;
        populateLotDetail(l);
        // TASK6 6.1: loadLotScreen() — единственный вызывающий, только для
        // /workspace/lot/{id} (site) — см. её же комментарий в
        // populateLotDetailSite().
        // TASK6 6.3: loadLotHistorySite() — не loadLotHistory() (та общая с
        // Mini App/openModal(), не тронута) — тот же !IS_TELEGRAM контракт.
        if (!IS_TELEGRAM) { populateLotDetailSite(l); loadLotHistorySite(lotId); loadSimilarLots(l); loadLotEntryConditions(lotId, l); } else { loadLotHistory(lotId); }
    } catch (e) {
        console.error('Ошибка загрузки лота:', e);
    }
}

// --- ХЕЛПЕРЫ ---
// getRecBadgeData и formatDate раньше были объявлены здесь ВТОРОЙ раз (ниже по
// файлу есть ещё одна версия каждой функции). В JS дубли function-деклараций
// в одной области видимости не ошибка — просто вторая тихо перекрывает первую,
// и код ниже реально никогда не выполнялся. Удалено как мёртвый код;
// актуальные версии — см. getRecBadgeData() и formatDate() ниже по файлу.

function getDocTerm(n) {
    if (n % 10 === 1 && n % 100 !== 11) return 'документ';
    if ([2, 3, 4].includes(n % 10) && ![12, 13, 14].includes(n % 100)) return 'документа';
    return 'документов';
}

// 🔥 УПРАВЛЕНИЕ ОКНОМ АНАЛИЗА
function openAnalysisModal() {
    if (!currentAiReport) return;

    // ДОБАВЛЕНО (§5.4 DESIGN_MASTER_PROMPT.md, "сайт — не приложение"): на
    // сайте анализ — своя страница /workspace/analysis/{lot_id}, открытая
    // настоящей навигацией (полная перезагрузка), не SPA-переходом поверх
    // ещё открытой модалки лота. На сайте эта функция сама по себе больше
    // нигде не вызывается как onclick (кнопка "ОТКРЫТЬ АНАЛИЗ" на
    // #screen-lot — обычная <a href>, см. populateLotDetail()) — ветка
    // ниже остаётся как защита для любых прочих вызовов (например,
    // openHistoryAnalysis() из "Моих анализов").
    if (!IS_TELEGRAM) {
        const lotId = state.currentLot?.id;
        if (!lotId) return;
        window.location.href = `/workspace/analysis/${lotId}`;
        return;
    }

    const modal = document.getElementById('analysisModal');
    modal.classList.remove('hidden');
    // ИСПРАВЛЕНО (05.09.2026, см. openModalOverMap()): если карточка лота
    // была открыта прямо с карты (#detailModal.modal-over-map), отчёт ИИ,
    // открытый из неё, тоже должен лечь поверх карты, а не под ней —
    // переносим тот же класс.
    if (document.getElementById('detailModal').classList.contains('modal-over-map')) {
        modal.classList.add('modal-over-map');
    }

    // Плавный выезд
    setTimeout(() => {
        modal.classList.remove('translate-y-full');
    }, 10);

    // Заполняем шапку данными текущего лота
    if (state.currentLot) {
        document.getElementById('uiAnalisysTitle').innerText = formatLotTitle(state.currentLot).primary;
        document.getElementById('uiAnalisysPrice').innerText = `${getPriceLabel(state.currentLot.type_trading)}: ${formatMoney(state.currentLot.start_price)}`;
    }

    // Рендерим данные — тот же набор вызовов, что и loadAnalysisScreen() на сайте (классический отчёт, см. REPORT_LEGACY_MARKUP).
    const scroller = document.getElementById('pdfContentArea');
    if (scroller) scroller.scrollTop = 0;
    renderClassicReport(currentAiReport);
    initAdminRerunButton();
    renderStaleBanner(currentAiReport);
}

function closeAnalysisModal() {
    const modal = document.getElementById('analysisModal');
    modal.classList.add('translate-y-full');
    setTimeout(() => {
        modal.classList.add('hidden');
    }, 300);
}

// ДОБАВЛЕНО (§5.4 DESIGN_MASTER_PROMPT.md): заполняет #screen-analysis
// отчётом по lotId — общая точка для трёх путей: клика по лоту (см.
// pendingAnalysisLotId в openAnalysisModal() выше), прямого захода на
// /workspace/analysis/{id} (см. workspace-bootstrap.js) и браузерных
// back/forward (см. popstate ниже). Вызывается ТОЛЬКО из хука в wrapped
// switchScreen ('analysis' в SCREENS_REQUIRE_LOGIN) — то есть уже после
// того, как гейт логина пропустил залогиненного пользователя, анонима
// switchScreen сам уводит на #screen-login, сюда мы не доходим.
// Если currentAiReport уже относится к этому же lotId (например, только
// что заполнен внутри openModal() перед вызовом openAnalysisModal()) —
// повторный /api/lot/{id} не делаем, тот же приём, что и в openModal().
async function loadAnalysisScreen(lotId) {
    if (state.currentLot?.id !== lotId || !currentAiReport) {
        try {
            const detailUrl = `/api/lot/${lotId}?t=${Date.now()}` + (userId ? `&user_id=${userId}` : '');
            const r = await fetch(detailUrl);
            const l = await r.json();
            if (!l.raw_report) {
                // Нет своего анализа этого лота (истёк доступ, чужая ссылка
                // и т.п.) — та же судьба, что и у server-side редиректа в
                // workspace_analysis_page(): обычная страница лота вместо
                // пустого/битого экрана отчёта.
                window.location.href = `/workspace/lot/${lotId}`;
                return;
            }
            state.currentLot = l;
            currentAiReport = l.raw_report;
        } catch (e) {
            console.error('Ошибка загрузки анализа:', e);
            return;
        }
    }
    document.getElementById('uiAnalisysTitle').innerText = formatLotTitle(state.currentLot).primary;
    document.getElementById('uiAnalisysPrice').innerText = `${getPriceLabel(state.currentLot.type_trading)}: ${formatMoney(state.currentLot.start_price)}`;
    renderClassicReport(currentAiReport);
    initAdminRerunButton();
    renderStaleBanner(currentAiReport);
}

// TASK16 16.1: reveal btnAdminRerunAnalysis (report header row, site only --
// see its own comment in partials/screens/analysis.html) only for admins.
// Same reveal pattern as adminPanelBtn on Profile -- server doesn't hide
// it via a template flag here (this partial has no admin context passed
// in), so the button starts `hidden` in markup and this just un-hides it.
function initAdminRerunButton() {
    const btn = document.getElementById('btnAdminRerunAnalysis');
    if (!btn) return;
    btn.classList.toggle('hidden', !(userProfile && userProfile.is_admin));
}

// TASK16 16.1: admin "Повторить анализ" -- a real paid (for us) Gemini call
// on the admin's OWN user_id, free for them (charged_credits=0, see the
// endpoint's own docstring). Confirm dialog wording is the brief's own.
// Own small self-contained poll loop rather than the lot-page's shared
// startPolling()/updateButtonState() -- those manipulate lot-page-specific
// DOM (detailRecBadgeContainer, the analyze button) this report-page
// button doesn't have; reloading the page once the fresh analysis lands
// is simpler and correct here (the WHOLE report, not just one field,
// needs to reflect the new financial_model/verdict/narrative).
window.adminRerunAnalysis = async () => {
    if (!state.currentLot || !userId) return;
    if (!confirm('Новый анализ, старый сохранится. Стоит денег API.')) return;

    const btn = document.getElementById('btnAdminRerunAnalysis');
    if (btn) { btn.disabled = true; btn.querySelector('span').textContent = 'В очереди…'; }

    try {
        const res = await fetch(`/api/admin/analysis/rerun?admin_id=${userId}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ lot_id: state.currentLot.id }),
        });
        const data = await res.json().catch(() => ({}));
        if (!res.ok) {
            alert(data.message || data.detail || 'Не удалось запустить повторный анализ');
            if (btn) { btn.disabled = false; btn.querySelector('span').textContent = 'Повторить анализ'; }
            return;
        }
        adminRerunPollLotId = state.currentLot.id;
        adminRerunPoll();
    } catch (e) {
        console.error('Ошибка перезапуска анализа:', e);
        alert('Ошибка сети');
        if (btn) { btn.disabled = false; btn.querySelector('span').textContent = 'Повторить анализ'; }
    }
};

let adminRerunPollLotId = null;
let adminRerunPollTimer = null;

async function adminRerunPoll() {
    if (adminRerunPollTimer) clearTimeout(adminRerunPollTimer);
    const lotId = adminRerunPollLotId;
    try {
        const r = await fetch(`/api/analysis/status?user_id=${userId}&lot_id=${lotId}&t=${Date.now()}`);
        const d = r.ok ? await r.json() : null;
        if (d && (d.status === 'completed' || d.status === 'failed')) {
            window.location.reload();
            return;
        }
    } catch (e) {
        console.warn('Ошибка опроса статуса перезапуска:', e);
    }
    adminRerunPollTimer = setTimeout(adminRerunPoll, 3000);
}

function closeModal() {
    document.getElementById('detailModal').classList.remove('open');
    // ИСПРАВЛЕНО (05.09.2026, "лот, открытый через карту, закрывает её
    // насовсем"): карточка лота теперь может быть открыта ПОВЕРХ карты (см.
    // openModalOverMap()/buildLotPinElement() выше — карту больше не
    // закрывают перед открытием лота). .modal-over-map снимаем всегда,
    // независимо от того, как лот был открыт — класс временный, только на
    // время показа лота именно с карты (см. dashboard.css), в следующий раз
    // его снова поставит openModalOverMap(), если понадобится.
    document.getElementById('detailModal').classList.remove('modal-over-map');
    // ?. — на сайте #analysisModal больше не рендерится (§5.4, см.
    // shells/site.html), только в Mini App; в Telegram элемент есть всегда.
    document.getElementById('analysisModal')?.classList.remove('modal-over-map');
    // Если карта осталась открытой под карточкой — прячем кнопку "назад" не
    // насовсем, а возвращаем её карте (иначе аппаратная/Telegram-кнопка
    // "назад" перестанет закрывать карту, и пользователь застрянет на
    // открытой карте без способа её закрыть).
    const mapStillOpen = document.getElementById('mapModal').classList.contains('open');
    if (mapStillOpen) {
        tg.BackButton.show();
        tg.BackButton.offClick(closeModal); // см. комментарий у tg.BackButton.offClick в openModal()
        tg.BackButton.onClick(closeMapModal);
    } else {
        tg.BackButton.hide();
    }
    stopPolling(); // 🔥 Теперь используем нашу умную функцию остановки
    // Поллинг покупки вердикта (buyVerdict) убран вместе с самой функцией
    // 26.08 — продукт не использовался, чистить здесь больше нечего.

    // УДАЛЕНО (§5.4 DESIGN_MASTER_PROMPT.md, "сайт — не приложение"): здесь
    // стоял pushState, возвращавший адрес активной вкладки после закрытия
    // модалки лота — нужен был только пока лот на сайте был модалкой,
    // визуально притворяющейся страницей (position:static-хаки, см. git-
    // историю dashboard.css). Теперь #detailModal — Mini-App-only модалка,
    // closeModal() на сайте никогда не вызывается (там свой экран
    // #screen-lot, а "закрыть" — обычная ссылка "Назад", реальная
    // навигация). SCREEN_TO_PATH ниже остаётся — её ещё использует
    // командная палитра (cmdkLotItem() и соседи).
}

// ДОБАВЛЕНО (аудит "мини-апп ведёт себя как сайт"): карта id экрана → его
// URL на сайте — используется командной палитрой (см. ниже) для подсказок-
// ссылок. Экран #screen-global живёт по адресу /workspace/reports (см.
// канонический комментарий в partials/screens/global.html) — не
// переименовывать здесь.
const SCREEN_TO_PATH = {
    'screen-home': '/workspace',
    'screen-favorites': '/workspace/favorites',
    'screen-global': '/workspace/reports',
    'screen-profile': '/workspace/profile',
    'screen-analyses': '/workspace/analyses',
};

// УДАЛЕНО (§5.4 DESIGN_MASTER_PROMPT.md, "сайт — не приложение", повторная
// правка): здесь стояли — перехватчик клика по a[data-nav] (preventDefault +
// switchScreen + pushState), принудительный history.scrollRestoration =
// 'manual' и обработчик popstate, синхронизировавший модалки лота/анализа
// и вкладки с адресной строкой. Вся эта механика была нужна, чтобы имитировать
// многостраничный сайт поверх SPA-переключения экранов — теперь сайт
// НАСТОЯЩИЙ многостраничный: вкладки (#sidebarNav и т.п.) — обычные <a href>,
// каждый переход — полная перезагрузка, экран, который должен быть активным,
// сервер уже отрисовывает через active_screen (см. _render_workspace() в
// api_server.py). Back/Forward и восстановление скролла — целиком браузер,
// без единой строчки JS. В Mini App этот перехватчик был нужен ВСЕГДА (там
// нет ни адресной строки, ни повторных запросов к серверу за вкладками) —
// он остался, просто теперь безусловный (не завязан на IS_TELEGRAM), см. его
// ниже, рядом с остальными Mini-App-специфичными обработчиками кликов.
document.addEventListener('click', (e) => {
    if (!IS_TELEGRAM) return;
    const a = e.target.closest && e.target.closest('a[data-nav]');
    if (!a) return;
    if (e.defaultPrevented || e.button !== 0) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (a.target && a.target !== '_self') return;

    const nav = a.dataset.nav;
    if (!nav || !document.getElementById('screen-' + nav)) return;

    e.preventDefault();
    // Именно window.switchScreen — обёртка, а не базовая функция: в обёртке
    // живёт гейт логина (SCREENS_REQUIRE_LOGIN) и защита от мелькания экрана
    // входа через authChecked.
    window.switchScreen(nav);
});

// --- Фаза 4: история цены/статуса лота ---

function describeHistoryEvent(ev) {
    // Фаза 15 (30.08.2026): formatMoney() уже добавляет "₸" сама (см. её
    // определение выше) — здесь раньше дописывали ещё один " ₸" поверх,
    // получалось "150 000 000 ₸ ₸".
    const fmt = v => {
        if (v === null || v === undefined || v === 'None') return '—';
        const n = Number(v);
        return !isNaN(n) && n > 1000 ? formatMoney(n) : v;
    };
    switch (ev.event_type) {
        case 'price_changed':
            return `💰 Цена изменена: ${fmt(ev.old_value)} → ${fmt(ev.new_value)}`;
        case 'status_changed':
            return `🔄 Статус торгов изменён: ${ev.old_value || '—'} → ${ev.new_value || '—'}`;
        case 'auction_closed':
            return `🔒 Торги завершены / лот снят с публикации`;
        case 'auction_reopened':
            return `🔓 Лот снова активен`;
        // Миграция 0009_lot_history_extended_and_relisting.sql — раньше эти
        // 4 типа событий падали в default (сырые old/new без объяснения,
        // что вообще произошло, а у winner_recorded/relisted нужные данные
        // лежат в ev.meta, которого default вообще не читает).
        case 'deadline_changed':
            return `📅 Срок приёма заявок изменён: ${formatDate(ev.old_value) || '—'} → ${formatDate(ev.new_value) || '—'}`;
        case 'guarantee_changed':
            return `🔐 Гарантийный взнос изменён: ${fmt(ev.old_value)} → ${fmt(ev.new_value)}`;
        case 'winner_recorded': {
            const name = ev.meta?.name;
            const bin = ev.meta?.bin;
            if (!name && !bin) return `🏆 Победитель торгов зафиксирован`;
            return `🏆 Победитель торгов: ${name || 'без имени'}${bin ? ` (БИН/ИИН ${bin})` : ''}`;
        }
        case 'relisted': {
            const prevId = ev.meta?.previous_lot_id;
            const similarity = ev.meta?.similarity;
            const simText = typeof similarity === 'number' ? ` (совпадение ${Math.round(similarity * 100)}%)` : '';
            return `♻️ Похоже на повторное выставление лота${prevId ? ` #${prevId}` : ''}${simText}`;
        }
        default:
            return `Изменение: ${ev.old_value || '—'} → ${ev.new_value || '—'}`;
    }
}

// Фаза 15 (30.08.2026, "не понимаю пользу этой истории"): сырой список
// событий как есть плохо читается по двум причинам сразу:
//   1) шумные повторы — deadline_changed (и потенциально другие типы)
//      мог логироваться на каждом цикле опроса лота даже когда срок
//      реально не менялся (см. фикс сравнения в
//      postgres_db.py::_record_lot_changes) — уже накопленный в БД шум
//      этим бэкенд-фиксом не убирается, поэтому схлопываем подряд идущие
//      одинаковые записи здесь же, на отображении;
//   2) даже без повторов список из 10+ разрозненных событий не отвечает
//      на вопрос, который инвестора реально интересует: "и что это для
//      меня значит?" — снижали ли цену и на сколько всего, переносили ли
//      срок и сколько раз, не перевыставляли ли лот заново. summarizeHistory
//      ниже считает это один раз по всем событиям и показывает как
//      готовые выводы над сырым списком.
function collapseHistoryEvents(events) {
    const collapsed = [];
    for (const ev of events) {
        const desc = describeHistoryEvent(ev);
        const prev = collapsed[collapsed.length - 1];
        // events приходят от новых к старым (см. API) — при схлопывании
        // "lastAt" остаётся временем первого (самого нового) вхождения,
        // "firstAt" сдвигается на самое старое по мере обхода.
        if (prev && prev.desc === desc && prev.event_type === ev.event_type) {
            prev.count += 1;
            prev.firstAt = ev.created_at;
        } else {
            collapsed.push({ desc, event_type: ev.event_type, lastAt: ev.created_at, firstAt: ev.created_at, count: 1 });
        }
    }
    return collapsed;
}

function summarizeHistory(events) {
    const chips = [];

    const priceEvents = events.filter(e => e.event_type === 'price_changed');
    if (priceEvents.length) {
        // events отсортированы от новых к старым: [0] — самое свежее
        // изменение, последний элемент — самое первое. Сравниваем
        // начальную и конечную цену за всё время, а не только последний шаг.
        const start = Number(priceEvents[priceEvents.length - 1].old_value);
        const end = Number(priceEvents[0].new_value);
        if (!isNaN(start) && !isNaN(end) && start > 0) {
            const pct = Math.round((end - start) / start * 100);
            const label = pct < 0 ? '📉 Цена снижена' : pct > 0 ? '📈 Цена повышена' : '💰 Цена менялась';
            const pctText = pct !== 0 ? ` на ${Math.abs(pct)}%` : '';
            const timesText = priceEvents.length > 1 ? ` (${priceEvents.length}×)` : '';
            chips.push(`${label}${pctText}${timesText}: ${formatMoney(start)} → ${formatMoney(end)}`);
        }
    }

    const deadlineEvents = events.filter(e => e.event_type === 'deadline_changed');
    if (deadlineEvents.length) {
        chips.push(`📅 Срок подачи заявок переносился ${deadlineEvents.length}×, действующий срок: ${formatDate(deadlineEvents[0].new_value)}`);
    }

    if (events.some(e => e.event_type === 'relisted')) {
        chips.push(`♻️ Похоже на повторное выставление — предыдущие торги по этому же объекту, вероятно, не состоялись`);
    }
    if (events.some(e => e.event_type === 'winner_recorded')) {
        chips.push(`🏆 Победитель торгов уже зафиксирован`);
    }
    const reopenedCount = events.filter(e => e.event_type === 'auction_reopened').length;
    if (reopenedCount) {
        chips.push(`🔓 Лот снимался с публикации и возвращался в продажу ${reopenedCount}×`);
    }

    return chips;
}

async function loadLotHistory(lotId) {
    const container = document.getElementById('lotHistorySection');
    const list = document.getElementById('lotHistoryList');
    if (!container || !list) return;
    container.classList.add('hidden');

    try {
        const r = await fetch(`/api/lot/${lotId}/history`);
        if (!r.ok) return; // тихо — история не критична для основного экрана
        const events = await r.json();
        if (!events || !events.length) return;

        container.classList.remove('hidden');

        const summaryHtml = summarizeHistory(events).map(chip => `
            <div class="flex items-start gap-2 py-1.5 px-2 mb-1 rounded-lg bg-amber-500/10 border border-amber-500/20">
                <span class="text-xs text-amber-200 font-medium">${chip}</span>
            </div>
        `).join('');

        const rowsHtml = collapseHistoryEvents(events).map(item => `
            <div class="flex items-start gap-2 py-1.5 border-b border-white/5 last:border-0">
                <span class="text-[10px] text-[#94a3b8] whitespace-nowrap shrink-0">${formatDate(item.lastAt)}</span>
                <span class="text-xs text-gray-300">${item.desc}${item.count > 1
                    ? ` <span class="text-[#94a3b8]">(повторилось ${item.count}× за ${formatDate(item.firstAt)} — ${formatDate(item.lastAt)})</span>`
                    : ''}</span>
            </div>
        `).join('');

        list.innerHTML = summaryHtml + rowsHtml;
    } catch (e) {
        console.error('[loadLotHistory]', e); // не показываем ошибку пользователю — второстепенная секция
    }
}




// D2 (DESIGN_UPGRADE_PROMPT.md §5.4, Профиль): "«Мои отчёты» как реальный
// превью-список (последние 3), а не голая кнопка со счётчиком". Отдельный
// лёгкий рендер (не полная карточка renderAnalysesList() — та рассчитана на
// весь экран "Мои анализы", здесь только заголовок/дата/статус-точка в
// одну строку) на том же /api/analysis/history, что и там — второго
// эндпоинта не появилось. Обновляет и #analysesCount, как раньше делал
// renderAnalyses() — Профиль сам его больше не запрашивает отдельно.
async function loadProfileReportsPreview() {
    const el = document.getElementById('profileReportsPreview');
    const countEl = document.getElementById('analysesCount');
    if (!el || !userId) return;
    try {
        const r = await fetch(`/api/analysis/history?user_id=${userId}&t=${Date.now()}`);
        const history = await r.json();
        if (!Array.isArray(history)) throw new Error(history?.detail || 'Некорректный ответ истории анализов');
        if (countEl) countEl.innerText = IS_TELEGRAM ? `${history.length} шт` : `${history.length}`;
        if (!history.length) {
            el.innerHTML = IS_TELEGRAM
                ? '<p class="text-xs text-tertiary text-center py-3">Пока нет ни одного анализа</p>'
                : '<p class="text-caption text-tertiary">Пока нет ни одного анализа</p>';
            return;
        }
        // ИЗМЕНЕНО (TASK8 8.2, §7.5, E-03): было — компактная кнопка-строка с
        // СЫРЫМ заголовком (до 300 символов) и точкой-статусом; сайт получает
        // ТЕ ЖЕ строки renderLotRow(), что Избранное/База AI/Мои анализы (тот
        // же ctx-паттерн, что renderAnalyses() уже использует для полного
        // списка на этой же истории) — formatLotTitleSite() вместо сырого
        // title, 64px, thumb/price/verdict/date. Mini App — старый код без
        // единой правки (компактная точка-строка там уместна, не 64px таблица).
        if (IS_TELEGRAM) {
            el.innerHTML = history.slice(0, 3).map(item => {
                const isCompleted = item.status === 'completed';
                const isVerdict = item.status === 'verdict_only';
                const dotClass = isCompleted ? 'bg-pos' : (isVerdict ? 'bg-warn' : 'bg-tertiary');
                const title = escapeHtml(item.title || item.lot_title || 'Лот');
                return `<button onclick="${(isCompleted || isVerdict) ? `openHistoryAnalysis('${item.lot_id}')` : ''}" class="w-full flex items-center gap-2.5 px-3 py-2.5 bg-white/5 hover:bg-white/10 rounded-lg border border-white/5 text-left transition-colors">
                    <span class="w-1.5 h-1.5 rounded-full ${dotClass} shrink-0"></span>
                    <span class="flex-1 min-w-0 text-xs text-white truncate">${title}</span>
                    <span class="text-[10px] text-tertiary font-mono-nums shrink-0">${fmtDate(item.created_at)}</span>
                </button>`;
            }).join('');
        } else {
            el.innerHTML = '';
            const frag = document.createDocumentFragment();
            history.slice(0, 3).forEach((item) => {
                const isCompleted = item.status === 'completed';
                const isVerdict = item.status === 'verdict_only';
                const row = renderLotRow(item, {
                    tag: 'div',
                    columns: ['thumb', 'title', 'price', 'verdict', 'date'],
                    getId: (x) => x.lot_id,
                    getPrice: (x) => x.price,
                    getDate: (x) => x.created_at,
                    href: (x) => `/workspace/lot/${x.lot_id}`,   // 2026-10-29: как в остальных списках — сначала лот
                    onClick: (x) => { window.location.href = `/workspace/lot/${x.lot_id}`; },
                });
                frag.appendChild(row);
            });
            el.appendChild(frag);
        }
    } catch (e) {
        el.innerHTML = IS_TELEGRAM
            ? '<p class="text-xs text-neg text-center py-3">Ошибка загрузки истории</p>'
            : '<p class="text-caption" style="color:var(--status-neg);">Ошибка загрузки истории</p>';
    }
}

async function renderAnalyses() {
    // 1. Ищем контейнер по новому ID из профиля
    const grid = document.getElementById('analysesListModal');
    if (!grid) return;
    
    // Запускаем ваш скелетон (если функция getSkeletonHTML существует)
    grid.innerHTML = typeof getSkeletonHTML === 'function' 
        ? getSkeletonHTML().repeat(3) 
        : '<div class="text-center py-6"><i class="ph-bold ph-spinner animate-spin text-3xl text-blue-500"></i></div>';

    try {
        const r = await fetch(`/api/analysis/history?user_id=${userId}&t=${Date.now()}`);
        const history = await r.json();
        // API может вернуть не массив, а объект с ошибкой (напр. {"detail": "..."}
        // при невалидном/пустом user_id) — тогда .length будет undefined, и счётчик
        // раньше буквально показывал текст "undefined шт" вместо адекватного состояния.
        if (!Array.isArray(history)) throw new Error(history?.detail || 'Некорректный ответ истории анализов');
        lastAnalysesHistory = history; // 🔥 Сохраняем — toggleCompareSelect() перерисовывает список без повторного fetch

        // 2. Обновляем счетчик в профиле
        const countEl = document.getElementById('analysesCount');
        if (countEl) countEl.innerText = `${history.length} шт`;

        // D2: через тулбар, а не renderAnalysesList(history) напрямую — экран
        // остаётся в DOM между переходами (SPA), и если поиск/фильтр уже были
        // заполнены с прошлого раза, свежая загрузка не должна тихо показать
        // несогласованный с ними полный список.
        applyAnalysesToolbar();
    } catch (e) {
        grid.innerHTML = '<div class="text-center py-4 text-xs text-red-500 bg-red-500/10 rounded-xl border border-red-500/20">Ошибка загрузки истории</div>';
    }
}

// 2026-10-29 (владелец: «блоками, как на Главной, но по своим канонам»): карточка Моих анализов — блок Главной из
// записи истории (/api/analysis/history: lot_id/price/region вместо id/start_price/location). Свои действия по статусу
// анализа: готов — PDF и «Отчёт», только вердикт — «Полный отчёт», идёт — индикатор; под ценой — дата моего анализа.
// В режиме «Сравнить» клик по карточке выбирает её (только готовые анализы), а не открывает лот.
function buildAnalysisSiteCard(item) {
    const lot = { ...item, id: item.lot_id, start_price: item.price, location: item.region,
        attributes: item.deal_type ? { deal_type: item.deal_type, lease_term_months: item.lease_term_months } : {} };
    const isCompleted = item.status === 'completed';
    const isVerdict = item.status === 'verdict_only';
    const isSelectable = compareMode && isCompleted;
    const isSelected = compareMode && compareSelection.includes(item.lot_id);
    const id = escapeHtml(String(item.lot_id));
    let actionsHtml;
    if (compareMode) {
        actionsHtml = isSelectable
            ? `<span class="lot-card-site-pick${isSelected ? ' is-on' : ''}"><i class="ph-${isSelected ? 'fill ph-check-circle' : 'bold ph-circle'}"></i>${isSelected ? 'Выбран' : 'Выбрать'}</span>`
            : '<span class="lot-card-site-pick is-off">Нет отчёта</span>';
    } else if (isCompleted) {
        actionsHtml = `${item.pdf_url ? `<button type="button" onclick="event.preventDefault(); event.stopPropagation(); openPdf('${escapeHtml(item.pdf_url)}')" aria-label="Открыть PDF" title="PDF" class="list-icon-btn"><i class="ph-bold ph-file-pdf"></i></button>` : ''}${reportActionHtml(item.lot_id)}`;
    } else if (isVerdict) {
        actionsHtml = `<button type="button" onclick="event.preventDefault(); event.stopPropagation(); openHistoryAnalysis('${id}')" class="list-report-btn"><i class="ph-fill ph-lock-key-open"></i>Полный отчёт</button>`;
    } else {
        actionsHtml = '<span class="lot-card-site-pending"><span class="lot-card-site-spinner animate-spin"></span>Анализ идёт</span>';
    }
    return renderLotCardSite(lot, {
        actionsHtml,
        noteHtml: item.created_at ? `Мой анализ ${escapeHtml(fmtDate(item.created_at))}` : '',
        cardClass: isSelected ? 'is-selected' : (compareMode && !isSelectable ? 'is-unselectable' : ''),
        onCardClick: compareMode ? (e) => { e.preventDefault(); if (isSelectable) toggleCompareSelect(item.lot_id); } : null,
    });
}

// D2 (DESIGN_UPGRADE_PROMPT.md §5.5, "Мои анализы"): было — карточка с фото
// на всю ширину (заголовок/цена/бейдж статуса/крупная кнопка-действие) на
// каждый анализ, десятки экранов прокрутки на реальной истории. Теперь —
// строка документа: точка-вердикт · заголовок · скор · дата · компактные
// иконки-действия, тот же "documents-library" вид, что и таблицы Главной/
// Избранного/Базы AI. recommendation_score/recommendation_status — новые
// поля в get_user_analysis_history() (postgres_client.py), раньше эта
// история их не выбирала вовсе.
//
// Вынесена из renderAnalyses(), чтобы переключение выбора в режиме
// сравнения (Фаза 4, premium) и локальные поиск/сортировка/фильтр по
// вердикту (см. applyAnalysesToolbar()) могли перерисовать список мгновенно,
// без повторного fetch к /api/analysis/history.
function renderAnalysesList(history) {
    const grid = document.getElementById('analysesListModal');
    if (!grid) return;
    grid.innerHTML = '';
    const cardsGrid = document.getElementById('analysesGrid');   // сайт ≥1024: блоки Главной (вид «Карточки»)
    const useCards = cardsGrid && !IS_TELEGRAM && isWideBrowser();
    if (cardsGrid) cardsGrid.innerHTML = '';

    // ДОБАВЛЕНО (TASK5 5.4, §5): «Мои анализы · N» в заголовке сайта — N от
    // ВСЕГО загруженного (lastAnalysesHistory), не от текущей
    // отфильтрованной выдачи, тот же принцип, что #favHeaderCount
    // (Избранное, 5.2: "заголовок отвечает на 'сколько у меня', не
    // 'сколько сейчас видно после фильтра'"). Mini App/модалка — узла с
    // этим id там нет, null-safe.
    const headerCount = document.getElementById('analysesHeaderCount');
    if (headerCount) headerCount.textContent = `Мои анализы · ${lastAnalysesHistory.length}`;
    const resultsCount = document.getElementById('analysesResultsCount');   // 2026-10-29 (вариант 3): строка результатов
    if (resultsCount) resultsCount.textContent = history.length === lastAnalysesHistory.length
        ? `${history.length} ${plural(history.length, 'анализ', 'анализа', 'анализов')}`
        : `Показано ${history.length} из ${lastAnalysesHistory.length}`;

    if (!history.length) {
        // D2: разные пустые состояния — "истории вообще нет" (что делать —
        // где запустить первый анализ) отличается от "ничего не нашлось по
        // текущему поиску/фильтру" (что делать — сбросить фильтр).
        const isFiltered = lastAnalysesHistory.length > 0;
        grid.innerHTML = isFiltered
            ? `<div class="text-center py-10 bg-white/5 rounded-2xl border border-white/5">
                <i class="ph-fill ph-magnifying-glass text-3xl text-gray-500 mb-2"></i>
                <p class="text-sm font-bold text-gray-400">Ничего не найдено</p>
                <p class="text-[11px] text-tertiary mt-1">Попробуйте изменить поиск или фильтр</p>
               </div>`
            : `<div class="text-center py-10 bg-white/5 rounded-2xl border border-white/5">
                <i class="ph-fill ph-file-dashed text-4xl text-gray-400 mb-2"></i>
                <p class="text-sm font-bold text-gray-400">Пока нет ни одного анализа</p>
                <p class="text-[11px] text-tertiary mt-1 max-w-xs mx-auto">Отчёт появляется здесь после запуска AI-анализа на карточке лота — на Главной, в Избранном или в Базе AI.</p>
               </div>`;
        if (useCards) cardsGrid.innerHTML = isFiltered
            ? emptyStateHtml('ph-magnifying-glass', 'Ничего не найдено', 'Попробуйте изменить поиск или фильтр.')
            : emptyStateHtml('ph-file-dashed', 'Пока нет ни одного анализа', 'Отчёт появляется здесь после запуска AI-анализа на карточке лота — на Главной, в Избранном или в Базе AI.');
        return;
    }
    if (useCards) {
        const cards = document.createDocumentFragment();
        history.forEach((item) => cards.appendChild(buildAnalysisSiteCard(item)));
        cardsGrid.appendChild(cards);
    }

    // ДОБАВЛЕНО (§5.1 DESIGN_MASTER_PROMPT.md, "один универсальный вид"): на
    // сайте (вне Telegram) строка Моих анализов теперь та же самая, что и в
    // Избранном/Базе AI — renderLotRow(l, ctx) с tag:'div' (эта вкладка и
    // раньше рисовала не <tr>, а flex-строку, здесь ничего структурно не
    // меняется). В Mini App (#analysesListModal — тот же id, что и в
    // #screen-analyses сайта, см. §4.7 в partials/modals/analyses.html) ниже
    // остаётся СТАРЫЙ код без единой правки — там разметка иная (точка-
    // индикатор вместо бейджа вердикта, компактная строка ~44px) и трогать
    // её вне скоупа этой задачи.
    if (!IS_TELEGRAM) {
        const frag = document.createDocumentFragment();
        history.forEach(item => {
            const isCompleted = item.status === 'completed';
            const isVerdict = item.status === 'verdict_only';
            const isClosed = item.is_active === false;
            const isSelectable = compareMode && isCompleted;
            const isSelected = compareMode && compareSelection.includes(item.lot_id);

            const row = renderLotRow(item, {
                tag: 'div',
                columns: ['thumb', 'title', 'price', 'score', 'verdict', 'date', 'actions'],
                getId: (x) => x.lot_id,
                getPrice: (x) => x.price,
                getDate: (x) => x.created_at,
                // 2026-10-29 (владелец): строка ведёт на страницу лота, как в остальных списках; отчёт — кнопкой «Отчёт»
                href: (x) => `/workspace/lot/${x.lot_id}`,
                titleMeta: () => isClosed ? '<span class="lot-row-meta">Торги завершены</span>' : '',
                rowClass: () => isSelected ? 'lot-row--selected' : (compareMode && !isSelectable ? 'lot-row--unselectable' : ''),
                renderActions: (x) => {
                    if (compareMode) {
                        return `<i class="ph-bold ${isSelected ? 'ph-check-circle text-purple-300' : 'ph-circle text-gray-500'} text-lg"></i>`;
                    }
                    if (isCompleted) {
                        return `${x.pdf_url ? `<button onclick="event.stopPropagation(); openPdf('${x.pdf_url}')" aria-label="Открыть PDF" class="btn-icon sm !w-8 !h-8 !bg-white/5"><i class="ph-bold ph-file-pdf"></i></button>` : ''}
                            ${reportActionHtml(x.lot_id)}`;
                    }
                    if (isVerdict) {
                        return `<button onclick="event.stopPropagation(); openHistoryAnalysis('${x.lot_id}')" aria-label="Докупить полный отчёт" title="Докупить полный отчёт" class="btn-icon sm !w-8 !h-8 !bg-warn/10 !text-warn"><i class="ph-fill ph-lock-key-open"></i></button>`;
                    }
                    return `<div class="w-3.5 h-3.5 border-2 border-white/30 border-t-white rounded-full animate-spin" title="Анализ выполняется"></div>`;
                },
                onClick: (x) => {
                    if (compareMode) {
                        if (isSelectable) toggleCompareSelect(x.lot_id);
                        return;
                    }
                    window.location.href = `/workspace/lot/${x.lot_id}`;
                },
            });
            frag.appendChild(row);
        });
        grid.appendChild(frag);
        return;
    }

    const frag = document.createDocumentFragment();
    history.forEach(item => {
        const row = document.createElement('div');

        const isCompleted = item.status === 'completed';
        const isVerdict = item.status === 'verdict_only';
        const isClosed = item.is_active === false;

        // Фаза 4: сравнение — выбирать можно только завершённые анализы
        const isSelectable = compareMode && isCompleted;
        const isSelected = compareMode && compareSelection.includes(item.lot_id);

        const score = typeof item.recommendation_score === 'number' ? item.recommendation_score : null;
        const hasScore = score != null && score > 0;
        const dotClass = !hasScore ? 'bg-white/20' : (score >= 70 ? 'bg-pos' : score >= 40 ? 'bg-warn' : 'bg-neg');
        const scoreClass = !hasScore ? 'text-tertiary' : (score >= 70 ? 'text-pos' : score >= 40 ? 'text-warn' : 'text-neg');
        const verdictTitle = !hasScore ? 'Ещё не оценено' : `Инвестскор ${fmtScore(score)}`;

        row.className = "analysis-row flex items-center gap-3 px-3 py-2.5 rounded-lg border transition-colors " +
            (isSelected ? "border-purple-500/60 bg-purple-900/10"
                : "border-white/5 bg-white/[0.02] hover:bg-white/5") +
            (compareMode && !isSelectable ? " opacity-40" : "");

        if (compareMode) {
            if (isSelectable) {
                row.onclick = () => toggleCompareSelect(item.lot_id);
                row.classList.add('cursor-pointer');
            }
        } else {
            row.onclick = () => openModal(item.lot_id);
            row.classList.add('cursor-pointer');
        }

        // Иконки-действия справа — свои для каждого статуса, скрыты в
        // режиме сравнения (там весь ряд — один переключатель выбора).
        let actionsHtml = '';
        if (compareMode) {
            actionsHtml = `<i class="ph-bold ${isSelected ? 'ph-check-circle text-purple-300' : 'ph-circle text-gray-500'} text-lg"></i>`;
        } else if (isCompleted) {
            actionsHtml = `
                ${item.pdf_url ? `<button onclick="event.stopPropagation(); openPdf('${item.pdf_url}')" aria-label="Открыть PDF" class="btn-icon sm !w-8 !h-8 !bg-white/5"><i class="ph-bold ph-file-pdf"></i></button>` : ''}
                <button onclick="event.stopPropagation(); openHistoryAnalysis('${item.lot_id}')" aria-label="Смотреть анализ" class="btn-icon sm !w-8 !h-8 !bg-accent/10 !text-accent"><i class="ph-fill ph-chart-line-up"></i></button>`;
        } else if (isVerdict) {
            actionsHtml = `<button onclick="event.stopPropagation(); openHistoryAnalysis('${item.lot_id}')" aria-label="Докупить полный отчёт" title="Докупить полный отчёт" class="btn-icon sm !w-8 !h-8 !bg-warn/10 !text-warn"><i class="ph-fill ph-lock-key-open"></i></button>`;
        } else {
            actionsHtml = `<div class="w-3.5 h-3.5 border-2 border-white/30 border-t-white rounded-full animate-spin" title="Анализ выполняется"></div>`;
        }

        // Миниатюра лота — была в старой карточке (64×64), в строке документа
        // достаточно узнаваемого превью 36×36, не крупной фотографии.
        const thumbHtml = item.image_url
            ? `<img src="${proxyImg(item.image_url, 80)}" alt="" onerror="this.onerror=null;this.src='${PLACEHOLDER_LOT}';" referrerpolicy="no-referrer" loading="lazy" class="w-9 h-9 rounded-md object-cover bg-white/5 border border-white/5 shrink-0">`
            : `<div class="w-9 h-9 rounded-md bg-white/5 border border-white/5 flex items-center justify-center shrink-0"><i class="ph-fill ph-image text-gray-500 text-sm"></i></div>`;

        row.innerHTML = `
            <span class="w-2 h-2 rounded-full ${dotClass} shrink-0" title="${escapeHtml(verdictTitle)}"></span>
            ${thumbHtml}
            <span class="flex-1 min-w-0">
                <span class="block text-sm text-white truncate">${escapeHtml(item.title || item.lot_title || ('Лот ' + item.lot_id))}</span>
                ${isClosed ? '<span class="text-[10px] text-tertiary">Торги завершены</span>' : ''}
            </span>
            <span class="text-xs font-mono-nums ${scoreClass} w-7 text-right shrink-0">${hasScore ? score : '—'}</span>
            <span class="text-[11px] text-tertiary font-mono-nums w-16 text-right shrink-0 hidden sm:block">${fmtDate(item.created_at)}</span>
            <span class="flex items-center gap-1.5 shrink-0">${actionsHtml}</span>
        `;
        frag.appendChild(row);
    });
    grid.appendChild(frag);
}

// D2 (DESIGN_UPGRADE_PROMPT.md §5.5): поиск/сортировка/фильтр по вердикту —
// целиком клиентские, над уже загруженным lastAnalysesHistory (та же
// единственная загрузка /api/analysis/history, что и раньше — новых
// запросов нет). Если тулбара в разметке нет (например, будущий контекст
// без него), просто перерисовывает полный список — вызывающий код
// (toggleCompareMode/toggleCompareSelect) не должен знать о существовании
// тулбара.
function applyAnalysesToolbar() {
    const searchEl = document.getElementById('analysesSearchInput');
    const sortEl = document.getElementById('analysesSortSelect');
    const verdictEl = document.getElementById('analysesVerdictFilter');
    if (!searchEl && !sortEl && !verdictEl) {
        renderAnalysesList(lastAnalysesHistory);
        return;
    }

    const q = (searchEl?.value || '').trim().toLowerCase();
    const sort = sortEl?.value || 'date_desc';
    const verdict = verdictEl?.value || 'all';

    let list = lastAnalysesHistory.slice();

    if (q) {
        list = list.filter(item => (item.title || item.lot_title || '').toLowerCase().includes(q));
    }

    if (verdict !== 'all') {
        list = list.filter(item => {
            const score = typeof item.recommendation_score === 'number' ? item.recommendation_score : null;
            if (score == null || score <= 0) return false;
            if (verdict === 'good') return score >= 70;
            if (verdict === 'mid') return score >= 40 && score < 70;
            return score < 40; // 'bad'
        });
    }

    list.sort((a, b) => {
        if (sort === 'date_asc') return new Date(a.created_at) - new Date(b.created_at);
        if (sort === 'date_desc') return new Date(b.created_at) - new Date(a.created_at);
        const sa = typeof a.recommendation_score === 'number' ? a.recommendation_score : -1;
        const sb = typeof b.recommendation_score === 'number' ? b.recommendation_score : -1;
        return sort === 'score_asc' ? sa - sb : sb - sa; // default score_desc
    });

    renderAnalysesList(list);
    updateAnalysesRailResetLabel(); // ДОБАВЛЕНО (TASK5 5.4) — на каждый реальный рендер, тот же приём, что updateFavRailResetLabel()/updateGRailResetLabel()
}

// ДОБАВЛЕНО (TASK5 5.4, §5): «Сбросить · N» в футере рейла сайта — тот же
// приём, что countActiveFavFilters()/countActiveGFilters(). Сортировка не
// считается фильтром (не сужает список, см. их же комментарий); поиск/
// вердикт — единственные два поля этого экрана.
function countActiveAnalysesFilters() {
    let n = 0;
    const searchEl = document.getElementById('analysesSearchInput');
    const verdictEl = document.getElementById('analysesVerdictFilter');
    if (searchEl && searchEl.value.trim()) n++;
    if (verdictEl && verdictEl.value !== 'all') n++;
    return n;
}

function updateAnalysesRailResetLabel() {
    const btn = document.getElementById('analysesRailResetBtn');
    if (!btn) return; // мобильный/узкий браузер — рейла нет вовсе
    const n = countActiveAnalysesFilters();
    if (n > 0) {
        btn.textContent = `Сбросить · ${n}`;
        btn.classList.remove('hidden');
    } else {
        btn.classList.add('hidden');
    }
}

// window.resetAnalysesFilters — сброс поиска/вердикта (канонические id +
// десктопные зеркала); сортировку не трогает, тот же принцип, что у
// resetFavFilters()/resetGFilters().
window.resetAnalysesFilters = () => {
    const searchEl = document.getElementById('analysesSearchInput');
    if (searchEl) searchEl.value = '';
    const searchDesktopEl = document.getElementById('analysesSearchInputDesktop');
    if (searchDesktopEl) searchDesktopEl.value = '';
    const verdictEl = document.getElementById('analysesVerdictFilter');
    if (verdictEl) verdictEl.value = 'all';
    const verdictDesktopEl = document.getElementById('analysesVerdictFilterDesktop');
    if (verdictDesktopEl) verdictDesktopEl.value = 'all';
    applyAnalysesToolbar();
};

// --- Фаза 4: режим сравнения лотов (premium) ---

window.toggleCompareMode = () => {
    if (!compareMode && !isPremiumUser()) {
        // TASK29: покупку предлагаем, только если Premium этому пользователю продаётся.
        if (premiumOnSale()) {
            tg.showAlert("Сравнение лотов доступно только на тарифе PREMIUM.");
            openSubscription();
        }
        return;
    }

    compareMode = !compareMode;
    compareSelection = [];

    const btn = document.getElementById('btnCompareToggle');
    if (btn) {
        btn.classList.toggle('bg-purple-600/30', compareMode);
        btn.classList.toggle('text-purple-300', compareMode);
    }
    // ДОБАВЛЕНО (TASK5 5.4, §5): «Сравнить»→«Отмена» на кнопке заголовка
    // сайта — тот же приём, что «Выбрать»→«Готово» у Избранного
    // (toggleFavSelectMode()); null-safe — у Mini App/модалки этой кнопки
    // с текстовым span нет вовсе (#btnCompareToggleLabel там не существует).
    const label = document.getElementById('btnCompareToggleLabel');
    if (label) label.textContent = compareMode ? 'Отмена' : 'Сравнить';

    // D2: через applyAnalysesToolbar(), а не renderAnalysesList()
    // напрямую — иначе включение режима сравнения сбрасывало активный
    // поиск/сортировку/фильтр по вердикту обратно к полному списку.
    // applyAnalysesToolbar() сама делает renderAnalysesList(lastAnalysesHistory),
    // если тулбара нет в разметке (модалка #modalAnalyses его не имеет).
    applyAnalysesToolbar();
    updateCompareBar();
    updateAnalysesHeaderBulkBar(); // ДОБАВЛЕНО (TASK5 5.4) — site-only bulk-бар в заголовке, см. её комментарий
};

window.toggleCompareSelect = (lotId) => {
    const idx = compareSelection.indexOf(lotId);
    if (idx !== -1) {
        compareSelection.splice(idx, 1);
    } else {
        if (compareSelection.length >= MAX_COMPARE_LOTS) {
            tg.showAlert(`Можно сравнить максимум ${MAX_COMPARE_LOTS} лота за раз.`);
            return;
        }
        compareSelection.push(lotId);
    }
    if (tg.HapticFeedback) tg.HapticFeedback.impactOccurred('light');
    // D2: через applyAnalysesToolbar(), а не renderAnalysesList()
    // напрямую — иначе включение режима сравнения сбрасывало активный
    // поиск/сортировку/фильтр по вердикту обратно к полному списку.
    // applyAnalysesToolbar() сама делает renderAnalysesList(lastAnalysesHistory),
    // если тулбара нет в разметке (модалка #modalAnalyses его не имеет).
    applyAnalysesToolbar();
    updateCompareBar();
    updateAnalysesHeaderBulkBar(); // ДОБАВЛЕНО (TASK5 5.4) — site-only bulk-бар в заголовке, см. её комментарий
};

// Mini App/модалка (modals/analyses.html, #compareBar — фиолетовый fixed-бар
// снизу) — НЕ ТРОГАТЬ (TASK5_LISTS_PROMPT.md §8). На сайте (analyses.html)
// этот узел удалён в 5.4 (B-10) — getElementById здесь просто находит null.
function updateCompareBar() {
    const bar = document.getElementById('compareBar');
    if (!bar) return;
    const canCompare = compareMode && compareSelection.length >= 2;
    bar.classList.toggle('hidden', !canCompare);
    const countEl = document.getElementById('compareBarCount');
    if (countEl) countEl.innerText = `Сравнить (${compareSelection.length})`;
}

// ДОБАВЛЕНО (TASK5 5.4, §5, B-10): сайтовая замена #compareBar — bulk-бар
// «N выбрано · Сравнить (≥2) · Отмена» в самом заголовке экрана
// (#analysesHeaderBulkBar), тот же приём, что #favHeaderBulkBar у
// Избранного. Видим ТОЛЬКО когда есть хотя бы один выбранный лот (в
// отличие от старого #compareBar, который появлялся лишь при ≥2 — кнопка
// «Сравнить» внутри теперь просто disabled до ≥2, счётчик "N выбрано"
// виден сразу после первого клика — так пользователь видит, что режим
// реально что-то выбирает). null-safe — у Mini App/модалки этих узлов нет.
function updateAnalysesHeaderBulkBar() {
    const bar = document.getElementById('analysesHeaderBulkBar');
    if (!bar) return;
    const def = document.getElementById('analysesHeaderDefault');
    const hasSelection = compareMode && compareSelection.length > 0;
    bar.classList.toggle('hidden', !hasSelection);
    bar.classList.toggle('flex', hasSelection);
    if (def) def.classList.toggle('hidden', hasSelection);
    const countEl = document.getElementById('analysesHeaderBulkCount');
    if (countEl) countEl.textContent = String(compareSelection.length);
    const compareBtn = document.getElementById('analysesCompareBtn');
    if (compareBtn) compareBtn.disabled = compareSelection.length < 2;
}

window.openCompareModal = async () => {
    if (compareSelection.length < 2) return;

    if (!isPremiumUser()) {
        // На случай рассинхрона состояния (план мог протухнуть между открытием
        // режима сравнения и нажатием кнопки) — перепроверяем перед запросом.
        if (premiumOnSale()) {
            tg.showAlert("Сравнение лотов доступно только на тарифе PREMIUM.");
            openSubscription();
        }
        return;
    }

    if (tg.HapticFeedback) tg.HapticFeedback.impactOccurred('medium');

    const modal = document.getElementById('compareModal');
    const content = document.getElementById('compareContent');
    if (!modal || !content) return;

    content.innerHTML = '<div class="text-center py-10"><i class="ph-bold ph-spinner animate-spin text-3xl text-purple-400"></i></div>';
    modal.classList.remove('hidden');
    setTimeout(() => modal.classList.remove('translate-y-full'), 10);

    try {
        const r = await fetch(`/api/analysis/compare?user_id=${userId}&lot_ids=${compareSelection.join(',')}`);
        const d = await r.json();

        if (!r.ok) {
            content.innerHTML = `<div class="text-center py-10 text-sm text-red-400">${d.detail || 'Не удалось загрузить сравнение'}</div>`;
            return;
        }

        if (!d.lots || d.lots.length < 2) {
            content.innerHTML = '<div class="text-center py-10 text-sm text-gray-400">Недостаточно данных для сравнения — попробуйте выбрать другие лоты.</div>';
            return;
        }

        renderCompareContent(d.lots);
    } catch (e) {
        console.error('[openCompareModal]', e);
        content.innerHTML = '<div class="text-center py-10 text-sm text-red-400">Ошибка сети при загрузке сравнения</div>';
    }
};

window.closeCompareModal = () => {
    const modal = document.getElementById('compareModal');
    if (!modal) return;
    modal.classList.add('translate-y-full');
    setTimeout(() => modal.classList.add('hidden'), 300);
};

// D7 (DESIGN_UPGRADE_PROMPT.md §6, "апгрейд сравнения"): было горизонтальной
// каруселью карточек — те же цифры дублировались в каждой карточке, глазами
// сравнивать 3 колонки чисел неудобно (нужно листать туда-обратно). Теперь —
// настоящая таблица "метрика × лот" с подсветкой лучшего/худшего значения в
// строке (compareRowDiffClass() ниже), как и просит бриф. compareLotsCache —
// нужен exportCompareToPdf() ниже (те же данные, без повторного fetch).
let compareLotsCache = [];

// Подсветка строки: 'higher' — больше значит лучше (скор/ROI/прибыль),
// 'lower' — меньше значит лучше (цена входа, число критичных рисков).
// Ничего не подсвечивает, если значений меньше двух РАЗЛИЧНЫХ чисел —
// сравнивать нечего, а красить все ячейки одним цветом ввело бы в заблуждение.
function compareRowDiffClass(values, direction) {
    const nums = values.filter(v => typeof v === 'number' && !isNaN(v));
    const distinct = new Set(nums);
    if (distinct.size < 2) return values.map(() => '');
    const best = direction === 'higher' ? Math.max(...nums) : Math.min(...nums);
    const worst = direction === 'higher' ? Math.min(...nums) : Math.max(...nums);
    return values.map(v => {
        if (typeof v !== 'number' || isNaN(v)) return '';
        if (v === best) return 'compare-best';
        if (v === worst) return 'compare-worst';
        return '';
    });
}

function compareBuildRows(lots) {
    const verdictText = { 'recommended': 'Рекомендуется', 'conditionally_recommended': 'Условно', 'not_recommended': 'Не рекомендуется' };
    // Свои классы, не text-pos/warn/neg (Tailwind-утилиты) — .compare-td
    // ниже уже задаёт свой color с той же специфичностью (один класс), и
    // побеждал бы по порядку в каскаде (style.css подключён ПОСЛЕ
    // tailwind.build.css, см. base.html) независимо от того, какой класс
    // стоит в разметке раньше. compare-verdict-* объявлены В ТОМ ЖЕ файле
    // сразу после .compare-td — порядок гарантированно в нашу пользу.
    const verdictClass = { 'recommended': 'compare-verdict-pos', 'conditionally_recommended': 'compare-verdict-warn', 'not_recommended': 'compare-verdict-neg' };
    const fmt = (num) => num != null ? formatMoney(num) : '—';

    const scores = lots.map(l => (l.report || {}).investment_score ?? null);
    const prices = lots.map(l => l.price ?? null);
    const rois = lots.map(l => (l.report || {}).financials?.roi_percent ?? null);
    const profits = lots.map(l => (l.report || {}).financials?.projected_profit ?? null);
    const risks = lots.map(l => {
        const list = (l.report || {}).risks || [];
        return list.filter(r => r.severity === 'Critical' || r.severity === 'High').length;
    });

    const scoreDiff = compareRowDiffClass(scores, 'higher');
    const priceDiff = compareRowDiffClass(prices, 'lower');
    const roiDiff = compareRowDiffClass(rois, 'higher');
    const profitDiff = compareRowDiffClass(profits, 'higher');
    const riskDiff = compareRowDiffClass(risks, 'lower');

    return { verdictText, verdictClass, fmt, scores, prices, rois, profits, risks, scoreDiff, priceDiff, roiDiff, profitDiff, riskDiff };
}

function renderCompareContent(lots) {
    const content = document.getElementById('compareContent');
    if (!content) return;
    compareLotsCache = lots;

    const b = compareBuildRows(lots);
    const cell = (val, cls) => `<td class="compare-td ${cls || ''}">${val}</td>`;

    const headerCells = lots.map(lot => `
        <th class="compare-th">
            <div class="compare-th-photo">${lot.image_url ? `<img src="${proxyImg(lot.image_url, 160)}" alt="${escapeHtml(lot.title || 'Лот')}" onerror="this.onerror=null;this.src='${PLACEHOLDER_LOT}';">` : `<i class="ph-fill ph-image"></i>`}</div>
            <div class="compare-th-title">${escapeHtml(lot.title || ('Лот ' + lot.lot_id))}</div>
        </th>`).join('');

    const rows = [
        { label: 'Цена входа', cells: b.prices.map((v, i) => cell(b.fmt(v), b.priceDiff[i])) },
        { label: 'Скор', cells: b.scores.map((v, i) => cell(v != null ? v : '—', b.scoreDiff[i])) },
        { label: 'Вердикт', cells: lots.map(l => `<td class="compare-td ${b.verdictClass[(l.report || {}).verdict_badge] || ''}">${b.verdictText[(l.report || {}).verdict_badge] || '—'}</td>`).join('') },
        { label: 'ROI', cells: b.rois.map((v, i) => cell(v != null ? v + '%' : '—', b.roiDiff[i])) },
        { label: 'Прогноз прибыли', cells: b.profits.map((v, i) => cell(b.fmt(v), b.profitDiff[i])) },
        { label: 'Ликвидность', cells: lots.map(l => cell((l.report || {}).financials?.liquidity_rating || '—')) },
        { label: 'Точность', cells: lots.map(l => cell((l.report || {}).confidence_level || '—')) },
        { label: 'Критичные риски', cells: b.risks.map((v, i) => cell(v, b.riskDiff[i])) },
    ];

    const bodyRows = rows.map(row => `
        <tr>
            <td class="compare-row-label">${row.label}</td>
            ${Array.isArray(row.cells) ? row.cells.join('') : row.cells}
        </tr>`).join('');

    const actionsRow = `
        <tr>
            <td class="compare-row-label"></td>
            ${lots.map(l => `<td class="compare-td"><button onclick="closeCompareModal(); openHistoryAnalysis('${l.lot_id}')" class="compare-open-btn"><i class="ph-bold ph-arrow-square-out"></i> Полный анализ</button></td>`).join('')}
        </tr>`;

    content.innerHTML = `
        <div class="overflow-x-auto -mx-4 px-4">
            <table class="compare-table">
                <thead><tr><th class="compare-th"></th>${headerCells}</tr></thead>
                <tbody>${bodyRows}${actionsRow}</tbody>
            </table>
        </div>`;
}

// D7: "экспорт в PDF через существующий конвейер отчётов" — сравнение нигде
// не хранится на бэкенде (это временный клиентский выбор из compareSelection),
// экспортировать с сервера нечего. Тот же приём, что и у report_template.html:
// отдельный документ + window.print() — просто собранный на лету из уже
// загруженных данных (compareLotsCache), без нового эндпоинта. Светлая печать
// — тот же язык, что и у D10 (report_template.html), не тёмная тема 1:1.
window.exportCompareToPdf = function () {
    if (!compareLotsCache.length) return;
    const win = window.open('', '_blank');
    if (!win) {
        tg.showAlert('Разрешите всплывающие окна в браузере, чтобы скачать сравнение в PDF.');
        return;
    }
    const b = compareBuildRows(compareLotsCache);
    const cellHtml = (val, cls) => `<td class="${cls || ''}">${val}</td>`;
    const headerCells = compareLotsCache.map(l => `<th>${escapeHtml(l.title || ('Лот ' + l.lot_id))}</th>`).join('');
    const rows = [
        ['Цена входа', b.prices.map((v, i) => cellHtml(b.fmt(v), b.priceDiff[i]))],
        ['Скор', b.scores.map((v, i) => cellHtml(v != null ? v : '—', b.scoreDiff[i]))],
        ['Вердикт', compareLotsCache.map(l => `<td>${b.verdictText[(l.report || {}).verdict_badge] || '—'}</td>`)],
        ['ROI', b.rois.map((v, i) => cellHtml(v != null ? v + '%' : '—', b.roiDiff[i]))],
        ['Прогноз прибыли', b.profits.map((v, i) => cellHtml(b.fmt(v), b.profitDiff[i]))],
        ['Ликвидность', compareLotsCache.map(l => cellHtml((l.report || {}).financials?.liquidity_rating || '—'))],
        ['Точность', compareLotsCache.map(l => cellHtml((l.report || {}).confidence_level || '—'))],
        ['Критичные риски', b.risks.map((v, i) => cellHtml(v, b.riskDiff[i]))],
    ].map(([label, cells]) => `<tr><td class="rowlabel">${label}</td>${cells.join('')}</tr>`).join('');

    win.document.write(`<!doctype html><html lang="ru"><head><meta charset="utf-8"><title>Сравнение лотов — Auction Detective</title>
        <style>
            body { font-family: Manrope, sans-serif; background: #fff; color: #111827; padding: 24px; }
            h1 { font-size: 16px; margin: 0 0 16px; }
            table { border-collapse: collapse; width: 100%; }
            th, td { border: 1px solid #E1E4E9; padding: 8px 10px; text-align: left; font-size: 12px; }
            th { background: #F7F8FA; font-weight: 700; }
            td.rowlabel { font-weight: 700; color: #4B5563; white-space: nowrap; }
            .compare-best { color: #15803D; font-weight: 700; }
            .compare-worst { color: #B91C1C; }
        </style>
    </head><body>
        <h1>Сравнение лотов — Auction Detective</h1>
        <table><thead><tr><th></th>${headerCells}</tr></thead><tbody>${rows}</tbody></table>
    </body></html>`);
    win.document.close();
    win.focus();
    setTimeout(() => win.print(), 300);
};

async function openHistoryAnalysis(lotId) {
    try {
        tg.HapticFeedback.impactOccurred('light');
        
        const res = await fetch(`/api/lot/${lotId}?user_id=${userId}`);
        const lot = await res.json();
        
        const statusRes = await fetch(`/api/analysis/status?user_id=${userId}&lot_id=${lotId}&t=${Date.now()}`);
        const statusData = await statusRes.json();
        
        if (!lot) {
            tg.showAlert('Не удалось загрузить данные лота');
            return;
        }

        // §5.4 DESIGN_MASTER_PROMPT.md: на сайте — настоящая навигация,
        // без промежуточного fetch+рендер в контейнеры текущей страницы,
        // которые всё равно сейчас выгрузятся. Проверять fetch'ем выше уже
        // пришлось (нужен statusData.status), но сам рендер/openAnalysisModal()
        // на сайте — лишняя работа перед уходом со страницы.
        if (!IS_TELEGRAM && statusData && statusData.status === 'completed' && statusData.raw_report) {
            window.location.href = `/workspace/analysis/${lotId}`;
            return;
        }
        if (!IS_TELEGRAM && statusData && statusData.status === 'verdict_only') {
            window.location.href = `/workspace/lot/${lotId}`;
            return;
        }

        // 🔥 ИСПРАВЛЕНИЕ: Разделяем поведение для completed и verdict_only
        if (statusData && statusData.status === 'completed' && statusData.raw_report) {
            let reportObj = statusData.raw_report;
            if (typeof reportObj === 'string') reportObj = JSON.parse(reportObj);

            state.currentLot = lot;
            currentAiReport = reportObj;

            if (typeof closeAnalysesHistory === 'function') closeAnalysesHistory();
            openAnalysisModal();      // рендерит отчёт сам (renderClassicReport)
        }
        else if (statusData && statusData.status === 'verdict_only') {
            // Если куплен только вердикт, открываем карточку лота, чтобы предложить апгрейд
            if (typeof closeAnalysesHistory === 'function') closeAnalysesHistory();
            openModal(lotId);
        }
        else if (statusData && statusData.pdf_url) {
            if (typeof closeAnalysesHistory === 'function') closeAnalysesHistory();
            openPdf(statusData.pdf_url); 
        } 
        else {
            tg.showAlert('Отчет не найден или еще не сформирован');
        }
    } catch (e) {
        console.error("Ошибка открытия анализа:", e);
        tg.showAlert('Ошибка при загрузке отчета');
    }
}

// --- RENDERING ---
function createCard(l, a=false, d=null) {
    const e = document.createElement('div');
    // 🔥 НАЙДЕННЫЙ БАГ (карточки залипают полупрозрачными/съезжают, "во всех
    // вкладках приходится скроллить"): раньше здесь висел класс "fade-in" —
    // старая, ещё до-GSAP'овская CSS @keyframes-анимация (0.3s, opacity/translateY,
    // см. style.css). После Phase 3 те же карточки СВЕРХУ ещё раз анимирует
    // revealNewCards() через GSAP (0.35s+stagger, тоже opacity/transform).
    // Два независимых механизма одновременно дерутся за одни и те же CSS-
    // свойства одного элемента: CSS-анимация по спецификации всегда перебивает
    // инлайн-стили, которые в это же время пишет GSAP, а как только (более
    // короткая) CSS-анимация заканчивается — без fill-mode:forwards свойство
    // "отпускается" ровно на том значении, на котором в этот момент застал его
    // GSAP-твин, и из-за stagger-задержки для разных карточек это застревание
    // происходит на РАЗНЫХ степенях готовности — отсюда и хаотичная картина:
    // одни карточки в норме, другие видимо "просели"/остались полупрозрачными.
    // Карточки, которые проходят через revealNewCards(), больше не должны
    // получать "fade-in" — GSAP теперь единственный владелец их анимации
    // появления (класс "fade-in" остаётся в style.css и продолжает работать
    // для другой, не-GSAP'нутой разметки — блоки рисков/сценариев и т.п.).
    e.className = "glass-card p-3 rounded-2xl flex items-start gap-3 active:scale-[0.98] transition-transform cursor-pointer group bg-[#1e293b]/50 relative overflow-hidden";
    // Доступность с клавиатуры: карточка — это div с onclick, без role/tabindex
    // она невидима для клавиатурной навигации и скринридеров (ПК-пользователи).
    e.setAttribute('role', 'button');
    e.tabIndex = 0;
    e.addEventListener('keydown', (ev) => {
        if (ev.key === 'Enter' || ev.key === ' ') {
            ev.preventDefault();
            e.onclick && e.onclick(ev);
        }
    });

    if(a) {
        // Analysis Card
        const s = d.status;
        const r = s === 'completed';
        const dt = new Date(d.created_at).toLocaleDateString();
        const i = r ? '📄' : '⏳';
        const c = r ? 'bg-blue-600' : 'bg-white/10';
        
        e.onclick = r ? () => openPdf(d.pdf_url) : null;
        e.innerHTML = `
            <div class="w-16 h-16 rounded-xl bg-white/5 flex items-center justify-center flex-shrink-0 text-2xl border border-white/5">${i}</div>
            <div class="flex-1 min-w-0">
                <h3 class="text-white font-bold text-sm truncate">${d.lot_title||'Лот'}</h3>
                <p class="text-gray-400 text-xs mt-1">${dt} • ${r?'Готово':'В работе'}</p>
            </div>
            <button class="w-10 h-10 rounded-full ${c} flex items-center justify-center flex-shrink-0">
                ${r ? '<i class="ph-bold ph-caret-right text-white"></i>' : ''}
            </button>`;
    } else {
        // Lot Card
        // Phase 3: доп. класс lot-card только для карточек лотов (не для
        // карточек анализа выше) — под него в style.css отдельный, более
        // выраженный hover-подъём, ограниченный @media(hover:hover).
        e.classList.add('lot-card');
        const p = fmtPriceCompact(l.start_price);
        const i = proxyImg(l.image_url, 480) || PLACEHOLDER_LOT;
        const isE = l.url.includes('adilet');
        const rc = getRecBadgeData(l.recommendation_status || 'requires_analysis', l.recommendation_score);
        // Фаза 16 (30.08.2026, "старые лоты копятся в избранном/анализах"):
        // is_active лежит в этой же строке лота (SELECT * FROM lots), просто
        // раньше карточка его никак не показывала — ни в избранном, ни в
        // истории анализов не было видно, что торги вообще завершились.
        const isClosed = l.is_active === false;
        // 🔥 ДОБАВЛЕНО (аудит "карточка не даёт принять решение", 05.09.2026),
        // D1: чип срочности — см. renderDeadlineChipHtml()/deadlineChip() выше.
        // Для завершённых лотов вместо него показываем "Торги завершены" В ТОЙ
        // ЖЕ строке — не убираем строку целиком, иначе у закрытых и открытых
        // лотов в одном ряду сетки разная высота карточки (title у всех уже
        // зарезервирован фиксированной min-h ниже, эта строка — второй
        // источник разъезда, если сделать её условной по наличию).
        const dl = deadlineChip(l.application_deadline);
        const deadlineRow = isClosed
            ? `<div class="flex items-center gap-1 text-[10px] text-tertiary"><i class="ph-fill ph-lock-simple"></i><span>Торги завершены</span></div>`
            : dl
                ? `<div class="text-[10px]">${renderDeadlineChipHtml(l.application_deadline)}</div>`
                : `<div class="flex items-center gap-1 text-[10px] text-transparent select-none" aria-hidden="true"><i class="ph-fill ph-hourglass"></i><span>—</span></div>`;

        e.innerHTML = `
            <div class="w-24 h-24 min-w-[6rem] rounded-xl overflow-hidden flex-shrink-0 relative border border-white/5 bg-white/5 lot-card-thumb">
                <img src="${i}" alt="${escapeHtml(formatLotTitle(l).primary)}" onerror="this.onerror=null;this.src='${PLACEHOLDER_LOT}';" referrerpolicy="no-referrer" class="w-full h-full object-cover transition-opacity duration-300 opacity-90 group-hover:opacity-100 ${isClosed ? 'grayscale' : ''}" loading="lazy">
                <div class="absolute bottom-1 left-1 px-1.5 py-0.5 rounded text-[8px] uppercase badge-solid ${isE?'bg-etp':'bg-sauda'}">${isE?'ETP':'SAUDA'}</div>
                ${isClosed ? '<div class="absolute inset-0 flex items-center justify-center bg-black/50"><span class="px-1.5 py-0.5 rounded text-[8px] uppercase font-bold text-gray-200 bg-black/60 border border-white/20">Завершено</span></div>' : ''}
            </div>
            <div class="flex-1 min-w-0 flex flex-col gap-1 py-0.5 lot-card-body ${isClosed ? 'opacity-70' : ''}">
                <h3 class="text-white font-bold text-xs leading-snug ${lotHasMapPoint(l) ? 'pr-8' : 'pr-4'} line-clamp-2 min-h-[2.2rem]">${escapeHtml(formatLotTitle(l).primary)}</h3>
                ${lotHasMapPoint(l) ? `<button type="button" class="lot-card-mapbtn" aria-label="Посмотреть на карте" onclick="openLotOnMap('${escapeHtml(String(l.id))}', event)"><i class="ph-bold ph-map-pin"></i></button>` : ''}
                <div class="flex items-center gap-1 text-gray-400 text-[10px]">
                    <i class="ph-fill ph-map-pin"></i>
                    ${
                        // distance_km приходит от бэкенда только в режиме "Рядом со
                        // мной" (near_lat/near_lon в запросе, см. get_filtered_lots) —
                        // в этом случае показываем расстояние вместо города, это и
                        // есть та информация, ради которой пользователь включил
                        // сортировку "Рядом".
                        typeof l.distance_km === 'number'
                            ? `<span class="truncate max-w-[80px] text-amber-400 font-bold">${l.distance_km < 1 ? Math.round(l.distance_km * 1000) + ' м' : l.distance_km.toFixed(1) + ' км'}</span>`
                            : `<span class="truncate max-w-[80px]">${l.location?.split(',')[0]||'KZ'}</span>`
                    }
                </div>
                ${deadlineRow}
                <div class="flex flex-col gap-0.5 mt-auto">
                    <span class="lot-card-price text-[#E8B84B] text-base font-mono font-bold">${p} ₸</span>
                    <span class="badge-rec ${rc.class} self-start max-w-full px-1.5 py-0.5 rounded text-[10px] font-bold inline-flex items-center gap-1">
                        <i class="ph-fill ${rc.icon} shrink-0"></i><span class="truncate">${rc.text}</span>
                    </span>
                </div>
            </div>`;
        const thumbImg = e.querySelector('img');
        // §5.2/§5.4: на сайте — настоящая навигация на /workspace/lot/{id}
        // (полная перезагрузка, никаких оверлеев); в Mini App — как и
        // раньше, модалка #detailModal.
        e.onclick = () => {
            if (!IS_TELEGRAM) { window.location.href = `/workspace/lot/${l.id}`; return; }
            openModal(l.id, thumbImg);
        };
    }
    return e;
}

// ДОБАВЛЕНО (TASK4 4.6, DESIGN_MASTER_PROMPT.md §7.6, TASK4_HOME_PROMPT.md
// §4): карточка лота для сетки Главной на широком сайте. createCard() выше
// НЕ меняется ни строкой — общая с Mini App/мобильным сайтом (§12).
// Ветвление на месте вызова (loadLots()/loadRecommendations()):
// !IS_TELEGRAM && isWideBrowser() → эта функция, иначе createCard().
// Внешний тег — <a href>, не div+onclick: настоящая навигация (Ctrl/⌘-клик
// открывает в новой вкладке, Tab работает без JS, краулеры видят href).
// Класс контейнера — "lot-card-site", НЕ "lot-card": в style.css у
// .lot-card уже есть мобильный @media(hover:hover) hover-подъём
// (translateY + тень) — конституция явно запрещает подъём/тень на сайте
// (§7.6, "no CTA" / hover — только фон+бордер). Общее имя класса делило бы
// один селектор между структурно разными деревьями (div vs a, разные
// внутренние классы) и означало бы либо переопределять чужой hover
// каждый раз через html.is-browser, либо рисковать, что забудут. Отдельное
// имя — ноль риска для мобильной/Mini App карточки, нуль общих строк CSS.
// ДОБАВЛЕНО (TASK4 4.6b — дефект найден ревьюером на живых данных
// 14.09.2026): «обремен» где угодно в description — слишком широкий тест.
// Замер на первых 200 /api/lots: у ETP «Имеются обременения» встречается в
// 53/53 лотов дословно — это шаблонная фраза площадки (форма подачи у
// госимущества всегда несёт это поле), не признак конкретного лота; у
// Sauda «обремен» часто стоит в ОТРИЦАНИИ («Обременения: нет», «без
// обременений», «обременения – нет», пустое «Обременения: ;» после
// лейбла) — прежний regex читал это как "есть обременение", что прямо
// противоположно факту. Показываем флаг только на том, что осталось после
// вычитания шаблонной фразы и отрицаний — редкое, содержательное упоминание
// (напр. «…имеются обременения от ЧСИ» — уже не голый шаблон, конкретика).
function hasExplicitEncumbrance(description) {
    const d = (description || '').trim();
    if (!d) return false;
    if (!/обремен/i.test(d)) return false;
    // Шаблонная фраза площадки стоит СВОЕЙ строкой (реальный паттерн ETP:
    // "…\nКоличество: 1.0 ШТ\nИмеются обременения" — проверено на 53/53
    // ETP-лотов) — вычитаем только такие строки целиком, а не саму
    // подстроку где угодно: "…(имеются обременения от ЧСИ)…" — это уже
    // конкретика ВНУТРИ предложения, не шаблон, резать её было бы неверно
    // (первая версия фикса именно так и ломалась — вырезала слово
    // "обременения" из содержательного предложения вместе с шаблоном).
    const remaining = d.split('\n')
        .map((line) => line.trim())
        .filter((line) => !/^имеются обременения[.,;]?$/i.test(line))
        .join(' ');
    if (!/обремен/i.test(remaining)) return false;
    // Отрицания: "без обременений", "обременения: нет/Нет", "обременения –
    // нет", "не имеется обременений", "обременения отсутствуют".
    if (/без\s+обременени|обременени[а-яё]*\s*[:\-–—]?\s*(нет|отсутств)|не\s+имеется\s+обременени/i.test(remaining)) return false;
    // Пустое значение сразу после лейбла ("Обременения: ;" / "Обременения:.").
    if (/обременени[а-яё]*\s*[:\-–—]?\s*[;.,]/i.test(remaining)) return false;
    return true;
}

// 2026-10-28: «посмотреть на карте» — только у недвижимости с собственной точкой (lots.lat/lon = кадастр/jerler)
function lotHasMapPoint(l) {
    return l && l.lat != null && l.lon != null && l.category !== 'авто';
}

// 2026-10-29 (владелец: «списки — блоками, как на Главной, но по своим канонам»): та же карточка в Избранном, Базе AI и
// Моих анализах. opts.actionsHtml — действия вкладки вместо «Анализ →» (видны всегда, не по наведению), opts.noteHtml —
// строка о самом анализе под ценой, opts.onCardClick — свой клик по карточке (выбор для сравнения), opts.cardClass.
function renderLotCardSite(l, opts = {}) {
    const el = document.createElement('a');
    el.href = `/workspace/lot/${l.id}`;
    el.className = 'lot-card-site' + (opts.actionsHtml != null ? ' lot-card-site--list' : '') + (opts.cardClass ? ' ' + opts.cardClass : '');
    el.setAttribute('data-lot-id', l.id);

    const isE = (l.url || '').includes('adilet');
    const photo = proxyImg(l.image_url, 480);
    const img = photo || getPlaceholderFor(l.category);
    const fallbackImg = getPlaceholderFor(l.category);
    const titleInfo = formatLotTitleSite(l);
    const title = escapeHtml(titleInfo.primary);
    const titleFull = escapeHtml(titleInfo.secondary);
    // Владелец, 2026-10-29 (вариант 3): у большинства лотов ETP нет фото — вместо пустой серой иконки на месте фото
    // крупно главный факт лота (марка / площадь), над ним вид объекта. Показывается и когда фото есть, но не загрузилось
    // (onerror ниже ставит тот же класс).
    const factKind = { 'авто': 'Транспорт', 'квартиры': 'Квартира', 'дома': 'Дом', 'участки': 'Земельный участок', 'коммерция': 'Коммерция', 'паркинг': 'Паркинг' }[l.category] || 'Лот';
    // площадь самого объекта («104.3 кв.м») идёт раньше площади участка под ним — берём первую; «кв.м» пишем как «м²»
    const factArea = String(titleInfo.primary).match(/\d[\d\s.,]*\s?(?:м²|кв\.?\s?м\.?|га|сот)/);
    const factBig = escapeHtml(factArea ? factArea[0].replace(/\s?кв\.?\s?м\.?$/, ' м²') : titleInfo.primary);

    // ИЗМЕНЕНО (TASK4 4.6b — дефект найден ревьюером на живых данных): порядок
    // «до {дата} · {тип торгов} · {город}» — было «{город} · {тип} · до
    // {дата}», срок (самый важный токен) обрезался эллипсисом первым на
    // первых 20 карточках при 1920px, потому что стоял последним. Дата —
    // fmtDate(..., {short:true}) — "DD.MM" без года (§8.1: только через
    // fmtDate(), не свой формат; опция добавлена в саму функцию, не форк).
    //
    // ИСПРАВЛЕНО (та же находка ревьюера): простой reorder внутри одной
    // строки с white-space:nowrap+ellipsis НЕ решал задачу до конца —
    // «до DD.MM · Тип» само по себе близко к ширине карточки на узких
    // колонках (4-5 в ряд), эллипсис у строки целиком по-прежнему срезал
    // хвост ДО того, как регион вообще появлялся, — 9/20 карточек на
    // живых данных 1920/1280px. Мета теперь ДВЕ flex-ячейки: срок+тип —
    // неусыхающая (flex-shrink:0, никогда не обрезается), регион —
    // flex:1 min-width:0 с СОБСТВЕННЫМ text-overflow:ellipsis (dashboard.css).
    // Дочерний overflow:hidden не отдаёт родителю свою полную ширину текста —
    // scrollWidth родителя (.lot-card-site-meta) перестаёт превышать
    // clientWidth (проверено regression-check.mjs блок 18).
    const region = escapeHtml((l.location || '').split(',')[0].trim() || 'KZ');
    const tt = (l.type_trading || '').toLowerCase();
    const tradeType = tt.includes('пониж') ? 'На понижение' : (tt.includes('повыш') ? 'На повышение' : '');
    const dateText = l.application_deadline ? fmtDate(l.application_deadline, { short: true }) : '';
    const metaDate = dateText ? `до <span class="font-mono-nums">${escapeHtml(dateText)}</span>` : '';
    const metaFixed = [metaDate, escapeHtml(tradeType)].filter(Boolean).join(' · ');
    // TASK4 4.9: CSS margin:4px на .lot-card-site-meta-sep даёт визуальный
    // зазор, но textContent (DOM-инспектор/копирование/скринридер) всё
    // равно читает "···без пробелов" — margin не текст. Пробелы теперь
    // прямо в содержимом узла, тем же приёмом, что уже работает в metaFixed
    // выше (join(' · ')).
    const metaHtml = `${metaFixed ? `<span class="lot-card-site-meta-fixed">${metaFixed}</span>` : ''}${metaFixed && region ? '<span class="lot-card-site-meta-sep"> · </span>' : ''}<span class="lot-card-site-meta-region">${region}</span>`;

    const isClosed = l.is_active === false;
    // TASK10 10.3: лоты продажи ПРАВ аренды земли — start_price здесь не
    // цена, а периодическая ставка (attributes.deal_type/lease_rate, см.
    // sauda_parser_aiohttp.py::_extract_deal_type_fast). Сравнивать её со
    // сроком/дедлайном в терминах "растёт/близко к завершению" так же, как
    // обычную цену продажи, нечестно — эти два числа не сопоставимы.
    const isLease = l.attributes && l.attributes.deal_type === 'lease';
    // Чип срочности — ТОЛЬКО ≤3 дня или закрыт (§4): в отличие от карточки
    // Mini App (deadlineChip() у любого будущего срока), дата и так уже в
    // мета-строке выше — повторный чип нужен только как предупреждение.
    const dl = deadlineChip(l.application_deadline);
    let deadlineDays = null;
    if (dl) deadlineDays = dl.tone === 'neg' ? 0 : (dl.tone === 'warn' ? 1 : parseInt(dl.text, 10));
    const showDeadlineChip = !isLease && (isClosed || (Number.isFinite(deadlineDays) && deadlineDays <= 3));
    const deadlineChipHtml = isLease ? '' : (isClosed
        ? `<span class="lot-card-site-deadline text-neg font-bold"><i class="ph-fill ph-lock-simple"></i><span>Торги завершены</span></span>`
        : (showDeadlineChip ? `<span class="lot-card-site-deadline">${renderDeadlineChipHtml(l.application_deadline)}</span>` : ''));

    // ИЗМЕНЕНО (TASK4 4.6b): «Повторно» убрана с карточки целиком — 177/200
    // (88%) живых лотов несут relisted_from_id, флаг на 9 карточках из 10
    // не различает ничего (§5 конституции, принцип 5); история переносов
    // остаётся на странице лота (§III.2 блок 7, отдельная задача). «Обременение»
    // теперь только по hasExplicitEncumbrance() выше — редкое и конкретное,
    // не шаблон площадки и не отрицание. Флаги: обременение → скор
    // (если анализ уже есть). Максимум 2 сохраняется, но фактически теперь
    // не больше 2 источников и осталось.
    const flags = [];
    if (hasExplicitEncumbrance(l.description)) {
        flags.push({ icon: 'ph-warning', tone: 'neg', text: 'Обременение' });
    }
    if (isRecAnalyzed(l.recommendation_status, l.recommendation_score)) {
        const rc = getRecBadgeData(l.recommendation_status, l.recommendation_score);
        flags.push({ icon: rc.icon, tone: 'score', text: String(l.recommendation_score), cls: rc.class });
    }
    const shownFlags = flags.slice(0, 2);
    const flagsListHtml = shownFlags.map((f) => `<span class="lot-card-site-flag lot-card-site-flag--${f.tone}${f.cls ? ' ' + f.cls : ''}"><i class="ph-bold ${f.icon}"></i>${escapeHtml(f.text)}</span>`).join('');

    const guaranteeHtml = (l.guarantee_amount && l.guarantee_amount > 0)
        ? `<div class="lot-card-site-guarantee text-micro text-tertiary">гарантийный взнос ${escapeHtml(formatMoney(l.guarantee_amount))}</div>`
        : '';

    // ИСПРАВЛЕНО (TASK4 4.6b — дефект найден ревьюером): «Анализ →» раньше
    // была отдельной строкой в потоке (visibility:hidden оставляет
    // зарезервированную высоту, opacity:0 — тоже) — под флагами всегда
    // висела пустая ~40px полоса, даже без hover. Кнопка теперь ВНУТРИ уже
    // существующей последней строки (ряд флагов — если есть хоть один, иначе
    // ряд цены), а не отдельным блоком под ней: высота тела карточки
    // определяется только реально видимым содержимым. Заодно починена
    // клавиатурная доступность — visibility:hidden убирает элемент из
    // последовательности Tab целиком (Tab не мог дойти до кнопки, чтобы её
    // же :focus-visible её показал); opacity/pointer-events без visibility
    // оставляют её в Tab-последовательности.
    const analyzeBtnHtml = opts.actionsHtml != null
        ? `<span class="lot-card-site-actions">${opts.actionsHtml}</span>`
        : `<button type="button" class="lot-card-site-analyze" data-lot-id="${l.id}">Анализ <i class="ph-bold ph-arrow-right"></i></button>`;
    const flagsRowHtml = shownFlags.length
        ? `<div class="lot-card-site-flags"><div class="lot-card-site-flags-list">${flagsListHtml}</div>${analyzeBtnHtml}</div>`
        : '';

    // TASK9 9.6: l.is_favorite — теперь реальное поле из /api/lots
    // (get_filtered_lots(), EXISTS-подзапрос в SELECT), не только
    // оптимистичное локальное состояние клика. Тот же класс/атрибуты/иконка,
    // что toggleCardFavoriteSite() уже проставляет ПОСЛЕ клика — здесь
    // просто тот же результат сразу при первой отрисовке карточки.
    el.innerHTML = `
        <div class="lot-card-site-media${photo ? '' : ' is-nophoto'}">
            <span class="lot-card-site-source badge-solid ${isE ? 'bg-etp' : 'bg-sauda'}">${isE ? 'ETP' : 'SAUDA'}</span>
            <img src="${img}" alt="${title}" title="${titleFull}" onerror="this.onerror=null;this.src='${fallbackImg}';this.parentNode.classList.add('is-nophoto');" referrerpolicy="no-referrer" loading="lazy" class="${isClosed ? 'grayscale' : ''}">
            <div class="lot-card-site-fact" aria-hidden="true"><span class="lot-card-site-fact-kind">${factKind} · фото нет</span><span class="lot-card-site-fact-big">${factBig}</span></div>
            <button type="button" class="lot-card-site-fav${l.is_favorite ? ' is-active' : ''}" data-lot-id="${l.id}" aria-label="Добавить в избранное" aria-pressed="${l.is_favorite ? 'true' : 'false'}">
                <i class="${l.is_favorite ? 'ph-fill' : 'ph-bold'} ph-heart"></i>
            </button>
            ${lotHasMapPoint(l) ? `<button type="button" class="lot-card-site-mapbtn" aria-label="Посмотреть на карте" title="Посмотреть на карте" onclick="openLotOnMap('${escapeHtml(String(l.id))}', event)"><i class="ph-bold ph-map-pin"></i></button>` : ''}
        </div>
        <div class="lot-card-site-body">
            <h3 class="lot-card-site-title" title="${titleFull}">${title}</h3>
            <div class="lot-card-site-meta text-caption text-secondary">${metaHtml}</div>
            <div class="lot-card-site-price-row">
                <span class="lot-card-site-price font-mono-nums">${escapeHtml(formatMoney(l.start_price))}</span>
                <div class="lot-card-site-price-right">
                    ${deadlineChipHtml}
                    ${!shownFlags.length ? analyzeBtnHtml : ''}
                </div>
            </div>
            ${guaranteeHtml}
            ${opts.noteHtml ? `<div class="lot-card-site-note text-micro text-tertiary">${opts.noteHtml}</div>` : ''}
            ${flagsRowHtml}
        </div>`;

    const favBtn = el.querySelector('.lot-card-site-fav');
    favBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        toggleCardFavoriteSite(l.id, favBtn, formatLotTitleSite(l).primary);
    });

    if (opts.onCardClick) el.addEventListener('click', (e) => { if (e.target.closest('a[href]') !== el) return; opts.onCardClick(e); });
    const analyzeBtn = el.querySelector('.lot-card-site-analyze');
    if (analyzeBtn) analyzeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        // Гость → тот же вход, что и у остальных персональных действий
        // (startAnalysis()/toggleDetailFav()) — карточки/каталог открыты
        // анонимно, запуск анализа — нет. На лоте ведём тем же адресом,
        // на который и так указывает вся карточка (§4: "use the same
        // target the card CTA points to today") — #analyze лишь помечает
        // намерение для будущей автопрокрутки/автозапуска на самой
        // странице лота (Lot-1, вне периметра этой задачи).
        if (!IS_TELEGRAM && !userId) { renderLoginGate(formatLotTitleSite(l).primary); return; }
        window.location.href = `/workspace/lot/${l.id}#analyze`;
    });

    return el;
}

// ДОБАВЛЕНО (TASK4 4.6, §4): избранное с карточки сайта — тот же
// /api/favorites/toggle, что и toggleDetailFav() (модалка лота), но без
// привязки к state.currentLot (карточка не открывает лот). /api/lots не
// отдаёт is_favorite по каждому лоту списка (только /api/lot/{id} —
// проверено в api_server.py) — задача запрещает новые эндпоинты/параметры
// (TASK4 §12), поэтому сердечко здесь оптимистично-локальное: отражает
// действие в этой сессии, не читает персистентное состояние при отрисовке
// (тот же уровень достоверности, что и у createCard() — там на карточке
// сердечка нет вовсе, лайк виден только внутри уже открытого лота).
async function toggleCardFavoriteSite(lotId, btnEl, lotLabel) {
    if (!IS_TELEGRAM && !userId) { renderLoginGate(lotLabel); return; }
    const icon = btnEl.querySelector('i');
    const wasActive = btnEl.classList.contains('is-active');
    const nowActive = !wasActive;
    btnEl.classList.toggle('is-active', nowActive);
    btnEl.setAttribute('aria-pressed', String(nowActive));
    icon.className = nowActive ? 'ph-fill ph-heart' : 'ph-bold ph-heart';
    tg.HapticFeedback.impactOccurred('medium');
    try {
        const r = await fetch('/api/favorites/toggle', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ user_id: userId, lot_id: lotId }),
        });
        if (!r.ok) throw new Error(`HTTP ${r.status}`);
    } catch (e) {
        console.error('[toggleCardFavoriteSite]', e);
        btnEl.classList.toggle('is-active', wasActive);
        btnEl.setAttribute('aria-pressed', String(wasActive));
        icon.className = wasActive ? 'ph-fill ph-heart' : 'ph-bold ph-heart';
    }
}

// --- HELPER FUNCTIONS ---
// Бэкенд присылает recommendation_status: "requires_analysis" и
// recommendation_score: 0 (НЕ null) для ещё не проанализированных лотов —
// это валидные, непустые значения, поэтому обычная проверка на null/undefined
// их не отсекала, и компактный бейдж в карточке лота показывал "🔍 0",
// что читается как "оценка 0 из 100" вместо настоящего смысла "анализ ещё
// не проводился". Показываем число только для реально завершённого анализа.
//
// 🔥 ВТОРОЙ СЛОЙ БАГА (найден в «База AI» / /api/global_lots): бэкенд не всегда
// успевает обновить recommendation_status на финальный вердикт после того, как
// скоринг реально прогнан — лот повисает с status:"requires_analysis", но при
// этом recommendation_score уже настоящий (>0) и recommendation_updated_at
// свежий. Раньше это давало серый бейдж-«лупу» на уже проанализированных
// лотах. Если реальный балл (>0) есть — считаем анализ завершённым и красим
// бейдж по тем же порогам, что и кольцо оценки в отчёте (см. scoreColor).
function isRecAnalyzed(status, score = null) {
    if (status === 'recommended' || status === 'conditionally_recommended' || status === 'not_recommended') return true;
    return typeof score === 'number' && score > 0;
}

// ДОБАВЛЕНО (TASK5 5.1, §2 п.2, B-02 "скор дважды"): поле `label` — то же
// слово, что и `text`, БЕЗ суффикса NN/100 и БЕЗ ALL CAPS (Title Case —
// §6.2 конституции: uppercase-текст разрешён только в .text-table-head,
// `text` — существующее поле, ALL CAPS, с баллом — Mini App и карточки его
// уже читают, не меняется ни строкой). `label` — для ячейки `verdict`
// общего рендерера строки (§5.1 канона): пилюля там несёт ТОЛЬКО слово,
// число уже показано отдельно в ячейке `score`, когда та есть в columns.
function getRecBadgeData(s, score = null) {
    // Добавляем баллы, если они есть (score может быть 0 — это тоже валидное значение)
    const scoreText = score != null ? ` ${fmtScore(score)}` : '';

    // Переводим статус в нижний регистр, чтобы избежать багов с большими буквами
    const status = (s || '').toLowerCase().trim();
    const build = (text, label, cls, icon) => ({ text, label, class: cls, icon });

    switch(status) {
        case 'recommended':
        case 'рекомендуется':
            return build('РЕКОМЕНДУЕТСЯ' + scoreText, 'Рекомендуется', 'rec-green', 'ph-check-circle');

        case 'conditionally_recommended':
        case 'условно рекомендуется':
            return build('УСЛОВНО' + scoreText, 'Условно', 'rec-yellow', 'ph-warning');

        case 'not_recommended':
        case 'не рекомендуется':
            return build('НЕ РЕКОМЕНДУЕТСЯ' + scoreText, 'Не рекомендуется', 'rec-red', 'ph-x-circle');

        default:
            // Статус ещё "requires_analysis" (или бэкенд не обновил его вовремя),
            // но реальный балл уже посчитан — доверяем баллу, а не тексту статуса.
            if (typeof score === 'number' && score > 0) {
                if (score >= 70) return build('РЕКОМЕНДУЕТСЯ' + scoreText, 'Рекомендуется', 'rec-green', 'ph-check-circle');
                if (score >= 40) return build('УСЛОВНО' + scoreText, 'Условно', 'rec-yellow', 'ph-warning');
                return build('НЕ РЕКОМЕНДУЕТСЯ' + scoreText, 'Не рекомендуется', 'rec-red', 'ph-x-circle');
            }
            return build('ТРЕБУЕТ АНАЛИЗА', 'Требует анализа', 'rec-gray', 'ph-magnifying-glass');
    }
}

// 🔥 ДОБАВЛЕНО (аудит "карточка не даёт принять решение", 05.09.2026),
// ПЕРЕРАБОТАНО (D1, DESIGN_UPGRADE_PROMPT.md §6 D1 "модель срочности
// дедлайна"): application_deadline приходит в каждом лоте от /api/lots.
// Единая функция на все поверхности (карточка/таблица/деталь/избранное/
// отчёт) вместо разных урезанных версий по месту — три категории срочности,
// как в плане: сегодня (status-neg/красный), завтра (status-warn/жёлтый),
// N дн (нейтрально). Раньше "≤3 дня" тоже красились красным с точным
// остатком — сведено к трём категориям по плану, без промежуточной.
function deadlineChip(iso) {
    if (!iso) return null;
    const d = new Date(iso);
    if (isNaN(d.getTime())) return null;
    const daysLeft = Math.ceil((d.getTime() - Date.now()) / 86400000);
    const dateText = d.toLocaleDateString('ru-RU', { day: 'numeric', month: 'short' }).replace('.', '');
    if (daysLeft <= 0) return { text: 'сегодня', tone: 'neg', full: `Приём заявок — сегодня (до ${dateText})` };
    if (daysLeft === 1) return { text: 'завтра', tone: 'warn', full: `Приём заявок — завтра (до ${dateText})` };
    return { text: `${daysLeft} дн`, tone: 'neutral', full: `Приём заявок до ${dateText} (ещё ${daysLeft} дн)` };
}
const DEADLINE_TONE_CLASS = { neg: 'text-neg font-bold', warn: 'text-warn font-bold', neutral: 'text-secondary' };
// Готовый HTML чипа (иконка песочных часов + текст) — единая точка рендера
// для card/table/detail, чтобы не собирать обёртку заново в каждом месте.
function renderDeadlineChipHtml(iso, opts = {}) {
    const dl = deadlineChip(iso);
    const toneClass = dl ? (DEADLINE_TONE_CLASS[dl.tone] || 'text-secondary') : 'text-tertiary';
    const text = dl ? dl.text : (opts.emptyText || '—');
    const title = dl ? ` title="${escapeHtml(dl.full)}"` : '';
    // Моно-цифры только для формы "N дн" — "сегодня"/"завтра" это слова, не число.
    const numClass = dl && dl.tone === 'neutral' ? ' font-mono-nums' : '';
    return `<span class="inline-flex items-center gap-1 ${toneClass} ${opts.extraClass || ''}"${title}><i class="ph-fill ph-hourglass"></i><span class="truncate${numClass}">${text}</span></span>`;
}
function formatDate(d){if(!d)return"-";try{return new Date(d).toLocaleString('ru-RU',{day:'2-digit',month:'2-digit',year:'numeric',hour:'2-digit',minute:'2-digit'})}catch{return d}}

// D1 (DESIGN_UPGRADE_PROMPT.md §6 D2): одна функция на "когда добавлено/
// обновлено" в списках и таблицах — раньше почти в каждом месте была своя
// комбинация toLocaleDateString({...}), местами вовсе без локали ('ru-RU'
// потерян — браузерный формат по умолчанию). Правило по плану: относительная
// дата в пределах недели, иначе абсолютная ДД.ММ.ГГГГ. Для полных штампов
// времени (генерация отчёта, "обновлено в HH:MM") formatDate() выше остаётся
// как есть — это другая задача (точный момент, не "давно ли").
// ИЗМЕНЕНО (TASK4 4.6b): необязательный второй параметр opts.short — "DD.MM"
// без года и без "сегодня/вчера/N дн назад" (та относительная лесенка для
// ПРОШЕДШИХ дат — не подходит будущему application_deadline, которым и
// пользуется renderLotCardSite() для меты карточки). Второй параметр
// опционален и по умолчанию отсутствует — все существующие вызовы fmtDate(x)
// без него ведут себя побайтово как раньше, поведение не менялось нигде,
// кроме нового места вызова.
function fmtDate(input, opts = {}) {
    if (!input) return '—';
    const d = new Date(input);
    if (isNaN(d.getTime())) return '—';
    if (opts.short) return d.toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit' });
    const startOfDay = (dt) => new Date(dt.getFullYear(), dt.getMonth(), dt.getDate()).getTime();
    const daysAgo = Math.round((startOfDay(new Date()) - startOfDay(d)) / 86400000);
    if (daysAgo === 0) return 'сегодня';
    if (daysAgo === 1) return 'вчера';
    if (daysAgo > 1 && daysAgo <= 7) return `${daysAgo} дн назад`;
    return d.toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit', year: 'numeric' });
}

// D2 (DESIGN_UPGRADE_PROMPT.md §6, "один fmtScore()"): раньше "N/100" было
// собрано инлайном в 3+ местах (getRecBadgeData()/renderInAppReport()/бейдж
// вердикта) — каждое само решало, что значит "нет балла" (пустая строка? "—"?
// просто не показывать?). Один форматтер, один инвариант: score==null/
// score==undefined → "—/100" (честно "нет данных", не молчание — в отличие от
// цены/даты, отсутствие скора здесь всегда означает "лот ещё не анализировался",
// это ожидаемо и не нужно прятать). 0 — валидный балл, не путать с "нет данных"
// (см. её же комментарий у isRecAnalyzed()).
function fmtScore(score) {
    return `${typeof score === 'number' ? score : '—'}/100`;
}

// D2 (DESIGN_UPGRADE_PROMPT.md §6): "12.09.2026 14:30" собиралось инлайн в
// трёх местах отчёта (renderInAppReport() — свежесть цены на самой цифре
// взноса и в заголовке "Отчёт сформирован") — одно из них даже переобъявляло
// локальную `const fmtDate`, тенью перекрывая глобальный fmtDate() (день-
// относительный, другая семантика) прямо в той же функции. Один форматтер,
// одно имя, никакой путаницы между "N дн назад" и "точная дата+время".
function fmtDateTime(iso) {
    if (!iso) return null;
    const d = new Date(iso);
    if (isNaN(d.getTime())) return null;
    return d.toLocaleDateString('ru-RU') + ' ' + d.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' });
}

// D2: "26 августа 2027" (день/месяц-словом/год) — та же строка была собрана
// инлайн дважды подряд в updateProfileUI() (сам срок тарифа и срок скидки).
function fmtDateLong(iso) {
    if (!iso) return null;
    const d = new Date(iso);
    if (isNaN(d.getTime())) return null;
    return d.toLocaleDateString('ru-RU', { day: 'numeric', month: 'long', year: 'numeric' });
}

// D9 (DESIGN_UPGRADE_PROMPT.md §6, провенанс-штамп): fmtDate() выше нарочно
// дневной точности (сегодня/вчера/N дн назад) — для "данные площадки
// обновлены" этого мало (скрапер обновляет lots.updated_at по многу раз за
// день, "сегодня" не отличает свежий скрап от вчерашнего конца дня). Часовая/
// минутная точность в первые сутки, дальше — тот же fmtDate() (не изобретаем
// вторую систему относительных дат на весь остаток срока жизни лота).
function provenanceAgo(iso) {
    if (!iso) return null;
    const d = new Date(iso);
    if (isNaN(d.getTime())) return null;
    const minutes = Math.round((Date.now() - d.getTime()) / 60000);
    if (minutes < 1) return 'только что';
    if (minutes < 60) return `${minutes} мин назад`;
    const hours = Math.round(minutes / 60);
    if (hours < 24) return `${hours} ч назад`;
    return fmtDate(iso);
}

// D4 (DESIGN_UPGRADE_PROMPT.md §6, ценовые спарклайны в таблицах): lot_history
// уже трекает переслистывание/смену цены (миграции 0004/0009, см. её же
// использование в #lotHistorySection карточки лота) — здесь то же самое,
// только компактно, прямо в строках таблиц (Главная/Избранное; «База AI» — у
// её таблицы нет столбца цены вообще, см. renderGlobalTableRows(), заводить
// его только ради спарклайна не стал). Per-лот /api/lot/{id}/history — тот
// же эндпоинт, что и у карточки, batch-версии нет и не заводим ("top rows
// текущей страницы" из брифа — это и есть уже отрендеренные строки, не
// требует отдельного batch-API). root — контейнер (tbody/tr-родитель) только
// что отрисованных строк; :not([data-spark-done]) не даёт повторно
// перезапрашивать историю уже обработанных строк при append-подгрузке.
async function attachSparklines(root) {
    if (!root) return;
    const holders = root.querySelectorAll('.spark-holder:not([data-spark-done])');
    await Promise.all([...holders].map(async holder => {
        holder.dataset.sparkDone = '1';
        const lotId = holder.dataset.lotId;
        const currentPrice = Number(holder.dataset.price) || null;
        if (!lotId) return;
        try {
            // limit=100 — см. её же комментарий у get_lot_history() в
            // api_server.py: дефолтные 20 записей у активно синкающихся лотов
            // почти целиком забиты deadline_changed, price_changed там может
            // не остаться вовсе, хотя реально есть глубже.
            const res = await fetch(`/api/lot/${encodeURIComponent(lotId)}/history?limit=100`);
            const events = await res.json();
            // API отдаёт события DESC (новые первыми, см. get_lot_history()) —
            // разворачиваем в хронологический порядок для графика слева-направо.
            const priceEvents = (Array.isArray(events) ? events : [])
                .filter(e => e.event_type === 'price_changed' && e.new_value != null)
                .slice().reverse();
            if (!priceEvents.length) return; // нет истории цены — молчание, а не пустой/нулевой график

            const points = [];
            if (priceEvents[0].old_value != null) points.push(Number(priceEvents[0].old_value));
            priceEvents.forEach(e => points.push(Number(e.new_value)));
            if (currentPrice != null) points.push(currentPrice);
            if (points.length < 2) return;

            const min = Math.min(...points), max = Math.max(...points);
            const range = max - min || 1;
            const W = 60, H = 20, PAD = 2;
            const stepX = (W - PAD * 2) / (points.length - 1);
            const coords = points.map((v, i) => {
                const x = PAD + i * stepX;
                const y = PAD + (H - PAD * 2) * (1 - (v - min) / range);
                return `${x.toFixed(1)},${y.toFixed(1)}`;
            }).join(' ');

            const first = points[0], last = points[points.length - 1];
            const trendClass = last > first ? 'spark-up' : last < first ? 'spark-down' : 'spark-flat';
            const delta = last - first;
            const deltaText = delta === 0 ? 'без изменений' : `${delta > 0 ? '+' : '−'}${formatMoney(Math.abs(delta))}`;
            const lastChangeAt = priceEvents[priceEvents.length - 1]?.created_at;
            const whenText = lastChangeAt ? fmtDate(lastChangeAt) : '';

            holder.innerHTML = `<svg class="spark ${trendClass}" viewBox="0 0 ${W} ${H}" width="${W}" height="${H}" aria-hidden="true"><polyline points="${coords}"/></svg>`;
            holder.title = `Изменение цены: ${deltaText}${whenText ? ' · ' + whenText : ''}`;
        } catch (e) {
            console.error('[attachSparklines]', e);
        }
    }));
}

// 🔥 ДОБАВЛЕНО (аудит "цвет полос по номеру строки, а не по значению",
// 05.09.2026): используется в "Разбивке оценки" отчёта (renderInAppReport) —
// см. её же комментарий у rows.map(). Те же пороги и та же палитра
// (#4ade80/#E8B84B/#f87171), что и у .score-good/.score-mid/.score-bad в
// dashboard.css (там — scoped под #globalTable) и у scoreColor в
// renderCompareContent — здесь как переиспользуемая функция, а не
// локальная переменная, потому что нужна в контексте, который рендерится
// и в Telegram, не только в браузере.
function scoreBarColor(value) {
    if (value == null) return 'bg-white/20'; // нет данных — нейтральный цвет, не зелёный и не красный
    if (value >= 70) return 'bg-[#4ade80]';
    if (value >= 40) return 'bg-[#E8B84B]';
    return 'bg-[#f87171]';
}

async function toggleDetailFav(){
    if (!state.currentLot) return;
    // ДОБАВЛЕНО (анонимный просмотр лотов): раньше это молча ничего не
    // делало для гостя — теперь и такое действие ведёт на вход, а не в
    // тишину (тот же гейт, что и на "Начать анализ", см. startAnalysis()).
    if (!userId) {
        if (!IS_TELEGRAM) { renderLoginGate(formatLotTitleSite(state.currentLot).primary); return; }
        return;
    }
    const icon = document.querySelector('#detailFavBtn i');
    const isFav = icon.classList.contains('text-red-500');
    
    state.currentLot.is_favorite = !isFav;
    const nowLiking = !isFav;
    // Phase 3: CSS-поп (animate-pop) — только при уважении reduced-motion;
    // сам класс/цвет сердечка (логика лайка) не меняется.
    const popClass = REDUCE_MOTION ? '' : ' animate-pop';
    icon.className = nowLiking
        ? `ph-fill ph-heart text-3xl text-red-500${popClass}`
        : `ph-fill ph-heart text-3xl text-[#94a3b8]${popClass}`;

    void icon.offsetWidth;
    tg.HapticFeedback.impactOccurred('medium');

    // Phase 3: доп. scale-пульс через GSAP только при лайке (не при снятии
    // лайка) — усиливает уже существующий CSS-поп сверху, безопасно
    // деградирует, если GSAP не загрузился или reduced-motion включён.
    if (nowLiking && !REDUCE_MOTION && HAS_GSAP()) {
        try {
            gsap.fromTo(icon, { scale: 1 }, { scale: 1.3, duration: 0.15, yoyo: true, repeat: 1, ease: 'power1.out' });
        } catch (e) { /* безопасно игнорируем — CSS-поп уже отработал */ }
    }

    try {
        // ⚠️ fetch() не бросает исключение на 4xx/5xx — раньше здесь ловилась
        // только сетевая ошибка, а ответ сервера вообще не проверялся. Если
        // бэкенд отвечал ошибкой (403/500), иконка оставалась "переключённой"
        // навсегда, хотя на сервере ничего не сохранилось — расхождение
        // видно только после перезагрузки приложения.
        const r = await fetch('/api/favorites/toggle', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({ user_id: userId, lot_id: state.currentLot.id })
        });
        if (!r.ok) throw new Error(`HTTP ${r.status}`);
    } catch(e) {
        console.error('[toggleDetailFav]', e);
        state.currentLot.is_favorite = isFav;
        icon.className = isFav
            ? 'ph-fill ph-heart text-3xl text-red-500'
            : 'ph-fill ph-heart text-3xl text-[#94a3b8]';
    }
}

// --- FILTERS & TABS ---
window.setCategory = (v, btn) => {
    state.category = v;
    // ИСПРАВЛЕНО (аудит интерфейса): раньше здесь терялся whitespace-nowrap
    // (категории могли перенестись на вторую строку в горизонтальном скролле)
    // и активная кнопка теряла золотой градиент из исходной вёрстки
    // (app_shell.html #homeCategoryRow) в пользу плоского цвета — после первого
    // клика ряд выглядел иначе, чем при первой загрузке страницы. Классы ниже
    // дословно повторяют то, что уже задано в HTML для active/inactive.
    document.querySelectorAll('.cat-btn').forEach(x => x.className="whitespace-nowrap px-4 py-1.5 rounded-full text-xs font-bold bg-white/5 text-gray-300 border border-white/5 transition-all cat-btn");
    btn.className = "whitespace-nowrap px-4 py-1.5 rounded-full text-xs font-bold bg-accent text-accent-ink transition-all cat-btn";
    tg.HapticFeedback.selectionChanged();
    updateDynamicFilters();
    updateDynamicFilters('Desktop'); // P3.2 аудита — no-op, если десктопной колонки нет (см. её же guard)
    updateRegionsOnFilterChange(); // 🔥 Обновляем список регионов при изменении категории
    loadLots();
}

window.setSite = (v, btn) => {
    state.site = v;
    document.querySelectorAll('.site-btn').forEach(x => x.className="flex-1 py-1.5 text-xs font-bold rounded-full text-gray-400 hover:text-white transition-all site-btn");
    btn.className = "flex-1 py-1.5 text-xs font-bold rounded-full bg-white/10 text-white shadow-sm transition-all site-btn active";
    tg.HapticFeedback.selectionChanged();
    updateRegionsOnFilterChange(); // 🔥 Обновляем список регионов при изменении сайта
    loadLots();
};

window.setFavCategory = (val, btn) => {
    favState.category = val;

    // D2 (DESIGN_UPGRADE_PROMPT.md §5.2): категория теперь select
    // (render_select() в _category_row.html) — вызывает setFavCategory(val,
    // null), красить пилюли не нужно и нечего. btn остаётся необязательным,
    // чтобы старый вызов с кнопкой (если где-то ещё используется render())
    // продолжал подсвечивать активную пилюлю как раньше.
    if (btn) {
        // ИСПРАВЛЕНО (унификация категорий): активный цвет раньше менялся с синего
        // (как в исходной вёрстке у "Все") на золотисто-коричневый после первого
        // клика — тот же класс бага, что и в setCategory()/setGCategory(). Активный
        // класс теперь дословно совпадает с тем, что уже задано в HTML для "Все".
        document.querySelectorAll('.fav-cat-btn').forEach(b => {
            b.className = "fav-cat-btn px-3 py-1.5 rounded-full text-[10px] font-bold bg-white/5 text-gray-400 border border-white/10";
        });
        btn.className = "fav-cat-btn px-3 py-1.5 rounded-full text-[10px] font-bold bg-blue-600 text-white border border-blue-600 active";
    }

    tg.HapticFeedback.selectionChanged();
    renderFavorites();
};

window.setFavSite = (val, btn) => {
    favState.site = val;
    document.querySelectorAll('.fav-site-btn').forEach(b => b.className = "fav-site-btn flex-1 py-1.5 text-[10px] font-bold rounded-md text-gray-400");
    btn.className = "fav-site-btn flex-1 py-1.5 text-[10px] font-bold rounded-md bg-white/10 text-white active";
    renderFavorites();
}

window.toggleFavSort = (btn) => {
    const span = btn.querySelector('span');
    if(favState.sort === 'date_desc') { favState.sort = 'price_asc'; span.innerText = 'Дешевые'; } 
    else if(favState.sort === 'price_asc') { favState.sort = 'price_desc'; span.innerText = 'Дорогие'; } 
    else { favState.sort = 'date_desc'; span.innerText = 'Новые'; }
    renderFavorites();
}

window.setFavSort = (mode, btn) => {
    favState.sort = mode;

    // D2 (DESIGN_UPGRADE_PROMPT.md §5.2, "sort dropdown вместо цикличных
    // чипов"): вызов теперь идёт и от select (#favSortSelect, btn=null), и
    // от старых чипов-кнопок (если где-то ещё остались) — красим активный
    // чип, только если он реально есть.
    if (btn) {
        // Снимаем активный класс со всех чипов сортировки
        document.querySelectorAll('.fav-sort-btn').forEach(b => {
            b.className = "fav-sort-btn px-3 py-1.5 rounded-lg text-[10px] font-bold bg-white/5 text-gray-400 border border-white/10";
        });

        // Активируем выбранный. ИСПРАВЛЕНО (аудит интерфейса): в отличие от
        // .fav-cat-btn/.fav-site-btn, для .fav-sort-btn.active НЕТ отдельного
        // CSS-правила в style.css — цвет активной кнопки целиком берётся из
        // инлайн-классов ниже. Раньше здесь стоял золотисто-коричневый цвет
        // (#A16207), хотя исходная разметка ("Сначала новые" при загрузке
        // страницы) — синий bg-blue-600, так что после первого клика по любой
        // сортировке цвет активного чипа менялся сам по себе.
        btn.className = "fav-sort-btn active px-3 py-1.5 rounded-lg text-[10px] font-bold bg-blue-600 text-white border border-blue-600";
    }

    if (window.Telegram?.WebApp?.HapticFeedback) {
        tg.HapticFeedback.selectionChanged();
    }

    renderFavorites(); // Перерисовываем сетку
};

// ДОБАВЛЕНО (TASK5 5.2, §3): поиск рейла сайта — 300мс debounce, тот же
// приём, что у текстовых полей рейла Главной (initDesktopInstantFilters()),
// но проще: здесь нет сетевого запроса/AbortController — фильтрация
// целиком клиентская над уже загруженным favState.lotsCache, дебаунс нужен
// только чтобы не перестраивать таблицу на каждое нажатие клавиши.
let favQueryDebounce = null;
window.setFavQuery = (val) => {
    clearTimeout(favQueryDebounce);
    favQueryDebounce = setTimeout(() => {
        favState.query = val;
        renderFavorites();
    }, 300);
};

window.setFavVerdict = (val) => {
    favState.verdict = val;
    renderFavorites();
};

// ДОБАВЛЕНО (TASK5 5.2, §3, «Сбросить · N» в футере рейла — тот же паттерн,
// что countActiveRailFilters()/resetFilters() Главной, TASK4 4.3): категория
// и площадка здесь ЖИВУТ в рейле (в отличие от Главной, где это отдельный
// ряд чипов вне рейла) — считаются наравне с поиском/вердиктом.
function countActiveFavFilters() {
    let n = 0;
    if (favState.query) n++;
    if (favState.category !== 'all') n++;
    if (favState.site !== 'all') n++;
    if (favState.verdict !== 'all') n++;
    return n;
}

function updateFavRailResetLabel() {
    const btn = document.getElementById('favRailResetBtn');
    if (!btn) return; // мобильный/Mini App — рейла нет вовсе
    const n = countActiveFavFilters();
    if (n > 0) {
        btn.textContent = `Сбросить · ${n}`;
        btn.classList.remove('hidden');
    } else {
        btn.classList.add('hidden');
    }
}

// window.resetFavFilters — сброс ТОЛЬКО полей рейла сайта (поиск/категория/
// площадка/вердикт); сортировку не трогает, тот же принцип, что у
// resetFilters() Главной (сортировка — не фильтр). Программная установка
// .value не порождает событие change — очищаем favState напрямую, а не
// полагаемся на onchange полей.
// 2026-10-29 (вариант 3): вид списков на сайте — «Карточки» (блоки Главной, по умолчанию) или «Таблица»; у каждой
// вкладки свой, запоминается в браузере. Класс на #screen-X решает CSS, данные одни и те же (рендер строит обе формы).
const LIST_VIEW_KEYS = { favorites: 'ad_fav_view_v1', global: 'ad_global_view_v1', analyses: 'ad_analyses_view_v1' };
window.setListView = (screen, mode) => {
    const v = mode === 'table' ? 'table' : 'grid';
    try { localStorage.setItem(LIST_VIEW_KEYS[screen], v); } catch (e) {}
    const scr = document.getElementById('screen-' + screen);
    if (!scr) return;
    scr.classList.toggle('list-view-grid', v === 'grid');
    scr.classList.toggle('list-view-table', v === 'table');
    scr.querySelectorAll('[data-list-view]').forEach((b) => b.classList.toggle('active', b.dataset.listView === v));
    if (screen === 'favorites' && v === 'grid' && document.getElementById('favTableWrap')?.classList.contains('fav-select-mode')) toggleFavSelectMode();
};
Object.keys(LIST_VIEW_KEYS).forEach((screen) => {
    let v = 'grid';
    try { v = localStorage.getItem(LIST_VIEW_KEYS[screen]) || 'grid'; } catch (e) {}
    window.setListView(screen, v);
});

window.resetFavFilters = () => {
    const searchEl = document.getElementById('favSearchInputDesktop');
    if (searchEl) searchEl.value = '';
    clearTimeout(favQueryDebounce);
    favState.query = '';
    favState.category = 'all';
    favState.site = 'all';
    favState.verdict = 'all';
    const catEl = document.getElementById('favCatTabsDesktop');
    if (catEl) catEl.value = 'all';
    document.querySelectorAll('#favCatTabsDesktopRow .fav-cat-btn').forEach((b) => {   // вкладки категорий (вариант 3)
        b.className = b.textContent.trim() === 'Все'
            ? 'fav-cat-btn px-3 py-1.5 rounded-full text-[10px] font-bold bg-blue-600 text-white border border-blue-600 active'
            : 'fav-cat-btn px-3 py-1.5 rounded-full text-[10px] font-bold bg-white/5 text-gray-400 border border-white/10';
    });
    const mobileCatEl = document.getElementById('favCatTabs');
    if (mobileCatEl) mobileCatEl.value = 'all';
    const verdictEl = document.getElementById('favVerdictSelectDesktop');
    if (verdictEl) verdictEl.value = 'all';
    // По ТЕКСТУ, не позиции — два копии («Все площадки» мобильная + десктопная
    // рейла) идут в DOM подряд, indexOf(0) красил бы только первую физическую
    // кнопку в документе, а не обе копии "Все площадки".
    document.querySelectorAll('.fav-site-btn').forEach((b) => {
        b.className = b.textContent.trim() === 'Все площадки'
            ? 'fav-site-btn flex-1 py-1.5 text-[10px] font-bold rounded-md bg-white/10 text-white active'
            : 'fav-site-btn flex-1 py-1.5 text-[10px] font-bold rounded-md text-gray-400';
    });
    renderFavorites();
};

// ДОБАВЛЕНО (TASK5 5.2, §3): «Выбрать» — чекбоксы скрыты по умолчанию
// (чекбокс на каждой строке списка из 1 лота — шум), появляются только в
// этом режиме. CSS-класс на #favTableWrap/#favArchiveTableWrap (dashboard.css)
// прячет .lot-row-cell--checkbox/.lot-row-td--checkbox — та же колонка,
// разметка не меняется, никакого пересбора таблицы. Выход из режима сам
// снимает выбор — иначе можно было бы случайно оставить лоты "выбранными
// невидимо" после того, как чекбоксы снова спрятаны.
// TASK5_LISTS_PROMPT.md §3: массовый выбор — только у активного списка.
// Архив («Завершённые») не несёт своей bulk-панели — одна ghost-ссылка
// «Убрать все завершённые» в заголовке секции (clearClosedFavorites()),
// без построчного выбора (см. renderFavArchiveTable()).
let favSelectMode = false;
window.toggleFavSelectMode = () => {
    favSelectMode = !favSelectMode;
    // вариант 3: выбор с чекбоксами есть только у таблицы — «Выбрать» в виде «Карточки» переключает на таблицу
    if (favSelectMode && document.getElementById('screen-favorites')?.classList.contains('list-view-grid')) window.setListView('favorites', 'table');
    const wrap = document.getElementById('favTableWrap');
    if (wrap) wrap.classList.toggle('fav-select-mode', favSelectMode);
    const btn = document.getElementById('favSelectModeBtn');
    if (btn) btn.textContent = favSelectMode ? 'Готово' : 'Выбрать';
    if (!favSelectMode) {
        favSelected.clear();
        document.querySelectorAll('#favTableBody .lot-row-checkbox').forEach((cb) => { cb.checked = false; });
        updateFavBulkBar();
    }
};

// ИЗМЕНЕНО (P3.2 аудита, 12.09.2026): idSuffix — параметр, а не жёстко
// зашитые id, потому что десктопной колонке (home_desktop.html) нужна ВТОРАЯ
// копия этого же блока (свои id, вторая копия <select id="modelSelect">
// в одном документе — невалидный HTML и document.getElementById() отдал бы
// только первую). Дублировать саму функцию (200+ строк, из них ~110 —
// список марок/моделей авто) означало бы ту же ошибку copy-paste, ради
// которой сделан P1.1 — вместо этого один источник разметки, вызываемый
// дважды: updateDynamicFilters() для мобильной копии (idSuffix='', как и
// раньше — поведение по умолчанию не изменилось) и
// updateDynamicFilters('Desktop') для десктопной, см. вызовы в
// window.setCategory(). mirror(id) — то же зеркалирование значения между
// копиями, что и у остальных полей ввода (см. комментарий у
// _filters/auction_type_select.html, P3.1 аудита) — applyFilters() ниже
// по-прежнему читает канонические id без суффикса, не переписан.
function updateDynamicFilters(idSuffix = '') {
    const container = document.getElementById('dynamicFilters' + idSuffix);
    if (!container) return; // На Mini App/мобильном второй копии нет — не ошибка
    container.innerHTML = '';

    const otherSuffix = idSuffix === '' ? 'Desktop' : '';
    const mirror = (id) => `var o=document.getElementById('${id}${otherSuffix}'); if(o) o.value=this.value;`;

    let html = '';

    // 1. АВТОМОБИЛИ
    if (state.category === 'авто') {
        html = `
        <div class="fade-in mb-4">
            <p class="text-[10px] font-bold text-[#94a3b8] uppercase mb-2">Марка / Модель</p>
            <div class="relative bg-white/5 rounded-lg border border-white/10">
                <select id="modelSelect${idSuffix}" onchange="${mirror('modelSelect')}" class="w-full bg-transparent text-white text-xs font-bold p-3 outline-none">
                    <option value="all" class="bg-[#0f172a]">Все модели</option>
        
                    <optgroup label="CHEVROLET" class="bg-[#0f172a] text-gray-400">
                        <option value="Chevrolet Cobalt" class="text-white">Cobalt</option>
                        <option value="Chevrolet Nexia" class="text-white">Nexia</option>
                        <option value="Chevrolet Tracker" class="text-white">Tracker</option>
                        <option value="Chevrolet Equinox" class="text-white">Equinox</option>
                    </optgroup>
        
                    <optgroup label="HYUNDAI" class="bg-[#0f172a] text-gray-400">
                        <option value="Hyundai Accent" class="text-white">Accent</option>
                        <option value="Hyundai Elantra" class="text-white">Elantra</option>
                        <option value="Hyundai Sonata" class="text-white">Sonata</option>
                        <option value="Hyundai Tucson" class="text-white">Tucson</option>
                        <option value="Hyundai Santa Fe" class="text-white">Santa Fe</option>
                        <option value="Hyundai Palisade" class="text-white">Palisade</option>
                    </optgroup>
        
                    <optgroup label="KIA" class="bg-[#0f172a] text-gray-400">
                        <option value="Kia Rio" class="text-white">Rio</option>
                        <option value="Kia Cerato" class="text-white">Cerato</option>
                        <option value="Kia K5" class="text-white">K5</option>
                        <option value="Kia Sportage" class="text-white">Sportage</option>
                        <option value="Kia Sorento" class="text-white">Sorento</option>
                    </optgroup>
        
                    <optgroup label="TOYOTA" class="bg-[#0f172a] text-gray-400">
                        <option value="Toyota Camry" class="text-white">Camry</option>
                        <option value="Toyota Corolla" class="text-white">Corolla</option>
                        <option value="Toyota RAV4" class="text-white">RAV4</option>
                        <option value="Toyota Highlander" class="text-white">Highlander</option>
                        <option value="Toyota Land Cruiser Prado" class="text-white">Land Cruiser Prado</option>
                        <option value="Toyota Land Cruiser" class="text-white">Land Cruiser (200/300)</option>
                        <option value="Toyota Hilux" class="text-white">Hilux</option>
                    </optgroup>
        
                    <optgroup label="GEELY" class="bg-[#0f172a] text-gray-400">
                        <option value="Geely Coolray" class="text-white">Coolray</option>
                        <option value="Geely Monjaro" class="text-white">Monjaro</option>
                        <option value="Geely Tugella" class="text-white">Tugella</option>
                    </optgroup>
        
                    <optgroup label="HAVAL" class="bg-[#0f172a] text-gray-400">
                        <option value="Haval Jolion" class="text-white">Jolion</option>
                        <option value="Haval H6" class="text-white">H6</option>
                        <option value="Haval Dargo" class="text-white">Dargo</option>
                    </optgroup>
        
                    <optgroup label="CHERY" class="bg-[#0f172a] text-gray-400">
                        <option value="Chery Tiggo 4 Pro" class="text-white">Tiggo 4 Pro</option>
                        <option value="Chery Tiggo 7 Pro" class="text-white">Tiggo 7 Pro</option>
                        <option value="Chery Tiggo 8 Pro" class="text-white">Tiggo 8 Pro</option>
                    </optgroup>
        
                    <optgroup label="CHANGAN" class="bg-[#0f172a] text-gray-400">
                        <option value="Changan CS35 Plus" class="text-white">CS35 Plus</option>
                        <option value="Changan CS55 Plus" class="text-white">CS55 Plus</option>
                        <option value="Changan UNI-K" class="text-white">UNI-K</option>
                    </optgroup>
        
                    <optgroup label="JAC" class="bg-[#0f172a] text-gray-400">
                        <option value="JAC J7" class="text-white">J7</option>
                        <option value="JAC JS4" class="text-white">JS4</option>
                    </optgroup>
        
                    <optgroup label="LEXUS" class="bg-[#0f172a] text-gray-400">
                        <option value="Lexus ES" class="text-white">ES</option>
                        <option value="Lexus NX" class="text-white">NX</option>
                        <option value="Lexus RX" class="text-white">RX</option>
                        <option value="Lexus LX" class="text-white">LX</option>
                    </optgroup>
        
                    <optgroup label="ZEEKR & LI AUTO" class="bg-[#0f172a] text-gray-400">
                        <option value="Zeekr 001" class="text-white">Zeekr 001</option>
                        <option value="Zeekr X" class="text-white">Zeekr X</option>
                        <option value="Li Auto L7" class="text-white">LiXiang L7</option>
                        <option value="Li Auto L9" class="text-white">LiXiang L9</option>
                    </optgroup>
        
                    <optgroup label="BMW" class="bg-[#0f172a] text-gray-400">
                        <option value="BMW 5 Series" class="text-white">5 Series</option>
                        <option value="BMW X5" class="text-white">X5</option>
                        <option value="BMW X7" class="text-white">X7</option>
                    </optgroup>
        
                    <optgroup label="MERCEDES-BENZ" class="bg-[#0f172a] text-gray-400">
                        <option value="Mercedes-Benz E-Class" class="text-white">E-Class</option>
                        <option value="Mercedes-Benz GLE" class="text-white">GLE</option>
                        <option value="Mercedes-Benz G-Class" class="text-white">G-Class (Geländewagen)</option>
                    </optgroup>
        
                    <optgroup label="VOLKSWAGEN" class="bg-[#0f172a] text-gray-400">
                        <option value="Volkswagen Polo" class="text-white">Polo</option>
                        <option value="Volkswagen Tiguan" class="text-white">Tiguan</option>
                        <option value="Volkswagen Touareg" class="text-white">Touareg</option>
                    </optgroup>
                    
                    <optgroup label="NISSAN" class="bg-[#0f172a] text-gray-400">
                        <option value="Nissan Qashqai" class="text-white">Qashqai</option>
                        <option value="Nissan X-Trail" class="text-white">X-Trail</option>
                        <option value="Nissan Patrol" class="text-white">Patrol</option>
                    </optgroup>
        
                </select>
                <i class="ph-bold ph-caret-down absolute right-3 top-3 text-gray-400 pointer-events-none"></i>
            </div>
        </div>
            <div class="fade-in">
                <p class="text-[10px] font-bold text-[#94a3b8] uppercase mb-2">Год выпуска</p>
                <div class="flex gap-2 items-center">
                    <div class="flex-1 bg-white/5 rounded-lg px-3 py-2 border border-white/10"><input type="number" id="yearMin${idSuffix}" oninput="${mirror('yearMin')}" placeholder="От 2000" class="w-full bg-transparent text-white text-xs font-bold outline-none"></div>
                    <div class="flex-1 bg-white/5 rounded-lg px-3 py-2 border border-white/10"><input type="number" id="yearMax${idSuffix}" oninput="${mirror('yearMax')}" placeholder="До 2026" class="w-full bg-transparent text-white text-xs font-bold outline-none"></div>
                </div>
            </div>`;
    }

    // 2. ЖИЛЬЕ (Квартиры + Дома) -> ЕСТЬ КОМНАТЫ И М²
    else if (['квартиры', 'дома'].includes(state.category)) {
        html = `
            <div class="fade-in mb-4">
                <p class="text-[10px] font-bold text-[#94a3b8] uppercase mb-2">Комнаты</p>
                <div class="flex gap-2 items-center">
                    <div class="flex-1 bg-white/5 rounded-lg px-3 py-2 border border-white/10"><input type="number" id="roomsMin${idSuffix}" oninput="${mirror('roomsMin')}" placeholder="1" class="w-full bg-transparent text-white text-xs font-bold outline-none"></div>
                    <div class="flex-1 bg-white/5 rounded-lg px-3 py-2 border border-white/10"><input type="number" id="roomsMax${idSuffix}" oninput="${mirror('roomsMax')}" placeholder="5" class="w-full bg-transparent text-white text-xs font-bold outline-none"></div>
                </div>
            </div>
            <div class="fade-in">
                <p class="text-[10px] font-bold text-[#94a3b8] uppercase mb-2">Площадь (м²)</p>
                <div class="flex gap-2 items-center">
                    <div class="flex-1 bg-white/5 rounded-lg px-3 py-2 border border-white/10"><input type="number" id="areaMin${idSuffix}" oninput="${mirror('areaMin')}" placeholder="30" class="w-full bg-transparent text-white text-xs font-bold outline-none"></div>
                    <div class="flex-1 bg-white/5 rounded-lg px-3 py-2 border border-white/10"><input type="number" id="areaMax${idSuffix}" oninput="${mirror('areaMax')}" placeholder="200" class="w-full bg-transparent text-white text-xs font-bold outline-none"></div>
                </div>
            </div>`;
    }

    // 3. КОММЕРЦИЯ + ПАРКИНГ -> ТОЛЬКО М²
    else if (['коммерция', 'паркинг'].includes(state.category)) {
        html = `
            <div class="fade-in">
                <p class="text-[10px] font-bold text-[#94a3b8] uppercase mb-2">Площадь (м²)</p>
                <div class="flex gap-2 items-center">
                    <div class="flex-1 bg-white/5 rounded-lg px-3 py-2 border border-white/10"><input type="number" id="areaMin${idSuffix}" oninput="${mirror('areaMin')}" placeholder="15" class="w-full bg-transparent text-white text-xs font-bold outline-none"></div>
                    <div class="flex-1 bg-white/5 rounded-lg px-3 py-2 border border-white/10"><input type="number" id="areaMax${idSuffix}" oninput="${mirror('areaMax')}" placeholder="500" class="w-full bg-transparent text-white text-xs font-bold outline-none"></div>
                </div>
            </div>`;
    }

    // 4. ЗЕМЛЯ -> ГЕКТАРЫ / СОТКИ
    else if (state.category === 'участки') {
        html = `
            <div class="fade-in">
                <p class="text-[10px] font-bold text-[#94a3b8] uppercase mb-2">Площадь (га)</p>
                <div class="flex gap-2 items-center">
                    <div class="flex-1 bg-white/5 rounded-lg px-3 py-2 border border-white/10"><input type="number" id="areaMin${idSuffix}" oninput="${mirror('areaMin')}" placeholder="0.05" step="0.01" class="w-full bg-transparent text-white text-xs font-bold outline-none"></div>
                    <div class="flex-1 bg-white/5 rounded-lg px-3 py-2 border border-white/10"><input type="number" id="areaMax${idSuffix}" oninput="${mirror('areaMax')}" placeholder="100" step="0.01" class="w-full bg-transparent text-white text-xs font-bold outline-none"></div>
                </div>
                <p class="text-[9px] text-[#94a3b8] mt-1.5 ml-1">* 1 га = 100 соток (0.1 га = 10 соток)</p>
            </div>`;
    }

    if(html) {
        container.classList.remove('hidden');
        container.innerHTML = html;
    } else {
        container.classList.add('hidden');
    }

    // Пересчёт высоты мобильного аккордеона — только для мобильной копии
    // (idSuffix==''): десктопная колонка не аккордеон, .open у неё не бывает.
    if (idSuffix === '' && document.getElementById('filterPanel').classList.contains('open')) {
        toggleFilters(true);
    }
}

window.toggleFilters = (forceClose = false) => {
    const p = document.getElementById('filterPanel');
    const b = document.getElementById('filterToggleBtn');
    const s = document.getElementById('headerSpacer');
    const h = document.getElementById('mainHeader');
    // ИСПРАВЛЕНИЕ РЕГРЕССА (05.09.2026, см. style.css у #filterPanelActions):
    // кнопки "Применить"/"Сохранить" — теперь СОСЕД #filterPanel, а не его
    // ребёнок, поэтому свою видимость сами не наследуют — держим класс .open
    // в синхроне вручную.
    const actions = document.getElementById('filterPanelActions');

    // Исправленная логика принудительного закрытия
    if (forceClose) {
        p.classList.remove('open');
        if (actions) actions.classList.remove('open');
    } else {
        p.classList.toggle('open');
        if (actions) actions.classList.toggle('open', p.classList.contains('open'));
    }

    // D2 (DESIGN_UPGRADE_PROMPT.md §5.1, аудит "пробел на 768px"): спейсер
    // резервирует место только когда шапка реально position:fixed (узкий
    // экран, см. @media(max-width:639px) в style.css). На 640–1023px —
    // планшет/узкое окно без ещё не появившегося (≥1024px) десктопного
    // сайдбара — шапка уже обычный блок в потоке, и лишний спейсер поверх
    // нёс собственную высоту так же, как #mainHeader ниже "пробел на
    // телефоне" (тот же баг, что чинили 03.09.2026, только в другом
    // диапазоне ширины — тогда чинили только <640px).
    const headerIsFixed = getComputedStyle(h).position === 'fixed';
    if (p.classList.contains('open')) {
        b.classList.add('bg-blue-600', 'border-blue-600');
        if (headerIsFixed) {
            setTimeout(() => { s.style.height = (h.offsetHeight + 20) + 'px' }, 50);
            s.style.height = (230 + p.scrollHeight + (state.category !== 'all' ? 50 : 0)) + 'px';
        } else {
            s.style.height = '0px';
        }

        // 🔥 МАГИЯ СКРОЛЛА: Блокируем фон, разрешаем скролл меню
        document.body.style.overflow = 'hidden';
        h.style.maxHeight = '100vh';
        h.style.overflowY = 'auto';
        h.style.overscrollBehavior = 'contain'; // Предотвращает "цепляние" фона
    } else {
        b.classList.remove('bg-blue-600', 'border-blue-600');
        s.style.height = headerIsFixed ? '230px' : '0px';
        // НАЙДЕНО (жалоба "с телефона появился пробел", 03.09.2026), ПЕРВАЯ
        // ПОПЫТКА ЧИНИТЬ (не сработала на реальном устройстве): здесь стоял
        // setTimeout(...,450) — предположение, что 0.4s CSS-transition
        // .filter-panel-inline (см. style.css) плюс небольшой запас хватит,
        // чтобы поймать реальную закрытую высоту шапки вместо захардкоженных
        // "230px". Пользователь подтвердил, что зазор остался — и что он
        // никогда не зависел от открытия/закрытия панели, а виден по
        // умолчанию на всех вкладках, включая те, где этой панели вообще нет.
        // Более точная причина (см. watchHeaderSpacer() в window.onload
        // ниже): единоразовый замер offsetHeight в любой фиксированной
        // точке времени (будь то 50мс, 450мс или 600мс) — в принципе
        // ненадёжен, потому что момент, когда высота шапки на РЕАЛЬНОМ
        // мобильном устройстве окончательно стабилизируется (иконочный
        // шрифт с CDN грузится асинхронно, window.onload его не ждёт),
        // заранее не известен и на медленной сети может быть больше любой
        // разумной задержки. Правильная замена таймеру — ResizeObserver,
        // который сам реагирует на любое изменение реальной высоты
        // #mainHeader, когда бы оно ни случилось (в т.ч. и здесь, при
        // закрытии панели — сама шапка физически содержит панель фильтров
        // внутри себя, поэтому его срабатывания достаточно и тут, отдельный
        // вызов не нужен).

        // 🔥 Возвращаем скролл фону
        document.body.style.overflow = '';
        h.style.maxHeight = '';
        h.style.overflowY = '';
        h.style.overscrollBehavior = '';
    }
}

window.selectSort = (v,b) => {
    state.sort = v;
    // Обычная сортировка (дата/цена) выключает режим "Рядом со мной" —
    // бэкенд всё равно бы её проигнорировал, пока near_lat/near_lon в
    // запросе, так что явно синхронизируем UI-состояние.
    state.nearMe = false;
    document.querySelectorAll('.sort-btn').forEach(x => {
        x.classList.remove('active','bg-[#A16207]','text-white','border-[#A16207]');
        x.classList.add('bg-white/5','text-gray-400');
    });
    // ИЗМЕНЕНО (TASK4 4.2): b — необязателен. Мобильные кнопки (.sort-btn,
    // #filterPanel) по-прежнему зовут selectSort(v, this) и красят себя;
    // десктопный дропдаун тулбара зовёт selectSort(v, null) из
    // window.selectHomeSort() ниже — красить нечего, там обычный <select>.
    if (b) {
        b.classList.remove('bg-white/5','text-gray-400');
        b.classList.add('active','bg-[#A16207]','text-white','border-[#A16207]');
    }
    syncHomeSortSelect();
}

// ДОБАВЛЕНО (TASK4 4.2, DESIGN_MASTER_PROMPT.md §7.9/TASK4_HOME_PROMPT.md
// §2): держит #homeSortSelectDesktop (дропдаун тулбара) в синхроне с
// текущим state.sort/state.nearMe — вызывается из selectSort() и из
// активации "Рядом со мной" (мобильной и десктопной), чтобы значение в
// дропдауне не расходилось с реальной сортировкой списка, даже если она
// была выставлена не самим дропдауном (например, мобильной кнопкой при
// смене ширины окна). Узла нет вне сайта/десктопа — тихо выходит.
// Владелец, 2026-10-29 (вариант 3): фильтры Главной — в адресе страницы (только сайт, /workspace), чтобы поиском можно
// было поделиться ссылкой и «Назад» с лота возвращал тот же список. replaceState — без лишних записей в истории.
// Ключи: q, cat, site, region, type, min, max, sort; значение по умолчанию в адрес не пишется.
const HOME_URL_SORTS = ['date_desc', 'price_asc', 'price_desc'];
function homeFiltersInUrl() {
    return !IS_TELEGRAM && window.location.pathname === '/workspace';
}
function syncHomeFiltersToUrl() {
    if (!homeFiltersInUrl()) return;
    const q = new URLSearchParams();
    if (state.query) q.set('q', state.query);
    if (state.category && state.category !== 'all') q.set('cat', state.category);
    if (state.site && state.site !== 'all') q.set('site', state.site);
    if (state.region && state.region !== 'all') q.set('region', state.region);
    if (state.auctionType && state.auctionType !== 'all') q.set('type', state.auctionType);
    if (state.minPrice) q.set('min', state.minPrice);
    if (state.maxPrice) q.set('max', state.maxPrice);
    if (state.sort && state.sort !== 'date_desc' && HOME_URL_SORTS.includes(state.sort)) q.set('sort', state.sort);
    const qs = q.toString();
    const next = '/workspace' + (qs ? '?' + qs : '') + window.location.hash;
    if (next !== window.location.pathname + window.location.search + window.location.hash) history.replaceState(history.state, '', next);
}
// Обратное направление — один раз при загрузке, до первого loadLots(). Кнопки категорий/площадок красятся теми же
// классами, что ставят setCategory()/setSite(); поля — и мобильная, и десктопная копия.
function restoreHomeFiltersFromUrl() {
    if (!homeFiltersInUrl() || !window.location.search) return;
    const q = new URLSearchParams(window.location.search);
    const setVal = (ids, v) => ids.forEach((id) => { const el = document.getElementById(id); if (el) el.value = v; });
    const paint = (selector, value, onCls, offCls) => {
        const btns = [...document.querySelectorAll(selector)];
        const hit = btns.filter((b) => (b.getAttribute('onclick') || '').includes(`('${value}'`));
        if (!hit.length) return false;
        btns.forEach((b) => { b.className = offCls; });
        hit.forEach((b) => { b.className = onCls; });
        return true;
    };
    const cat = q.get('cat');
    if (cat && paint('.cat-btn', cat,
        'whitespace-nowrap px-4 py-1.5 rounded-full text-xs font-bold bg-accent text-accent-ink transition-all cat-btn',
        'whitespace-nowrap px-4 py-1.5 rounded-full text-xs font-bold bg-white/5 text-gray-300 border border-white/5 transition-all cat-btn')) {
        state.category = cat;
        updateDynamicFilters();
        updateDynamicFilters('Desktop');
    }
    const site = q.get('site');
    if (site && paint('.site-btn', site,
        'flex-1 py-1.5 text-xs font-bold rounded-full bg-white/10 text-white shadow-sm transition-all site-btn active',
        'flex-1 py-1.5 text-xs font-bold rounded-full text-gray-400 hover:text-white transition-all site-btn')) state.site = site;
    if (q.get('q')) { state.query = q.get('q'); setVal(['searchInput', 'searchInputDesktop'], state.query); }
    const type = q.get('type');
    if (type === 'down' || type === 'up') { state.auctionType = type; setVal(['auctionTypeSelect', 'auctionTypeSelectDesktop'], type); }
    const num = (k) => { const n = parseInt(q.get(k), 10); return Number.isFinite(n) && n > 0 ? n : null; };
    if (num('min')) { state.minPrice = num('min'); setVal(['minPrice', 'minPriceDesktop'], state.minPrice); }
    if (num('max')) { state.maxPrice = num('max'); setVal(['maxPrice', 'maxPriceDesktop'], state.maxPrice); }
    if (q.get('region')) state.region = q.get('region');   // the select gets its options from loadRegions(), which keeps it
    if (HOME_URL_SORTS.includes(q.get('sort'))) { state.sort = q.get('sort'); syncHomeSortSelect(); }
}

function syncHomeSortSelect() {
    const sel = document.getElementById('homeSortSelectDesktop');
    if (!sel) return;
    sel.value = state.nearMe ? 'near_me' : state.sort;
}

// ДОБАВЛЕНО (TASK4 4.2, §2): единственный обработчик дропдауна сортировки
// тулбара. «Ближе ко мне» — та же геолокация, что и у мобильной кнопки
// selectSortNearMe() (см. ниже), но без кнопки для покраски (b=null путь
// там не годится — b.disabled/b.classList требуют элемент); при отказе/
// ошибке возвращает дропдаун к прежнему значению, а не оставляет его на
// недостигнутой "Ближе ко мне". Как и setSite()/setCategory() в этом же
// тулбаре — применяется мгновенно, без кнопки "Применить".
window.selectHomeSort = (sel) => {
    const v = sel.value;
    if (v === 'near_me') {
        if (!navigator.geolocation) {
            tg.showAlert('Геолокация не поддерживается этим устройством/браузером.');
            syncHomeSortSelect();
            return;
        }
        const activate = () => {
            document.querySelectorAll('.sort-btn').forEach(x => {
                x.classList.remove('active','bg-[#A16207]','text-white','border-[#A16207]');
                x.classList.add('bg-white/5','text-gray-400');
            });
            state.nearMe = true;
            loadLots();
        };
        if (userGeoCoords) { activate(); return; }
        sel.disabled = true;
        navigator.geolocation.getCurrentPosition(
            (pos) => {
                userGeoCoords = { lat: pos.coords.latitude, lon: pos.coords.longitude };
                activate();
                sel.disabled = false;
            },
            (err) => {
                console.warn('[selectHomeSort]', err);
                tg.showAlert('Не удалось получить вашу геолокацию. Проверьте разрешения и попробуйте снова.');
                sel.disabled = false;
                syncHomeSortSelect();
            },
            { enableHighAccuracy: false, timeout: 10000, maximumAge: 5 * 60 * 1000 }
        );
        return;
    }
    selectSort(v, null);
    loadLots();
};

// ДОБАВЛЕНО (TASK4 4.7, §7: "click-to-sort on price/date — as in «База AI»"):
// тот же паттерн переключения, что setFavTableSort()/setGlobalTableSort() —
// клик по заголовку колонки инвертирует направление и держит выпадающий
// список тулбара (selectHomeSort()) в синхроне через уже существующую
// syncHomeSortSelect() (4.2/4.3), а не отдельную копию логики.
//
// Только price — "дата" колонки в Home-таблице нет вовсе (§7 задаёт колонки
// как thumb/title/site/price/region/deadline/verdict, без отдельной "дата
// публикации"); deadline — application_deadline, backend НЕ поддерживает
// sort_by по нему (проверено в postgres_client.py::get_filtered_lots —
// только price_asc/price_desc/score_*, ELSE — всегда publication_date DESC
// вне зависимости от переданного значения; то же ограничение, из-за
// которого в 4.2 пропущена сортировка «Скоро закрытие», TASK4 §12 — новых
// параметров backend не заводим). Заголовок колонки "Срок" остаётся
// некликабельным — честно, а не молчаливый no-op при клике.
window.setHomeTableSort = (mode) => {
    state.sort = mode;
    state.nearMe = false;
    syncHomeSortSelect();
    loadLots();
};

// "Рядом со мной" как режим сортировки основного списка лотов (Фаза 4,
// геокодирование). Технически отдельный флаг state.nearMe, а не значение
// state.sort — см. комментарий у объявления state. При первом клике
// запрашивает геолокацию (как requestNearMe() для карты, но независимо от
// неё — координаты кэшируются в той же userGeoCoords, чтобы не спрашивать
// разрешение дважды, если пользователь потом откроет карту).
window.selectSortNearMe = (b) => {
    if (!navigator.geolocation) {
        tg.showAlert('Геолокация не поддерживается этим устройством/браузером.');
        return;
    }

    const activateButton = () => {
        document.querySelectorAll('.sort-btn').forEach(x => {
            x.classList.remove('active','bg-[#A16207]','text-white','border-[#A16207]');
            x.classList.add('bg-white/5','text-gray-400');
        });
        b.classList.remove('bg-white/5','text-gray-400');
        b.classList.add('active','bg-[#A16207]','text-white','border-[#A16207]');
        // ДОБАВЛЕНО (P3.2 аудита): mirrorGButtonState() здесь, а не в onclick
        // рядом с вызовом selectSortNearMe(this) (как у остальных кнопок
        // сортировки), — геолокация асинхронна (см. getCurrentPosition ниже),
        // а активный класс выставляется именно тут, внутри колбэка. Вызов
        // сразу после selectSortNearMe(this) скопировал бы на "близнеца" ещё
        // не обновлённый (устаревший) класс.
        mirrorGButtonState(b, 'sort-btn');
        // TASK4 4.2 — мобильная кнопка "Рядом" тоже держит дропдаун тулбара
        // в синхроне (см. syncHomeSortSelect() выше), на случай активации на
        // мобильной ширине с последующим расширением окна до десктопа.
        syncHomeSortSelect();
    };

    // Координаты уже есть (например, пользователь ранее открывал карту и
    // жал "Рядом со мной" там) — не спрашиваем геолокацию заново.
    if (userGeoCoords) {
        state.nearMe = true;
        activateButton();
        return;
    }

    b.disabled = true;
    navigator.geolocation.getCurrentPosition(
        (pos) => {
            userGeoCoords = { lat: pos.coords.latitude, lon: pos.coords.longitude };
            state.nearMe = true;
            activateButton();
            b.disabled = false;
        },
        (err) => {
            console.warn('[selectSortNearMe]', err);
            tg.showAlert('Не удалось получить вашу геолокацию. Проверьте разрешения и попробуйте снова.');
            b.disabled = false;
        },
        { enableHighAccuracy: false, timeout: 10000, maximumAge: 5 * 60 * 1000 }
    );
}

window.applyFilters = () => {
    // 1. Базовые
    const min = document.getElementById('minPrice').value;
    const max = document.getElementById('maxPrice').value;
    state.minPrice = min ? parseInt(min) : null;
    state.maxPrice = max ? parseInt(max) : null;
    state.region = document.getElementById('regionSelect').value;
    state.auctionType = document.getElementById('auctionTypeSelect') ? document.getElementById('auctionTypeSelect').value : 'all';
    
    // Сброс
    state.yearMin = state.yearMax = state.roomsMin = state.roomsMax = state.areaMin = state.areaMax = null;
    state.model = 'all';
    
    // 2. АВТО
    if (state.category === 'авто') {
        const yMin = document.getElementById('yearMin')?.value;
        const yMax = document.getElementById('yearMax')?.value;
        state.yearMin = yMin ? parseInt(yMin) : null;
        state.yearMax = yMax ? parseInt(yMax) : null;
        state.model = document.getElementById('modelSelect')?.value || 'all';
    }
    
    // 3. ВСЯ НЕДВИЖИМОСТЬ КРОМЕ ЗЕМЛИ (Метры)
    else if (['квартиры', 'дома', 'коммерция', 'паркинг'].includes(state.category)) {
        const aMin = document.getElementById('areaMin')?.value;
        const aMax = document.getElementById('areaMax')?.value;
        state.areaMin = aMin ? parseFloat(aMin) : null;
        state.areaMax = aMax ? parseFloat(aMax) : null;

        if (['квартиры', 'дома'].includes(state.category)) {
            const rMin = document.getElementById('roomsMin')?.value;
            const rMax = document.getElementById('roomsMax')?.value;
            state.roomsMin = rMin ? parseInt(rMin) : null;
            state.roomsMax = rMax ? parseInt(rMax) : null;
        }
    }
    
    // 4. ЗЕМЛЯ (Гектары)
    else if (state.category === 'участки') {
        const aMin = document.getElementById('areaMin')?.value;
        const aMax = document.getElementById('areaMax')?.value;
        state.areaMin = aMin ? parseFloat(aMin) : null;
        state.areaMax = aMax ? parseFloat(aMax) : null;
    }
    
    toggleFilters(true); // 🔥 Явно передаем true, чтобы принудительно закрыть
    loadLots();
    updateRailResetLabel(); // TASK4 4.3, §3 п.6 — держит «Сбросить · N» в синхроне с реальным состоянием рейла
}

// ДОБАВЛЕНО (TASK4 4.3, DESIGN_MASTER_PROMPT.md §7.8, TASK4_HOME_PROMPT.md
// §3 п.6): сколько ПОЛЕЙ РЕЙЛА реально активны — категория/площадка сюда
// не входят (они больше не часть рейла, живут в тулбаре/строке категорий,
// §2/§3), у них свой визуальный статус (активная пилюля/сегмент). Один
// источник правды для подписи «Сбросить · N» в футере рейла и, позже,
// для пустого состояния §9 (переиспользует ту же функцию).
function countActiveRailFilters() {
    let n = 0;
    if (state.query) n++;
    if (state.region && state.region !== 'all') n++;
    if (state.auctionType && state.auctionType !== 'all') n++;
    if (state.minPrice) n++;
    if (state.maxPrice) n++;
    if (state.yearMin) n++;
    if (state.yearMax) n++;
    if (state.roomsMin) n++;
    if (state.roomsMax) n++;
    if (state.areaMin) n++;
    if (state.areaMax) n++;
    if (state.model && state.model !== 'all') n++;
    return n;
}

function updateRailResetLabel() {
    const btn = document.getElementById('railResetBtn');
    if (!btn) return; // Mini App/мобильный — рейла нет вовсе
    const n = countActiveRailFilters();
    if (n > 0) {
        btn.textContent = `Сбросить · ${n}`;
        btn.classList.remove('hidden');
    } else {
        btn.classList.add('hidden');
    }
}

// ДОБАВЛЕНО (TASK4 4.3, §3 п.6): сброс ТОЛЬКО полей рейла (поиск/регион/
// тип торгов/цена/динамические поля категории) — категорию и площадку не
// трогает, это больше не рейл (см. countActiveRailFilters() выше).
// Программная установка .value НЕ порождает событие input/change (значит,
// зеркалирование между мобильной/десктопной копией здесь не сработает само
// собой) — поэтому чистим обе копии каждого поля явно, а не одну
// каноническую. applyFilters() в конце сам нормализует state и перезагрузит
// список — тот же путь, что и у любого другого инстант-изменения рейла.
window.resetFilters = () => {
    ['searchInput', 'searchInputDesktop'].forEach(id => { const el = document.getElementById(id); if (el) el.value = ''; });
    state.query = '';
    ['minPrice', 'minPriceDesktop', 'maxPrice', 'maxPriceDesktop'].forEach(id => { const el = document.getElementById(id); if (el) el.value = ''; });
    ['regionSelect', 'regionSelectDesktop'].forEach(id => { const el = document.getElementById(id); if (el) el.value = 'all'; });
    ['auctionTypeSelect', 'auctionTypeSelectDesktop'].forEach(id => { const el = document.getElementById(id); if (el) el.value = 'all'; });
    [
        'yearMin', 'yearMinDesktop', 'yearMax', 'yearMaxDesktop',
        'roomsMin', 'roomsMinDesktop', 'roomsMax', 'roomsMaxDesktop',
        'areaMin', 'areaMinDesktop', 'areaMax', 'areaMaxDesktop',
    ].forEach(id => { const el = document.getElementById(id); if (el) el.value = ''; });
    ['modelSelect', 'modelSelectDesktop'].forEach(id => { const el = document.getElementById(id); if (el) el.value = 'all'; });
    applyFilters();
};

// ДОБАВЛЕНО (TASK4 4.3, DESIGN_MASTER_PROMPT.md §7.8, TASK4_HOME_PROMPT.md
// §3): инстант-применение рейла на десктопе — один делегированный
// listener на #homeFilterRailScroll вместо отдельного обработчика на
// каждое поле. Ловит и статичные поля разметки (регион/тип/цена), и те,
// что updateDynamicFilters() генерирует ПОЗЖЕ (год/комнаты/площадь/марка) —
// делегирование работает и для узлов, которых ещё не было в DOM на
// момент навешивания слушателя. #searchInputDesktop исключён явно: у
// поиска свой, более старый и уже рабочий инстант-путь (см. слушатель на
// #searchInput ниже по файлу) — applyFilters() вообще не читает текст
// поиска, дублировать его через этот путь означало бы два запроса на
// каждое нажатие клавиши вместо одного. Кнопка «Применить фильтры» в
// рейле больше не рендерится (см. home_desktop.html::render_actions()) —
// этот путь единственный. Мобильный #filterPanel/#filterPanelActions не
// затронут (другой контейнер, другой обработчик) — TASK4 §12.
let desktopFilterApplyTimeout = null;
function initDesktopInstantFilters() {
    const scroll = document.getElementById('homeFilterRailScroll');
    if (!scroll) return; // Mini App/мобильный — колонки нет вовсе
    scroll.addEventListener('change', (e) => {
        if (e.target.id === 'searchInputDesktop') return;
        if (e.target.matches('select, input[type="checkbox"]')) applyFilters();
    });
    scroll.addEventListener('input', (e) => {
        if (e.target.id === 'searchInputDesktop') return;
        if (e.target.matches('input[type="number"], input[type="text"]')) {
            clearTimeout(desktopFilterApplyTimeout);
            desktopFilterApplyTimeout = setTimeout(() => applyFilters(), 300);
        }
    });
}

// --- Фаза 4: сохранённые фильтры + уведомления о новых лотах ---

function describeFilterState() {
    const parts = [];
    const catNames = {
        'авто': 'Авто', 'квартиры': 'Квартиры', 'дома': 'Дома',
        'коммерция': 'Коммерция', 'паркинг': 'Паркинг', 'участки': 'Участки', 'прочее': 'Прочее'
    };
    parts.push(catNames[state.category] || 'Все категории');
    if (state.region && state.region !== 'all') {
        const regionText = document.getElementById('regionSelect')?.selectedOptions?.[0]?.text;
        parts.push(regionText || state.region);
    }
    if (state.minPrice || state.maxPrice) {
        const min = state.minPrice ? formatMoney(state.minPrice) : '0';
        const max = state.maxPrice ? formatMoney(state.maxPrice) : '∞';
        parts.push(`${min}–${max} ₸`);
    }
    return parts.join(', ');
}

// Универсальный "замок" для кнопок с асинхронным действием: подменяет
// содержимое на спиннер и блокирует повторный клик, пока запрос не завершится
// (без этого при двойном тапе на медленной сети уходило 2 запроса подряд —
// например, дублирующийся сохранённый фильтр или повторное списание промокода).
async function withButtonBusy(btn, label, action) {
    if (!btn || btn.dataset.busy === '1') return;
    const originalHtml = btn.innerHTML;
    btn.dataset.busy = '1';
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    btn.innerHTML = `<div class="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"></div><span>${label}</span>`;
    try {
        await action();
    } finally {
        btn.innerHTML = originalHtml;
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
        delete btn.dataset.busy;
    }
}

window.saveCurrentFilter = async (btnEl) => {
    applyFilters(); // нормализует state из полей формы (и заодно закрывает панель/грузит список)

    const payload = {
        user_id: userId,
        name: describeFilterState(),
        site: state.site, category: state.category, query_text: state.query || '',
        min_price: state.minPrice, max_price: state.maxPrice,
        region: (state.region && state.region !== 'all') ? state.region : null,
        auction_type: state.auctionType || 'all',
        year_min: state.yearMin, year_max: state.yearMax,
        rooms_min: state.roomsMin, rooms_max: state.roomsMax,
        area_min: state.areaMin, area_max: state.areaMax,
        model: (state.model && state.model !== 'all') ? state.model : null,
    };

    try {
        await withButtonBusy(btnEl, 'Сохранение...', async () => {
            const r = await fetch('/api/filters', {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify(payload)
            });
            const d = await r.json();
            if (!r.ok) {
                tg.showAlert(d.detail || "Не удалось сохранить фильтр");
                return;
            }
            tg.HapticFeedback.notificationOccurred('success');
            tg.showAlert(`Фильтр сохранён: «${payload.name}». Пришлём уведомление, когда появится подходящий лот.`);
            loadScenarioChips(); // D5 — новый сценарий должен появиться в строке чипов сразу, без перезагрузки страницы
        });
    } catch (e) {
        console.error('[saveCurrentFilter]', e);
        tg.showAlert("Ошибка сети при сохранении фильтра");
    }
};

window.openSavedFiltersModal = async () => {
    document.getElementById('savedFiltersModal').classList.add('open');
    tg.BackButton.show();
    await loadSavedFilters();
};

window.closeSavedFiltersModal = () => {
    document.getElementById('savedFiltersModal').classList.remove('open');
    tg.BackButton.hide();
};

// D5 (DESIGN_UPGRADE_PROMPT.md §6, "Мои сценарии"): та же самая коллекция
// сохранённых фильтров (см. loadSavedFilters()/renderSavedFilters() выше),
// просто ещё и в виде строки чипов под тулбаром Главной — без этого они были
// видны только внутри #savedFiltersModal за иконкой-колокольчиком. Отдельный
// fetch (не переиспользует loadSavedFilters()) — тот безусловно перезаписывает
// #savedFiltersList и требует, чтобы модалка была в DOM с этим id; здесь своя,
// независимая цель (#scenarioChipsRow), тот же дешёвый GET /api/filters.
let scenarioChipsCache = [];
async function loadScenarioChips() {
    if (!userId) return;
    try {
        const r = await fetch(`/api/filters?user_id=${userId}`);
        if (!r.ok) throw new Error(`HTTP ${r.status}`);
        scenarioChipsCache = await r.json();
        renderScenarioChips();
    } catch (e) {
        console.error('[loadScenarioChips]', e);
        // Молча ничего не показываем — то же решение, что и у
        // gPaywallCount/loadGlobalPaywallCount: не заведомо пустой/неверный
        // блок, а просто отсутствие необязательного украшения тулбара.
    }
}

function renderScenarioChips() {
    const row = document.getElementById('scenarioChipsRow');
    const list = document.getElementById('scenarioChipsList');
    if (!row || !list) return;
    if (!scenarioChipsCache.length) {
        row.classList.add('hidden');
        return;
    }
    row.classList.remove('hidden');
    list.innerHTML = scenarioChipsCache.map(f => `
        <button type="button" class="scenario-chip" data-filter-id="${f.id}" onclick="applySavedFilter(${f.id})">
            ${escapeHtml(f.name || 'Без названия')}
        </button>
    `).join('');
}

// Реальные значения фильтра — SELECT * из user_saved_filters (см.
// get_saved_filters() в postgres_client.py), те же ключи, что и в payload
// saveCurrentFilter() ниже по коду, просто в обратную сторону.
window.applySavedFilter = (filterId) => {
    const f = scenarioChipsCache.find(x => x.id === filterId);
    if (!f) return;

    state.site = f.site || 'all';
    state.category = f.category || 'all';
    state.query = f.query_text || '';
    state.minPrice = f.min_price ?? null;
    state.maxPrice = f.max_price ?? null;
    state.region = f.region || 'all';
    state.auctionType = f.auction_type || 'all';
    state.yearMin = f.year_min ?? null;
    state.yearMax = f.year_max ?? null;
    state.roomsMin = f.rooms_min ?? null;
    state.roomsMax = f.rooms_max ?? null;
    state.areaMin = f.area_min ?? null;
    state.areaMax = f.area_max ?? null;
    state.model = f.model || 'all';

    // Видимая синхронизация — только простые, безопасные для прямой записи
    // поля (поиск/цена), тем же приёмом .value=, что и десктопные зеркала
    // (P3.2 аудита). Категория/площадка — набор кнопок в НЕСКОЛЬКИХ копиях
    // (мобильная + десктопная колонка, см. home_desktop.html), красим все
    // разом по значению в onclick, а не полагаемся на setCategory()/setSite()
    // с фиктивным "this" — та функция красит только один переданный элемент.
    ['searchInput', 'searchInputDesktop'].forEach(id => {
        const el = document.getElementById(id);
        if (el) el.value = state.query;
    });
    ['minPrice', 'minPriceDesktop'].forEach(id => {
        const el = document.getElementById(id);
        if (el) el.value = state.minPrice ?? '';
    });
    ['maxPrice', 'maxPriceDesktop'].forEach(id => {
        const el = document.getElementById(id);
        if (el) el.value = state.maxPrice ?? '';
    });
    document.querySelectorAll('.cat-btn').forEach(btn => {
        const m = (btn.getAttribute('onclick') || '').match(/setCategory\('([^']*)'/);
        if (!m) return;
        const isActive = m[1] === state.category;
        btn.className = isActive
            ? "whitespace-nowrap px-4 py-1.5 rounded-full text-xs font-bold bg-accent text-accent-ink transition-all cat-btn"
            : "whitespace-nowrap px-4 py-1.5 rounded-full text-xs font-bold bg-white/5 text-gray-300 border border-white/5 transition-all cat-btn";
    });
    document.querySelectorAll('.site-btn').forEach(btn => {
        const m = (btn.getAttribute('onclick') || '').match(/setSite\('([^']*)'/);
        if (!m) return;
        const isActive = m[1] === state.site;
        btn.className = isActive
            ? "flex-1 py-1.5 text-xs font-bold rounded-full bg-white/10 text-white shadow-sm transition-all site-btn active"
            : "flex-1 py-1.5 text-xs font-bold rounded-full text-gray-400 hover:text-white transition-all site-btn";
    });

    document.querySelectorAll('.scenario-chip').forEach(chip => {
        chip.classList.toggle('active', Number(chip.dataset.filterId) === filterId);
    });

    tg.HapticFeedback.selectionChanged();
    loadLots();
};

// «Первые шаги» (D8 onboarding checklist) removed 2026-10-28 by the owner.

// =======================================================
// 🗺️ КАРТА ЛОТОВ — 2026-10-28 (owner): MapLibre + OpenFreeMap, список, слои
// =======================================================
// Только активная недвижимость в её собственной точке (lots.lat/lon = участок
// НИПД/ЕГКН или объект jerler, bot/geo/coords.py; Яндекс Геокодер выключен —
// он складывал лоты в центр города). Одно содержимое на обе площадки
// (partials/lots_map_body.html): на сайте — страница /workspace/map (адрес
// хранит фильтры и область, §5.6), в Mini App — модалка на весь экран.
//
// Данные карты — один запрос /api/map/lots (места, контуры, лоты без точки,
// bot/geo/lots_map.py). Рядом с картой — список лотов в видимой области (или
// одного места после клика по нему): компактные строки (фото, название, номер
// помещения и площадь, срок, цена) — все поля уже в данных карты, второго
// запроса нет. Наведение на строку подсвечивает точку и наоборот. Слои — те же госслои, что у карты участка в отчёте (GEO_MAP_LAYERS
// через наш прокси /api/geo/tile), включаются с масштаба района.

let lotsMap = null;                 // maplibregl.Map, создаётся один раз
let lotsMapData = null;             // ответ /api/map/lots
let lotsMapDataAt = 0;
let lotsMapUserMarker = null;
let userGeoCoords = null;           // {lat, lon} — после геолокации; общая с «рядом со мной» каталога
let lotsMapFocusKey = null;         // "lat,lon" места, чьи лоты сейчас в списке (клик по точке), иначе — вся видимая область
let lotsMapListLots = [];           // лоты списка в порядке сортировки
let lotsMapListShown = 0;           // сколько карточек уже нарисовано
let lotsMapHoverPid = null;
let lotsMapPopup = null;
const LOTS_MAP_DATA_TTL_MS = 60 * 1000;
const LOTS_MAP_KZ_BOUNDS = [[46.4, 40.5], [87.4, 55.5]];
const LOTS_MAP_PAGE = 24;           // карточек за раз («Показать ещё»)
const LOTS_MAP_ASTANA = [71.15, 50.95, 71.75, 51.35];   // где предлагать слои ГИС Астаны (w, s, e, n)

// Статус анализа -> цвет точки (данные, не украшение: §5.2). Не проанализирован — нейтральный --info.
function lotsMapStatus(l) {
    if (!isRecAnalyzed(l.recommendation_status, l.recommendation_score)) return 'none';
    const cls = getRecBadgeData(l.recommendation_status, l.recommendation_score).class;
    return cls === 'rec-green' ? 'pos' : (cls === 'rec-red' ? 'neg' : 'warn');
}

const lotsMapPlaceKey = (p) => `${p.lat},${p.lon}`;

function lotsMapGeojson(places) {
    return {
        type: 'FeatureCollection',
        features: places.map((p, i) => {
            const n = p.lots.length;
            const one = p.lots[0];
            return {
                type: 'Feature',
                geometry: { type: 'Point', coordinates: [p.lon, p.lat] },
                properties: {
                    pid: i, n, approx: p.approx ? 1 : 0,
                    status: n === 1 ? lotsMapStatus(one) : 'none',
                    label: n === 1 ? (compactPriceKzt(one.start_price) || 'Лот') : `${n} ${pluralizeRu(n, 'лот', 'лота', 'лотов')}`,
                },
            };
        }),
    };
}

// ---- свои фильтры карты (не каталога): категория, площадка, тип торгов, цена, срок подачи ----
const LOTS_MAP_FILTERS_KEY = 'ad_map_filters_v1';
const LOTS_MAP_FILTERS_DEFAULT = { cat: 'all', deal: 'all', site: 'all', trade: 'all', min: null, max: null, deadline: 'all', sort: 'new' };
const LOTS_MAP_CATEGORIES = [['all', 'Все'], ['участки', 'Участки'], ['квартиры', 'Квартиры'], ['дома', 'Дома'],
                             ['коммерция', 'Коммерция'], ['паркинг', 'Паркинг'], ['Прочее', 'Прочее']];
let lotsMapFilters = { ...LOTS_MAP_FILTERS_DEFAULT };
let lotsMapVisible = [];           // места, прошедшие фильтры — их индексы = pid точки
let lotsMapPidByLot = new Map();   // id лота -> pid его места (подсветка из списка)
let lotsMapFiltersBound = false;
try { lotsMapFilters = { ...LOTS_MAP_FILTERS_DEFAULT, ...JSON.parse(localStorage.getItem(LOTS_MAP_FILTERS_KEY) || '{}') }; } catch (e) { /* приватный режим */ }

function saveLotsMapFilters() {
    try { localStorage.setItem(LOTS_MAP_FILTERS_KEY, JSON.stringify(lotsMapFilters)); } catch (e) { /* не запомнится — не страшно */ }
    writeLotsMapUrl();
}

function lotPassesMapFilters(l, f, ignoreCategory = false) {
    if (!ignoreCategory && f.cat !== 'all' && l.category !== f.cat) return false;
    if (f.deal !== 'all' && (l.deal || 'sale') !== f.deal) return false;
    if (f.site !== 'all' && l.site !== f.site) return false;
    const tt = (l.type_trading || '').toLowerCase();
    if (f.trade === 'up' && !tt.includes('повыш')) return false;
    if (f.trade === 'down' && !tt.includes('пониж')) return false;
    // цена — это цена ПРОДАЖИ: у аренды start_price — ставка в месяц, сравнивать её с ценой продажи нельзя
    if ((f.min != null || f.max != null) && (l.deal || 'sale') === 'lease') return false;
    const price = Number(l.start_price) || 0;
    if (f.min != null && price < f.min) return false;
    if (f.max != null && price > f.max) return false;
    if (f.deadline !== 'all') {
        if (!l.application_deadline) return false;
        const days = (new Date(l.application_deadline) - Date.now()) / 86400000;
        if (!(days >= 0 && days <= Number(f.deadline))) return false;
    }
    return true;
}

function lotsMapActiveExtraFilters(f) {
    return (f.deal !== 'all') + (f.site !== 'all') + (f.trade !== 'all') + (f.min != null || f.max != null) + (f.deadline !== 'all');
}

function applyLotsMapFilters() {
    if (!lotsMap || !lotsMapData) return;
    const f = lotsMapFilters;
    lotsMapVisible = [];
    lotsMapPidByLot = new Map();
    for (const p of lotsMapData.places) {
        const lots = p.lots.filter(l => lotPassesMapFilters(l, f));
        if (!lots.length) continue;
        lots.forEach(l => lotsMapPidByLot.set(String(l.id), lotsMapVisible.length));
        lotsMapVisible.push({ ...p, lots });
    }
    lotsMapHoverPid = null;
    lotsMap.getSource('lots').setData(lotsMapGeojson(lotsMapVisible));
    const shown = new Set(lotsMapVisible.map(lotsMapPlaceKey));
    const outlines = (lotsMapData.outlines && lotsMapData.outlines.features) || [];
    lotsMap.getSource('lots-outlines').setData({ type: 'FeatureCollection',
        features: outlines.filter(o => (o.properties.places || []).some(k => shown.has(k))) });
    if (lotsMapFocusKey && !shown.has(lotsMapFocusKey)) lotsMapFocusKey = null;

    // счётчики чипов — с остальными фильтрами, без категории
    const counts = {};
    for (const p of lotsMapData.places) for (const l of p.lots) {
        if (lotPassesMapFilters(l, f, true)) counts[l.category] = (counts[l.category] || 0) + 1;
    }
    counts.all = Object.values(counts).reduce((a, b) => a + b, 0);
    const chips = document.getElementById('mapCatChips');
    chips.innerHTML = LOTS_MAP_CATEGORIES.map(([v, label]) => {
        const n = counts[v] || 0;
        if (v !== 'all' && !n && f.cat !== v) return '';
        return `<button type="button" class="lots-map-chip${f.cat === v ? ' is-active' : ''}" data-value="${escapeHtml(v)}" aria-pressed="${f.cat === v}">${label} <span class="lots-map-chip__n">· ${formatNumber(n)}</span></button>`;
    }).join('');
    const activeChip = chips.querySelector('.lots-map-chip.is-active');
    if (activeChip) {   // centre the active chip inside its own row (scrollIntoView would also scroll the page); again once the font is in
        const centre = () => { chips.scrollLeft = activeChip.offsetLeft - chips.offsetLeft - (chips.clientWidth - activeChip.offsetWidth) / 2; };
        centre();
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(centre);
    }

    document.querySelectorAll('#mapFiltersMore .lots-map-seg').forEach(seg => {
        const cur = String(f[seg.dataset.filter]);
        seg.querySelectorAll('button').forEach(b => {
            b.classList.toggle('is-active', b.dataset.value === cur);
            b.setAttribute('aria-pressed', String(b.dataset.value === cur));
        });
    });
    const extra = lotsMapActiveExtraFilters(f);
    document.getElementById('mapFiltersCount').textContent = extra ? ` · ${extra}` : '';
    document.getElementById('mapFiltersReset').hidden = !extra && f.cat === 'all';   // .btn-ghost would override .hidden
    renderLotsMapCities();
    refreshLotsMapList();
}

function bindLotsMapFilters() {
    if (lotsMapFiltersBound) return;
    lotsMapFiltersBound = true;
    const min = document.getElementById('mapPriceMin');
    const max = document.getElementById('mapPriceMax');
    const sort = document.getElementById('lotsMapSort');
    // цена вводится в млн ₸ («12,5»), хранится в тенге (фильтр, адрес страницы)
    const asMln = (v) => (v == null ? '' : String(+(v / 1e6).toFixed(3)).replace('.', ','));
    min.value = asMln(lotsMapFilters.min);
    max.value = asMln(lotsMapFilters.max);
    sort.value = lotsMapFilters.sort || 'new';
    document.getElementById('mapCatChips').addEventListener('click', (e) => {
        const chip = e.target.closest('.lots-map-chip');
        if (!chip) return;
        lotsMapFilters.cat = chip.dataset.value;
        saveLotsMapFilters();
        applyLotsMapFilters();
    });
    document.querySelectorAll('#mapFiltersMore .lots-map-seg').forEach(seg => seg.addEventListener('click', (e) => {
        const b = e.target.closest('button');
        if (!b) return;
        lotsMapFilters[seg.dataset.filter] = b.dataset.value;
        saveLotsMapFilters();
        applyLotsMapFilters();
    }));
    let t = null;
    const onPrice = () => {
        clearTimeout(t);
        t = setTimeout(() => {
            const v = (el) => {
                const n = parseFloat(el.value.replace(/\s/g, '').replace(',', '.'));
                return Number.isFinite(n) && n >= 0 ? Math.round(n * 1e6) : null;
            };
            lotsMapFilters.min = v(min);
            lotsMapFilters.max = v(max);
            saveLotsMapFilters();
            applyLotsMapFilters();
        }, 400);
    };
    min.addEventListener('input', onPrice);
    max.addEventListener('input', onPrice);
    sort.addEventListener('change', () => {
        lotsMapFilters.sort = sort.value;
        saveLotsMapFilters();
        refreshLotsMapList();
    });
}

window.toggleLotsMapFilters = () => {
    const more = document.getElementById('mapFiltersMore');
    const open = more.classList.toggle('is-open');
    document.getElementById('mapFiltersToggle').setAttribute('aria-expanded', String(open));
    if (lotsMap) setTimeout(() => lotsMap.resize(), 0);
};

window.resetLotsMapFilters = () => {
    lotsMapFilters = { ...LOTS_MAP_FILTERS_DEFAULT, sort: lotsMapFilters.sort };
    document.getElementById('mapPriceMin').value = '';
    document.getElementById('mapPriceMax').value = '';
    saveLotsMapFilters();
    applyLotsMapFilters();
};

// ---- адрес страницы (только сайт, /workspace/map): фильтры и область, чтобы ссылкой можно было поделиться ----
const lotsMapIsPage = () => !IS_TELEGRAM && window.location.pathname === '/workspace/map';
let lotsMapUrlTimer = null;

function readLotsMapUrl() {
    if (!lotsMapIsPage()) return {};
    const q = new URLSearchParams(window.location.search);
    const out = { lot: q.get('lot') || null };
    const f = {};
    if (q.has('cat')) f.cat = q.get('cat');
    if (q.has('deal')) f.deal = q.get('deal');
    if (q.has('site')) f.site = q.get('site');
    if (q.has('trade')) f.trade = q.get('trade');
    if (q.has('dl')) f.deadline = q.get('dl');
    if (q.has('sort')) f.sort = q.get('sort');
    if (q.has('min')) f.min = Number(q.get('min')) || null;
    if (q.has('max')) f.max = Number(q.get('max')) || null;
    if (Object.keys(f).length) out.filters = f;
    const c = (q.get('c') || '').split(',').map(Number);
    if (c.length === 3 && c.every(Number.isFinite)) out.view = { center: [c[0], c[1]], zoom: c[2] };
    return out;
}

function writeLotsMapUrl() {
    if (!lotsMapIsPage() || !lotsMap) return;
    clearTimeout(lotsMapUrlTimer);
    lotsMapUrlTimer = setTimeout(() => {
        const f = lotsMapFilters;
        const q = new URLSearchParams();
        if (f.cat !== 'all') q.set('cat', f.cat);
        if (f.deal !== 'all') q.set('deal', f.deal);
        if (f.site !== 'all') q.set('site', f.site);
        if (f.trade !== 'all') q.set('trade', f.trade);
        if (f.deadline !== 'all') q.set('dl', f.deadline);
        if (f.sort && f.sort !== 'new') q.set('sort', f.sort);
        if (f.min != null) q.set('min', String(f.min));
        if (f.max != null) q.set('max', String(f.max));
        const c = lotsMap.getCenter();
        q.set('c', `${c.lng.toFixed(5)},${c.lat.toFixed(5)},${lotsMap.getZoom().toFixed(2)}`);
        history.replaceState(history.state, '', `/workspace/map?${q.toString().replace(/%2C/g, ',')}`);   // readable shared links
    }, 300);
}

async function loadLotsMapData() {
    if (lotsMapData && Date.now() - lotsMapDataAt < LOTS_MAP_DATA_TTL_MS) return lotsMapData;
    const r = await fetch('/api/map/lots', { cache: 'no-store' });
    if (!r.ok) throw new Error(`HTTP ${r.status}`);
    lotsMapData = await r.json();
    lotsMapDataAt = Date.now();
    return lotsMapData;
}

function setLotsMapNotice(text) {
    const notice = document.getElementById('mapUnavailableNotice');
    if (!notice) return;
    notice.textContent = text || '';
    notice.classList.toggle('hidden', !text);
}

// ---- список рядом с картой ----
function lotsMapSortLots(lots) {
    const s = lotsMapFilters.sort || 'new';
    const price = (l) => Number(l.start_price) || 0;
    const lease = (l) => ((l.deal || 'sale') === 'lease' ? 1 : 0);   // аренда (ставка в месяц) — после продажи, а не «самые дешёвые»
    const deadline = (l) => (l.application_deadline ? new Date(l.application_deadline).getTime() : Infinity);
    const arr = [...lots];
    if (s === 'price_asc') arr.sort((a, b) => lease(a) - lease(b) || price(a) - price(b));
    else if (s === 'price_desc') arr.sort((a, b) => lease(a) - lease(b) || price(b) - price(a));
    else if (s === 'deadline') arr.sort((a, b) => deadline(a) - deadline(b));
    else arr.sort((a, b) => String(b.published || '').localeCompare(String(a.published || '')) || String(b.id).localeCompare(String(a.id)));
    return arr;
}

function refreshLotsMapList() {
    if (!lotsMap || !lotsMapData) return;
    const focus = lotsMapFocusKey && lotsMapVisible.find(p => lotsMapPlaceKey(p) === lotsMapFocusKey);
    let lots;
    if (focus) {
        lots = focus.lots;
    } else {
        const b = lotsMap.getBounds();
        lots = lotsMapVisible.filter(p => b.contains([p.lon, p.lat])).flatMap(p => p.lots);
    }
    lotsMapListLots = lotsMapSortLots(lots);
    const n = lotsMapListLots.length;
    const word = `${formatNumber(n)} ${pluralizeRu(n, 'лот', 'лота', 'лотов')}`;
    document.getElementById('lotsMapListTitle').textContent = focus
        ? `${word} здесь${focus.approx ? ' · расположение примерное' : ''}`
        : `${word} в этой области`;
    document.getElementById('lotsMapListAll').hidden = !focus;
    const nShown = lotsMapVisible.reduce((a, p) => a + p.lots.length, 0);
    const nHidden = (lotsMapData.hidden_lots || []).filter(l => lotPassesMapFilters(l, lotsMapFilters)).length;
    document.getElementById('mapHiddenNote').textContent = `${formatNumber(nShown)} ${pluralizeRu(nShown, 'лот', 'лота', 'лотов')} на карте`
        + (nHidden ? ` · ${formatNumber(nHidden)} без точного адреса не ${nHidden === 1 ? 'показан' : 'показаны'}` : '');
    lotsMapListShown = 0;
    document.getElementById('lotsMapCards').innerHTML = '';
    renderLotsMapCards();
}

// Компактная строка списка (2026-10-28, UX-тест): карточка каталога в колонке ~450 px давала 1–1,5 лота на экран,
// а 30 лотов одного здания читались одинаково. Здесь: фото, название, номер помещения и площадь, срок и тип торгов, цена
// (у аренды без «/мес» — владелец, 2026-11-03: только стартовая цена), оценка анализа. Сайт — ссылка на страницу лота; Mini App — лот поверх карты (карта сохраняет вид).
function renderLotsMapRow(l) {
    const el = document.createElement(IS_TELEGRAM ? 'div' : 'a');
    el.className = 'lots-map-row';
    el.dataset.lotId = String(l.id);
    if (IS_TELEGRAM) {
        el.setAttribute('role', 'button');
        el.tabIndex = 0;
        el.addEventListener('click', () => openModalOverMap(l.id));
        el.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openModalOverMap(l.id); } });
    } else {
        el.href = `/workspace/lot/${encodeURIComponent(l.id)}`;
    }
    const title = formatLotTitleSite(l).primary;
    const fallback = getPlaceholderFor(l.category);
    const img = proxyImg(l.image_url, 240) || fallback;
    const sub = [l.unit, l.area].filter(Boolean).join(' · ');
    const tt = (l.type_trading || '').toLowerCase();
    const trade = tt.includes('пониж') ? 'на понижение' : (tt.includes('повыш') ? 'на повышение' : '');
    const dl = l.application_deadline ? fmtDate(l.application_deadline, { short: true }) : '';
    const meta = [dl ? `до <span class="font-mono-nums">${escapeHtml(dl)}</span>` : '', escapeHtml(trade)].filter(Boolean).join(' · ');
    const lease = (l.deal || 'sale') === 'lease';
    const price = l.start_price ? escapeHtml(formatMoney(l.start_price)) : '';
    const rec = isRecAnalyzed(l.recommendation_status, l.recommendation_score) ? getRecBadgeData(l.recommendation_status, l.recommendation_score) : null;
    el.innerHTML = `
        <span class="lots-map-row__media">
            <img src="${escapeHtml(img)}" alt="" loading="lazy" referrerpolicy="no-referrer" onerror="this.onerror=null;this.src='${fallback}';">
            <span class="lots-map-row__site badge-solid ${l.site === 'etp' ? 'bg-etp' : 'bg-sauda'}">${l.site === 'etp' ? 'ETP' : 'SAUDA'}</span>
        </span>
        <span class="lots-map-row__body">
            <span class="lots-map-row__title" title="${escapeHtml(l.title || '')}">${escapeHtml(title)}</span>
            ${sub ? `<span class="lots-map-row__sub font-mono-nums">${escapeHtml(sub)}</span>` : ''}
            ${meta ? `<span class="lots-map-row__meta">${meta}</span>` : ''}
            <span class="lots-map-row__bottom">
                ${lease ? '<span class="lots-map-row__lease">Аренда</span>' : ''}
                <span class="lots-map-row__price font-mono-nums">${price}</span>
                ${rec ? `<span class="badge-rec ${rec.class} lots-map-row__rec">${escapeHtml(rec.text)}</span>` : ''}
            </span>
        </span>`;
    return el;
}

function renderLotsMapCards() {
    const box = document.getElementById('lotsMapCards');
    const more = document.getElementById('lotsMapMore');
    const from = lotsMapListShown;
    const slice = lotsMapListLots.slice(from, from + LOTS_MAP_PAGE);
    if (!lotsMapListLots.length) {
        const filtered = lotsMapActiveExtraFilters(lotsMapFilters) || lotsMapFilters.cat !== 'all';
        box.innerHTML = `<p class="lots-map-cards-empty text-body">${filtered ? 'Под фильтры здесь ничего не подходит.' : 'В этой области нет лотов. Отдалите карту.'}</p>`
            + (filtered ? '<button type="button" class="btn-secondary lots-map-empty-reset" onclick="resetLotsMapFilters()">Сбросить фильтры</button>' : '');
        more.hidden = true;
        return;
    }
    const frag = document.createDocumentFragment();
    for (const l of slice) {
        let row;
        try { row = renderLotsMapRow(l); } catch (e) { console.warn('[lotsMap row]', l.id, e); continue; }   // one odd lot never blanks the list
        row.addEventListener('mouseenter', () => highlightLotsMapPlace(lotsMapPidByLot.get(String(l.id))));
        row.addEventListener('mouseleave', () => highlightLotsMapPlace(null));
        frag.appendChild(row);
    }
    box.appendChild(frag);
    lotsMapListShown = from + slice.length;
    more.hidden = lotsMapListShown >= lotsMapListLots.length;
}

window.showMoreLotsMapCards = () => renderLotsMapCards();

function highlightLotsMapPlace(pid) {
    if (!lotsMap || !lotsMap.getSource('lots')) return;
    if (lotsMapHoverPid != null) lotsMap.setFeatureState({ source: 'lots', id: lotsMapHoverPid }, { hover: false });
    lotsMapHoverPid = pid == null ? null : pid;
    if (lotsMapHoverPid != null) lotsMap.setFeatureState({ source: 'lots', id: lotsMapHoverPid }, { hover: true });
}

function highlightLotsMapCards(place) {
    const ids = new Set(place ? place.lots.map(l => String(l.id)) : []);
    document.querySelectorAll('#lotsMapCards > [data-lot-id]').forEach(c => c.classList.toggle('is-hl', ids.has(c.dataset.lotId)));   // the card, not its ♥/«Анализ» buttons
}

// Лоты одного места — в список; на телефоне лист раскрывается, точка остаётся видна над ним
function focusLotsMapPlace(place, zoom, jump = false) {
    lotsMapFocusKey = lotsMapPlaceKey(place);
    refreshLotsMapList();
    const phone = window.matchMedia('(max-width: 767.98px)').matches;
    if (phone) setLotsMapSheet(true);
    // the sheet animates to 55 % (style.css): shift by half of its TARGET height, not the height it has mid-transition
    const shift = phone ? Math.round(lotsMap.getContainer().clientHeight * 0.55 / 2) : 0;
    lotsMap.easeTo({ center: [place.lon, place.lat], zoom, offset: [0, -shift], duration: jump ? 0 : 200 });   // jumpTo has no offset
}

window.clearLotsMapPlace = () => {
    lotsMapFocusKey = null;
    refreshLotsMapList();
};

function focusLotsMapLot(id) {
    const place = lotsMapVisible.find(p => p.lots.some(l => String(l.id) === String(id)));
    if (place) focusLotsMapPlace(place, Math.max(lotsMap.getZoom(), 16));
    return Boolean(place);
}

function setLotsMapSheet(open) {
    const list = document.getElementById('lotsMapList');
    list.classList.toggle('is-expanded', open);
    if (open) closeLotsMapLayers();     // на телефоне лист и панель слоёв не перекрывают друг друга
    document.getElementById('lotsMapListHandle').setAttribute('aria-expanded', String(open));
}
window.toggleLotsMapSheet = () => setLotsMapSheet(!document.getElementById('lotsMapList').classList.contains('is-expanded'));

// Планшет/компьютер: список сворачивается, карта — на всю ширину
window.toggleLotsMapList = (show) => {
    document.getElementById('lotsMapBody').classList.toggle('is-list-collapsed', !show);
    document.getElementById('lotsMapListExpand').hidden = show;
    if (lotsMap) setTimeout(() => lotsMap.resize(), 0);
};

// ---- слои: те же госслои, что у карты участка в отчёте (GEO_MAP_LAYERS, прокси /api/geo/tile) ----
const LOTS_MAP_LAYERS_KEY = 'ad_map_layers_v1';
let lotsMapLayersOn = new Set();
let lotsMapSatelliteOk = true;
try { lotsMapLayersOn = new Set(JSON.parse(localStorage.getItem(LOTS_MAP_LAYERS_KEY) || '[]')); } catch (e) { /* приватный режим */ }

function lotsMapInAstana() {
    const c = lotsMap.getCenter();
    return c.lng >= LOTS_MAP_ASTANA[0] && c.lng <= LOTS_MAP_ASTANA[2] && c.lat >= LOTS_MAP_ASTANA[1] && c.lat <= LOTS_MAP_ASTANA[3];
}

function ensureLotsMapLayer(key) {
    const id = `lm-${key}`;
    if (lotsMap.getLayer(id)) return id;
    const origin = window.location.origin;
    if (key === 'satellite') {
        lotsMap.addSource(id, { type: 'raster', tileSize: 256, maxzoom: 19, tiles: [`${origin}/api/geo/satellite/{z}/{x}/{y}`] });
        const firstState = lotsMap.getStyle().layers.find(l => l.id.startsWith('lm-') && l.id !== id);
        lotsMap.addLayer({ id, type: 'raster', source: id }, firstState ? firstState.id : 'lots-outline-fill');
        return id;
    }
    const def = GEO_MAP_LAYERS.find(l => l.key === key);
    lotsMap.addSource(id, { type: 'raster', tileSize: 512, minzoom: def.minzoom, maxzoom: 18,
        tiles: [`${origin}/api/geo/tile/${key}?bbox={bbox-epsg-3857}&size=512`] });
    lotsMap.addLayer({ id, type: 'raster', source: id, minzoom: def.minzoom,
        paint: { 'raster-opacity': def.opacity, 'raster-fade-duration': 0 } }, 'lots-outline-fill');
    return id;
}

function setLotsMapLayer(key, on) {
    if (on) lotsMapLayersOn.add(key); else lotsMapLayersOn.delete(key);
    try { localStorage.setItem(LOTS_MAP_LAYERS_KEY, JSON.stringify([...lotsMapLayersOn])); } catch (e) { /* не запомнится */ }
    if (on) ensureLotsMapLayer(key);
    if (lotsMap.getLayer(`lm-${key}`)) lotsMap.setLayoutProperty(`lm-${key}`, 'visibility', on ? 'visible' : 'none');
    renderLotsMapLayersPanel();
}

function renderLotsMapLayersPanel() {
    if (!lotsMap) return;
    const zoom = lotsMap.getZoom();
    const astana = lotsMapInAstana();
    const offered = (l) => !l.key.startsWith('astana_') || astana;
    const row = (key, label, swatch, minzoom) => `
        <label class="lots-map-layer${zoom < minzoom ? ' is-far' : ''}">
            <input type="checkbox" data-layer="${key}"${lotsMapLayersOn.has(key) ? ' checked' : ''}>
            <span class="lots-map-layer__swatch" style="background:${swatch}"></span><span>${label}</span>
        </label>`;
    const national = GEO_MAP_LAYERS.filter(l => !l.key.startsWith('astana_'));
    const city = GEO_MAP_LAYERS.filter(l => l.key.startsWith('astana_') && offered(l));
    const minZ = Math.min(...GEO_MAP_LAYERS.map(l => l.minzoom));
    document.getElementById('lotsMapLayersHint').textContent = zoom < minZ
        ? 'Слои видны при приближении — до масштаба района города.' : '';
    document.getElementById('lotsMapLayersList').innerHTML =
        national.map(l => row(l.key, l.label, l.swatch, l.minzoom)).join('')
        + (city.length ? `<p class="lots-map-layers__group text-micro">ГИС Астаны</p>${city.map(l => row(l.key, l.label, l.swatch, l.minzoom)).join('')}` : '')
        + (lotsMapSatelliteOk ? `<p class="lots-map-layers__group text-micro">Подложка</p>${row('satellite', 'Спутник', '#5b6b52', 0)}` : '');
    const n = [...lotsMapLayersOn].filter(k => k === 'satellite' || GEO_MAP_LAYERS.some(l => l.key === k && offered(l))).length;
    document.getElementById('lotsMapLayersCount').textContent = n ? ` · ${n}` : '';
}

window.toggleLotsMapLayers = () => {
    const panel = document.getElementById('lotsMapLayers');
    panel.hidden = !panel.hidden;
    document.getElementById('lotsMapLayersBtn').setAttribute('aria-expanded', String(!panel.hidden));
    if (!panel.hidden) {
        renderLotsMapLayersPanel();
        if (window.matchMedia('(max-width: 767.98px)').matches) setLotsMapSheet(false);
    }
};

function closeLotsMapLayers() {
    const panel = document.getElementById('lotsMapLayers');
    if (!panel || panel.hidden) return;
    panel.hidden = true;
    document.getElementById('lotsMapLayersBtn').setAttribute('aria-expanded', 'false');
}

// ---- быстрый переход к городу (со счётчиком лотов под текущие фильтры) и запомненный вид ----
const LOTS_MAP_CITIES = [
    ['Астана', 71.43, 51.13], ['Алматы', 76.92, 43.24], ['Шымкент', 69.59, 42.32], ['Караганда', 73.10, 49.81],
    ['Актобе', 57.17, 50.28], ['Атырау', 51.92, 47.11], ['Актау', 51.17, 43.65], ['Павлодар', 76.95, 52.29],
    ['Усть-Каменогорск', 82.61, 49.95], ['Семей', 80.23, 50.41], ['Костанай', 63.62, 53.21], ['Петропавловск', 69.15, 54.87],
    ['Уральск', 51.37, 51.23], ['Тараз', 71.37, 42.90], ['Кызылорда', 65.51, 44.85], ['Талдыкорган', 78.37, 45.02],
    ['Туркестан', 68.25, 43.30], ['Кокшетау', 69.39, 53.28], ['Конаев', 77.07, 43.87], ['Жезказган', 67.71, 47.80],
];
const LOTS_MAP_CITY_KM = 30;
const LOTS_MAP_VIEW_KEY = 'ad_map_view_v1';

function lotsMapKm(lat1, lon1, lat2, lon2) {
    const dx = (lon2 - lon1) * 111.32 * Math.cos(((lat1 + lat2) / 2) * Math.PI / 180);
    return Math.hypot(dx, (lat2 - lat1) * 110.57);
}

function renderLotsMapCities() {
    const sel = document.getElementById('lotsMapCity');
    if (!sel || !lotsMapData) return;
    const count = (lon, lat) => lotsMapVisible.reduce((a, p) => a + (lotsMapKm(lat, lon, p.lat, p.lon) <= LOTS_MAP_CITY_KM ? p.lots.length : 0), 0);
    const rows = LOTS_MAP_CITIES.map(([name, lon, lat]) => ({ name, lon, lat, n: count(lon, lat) })).sort((a, b) => b.n - a.n);
    sel.innerHTML = '<option value="">Город…</option><option value="kz">Весь Казахстан</option>'
        + rows.map(c => `<option value="${c.lon},${c.lat}"${c.n ? '' : ' disabled'}>${escapeHtml(c.name)} · ${formatNumber(c.n)}</option>`).join('');
    sel.value = '';
}

function bindLotsMapCity() {
    const sel = document.getElementById('lotsMapCity');
    if (!sel || sel.dataset.bound) return;
    sel.dataset.bound = '1';
    sel.addEventListener('change', () => {
        if (!sel.value) return;
        lotsMapFocusKey = null;
        if (sel.value === 'kz') lotsMap.fitBounds(LOTS_MAP_KZ_BOUNDS, { padding: 16, duration: 200 });
        else {
            const [lon, lat] = sel.value.split(',').map(Number);
            lotsMap.easeTo({ center: [lon, lat], zoom: 11, duration: 200 });
        }
        sel.value = '';
    });
}

function savedLotsMapView() {
    try {
        const v = JSON.parse(localStorage.getItem(LOTS_MAP_VIEW_KEY) || 'null');
        return v && Array.isArray(v.c) && Number.isFinite(v.z) ? { center: v.c, zoom: v.z } : null;
    } catch (e) { return null; }
}

// ---- подсказка при наведении на точку (компьютер): цена и что это, без клика ----
let lotsMapTip = null;
function lotsMapTipHtml(place) {
    const n = place.lots.length;
    const one = place.lots[0];
    if (n === 1) {
        const sub = [one.unit, one.area].filter(Boolean).join(' · ');
        return `<div class="lots-map-tip__title">${escapeHtml(formatLotTitleSite(one).primary)}</div>`
            + (sub ? `<div class="lots-map-tip__sub font-mono-nums">${escapeHtml(sub)}</div>` : '')
            + `<div class="lots-map-tip__price font-mono-nums">${escapeHtml(formatMoney(one.start_price))}</div>`;
    }
    const sale = place.lots.filter(l => (l.deal || 'sale') !== 'lease').map(l => Number(l.start_price) || 0).filter(Boolean);
    const from = sale.length ? `от ${escapeHtml(formatMoney(Math.min(...sale)))}` : '';
    // несколько лотов в одном месте: из чего оно состоит, а не название одного случайного лота
    const mix = {};
    place.lots.forEach(l => { mix[l.category] = (mix[l.category] || 0) + 1; });
    const mixText = Object.entries(mix).sort((x, y) => y[1] - x[1]).map(([c, k]) => `${c.toLowerCase()} ${k}`).join(' · ');
    return `<div class="lots-map-tip__title">${n} ${pluralizeRu(n, 'лот', 'лота', 'лотов')} здесь</div>`
        + `<div class="lots-map-tip__sub">${escapeHtml(mixText)}</div>`
        + (from ? `<div class="lots-map-tip__price font-mono-nums">${from}</div>` : '');
}

async function initLotsMap() {
    const maplibregl = await _loadMapLibre();
    if (lotsMap) { lotsMap.resize(); return lotsMap; }
    const tok = (name, fb) => _geoToken(name, fb);
    const colors = {
        pos: tok('--status-pos', '#34C77B'), warn: tok('--status-warn', '#E5A50A'), neg: tok('--status-neg', '#F06A6E'),
        none: tok('--info', '#6B8AE8'), ink: tok('--bg-surface', '#151A24'), text: tok('--text-primary', '#E8EBF0'),
        accent: tok('--accent', '#D9A441'),
    };
    const url = readLotsMapUrl();
    const map = new maplibregl.Map({
        container: 'lotsMapContainer',
        style: GEO_BASEMAP_STYLE,
        // вид: адрес страницы > последний вид этого пользователя > весь Казахстан (на лот карта переводится позже)
        ...((url.view || savedLotsMapView()) ? { center: (url.view || savedLotsMapView()).center, zoom: (url.view || savedLotsMapView()).zoom }
            : { bounds: LOTS_MAP_KZ_BOUNDS, fitBoundsOptions: { padding: 16 } }),
        attributionControl: false,
        dragRotate: false,
        fadeDuration: 0,
        renderWorldCopies: false,
        maxZoom: 19,
        // fetch() of an absolute URL bypasses the /api/ header patch: the Mini App's signed initData goes here (site = cookie)
        transformRequest: (u) => (IS_TELEGRAM && u.includes('/api/geo/') ? { url: u, headers: { 'X-Telegram-Init-Data': tg.initData || '' } } : { url: u }),
    });
    map.addControl(new maplibregl.AttributionControl({
        compact: true,
        customAttribution: ['© <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener">OpenStreetMap contributors</a>',
                            'Участки: НИПД, ЕГКН, jerler', 'Слои: НИПД, ГГК'],
    }), 'bottom-left');     // справа внизу — кнопка «рядом со мной»
    map.addControl(new maplibregl.NavigationControl({ showCompass: false }), 'top-right');
    map.touchZoomRotate.disableRotation();
    await new Promise((resolve, reject) => {
        const t = setTimeout(() => reject(new Error('map start timeout')), GEO_MAP_START_TIMEOUT_MS);
        map.once('load', () => { clearTimeout(t); resolve(); });
    });
    // MapLibre opens the compact attribution until the first move; on a phone it covers the map
    const attrib = map.getContainer().querySelector('.maplibregl-ctrl-attrib');
    if (attrib) attrib.classList.remove('maplibregl-compact-show');

    map.addSource('lots-outlines', { type: 'geojson', data: { type: 'FeatureCollection', features: [] } });
    map.addSource('lots', {
        type: 'geojson', data: { type: 'FeatureCollection', features: [] }, promoteId: 'pid',
        cluster: true, clusterRadius: 44, clusterMaxZoom: 13,
        clusterProperties: { lots: ['+', ['get', 'n']] },
    });
    map.addLayer({ id: 'lots-outline-fill', type: 'fill', source: 'lots-outlines', minzoom: 14,
        paint: { 'fill-color': colors.none, 'fill-opacity': 0.12 } });
    map.addLayer({ id: 'lots-outline-line', type: 'line', source: 'lots-outlines', minzoom: 14,
        filter: ['!=', ['get', 'approx'], true], paint: { 'line-color': colors.none, 'line-width': 1.5 } });
    // контур jerler (рисует продавец, размер часто неверный) — пунктиром
    map.addLayer({ id: 'lots-outline-approx', type: 'line', source: 'lots-outlines', minzoom: 14,
        filter: ['==', ['get', 'approx'], true], paint: { 'line-color': colors.none, 'line-width': 1.5, 'line-dasharray': [3, 2] } });
    map.addLayer({ id: 'lots-clusters', type: 'circle', source: 'lots', filter: ['has', 'point_count'],
        paint: { 'circle-color': colors.ink, 'circle-opacity': 0.92, 'circle-stroke-color': '#ffffff', 'circle-stroke-width': 1.5,
                 'circle-radius': ['step', ['get', 'lots'], 14, 10, 17, 50, 21, 200, 25] } });
    map.addLayer({ id: 'lots-cluster-count', type: 'symbol', source: 'lots', filter: ['has', 'point_count'],
        layout: { 'text-field': ['to-string', ['get', 'lots']], 'text-font': ['Noto Sans Bold'], 'text-size': 12, 'text-allow-overlap': true },
        paint: { 'text-color': colors.text } });
    const statusColor = ['match', ['get', 'status'], 'pos', colors.pos, 'warn', colors.warn, 'neg', colors.neg, colors.none];
    const hovered = ['boolean', ['feature-state', 'hover'], false];
    map.addLayer({ id: 'lots-places', type: 'circle', source: 'lots', filter: ['!', ['has', 'point_count']],
        paint: {
            'circle-radius': ['interpolate', ['linear'], ['zoom'], 5, ['case', hovered, 10, 5], 14, ['case', hovered, 12, 8]],   // zoom must be outermost
            // «примерно» (только контур jerler) — пустой кружок; подсветка из списка — золотая обводка (активное состояние, §5.2)
            'circle-color': ['case', ['==', ['get', 'approx'], 1], '#ffffff', statusColor],
            'circle-stroke-color': ['case', hovered, colors.accent, ['==', ['get', 'approx'], 1], statusColor, '#ffffff'],
            'circle-stroke-width': ['case', hovered, 3, ['==', ['get', 'approx'], 1], 2.5, 1.5],
        } });
    map.addLayer({ id: 'lots-place-labels', type: 'symbol', source: 'lots', filter: ['!', ['has', 'point_count']], minzoom: 12,
        layout: { 'text-field': ['get', 'label'], 'text-font': ['Noto Sans Bold'], 'text-size': 12, 'text-offset': [0, -1.3],
                  'text-anchor': 'bottom', 'text-optional': true },
        paint: { 'text-color': colors.ink, 'text-halo-color': '#ffffff', 'text-halo-width': 1.6 } });

    map.on('click', 'lots-clusters', async (e) => {
        const f = e.features[0];
        try {
            const zoom = await map.getSource('lots').getClusterExpansionZoom(f.properties.cluster_id);
            map.easeTo({ center: f.geometry.coordinates, zoom: Math.min(zoom, 17), duration: 200 });
        } catch (err) { console.warn('[lotsMap cluster]', err); }
    });
    map.on('click', 'lots-places', (e) => {
        const place = lotsMapVisible[e.features[0].properties.pid];
        if (place) focusLotsMapPlace(place, map.getZoom());
    });
    const canHover = window.matchMedia('(hover: hover)').matches;
    map.on('mousemove', 'lots-places', (e) => {
        const pid = e.features[0].properties.pid;
        if (pid === lotsMapHoverPid) return;
        highlightLotsMapPlace(pid);
        highlightLotsMapCards(lotsMapVisible[pid]);
        const place = lotsMapVisible[pid];
        if (canHover && place) {
            if (!lotsMapTip) lotsMapTip = new maplibregl.Popup({ closeButton: false, closeOnClick: false, offset: 14, className: 'lots-map-tip', maxWidth: '260px' });
            lotsMapTip.setLngLat([place.lon, place.lat]).setHTML(lotsMapTipHtml(place)).addTo(map);
        }
    });
    map.on('mouseleave', 'lots-places', () => {
        highlightLotsMapPlace(null); highlightLotsMapCards(null);
        if (lotsMapTip) lotsMapTip.remove();
    });
    for (const id of ['lots-clusters', 'lots-places']) {
        map.on('mouseenter', id, () => { map.getCanvas().style.cursor = 'pointer'; });
        map.on('mouseleave', id, () => { map.getCanvas().style.cursor = ''; });
    }
    // клик по соседнему участку (слой «Соседние участки», с масштаба 15) — номер / назначение / площадь, как в отчёте
    map.on('click', async (e) => {
        if (!lotsMapLayersOn.has('parcels') || map.getZoom() < 15) return;
        if (map.queryRenderedFeatures(e.point, { layers: ['lots-places', 'lots-clusters'] }).length) return;
        const { lat, lng } = e.lngLat;
        let parcel = null;
        let failed = false;
        try {
            const resp = await fetch(`/api/geo/feature/parcels?lat=${lat.toFixed(6)}&lon=${lng.toFixed(6)}`);
            const data = resp.ok ? await resp.json() : null;
            if (data && data.ok) parcel = data.parcel; else failed = true;
        } catch (err) { failed = true; }
        if (lotsMapPopup) lotsMapPopup.remove();
        lotsMapPopup = new maplibregl.Popup({ closeButton: true, maxWidth: '260px' }).setLngLat(e.lngLat)
            .setDOMContent(_geoPopupContent(parcel, failed)).addTo(map);
    });
    map.on('error', (e) => {
        if (e && e.sourceId === 'lm-satellite') {      // no key / quota: the option goes, never a grey layer
            lotsMapSatelliteOk = false;
            lotsMapLayersOn.delete('satellite');
            if (map.getLayer('lm-satellite')) map.setLayoutProperty('lm-satellite', 'visibility', 'none');
            renderLotsMapLayersPanel();
        }
    });
    let moveTimer = null;
    map.on('moveend', () => {
        clearTimeout(moveTimer);
        moveTimer = setTimeout(() => {
            if (!lotsMapFocusKey) refreshLotsMapList();
            renderLotsMapLayersPanel();
            writeLotsMapUrl();
            const c = map.getCenter();
            try { localStorage.setItem(LOTS_MAP_VIEW_KEY, JSON.stringify({ c: [+c.lng.toFixed(5), +c.lat.toFixed(5)], z: +map.getZoom().toFixed(2) })); } catch (e) { /* не запомнится */ }
        }, 200);
    });
    document.getElementById('lotsMapLayersList').addEventListener('change', (e) => {
        const box = e.target.closest('input[data-layer]');
        if (box) setLotsMapLayer(box.dataset.layer, box.checked);
    });
    lotsMap = map;
    for (const key of lotsMapLayersOn) {           // the layers chosen last time
        if (key === 'satellite' || GEO_MAP_LAYERS.some(l => l.key === key)) ensureLotsMapLayer(key);
    }
    renderLotsMapLayersPanel();
    return map;
}

function showLotsMapUser(maplibregl) {
    if (!userGeoCoords || !lotsMap) return;
    const lngLat = [userGeoCoords.lon, userGeoCoords.lat];
    if (!lotsMapUserMarker) {
        const el = document.createElement('div');
        el.className = 'lots-map-user';
        el.setAttribute('aria-label', 'Вы здесь');
        lotsMapUserMarker = new maplibregl.Marker({ element: el }).setLngLat(lngLat).addTo(lotsMap);
    } else {
        lotsMapUserMarker.setLngLat(lngLat);
    }
    lotsMapFocusKey = null;
    lotsMap.easeTo({ center: lngLat, zoom: 12, duration: 200 });
}

window.requestNearMe = () => {
    if (!navigator.geolocation) {
        tg.showAlert('Геолокация не поддерживается этим устройством/браузером.');
        return;
    }
    const btn = document.getElementById('nearMeBtn');
    if (btn) btn.disabled = true;
    navigator.geolocation.getCurrentPosition(
        (pos) => {
            userGeoCoords = { lat: pos.coords.latitude, lon: pos.coords.longitude };
            if (window.maplibregl) showLotsMapUser(window.maplibregl);
            if (btn) btn.disabled = false;
        },
        (err) => {
            console.warn('[requestNearMe]', err);
            tg.showAlert('Не удалось получить вашу геолокацию. Проверьте разрешения и попробуйте снова.');
            if (btn) btn.disabled = false;
        },
        { enableHighAccuracy: false, timeout: 10000, maximumAge: 5 * 60 * 1000 }
    );
};

// Общий запуск карты: страница сайта (switchScreen('map')) и модалка Mini App (openMapModal). opts.lotId — открыть на лоте.
async function initLotsMapView(opts = {}) {
    // PREMIUM (TASK29 29.3: гостю — вход, вошедшему без права купить — без кнопки покупки); /api/map/* проверяют то же
    const paywall = document.getElementById('mapPaywall');
    const content = document.getElementById('mapContent');
    if (!isPremiumUser()) {
        if (!userId) { renderLoginGate('Карта лотов'); return; }
        const buy = paywall.querySelector('button');
        if (buy) buy.style.display = premiumOnSale() ? '' : 'none';
        paywall.classList.remove('hidden');
        paywall.classList.add('flex');
        content.classList.add('hidden');
        return;
    }
    paywall.classList.add('hidden');
    paywall.classList.remove('flex');
    content.classList.remove('hidden');

    const container = document.getElementById('lotsMapContainer');
    if (!_geoWebglOk()) {
        setLotsMapNotice('Карта не поддерживается этим устройством (нет WebGL).');
        container.classList.add('hidden');
        return;
    }
    const url = readLotsMapUrl();
    if (url.filters) lotsMapFilters = { ...lotsMapFilters, ...url.filters };
    const lotId = opts.lotId || url.lot || null;
    try {
        setLotsMapNotice('');
        container.classList.remove('hidden');
        await initLotsMap();
        await loadLotsMapData();
        bindLotsMapFilters();
        bindLotsMapCity();
        // открытая на лоте карта не прячет этот лот своими фильтрами
        const lot = lotId && lotsMapData.places.flatMap(p => p.lots).find(l => String(l.id) === String(lotId));
        if (lot && !lotPassesMapFilters(lot, lotsMapFilters)) {
            lotsMapFilters = { ...LOTS_MAP_FILTERS_DEFAULT, sort: lotsMapFilters.sort };
            document.getElementById('mapPriceMin').value = '';
            document.getElementById('mapPriceMax').value = '';
        }
        applyLotsMapFilters();
        if (lotId) {
            const place = lotsMapVisible.find(p => p.lots.some(l => String(l.id) === String(lotId)));
            if (place) focusLotsMapPlace(place, 16, true);
        }
    } catch (e) {
        console.error('[initLotsMapView]', e);
        setLotsMapNotice('Не удалось загрузить карту. Попробуйте позже.');
    }
}

// Кнопка «на карте» (карточки каталога, страница лота): на открытой карте — к лоту, иначе — открыть карту на нём
window.openLotOnMap = (lotId, ev) => {
    if (ev) { ev.preventDefault(); ev.stopPropagation(); }
    const mapShown = lotsMap && (document.getElementById('screen-map')?.classList.contains('active')
        || document.getElementById('mapModal')?.classList.contains('open'));
    if (mapShown && lotsMapData && focusLotsMapLot(lotId)) return;
    openMapModal({ lotId });
};

// Сайт: карта — страница /workspace/map (ссылка, «Назад» работает); Mini App: модалка на весь экран.
window.openMapModal = async (opts = {}) => {
    if (!IS_TELEGRAM) {
        window.location.href = `/workspace/map${opts.lotId ? `?lot=${encodeURIComponent(opts.lotId)}` : ''}`;
        return;
    }
    document.getElementById('mapModal').classList.add('open');
    tg.BackButton.show();
    tg.BackButton.onClick(closeMapModal);
    // Фаза 11 (30.08.2026): Telegram перехватывает вертикальные жесты — карта без этого «лагает» на pinch-zoom
    if (tg.isVersionAtLeast && tg.isVersionAtLeast('7.7') && tg.disableVerticalSwipes) {
        tg.disableVerticalSwipes();
    }
    if (!isPremiumUser() && !userId) { closeMapModal(); renderLoginGate('Карта лотов'); return; }
    await initLotsMapView(opts);
};

window.closeMapModal = () => {
    document.getElementById('mapModal').classList.remove('open');
    tg.BackButton.hide();
    // свайпы — только если они не отключены глобально (SWIPES_DISABLED_GLOBALLY)
    if (!SWIPES_DISABLED_GLOBALLY && tg.isVersionAtLeast && tg.isVersionAtLeast('7.7') && tg.enableVerticalSwipes) {
        tg.enableVerticalSwipes();
    }
};


// D1 (DESIGN_UPGRADE_PROMPT.md §6 D2 "число и формат дат — одна функция на
// каждый тип"): раньше `new Intl.NumberFormat('ru-RU', {compactDisplay:
// 'short', notation: 'compact'})` дублировался литералом в 5 местах (карточка
// лота, 3 таблицы Избранного/Главной) — здесь единая точка входа, без ₸
// (валюту добавляет вызывающий шаблон, как и раньше в этих 4 местах).
// General site-wide use (lot cards, chart ticks) -- 0 decimals is right
// here; the finance editor/share page's own stricter needs (distinct
// close prices on a ladder) are fmPriceCompactStrict below, not this.
function fmtPriceCompact(price) {
    if (!price) return '';
    return new Intl.NumberFormat('ru-RU', { compactDisplay: 'short', notation: 'compact' }).format(price);
}
// TASK15 15.4b item 6: "One formatter everywhere in the editor and on the
// share page" -- fixed 1 decimal (both min and max, so 13 982 794 shows
// as "14,0 млн", not a bare "14" that looks unrounded). Without
// maximumFractionDigits, compact notation rounds to the nearest whole
// million, so 14 718 730 and 13 982 794 both print "15 млн"/"14 млн" and
// collide with a THIRD different price that also rounds to "14 млн"
// (found live on Sauda's sensitivity grid: шаг 27/28/пол all disagreeing
// with the ladder above despite being three genuinely different prices).
// Scoped to the ladder + sensitivity grid, not fmtPriceCompact's other
// site-wide callers (lot cards etc.), which the brief doesn't ask to
// change and where 0 decimals is still the right call.
// TASK15 15.6 nit (owner review): 15.5 moved the ladder/sensitivity grid
// off this function onto their own buildDistinctPriceFormatter-based
// formatter (fmComputeCurrentPriceFormatter) -- this function's only live
// caller now is the history row's "≈ {compact}" reconstructed-start price
// (15.4c item 4), a single standalone approximate figure, not part of a
// collision-sensitive SET the way the ladder/grid prices are (forcing 0
// decimals there would risk reintroducing item 5's exact collision bug on
// close sub-million prices). Under 1 млн, Intl's compact notation uses
// "тыс." -- a forced 1 decimal there is fake precision the other way
// ("≈ 252,0 тыс." from an already-approximate figure); 0 decimals for
// тыс., 1 decimal from млн up (unchanged).
function fmPriceCompactStrict(price) {
    if (!price) return '';
    const digits = Math.abs(price) < 1000000 ? 0 : 1;
    return new Intl.NumberFormat('ru-RU', { compactDisplay: 'short', notation: 'compact', minimumFractionDigits: digits, maximumFractionDigits: digits }).format(price);
}
// TASK15 15.4c item 5: a FIXED 1 decimal (fmPriceCompactStrict above)
// still collides -- 11 of 114 stored engine reports print two genuinely
// different prices identically at 1 decimal (e.g. sauda_337504271188…:
// 1 384 261 and 1 358 107 both round to "1,4 млн"). Given the full set of
// prices ONE report shows (ladder + sensitivity grid + market markers,
// gathered by the caller as one union), this picks the smallest fixed
// fraction-digit count in 1..3 that keeps every distinct price in that
// set visually distinct, falling back to the exact ₸ figure (fmMoney)
// when even 3 decimals can't separate them. Verified with a node script
// over all 114 stored financial_model union sets: 0 collisions.
function buildDistinctPriceFormatter(prices) {
    const distinct = [...new Set((prices || []).filter((p) => typeof p === 'number' && p))];
    for (let digits = 1; digits <= 3; digits++) {
        const fmt = new Intl.NumberFormat('ru-RU', { compactDisplay: 'short', notation: 'compact', minimumFractionDigits: digits, maximumFractionDigits: digits });
        const labels = distinct.map((p) => fmt.format(p));
        if (new Set(labels).size === labels.length) {
            return (price) => (price ? fmt.format(price) : '');
        }
    }
    return (price) => fmMoney(price);
}
// Module-level, set once per report render (renderInAppReport, site-only)
// from the FROZEN report's own price union -- read by the market markers
// only (renderInAppReport itself). TASK15 15.5 nit 1 (owner review): the
// finance editor's ladder/sensitivity grid render a DIFFERENT model (the
// live-recomputed one from /api/lot/{id}/model, or the user's own
// overridden model in "mine" mode) whose prices can genuinely differ from
// this frozen set -- they get their own editor-local formatter
// (fmComputeCurrentPriceFormatter, near fmSensitivityCells below), never
// this one. Defaults to fmPriceCompactStrict (fixed 1 decimal) until a
// report has rendered.
let reportPriceFormatter = fmPriceCompactStrict;
function compactPriceKzt(price) {
    if (!price) return '';
    return `${fmtPriceCompact(price)} ₸`;
}

// ИСПРАВЛЕНО (жалоба "лот при открытии через карту закрывает её насовсем",
// 05.09.2026): раньше buildLotPinElement()/openLotFromCluster() звали
// closeMapModal() перед openModal() — карта полностью закрывалась (и
// пересоздавалась заново при следующем открытии), пользователь терял
// масштаб/положение карты и список кластера.
//
// Просто оставить карту открытой оказалось НЕДОСТАТОЧНО: на десктопе
// браузера #detailModal/#analysisModal намеренно position:static
// ("полноэкранная страница", см. html.is-browser #detailModal в
// dashboard.css) — а z-index у static-элемента браузер вообще не
// учитывает, поэтому #mapModal (position:fixed) рисовался ПОВЕРХ карточки
// лота, что бы та ни показывала — визуально казалось, что карта "не
// пускает" лот наверх, хотя JS исправно считал обе модалки открытыми.
// Проверено через elementFromPoint() — без класса ниже поверх карты
// оказывался именно #yandexMapContainer, а не заголовок карточки лота.
//
// openModalOverMap() — общая точка входа для обоих мест, откуда лот
// открывается ПРЯМО С КАРТЫ: временно возвращает #detailModal в обычный
// fixed-оверлей (класс .modal-over-map, см. правило в dashboard.css) перед
// вызовом openModal(). closeModal() снимает класс. openAnalysisModal() сам
// копирует класс на #analysisModal, если карточка лота была открыта именно
// так — чтобы и отчёт ИИ, открытый из такой карточки, тоже лёг поверх
// карты, а не под неё.
function openModalOverMap(lotId) {
    // §5.4 DESIGN_MASTER_PROMPT.md: на сайте лот, открытый прямо с карты —
    // такая же настоящая навигация на /workspace/lot/{id}, как и любой
    // другой клик по лоту; карта — модалка, страница уходит вместе с ней,
    // "остаться над картой" (.modal-over-map) больше не нужно решать — та
    // проблема существовала только пока лот тоже был модалкой поверх
    // страницы. В Mini App ничего не изменилось.
    if (!IS_TELEGRAM) { window.location.href = `/workspace/lot/${lotId}`; return; }
    document.getElementById('detailModal').classList.add('modal-over-map');
    openModal(lotId);
}



function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, (c) => (
        { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]
    ));
}

// Russian plural declension (1/2-4/5-20 forms) for count chips (TASK15
// 15.4). n=1 -> one, n=2..4 (except 12-14) -> few, else -> many.
function pluralizeRu(n, one, few, many) {
    const n10 = n % 10, n100 = n % 100;
    if (n10 === 1 && n100 !== 11) return one;
    if (n10 >= 2 && n10 <= 4 && (n100 < 12 || n100 > 14)) return few;
    return many;
}

// ДОБАВЛЕНО (интерфейсный аудит, раздел 03/фаза 3): l.title приходит от
// парсера как сырая строка реестра госимущества — например
// "Объект: грузовые автомобили, 1.000 НЕФАЗ 8560-062-02, 2011, -, ОРАНЖЕВЫЙ
// \nКомментарий: НЕФАЗ 8560-062-02, " или, для недвижимости,
// "Жилые помещения,  квартира, вторичный объект, 20-314-015-000-21/1-4,
// квартира, 49.300, Алматы" — служебные лейблы, задвоенный "Комментарий:"
// и кадастровый/учётный номер внутри одной строки с описанием. structured
// JSON-поле lots.attributes для этого пока не заполняется парсером (см.
// PROJECT_NOTES.md) — переразбирать текст по позициям КОМММ было бы гаданием
// вслепую (порядок полей у недвижимости не фиксирован, проверено на реальных
// данных), а due-diligence продукту нельзя показывать додуманную структуру
// как факт. Поэтому формат вывода разный по надёжности:
//   - "авто": хвост строки (год, VIN/номер, ЦВЕТ) идёт в фиксированном
//     порядке на реальных данных (проверено на ~20 лотах) — безопасно
//     собрать читаемую строку "Модель · Год · рег. № · Цвет".
//   - всё остальное: только надёжная чистка (убрать служебные лейблы,
//     вынести похожий на кадастровый номер токен в отдельную строку,
//     схлопнуть пробелы/запятые) — без домысливания порядка полей.
function formatLotTitle(lot) {
    const raw = (lot && lot.title) || '';
    if (!raw) return { primary: lot && lot.lot_id ? `Лот ${lot.lot_id}` : 'Лот', code: '' };

    // "Комментарий: ..." почти дословно повторяет часть до \n — обрезаем.
    let text = raw.split('\n')[0];
    text = text.replace(/^\s*объект\s*:\s*/i, '').trim();

    if (lot.category === 'авто') {
        const parts = text.split(',').map(p => p.trim()).filter(Boolean);
        if (parts.length >= 3) {
            const color = parts[parts.length - 1];
            const regOrDash = parts[parts.length - 2];
            const year = parts[parts.length - 3];
            const colorOk = /^[А-ЯЁ][А-ЯЁ\s-]*$/.test(color);
            const yearOk = /^(19|20)\d{2}$/.test(year);
            if (colorOk && yearOk) {
                let model = parts.slice(0, parts.length - 3).join(', ')
                    .replace(/\b\d+[.,]\d+\s*(?:ШТУКА)?,?\s*/gi, '')
                    .trim();
                model = model.charAt(0).toUpperCase() + model.slice(1);
                const bits = [model || 'Транспортное средство', `${year} г.`];
                if (regOrDash && regOrDash !== '-') bits.push(`рег. № ${regOrDash}`);
                const colorTitled = color.charAt(0) + color.slice(1).toLowerCase();
                bits.push(colorTitled);
                return { primary: bits.join(' · '), code: '' };
            }
        }
    }

    // Общая безопасная чистка: вынести кадастровый/учётный номер (несколько
    // групп цифр/букв через ":" или "-", напр. "13:200:015:000:2:22" или
    // "20-314-015-000-21/1-4") в отдельную строку — он остаётся видимым, но
    // не смешивается с человекочитаемым описанием в одну кашу.
    let code = '';
    const codeMatch = text.match(/\b[\dA-Za-zА-Яа-я]+(?:[:\-\/][\dA-Za-zА-Яа-я]+){3,}\b/);
    if (codeMatch) {
        code = codeMatch[0];
        text = text.replace(code, ' ');
    }
    text = text.replace(/\s*,\s*,+/g, ',').replace(/\s+,/g, ',').replace(/\s{2,}/g, ' ').replace(/^[\s,]+|[\s,]+$/g, '').trim();
    if (text) text = text.charAt(0).toUpperCase() + text.slice(1);
    return { primary: text || (lot.lot_id ? `Лот ${lot.lot_id}` : 'Лот'), code };
}

// ДОБАВЛЕНО (TASK4 4.4, DESIGN_MASTER_PROMPT.md §8.3, TASK4_HOME_PROMPT.md
// §5): нормализация заголовка САЙТА — отдельная от formatLotTitle() (та
// НЕ меняется, общая с Mini App, §12). Цель: primary — 1-2 строки, по
// которым лот узнаваем («SCANIA R420 TOPLINE, 2011», «Квартира, 35.2 м²,
// Павлодар»), без «1.000 ШТУКА»/номеров/VIN; secondary — сырой заголовок
// целиком (для title="" и страницы лота).
//
// lots.attributes сейчас всегда null на реальных данных (см. комментарий
// у formatLotTitle() и PROJECT_NOTES.md) — код проверяет его первым
// (на будущее, если парсер когда-нибудь начнёт его заполнять), но на
// практике всегда падает на разбор текста l.title. Разбор — по образцам
// живых данных обеих площадок (ETP и Sauda сильно расходятся форматом:
// «Автотранспортное средство MITSUBISHI PAJERO» у ETP против «Автомобиль
// "Skoda Octavia A4", г.н. 926AW16» или «Марка – ВАЗ 21310, государственный
// регистрационный номер – 535 BF12, кузов – …, год выпуска – 2006» у
// Sauda) — не домысливает порядок полей, которого нет (тот же принцип, что
// у formatLotTitle(), см. её комментарий), только вырезает узнаваемо
// служебные куски (гос.номер/VIN/кузов/объём двигателя) и достаёт то, что
// осталось надёжно опознаваемым (модель в кавычках, площадь перед "кв.м",
// площадь перед "га", год выпуска). Если после разбора для категории
// ничего надёжного не осталось — primary = formatLotTitle(lot).primary
// (тот же фолбэк, что и предписано §5 — ничего не ломается).
function extractCitySite(location) {
    if (!location) return '';
    // Берём первый сегмент адреса — без домысливания, какой из сегментов
    // "настоящий город" в сильно разном формате разных площадок (см.
    // комментарий formatLotTitle() про то же самое решение).
    let seg = location.split(',')[0].trim();
    seg = seg.replace(/^г\.?\s*/i, '').replace(/^город\s+/i, '').replace(/^с\.?\s+/i, '').replace(/^село\s+/i, '');
    return seg.trim();
}

function cleanupPrimarySite(s) {
    if (!s) return s;
    // НЕ \bШТУКА\b/\bОБЪЕКТ\b — JS-движок считает \w только ASCII
    // ([A-Za-z0-9_]), кириллица для \b не "буква", а "граница" между двумя
    // такими "не-буквами" (конец кириллического слова и пробел/начало
    // строки) не срабатывает вовсе — \b после/перед кириллицей молча не
    // матчит НИЧЕГО. Найдено на фикстурах: «1.000 ШТУКА» не вырезался,
    // хотя регулярка визуально выглядела корректной.
    //
    // ОБОБЩЕНО (ревью 8.5, живые данные §5): было только «1.000 ШТУКА/
    // ОБЪЕКТ» — на живых 60 лотах утекали «1.000 АМПУЛА», «1.000 МЕТР» (не
    // площадь — количество, отдельный юнит-код источника, не кв.метр) и
    // голое «8842.000»/«10.000» БЕЗ юнит-слова вообще (просто число перед
    // повтором категории/следующим сегментом). Три случая одной регуляркой
    // не покрыть по-разному, поэтому два прохода: (1) число + явный юнит
    // (список известных + любое ЗАГЛАВНОЕ кириллическое слово 3+ букв —
    // сама заглавность здесь и есть признак служебного кода источника, а не
    // обычного текста карточки, который у обеих площадок в Title Case);
    // (2) голое «NNN.000[,]» без юнита следом. Оба — НЕ /gi (без i): юнит-
    // альтернатива [А-ЯЁ]{3,} обязана остаться регистрозависимой, иначе
    // словит любое трёхбуквенное слово после числа («3 эт», "5 лет") — тем
    // же нарочно ЗАГЛАВНЫЕ ШТУКА/ОБЪЕКТ/МЕТР/АМПУЛА в списке, а не через i.
    let out = s
        .replace(/\d+(?:[.,]\d{3})?\s+(?:ШТУКА|ОБЪЕКТ|ЕД\.?|МЕТР|АМПУЛА|[А-ЯЁ]{3,})\s*,?\s*/g, '')
        .replace(/\d+\.000,?\s*/g, '');
    // Схлопнуть подряд идущие одинаковые сегменты через запятую
    // ("Жилые помещения, Жилые помещения" → "Жилые помещения").
    // (?!\d) — не резать по запятой десятичной дроби ("168,9" — запятая
    // сразу перед цифрой, это не граница сегмента). НАЙДЕНО на фикстурах:
    // без guard'а "168,9 кв.м" превращалось в "168, 9 кв.м" после join.
    const segs = out.split(/,(?!\d)/).map(p => p.trim()).filter(Boolean);
    const dedup = [];
    for (const seg of segs) {
        if (!dedup.length || dedup[dedup.length - 1].toLowerCase() !== seg.toLowerCase()) dedup.push(seg);
    }
    let joined = dedup.join(', ').replace(/\s{2,}/g, ' ').trim();
    // Первая буква заглавная (источники вроде "здания и сооружения, ..."
    // приходят со строчной) — идемпотентно для уже капса/заглавной буквы.
    if (joined) joined = joined.charAt(0).toUpperCase() + joined.slice(1);
    return joined;
}

// ДОБАВЛЕНО (TASK4 4.4b — дефект найден ревьюером на живых данных 14.09.2026):
// категорийные разборщики (formatAutoTitleSite/formatHousingTitleSite/...)
// ниже доверяли собственному разбору без общей сетки безопасности, а
// фолбэк на formatLotTitle() возвращал сырую строку БЕЗ ограничения длины —
// кадастровые номера/гос.номера/VIN оставались в primary целиком (600+
// символов на одну реальную запись). Вырезает то, что узнаваемо служебное,
// ДО категорийного разбора (а не только после) — чтобы «168,9 кв.м.»,
// лежащий ПОСЛЕ кадастровых номеров в одной строке, разбирался с чистого
// текста, а не терялся вместе с ними. "Комментарий:" не режется здесь —
// formatHousingTitleSite для (a) достаёт площадь ИЗ-ЗА этой метки (она в
// реальных записях идёт раньше "Комментарий:" не всегда), обрезка живёт в
// sanitizePrimarySite() ниже, уже на ГОТОВОМ коротком primary.
function preStripTrackingTokensSite(text) {
    if (!text) return text;
    return text
        // "год выпуска NNNN" → ", NNNN" — год остаётся полезным, лейбл нет.
        .replace(/год\s*выпуска\s*[–—\-:]?\s*(\d{4})/gi, ', $1')
        // [^\s,]+, не \S+ — НАЙДЕНО (TASK4 4.4b, живая фикстура (b)): \S+
        // жадно проглатывал и разделительную запятую сразу после значения
        // ("…773AQL05," целиком), склеивая два соседних сегмента в один без
        // границы — хвостовая эвристика в formatAutoTitleSite() после этого
        // мисвычисляла количество частей и не набирала уверенности.
        .replace(/VIN[\s\-]*(?:код|кузов)?[\s:–—\-]*[^\s,]+/gi, '')
        .replace(/государственн(?:ый|ого)?\s*(?:регистрационн(?:ый|ого)?\s*)?номер\s*[–—\-:]?\s*[^\s,]+/gi, '')
        // Кадастровый/учётный номер: 2 цифры : 3 цифры : 3 цифры : 3 цифры
        // (+ необязательный хвост через ":"), напр. "22:327:065:349:1/А".
        // Голый гос.номер (без лейбла, напр. "910BHS02" в хвосте
        // год/номер/цвет) СОЗНАТЕЛЬНО НЕ режется здесь — formatAutoTitleSite()
        // ниже ожидает его на фиксированной позиции (год, номер-или-прочерк,
        // ЦВЕТ — последние три сегмента через запятую, тот же приём, что у
        // formatLotTitle()); вырезать его ДО разбора сдвинуло бы позиции и
        // сломало бы само распознавание (найдено на фикстуре SCANIA — с
        // вырезанным здесь номером хвост перестаёт быть "уверенным", падает
        // в фолбэк). Убирается позже, как содержимое конкретной ячейки,
        // не как текст "где попало" — см. комментарий у middle-фильтра ниже.
        .replace(/\b\d{2}:\d{3}:\d{3}:\d{3}(?::[^\s,]+)?/g, '');
}

// ДОБАВЛЕНО (TASK4 4.4b): последний рубеж — применяется к ЛЮБОМУ primary
// перед возвратом из formatLotTitleSite(), включая фолбэк на
// formatLotTitle() (та не меняется, но её результат тоже проходит через
// этот фильтр). §5: «no plate numbers, VINs, cadastral numbers; primary
// is 1–2 lines» — категорийные разборщики целятся в это узкой резкой по
// смыслу, эта функция — грубой резкой по форме токена, вторым слоем,
// на случай, если что-то узнаваемо служебное просочилось мимо разборщика
// (не смогли предугадать все форматы обеих площадок заранее).
function sanitizePrimarySite(s) {
    if (!s) return s;
    let out = s
        // Всё от "Комментарий:" и дальше — дублирует уже вошедшее описание,
        // не короче исходного заголовка целиком.
        .replace(/Комментарий\s*:[\s\S]*$/i, '')
        .replace(/\b\d{2}:\d{3}:\d{3}:\d{3}(?::[^\s,]+)?/g, '') // кадастровый номер
        .replace(/\b[0-9]{3}[A-ZА-Я]{2,3}[0-9]{2}\b/gi, '') // гос.номер (рег.знак)
        .replace(/\b[A-HJ-NPR-Z0-9]{17}\b/g, ''); // "голый" VIN без лейбла (17 симв., без I/O/Q)
    out = out.replace(/\s*,\s*,+/g, ',').replace(/^[\s,·]+|[\s,·]+$/g, '').replace(/\s{2,}/g, ' ').trim();
    // Жёсткий потолок 80 символов по границе слова (§5: "primary is 1-2
    // lines") — обрезаем на последнем пробеле не короче половины лимита,
    // чтобы не откусить одно длинное слово почти целиком.
    if (out.length > 80) {
        let cut = out.slice(0, 80);
        const lastSpace = cut.lastIndexOf(' ');
        if (lastSpace > 40) cut = cut.slice(0, lastSpace);
        out = cut.replace(/[,;\s]+$/, '') + '…';
    }
    return out;
}

function formatAutoTitleSite(lot, raw) {
    const attrs = lot.attributes;
    if (attrs && (attrs.brand || attrs.model)) {
        const mm = [attrs.brand, attrs.model].filter(Boolean).join(' ').trim();
        return attrs.year ? `${mm}, ${attrs.year}` : mm;
    }

    let text = raw.split('\n')[0];

    // Год выпуска — размеченный (до или после числа) либо голый токен
    // 19xx/20xx. Порядок проверки важен: размеченные формы точнее голого
    // фолбэка (тот мог бы случайно зацепить часть номера кузова).
    let year = '';
    let m = text.match(/год\s*выпуска\s*[–\-:]\s*(\d{4})/i);
    if (m) year = m[1];
    if (!year) { m = text.match(/\b((?:19|20)\d{2})\b\s*г(?:ода)?\.?\s*в(?:ыпуска)?\.?/i); if (m) year = m[1]; }
    if (!year) { m = text.match(/\b(19|20)\d{2}\b/); if (m) year = m[0]; }

    // Служебные поля (гос.номер/VIN/кузов/объём двигателя/цвет/год) —
    // вырезаем, чтобы они не попали в "модель", независимо от того, нашли
    // мы год выше или нет (год уже сохранён в переменной).
    text = text
        // "регистрационный" опционален — НАЙДЕНО на фикстурах: «государственный
        // номер 773AQL05» (без слова "регистрационный") не совпадало со
        // старой регуляркой, гос.номер просачивался в модель через
        // хвостовую эвристику ниже.
        .replace(/государственн(ый|ого)?\s*(?:регистрационн(ый|ого)?\s*)?номер\s*[–\-:]?\s*[^\s,]+/gi, '')
        .replace(/(гос\.?\s*номер|г\.?\s*н\.?|г\/н|р\/н|рег\.?\s*номер|рег\.?\s*№)\s*[:.]?\s*[«»"]?[А-ЯA-Z0-9]+[«»"]?/gi, '')
        // НАЙДЕНО на реальных данных (regression-check фикстуры): формат
        // "VIN-код XXXXXXXXXXXXXXXXX" (лейбл "код" МЕЖДУ "VIN" и самим
        // значением) — старая регулярка съедала только "VIN-код" целиком
        // как один "непробельный" токен, а сам 17-символьный VIN оставался
        // в тексте и просачивался в "модель" через хвостовую эвристику
        // ниже. Плюс необязательный лейбл "кузов" — тот же класс проблемы.
        // [^\s,]+ (не \S+, TASK4 4.4b) — иначе съедает разделительную запятую
        // сразу после значения, склеивая соседние сегменты без границы.
        .replace(/VIN[\s\-]*(?:код|кузов)?[\s:–\-]*[^\s,]+/gi, '')
        .replace(/кузов\s*[–\-:]\s*[^\s,]+/gi, '')
        .replace(/объ[её]м\s*двигателя\s*[–\-:]\s*[^\s,]+/gi, '')
        .replace(/цвет\s*[–\-:]?\s*[А-Яа-яёЁ]+/gi, '')
        .replace(/год\s*выпуска\s*[–\-:]\s*\d{4}/gi, '')
        .replace(/\b(19|20)\d{2}\s*г(?:ода)?\.?\s*в(?:ыпуска)?\.?/gi, '')
        .trim();

    // Модель: в кавычках — самый надёжный источник (обе площадки часто
    // заключают марку/модель в кавычки независимо от остального шаблона
    // строки); иначе — снимаем служебный префикс категории/лейбл "марки".
    // НАЙДЕНО на реальных данных (regression-check фикстуры): без этого
    // guard'а «тракторная техника, трактор К-701» (нет ни кавычек, ни
    // узнаваемого префикса) обрезалась по первой запятой до «тракторная
    // техника» — терялась САМАЯ содержательная часть (марка/модель шла
    // ПОСЛЕ запятой, а не после лейбла). Обрезка по запятой безопасна
    // только когда мы уверены, что уже отделили лейбл/кавычки от
    // содержания; для неопознанного формата — не гадаем, отдаём заголовок
    // formatLotTitle() (тот хотя бы не теряет данные).
    let model = '';
    let confident = false;
    const quoted = text.match(/["«]([^"»]{2,60})["»]/);
    if (quoted) {
        model = quoted[1];
        confident = true;
    } else {
        const prefixMatch = text.match(/^\s*(Автотранспортное\s+средство|Автомобиль|АВТОМОБИЛЬ|Автобус|АВТОБУС|Бренд)\s*[:\-]?\s*/i);
        if (prefixMatch) {
            model = text.slice(prefixMatch[0].length)
                .replace(/марки\s+/i, '')
                .replace(/Марка\s*[–\-]\s*/i, '');
            confident = true;
        }
    }
    // Третий узнаваемый шаблон (сам пример из DESIGN_MASTER_PROMPT.md §5:
    // «SCANIA R420 TOPLINE, 2011» — живая запись реально выглядит как
    // «Грузовые автомобили, SCANIA R420 TOPLINE, 2011, -, БЕЛЫЙ»): хвост из
    // запятых — год, гос.номер-или-прочерк, ЦВЕТ КАПСОМ. Тот же тест
    // (colorOk/yearOk), что использует formatLotTitle() для этого случая —
    // но, в отличие от неё, не тащим номер/цвет в результат (§5: "Plate
    // number and VIN are not in the title"), а модель берём БЛИЖАЙШИМ к
    // году сегментом, а не всей склейкой до него — иначе сюда же попадал
    // бы и лишний ведущий тип техники ("Грузовые автомобили,").
    if (!confident) {
        const parts = text.split(',').map(p => p.trim()).filter(Boolean);
        if (parts.length >= 3) {
            const color = parts[parts.length - 1];
            const regOrDash = parts[parts.length - 2];
            const yr = parts[parts.length - 3];
            const colorOk = /^[А-ЯЁ][А-ЯЁ\s-]*$/.test(color);
            const yearOk = /^(19|20)\d{2}$/.test(yr);
            if (colorOk && yearOk && regOrDash) {
                // ИСПРАВЛЕНО (TASK4 4.4b, живая фикстура (b)): фиксированная
                // позиция "parts[length-4]" ломается, когда где-то раньше в
                // строке год уже встречался в прозе ("год выпуска 2017
                // государственный номер …") — preStripTrackingTokensSite()
                // выше сворачивает этот лейбл в ", 2017", добавляя ЛИШНИЙ
                // сегмент-дубликат года перед хвостом и сдвигая индексы.
                // Вместо жёсткой позиции — берём последний сегмент "середины"
                // (всё до хвостовых трёх), ОТБРОСИВ сегменты, равные уже
                // найденному году: они почти наверняка тот самый дубликат,
                // а не часть модели.
                const middle = parts.slice(0, parts.length - 3).filter((p) => p !== yr);
                model = middle.length ? middle[middle.length - 1] : parts.slice(0, parts.length - 3).join(', ');
                if (!year) year = yr;
                confident = true;
            }
        }
    }
    if (!confident) return '';
    // ИСПРАВЛЕНО (TASK4 4.4b): "1.000 HYUNDAI ACCENT" — количество-маркер
    // ("1.000", без слова ШТУКА/ОБЪЕКТ рядом, так что cleanupPrimarySite()
    // его не ловит) иногда стоит вплотную перед моделью, а не только перед
    // категорией — попадал в хвостовую эвристику как часть "модели".
    model = model.split(/[,;]/)[0].replace(/^\d+[.,]\d+\s+/, '').replace(/^["«]|["»]$/g, '').replace(/\s{2,}/g, ' ').trim();

    if (!model) return '';
    // Защита от просочившегося VIN/серийного номера (§5: "Plate number and
    // VIN are not in the title") — если чистка выше по какой-то причине не
    // распознала лейбл и "модель" оказалась одним длинным сплошным
    // буквенно-цифровым токеном без пробелов (VIN — 17 символов, похожие
    // серийники обычно не короче), не показываем его как модель, честно
    // отдаём заголовок formatLotTitle().
    if (/^[A-ZА-Я0-9]{12,}$/.test(model)) return '';
    return year ? `${model}, ${year}` : model;
}

// TASK4 4.9 (дефект живых данных: «Квартира, 1.000 м², Астана» — «1.000»
// было количеством из «1.000 ШТУКА», не площадью). Вырезаем количественный
// токен ДО поиска площади, а не пытаемся отличить его по значению —
// "площадь" из объявления и "количество" в описании неотличимы по форме
// числа (оба бывают "1.000"). Не \b перед кириллицей — см. cleanupPrimarySite().
function stripQuantityTokenSite(text) {
    return text.replace(/\d+[.,]?\d*\s*(?:ШТУКА|ОБЪЕКТ|ЕД)\.?(?![а-яёА-ЯЁ])/gi, ' ').trim();
}

function formatHousingTitleSite(lot, raw, category) {
    const attrs = lot.attributes;
    const label = category === 'дома' ? 'Дом' : 'Квартира';
    let area = attrs && attrs.area ? String(attrs.area) : '';
    if (!area) {
        const text = stripQuantityTokenSite(raw.split('\n')[0]);
        // ИСПРАВЛЕНО (TASK4 4.4b): [\s\-:] не покрывал тире («–», U+2013) —
        // реальный формат «площадью – 168,9 кв.м.» (пробел-тире-пробел) не
        // совпадал вовсе, площадь терялась, функция отдавала '' → фолбэк.
        // ИСПРАВЛЕНО (TASK4 4.9): убран фолбэк "число перед ШТУКА/ОБЪЕКТ" —
        // ловил количество лота, а не площадь (см. stripQuantityTokenSite()
        // выше). Площадь принимается ТОЛЬКО рядом с явным "площадь"/"кв.м"/"м²".
        const m = text.match(/площадь(?:ю)?[\s\-–—:]*([\d]+[.,]?\d*)\s*(?:кв\.?\s*м|м2|м²)/i);
        if (m) area = m[1];
    }
    if (!area) return '';
    area = area.replace(',', '.');
    // ДОБАВЛЕНО (TASK5 5.6, ревью владельца): площадь "0" (или практически
    // ноль) — не настоящая площадь, а артефакт разбора (например, число
    // перед "ШТУКА"/"ОБЪЕКТ", просочившееся мимо stripQuantityTokenSite()
    // на нетипичной строке) — не показываем «Квартира, 0 м²», честно
    // уходим на фолбэк formatLotTitle() ниже по цепочке в formatLotTitleSite().
    if (!(parseFloat(area) >= 0.001)) return '';
    // TASK15 15.4c item 8: ru-RU decimal comma (found live: "18.7 м²"
    // printed with a dot instead of "18,7 м²").
    const displayArea = area.replace('.', ',');
    const city = extractCitySite(lot.location);
    return city ? `${label}, ${displayArea} м², ${city}` : `${label}, ${displayArea} м²`;
}

function formatLandTitleSite(lot, raw) {
    const attrs = lot.attributes;
    let area = attrs && attrs.area ? String(attrs.area) : '';
    if (!area) {
        const text = raw.split('\n')[0];
        // Не \b после "га" (кириллица, см. cleanupPrimarySite()) — вместо
        // этого негативный лукахед: следующий символ не кириллическая
        // буква, иначе "5 га" совпало бы с началом слова "гараж".
        const m = text.match(/(\d+[.,]?\d*)\s*га(?![а-яёА-ЯЁ])/i);
        if (m) area = m[1];
    }
    if (!area) return '';
    area = area.replace(',', '.');
    // ДОБАВЛЕНО (TASK5 5.6, ревью владельца) — та же защита, что в
    // formatHousingTitleSite() выше: «Участок, 0 га» — не настоящая
    // площадь, честный фолбэк вместо неё.
    if (!(parseFloat(area) >= 0.001)) return '';
    // TASK15 15.4c item 8: same ru-RU decimal comma fix as the housing
    // title above -- same root defect (area normalized to a dot for
    // parseFloat, then printed as-is).
    const displayArea = area.replace('.', ',');
    const city = extractCitySite(lot.location);
    return city ? `Участок, ${displayArea} га, ${city}` : `Участок, ${displayArea} га`;
}

// коммерция/прочее — общего правила формы нет (§5 не даёт для них жёсткий
// шаблон полей, в отличие от авто/жилья/земли), поэтому берём первый
// содержательный сегмент заголовка (после служебных лейблов "Объект:"/
// "Недвижимо(с)ть:") + город. Паркинг в §5 отдельно не описан — заведён
// сюда же по той же логике, тот же уровень надёжности данных.
function formatGenericTitleSite(lot, raw) {
    let text = raw.split('\n')[0];
    text = text.replace(/^\s*(Объект|Недвижимо[сc]ть)\s*:\s*/i, '').trim();
    const firstSeg = text.split(/[,;]/)[0].trim();
    if (!firstSeg || /^прочие?\s+категории/i.test(firstSeg)) return '';
    const city = extractCitySite(lot.location);
    return city ? `${firstSeg}, ${city}` : firstSeg;
}

// ДОБАВЛЕНО (TASK5 5.6, ревью владельца): /api/analysis/history (Мои
// анализы) не отдаёт category вовсе (SELECT в get_user_analysis_history(),
// postgres_client.py, не выбирает это поле — backend debt, записано в
// отчёте 5.6, не чинится здесь). formatLotTitleSite() без category падала
// в formatGenericTitleSite() — тот берёт "первый сегмент до запятой", а
// сырой title лота вида "Легковые автомобили, TOYOTA LAND CRUISER 200,
// 2016, ..." теряет марку/модель целиком, "Земельный участок – 0,0117 га"
// теряет площадь на ДЕСЯТИЧНОЙ запятой. Упрощённый клиентский аналог
// parser/shared/taxonomy.py::normalize_category — только по заголовку (тот
// использует ещё raw_cat/description, которых здесь нет), список ключевых
// слов и порядок проверок — по прямому указанию ревью, не полный перенос
// бэкендовой функции (там своя расстановка приоритетов под сырые данные
// разных площадок, длиннее и с ложными срабатываниями, для которых здесь
// нет входных данных, чтобы их отличать).
function inferLotCategorySite(title) {
    const t = (title || '').toLowerCase();
    if (/автомоб|автотранспорт|легков|грузов|трактор|экскават|спецтехник/.test(t)) return 'авто';
    if (/квартир/.test(t)) return 'квартиры';
    if (/жилой дом|домовлад|коттедж/.test(t)) return 'дома';
    if (/земельн|участок/.test(t)) return 'участки';
    if (/паркова|парковочн|машиномест/.test(t)) return 'паркинг';
    if (/здани|помещени|склад|комплекс|объект/.test(t)) return 'коммерция';
    return 'прочее';
}

function formatLotTitleSite(lot) {
    const raw = (lot && lot.title) || '';
    const secondary = raw;
    if (!raw) return { primary: (lot && lot.lot_id) ? `Лот ${lot.lot_id}` : 'Лот', secondary };

    // TASK4 4.4b: категорийные разборщики получают текст с уже вырезанными
    // кадастровыми номерами/гос.номером/VIN/лейблом "год выпуска" — иначе
    // площадь ("168,9 кв.м."), лежащая ПОСЛЕ шести кадастровых номеров в
    // одной строке, тонет в них раньше, чем до неё доходит regex площади.
    const cleanedRaw = preStripTrackingTokensSite(raw);

    // ДОБАВЛЕНО (TASK5 5.6): category может отсутствовать вовсе (Мои
    // анализы, см. inferLotCategorySite() выше) — тогда угадываем по
    // самому заголовку. lot.category не переписывается (объект лота могут
    // читать и дальше по цепочке) — только локальная переменная здесь.
    //
    // TASK9 9.3 (backend debt закрыт): get_user_analysis_history() теперь
    // отдаёт l.category (и l.site) — источник, ради которого эта строка
    // вообще появилась в 5.6, больше не пуст. inferLotCategorySite() ОСТАВЛЕН
    // как fallback намеренно, не удалён: единственный вызов угадывания живёт
    // прямо здесь (grep подтверждает — второго нет), но lot.category может
    // прийти пустой строкой/null и из другого, ещё не проверенного будущего
    // источника лота — a || b безопаснее, чем полагаться на то, что КАЖДЫЙ
    // caller formatLotTitleSite() сейчас и всегда будет отдавать непустой
    // category. Если появится доказательство, что это невозможно — можно
    // убрать.
    const category = lot.category || inferLotCategorySite(raw);

    let primary = '';
    switch (category) {
        case 'авто': primary = formatAutoTitleSite(lot, cleanedRaw); break;
        case 'квартиры': primary = formatHousingTitleSite(lot, cleanedRaw, 'квартиры'); break;
        case 'дома': primary = formatHousingTitleSite(lot, cleanedRaw, 'дома'); break;
        case 'участки': primary = formatLandTitleSite(lot, cleanedRaw); break;
        default: primary = formatGenericTitleSite(lot, cleanedRaw); break;
    }
    // ИСПРАВЛЕНО (regression-check фикстуры): cleanupPrimarySite() должен
    // отработать и на фолбэке тоже — раньше вызывался ДО проверки "пусто ли
    // primary", поэтому «1.000 ШТУКА»/повторы сегментов оставались
    // нечищенными именно в тех записях, где категорийный разбор не смог
    // ничего извлечь и функция отдавала formatLotTitle().primary как есть.
    // ИСПРАВЛЕНО (TASK4 4.4b): фолбэк тоже получает cleanedRaw, не raw —
    // formatLotTitle() не меняется ни строкой (§12), но ей подставляется
    // неглубокая копия lot с уже предочищенным title (formatLotTitle()
    // читает только lot.title/lot.category/lot.lot_id — безопасно).
    if (!primary) primary = formatLotTitle({ ...lot, title: cleanedRaw }).primary;
    primary = cleanupPrimarySite(primary);
    // TASK4 4.4b: последний рубеж — на ЛЮБОМ пути, включая фолбэк. §5: "no
    // plate numbers, VINs, cadastral numbers; primary is 1-2 lines".
    primary = sanitizePrimarySite(primary);
    return { primary, secondary };
}

// TASK15 15.4b item 5: historical_sales titles are the same raw registry
// strings as a lot's own title (make/plate/colour all run together) --
// reuses formatLotTitleSite's §8.3 parser (make/model/year, no plate, no
// colour) via a minimal lot-shaped object; `category` assumes the
// historical sale is the same asset class as the current lot (the DB
// query that finds "similar past lots" already filters on it).
function historicalSaleTitleSite(saleTitle, category) {
    return formatLotTitleSite({ title: saleTitle || '', category }).primary;
}









async function loadSavedFilters() {
    const list = document.getElementById('savedFiltersList');
    list.innerHTML = '<div class="text-center py-6"><i class="ph-bold ph-spinner animate-spin text-3xl text-blue-500"></i></div>';
    try {
        const r = await fetch(`/api/filters?user_id=${userId}`);
        if (!r.ok) throw new Error(`HTTP ${r.status}`);
        const filters = await r.json();
        renderSavedFilters(filters);
    } catch (e) {
        console.error('[loadSavedFilters]', e);
        list.innerHTML = '<p class="text-center text-xs text-[#94a3b8] py-6">Не удалось загрузить фильтры</p>';
    }
}

function renderSavedFilters(filters) {
    const list = document.getElementById('savedFiltersList');
    if (!filters || !filters.length) {
        list.innerHTML = '<p class="text-center text-xs text-[#94a3b8] py-10">Пока нет сохранённых фильтров.<br>Настройте поиск и нажмите «Сохранить и получать уведомления».</p>';
        return;
    }
    list.innerHTML = filters.map(f => `
        <div class="glass-panel rounded-xl p-3 border border-white/10 flex items-center justify-between gap-2">
            <div class="flex-1 min-w-0">
                <p class="text-sm font-bold text-white truncate">${f.name || 'Без названия'}</p>
                <p class="text-[10px] text-[#94a3b8]">${f.is_active ? 'Активен' : 'Отключён'}</p>
            </div>
            <div class="flex items-center gap-2 shrink-0">
                <button onclick="toggleSavedFilter(${f.id}, ${!f.is_active})" class="w-9 h-9 flex items-center justify-center rounded-lg ${f.is_active ? 'bg-blue-600' : 'bg-white/10'} active:scale-90 transition-all">
                    <i class="ph-bold ${f.is_active ? 'ph-bell-ringing' : 'ph-bell-slash'} text-white text-sm"></i>
                </button>
                <button onclick="deleteSavedFilter(${f.id})" class="w-9 h-9 flex items-center justify-center rounded-lg bg-red-500/20 active:scale-90 transition-all">
                    <i class="ph-bold ph-trash text-red-400 text-sm"></i>
                </button>
            </div>
        </div>
    `).join('');
}

window.toggleSavedFilter = async (filterId, newActive) => {
    try {
        const r = await fetch(`/api/filters/${filterId}/toggle?user_id=${userId}&is_active=${newActive}`, { method: 'POST' });
        if (!r.ok) throw new Error(`HTTP ${r.status}`);
        tg.HapticFeedback.impactOccurred('light');
        await loadSavedFilters();
    } catch (e) {
        console.error('[toggleSavedFilter]', e);
        tg.showAlert("Не удалось изменить фильтр");
    }
};

window.deleteSavedFilter = async (filterId) => {
    try {
        const r = await fetch(`/api/filters/${filterId}?user_id=${userId}`, { method: 'DELETE' });
        if (!r.ok) throw new Error(`HTTP ${r.status}`);
        tg.HapticFeedback.notificationOccurred('success');
        await loadSavedFilters();
    } catch (e) {
        console.error('[deleteSavedFilter]', e);
        tg.showAlert("Не удалось удалить фильтр");
    }
};

window.openPdf = (url) => {
    const modal = document.getElementById('pdfModal');
    const frame = document.getElementById('pdfFrame');
    const loader = document.getElementById('pdfLoader');
    
    state.currentPdfUrl = url;
    
    // Показываем индикатор загрузки
    loader.style.display = 'flex';
    frame.style.display = 'none';

    // Формируем ссылку для Google Viewer
    // encodeURIComponent обязателен, чтобы символы в URL файла не ломали ссылку Google
    const googleViewerUrl = `https://docs.google.com/gview?url=${encodeURIComponent(url)}&embedded=true`;
    
    frame.src = googleViewerUrl;

    // Скрываем лоадер, когда Google Viewer загрузится
    frame.onload = () => {
        loader.style.display = 'none';
        frame.style.display = 'block';
    };

    modal.classList.add('open');
    tg.BackButton.show();
    tg.BackButton.onClick(closePdf);
};
window.closePdf = () => { document.getElementById('pdfModal').classList.remove('open'); document.getElementById('pdfFrame').src=""; tg.BackButton.hide(); }
window.openExternalPdf = () => { if(state.currentPdfUrl) tg.openLink(state.currentPdfUrl); }

// 🔥 Выход из аккаунта — ТОЛЬКО для браузера (сайт, вне Mini App). Внутри
// Telegram выйти "из аккаунта" не имеет смысла (личность = Telegram-клиент),
// там нижняя кнопка навигации просто закрывает Mini App (tg.close()) — см.
// handleNavClose() ниже, который выбирает между ними. Раньше кнопка "Выход"
// в #bottomNav ВСЕГДА звала tg.close(), которая в браузере не делает ничего
// (tg.close — заглушка вне Telegram) — то есть у браузерных пользователей
// физически не было способа выйти из аккаунта на этом же устройстве.
window.logoutBrowser = async function () {
    try { await fetch('/api/auth/logout', { method: 'POST' }); } catch (e) { /* всё равно уходим со страницы */ }
    window.location.href = '/';
};
window.handleNavClose = function () {
    if (IS_TELEGRAM) { tg.close(); } else { logoutBrowser(); }
};

window.switchScreen = (n) => {
    // 1. Скрываем все экраны (Phase 2: instant display swap заменён на
    // короткий cross-fade через GSAP — старый экран гаснет ~150ms, новый
    // проявляется ~200ms. GSAP-сбой/reduced-motion → мгновенный fallback,
    // навигация никогда не блокируется анимацией).
    const prevScreen = document.querySelector('.screen.active');
    document.querySelectorAll('.screen').forEach(e => { if (e !== prevScreen) { e.style.display='none'; } e.classList.remove('active'); });
    document.querySelectorAll('.nav-item').forEach(e => e.classList.remove('active'));

    // 2. Показываем нужный экран
    const targetScreen = document.getElementById(`screen-${n}`);
    if (targetScreen) {
        targetScreen.classList.add('active');
        if (targetScreen !== prevScreen) {
            let animated = false;
            if (!REDUCE_MOTION && HAS_GSAP()) {
                try {
                    if (prevScreen && prevScreen !== targetScreen) {
                        gsap.to(prevScreen, {
                            opacity: 0, duration: 0.15, ease: 'power1.out',
                            onComplete: () => { prevScreen.style.display = 'none'; prevScreen.style.opacity = ''; }
                        });
                    }
                    gsap.set(targetScreen, { opacity: 0 });
                    targetScreen.style.display = 'block';
                    gsap.to(targetScreen, { opacity: 1, duration: 0.2, ease: 'power1.out' });
                    animated = true;
                } catch (e) { animated = false; }
            }
            if (!animated) {
                if (prevScreen && prevScreen !== targetScreen) { prevScreen.style.display = 'none'; prevScreen.style.opacity = ''; }
                targetScreen.style.display = 'block';
                targetScreen.style.opacity = '1';
            }
        } else {
            targetScreen.style.display = 'block';
        }
    }

    // 2b. Подсвечиваем соответствующую вкладку нижнего меню — раньше класс
    // 'active' только СНИМАЛСЯ со всех пунктов и никогда не возвращался
    // выбранному, поэтому после первого же перехода подсветка пропадала
    // навсегда (виден был только домашний экран при самой первой загрузке).
    //
    // 🔥 БАГ (найден при доводке браузерной вёрстки): здесь стоял
    // querySelector (единственное число) — он возвращает только ПЕРВОЕ
    // совпадение в DOM. После того как в index.html появился #sidebarNav
    // (стоит в разметке раньше #bottomNav), querySelector с тем же
    // data-nav начал находить пункт сайдбара и переставал доходить до
    // нижней навигации — активная вкладка в Mini App (где сайдбар скрыт
    // через CSS, но остаётся в DOM) перестала подсвечиваться. querySelectorAll
    // подсвечивает оба пункта разом — невидимый (display:none) от этого
    // никак не страдает, а видимый теперь снова подсвечивается в обоих
    // контекстах.
    document.querySelectorAll(`.nav-item[data-nav="${n}"]`).forEach(el => el.classList.add('active'));
    const navBtn = document.querySelector(`#bottomNav .nav-item[data-nav="${n}"]`);

    // 2c. Плавающий индикатор нижнего меню (Phase 2) — доп. визуальный слой
    // поверх уже существующей логики .nav-item.active (её не меняем).
    moveNavIndicator(navBtn);

    // 3. Вызываем логику для конкретных экранов
    if (n === 'favorites') loadFavorites();
    if (n === 'profile') {
        authUser();
        // D2: тот же fetch, что и updateAnalysesCount(), плюс превью
        // последних 3 отчётов — см. её комментарий.
        loadProfileReportsPreview();
    }

    // Открываем базу AI (грузим, только если сетка пустая)
    if (n === 'global') {
        const globalGrid = document.getElementById('globalGrid');
        if (gState.offset === 0 && (!globalGrid.innerHTML || globalGrid.innerHTML.trim() === '')) {
            loadGlobalLots();
        }
        
        setTimeout(() => syncHeaderSpacer('gHeader', 'gHeaderSpacer'), 50);
    }

    // Главная страница (грузим рекомендации, только если их еще нет)
    if (n === 'home') {
        const recGrid = document.getElementById('recommendationsGrid');
        if (!recGrid.innerHTML || recGrid.innerHTML.trim() === '') {
            loadRecommendations();
        }

        setTimeout(() => {
            if (!document.getElementById('filterPanel').classList.contains('open')) {
                syncHeaderSpacer('mainHeader', 'headerSpacer');
            }
        }, 50);
    }

    window.scrollTo({top:0});
}

// Плавающий индикатор нижней навигации (Phase 2). Позиционируется по
// getBoundingClientRect() активной кнопки относительно #bottomNav — работает
// на любой ширине экрана без хардкода координат. Не трогает существующую
// логику .nav-item.active (цвет иконки/подписи) — индикатор лежит позади
// (z-index ниже) как дополнительный слой.
function moveNavIndicator(navBtn) {
    const nav = document.getElementById('bottomNav');
    const indicator = document.getElementById('navIndicator');
    if (!nav || !indicator || !navBtn) return;
    const navRect = nav.getBoundingClientRect();
    const btnRect = navBtn.getBoundingClientRect();
    const x = btnRect.left - navRect.left;
    const width = btnRect.width;

    if (REDUCE_MOTION || !HAS_GSAP()) {
        indicator.style.opacity = '1';
        indicator.style.width = width + 'px';
        indicator.style.transform = `translateX(${x}px)`;
        return;
    }
    try {
        gsap.to(indicator, {
            x, width,
            opacity: 1,
            duration: 0.3,
            ease: 'power2.out'
        });
    } catch (e) {
        indicator.style.opacity = '1';
        indicator.style.width = width + 'px';
        indicator.style.transform = `translateX(${x}px)`;
    }
}

// --- FAVORITES LOGIC ---
async function loadFavorites() {
    if(!userId) return;
    const grid = document.getElementById('favGrid');
    showLoader('favGrid'); // Используем скелетон
    try {
        const res = await fetch(`/api/favorites?user_id=${userId}`);
        favState.lotsCache = await res.json();
        renderFavorites();
    } catch(e) { grid.innerHTML = '<div class="text-center text-red-400 py-10">Ошибка</div>'; }
}

function renderFavorites() {
    const grid = document.getElementById('favGrid');
    if (!grid) return;
    grid.innerHTML = '';
    updateFavRailResetLabel(); // TASK5 5.2 — держит «Сбросить · N» в синхроне на каждый пересчёт фильтров
    // TASK5 5.2 (§3): «Избранное · N» — N от ВСЕГО загруженного активного
    // избранного (favState.lotsCache), не от текущей отфильтрованной
    // выдачи — заголовок отвечает на "сколько у меня избранного", а не
    // "сколько сейчас видно после фильтра".
    const headerCount = document.getElementById('favHeaderCount');
    if (headerCount) {
        const totalActive = favState.lotsCache.filter(l => l.is_active !== false).length;
        headerCount.textContent = `Избранное · ${totalActive}`;
    }

    // --- ШАГ 1: ФИЛЬТРАЦИЯ ---
    let filtered = favState.lotsCache.filter(l => {
        // А. Фильтр по площадке
        if (favState.site === 'etp' && !l.url.includes('adilet')) return false;
        if (favState.site === 'sauda' && l.url.includes('adilet')) return false;

        // Б. Фильтр по категории — та же колонка lots.category, что на Главной
        // и в Базе AI. ИСПРАВЛЕНО (унификация категорий): раньше здесь был
        // отдельный самодельный поиск по ключевым словам в title+description —
        // независимая от бэкенда эвристика, которая могла давать другой
        // результат для того же лота (например, слово "жилой" совпадало
        // одновременно и с "квартиры", и с "дома" — на Главной у лота ровно
        // одна категория, такое структурно невозможно). /api/favorites и так
        // возвращает полный объект лота (get_lot_by_id_any_site -> SELECT *
        // FROM lots), включая настоящее поле category — используем его
        // напрямую, как везде.
        if (favState.category !== 'all' && (l.category || '').toLowerCase() !== favState.category) return false;

        // TASK5 5.2 (§3): поиск по названию — клиентский, по formatLotTitleSite()
        // primary (то же, что видит пользователь в строке/карточке, а не по
        // сырому title — иначе поиск "Camry" не нашёл бы "TOYOTA CAMRY, 2019",
        // если сырой заголовок площадки — другой порядок слов).
        if (favState.query) {
            const q = favState.query.trim().toLowerCase();
            if (q) {
                const hay = `${formatLotTitleSite(l).primary} ${l.title || ''}`.toLowerCase();
                if (!hay.includes(q)) return false;
            }
        }

        // TASK5 5.2 (§3): фильтр по вердикту — те же значения (good/mid/bad),
        // что уже использует «Мои анализы» (applyAnalysesToolbar()) — один
        // словарь на приложение, не новая шкала специально для Избранного.
        if (favState.verdict !== 'all') {
            const score = typeof l.recommendation_score === 'number' ? l.recommendation_score : null;
            const analyzed = isRecAnalyzed(l.recommendation_status, l.recommendation_score) && score != null;
            if (favState.verdict === 'none') {
                if (analyzed) return false;
            } else {
                if (!analyzed) return false;
                if (favState.verdict === 'good' && !(score >= 70)) return false;
                if (favState.verdict === 'mid' && !(score >= 40 && score < 70)) return false;
                if (favState.verdict === 'bad' && !(score < 40)) return false;
            }
        }

        return true;
    });
    // 🔥 ИСПРАВЛЕННАЯ ЛОГИКА СОРТИРОВКИ
    filtered.sort((a, b) => {
        // Надежно превращаем даты в миллисекунды (0 если даты почему-то нет)
        const timeA = a.added_at ? new Date(a.added_at).getTime() : 0;
        const timeB = b.added_at ? new Date(b.added_at).getTime() : 0;

        switch (favState.sort) {
            case 'price_asc':
                return a.start_price - b.start_price;
            case 'price_desc':
                return b.start_price - a.start_price;
            case 'added_asc':
                return timeA - timeB; // Сначала старые лайки
            case 'added_desc':
            default:
                return timeB - timeA; // Сначала новые лайки
        }
    });

    // Фаза 16 (30.08.2026, "старые лоты копятся в избранном"): активные и
    // завершённые торги — разные списки по смыслу (см. обсуждение с
    // пользователем 30.08.2026: не объединять с "Мои анализы", а почистить
    // каждую вкладку отдельно). Основной грид — только активные, закрытые
    // уходят в свёрнутый архив ниже (см. renderFavArchive).
    const active = filtered.filter(l => l.is_active !== false);
    const closed = filtered.filter(l => l.is_active === false);

    // 3. Отрисовка
    if(!active.length) {
        grid.innerHTML = closed.length
            // Всё избранное закрыто — не показываем "пусто", это неверно
            // (лоты есть, просто в архиве), а прямо указываем, где искать.
            ? '<div class="col-span-full text-center py-10 text-sm text-[#94a3b8]">Все избранные лоты завершены — смотрите архив ниже.</div>'
            : emptyStateHtml('ph-heart', 'Пока нет избранного', 'Отмечайте лоты сердечком в списке — они появятся здесь.');
    } else {
        const fragment = document.createDocumentFragment();
        // 2026-10-29 (вариант 3): на сайте ≥1024 «Карточки» — те же карточки, что на Главной (renderLotCardSite)
        const newCards = active.map(lot => isWideBrowser() ? renderLotCardSite({ ...lot, is_favorite: true }) : createCard(lot));
        newCards.forEach(c => fragment.appendChild(c));
        grid.appendChild(fragment);
        revealNewCards(newCards); // Phase 3: stagger fade+y (renderFavorites полностью пересобирает грид каждый раз, это ожидаемо)
    }

    const resultsCount = document.getElementById('favResultsCount');
    if (resultsCount) resultsCount.textContent = `${active.length} ${plural(active.length, 'лот', 'лота', 'лотов')}` + (closed.length ? ` · ${closed.length} завершено` : '');
    renderFavArchive(closed);
    renderFavTable(active); // ДОБАВЛЕНО (платформенный план, фаза 2): тот же
    // отфильтрованный/отсортированный список, что и карточная лента выше —
    // на мобильном/в Telegram таблица скрыта CSS'ом, рендер просто не виден.
}

// =====================================================================
// §5.1 DESIGN_MASTER_PROMPT.md — ЕДИНЫЙ БИЛДЕР СТРОКИ ЛОТА (документ-стиль,
// n8n/Linear). Раньше Избранное/База AI/Мои анализы рисовали три разные
// разметки (два разных <table> + один flex-div) с разной высотой строки,
// разной подачей вердикта (бейдж vs цветная точка) и разным поведением
// клика. renderLotRow(l, ctx) — общая точка: столбцы и их порядок задаёт
// ctx.columns, конкретную разметку столбца — LOT_ROW_CELL_RENDERERS.
//
// ctx.tag: 'tr' для Избранного/Базы AI — они остаются внутри настоящих
// <table> (разметка <table>/<thead> в партиалах не менялась, это PR только
// про содержимое строк), 'div' — для Моих анализов (там и раньше была не
// <tr>, а flex-строка). Содержимое каждого столбца оборачивается в один и
// тот же <span class="lot-row-cell lot-row-cell--X"> независимо от tag —
// для 'tr' он лежит внутри <td>, для 'div' сам является ячейкой; CSS в
// dashboard.css (html.is-browser) стилизует .lot-row-cell одинаково для
// обоих случаев, поэтому строки визуально идентичны с точностью до набора
// колонок.
//
// getId/getPrice — потому что у лота (Избранное/База AI) поле называется
// l.id/l.start_price, а у истории анализов (Мои анализы, /api/analysis/
// history) — l.lot_id/l.price (см. get_user_analysis_history() в
// postgres_client.py); остальные поля (recommendation_score/status,
// title, image_url, location) называются одинаково во всех трёх — их
// рендерят напрямую, без ctx-обёртки.
const LOT_ROW_CELL_RENDERERS = {
    checkbox: (l, ctx) => `<span class="lot-row-cell lot-row-cell--checkbox"><input type="checkbox" class="lot-row-checkbox" ${ctx.isChecked?.(l) ? 'checked' : ''} aria-label="Выбрать лот"></span>`,
    thumb: (l, ctx) => {
        // TASK4 4.5 (§6): renderLotRow вызывается и из мест, что рендерят
        // безусловно (renderFavTable — см. её комментарий: "вызывается из
        // renderFavorites безусловно", результат просто спрятан CSS на
        // мобильном/в Mini App), поэтому IS_TELEGRAM-гейт — не только "на
        // сайте красивее", а страховка, что Mini App ни при каких условиях
        // не получит категорийную заглушку вместо PLACEHOLDER_LOT (§12).
        const fallback = IS_TELEGRAM ? PLACEHOLDER_LOT : getPlaceholderFor(l.category);
        const img = proxyImg(l.image_url, 160) || fallback;
        const alt = escapeHtml(formatLotTitle(l).primary);
        return `<span class="lot-row-cell lot-row-cell--thumb"><img src="${img}" alt="${alt}" onerror="this.onerror=null;this.src='${fallback}';" referrerpolicy="no-referrer" loading="lazy" class="lot-row-thumb"></span>`;
    },
    // ИЗМЕНЕНО (TASK4 4.7, §7): title в общей строке — formatLotTitleSite(),
    // не formatLotTitle() — тот же нормализованный заголовок, что и на
    // карточке (4.4/4.4b), title="" держит полный сырой текст (secondary).
    // Общий builder — Избранное/База AI/Мои анализы получают тот же более
    // чистый заголовок как естественное следствие (§7: "визуально идентичны
    // до набора колонок"), не отдельная правка под них.
    // ИЗМЕНЕНО (TASK5 5.1, §2 п.3/п.8, B-11): title/meta стали block-элементами
    // (CSS ниже) — раньше два inline-span без разделителя, textContent читал
    // «NISSAN ALMERA, 2014На повышение» слитно. Добавлен <span class="sr-only">
    // — accessibility-разделитель, не декоративный ", " для глаз (визуально его
    // не видно, meta и так на своей строке — .lot-row-meta ниже). Заголовок
    // теперь настоящий <a href> (ctx.href, дефолт /workspace/lot/{id}) —
    // средний клик/Cmd-клик/краулер открывают страницу лота напрямую;
    // tabindex="-1" — таб-стоп остаётся один, на самой строке (ctx.onClick +
    // Enter, см. renderLotRow), а не два подряд (ссылка, потом строка).
    title: (l, ctx) => {
        const info = formatLotTitleSite(l);
        const title = escapeHtml(info.primary);
        const titleFull = escapeHtml(info.secondary);
        const meta = ctx.titleMeta ? (ctx.titleMeta(l) || '') : '';
        const sep = meta ? '<span class="sr-only">, </span>' : '';
        const href = escapeHtml(ctx.href ? ctx.href(l) : `/workspace/lot/${ctx.getId(l)}`);
        return `<span class="lot-row-cell lot-row-cell--title"><a class="lot-row-title-link" href="${href}" tabindex="-1"><span class="row-title-ellipsis" title="${titleFull}">${title}</span></a>${sep}${meta}</span>`;
    },
    // ИЗМЕНЕНО (TASK5 5.1, §2 п.4, B-07): регион переполнял ячейку без
    // ellipsis (перенос на 2 строки на «База AI» при узком регионе) —
    // вложенный span с тем же паттерном обрезки, что row-title-ellipsis,
    // полное значение в title="".
    region: (l) => {
        const full = (l.location || l.region || '').trim();
        const short = full.split(',')[0].trim() || '—';
        return `<span class="lot-row-cell lot-row-cell--region"><span class="row-title-ellipsis" title="${escapeHtml(full)}">${escapeHtml(short)}</span></span>`;
    },
    // ДОБАВЛЕНО (TASK4 4.7, §7): бейдж площадки — тот же badge-solid/bg-etp/
    // bg-sauda, что уже использовался в удалённой renderHomeTableRows() и на
    // карточке (4.6), просто теперь в общем словаре ячеек.
    site: (l) => {
        const isE = (l.url || '').includes('adilet');
        return `<span class="lot-row-cell lot-row-cell--site"><span class="badge-solid ${isE ? 'bg-etp' : 'bg-sauda'}">${isE ? 'ETP' : 'SAUDA'}</span></span>`;
    },
    price: (l, ctx) => {
        const id = ctx.getId(l);
        const price = ctx.getPrice ? ctx.getPrice(l) : l.start_price;
        // TASK10 10.3: см. тот же комментарий у renderLotCardSite.
        const leaseLabel = (l.attributes && l.attributes.deal_type === 'lease')
            ? '<span class="text-tertiary lot-row-cell-lease-label">аренда · </span>' : '';
        return `<span class="lot-row-cell lot-row-cell--price">${leaseLabel}${fmtPriceCompact(price)} ₸<span class="spark-holder" data-lot-id="${id}" data-price="${price || 0}"></span></span>`;
    },
    // ДОБАВЛЕНО (TASK4 4.7, §7: "мono-дата + чип срочности по тем же
    // правилам, что §4"): в отличие от карточки (где чип срочности —
    // ДОПОЛНЕНИЕ к дате, уже показанной в мете, и потому виден только
    // ≤3 дня/закрыт), в таблице это ЕДИНСТВЕННОЕ место, где виден срок —
    // renderDeadlineChipHtml() показывается всегда (тот же рендерер/
    // раскраска, что и на карточке — "те же правила", не тот же гейт
    // видимости, для которого в таблице просто нет отдельной строки-меты).
    deadline: (l) => {
        const isClosed = l.is_active === false;
        const html = isClosed
            ? `<span class="text-neg font-bold"><i class="ph-fill ph-lock-simple"></i> Закрыт</span>`
            : renderDeadlineChipHtml(l.application_deadline);
        return `<span class="lot-row-cell lot-row-cell--deadline font-mono-nums">${html}</span>`;
    },
    score: (l) => {
        const score = (typeof l.recommendation_score === 'number') ? l.recommendation_score : null;
        const hasScore = score != null && score > 0;
        const cls = !hasScore ? 'score-none' : (score >= 70 ? 'score-good' : score >= 40 ? 'score-mid' : 'score-bad');
        return `<span class="lot-row-cell lot-row-cell--score">
            <span class="lot-row-score-num ${cls}">${hasScore ? score : '—'}</span>
            <span class="lot-row-score-bar"><span class="lot-row-score-bar-fill ${cls}" style="width:${hasScore ? Math.max(0, Math.min(100, score)) : 0}%"></span></span>
        </span>`;
    },
    // TASK4 4.9 (§11, DESIGN_MASTER_PROMPT.md §7.4: "отсутствие анализа —
    // отсутствие пилюли"): раньше неанализированный лот всё равно получал
    // пилюлю "ТРЕБУЕТ АНАЛИЗА" — тот самый шум, которого §7.4 требует
    // избегать в таблице. Общий рендерер (Избранное/Главная — AI-База
    // всегда содержит уже проанализированные лоты, там ветка не выполняется
    // никогда) — пустая ячейка с «—» вместо пилюли.
    // ИЗМЕНЕНО (TASK5 5.1, §2 п.2, B-02 "скор дважды"): пилюля несёт только
    // слово (rc.label, Title Case — не rc.text, тот ALL CAPS + "NN/100" для
    // Mini App/карточек). Число показываем в пилюле ТОЛЬКО если в этой же
    // строке нет отдельной ячейки score (Избранное — там verdict единственный
    // вердикт-столбец); когда score есть в columns (Главная/База AI/Мои
    // анализы), число уже показано там — дублировать его в пилюле нельзя.
    verdict: (l, ctx) => {
        const analyzed = isRecAnalyzed(l.recommendation_status, l.recommendation_score) && l.recommendation_score != null;
        if (!analyzed) {
            return `<span class="lot-row-cell lot-row-cell--verdict"><span style="color: var(--text-tertiary);">—</span></span>`;
        }
        const rc = getRecBadgeData(l.recommendation_status || 'requires_analysis', l.recommendation_score);
        const hasScoreCol = !!(ctx && ctx.columns && ctx.columns.includes('score'));
        const scoreSuffix = (!hasScoreCol && typeof l.recommendation_score === 'number')
            ? ` <span class="font-mono-nums">${l.recommendation_score}</span>`
            : '';
        return `<span class="lot-row-cell lot-row-cell--verdict"><span class="badge-rec ${rc.class} px-1.5 py-0.5 rounded text-[10px] font-bold inline-flex items-center gap-1"><i class="ph-fill ${rc.icon}"></i> ${escapeHtml(rc.label)}${scoreSuffix}</span></span>`;
    },
    date: (l, ctx) => `<span class="lot-row-cell lot-row-cell--date font-mono-nums">${fmtDate(ctx.getDate ? ctx.getDate(l) : l.added_at)}</span>`,
    actions: (l, ctx) => `<span class="lot-row-cell lot-row-cell--actions">${ctx.renderActions ? (ctx.renderActions(l) || '') : ''}</span>`,
};

function renderLotRow(l, ctx) {
    const tag = ctx.tag || 'div';
    const el = document.createElement(tag);
    el.dataset.lotId = ctx.getId(l);
    el.className = 'lot-row' + (ctx.rowClass ? ` ${ctx.rowClass(l) || ''}` : '');
    el.innerHTML = ctx.columns.map(col => {
        const html = LOT_ROW_CELL_RENDERERS[col](l, ctx);
        // Класс колонки нужен и на самом <td> (не только на вложенном span):
        // table-layout:fixed берёт ширину колонки из <td>/<th>, а не из
        // произвольного элемента внутри него.
        return tag === 'tr' ? `<td class="lot-row-td lot-row-td--${col}">${html}</td>` : html;
    }).join('');

    if (ctx.columns.includes('checkbox')) {
        const cb = el.querySelector('.lot-row-checkbox');
        if (cb) {
            cb.addEventListener('click', (e) => e.stopPropagation());
            cb.addEventListener('change', () => ctx.onCheckToggle?.(l, cb.checked));
        }
    }
    // ДОБАВЛЕНО (TASK5 5.1, §2 п.8): клавиатурная доступность строки — Tab
    // доходит до неё саму (tabindex=0, role="link" — вся строка ведёт себя
    // как одна большая ссылка), Enter переходит туда же, куда клик. Реальный
    // <a> внутри ячейки заголовка (см. title() выше) остаётся с tabindex="-1"
    // (один таб-стоп на строку, не два подряд) — он нужен для среднего
    // клика/Cmd-клика/краулеров, не для последовательной табуляции; такие
    // клики (модификатор или не левая кнопка) НЕ перехватываются — иначе
    // Cmd-клик по заголовку открывал бы новую вкладку и ОДНОВременно
    // навигировал текущую через ctx.onClick.
    if (ctx.onClick) {
        el.classList.add('lot-row--clickable');
        el.setAttribute('role', 'link');
        el.setAttribute('tabindex', '0');
        el.addEventListener('click', (e) => {
            if (e.target.closest('.lot-row-checkbox, .lot-row-cell--actions')) return;
            if (e.ctrlKey || e.metaKey || e.shiftKey || e.button !== 0) return;
            e.preventDefault();
            ctx.onClick(l, el);
        });
        el.addEventListener('keydown', (e) => {
            if (e.key !== 'Enter') return;
            if (e.target.closest('.lot-row-checkbox, .lot-row-cell--actions')) return;
            e.preventDefault();
            ctx.onClick(l, el);
        });
    }
    return el;
}

// ДОБАВЛЕНО (§5.1): переход к отчёту в один клик из строки списка — для
// вкладок, где по определению у каждой строки уже есть готовый анализ
// (База AI — список готовых отчётов; Мои анализы — своя история). В отличие
// от Избранного (там лот может быть ещё не проанализирован — клик по
// строке идёт прямой навигацией на /workspace/lot/{id}, см. renderFavTable()),
// здесь известно заранее — сразу настоящая навигация на страницу отчёта
// (§5.4: полная перезагрузка, не SPA-переход). Если отчёта на самом деле
// нет (например, статус "в очереди" в Моих анализах) — workspace_analysis_
// page() на сервере уводит на страницу лота, см. её комментарий.
function goToAnalysisPage(lotId) {
    if (!IS_TELEGRAM) {
        window.location.href = `/workspace/analysis/${lotId}`;
    } else {
        openModal(lotId);
    }
}

// ДОБАВЛЕНО (§5.1, п.4 — "два разных пустых состояния"): общий рендерер для
// Избранного/Базы AI, стиль 1:1 с уже существующим у Моих анализов (см.
// renderAnalysesList выше) — просто параметризован текстом и именем иконки,
// чтобы не плодить третью копию той же разметки.
// ИЗМЕНЕНО (TASK5 5.2, §3 «Empty states»): добавлен необязательный actionHtml —
// «Сбросить фильтры»/«Перейти в каталог» и т.п., готовую кнопку строит
// вызывающий код (он один знает нужный текст/обработчик для конкретного
// экрана), эта функция просто вставляет её под текстом. Текст
// "Ничего не найдено" заменён на «По этим фильтрам ничего нет» — конкретнее
// говорит, что фильтры сузили список, а не что список пуст сам по себе.
function lotListEmptyStateHtml(isFiltered, icon, emptyTitle, emptyHint, actionHtml = '') {
    return isFiltered
        ? `<div class="text-center py-10 bg-surface rounded-card border border-subtle">
            <i class="ph-fill ph-funnel-x text-3xl text-tertiary mb-2"></i>
            <p class="text-sm font-bold text-secondary">По этим фильтрам ничего нет</p>
            <p class="text-[11px] text-tertiary mt-1">Попробуйте изменить поиск или фильтр</p>
            ${actionHtml ? `<div class="mt-3">${actionHtml}</div>` : ''}
           </div>`
        : `<div class="text-center py-10 bg-surface rounded-card border border-subtle">
            <i class="ph-fill ${icon} text-4xl text-secondary mb-2"></i>
            <p class="text-sm font-bold text-secondary">${emptyTitle}</p>
            <p class="text-[11px] text-tertiary mt-1 max-w-xs mx-auto">${emptyHint}</p>
            ${actionHtml ? `<div class="mt-3">${actionHtml}</div>` : ''}
           </div>`;
}

// --- ДОБАВЛЕНО (платформенный план, фаза 2 «Избранное»): табличный вид для
// браузера на широком экране. #favTableWrap скрыт по умолчанию и появляется
// только под html.is-browser + ≥1024px (см. dashboard.css) — на мобильном и
// в Telegram эти функции по-прежнему выполняются (renderFavTable вызывается
// из renderFavorites безусловно), просто их результат никогда не виден. ---
let favSelected = new Set();

function renderFavTable(activeLots) {
    const body = document.getElementById('favTableBody');
    if (!body) return;
    // Выбор сохраняем только для лотов, которые всё ещё в списке (иначе
    // после смены фильтра счётчик "выбрано" мог бы указывать на лоты,
    // которых уже не видно).
    const visibleIds = new Set(activeLots.map(l => l.id));
    favSelected.forEach(id => { if (!visibleIds.has(id)) favSelected.delete(id); });

    body.innerHTML = '';
    if (!activeLots.length) {
        // §5.1 п.4: "избранного нет вообще" (favState.lotsCache пуст) — не то
        // же самое, что "фильтр площадки/категории/поиска/вердикта ничего не
        // оставил".
        const isFiltered = favState.lotsCache.length > 0;
        const actionHtml = isFiltered
            ? `<button type="button" onclick="resetFavFilters()" class="btn-secondary text-xs">Сбросить фильтры</button>`
            : `<a href="/workspace" class="btn-secondary text-xs">Перейти в каталог</a>`;
        body.innerHTML = `<tr><td colspan="7" class="lot-row-empty">${lotListEmptyStateHtml(
            isFiltered, 'ph-heart', 'В избранном пока пусто',
            'Нажмите на сердечко у лота на Главной или в Базе AI — он появится здесь.',
            actionHtml
        )}</td></tr>`;
        updateFavBulkBar();
        return;
    }

    const fragment = document.createDocumentFragment();
    activeLots.forEach(l => {
        const tr = renderLotRow(l, {
            tag: 'tr',
            columns: ['checkbox', 'thumb', 'title', 'site', 'price', 'verdict', 'date'],
            getId: (x) => x.id,
            getDate: (x) => x.added_at,
            isChecked: (x) => favSelected.has(x.id),
            onCheckToggle: (x, checked) => {
                if (checked) favSelected.add(x.id); else favSelected.delete(x.id);
                updateFavBulkBar();
            },
            // §5.1/§5.4: Избранное не в списке "анализ есть всегда" (в
            // отличие от Базы AI/Моих анализов) — строка всегда ведёт на
            // страницу лота; если у пользователя уже есть свой отчёт, кнопка
            // "ОТКРЫТЬ АНАЛИЗ" на ней сама ведёт на /workspace/analysis/{id}
            // (populateLotDetail()). Настоящая навигация (не SPA), это
            // единственный ряд-триггер в файле, где строка всегда — <tr> на
            // сайте (Mini App не показывает эту таблицу вовсе, см. её же
            // комментарий у renderFavTable()).
            onClick: (x) => { window.location.href = `/workspace/lot/${x.id}`; },
        });
        fragment.appendChild(tr);
    });
    body.appendChild(fragment);
    attachSparklines(body); // D4 — см. её комментарий у attachSparklines()
    updateFavBulkBar();
}

// ИЗМЕНЕНО (TASK5 5.2, §3: "bulk bar заменяет строку заголовка (n8n-
// паттерн)... никогда не видна при 0 выбранных" — B-04): #favHeaderBulkBar/
// header — взаимоисключающие состояния одного и того же ряда сайта.
// ИЗМЕНЕНО (TASK5 5.3b, ревью): #favBulkBar (исходный узел 04fb221, внутри
// #favTableWrap) больше не показывается визуально ни на одной площадке —
// восстановлен ради DOM-паритета с Mini App (miniapp-render-diff.mjs), его
// .hidden/count по-прежнему считаются здесь же (дёшево, не удаляем логику),
// но видимый на сайте bulk-бар — #favHeaderBulkBar, отдельный site-only
// узел (favHeaderRow в favorites.html). Мобильный/Mini App — оба узла
// либо отсутствуют в DOM (favHeaderBulkBar, только surface=='site'), либо
// невидимы (favBulkBar — #favTableWrap целиком display:none).
function updateFavBulkBar() {
    const bar = document.getElementById('favBulkBar');
    const count = document.getElementById('favBulkCount');
    const selectAll = document.getElementById('favSelectAll');
    const headerBar = document.getElementById('favHeaderBulkBar');
    const headerCount = document.getElementById('favHeaderBulkCount');
    const headerDefault = document.getElementById('favHeaderDefault');
    const hasSelection = favSelected.size > 0;
    if (bar) {
        bar.classList.toggle('hidden', !hasSelection);
        bar.classList.toggle('flex', hasSelection);
    }
    if (count) count.textContent = String(favSelected.size);
    if (headerBar) {
        headerBar.classList.toggle('hidden', !hasSelection);
        headerBar.classList.toggle('flex', hasSelection);
    }
    if (headerCount) headerCount.textContent = String(favSelected.size);
    if (headerDefault) headerDefault.classList.toggle('hidden', hasSelection);
    if (selectAll) {
        const rows = document.querySelectorAll('#favTableBody .lot-row-checkbox');
        selectAll.checked = rows.length > 0 && favSelected.size === rows.length;
        selectAll.indeterminate = favSelected.size > 0 && favSelected.size < rows.length;
    }
}

window.toggleFavSelectAll = (masterCheckbox) => {
    document.querySelectorAll('#favTableBody tr[data-lot-id]').forEach(tr => {
        const id = Number(tr.dataset.lotId);
        const cb = tr.querySelector('.lot-row-checkbox');
        if (cb) cb.checked = masterCheckbox.checked;
        if (masterCheckbox.checked) favSelected.add(id); else favSelected.delete(id);
    });
    updateFavBulkBar();
};

// Переиспользует /api/favorites/toggle — тот же эндпоинт, что и сердечко в
// карточке/детали лота (см. toggleDetailFav) — новой backend-логики нет.
window.bulkRemoveFavorites = async () => {
    if (!favSelected.size) return;
    const ids = Array.from(favSelected);
    const bar = document.getElementById('favBulkBar');
    const btn = bar ? bar.querySelector('button') : null;
    if (btn) { btn.disabled = true; btn.style.opacity = '0.6'; }
    try {
        const results = await Promise.allSettled(ids.map(id => fetch('/api/favorites/toggle', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ user_id: userId, lot_id: id })
        }).then(r => { if (!r.ok) throw new Error(`HTTP ${r.status}`); return id; })));

        const removedIds = new Set(results.filter(r => r.status === 'fulfilled').map(r => r.value));
        const failedCount = results.length - removedIds.size;

        favState.lotsCache = favState.lotsCache.filter(l => !removedIds.has(l.id));
        favSelected.clear();
        renderFavorites();

        if (failedCount > 0) {
            tg.showAlert(`Не удалось убрать ${failedCount} из ${ids.length} лотов. Попробуйте ещё раз.`);
        }
    } catch (e) {
        console.error('[bulkRemoveFavorites]', e);
        tg.showAlert('Не удалось выполнить массовое действие. Попробуйте позже.');
    } finally {
        if (btn) { btn.disabled = false; btn.style.opacity = ''; }
    }
};

// Сортировка кликом по заголовку таблицы — переиспользует favState.sort и
// renderFavorites() целиком (тот же пересчёт, что и мобильные чипы сортировки
// setFavSort/toggleFavSort), просто без привязки к конкретной кнопке-чипу.
window.setFavTableSort = (mode) => {
    favState.sort = mode;
    // D2: держим #favSortSelect в синхроне — иначе после клика по заголовку
    // таблицы выпадающий список сортировки продолжал бы показывать старое
    // значение, хотя реальная сортировка (favState.sort) уже сменилась.
    const sel = document.getElementById('favSortSelect');
    if (sel) sel.value = mode;
    renderFavorites();
};

// Фаза 16: секция "Завершённые" под основным гридом избранного — см.
// #favArchiveSection в index.html. Свёрнута по умолчанию (toggleFavArchive
// сохраняет состояние только в памяти вкладки — намеренно не в
// localStorage, это не настройка, а просто "не мозолить глаза при каждом
// заходе"), список внутри собирается из тех же карточек createCard(), что
// и основной грид — просто отфильтрованных is_active === false.
let favArchiveExpanded = false;

function renderFavArchive(closedLots) {
    const section = document.getElementById('favArchiveSection');
    const countEl = document.getElementById('favArchiveCount');
    const bodyEl = document.getElementById('favArchiveBody');
    const gridEl = document.getElementById('favArchiveGrid');
    if (!section || !countEl || !bodyEl || !gridEl) return;

    if (!closedLots.length) {
        section.classList.add('hidden');
        return;
    }
    section.classList.remove('hidden');
    countEl.textContent = String(closedLots.length);

    gridEl.innerHTML = '';
    if (favArchiveExpanded) {
        const fragment = document.createDocumentFragment();
        // сайт ≥1024: блоки Главной; торги завершены — «Анализ →» не предлагаем (actionsHtml пустой)
        closedLots.forEach(lot => fragment.appendChild(isWideBrowser() ? renderLotCardSite({ ...lot, is_favorite: true }, { actionsHtml: '' }) : createCard(lot)));
        gridEl.appendChild(fragment);
    }
    // ДОБАВЛЕНО (аудит интерфейса): та же табличная десктоп-версия с массовым
    // выбором, что уже есть у активного списка (renderFavTable) — раньше
    // архив на любой ширине был только сеткой карточек с одной кнопкой
    // "убрать все". Строим только пока раскрыт, тем же приёмом, что и грид
    // выше (не тратим работу на скрытый аккордеон).
    renderFavArchiveTable(favArchiveExpanded ? closedLots : []);
}

// ИЗМЕНЕНО (TASK5 5.2, §3 «то же renderLotRow... не вторая bulk-панель»):
// раньше — отдельный самодельный рендерер (fav-row-*/fav-th-* классы,
// руками собранный <tr>.innerHTML, «ТРЕБУЕТ АНАЛИЗА» текстом вместо пустой
// ячейки) С СОБСТВЕННЫМ построчным выбором/bulk-баром — задание прямо
// говорит "не вторая bulk-панель": у архива одна ghost-ссылка «Убрать все
// завершённые» в заголовке секции (clearClosedFavorites(), уже
// существовала), построчного выбора здесь больше нет вовсе — колонка
// checkbox не входит в columns. Тот же builder/остальные колонки, что и у
// активной таблицы (renderFavTable()), плюс rowClass 'lot-row--archived'
// (приглушение + грейскейл миниатюры, dashboard.css) — единственная
// визуальная разница архива от активного списка.
function renderFavArchiveTable(closedLots) {
    const body = document.getElementById('favArchiveTableBody');
    if (!body) return;
    body.innerHTML = '';
    if (!closedLots.length) {
        body.innerHTML = '<tr><td colspan="6" class="lot-row-empty">Нет завершённых лотов.</td></tr>';
        return;
    }

    const fragment = document.createDocumentFragment();
    closedLots.forEach(l => {
        const tr = renderLotRow(l, {
            tag: 'tr',
            columns: ['thumb', 'title', 'site', 'price', 'verdict', 'date'],
            getId: (x) => x.id,
            getDate: (x) => x.added_at,
            rowClass: () => 'lot-row--archived',
            onClick: (x) => { window.location.href = `/workspace/lot/${x.id}`; },
        });
        fragment.appendChild(tr);
    });
    body.appendChild(fragment);
    attachSparklines(body); // D4 — см. её комментарий у attachSparklines()
}

window.toggleFavArchive = () => {
    favArchiveExpanded = !favArchiveExpanded;
    const body = document.getElementById('favArchiveBody');
    const caret = document.getElementById('favArchiveCaret');
    if (body) body.classList.toggle('hidden', !favArchiveExpanded);
    if (caret) caret.style.transform = favArchiveExpanded ? 'rotate(180deg)' : '';
    if (favArchiveExpanded) {
        // Список внутри архива не строился, пока был свёрнут (см.
        // renderFavArchive) — дособираем его сейчас, при раскрытии.
        renderFavArchive(favState.lotsCache.filter(l => l.is_active === false));
    }
};

window.clearClosedFavorites = () => {
    const closedCount = favState.lotsCache.filter(l => l.is_active === false).length;
    if (!closedCount) return;
    tg.showConfirm(
        `Убрать ${closedCount} завершённых лотов из избранного? Само избранное на активные лоты не затронет.`,
        async (confirmed) => {
            if (!confirmed) return;
            try {
                const r = await fetch(`/api/favorites/clear_closed?user_id=${userId}`, { method: 'POST' });
                if (!r.ok) throw new Error(`HTTP ${r.status}`);
                // Не перезапрашиваем весь /api/favorites — известно локально,
                // что именно удалилось (все is_active === false), дешевле
                // отфильтровать кэш на месте.
                favState.lotsCache = favState.lotsCache.filter(l => l.is_active !== false);
                renderFavorites();
            } catch (e) {
                console.error('[clearClosedFavorites]', e);
                tg.showAlert('Не удалось очистить архив. Попробуйте позже.');
            }
        }
    );
};

window.toggleFavSort = (btn) => {
    const span = btn.querySelector('span');
    if(favState.sort === 'date_desc') { 
        favState.sort = 'date_asc'; 
        span.innerText = 'Старые'; 
    } 
    else if(favState.sort === 'date_asc') { 
        favState.sort = 'price_asc'; 
        span.innerText = 'Дешевые'; 
    }
    else if(favState.sort === 'price_asc') { 
        favState.sort = 'price_desc'; 
        span.innerText = 'Дорогие'; 
    }
    else { 
        favState.sort = 'date_desc'; 
        span.innerText = 'Новые'; 
    }
    renderFavorites();
}

// Search Listener
document.getElementById('searchInput').addEventListener('input', (e) => {
    clearTimeout(searchTimeout);
    searchTimeout = setTimeout(() => { state.query = e.target.value; loadLots(); }, 600);
});

// Phase 6: клавиатурные шорткаты для десктопа (на телефоне клавиатуры нет —
// обработчик просто никогда не сработает, поэтому мобильному сценарию
// ничем не мешает).
//   Escape — закрыть то модальное окно/панель, которое сейчас реально видно
//            (проверяем в порядке от самого "верхнего" по z-index к нижнему,
//            чтобы не дёргать сразу несколько закрывающих функций разом).
//   /      — фокус в поиск, но только если фокус ещё не в текстовом поле
//            (иначе перехватили бы обычный ввод "/" в уже открытом инпуте).
//   g ЗАТЕМ h/f/b/p/a — D6 (DESIGN_UPGRADE_PROMPT.md §6, "github-style"
//            переходы по вкладкам): см. GSHORTCUT_MAP и обработку ниже.
//   ?      — D6: оверлей с картой шорткатов (см. #shortcutsModal).
// Стрелочная навигация по списку сознательно не добавляется (вне скоупа).
document.addEventListener('keydown', (e) => {
    // Не мешаем системным/браузерным сочетаниям (Cmd/Ctrl/Alt+что-то)
    if (e.metaKey || e.ctrlKey || e.altKey) return;

    if (e.key === 'Escape') {
        // D3 (DESIGN_UPGRADE_PROMPT.md §6, ⌘K палитра)/D6 (карта шорткатов) —
        // проверяем ПЕРВЫМИ: самый верхний z-index из всех модалок в этой
        // ветке (10000, как и detailModal/analysisModal, но открываются
        // последними по времени).
        const cmdkModal = document.getElementById('cmdkModal');
        const shortcutsModal = document.getElementById('shortcutsModal');
        const subModal = document.getElementById('subModal');
        const compareModal = document.getElementById('compareModal');
        const analysisModal = document.getElementById('analysisModal');
        const pdfModal = document.getElementById('pdfModal');
        const modalAnalyses = document.getElementById('modalAnalyses');
        const detailModal = document.getElementById('detailModal');
        const filterPanel = document.getElementById('filterPanel');
        const gFilterPanel = document.getElementById('gFilterPanel');

        if (cmdkModal && !cmdkModal.classList.contains('hidden')) {
            window.closeCommandPalette();
        } else if (shortcutsModal && !shortcutsModal.classList.contains('hidden')) {
            window.closeShortcutsModal();
        } else if (subModal && subModal.style.display === 'flex') {
            closeSub();
        } else if (compareModal && !compareModal.classList.contains('hidden')) {
            window.closeCompareModal();
        } else if (analysisModal && !analysisModal.classList.contains('hidden')) {
            closeAnalysisModal();
        } else if (pdfModal && pdfModal.classList.contains('open')) {
            window.closePdf();
        } else if (modalAnalyses && !modalAnalyses.classList.contains('translate-x-full')) {
            closeAnalysesHistory();
        } else if (detailModal && detailModal.classList.contains('open')) {
            closeModal();
        } else if (filterPanel && filterPanel.classList.contains('open')) {
            window.toggleFilters(true);
        } else if (gFilterPanel && gFilterPanel.classList.contains('open')) {
            window.toggleGFilters(true);
        }
        return;
    }

    if (e.key === '/') {
        const active = document.activeElement;
        const isTyping = !!active && (
            active.tagName === 'INPUT' ||
            active.tagName === 'TEXTAREA' ||
            active.isContentEditable
        );
        if (isTyping) return; // не перехватываем обычный ввод "/" в уже активном поле

        const searchInput = document.getElementById('searchInput');
        if (searchInput) {
            e.preventDefault();
            searchInput.focus();
        }
        return;
    }

    // D6 (DESIGN_UPGRADE_PROMPT.md §6, "github-style" g+буква): не перехваты-
    // ваем ни "g", ни вторую букву, пока фокус в текстовом поле — иначе обычный
    // набор текста (например, "город" в поиске) угонял бы фокус на вкладку.
    const active = document.activeElement;
    const isTyping = !!active && (
        active.tagName === 'INPUT' ||
        active.tagName === 'TEXTAREA' ||
        active.isContentEditable
    );
    if (isTyping) return;

    if (e.key === '?') {
        e.preventDefault();
        window.openShortcutsModal();
        return;
    }

    if (e.key === 'g' || e.key === 'G') {
        gPending = true;
        clearTimeout(gPendingTimer);
        // Окно ожидания второй буквы — 600мс (тот же порядок величины, что и
        // у GitHub) — не потерять "g", если вторая буква запаздывает, но и не
        // висеть вечно, если пользователь просто нажал "g" не для шортката.
        gPendingTimer = setTimeout(() => { gPending = false; }, 600);
        return;
    }

    if (gPending) {
        gPending = false;
        clearTimeout(gPendingTimer);
        const nav = GSHORTCUT_MAP[e.key.toLowerCase()];
        if (nav && document.getElementById('screen-' + nav)) {
            e.preventDefault();
            const link = document.querySelector(`a[data-nav="${nav}"]`);
            if (link) link.click();
        }
    }
});

// D6 (DESIGN_UPGRADE_PROMPT.md §6): те же 5 вкладок, что и SCREEN_TO_PATH/
// ⌘K-палитра выше — единая карта "буква -> nav", чтобы не заводить третий
// список вкладок в файле. 'a' (Мои анализы) — не из брифа буквально (там
// перечислены только h/f/b/p), добавлена по аналогии: раз уже есть 5-я
// вкладка и карта шорткатов её всё равно показывает, оставлять её недостижимой
// клавиатурой было бы странной дырой ровно в том месте, которое эта фича
// должна закрывать.
const GSHORTCUT_MAP = { h: 'home', f: 'favorites', b: 'global', p: 'profile', a: 'analyses' };
let gPending = false;
let gPendingTimer = null;

window.openShortcutsModal = function () {
    const modal = document.getElementById('shortcutsModal');
    if (!modal) return;
    modal.classList.remove('hidden');
    modal.classList.add('flex');
};

window.closeShortcutsModal = function () {
    const modal = document.getElementById('shortcutsModal');
    if (!modal) return;
    modal.classList.add('hidden');
    modal.classList.remove('flex');
};

// =======================================================
// D3 (DESIGN_UPGRADE_PROMPT.md §6): ⌘K КОМАНДНАЯ ПАЛИТРА
// =======================================================
// Отдельный keydown-слушатель (не внутри Phase 6 выше — тот сразу выходит
// на любом metaKey/ctrlKey, это ему и нужно, чтобы не мешать системным
// сочетаниям). Один плоский список результатов трёх типов — навигация (5
// вкладок SCREEN_TO_PATH), быстрые действия и лоты (уже отрисованные на
// Главной — мгновенно, из cmdkLoadedLots — плюс debounced /api/lots?query=
// для всего остального). Overlay — новая разметка (partials/modals/
// command_palette.html), но тот же язык, что и у остальных модалок (fixed +
// z-[10000] + scrim), и Escape закрывает её той же веткой общего
// обработчика клавиш выше. Zero deps, ~150 строк.
let cmdkResultItems = [];
let cmdkActiveIdx = -1;
let cmdkSearchTimer = null;
let cmdkSearchAbort = null;
let cmdkSearchToken = 0; // отбрасываем ответ устаревшего запроса, если пришёл после более нового

const CMDK_NAV_LABELS = {
    home: 'Главная', favorites: 'Избранное', global: 'База AI',
    profile: 'Профиль', analyses: 'Мои анализы',
};

function cmdkNavItems() {
    return Object.keys(SCREEN_TO_PATH).map(screenId => {
        const nav = screenId.replace('screen-', '');
        return {
            kind: 'nav', icon: 'ph-arrow-right',
            title: CMDK_NAV_LABELS[nav] || nav,
            hint: SCREEN_TO_PATH[screenId],
            run: () => {
                window.closeCommandPalette();
                // Реальный <a data-nav> клик — та же логика (SPA-переход +
                // history.pushState + гейт логина), что и у обычной навигации
                // (см. document.addEventListener('click', ...) выше), без
                // дублирования её здесь ещё раз.
                const link = document.querySelector(`a[data-nav="${nav}"]`);
                if (link) link.click();
            },
        };
    });
}

function cmdkActionItems() {
    const items = [{
        kind: 'action', icon: 'ph-credit-card',
        title: 'Пополнить баланс', hint: 'Пакеты анализов и оплата',
        run: () => { window.closeCommandPalette(); openSubscription(); },
    }];
    // «Экспорт CSV» — только админам, тот же эндпоинт и та же auth-модель
    // (браузерная сессионная кука через admin_id), что и в консоли /admin —
    // см. require_admin()/admin_export_users_csv() в api_server.py.
    if (userProfile && userProfile.is_admin) {
        items.push({
            kind: 'action', icon: 'ph-download-simple',
            title: 'Экспорт CSV', hint: 'Список пользователей (админ)',
            run: () => {
                window.closeCommandPalette();
                window.open(`/api/admin/users/export?admin_id=${userProfile.user_id}`, '_blank');
            },
        });
    }
    return items;
}

function cmdkLotItem(lot) {
    return {
        kind: 'lot', icon: 'ph-cube',
        title: formatLotTitle(lot).primary,
        hint: lot.start_price ? `${fmtPriceCompact(lot.start_price)} ₸` : '',
        run: () => {
            window.closeCommandPalette();
            if (!IS_TELEGRAM) { window.location.href = `/workspace/lot/${lot.id}`; return; }
            openModal(lot.id);
        },
    };
}

function cmdkMatchesQuery(lot, q) {
    return (lot.title || '').toLowerCase().includes(q) ||
        String(lot.registered_number || '').toLowerCase().includes(q);
}

function cmdkRenderItems(items) {
    const results = document.getElementById('cmdkResults');
    const empty = document.getElementById('cmdkEmpty');
    if (!results || !empty) return;

    cmdkResultItems = items;
    cmdkActiveIdx = items.length ? 0 : -1;

    results.innerHTML = items.map((item, i) => `
        <div class="cmdk-item${i === 0 ? ' active' : ''}" data-idx="${i}" role="option" aria-selected="${i === 0}">
            <i class="ph-bold ${item.icon}"></i>
            <span class="cmdk-item-title">${escapeHtml(item.title)}</span>
            ${item.hint ? `<span class="cmdk-item-hint">${escapeHtml(item.hint)}</span>` : ''}
        </div>
    `).join('');
    empty.style.display = items.length ? 'none' : 'block';
}

function cmdkSearchLotsRemote(q) {
    clearTimeout(cmdkSearchTimer);
    cmdkSearchTimer = setTimeout(async () => {
        if (cmdkSearchAbort) cmdkSearchAbort.abort();
        cmdkSearchAbort = new AbortController();
        const token = ++cmdkSearchToken;
        try {
            const res = await fetch(`/api/lots?query=${encodeURIComponent(q)}&limit=6`, { signal: cmdkSearchAbort.signal });
            const remoteLots = await res.json();
            // Устарел, если инпут с тех пор поменялся или палитра закрылась —
            // не подменяем уже показанные (более новые) результаты.
            const input = document.getElementById('cmdkInput');
            if (token !== cmdkSearchToken || !input || input.value.trim().toLowerCase() !== q) return;

            const known = new Set(cmdkResultItems.filter(i => i.kind === 'lot').map(i => i.__id));
            const extra = (Array.isArray(remoteLots) ? remoteLots : [])
                .filter(l => !known.has(l.id))
                .slice(0, 6)
                .map(l => Object.assign(cmdkLotItem(l), { __id: l.id }));
            if (extra.length) cmdkRenderItems([...cmdkResultItems, ...extra]);
        } catch (e) {
            if (e.name !== 'AbortError') console.error('[cmdkSearchLotsRemote]', e);
        }
    }, 250);
}

function cmdkRender(rawQuery) {
    const q = rawQuery.trim().toLowerCase();

    if (!q) {
        clearTimeout(cmdkSearchTimer);
        cmdkRenderItems([...cmdkNavItems(), ...cmdkActionItems()]);
        return;
    }

    const nav = cmdkNavItems().filter(i => i.title.toLowerCase().includes(q));
    const actions = cmdkActionItems().filter(i => i.title.toLowerCase().includes(q));
    const localLots = cmdkLoadedLots
        .filter(l => cmdkMatchesQuery(l, q))
        .slice(0, 6)
        .map(l => Object.assign(cmdkLotItem(l), { __id: l.id }));

    cmdkRenderItems([...nav, ...actions, ...localLots]);

    // Реальный поиск лотов имеет смысл только от осмысленного запроса —
    // на 1 символе /api/lots?query= вернул бы слишком широкий, бесполезный
    // список (та же граница, что и у обычного поля поиска на Главной).
    if (q.length >= 2) cmdkSearchLotsRemote(q);
}

function cmdkSetActive(idx) {
    const results = document.getElementById('cmdkResults');
    if (!results || !cmdkResultItems.length) return;
    cmdkActiveIdx = (idx + cmdkResultItems.length) % cmdkResultItems.length;
    results.querySelectorAll('.cmdk-item').forEach((el, i) => {
        const isActive = i === cmdkActiveIdx;
        el.classList.toggle('active', isActive);
        el.setAttribute('aria-selected', String(isActive));
        if (isActive) el.scrollIntoView({ block: 'nearest' });
    });
}

window.openCommandPalette = function () {
    const modal = document.getElementById('cmdkModal');
    const input = document.getElementById('cmdkInput');
    if (!modal || !input) return;
    modal.classList.remove('hidden');
    modal.classList.add('flex');
    input.value = '';
    cmdkRender('');
    input.focus();
};

window.closeCommandPalette = function () {
    const modal = document.getElementById('cmdkModal');
    if (!modal) return;
    modal.classList.add('hidden');
    modal.classList.remove('flex');
    clearTimeout(cmdkSearchTimer);
    if (cmdkSearchAbort) cmdkSearchAbort.abort();
};

document.addEventListener('keydown', (e) => {
    if ((e.metaKey || e.ctrlKey) && !e.shiftKey && !e.altKey && (e.key === 'k' || e.key === 'K')) {
        e.preventDefault();
        const modal = document.getElementById('cmdkModal');
        if (modal && !modal.classList.contains('hidden')) {
            window.closeCommandPalette();
        } else {
            window.openCommandPalette();
        }
    }
});

document.addEventListener('DOMContentLoaded', () => {
    const input = document.getElementById('cmdkInput');
    const results = document.getElementById('cmdkResults');
    if (!input || !results) return;

    input.addEventListener('input', () => cmdkRender(input.value));

    input.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowDown') {
            e.preventDefault();
            cmdkSetActive(cmdkActiveIdx + 1);
        } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            cmdkSetActive(cmdkActiveIdx - 1);
        } else if (e.key === 'Enter') {
            e.preventDefault();
            const item = cmdkResultItems[cmdkActiveIdx];
            if (item) item.run();
        }
        // Esc обрабатывается общим обработчиком клавиш выше (пузырится
        // естественным образом — здесь preventDefault не вызывается).
    });

    results.addEventListener('click', (e) => {
        const row = e.target.closest('.cmdk-item');
        if (!row) return;
        const item = cmdkResultItems[Number(row.dataset.idx)];
        if (item) item.run();
    });
});

// D2 (DESIGN_UPGRADE_PROMPT.md §5.1, аудит "пробел на 768px"): #headerSpacer/
// #gHeaderSpacer резервируют место под шапку, ТОЛЬКО когда она реально
// position:fixed (узкий экран, <640px — см. @media(max-width:639px) в
// style.css). На 640–1023px шапка уже обычный блок в потоке (десктопный
// сайдбар/рейл появляется только с 1024px, см. dashboard.css), и спейсер,
// продолжающий резервировать место "под фиксацию", создавал точно тот же
// пустой зазор, что чинили для <640px 03.09.2026 — просто в другом
// диапазоне ширины, который тогда не проверяли. Общая точка входа вместо
// разных копий этой логики в switchScreen()/toggleFilters()/window.onload.
function syncHeaderSpacer(headerId, spacerId) {
    const header = document.getElementById(headerId);
    const spacer = document.getElementById(spacerId);
    if (!header || !spacer) return;
    if (getComputedStyle(header).position !== 'fixed') {
        spacer.style.height = '0px';
        return;
    }
    spacer.style.height = (header.offsetHeight + 20) + 'px';
}

// Init
window.onload = async () => {
    // Вне Telegram (сайт, обычный браузер) — ничего не грузим и не рендерим,
    // пока посетитель не войдёт через Telegram (см. ensureAuthenticated
    // выше). renderLoginGate() сама показывает экран входа; когда она это
    // сделала, дальше по этому запуску делать нечего — новая загрузка
    // произойдёт после успешного входа и редиректа на "/".
    const authed = await ensureAuthenticated();
    if (!authed) return;

    // TASK8 8.4 (§3, "Tab titles"): лот/анализ получают meta_title с
    // сервера (см. _render_workspace() в api_server.py), а
    // profile/favorites/reports/analyses — нет, задача прямо запрещает
    // серверные правки для этого пункта. Экран уже отрисован сервером
    // активным (#screen-*.active — тот же признак, которым сам Jinja
    // решает, что показать, см. active_screen в base.html), клиенту
    // остаётся только прочитать его и один раз выставить <title>.
    if (!IS_TELEGRAM) {
        const SCREEN_TAB_TITLES = { favorites: 'Избранное', global: 'База AI', profile: 'Профиль', analyses: 'Мои анализы' };
        const activeScreenId = document.querySelector('.screen.active')?.id;
        const screenName = activeScreenId && activeScreenId.replace('screen-', '');
        if (screenName && SCREEN_TAB_TITLES[screenName]) {
            document.title = `${SCREEN_TAB_TITLES[screenName]} — Auction Detective`;
        }
    }

    syncHeaderSpacer('mainHeader', 'headerSpacer');
    // НАЙДЕНО (жалоба "с телефона появился пробел", 03.09.2026), ВТОРАЯ,
    // РАБОЧАЯ ПОПЫТКА — первая (единоразовый setTimeout(...,600) с
    // повторным замером) здесь стояла раньше и не решила проблему на
    // реальном телефоне (подтверждено пользователем): любая фиксированная
    // задержка — это угадывание момента, когда шрифт иконок (Phosphor,
    // грузится с CDN, window 'load' его не ждёт) и любой другой асинхронный
    // контент шапки успеют доехать на конкретной сети конкретного
    // устройства — и она может оказаться либо избыточной, либо
    // недостаточной. ResizeObserver вместо этого следит за РЕАЛЬНОЙ высотой
    // #mainHeader/#gHeader и пересчитывает спейсер при каждом её изменении,
    // сколько бы их ни случилось и когда бы они ни случились — включая
    // открытие/закрытие панели фильтров (она физически внутри #mainHeader,
    // так что уже покрыта тем же наблюдателем, отдельный код в
    // toggleFilters() для этого больше не нужен) и переключение на вкладку
    // "База AI" (заменяет прежний одноразовый setTimeout(...,50) в
    // switchScreen — он остаётся для мгновенной первой прикидки, но теперь
    // не единственная защита).
    function watchHeaderSpacer(headerId, spacerId, panelId) {
        const header = document.getElementById(headerId);
        const spacer = document.getElementById(spacerId);
        if (!header || !spacer || typeof ResizeObserver === 'undefined') return;
        const ro = new ResizeObserver(() => {
            const panel = panelId ? document.getElementById(panelId) : null;
            if (panel && panel.classList.contains('open')) return; // открытая панель сама считает нужную высоту (см. toggleFilters)
            syncHeaderSpacer(headerId, spacerId);
        });
        ro.observe(header);
    }
    watchHeaderSpacer('mainHeader', 'headerSpacer', 'filterPanel');
    watchHeaderSpacer('gHeader', 'gHeaderSpacer', null);

    // ОТКАЧЕНО (обратная связь 03.09.2026): здесь стояла экспериментальная
    // "прячущаяся при скролле" шапка (setupHeaderScrollCollapse — сначала
    // бинарная, потом пропорциональная версия) — пользователь попробовал
    // обе и попросил вернуть как было. Вместо этого проблема "категории
    // вытесняют место на телефоне" решена ниже, в CSS (dashboard.css) —
    // на узком браузере (телефон, вне Telegram) строка категорий снова
    // скроллится горизонтально, как в самом Mini App, вместо переноса всех
    // категорий сразу. На широком браузере (ПК) перенос строк остаётся
    // как есть — этот код тут был единственным местом, которое трогало
    // #mainHeader/#gHeader, поэтому откат — просто его удаление.

    layoutDesktopFilterRail(); // ДОБАВЛЕНО (платформенный план, фаза 4) — до loadLots(), т.к. может повлиять на итоговую высоту #mainHeader (панель фильтров либо в нём, либо в рейле)
    initDesktopInstantFilters(); // TASK4 4.3 — навешивается один раз, до первого взаимодействия с рейлом
    restoreHomeFiltersFromUrl(); // 2026-10-29: фильтры из адреса (/workspace?cat=…) — до первой загрузки и счётчика «Сбросить»
    updateRailResetLabel(); // TASK4 4.3 — на случай, если state уже не пуст к первой отрисовке (напр. applySavedFilter из URL)
    loadLots();
    authUser();

    // УДАЛЕНО (§5.4 DESIGN_MASTER_PROMPT.md, "сайт — не приложение"): здесь
    // стоял вызов openModal(window.INITIAL_LOT_ID) для прямого захода на
    // /lot/{id} — открывал модалку лота ПОВЕРХ каталога на сайте. Теперь
    // /workspace/lot/{id} — собственный экран #screen-lot, его данные грузит
    // workspace-bootstrap.js (loadLotScreen()), а не общий window.onload:
    // тот безусловно грузит "домашние" данные (loadLots() выше) для ЛЮБОГО
    // экрана, лот-специфичного здесь больше нет. window.INITIAL_LOT_ID
    // остаётся — его читает именно workspace-bootstrap.js.

    loadRecommendations(); // 🔥 Вызываем при старте приложения
    loadRegions(); // 🔥 Загружаем динамические регионы

    // Phase 2: выставляем плавающий индикатор нав-бара под уже активную
    // (по умолчанию — home) вкладку сразу при загрузке, без анимации.
    const activeNavBtn = document.querySelector('.nav-item.active');
    if (activeNavBtn) {
        const indicator = document.getElementById('navIndicator');
        const nav = document.getElementById('bottomNav');
        if (indicator && nav) {
            const navRect = nav.getBoundingClientRect();
            const btnRect = activeNavBtn.getBoundingClientRect();
            indicator.style.transform = `translateX(${btnRect.left - navRect.left}px)`;
            indicator.style.width = btnRect.width + 'px';
            indicator.style.opacity = '1';
        }
    }

    // 🔧 ВРЕМЕННАЯ ДИАГНОСТИКА (жалоба "с телефона появился пробел",
    // 03.09.2026, третий заход) — предыдущие попытки (перерасчёт
    // #headerSpacer по таймеру, потом через ResizeObserver) не помогли, а
    // получить в имеющихся инструментах настоящий узкий вьюпорт (как на
    // реальном телефоне) не получается никак — эмуляция мобильного экрана
    // в доступных инструментах не работает. Чинить дальше вслепую
    // бессмысленно, нужны реальные числа с реального устройства. Полностью
    // неактивно без ?layoutdebug=1 в адресной строке — ни на что не влияет
    // ни в Telegram, ни в обычном визите на сайт. Показывает высоту и
    // положение каждого ПРЯМОГО потомка активного экрана — сразу видно,
    // какой из блоков непропорционально высокий/пустой. Обновляется раз в
    // секунду, так что можно переключать вкладки нижним меню и смотреть,
    // не открывая инструменты разработчика (на iPhone Safari их и не
    // подключить без Mac рядом).
    if (new URLSearchParams(location.search).get('layoutdebug') === '1') {
        const dbgBox = document.createElement('div');
        dbgBox.style.cssText = 'position:fixed;left:4px;right:4px;bottom:64px;max-height:42vh;overflow:auto;background:rgba(0,0,0,0.92);color:#4ade80;font:10px/1.4 monospace;padding:8px;z-index:999999;white-space:pre-wrap;border:1px solid #4ade80;border-radius:8px;pointer-events:auto;';
        document.body.appendChild(dbgBox);
        const dbgDump = () => {
            const s = document.querySelector('.screen.active');
            if (!s) { dbgBox.textContent = 'нет .screen.active'; return; }
            let out = `screen=${s.id}  winW=${window.innerWidth} winH=${window.innerHeight}  isBrowser=${document.documentElement.classList.contains('is-browser')}\n\n`;
            Array.from(s.children).forEach(c => {
                const r = c.getBoundingClientRect();
                const cls = (c.className || '').toString().slice(0, 50);
                out += `${c.id || '(без id)'} <${c.tagName.toLowerCase()} class="${cls}">\n   h=${Math.round(r.height)} top=${Math.round(r.top)}\n`;
            });
            dbgBox.textContent = out;
        };
        dbgDump();
        setInterval(dbgDump, 1000);
    }
}

// ИЗМЕНЕНО (P3.2 аудита, 12.09.2026): раньше эта функция (и её помощники
// moveExtraRailNodes()/layoutHomeSiteSwitch(), теперь удалённые) ПЕРЕНОСИЛИ
// узлы (#filterPanel/#homeSearchWrap/#homeCategoryRow/#savedFiltersBtn/
// #filterPanelActions в #homeFilterRail, #homeSiteSwitch в #homeViewToggle)
// между мобильным #mainHeader и десктопными целями при пересечении 1280px —
// тот же DOM-relocation, что и в Base AI (P3.1), с тем же классом регрессов
// (см. AUDIT_FIX_PROMPT.md, P3, и комментарии в home.html "⚠️ РЕГРЕСС,
// НАЙДЕННЫЙ ПОЗЖЕ"). Десктопная колонка теперь — статическая копия тех же
// полей (partials/screens/home_desktop.html), видимая только через CSS; JS
// больше не двигает ни одного узла, только следит за высотой рейла
// (тот же приём, что и в упрощённом layoutGlobalFilterRail(), P3.1).
function layoutDesktopFilterRail() {
    if (IS_TELEGRAM) return;
    const rail = document.getElementById('homeFilterRail');
    const header = document.getElementById('mainHeader');
    if (!rail || !header) return;
    // TASK4 4.3 (ревью 4.2, §7.9 конституции): #mainHeader теперь полностью
    // display:none на сайте ≥1024px (dashboard.css) — offsetHeight стабильно
    // 0, а старый запас "+20" вешал рейл на 20px ниже тулбара, который сам
    // начинается у самого верха колонки. Запас нужен только если высота
    // header реально ненулевая (гипотетический будущий сценарий) — тогда
    // возвращается автоматически.
    rail.style.top = (header.offsetHeight + (header.offsetHeight ? 20 : 0)) + 'px';
}

let filterRailResizeTimeout = null;
window.addEventListener('resize', () => {
    if (filterRailResizeTimeout) clearTimeout(filterRailResizeTimeout);
    filterRailResizeTimeout = setTimeout(() => {
        layoutDesktopFilterRail();
        layoutGlobalFilterRail(); // ДОБАВЛЕНО (обратная связь 02.09.2026)
    }, 150);
});

// ИЗМЕНЕНО (P3.1 аудита, 11.09.2026): раньше эта функция ПЕРЕНОСИЛА узлы
// (#gSearchWrap/#gSiteSwitch/#gCategoryRow/#gFilterPanel/#gFilterPanelActions)
// между мобильным #gHeader и десктопным #globalFilterRail через
// moveExtraRailNodes() — именно такой DOM-relocation аудит (P3) просил
// заменить статической вёрсткой (см. AUDIT_FIX_PROMPT.md). Десктопная
// колонка теперь — отдельная, всегда присутствующая в DOM статическая копия
// тех же полей (partials/screens/global_desktop.html, те же классы/
// обработчики, что и у мобильных — переиспользуются без изменений здесь),
// видимая только через CSS (html.is-browser + ≥1280px, см. dashboard.css).
// toggleGFilters()/applyGFilters()/setGCategory()/setGSite()/selectGSort()
// ниже НЕ менялись — ни единой строки.
//
// Единственное, что всё ещё нужно JS, — верхняя граница рейла: она должна
// следовать за РЕАЛЬНОЙ высотой #gHeader (которая сама не статична — см.
// #gHeaderSpacer/ResizeObserver, P1.3 аудита), а не быть жёстким числом.
function layoutGlobalFilterRail() {
    if (IS_TELEGRAM) return;
    const rail = document.getElementById('globalFilterRail');
    const header = document.getElementById('gHeader');
    if (!rail || !header) return;
    if (!header.classList.contains('hidden')) rail.style.top = (header.offsetHeight + 20) + 'px';
}

// --- ДОБАВЛЕНО (платформенный план, фаза 4 «Главная»): переключатель
// "Сетка / Таблица" для списка лотов — таблица для тех, кто сравнивает 20+
// лотов разом. #homeTableWrap скрыт по умолчанию (см. dashboard.css), виден
// только в браузере на ≥1024px — на мобильном/в Telegram кнопки переключателя
// тоже скрыты (см. dashboard.css), так что homeViewMode всегда остаётся
// 'grid' там и эта функция никогда не вызывается пользователем. ---
let homeViewMode = 'grid';

window.setHomeViewMode = (mode) => {
    homeViewMode = mode;
    document.querySelectorAll('.home-view-btn').forEach(b => b.classList.toggle('active', b.dataset.mode === mode));
    const grid = document.getElementById('homeGrid');
    const table = document.getElementById('homeTableWrap');
    if (grid) grid.classList.toggle('hidden-by-view', mode === 'table');
    if (table) table.classList.toggle('hidden-by-view', mode === 'grid');
};

// УДАЛЕНО (TASK4 4.7, TASK4_HOME_PROMPT.md §7): renderHomeTableRows() —
// отдельный движок таблицы (120px миниатюры, заголовок обрезан на
// 25 символах регэкспом, ни срока, ни типа торгов) заменён на renderLotRow()
// на месте вызова в loadLots() выше — тот же builder, что у Избранного/
// Базы AI/Моих анализов (§5.1 канона).

let scrollTimeout = null;

// ИСПРАВЛЕНО (жалоба "лоты долго грузятся, после скролла вниз долго жду
// следующую партию", 05.09.2026): раньше эта функция всегда проверяла
// window.scrollY/document.body.offsetHeight — верно, пока вся страница
// скроллилась одним куском. После sticky-шапки на Главной (см. #screen-home
// в dashboard.css, html.is-browser + ≥1280px) окно САМО больше не
// скроллится — вся прокрутка теперь внутри #homeScrollArea, а window.scrollY
// остаётся 0 всегда. window.onscroll в таком состоянии почти никогда не
// срабатывает как надо — подгрузка следующей страницы лотов либо не
// случалась вовсе, либо срабатывала на редкий побочный микро-скролл окна
// (отсюда и "долго жду"). "База AI" (#screen-global) такой перестройки не
// получала — там вся страница по-прежнему скроллится целиком, window.onscroll
// для неё остаётся верным как есть.
// ДОБАВЛЕНО (TASK4 4.6, TASK4_HOME_PROMPT.md §4): общий чек "браузер вне
// Telegram + широкий экран" — раньше жил инлайном только внутри
// checkInfiniteScroll() ниже, теперь общая точка и для неё, и для решения
// "рисовать renderLotCardSite() или createCard()" на месте вызова
// (loadLots()/loadRecommendations()). Определение НЕ переносилось,
// извлечено дословно.
function isWideBrowser() {
    return document.documentElement.classList.contains('is-browser') && window.matchMedia('(min-width: 1024px)').matches;
}

function checkInfiniteScroll() {
    const isHome = document.getElementById('screen-home').style.display !== 'none';
    const isGlobal = document.getElementById('screen-global')?.style.display !== 'none';

    if (!isHome && !isGlobal) return;

    if (scrollTimeout) return;

    scrollTimeout = setTimeout(() => {
        const homeScrollArea = document.getElementById('homeScrollArea');
        // TASK4 4.1b: порог 1024px (было 1280) — синхронизирован с CSS:
        // #screen-home.active/#homeScrollArea (внутренний скролл) теперь
        // включаются с 1024px (dashboard.css). Без этого на 1024–1279 окно
        // перестаёт скроллиться (flex-рамка 100vh), а проверка смотрела бы
        // на window.scrollY — бесконечный скролл умирал бы ровно тем же
        // багом, который здесь чинили 05.09.2026.
        const isWide = isWideBrowser();
        // 2026-10-29 (вариант 3): на сайте Главная снова прокручивается окном (шапка — fixed, фильтры — sticky), а не
        // внутренней областью; область считаем, только если она реально прокручивается сама.
        const areaScrolls = homeScrollArea && homeScrollArea.scrollHeight > homeScrollArea.clientHeight + 1;
        const scrollBottom = (isHome && isWide && areaScrolls)
            ? (homeScrollArea.scrollTop + homeScrollArea.clientHeight >= homeScrollArea.scrollHeight - 400)
            : (window.innerHeight + window.scrollY >= document.body.offsetHeight - 400);

        if (scrollBottom) {
            if (isHome && !state.isLoading && state.hasMore) loadLots(true);
            if (isGlobal && !gState.isLoading && gState.hasMore) loadGlobalLots(true);
        }

        scrollTimeout = null;
    }, 100);
}

window.onscroll = checkInfiniteScroll;
// Слушатель на самом #homeScrollArea — на мобильном/в Mini App/на узком
// браузере он никогда не скроллится сам по себе (обычный div в потоке
// страницы, см. app_shell.html), поэтому это событие там просто никогда не
// возникает — безопасно вешать безусловно, без доп. проверки isWide здесь.
document.getElementById('homeScrollArea')?.addEventListener('scroll', checkInfiniteScroll);

// Пересчитываем позицию индикатора при смене ориентации/ресайзе (десктоп
// ресайз окна, поворот телефона) — без этого пилюля "залипала" бы на старых
// координатах после layout-сдвига.
let navResizeTimeout = null;
window.addEventListener('resize', () => {
    if (navResizeTimeout) clearTimeout(navResizeTimeout);
    navResizeTimeout = setTimeout(() => {
        const activeNavBtn = document.querySelector('.nav-item.active');
        if (activeNavBtn) moveNavIndicator(activeNavBtn);
    }, 150);
});

window.toggleDocs = () => {
    const wrapper = document.getElementById('docsWrapper');
    const caret = document.getElementById('docsCaret');
    
    wrapper.classList.toggle('open');
    caret.classList.toggle('rotate');
    
    tg.HapticFeedback.selectionChanged();
};



// --- Открытие отдельной консоли управления (/admin) ---
// Консоль — отдельная страница вне Mini App, у неё нет доступа к tg.initData
// напрямую. Передаём подписанный токен через URL-фрагмент (после #, не уходит
// на сервер в логах запроса) — admin.js читает его один раз при загрузке и
// дальше использует как обычный заголовок X-Telegram-Init-Data, ровно как
// делает сам Mini App. Токен живёт 24 часа (см. INIT_DATA_MAX_AGE_SECONDS на
// бэкенде) — после истечения нужно открыть консоль заново отсюда.
function openAdminConsole() {
    // ДОБАВЛЕНО (по прямому запросу, "через браузер консоль админа не
    // открывается"): раньше эта функция работала ТОЛЬКО внутри Telegram —
    // в браузере tg.initData всегда пуст (его больше неоткуда взять вне
    // самого Telegram-клиента), и единственным действием был tg.showAlert(),
    // который вне Telegram молча ничего не показывает — кнопка выглядела
    // полностью мёртвой. require_admin() на бэкенде теперь принимает и
    // браузерную сессионную куку (см. комментарий там же) — админ.js сам
    // подхватит её через /api/auth/session при открытии /admin, никакой
    // токен в URL для этого не нужен.
    if (IS_TELEGRAM) {
        if (!tg.initData) return tg.showAlert('Не удалось получить данные авторизации Telegram. Перезапустите приложение.');
        const url = `${location.origin}/admin#tgid=${encodeURIComponent(tg.initData)}`;
        tg.openLink(url);
        return;
    }
    if (!userId) { renderLoginGate('Панель администратора'); return; }
    window.open(`${location.origin}/admin`, '_blank');
}

// Если переключились на экран админа — экран теперь просто витрина с кнопкой
// «Открыть консоль управления» (см. openAdminConsole() выше). Вся живая админ-
// логика (поиск юзеров, теги, платежи, автоматизация, LIVE-опрос раз в 5 сек)
// переехала в отдельную консоль /admin (admin.js) — держать её копию ещё и
// здесь означало чинить одни и те же баги в двух местах.
const originalSwitchScreen = window.switchScreen;
// ДОБАВЛЕНО (анонимный просмотр лотов, интерфейсный аудит): "Избранное",
// "База AI" и "Профиль" — персональные экраны, которым физически нечего
// показать без входа (favorites/global/profile всегда требовали userId на
// бэкенде, это не менялось). Раньше эта проблема не существовала — сайт
// целиком блокировался экраном входа ДО того, как посетитель мог нажать
// любой из этих пунктов. Теперь, когда каталог лотов открыт анонимно (см.
// ensureAuthenticated()), нажатие на них должно вести к входу, а не к
// тихо пустому экрану — вот единственное место, где нужно решить, что
// считать "персональным" действием, требующим входа.
// 'analyses' ДОБАВЛЕН (аудит "641 отчёт спрятан за одной кнопкой в модалку",
// 05.09.2026, продолжение) — #screen-analyses (только is_workspace/браузер,
// см. app_shell.html) такой же личный экран, как favorites/global/profile:
// анонимному посетителю там нечего показывать, кроме чужой истории анализов.
// 'analysis' ДОБАВЛЕН (§5.4 DESIGN_MASTER_PROMPT.md, "анализ — отдельная
// страница") — тот же случай: #screen-analysis показывает ЛИЧНЫЙ отчёт
// (user_analyses конкретного пользователя, см. workspace_analysis_page() в
// api_server.py), гостю там нечего показывать, кроме гейта логина.
const SCREENS_REQUIRE_LOGIN = ['favorites', 'global', 'profile', 'analyses', 'analysis', 'map'];
// TASK8 8.3 (§III.6, F-04): человекочитаемые имена экранов для «Вы
// вернётесь на: …» на гейте входа — те же названия, что в нижней/боковой
// навигации и заголовках вкладок (см. §3 ниже).
const SCREEN_LOGIN_GATE_LABELS = { favorites: 'Избранное', global: 'База AI', profile: 'Профиль', analyses: 'Мои анализы', analysis: 'Анализ', map: 'Карта лотов' };
window.switchScreen = (n) => {
    // НАЙДЕНО (жалоба "мелькает окно входа при переключении вкладок",
    // 03.09.2026): раньше проверка ниже смотрела только на userId — а в
    // браузере он ещё undefined (не "гость", а "мы пока не знаем"), пока
    // не отработает асинхронная ensureAuthenticated() при загрузке
    // страницы. Клик по личной вкладке в это окно на мгновение показывал
    // экран входа, который через миг сама же ensureAuthenticated() прятала
    // — видно было как мелькание. authChecked (см. объявление userId в
    // начале файла) отличает "ещё не знаем" от "точно гость" — пока не
    // знаем наверняка, просто ждём и пробуем снова, ничего не показывая.
    // Защита от зависания (на случай, если authChecked почему-то так и не
    // станет true): не больше ~3 секунд ожидания, дальше — как раньше.
    if (!IS_TELEGRAM && !authChecked && SCREENS_REQUIRE_LOGIN.includes(n)) {
        window.__switchScreenWaitMs = (window.__switchScreenWaitMs || 0) + 60;
        if (window.__switchScreenWaitMs < 3000) {
            setTimeout(() => window.switchScreen(n), 60);
            return;
        }
    }
    window.__switchScreenWaitMs = 0;
    if (!IS_TELEGRAM && !userId && SCREENS_REQUIRE_LOGIN.includes(n)) {
        renderLoginGate(SCREEN_LOGIN_GATE_LABELS[n] || null);
        return;
    }
    originalSwitchScreen(n);
    if (n === 'favorites') loadFavorites();
    if (n === 'global') {
        layoutGlobalFilterRail(); // ДОБАВЛЕНО (обратная связь 02.09.2026) — экран уже видим здесь, offsetHeight измеряется корректно
        if (gState.offset === 0) loadGlobalLots(); // Подгрузит базу при первом открытии
    }
    // ДОБАВЛЕНО (аудит "Мои отчеты как страница", 05.09.2026): та же функция,
    // что и раньше заполняла #modalAnalyses по клику "Открыть историю" —
    // renderAnalyses() ищет контейнер по id #analysesListModal (одинаков в
    // обеих ветках app_shell.html, см. её же комментарий), ей всё равно,
    // экран это сейчас или модалка.
    if (n === 'analyses') renderAnalyses();
    if (n === 'map') initLotsMapView();     // 2026-10-28: /workspace/map — карта лотов страницей (сайт)
    // ДОБАВЛЕНО (§5.4 DESIGN_MASTER_PROMPT.md): доходим сюда только после
    // того, как гейт логина выше пропустил залогиненного пользователя —
    // анонима switchScreen увёл на renderLoginGate() и вернулся раньше.
    // pendingAnalysisLotId выставляют все три источника (клик по лоту,
    // прямой заход по URL, popstate) непосредственно перед вызовом
    // window.switchScreen('analysis') — см. их комментарии.
    if (n === 'analysis' && window.pendingAnalysisLotId) {
        loadAnalysisScreen(window.pendingAnalysisLotId);
        window.pendingAnalysisLotId = null;
    }
}

// ДОБАВЛЕНО (Профиль → аккаунт-страница, платформенный план): переключатель
// вкладок внутри самого экрана "Профиль" (Обзор / Биллинг / О сервисе).
// Разметка (#profileAccountNav + .profile-section[data-section]) уже
// сгруппирована в index.html — здесь только чистый UI-стейт, без сети и
// без побочных эффектов. На мобильном/в Telegram CSS не скрывает разделы
// (см. dashboard.css — правило только под html.is-browser + ≥1024px), так
// что там эта функция просто переставляет класс "active" без видимого
// эффекта — старый вид (все три блока подряд) остаётся как был.
window.switchProfileSection = (sec) => {
    document.querySelectorAll('.profile-section').forEach(el => {
        el.classList.toggle('active', el.dataset.section === sec);
    });
    document.querySelectorAll('#profileAccountNav .profile-account-nav-item').forEach(btn => {
        btn.classList.toggle('active', btn.dataset.section === sec);
    });
    // ДОБАВЛЕНО (Биллинг → история платежей): подгружаем один раз при первом
    // открытии вкладки, а не на каждый переход между разделами Профиля —
    // тот же приём "offset===0" what switchScreen() уже использует для Базы AI.
    if (sec === 'billing' && !billingHistoryLoaded) {
        loadBillingHistory();
    }
};

let billingHistoryLoaded = false;

async function loadBillingHistory() {
    if (!userProfile) return;
    billingHistoryLoaded = true;
    const list = document.getElementById('billingHistoryList');
    if (!list) return;
    // ДОБАВЛЕНО (TASK8 8.2, §1 п.6, E-05): "Загрузка..." как состояние покоя
    // (текст в разметке ещё ДО этого вызова) заменяем на скелетон-строки
    // сразу, пока идёт запрос — сайт видит движение, не статичный текст.
    // Mini App — как было, без скелетона (карточная вёрстка ниже не менялась).
    if (!IS_TELEGRAM) {
        list.innerHTML = Array.from({ length: 3 }, () => `
            <div class="report-fin-row" style="opacity:.5;">
                <span style="width:120px;height:14px;background:var(--bg-raised);border-radius:4px;display:inline-block;"></span>
                <span style="width:60px;height:14px;background:var(--bg-raised);border-radius:4px;display:inline-block;"></span>
            </div>`).join('');
    }
    try {
        const res = await fetch(`/api/user/${userProfile.user_id}/payments`);
        if (!res.ok) throw new Error('http ' + res.status);
        const payments = await res.json();
        renderBillingHistory(payments);
    } catch (e) {
        console.error('Ошибка загрузки истории платежей:', e);
        list.innerHTML = IS_TELEGRAM
            ? '<div class="text-xs text-[#94a3b8] text-center py-6">Не удалось загрузить историю платежей</div>'
            : '<p class="text-caption" style="color:var(--status-neg);">Не удалось загрузить историю платежей</p>';
        billingHistoryLoaded = false;
    }
}

function renderBillingHistory(payments) {
    const list = document.getElementById('billingHistoryList');
    if (!list) return;
    if (!payments || !payments.length) {
        list.innerHTML = IS_TELEGRAM
            ? '<div class="text-xs text-[#94a3b8] text-center py-6">Платежей пока не было</div>'
            : '<p class="text-caption text-tertiary">Платежей пока нет</p>';
        return;
    }
    const statusMap = {
        pending: { text: 'Ожидает подтверждения', cls: 'text-yellow-400 bg-yellow-500/10' },
        approved: { text: 'Оплачено', cls: 'text-emerald-400 bg-emerald-500/10' },
        rejected: { text: 'Отклонено', cls: 'text-red-400 bg-red-500/10' },
    };
    // ИЗМЕНЕНО (TASK8 8.2, §1 п.6): было — карточки-строки с raw hex, на
    // сайте всегда (не только в billing). Сайт получает таблицу
    // («дата mono · описание · сумма mono · статус pill»), Mini App —
    // байт-в-байт как было.
    if (IS_TELEGRAM) {
        list.innerHTML = payments.map(p => {
            const st = statusMap[p.status] || { text: p.status || '—', cls: 'text-gray-400 bg-white/5' };
            const date = fmtDate(p.created_at);
            return `
                <div class="flex items-center justify-between gap-3 p-3 bg-white/5 rounded-xl border border-white/5">
                    <div class="min-w-0">
                        <div class="text-sm font-medium text-white truncate">${escapeHtml(p.item_name || p.item_id || 'Платёж')}</div>
                        <div class="text-[11px] text-[#94a3b8]">${date}</div>
                    </div>
                    <div class="flex items-center gap-3 shrink-0">
                        <span class="text-xs font-bold px-2 py-0.5 rounded-md ${st.cls}">${st.text}</span>
                        <span class="text-sm font-bold text-white font-mono-nums">${formatMoney(p.amount_tenge || 0)}</span>
                    </div>
                </div>`;
        }).join('');
    } else {
        const statusPillMap = {
            pending: { text: 'ожидает', cls: 'pill-warn' },
            approved: { text: 'оплачено', cls: 'pill-pos' },
            rejected: { text: 'отклонено', cls: 'pill-neg' },
        };
        const rows = payments.map((p) => {
            const st = statusPillMap[p.status] || { text: p.status || '—', cls: '' };
            return `<tr>
                <td class="text-caption font-mono-nums text-tertiary">${fmtDate(p.created_at)}</td>
                <td class="text-body text-primary">${escapeHtml(p.item_name || p.item_id || 'Платёж')}</td>
                <td class="text-body font-mono-nums text-primary" style="text-align:right;">${formatMoney(p.amount_tenge || 0)}</td>
                <td style="text-align:right;"><span class="pill ${st.cls}">${st.text}</span></td>
            </tr>`;
        }).join('');
        list.innerHTML = `<table class="profile-billing-table"><thead><tr>
            <th class="text-table-head">Дата</th><th class="text-table-head">Описание</th>
            <th class="text-table-head" style="text-align:right;">Сумма</th><th class="text-table-head" style="text-align:right;">Статус</th>
        </tr></thead><tbody>${rows}</tbody></table>`;
    }
}


// 2. Поиск (Debounce)

// 3. Рендер списка (общий для поиска и "Всех")

// 4. Открытие Инспектора + ЗАПУСК REALTIME ЛОГОВ 🔥

// Закрытие инспектора + ОСТАНОВКА ЛОГОВ

// Вспомогательная: Обновить балансы (чтобы видеть начисление в реалтайме)

// Загрузка логов (isSilent = true значит не показывать "Загрузка...")


// ==========================================
// 🔥 ВКЛАДКА "БАЗА ГОТОВЫХ АНАЛИЗОВ" (GLOBAL)
// ==========================================

let gState = {
    site: 'all', category: 'all', query: '',
    minPrice: null, maxPrice: null, sort: 'date_desc', auctionType: 'all',
    region: 'all', yearMin: null, yearMax: null, roomsMin: null, roomsMax: null,
    areaMin: null, areaMax: null, model: 'all',
    offset: 0, limit: 20, isLoading: false, hasMore: true,
    // ДОБАВЛЕНО (TASK5 5.3c, §4 п.3): вердикт — клиентский фильтр (см.
    // isGlobalFiltered()/setGVerdict() ниже), /api/global_lots параметра
    // verdict не имеет. lotsCache — тот же приём, что favState.lotsCache
    // (Избранное, 5.2): весь уже загруженный постранично список, чтобы
    // фильтр по вердикту не терял ранее подгруженные страницы при
    // пересборке #globalTableBody без нового сетевого запроса.
    verdict: 'all', lotsCache: []
};
let gSearchTimeout;

// ДОБАВЛЕНО (§5.1 п.4): отличает "в Базе AI вообще нет ни одного отчёта" от
// "по текущему поиску/фильтру ничего не нашлось" — те же поля, что и сама
// сборка params в loadGlobalLots() выше, sort/limit/offset не считаются
// фильтром (они не сужают множество лотов, только его порядок/порцию).
function isGlobalFiltered() {
    return gState.query !== '' || gState.category !== 'all' || gState.site !== 'all' ||
        gState.auctionType !== 'all' || gState.region !== 'all' || gState.model !== 'all' ||
        gState.minPrice != null || gState.maxPrice != null ||
        gState.yearMin != null || gState.yearMax != null ||
        gState.roomsMin != null || gState.roomsMax != null ||
        gState.areaMin != null || gState.areaMax != null ||
        gState.verdict !== 'all'; // ДОБАВЛЕНО (TASK5 5.3c) — клиентский фильтр, тоже сужает список
}

// TASK29 29.3: продаётся ли Premium ЭТОМУ пользователю (window.PLANS_ON_SALE
// из /api/user premium_sale; гость — []). Своей логики доступа здесь нет.
function premiumOnSale() {
    return (window.PLANS_ON_SALE || []).includes('premium');
}

// TASK29 29.3: точки входа в функции, которых нет в рознице (карта,
// сравнение — Premium; «База AI» — PRO/Premium), прячем у вошедшего
// пользователя, который их не имеет и купить Premium не может: не
// рекламируем то, что нельзя купить. Гость — как раньше (вход решает).
function applyPremiumEntryPoints() {
    if (!userProfile) return;
    const closed = !premiumOnSale();
    const hidePremium = closed && !isPremiumUser();
    const hideBase = closed && !checkGlobalAccess();
    ['mapToggleBtnDesktop', 'mapToggleBtn', 'btnCompareToggle'].forEach(id => {
        document.querySelectorAll(`[id="${id}"]`).forEach(el => { el.style.display = hidePremium ? 'none' : ''; });
    });
    document.querySelectorAll('[data-nav="global"]').forEach(el => { el.style.display = hideBase ? 'none' : ''; });
    // Пейволлы «Базы AI» (прямой URL): кнопка покупки — только если есть что купить.
    document.querySelectorAll('#gPaywall button, #gTablePaywall .btn-primary').forEach(el => {
        el.style.display = closed ? 'none' : '';
    });
    // Без кнопки обещание «открытие расходует баланс» неверно — купить доступ нельзя.
    const baseText = document.getElementById('gTablePaywallText');
    if (baseText && hideBase) baseText.textContent = 'Раздел доступен только действующим подписчикам.';
}

// Фаза 4: сравнение лотов — доступно только на PREMIUM (+ админам).
// Та же логика определения тарифа, что и в checkGlobalAccess() ниже.
function isPremiumUser() {
    if (!userProfile) return false;
    const plan = (userProfile.plan_id && userProfile.plan_id !== 'free') ? userProfile.plan_id : (userProfile.subscription_plan || 'free');
    return plan === 'premium' || userProfile.is_admin;
}

// D2 (DESIGN_UPGRADE_PROMPT.md §5.3): живой счётчик на пейволле Базы AI —
// "в базе N готовых отчётов", вместо голословного соцдоказательства.
// /api/global_lots/count публичный и не требует PRO/PREMIUM (в отличие от
// самого /api/global_lots) — именно у пользователей без доступа он и
// показывается. Кэшируем в переменную модуля: число не меняется от смены
// экрана туда-обратно, повторный fetch на каждый заход на "Базу AI" не нужен.
let gPaywallCountCache = null;
async function loadGlobalPaywallCount() {
    if (gPaywallCountCache == null) {
        try {
            const res = await fetch('/api/global_lots/count');
            const data = await res.json();
            gPaywallCountCache = typeof data.count === 'number' ? data.count : 0;
        } catch (e) {
            console.error('[loadGlobalPaywallCount]', e);
            return; // Молча оставляем текст без счётчика — не заведомо неверное число
        }
    }
    const el = document.getElementById('gPaywallCount');
    if (el) el.innerHTML = `В базе ${formatNumber(gPaywallCountCache)} готовых отчётов. Доступ на тарифах PRO и PREMIUM. Открытие расходует баланс анализов, как обычно.`;
    // TASK5 5.3 (§4, B-13): та же живая цифра — в панели пейволла сайта
    // (#gTablePaywall в global.html), buквальный текст задания: "296
    // отчётов других инвесторов".
    const siteEl = document.getElementById('gTablePaywallCount');
    if (siteEl) siteEl.textContent = `${formatNumber(gPaywallCountCache)} отчётов других инвесторов`;
    updateGHeaderCount(); // счётчик пришёл асинхронно — досчитываем шапку сайта тем же значением
}

// ДОБАВЛЕНО (TASK5 5.3, §4, B-13): 6 скелетон-строк за панелью пейволла —
// честный превью того, что есть в базе (§7.10 канона: "skeletons of the
// same geometry", не пустой экран). Простая геометрия — не полноценный
// renderLotRow() (там нет данных, которые можно было бы туда подставить).
function renderGTablePaywallSkeleton() {
    const el = document.getElementById('gTablePaywallSkeleton');
    if (!el || el.dataset.built) return; // строим один раз, геометрия статична
    el.dataset.built = '1';
    const row = `<div style="display:flex; align-items:center; gap:14px; height:64px; padding:0 14px; border-bottom:1px solid var(--border-subtle);">
        <div style="width:48px; height:48px; border-radius:var(--radius-ctl); background:var(--bg-raised); flex-shrink:0;"></div>
        <div style="flex:1; height:12px; border-radius:var(--radius-ctl); background:var(--bg-raised); max-width:320px;"></div>
        <div style="width:80px; height:12px; border-radius:var(--radius-ctl); background:var(--bg-raised); flex-shrink:0;"></div>
        <div style="width:60px; height:12px; border-radius:var(--radius-ctl); background:var(--bg-raised); flex-shrink:0;"></div>
    </div>`;
    el.innerHTML = row.repeat(6);
}

// ДОБАВЛЕНО (TASK5 5.3, §4): «База AI · N отчётов» — N тот же публичный
// счётчик, что у пейволла (/api/global_lots/count, не новый эндпоинт),
// показывается независимо от доступа (§4: "header row... render as
// usual"). «показано M» — только когда есть реальные строки (доступ есть).
function updateGHeaderCount() {
    const countEl = document.getElementById('gHeaderCount');
    if (countEl && gPaywallCountCache != null) {
        countEl.textContent = `База AI · ${formatNumber(gPaywallCountCache)} отчётов`;
    }
    const shownEl = document.getElementById('gHeaderShown');
    if (shownEl) {
        // 2026-10-29 (вариант 3): строка результатов — «Показано N из M», как на Главной
        shownEl.textContent = checkGlobalAccess()
            // «из M» — только без фильтров: M — общее число отчётов, отфильтрованного итога API не отдаёт
            ? ((gPaywallCountCache && gState.category === 'all' && gState.site === 'all' && !gState.query && (gState.verdict || 'all') === 'all' && (gState.auctionType || 'all') === 'all')
                ? `Показано ${gState.offset} из ${formatNumber(gPaywallCountCache)}` : `Показано ${gState.offset}`)
            : '';
    }
}

// Вспомогательная функция для проверки доступа к Базе
function checkGlobalAccess() {
    if (!userProfile) return false;
    // Используем ту же надежную логику определения тарифа
    const plan = (userProfile.plan_id && userProfile.plan_id !== 'free') ? userProfile.plan_id : (userProfile.subscription_plan || 'free');
    return ['pro', 'premium'].includes(plan) || userProfile.is_admin; // Админам тоже можно
}

// Загрузка лотов с проверкой Paywall и защитой от спам-запросов (AbortController)
async function loadGlobalLots(append = false) {
    const paywall = document.getElementById('gPaywall');
    const header = document.getElementById('gHeader');
    const grid = document.getElementById('globalGrid');
    const spacer = document.getElementById('gHeaderSpacer');
    const tableWrap = document.getElementById('globalTableWrap'); // ДОБАВЛЕНО (платформенный план, фаза 3)
    const filterRail = document.getElementById('globalFilterRail'); // ДОБАВЛЕНО (обратная связь 02.09.2026, постоянная панель фильтров)
    const table = document.getElementById('globalTable');
    const tablePaywall = document.getElementById('gTablePaywall');
    // TASK5 5.3 (§4, B-13): на сайте пейволл — панель ВНУТРИ области
    // таблицы, не 80vh lock shrine (#gPaywall — мобильный/Mini App,
    // не трогается). useSiteCard — тот же признак, что уже использует
    // loadLots()/loadRecommendations() на Главной.
    const useSiteCard = !IS_TELEGRAM && isWideBrowser();

    // 1. ПРОВЕРКА ДОСТУПА (PAYWALL)
    if (!checkGlobalAccess()) {
        if (useSiteCard) {
            // §4: "header row and rail render as usual" — оба остаются
            // видимыми/рабочими, паиволл только в области таблицы.
            if (header) header.classList.add('hidden'); // мобильный #gHeader и так скрыт на сайте (dashboard.css), явный hidden — на случай гонки до применения CSS
            if (grid) grid.classList.add('hidden');
            if (spacer) spacer.classList.add('hidden');
            if (paywall) paywall.classList.add('hidden');
            if (filterRail) filterRail.classList.remove('hidden');
            if (tableWrap) tableWrap.classList.remove('hidden');
            if (table) table.classList.add('hidden');
            if (tablePaywall) tablePaywall.classList.remove('hidden');
            renderGTablePaywallSkeleton();
            loadGlobalPaywallCount(); // тот же живой счётчик — общий текст с #gPaywallCount
            updateGHeaderCount();
            layoutGlobalFilterRail();
            initGDesktopInstantFilters();
            return;
        }
        // Mobile/Mini App — как было, без изменений.
        if (paywall) paywall.classList.remove('hidden');
        if (paywall) paywall.classList.add('flex');
        loadGlobalPaywallCount(); // D2: живой счётчик "в базе N готовых отчётов"

        if (header) header.classList.add('hidden');
        if (grid) grid.classList.add('hidden');
        if (spacer) spacer.classList.add('hidden');
        if (tableWrap) tableWrap.classList.add('hidden');
        if (filterRail) filterRail.classList.add('hidden');
        return; // Останавливаем загрузку из БД!
    } else {
        // Если доступ есть - показываем интерфейс
        if (paywall) paywall.classList.add('hidden');
        if (paywall) paywall.classList.remove('flex');
        if (tablePaywall) tablePaywall.classList.add('hidden');
        if (table) table.classList.remove('hidden');

        if (header) header.classList.remove('hidden');
        if (grid) grid.classList.remove('hidden');
        if (spacer) spacer.classList.remove('hidden');
        if (tableWrap) tableWrap.classList.remove('hidden');
        if (filterRail) filterRail.classList.remove('hidden');
        layoutGlobalFilterRail(); // ДОБАВЛЕНО: измеряем/переносим панель фильтров только когда экран реально видим и доступен (offsetHeight иначе 0)
        initGDesktopInstantFilters(); // TASK5 5.3 — навешивается один раз, до первого взаимодействия с рейлом
        updateGRailResetLabel(); // TASK5 5.3 — на случай, если gState уже не пуст к первой отрисовке
        // TASK5 5.3: у пользователя с доступом gPaywallCountCache мог не
        // заполниться вовсе (эта ветка не проходит через пейволл) —
        // loadGlobalPaywallCount() сама обновит #gHeaderCount, когда придёт
        // ответ (публичный эндпоинт, безвреден для любого пользователя).
        loadGlobalPaywallCount();
        updateGHeaderCount();
    }

    // 2. СТАНДАРТНАЯ ЗАГРУЗКА
    // Не грузим следующую страницу, если уже грузим
    if (gState.isLoading && append) return;
    if (append && !gState.hasMore) return;
    
    // 🔥 ОТМЕНЯЕМ СТАРЫЙ ЗАПРОС ПРИ НОВОМ ПОИСКЕ
    if (!append && currentGlobalRequest) {
        currentGlobalRequest.abort();
    }

    gState.isLoading = true;
    
    if (!append) {
        gState.offset = 0;
        gState.hasMore = true;
        gState.lotsCache = []; // ДОБАВЛЕНО (TASK5 5.3c) — новая выдача, старый кэш для фильтра по вердикту больше не актуален
        showLoader('globalGrid'); // Включаем скелетон
        currentGlobalRequest = new AbortController(); // Создаем контроллер для нового запроса
    }

    try {
        const params = new URLSearchParams({
            user_id: userId,
            query: gState.query,
            category: gState.category,
            site: gState.site,
            sort: gState.sort,
            auction_type: gState.auctionType,
            limit: gState.limit,
            offset: gState.offset
        });

        // 🔥 ПЕРЕДАЕМ СИГНАЛ ОТМЕНЫ В FETCH
        const fetchOptions = !append ? { signal: currentGlobalRequest.signal } : {};
        const r = await fetch(`/api/global_lots?${params.toString()}`, fetchOptions);
        
        // Проверяем, не упал ли бэкенд (ошибка 500 и т.д.)
        if (!r.ok) {
            throw new Error(`HTTP error! status: ${r.status}`);
        }

        const d = await r.json();
        
        if (!append) grid.innerHTML = ''; // Очищаем скелетон/спиннер

        if (d.length < gState.limit) gState.hasMore = false;

        const fragment = document.createDocumentFragment();
        const newCards = d.map(x => useSiteCard ? buildGlobalSiteCard(x) : createCard(x));   // сайт ≥1024: блоки Главной со своим «Отчёт»
        newCards.forEach(c => fragment.appendChild(c));
        grid.appendChild(fragment);
        revealNewCards(newCards); // Phase 3: stagger fade+y только для новой пачки
        gState.lotsCache = gState.lotsCache.concat(d); // ДОБАВЛЕНО (TASK5 5.3c) — накопленный список для клиентского фильтра по вердикту
        // ИЗМЕНЕНО (TASK5 5.3c, §4 п.3): пока фильтр по вердикту активен,
        // таблица пересобирается целиком из gState.lotsCache (иначе новая
        // подгруженная бесконечным скроллом страница обошла бы фильтр —
        // renderGlobalTableRows() просто дозаписывает пачку в конец, не
        // фильтруя её). Карточная лента (#globalGrid, мобильная/Mini App)
        // фильтр не имеет вовсе — контрол site-only, см. global_desktop.html.
        if (gState.verdict !== 'all') {
            renderGlobalTableFromCache();
        } else {
            renderGlobalTableRows(d, append); // ДОБАВЛЕНО (платформенный план, фаза 3): та же страница данных, что и карточки — на мобильном/в Telegram результат не виден (см. dashboard.css)
        }

        if (d.length > 0) gState.offset += d.length;
        updateGHeaderCount(); // TASK5 5.3 — «показано M» после реального прироста offset
        updateGRailResetLabel(); // ИСПРАВЛЕНО (TASK5 5.3c, ревью владельца): раньше вызывалась только один раз при первой отрисовке экрана — «Сбросить» не появлялось/не пропадало при смене фильтров рейла (те не перезагружают экран, только зовут loadGlobalLots()), тот же приём, что updateFavRailResetLabel() в renderFavorites() (5.2) — обновляем на каждый реальный рендер.

        if (d.length === 0 && !append) {
            // §5.1 п.4: "в базе вообще ничего нет" (все фильтры на дефолте) —
            // не то же самое, что "этот запрос/фильтр ничего не нашёл".
            const tbody = document.getElementById('globalTableBody');
            if (isGlobalFiltered()) {
                const resetBtn = `<button type="button" onclick="resetGFilters()" class="btn-secondary text-xs">Сбросить фильтры</button>`;
                grid.innerHTML = emptyStateHtml('ph-magnifying-glass', 'Ничего не найдено', 'Попробуйте изменить поиск или фильтр.', resetBtn);
                if (tbody) tbody.innerHTML = `<tr><td colspan="8" class="lot-row-empty">${lotListEmptyStateHtml(true, null, null, null, resetBtn)}</td></tr>`;
            } else {
                grid.innerHTML = emptyStateHtml('ph-database', 'В базе пока нет готовых анализов', 'Отчёты появляются здесь по мере того, как инвесторы запускают AI-анализ лотов.');
                if (tbody) tbody.innerHTML = `<tr><td colspan="8" class="lot-row-empty">${lotListEmptyStateHtml(false, 'ph-database', 'В базе пока нет готовых анализов', 'Отчёты появляются здесь по мере того, как инвесторы запускают AI-анализ лотов.')}</td></tr>`;
            }
        }

    } catch (e) {
        // Игнорируем ошибку, если мы сами прервали запрос (пользователь быстро печатает)
        if (e.name === 'AbortError') {
            console.log("Предыдущий глобальный запрос отменен...");
            return; // Выходим без изменения gState.isLoading
        }

        console.error("Ошибка загрузки глобальных лотов:", e);
        if (!append) {
            grid.innerHTML = emptyStateHtml(
                'ph-wifi-slash', 'Не удалось загрузить базу', 'Проверьте соединение с интернетом и попробуйте ещё раз.',
                `<button onclick="loadGlobalLots(false)" class="btn-block btn-secondary text-xs px-4" style="width:auto;">Повторить</button>`
            );
            const tbody = document.getElementById('globalTableBody');
            if (tbody) tbody.innerHTML = '<tr><td colspan="7" class="lot-row-empty">Не удалось загрузить базу. Проверьте соединение и попробуйте ещё раз.</td></tr>';
        }
    } finally {
        gState.isLoading = false;
    }
}

// --- ДОБАВЛЕНО (платформенный план, фаза 3 «База AI»): табличный вид для
// браузера на широком экране. #globalTableWrap скрыт по умолчанию и
// появляется только под html.is-browser + ≥1024px (см. dashboard.css) — эта
// функция вызывается безусловно из loadGlobalLots (append и обычная
// загрузка), просто на мобильном/в Telegram её результат никогда не виден. ---
// §5.1 колонки Базы AI: thumb · title · region · price+spark · score ·
// verdict · date. Клик по строке — сразу /workspace/analysis/{id}, не
// карточка лота: в этой вкладке у каждого лота уже ЕСТЬ готовый анализ по
// определению (это и есть список готовых отчётов, см. её же комментарий у
// loadGlobalLots), в отличие от Избранного, где лот может быть ещё не
// проанализирован. ВЫДЕЛЕНО (TASK5 5.3c) из renderGlobalTableRows() в
// отдельную функцию — теперь строку строит и обычный append-рендер, и
// renderGlobalTableFromCache() (фильтр по вердикту), общий контекст в
// одном месте.
function buildGlobalTableRow(l) {
    return renderLotRow(l, {
        tag: 'tr',
        // ИЗМЕНЕНО (TASK5 5.3, §1 таблицы TASK5_LISTS_PROMPT.md): добавлена
        // колонка «Площадка» (её не было вовсе), порядок теперь совпадает
        // с <thead> в global.html: thumb/Лот/Площадка/Регион/Цена/Скор/
        // Вердикт/Дата.
        columns: ['thumb', 'title', 'site', 'region', 'price', 'score', 'verdict', 'date', 'actions'],
        getId: (x) => x.id,
        getDate: (x) => x.recommendation_updated_at,
        // 2026-10-29 (владелец): строка — как в остальных списках, ведёт на страницу лота; отчёт — кнопкой «Отчёт»
        renderActions: (x) => reportActionHtml(x.id),
        // TASK5 5.1 (§2 п.8): дефолт ctx.href — /workspace/lot/{id}, здесь
        // нужен /workspace/analysis/{id} (та же страница, что открывает
        // onClick) — иначе средний клик/Cmd-клик по заголовку вёл бы на
        // страницу лота, а обычный клик по строке — на анализ.
        href: (x) => `/workspace/lot/${x.id}`,
        onClick: (x) => { window.location.href = `/workspace/lot/${x.id}`; },
    });
}

// 2026-10-29 (владелец: «блоками, как на Главной»): карточка Базы AI — блок Главной; у каждого лота здесь уже есть
// разбор, поэтому вместо «Анализ →» — «Отчёт» (видна всегда) и дата разбора под ценой.
function buildGlobalSiteCard(l) {
    return renderLotCardSite(l, {
        actionsHtml: reportActionHtml(l.id),
        noteHtml: l.recommendation_updated_at ? `Разобран ${escapeHtml(fmtDate(l.recommendation_updated_at))}` : '',
    });
}

// 2026-10-29: кнопка «Отчёт» в строке списка (База AI, Мои анализы) — обычная ссылка (средний клик, Cmd-клик работают);
// клик по ней не доходит до onClick строки (та ведёт на страницу лота).
function reportActionHtml(lotId) {
    const id = escapeHtml(String(lotId));
    return `<a href="/workspace/analysis/${id}" class="list-report-btn" onclick="event.stopPropagation()"><i class="ph-bold ph-chart-line-up"></i>Отчёт</a>`;
}

// --- ДОБАВЛЕНО (платформенный план, фаза 3 «База AI»): табличный вид для
// браузера на широком экране. #globalTableWrap скрыт по умолчанию и
// появляется только под html.is-browser + ≥1024px (см. dashboard.css) — эта
// функция вызывается безусловно из loadGlobalLots (append и обычная
// загрузка), просто на мобильном/в Telegram её результат никогда не виден. ---
function renderGlobalTableRows(lots, append) {
    const tbody = document.getElementById('globalTableBody');
    if (!tbody) return;
    if (!append) tbody.innerHTML = '';
    if (!lots.length) return;

    const fragment = document.createDocumentFragment();
    lots.forEach(l => fragment.appendChild(buildGlobalTableRow(l)));
    tbody.appendChild(fragment);
    attachSparklines(tbody); // D4 — см. её комментарий у attachSparklines()
}

// ДОБАВЛЕНО (TASK5 5.3c, §4 п.3): фильтр по вердикту — клиентский
// (good/mid/bad/none, тот же словарь, что уже использует Избранное,
// favState.verdict в renderFavorites()) — /api/global_lots параметра
// verdict не поддерживает (постраничная подгрузка из БД, не полный
// клиентский кэш).
function matchesGVerdict(l) {
    if (gState.verdict === 'all') return true;
    const score = typeof l.recommendation_score === 'number' ? l.recommendation_score : null;
    const analyzed = isRecAnalyzed(l.recommendation_status, l.recommendation_score) && score != null;
    if (gState.verdict === 'none') return !analyzed;
    if (!analyzed) return false;
    if (gState.verdict === 'good') return score >= 70;
    if (gState.verdict === 'mid') return score >= 40 && score < 70;
    if (gState.verdict === 'bad') return score < 40;
    return true;
}

// ДОБАВЛЕНО (TASK5 5.3c): полная пересборка #globalTableBody из
// gState.lotsCache (весь уже загруженный постранично список, а не только
// последняя подгруженная страница) под текущий gState.verdict — без
// нового сетевого запроса. Нужна отдельно от renderGlobalTableRows()
// (та просто дозаписывает новую пачку в конец) — иначе включение фильтра
// не убрало бы уже отрисованные несовпадающие строки, а выключение не
// вернуло бы скрытые.
function renderGlobalTableFromCache() {
    const tbody = document.getElementById('globalTableBody');
    if (!tbody) return;
    const filtered = gState.lotsCache.filter(matchesGVerdict);
    const grid = document.getElementById('globalGrid');   // сайт ≥1024: блоки — тот же отфильтрованный список
    if (grid && !IS_TELEGRAM && isWideBrowser()) {
        grid.innerHTML = '';
        if (filtered.length) filtered.forEach((l) => grid.appendChild(buildGlobalSiteCard(l)));
        else if (gState.lotsCache.length) grid.innerHTML = emptyStateHtml('ph-magnifying-glass', 'Ничего не найдено', 'Попробуйте изменить фильтр.', `<button type="button" onclick="resetGFilters()" class="btn-secondary text-xs">Сбросить фильтры</button>`);
    }
    tbody.innerHTML = '';
    if (!filtered.length) {
        if (gState.lotsCache.length > 0) {
            const resetBtn = `<button type="button" onclick="resetGFilters()" class="btn-secondary text-xs">Сбросить фильтры</button>`;
            tbody.innerHTML = `<tr><td colspan="8" class="lot-row-empty">${lotListEmptyStateHtml(true, null, null, null, resetBtn)}</td></tr>`;
        }
        return;
    }
    const fragment = document.createDocumentFragment();
    filtered.forEach(l => fragment.appendChild(buildGlobalTableRow(l)));
    tbody.appendChild(fragment);
    attachSparklines(tbody);
}

// ДОБАВЛЕНО (TASK5 5.3c): обработчик select'а «Вердикт» в рейле сайта
// (global_desktop.html) — мгновенно, без «Применить» (тот же приём, что и
// остальные поля рейла Базы AI, см. её комментарий у initGDesktopInstantFilters).
window.setGVerdict = (v) => {
    gState.verdict = v;
    updateGRailResetLabel();
    renderGlobalTableFromCache();
    tg.HapticFeedback.selectionChanged();
};

// Сортировка по скору кликом по заголовку — переиспользует gState/loadGlobalLots
// целиком (тот же запрос к /api/global_lots, что и обычная перезагрузка списка).
window.setGlobalTableSort = (mode) => {
    gState.sort = mode;
    loadGlobalLots(false);
};

// Слушатель поиска
document.getElementById('gSearchInput').addEventListener('input', (e) => {
    clearTimeout(gSearchTimeout);
    gSearchTimeout = setTimeout(() => { gState.query = e.target.value; loadGlobalLots(); }, 600);
});

// ДОБАВЛЕНО (P3.1 аудита, 11.09.2026): «База AI» теперь держит ДВЕ копии
// каждой группы кнопок (мобильная — в #gHeader, десктопная — в
// #globalFilterRail, см. partials/screens/global_desktop.html) вместо
// одной физически переезжающей — см. развёрнутый комментарий в начале того
// партиала. setGCategory()/setGSite()/selectGSort() ниже НЕ переписаны:
// они по-прежнему гасят класс у ВСЕХ элементов группы через querySelectorAll
// и красят активным только конкретно кликнутую кнопку (this) — что и
// оставляет вторую, некликнутую копию с устаревшей подсветкой. Эта функция
// закрывает именно этот пробел: копирует итоговый className с кликнутой
// кнопки на её "близнеца" в другой копии (находится по совпадающему
// текстовому содержимому — оно уникально внутри одной группы кнопок и не
// зависит от разметки/id). Вызывается ДОПОЛНИТЕЛЬНО, только из onclick
// десктопных кнопок (см. global_desktop.html) — мобильные кнопки в
// #gHeader и Главная/Избранное её не вызывают вообще, их поведение не
// менялось ни на строку.
function mirrorGButtonState(clickedBtn, groupClass) {
    const text = clickedBtn.textContent.trim();
    document.querySelectorAll('.' + groupClass).forEach(btn => {
        if (btn !== clickedBtn && btn.textContent.trim() === text) {
            btn.className = clickedBtn.className;
        }
    });
}

// Кнопки категорий и сайтов
window.setGCategory = (v, btn) => {
    gState.category = v;
    // ИСПРАВЛЕНО (TASK5 5.3c, ревью владельца): десктопный рейл больше не
    // рендерит пилюли #gCategoryRowDesktop (был 8-кнопочный стек, тесно в
    // 264px, §4 просит select — см. global_desktop.html) — render_select()
    // зовёт setGCategory(v, null), красить нечего. Та же защита, что уже
    // есть у setFavCategory() (D2): btn остаётся опциональным на случай,
    // если мобильная разметка (#gCategoryRow в global.html) когда-нибудь
    // тоже перейдёт на select — сейчас она не трогается, её пилюли красит
    // этот же обработчик с реальной кнопкой, как и раньше.
    if (btn) {
        // ИСПРАВЛЕНО (унификация категорий): та же активная заливка, что и у
        // #homeCategoryRow/setCategory() — раньше здесь был плоский цвет вместо
        // золотого градиента из исходной вёрстки.
        document.querySelectorAll('.g-cat-btn').forEach(x => x.className="whitespace-nowrap px-4 py-1.5 rounded-full text-xs font-bold bg-white/5 text-gray-300 border border-white/5 transition-all g-cat-btn");
        btn.className = "whitespace-nowrap px-4 py-1.5 rounded-full text-xs font-bold bg-accent text-accent-ink transition-all g-cat-btn";
    } else {
        // ДОБАВЛЕНО (TASK5 5.3c): вызов пришёл из десктопного select'а (нет
        // кликнутой кнопки-«this», mirrorGButtonState тут не при чём — той
        // нужна пара с тем же textContent, у select'а его нет). Мобильная
        // пилюльная копия (#gCategoryRow в global.html) остаётся пилюлями
        // (не в периметре этой правки) и должна не разъезжаться с
        // gState.category, если пользователь потом сузит окно <1280px —
        // находим пару по значению в onclick, не по this.
        document.querySelectorAll('.g-cat-btn').forEach(x => {
            const isActive = (x.getAttribute('onclick') || '').startsWith(`setGCategory('${v}'`);
            x.className = isActive
                ? "whitespace-nowrap px-4 py-1.5 rounded-full text-xs font-bold bg-accent text-accent-ink transition-all g-cat-btn"
                : "whitespace-nowrap px-4 py-1.5 rounded-full text-xs font-bold bg-white/5 text-gray-300 border border-white/5 transition-all g-cat-btn";
        });
    }
    tg.HapticFeedback.selectionChanged();
    loadGlobalLots();
}

window.setGSite = (v, btn) => {
    gState.site = v;
    document.querySelectorAll('.g-site-btn').forEach(x => x.className="flex-1 py-1.5 text-xs font-bold rounded-full text-gray-400 hover:text-white transition-all g-site-btn");
    btn.className = "flex-1 py-1.5 text-xs font-bold rounded-full bg-white/10 text-white shadow-sm transition-all g-site-btn active";
    tg.HapticFeedback.selectionChanged(); 
    loadGlobalLots();
};

window.selectGSort = (v,b) => {
    gState.sort = v;
    document.querySelectorAll('.g-sort-btn').forEach(x => {
        x.classList.remove('active','bg-[#A16207]','text-white','border-[#A16207]');
        x.classList.add('bg-white/5','text-gray-400');
    });
    b.classList.remove('bg-white/5','text-gray-400');
    b.classList.add('active','bg-[#A16207]','text-white','border-[#A16207]');
}

window.toggleGFilters = (forceClose = false) => {
    const p = document.getElementById('gFilterPanel');
    const b = document.getElementById('gFilterToggleBtn');
    const s = document.getElementById('gHeaderSpacer');
    const h = document.getElementById('gHeader');
    // См. тот же комментарий у toggleFilters() выше — #gFilterPanelActions
    // теперь сосед #gFilterPanel, синхронизируем .open вручную.
    const actions = document.getElementById('gFilterPanelActions');

    // Исправленная логика принудительного закрытия
    if (forceClose) {
        p.classList.remove('open');
        if (actions) actions.classList.remove('open');
    } else {
        p.classList.toggle('open');
        if (actions) actions.classList.toggle('open', p.classList.contains('open'));
    }

    if (p.classList.contains('open')) {
        b.classList.add('bg-indigo-600', 'border-indigo-600');
        setTimeout(() => { s.style.height = (h.offsetHeight + 20) + 'px' }, 50);

        // 🔥 Блокировка фона для вкладки Global
        document.body.style.overflow = 'hidden';
        h.style.maxHeight = '100vh';
        h.style.overflowY = 'auto';
        h.style.overscrollBehavior = 'contain';
    } else {
        b.classList.remove('bg-indigo-600', 'border-indigo-600');
        s.style.height = '190px';

        // 🔥 Разблокировка фона
        document.body.style.overflow = '';
        h.style.maxHeight = '';
        h.style.overflowY = '';
        h.style.overscrollBehavior = '';
    }
}

window.applyGFilters = () => {
    gState.auctionType = document.getElementById('gAuctionTypeSelect') ? document.getElementById('gAuctionTypeSelect').value : 'all';
    toggleGFilters(true);
    loadGlobalLots();
}

// ДОБАВЛЕНО (TASK5 5.3, §4): рейл сайта применяется мгновенно — тот же
// делегированный listener на #globalFilterRailScroll, что и
// initDesktopInstantFilters() у Главной (TASK4 4.3). auctionType здесь —
// единственное поле, что раньше требовало отдельной кнопки «Применить»
// (поиск уже мгновенный — см. 'input'-listener на #gSearchInput ниже по
// файлу; категория/площадка/сортировка — собственные onclick/onchange,
// не нуждаются в делегировании). once — вешаем ровно один раз, не при
// каждом switchScreen('global').
let gInstantFiltersInit = false;
function initGDesktopInstantFilters() {
    if (gInstantFiltersInit) return;
    const scroll = document.getElementById('globalFilterRailScroll');
    if (!scroll) return; // Mini App/мобильный — колонки нет вовсе
    gInstantFiltersInit = true;
    scroll.addEventListener('change', (e) => {
        if (e.target.id === 'gAuctionTypeSelectDesktop') applyGFilters();
    });
}

// ДОБАВЛЕНО (TASK5 5.3, §4): «Сбросить · N» в футере рейла — тот же приём,
// что countActiveRailFilters()/resetFilters() Главной (TASK4 4.3) и
// countActiveFavFilters()/resetFavFilters() Избранного (5.2). Категория/
// площадка/сортировка живут вне рейла на мобильном, но здесь, в рейле
// сайта, — внутри него; считаем наравне с поиском/типом аукциона, как и
// в Избранном.
function countActiveGFilters() {
    let n = 0;
    if (gState.query) n++;
    if (gState.category !== 'all') n++;
    if (gState.site !== 'all') n++;
    if (gState.auctionType !== 'all') n++;
    if (gState.verdict !== 'all') n++; // ДОБАВЛЕНО (TASK5 5.3c)
    return n;
}

function updateGRailResetLabel() {
    const btn = document.getElementById('gRailResetBtn');
    if (!btn) return; // мобильный/Mini App — рейла нет вовсе
    const n = countActiveGFilters();
    if (n > 0) {
        btn.textContent = `Сбросить · ${n}`;
        btn.classList.remove('hidden');
    } else {
        btn.classList.add('hidden');
    }
}

// Сброс ТОЛЬКО полей рейла сайта (поиск/категория/площадка/тип аукциона) —
// сортировку не трогает, тот же принцип, что и у resetFilters()/
// resetFavFilters(). Программная установка .value не порождает change —
// чистим gState напрямую.
window.resetGFilters = () => {
    const searchEl = document.getElementById('gSearchInputDesktop');
    if (searchEl) searchEl.value = '';
    const mobileSearchEl = document.getElementById('gSearchInput');
    if (mobileSearchEl) mobileSearchEl.value = '';
    gState.query = '';
    gState.category = 'all';
    gState.site = 'all';
    gState.auctionType = 'all';
    gState.verdict = 'all'; // ДОБАВЛЕНО (TASK5 5.3c)
    const atEl = document.getElementById('gAuctionTypeSelectDesktop');
    if (atEl) atEl.value = 'all';
    const mobileAtEl = document.getElementById('gAuctionTypeSelect');
    if (mobileAtEl) mobileAtEl.value = 'all';
    const verdictEl = document.getElementById('gVerdictSelectDesktop');
    if (verdictEl) verdictEl.value = 'all';
    const catEl = document.getElementById('gCategoryRowDesktop');
    if (catEl && catEl.tagName === 'SELECT') catEl.value = 'all';
    document.querySelectorAll('.g-cat-btn').forEach((b) => {
        b.className = b.textContent.trim() === 'Все'
            ? 'whitespace-nowrap px-4 py-1.5 rounded-full text-xs font-bold bg-accent text-accent-ink transition-all g-cat-btn'
            : 'whitespace-nowrap px-4 py-1.5 rounded-full text-xs font-bold bg-white/5 text-gray-300 border border-white/5 transition-all g-cat-btn';
    });
    document.querySelectorAll('.g-site-btn').forEach((b) => {
        b.className = b.textContent.trim() === 'Все'
            ? 'flex-1 py-1.5 text-xs font-bold rounded-full bg-white/10 text-white shadow-sm transition-all g-site-btn active'
            : 'flex-1 py-1.5 text-xs font-bold rounded-full text-gray-400 hover:text-white transition-all g-site-btn';
    });
    loadGlobalLots();
};

// ДОБАВЛЕНО (TASK5 5.3, §4, B-07): обработчик select-сортировки рейла сайта —
// не selectGSort() (та красит кнопку по переданной ссылке и НЕ
// перезагружает список сама по себе — рассчитана на клик по кнопке
// мобильной/десктопной сетки, которых здесь больше нет, см. её комментарий
// в разметке). Мобильная кнопочная сетка (#gHeader) не синхронизируется —
// отдельная, независимая копия вне периметра этой правки.
window.setGSortSelect = (mode) => {
    gState.sort = mode;
    loadGlobalLots();
};

// Открытие/Закрытие истории анализов
function openAnalysesHistory() {
    document.getElementById('modalAnalyses')?.classList.remove('translate-x-full');
    renderAnalyses(); // Грузим список только при открытии окна
}

// ИСПРАВЛЕНО (жалоба "Ошибка при загрузке отчета" при открытии анализа с
// сайта): #modalAnalyses существует ТОЛЬКО в Mini App (partials/modals/
// analyses.html — на сайте вместо модалки настоящая страница
// /workspace/analyses, см. screens/analyses.html, там этого узла в DOM нет
// вовсе). closeAnalysesHistory() вызывается из openHistoryAnalysis() на
// ОБЕИХ площадках (общая функция для карточки/строки анализа) с проверкой
// только "typeof closeAnalysesHistory === 'function'" — сама функция
// существует всегда, а вот getElementById('modalAnalyses') на сайте
// возвращал null, и .classList.add(...) на null валил всю функцию
// исключением. Из-за этого openHistoryAnalysis() падал в catch ПОСЛЕ того,
// как отчёт уже успешно загрузился — пользователь видел "Ошибка при загрузке
// отчета", хотя данные были на месте и должны были просто открыться.
function closeAnalysesHistory() {
    document.getElementById('modalAnalyses')?.classList.add('translate-x-full');
    // Сбрасываем режим сравнения при выходе с экрана — иначе при повторном
    // открытии список снова окажется в режиме выбора без явного намерения.
    if (compareMode) {
        compareMode = false;
        compareSelection = [];
        const btn = document.getElementById('btnCompareToggle');
        if (btn) { btn.classList.remove('bg-purple-600/30', 'text-purple-300'); }
        updateCompareBar();
    }
}

// Тихое обновление счетчика для профиля
async function updateAnalysesCount() {
    try {
        const r = await fetch(`/api/analysis/history?user_id=${userId}&t=${Date.now()}`);
        const history = await r.json();
        if (!Array.isArray(history)) return; // см. комментарий в renderAnalyses() — та же защита от "undefined шт"
        const countEl = document.getElementById('analysesCount');
        if (countEl) countEl.innerText = `${history.length} шт`;
    } catch(e) {}
}
// --- ОБНОВЛЕННАЯ ФУНКЦИЯ: Оплата Kaspi (Ручной режим) + Активация Trial ---
async function payWithKaspi() {
    if (!selectedProduct) return;
    // TASK26 26.2b: страховка — тариф вне PLANS_ON_SALE не отправляем вовсе.
    if (selectedProduct.startsWith('sub_')) {
        const onSaleIds = (window.PLANS_ON_SALE || []);
        if (!onSaleIds.includes(selectedProduct.replace('sub_', ''))) {
            // TASK29: тариф не продаётся — заказ не отправляем; при пустом
            // списке модалка переключается на розницу (renderPlans()).
            if (!onSaleIds.length) { renderPlans(); return; }
            selectedProduct = `sub_${onSaleIds[0]}`;
        }
    }

    const btn = document.getElementById('checkoutBtn');
    const originalHtml = btn.innerHTML;

    const calc = calculatePriceInfo(selectedProduct, billingPeriod);
    
    // 3. Формируем правильный ID товара для бэкенда
    let finalItemId = selectedProduct;
    if (!selectedProduct.startsWith('retail_')) {
        const planId = selectedProduct.replace('sub_', '');
        finalItemId = `sub_${planId}_${billingPeriod}`;
    }

    btn.innerHTML = '<i class="ph-bold ph-spinner animate-spin text-xl"></i> Обработка...';
    btn.disabled = true;

    // TASK26 26.0: в браузере (нет Telegram initData) ответ сервера нужно показать
    // самому — tg.close() там no-op, раньше кнопка висела на «Обработка...» вечно.
    const inMiniApp = !!(typeof tg !== 'undefined' && tg && tg.initData);
    const resultBox = document.getElementById('kaspiResult');
    if (resultBox) { resultBox.classList.add('hidden'); resultBox.innerHTML = ''; }
    const showErr = (msg) => {
        if (inMiniApp && tg.showAlert) tg.showAlert(msg);
        else if (resultBox) {
            resultBox.textContent = msg;
            resultBox.className = 'mb-4 px-3 py-2.5 rounded-xl text-xs bg-red-500/10 border border-red-500/30 text-red-300';
        } else alert(msg);
    };
    const ctrl = new AbortController();
    const timer = setTimeout(() => ctrl.abort(), 20000);

    try {
        const res = await fetch('/api/billing/kaspi', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            signal: ctrl.signal,
            body: JSON.stringify({
                user_id: userId,
                item_id: finalItemId,
                price: calc.finalPrice,       // Итоговая цена (с учетом остатка старого тарифа)
                item_name: calc.itemName,     // Название (включает приписку "[Учтен остаток...]")
            })
        });

        if (inMiniApp) {
            // Mini App: прежнее поведение — закрываем WebApp, инструкция пришла в чат бота.
            tg.close();
            return;
        }

        let data = null;
        try { data = await res.json(); } catch (_) {}
        if (!res.ok) {
            const d = data && data.detail;
            showErr(typeof d === 'string' ? d : 'Не удалось оформить заказ (ошибка ' + res.status + '). Попробуйте ещё раз или напишите в поддержку.');
            return;
        }

        const link = (data && data.kaspi_link) || 'https://pay.kaspi.kz/pay/sibfhugn';
        const bot = window.BOT_USERNAME ? 'https://t.me/' + window.BOT_USERNAME : '';
        const esc = (x) => String(x).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
        if (resultBox) {
            resultBox.className = 'mb-4 px-3 py-3 rounded-xl text-xs bg-emerald-500/10 border border-emerald-500/30 text-gray-200 leading-relaxed';
            resultBox.innerHTML =
                '<div class="font-bold text-white mb-1">Заказ создан: ' + esc(calc.itemName) + ' — ' + esc(calc.finalPrice) + ' ₸</div>' +
                '<div><b>Шаг 1.</b> Оплатите через Kaspi Pay: <a href="' + esc(link) + '" target="_blank" rel="noopener" class="text-accent underline break-all">' + esc(link) + '</a></div>' +
                '<div class="mt-1"><b>Шаг 2.</b> ОБЯЗАТЕЛЬНО отправьте чек (скриншот или PDF) боту в Telegram' +
                (bot ? ': <a href="' + esc(bot) + '" target="_blank" rel="noopener" class="text-accent underline">@' + esc(window.BOT_USERNAME) + '</a>' : '') +
                '. Без чека тариф не активируется.</div>';
        }
    } catch (e) {
        showErr(e && e.name === 'AbortError'
            ? 'Сервер не ответил вовремя. Попробуйте ещё раз.'
            : 'Ошибка соединения с сервером');
    } finally {
        clearTimeout(timer);
        btn.innerHTML = originalHtml;
        btn.disabled = false;
    }
}


// ==========================================
// 🧮 "ПЕРЕСЧИТАТЬ ПОД СВОИ ЦИФРЫ" — надстройка над реальными цифрами отчёта
// ==========================================
// Раньше это был отдельный бесплатный калькулятор до покупки анализа со
// своими типовыми % дисконта — по запросу продукта перенесён внутрь уже
// оплаченного отчёта: вместо гадания на глаз пользователь двигает РЕАЛЬНЫЕ
// входные цифры этого лота (цена/ремонт/расходы) и видит, как это поменяет
// итог — той же формулой, что backend уже применил один раз при генерации
// отчёта (см. analyzer.py, блок "BACKEND-RECOMPUTE ФИНАНСОВОЙ МАТЕМАТИКИ" +
// "MARGIN OF SAFETY" + "ГОДОВАЯ ДОХОДНОСТЬ"):
//   total_investment = цена_входа + ремонт + расходы
//   profit = realistic_price - total_investment
//   roi% = profit / total_investment * 100
//   margin_of_safety% = max(0, (1 - total_investment/realistic_price) * 100)
//   roi_annualized% = roi% * (365 / estimated_sales_period_days), если срок известен
// realistic_price и срок продажи НЕ редактируются — это независимая оценка
// ИИ, подстраивать их под желаемый ответ было бы самообманом.
let calcWhatIfBase = null;

function calcWhatIfInit(report) {
    const box = document.getElementById('calcWhatIfBlock');
    const f = report && report.financials;
    const realisticPrice = f && f.market_prices && f.market_prices.realistic_price;
    if (!f || !realisticPrice || !box) {
        if (box) box.classList.add('hidden');
        calcWhatIfBase = null;
        return;
    }
    box.classList.remove('hidden');
    box.open = false;
    calcWhatIfBase = {
        targetPrice: f.target_purchase_price || 0,
        repair: f.estimated_repair_cost || 0,
        taxes: f.taxes_and_fees || 0,
        realisticPrice: realisticPrice,
        salesPeriodDays: f.estimated_sales_period_days || null,
    };
    const priceEl = document.getElementById('calcWhatIfPrice');
    const repairEl = document.getElementById('calcWhatIfRepair');
    const taxesEl = document.getElementById('calcWhatIfTaxes');
    if (priceEl) priceEl.value = calcWhatIfBase.targetPrice;
    if (repairEl) repairEl.value = calcWhatIfBase.repair;
    if (taxesEl) taxesEl.value = calcWhatIfBase.taxes;
    calcWhatIfRecompute();
}

window.calcWhatIfRecompute = () => {
    if (!calcWhatIfBase) return;
    const resultEl = document.getElementById('calcWhatIfResult');
    if (!resultEl) return;

    const price = parseFloat(document.getElementById('calcWhatIfPrice').value) || 0;
    const repair = parseFloat(document.getElementById('calcWhatIfRepair').value) || 0;
    const taxes = parseFloat(document.getElementById('calcWhatIfTaxes').value) || 0;

    const totalInvestment = price + repair + taxes;
    const profit = calcWhatIfBase.realisticPrice - totalInvestment;
    const roi = totalInvestment ? Math.round((profit / totalInvestment) * 1000) / 10 : 0;
    const marginSafety = calcWhatIfBase.realisticPrice
        ? Math.max(0, Math.round((1 - totalInvestment / calcWhatIfBase.realisticPrice) * 1000) / 10)
        : 0;

    const fmt = (v) => formatNumber(Math.round(v));
    const profitClassTg = profit >= 0 ? 'text-green-400' : 'text-red-400';
    const marginClassTg = marginSafety >= 20 ? 'text-green-400' : marginSafety >= 8 ? 'text-yellow-400' : 'text-red-400';

    // ИЗМЕНЕНО (TASK7 7.3, §4, "результат what-if — нейтральные строки,
    // цвет только на прибыли по знаку"): IS_TELEGRAM — старая разметка
    // (цветные плашки) байт-в-байт, сайт — definition-строки как в основной
    // финансовой таблице выше (report-fin-row), цвет только на прибыли.
    if (REPORT_LEGACY_MARKUP) {
        let annualHtml = '';
        if (calcWhatIfBase.salesPeriodDays) {
            const annualized = Math.round(roi * (365 / Math.max(1, calcWhatIfBase.salesPeriodDays)) * 10) / 10;
            annualHtml = `
                <div class="bg-white/5 p-2.5 rounded-lg border border-white/10 col-span-2">
                    <div class="text-[9px] text-[#94a3b8] uppercase font-bold mb-0.5">Годовых (справочно, грубая аннуализация)</div>
                    <div class="text-sm font-bold text-blue-300">${annualized}%</div>
                </div>`;
        }
        resultEl.innerHTML = `
            <div class="bg-white/5 p-2.5 rounded-lg border border-white/10">
                <div class="text-[9px] text-[#94a3b8] uppercase font-bold mb-0.5">Итоговый капитал</div>
                <div class="text-sm font-bold text-white">${fmt(totalInvestment)} ₸</div>
            </div>
            <div class="bg-green-500/10 p-2.5 rounded-lg border border-green-500/20">
                <div class="text-[9px] text-green-400/80 uppercase font-bold mb-0.5">Прибыль / ROI</div>
                <div class="text-sm font-bold ${profitClassTg}">${fmt(profit)} ₸ <span class="text-[10px]">(${roi}%)</span></div>
            </div>
            <div class="bg-white/5 p-2.5 rounded-lg border border-white/10 col-span-2">
                <div class="text-[9px] text-[#94a3b8] uppercase font-bold mb-0.5">Запас прочности</div>
                <div class="text-sm font-bold ${marginClassTg}">${marginSafety}%</div>
            </div>
            ${annualHtml}
        `;
    } else {
        const profitClass = profit >= 0 ? 'text-pos' : 'text-neg';
        let annualRow = '';
        if (calcWhatIfBase.salesPeriodDays) {
            const annualized = Math.round(roi * (365 / Math.max(1, calcWhatIfBase.salesPeriodDays)) * 10) / 10;
            annualRow = `<div class="report-fin-row"><span class="text-caption text-secondary">Годовых (справочно)</span><span class="text-body font-mono-nums text-primary">${annualized}%</span></div>`;
        }
        resultEl.innerHTML = `
            <div class="report-fin-row"><span class="text-caption text-secondary">Итоговый капитал</span><span class="text-body font-mono-nums text-primary">${fmt(totalInvestment)} ₸</span></div>
            <div class="report-fin-row"><span class="text-caption text-secondary">Прибыль / ROI</span><span class="text-body font-mono-nums ${profitClass}">${fmt(profit)} ₸ <span class="text-caption">(${roi}%)</span></span></div>
            <div class="report-fin-row"><span class="text-caption text-secondary">Запас прочности</span><span class="text-body font-mono-nums text-primary">${marginSafety}%</span></div>
            ${annualRow}
        `;
    }
};

window.calcWhatIfReset = () => {
    if (!calcWhatIfBase) return;
    document.getElementById('calcWhatIfPrice').value = calcWhatIfBase.targetPrice;
    document.getElementById('calcWhatIfRepair').value = calcWhatIfBase.repair;
    document.getElementById('calcWhatIfTaxes').value = calcWhatIfBase.taxes;
    calcWhatIfRecompute();
};

// D2 (DESIGN_UPGRADE_PROMPT.md §5.6, "the money screen — the 10-second
// test lives here"): липкая TL;DR-строка (#uiTldrStrip в analysis.html) —
// сводка уже существующих полей отчёта (вердикт/скор/целевая цена/ROI/
// дедлайн), не новые данные и не новый запрос. Целевая цена считается тем
// же способом, что и в блоке "ФИНАНСЫ" ниже (report.financials.target_purchase_price,
// либо от total_investment в обратную сторону, если поля нет в старых
// отчётах) — вынесено сюда отдельно, а не переиспользует локальную
// переменную того блока, потому что TL;DR должен быть готов ДО того, как
// дойдёт очередь до финансового блока в этой же функции.
// «под вопросом»: the same conditionally_recommended status, a different LABEL -- the conditional badge exists only because an AI-only market
// lifted a negative engine result (verdict_engine.doubtful, finance/verdict.py)
function reportVerdictLabel(report, badge, map) {
    if (badge === 'conditionally_recommended' && report && report.verdict_engine && report.verdict_engine.doubtful) return 'Под вопросом';
    return (map || {})[badge];
}

function updateTldrStrip(report) {
    const strip = document.getElementById('uiTldrStrip');
    if (!strip) return;
    if (!report) { strip.classList.add('hidden'); return; }
    strip.classList.remove('hidden');

    const verdictText = { recommended: 'Рекомендуется', conditionally_recommended: 'Условно', not_recommended: 'Не рекомендуется' };
    const verdictClass = { recommended: 'text-pos', conditionally_recommended: 'text-warn', not_recommended: 'text-neg' };
    const verdictEl = document.getElementById('uiTldrVerdict');
    verdictEl.textContent = reportVerdictLabel(report, report.verdict_badge, verdictText) || '—';
    verdictEl.className = `text-xs font-bold whitespace-nowrap ${verdictClass[report.verdict_badge] || 'text-tertiary'}`;

    const score = report.investment_score || 0;
    const scoreClass = score >= 70 ? 'text-pos' : score >= 40 ? 'text-warn' : 'text-neg';
    const scoreEl = document.getElementById('uiTldrScore');
    scoreEl.textContent = score;
    scoreEl.className = `text-xs font-mono-nums font-bold whitespace-nowrap ${scoreClass}`;

    const fin = report.financials || {};
    let targetPrice = fin.target_purchase_price;
    if (targetPrice === undefined) {
        const repair = fin.estimated_repair_cost || 0;
        const taxes = fin.taxes_and_fees !== undefined ? fin.taxes_and_fees : (fin.additional_costs || 0);
        targetPrice = (fin.total_investment || 0) - repair - taxes;
        if (targetPrice < 0) targetPrice = fin.start_price || 0;
    }
    document.getElementById('uiTldrPrice').textContent = targetPrice ? formatMoney(targetPrice) : '—';

    const roi = fin.roi_percent;
    const roiEl = document.getElementById('uiTldrRoi');
    if (typeof roi === 'number') {
        roiEl.textContent = `${roi >= 0 ? '+' : ''}${Math.round(roi)}%`;
        roiEl.className = `text-xs font-mono-nums font-bold whitespace-nowrap ${roi >= 0 ? 'text-pos' : 'text-neg'}`;
    } else {
        roiEl.textContent = '—';
        roiEl.className = 'text-xs font-mono-nums font-bold whitespace-nowrap text-tertiary';
    }

    document.getElementById('uiTldrDeadline').innerHTML = renderDeadlineChipHtml(state.currentLot?.application_deadline);
}

// TASK13 13.3: renders report.geo_context (bot/geo/lookup.py's
// GeoContext) into the «Участок и градостроительство» section.
// Unresolved (no parcel AND no registry point at all) -> the section
// stays hidden entirely -- the existing «Локация» prose block
// (#uiGeoText, rendered just above this call site) already carries one
// muted explanatory line via ctx.warnings, so this function doesn't
// duplicate it.
const GEO_UTILITY_LABELS = {
    electro: 'Электричество', gas: 'Газ', heat: 'Теплоснабжение', water: 'Водоснабжение',
    sewerage: 'Ливневая канализация', fecal: 'Канализация', phone: 'Телефония',
};

function _geoUtilityChipHtml(label, value) {
    // Same 3-state status-chip vocabulary as the rest of the report
    // (§7.4): true -> ok (green), false -> critical (red, "нет" is a
    // real gap the investor should register, not a neutral fact),
    // null/undefined -> unknown (muted "нет данных").
    const state = value === true ? 'ok' : value === false ? 'critical' : 'unknown';
    const text = value === true ? 'есть' : value === false ? 'нет' : 'нет данных';
    return `<span class="status-chip${state === 'unknown' ? '' : ` status-chip--${state}`}">${label}: ${text}</span>`;
}

function renderGeoContextSection(report, sectionEl) {
    const ctx = report.geo_context;
    const parcel = ctx && ctx.parcel;
    const registry = ctx && ctx.registry;
    // TASK39: the resolved parcel is not the lot's own land (areas differ > 5x) -- its data is dropped server-side; say so, draw no map
    if (ctx && ctx.parcel_mismatch) {
        _geoTeardownMap();
        const wrap = document.getElementById('uiGeoMapWrap');
        if (wrap) wrap.classList.add('hidden');
        const mm = ctx.parcel_mismatch;
        const ga = (v) => String(v).replace('.', ',');
        document.getElementById('uiGeoDetails').innerHTML =
            `<p class="text-body text-primary">Участок в реестре не совпадает с описанием лота (реестр ${escapeHtml(ga(mm.parcel_ga))} га, в ${escapeHtml(mm.stated_in || 'описании')} ${escapeHtml(ga(mm.stated_ga))} га) — данные реестра не используются.</p>`;
        sectionEl.classList.remove('hidden');
        return;
    }
    // A usable section needs a real parcel OR at least the registry's
    // own polygon-derived facts (jerler, unregistered land) -- a bare
    // "warnings only" context (13.1's honest "не определён") renders
    // nothing here, per the brief's own "unresolved -> not rendered" rule.
    const registryUsable = Boolean(registry && (registry.area_ga || registry.appraised_value));
    // 30.13: no parcel and no registry facts, but the lot states a cadastral number ->
    // show the section and say NIPD doesn't have it (never a silent vanish); no map.
    if (ctx && !parcel && !registryUsable && ctx.lot_kad_raw) {
        _geoTeardownMap();
        const wrap = document.getElementById('uiGeoMapWrap');
        if (wrap) wrap.classList.add('hidden');
        document.getElementById('uiGeoDetails').innerHTML =
            `<div class="report-fin-row"><span class="text-caption text-secondary">Кадастровый номер из лота</span><span class="text-body font-mono-nums text-primary">${escapeHtml(ctx.lot_kad_raw)}</span></div>`
            // 2026-10-27: NIPD answered 503 (maintenance) for days -- an unanswered registry is not «no such number»
            + `<p class="text-caption text-secondary" style="margin-top:8px;">${ctx.nipd_unavailable
                ? 'Реестр НИПД не отвечал, когда мы проверяли участок (технические работы на его сервере), поэтому номер не проверен: категория, назначение, площадь и градостроительные данные пока недоступны. Мы проверим участок повторно автоматически.'
                : 'В реестре НИПД такого номера не найдено, поэтому категория, назначение, площадь и градостроительные данные недоступны. Проверьте номер в документах лота.'}</p>`;
        sectionEl.classList.remove('hidden');
        return;
    }
    if (!ctx || (!parcel && !registryUsable)) {
        _geoTeardownMap();
        sectionEl.classList.add('hidden');
        return;
    }

    const planning = ctx.planning || {};
    const utilities = planning.utilities || {};
    const rows = [];

    // TASK13 13.3 (owner review round 3, live on sauda_337346917992000000):
    // resolved_by === 'address' (ЕГКН by street+house, exact suffix OR the
    // 13.2c base-number fallback) always finds the BUILDING's own shared
    // parcel, never a unit's individual plot -- true for flat/garage/
    // commercial (a flat/parking spot/premise never has its own separate
    // parcel in this cadastre). A house or land lot's OWN parcel search can
    // also go through the address step (no cadastral number in its docs),
    // but there the found parcel genuinely IS the lot's own -- so the
    // "shared, not yours" framing is keyed on property_category, not on
    // resolved_by alone.
    const propertyCategory = report.attributes && report.attributes.property_category;
    const isBuildingShared = ctx.resolved_by === 'address'
        && ['flat', 'garage', 'commercial'].includes(propertyCategory);
    // 33.0: the legend/«complex parcel» wording depends on the LOT, not on how the parcel was found
    // (a flat's kad number from the documents resolves the same complex parcel with resolved_by != 'address')
    const isComplexLot = ['flat', 'garage', 'commercial'].includes(propertyCategory);

    if (isBuildingShared) {
        rows.push('<p class="text-caption text-tertiary" style="margin-bottom:8px;">Участок жилого комплекса (общий), не сам объект.</p>');
    }

    // TASK30 30.4: every fact row names its source (small tertiary caption, not a
    // badge -- §7.4 allows <=1 badge per row and a source on EVERY row would be
    // exactly the "badge on every card" slop). «нет данных» != «нет» (TASK13).
    const SRC_NIPD = 'НИПД', SRC_JERLER = 'jerler', SRC_GGK = 'ГГК', SRC_ASTANA = 'ГИС Астаны', SRC_EGKN = 'ЕГКН';
    const geoRow = (label, valueHtml, opts = {}) => {
        const src = opts.src ? ` <span class="text-micro text-tertiary report-geo-src">${opts.src}</span>` : '';
        return `<div class="report-fin-row"><span class="text-caption text-secondary">${label}${src}</span><span class="${opts.cls || 'text-body text-primary'}">${valueHtml}</span></div>`;
    };
    const noData = 'нет данных';
    const pickSrc = (parcelVal, registryVal) => (parcelVal ? SRC_NIPD : registryVal ? SRC_JERLER : undefined);

    // 1. Участок
    const areaLabel = isBuildingShared ? 'Площадь участка комплекса' : 'Площадь';
    const parcelArea = parcel && parcel.area_m2;
    const registryAreaM2 = registry && registry.area_ga ? registry.area_ga * 10000 : null;
    const statedAreaM2 = parcelArea || registryAreaM2;
    let areaText = noData;
    if (parcelArea) {
        // same format as «по контуру» below (fmtPriceCompact gave «2,1 тыс. м²» next to «≈ 1 978 м²»)
        areaText = _geoFmtArea(parcelArea);
    } else if (registry && registry.area_ga) {
        areaText = `${String(registry.area_ga).replace('.', ',')} га`;
    }
    const kadNomerValue = (parcel && parcel.kad_nomer) || (registry && registry.kad_nomer);
    // jerler masks part of a registered number («09142______»): show the visible
    // head and say so, never the underscores as if it were the number.
    const kadMasked = typeof kadNomerValue === 'string' && kadNomerValue.includes('_');
    const fmtKad = (d) => (d && d.length >= 9 ? `${d.slice(0, 2)}:${d.slice(2, 5)}:${d.slice(5, 8)}:${d.slice(8)}` : d);
    const recode = ctx.kad_recode;  // 30.12: the lot's number only matched after the 2022 oblast re-coding
    const kadNomerText = recode
        ? `${fmtKad(recode.from)} (в НИПД: ${fmtKad(recode.to)}, код области ${recode.region})`
        : kadMasked
        ? `${kadNomerValue.replace(/_+/g, '')}… (часть номера скрыта реестром)`
        : (kadNomerValue || (registry && registry.registered === false ? 'ещё не зарегистрирован' : noData));
    // A real cadastral number is tabular/mono (§6.2); the "not registered"/
    // "no data" fallback is a sentence, not a number -- forcing it into
    // JetBrains Mono made it wide enough to overflow the row at 375px
    // instead of wrapping (found live during 13.2b review screenshots).
    const kadNomerClass = kadNomerValue && !kadMasked ? 'text-body font-mono-nums text-primary' : 'text-body text-primary';
    rows.push(geoRow('Кадастровый номер', escapeHtml(kadNomerText), { src: pickSrc(parcel && parcel.kad_nomer, registry && registry.kad_nomer), cls: kadNomerClass }));
    rows.push(geoRow('Категория земель', escapeHtml((parcel && parcel.category_ru) || (registry && registry.category_ru) || noData),
        { src: pickSrc(parcel && parcel.category_ru, registry && registry.category_ru) }));

    // Purpose: when NIPD and jerler BOTH state one and they differ, show both, labelled.
    const normPurpose = (t) => String(t || '').toLowerCase().replace(/[\s.]+/g, ' ').trim();
    const parcelPurpose = parcel && parcel.purpose_ru;
    const registryPurpose = registry && registry.purpose_ru;
    if (parcelPurpose && registryPurpose && normPurpose(parcelPurpose) !== normPurpose(registryPurpose)) {
        rows.push(geoRow('Целевое назначение', escapeHtml(parcelPurpose), { src: SRC_NIPD }));
        rows.push(geoRow('Целевое назначение', escapeHtml(registryPurpose), { src: SRC_JERLER }));
    } else {
        rows.push(geoRow('Целевое назначение', escapeHtml(parcelPurpose || registryPurpose || noData),
            { src: pickSrc(parcelPurpose, registryPurpose) }));
    }

    // 32.x ЕГКН `lands`: the right the parcel is held under and the term (dates only; no names, ever)
    const egknLands = (ctx.egkn && ctx.egkn.lands) || null;
    if (egknLands && egknLands.pravo_ru) rows.push(geoRow('Право на участок', escapeHtml(egknLands.pravo_ru), { src: SRC_EGKN }));
    if (egknLands && egknLands.date_end) {
        const d = new Date(egknLands.date_end);
        rows.push(geoRow('Срок землепользования', Number.isNaN(d.getTime()) ? escapeHtml(egknLands.date_end) : `до ${d.toLocaleDateString('ru-RU')}`, { src: SRC_EGKN, cls: 'text-body font-mono-nums text-primary' }));
    }
    rows.push(geoRow(areaLabel, areaText, { src: pickSrc(parcelArea, registryAreaM2), cls: 'text-body font-mono-nums text-primary' }));
    // Area check: the drawn outline's own geodesic area (server: geo/geometry.py)
    // against the registry's stated area. A >10 % gap is a warning row -- the
    // outline on the map is then only approximate (jerler's polygons are
    // often loose drawings; see the 30.4 commit message for the numbers).
    const contourM2 = ctx.polygon_area_m2;
    if (contourM2 && statedAreaM2) {
        const diffPct = Math.round(Math.abs(contourM2 - statedAreaM2) / statedAreaM2 * 100);
        // 32.4: one area row when the contour and the registry agree within 2 %
        if (Math.abs(contourM2 - statedAreaM2) / statedAreaM2 > 0.02) {
            rows.push(geoRow('Площадь по контуру', `≈ ${Math.round(contourM2).toLocaleString('ru-RU')} м²`,
                { src: parcel && parcel.polygon ? SRC_NIPD : SRC_JERLER, cls: 'text-body font-mono-nums text-primary' }));
        }
        if (diffPct > 10) {
            rows.push(`<p class="text-caption text-warn" style="margin:4px 0 8px;">Контур на карте не совпадает с площадью по реестру (разница ${diffPct}%): границы приблизительные, ориентируйтесь на площадь по реестру.</p>`);
        }
    }

    // 2. Генплан
    // 32.0: where the source keeps no such layer in this city the row says so (server: ctx.unavailable)
    const unavail = ctx.unavailable || {};
    // 32.4: rows with no data are NOT one row each -- they are collected and, per reason, written once
    // («Нет данных: зона генплана, ПДП, красные линии — ГГК не ведёт …»)
    const unknownItems = [];
    const GENERIC_REASON = 'источники (ГГК, ЕГКН) не ведут эти слои в этой точке';
    const pushUnknown = (label, reason) => unknownItems.push({ label, reason: reason || GENERIC_REASON });
    if (planning.gp_zone) rows.push(geoRow('Зона генплана', escapeHtml(planning.gp_zone), { src: SRC_GGK }));
    else pushUnknown('зона генплана', unavail.genplan);
    if (planning.pdp_zone) rows.push(geoRow('Зона детальной планировки (ПДП)', escapeHtml(planning.pdp_zone), { src: SRC_GGK }));
    else if (ctx.pdp_none) rows.push(geoRow('Зона детальной планировки (ПДП)', 'нет проекта в этой точке', { src: SRC_GGK }));
    else pushUnknown('ПДП', null);

    // 3. Ограничения. TASK13 13.3b (planner measurement: the old centroid-
    // distance test called 15/40 real parcels "пересекают" when the red
    // line was actually 4-126m outside the polygon) -- red_lines_relation
    // now comes from real polygon-vs-line geometry (geo/ggk.py's own
    // classify_red_lines). "Пересекают участок" (.text-neg, a warning)
    // only when the lot itself IS the parcel AND the line truly crosses
    // or runs along its boundary; a building-shared parcel keeps the
    // neutral "участка комплекса" wording for those same two relations
    // (red lines through the complex's grounds say nothing about the
    // individual unit); a point-only lot (no polygon at all) never claims
    // a crossing it can't confirm -- always the neutral "от точки объекта".
    // TASK30 30.4: the same line is now drawn on the map above.
    const relation = planning.red_lines_relation;
    const dist = planning.red_lines_distance_m;
    let redLines = 'нет данных';
    let redLinesClass = 'text-body text-primary';
    if (relation === 'crosses' || relation === 'boundary') {
        if (isBuildingShared) {
            redLines = 'проходят по участку комплекса';
        } else if (relation === 'crosses') {
            redLines = 'пересекают участок';
            redLinesClass = 'text-body text-neg';
        } else {
            redLines = 'проходят по границе участка';
        }
    } else if (relation === 'near') {
        redLines = dist != null ? `рядом, в ${Math.round(dist)} м от границы` : 'рядом с границей';
    } else if (relation === 'point') {
        redLines = dist != null ? `в ${Math.round(dist)} м от точки объекта` : 'нет данных';
    } else if (relation === 'none') {
        redLines = 'нет';
    }
    const waterProtection = ctx.water_protection === true ? 'да' : ctx.water_protection === false ? 'нет' : noData;
    if (redLines === noData) pushUnknown('красные линии', unavail.red_lines);
    else rows.push(geoRow('Красные линии', redLines, { src: planning.red_lines_source || SRC_GGK, cls: redLinesClass }));
    // 32.1 Астана: ГИС Астаны per-parcel layers (regulation, existing/projected red lines, buildings, water)
    const cl = (ctx.city_layers && ctx.city_layers.source === 'ГИС Астаны') ? ctx.city_layers : null;
    const rlWording = (rl) => {
        if (!rl || rl.relation == null) return null;
        if (rl.relation === 'crosses') return 'пересекают участок';
        if (rl.relation === 'boundary') return 'проходят по границе участка';
        if (rl.relation === 'near') return `рядом, в ${Math.round(rl.distance_m)} м от границы`;
        return 'нет в радиусе 50 м';
    };
    // 32.x: the context says which source answered the water row (ЕГКН / ГИС Астаны / слой map.gov.kz /
    // per-oblast map.gov.kz layers) and the reservoir names it gave
    let waterText = waterProtection;
    if (ctx.water_protection === true && ctx.water_names && ctx.water_names.length) waterText = `да — ${ctx.water_names.map(escapeHtml).join(', ')}`;
    const waterSrc = ctx.water_source || 'карты РК';
    if (waterText === noData) pushUnknown('водоохранная зона', null);
    else rows.push(geoRow('Водоохранная зона', waterText, { src: waterSrc }));
    if (cl) {
        if (cl.regulation && (cl.regulation.zone || cl.regulation.subzone)) {
            rows.push(geoRow('Градостроительный регламент', escapeHtml([cl.regulation.zone, cl.regulation.subzone].filter(Boolean).join(' / ')), { src: SRC_ASTANA }));
        }
        const ex = rlWording(cl.red_lines_existing), pr = rlWording(cl.red_lines_projected);
        if (ex) rows.push(geoRow('Красные линии: существующие', ex, { src: SRC_ASTANA, cls: cl.red_lines_existing.relation === 'crosses' ? 'text-body text-neg' : 'text-body text-primary' }));
        if (pr) {
            // projected = a FUTURE seizure risk, so it is shown distinctly from the existing lines
            rows.push(geoRow('Красные линии: проектируемые', pr, { src: SRC_ASTANA, cls: ['crosses', 'boundary'].includes(cl.red_lines_projected.relation) ? 'text-body text-warn' : 'text-body text-primary' }));
        }
        if (cl.buildings) {
            const b = cl.buildings;
            // 33.0: layer 15's FLOOR defaults to 1 -- never print «до 1 эт.» for a complex (and older stored
            // contexts carry no floors_reliable flag, so a «1» on a flat/parking/premise parcel is unknown too)
            const floorsKnown = b.max_floors && b.floors_reliable !== false && !(isComplexLot && b.max_floors <= 1);
            const small = b.small_count ? ` (+${b.small_count} мелк. построек)` : '';
            const bText = b.count
                ? `${b.count} ${pluralizeRu(b.count, 'здание', 'здания', 'зданий')}, ${floorsKnown ? `до ${b.max_floors} эт.` : 'этажность не определена'}${small}`
                : (b.small_count ? `только мелкие постройки (${b.small_count})` : 'участок не застроен');
            rows.push(geoRow('Здание на участке', bText, { src: SRC_ASTANA }));
        }
        if (cl.pdp_buildings && cl.pdp_buildings.count) {
            const pb = cl.pdp_buildings;
            rows.push(geoRow('Застройка по ПДП', `${pb.max_floors ? `до ${pb.max_floors} эт.` : 'есть'}${pb.functional && pb.functional.length ? ` — ${pb.functional.map(escapeHtml).join(', ')}` : ''}`, { src: SRC_ASTANA }));
        }
    }

    // Auctions on this parcel (jerler «Все торги»): count and last date from the
    // registry page, outcomes only from our own lots of the same object (the page
    // has none) -- so the caption says whose numbers they are.
    const th = ctx.trade_history;
    if (registry && th && th.count) {
        const lastDate = th.last_at ? new Date(th.last_at).toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit', year: 'numeric' }) : null;
        const ourDb = th.count_source === 'our_db' ? ' (в нашей базе)' : '';
        rows.push(geoRow('Торги по этому участку', `${th.count}${ourDb}${lastDate ? ` · последние ${lastDate}` : ''}`,
            { src: SRC_JERLER, cls: 'text-body font-mono-nums text-primary' }));
        const o = th.outcomes || {};
        const parts = [];
        if (o.held) parts.push(`состоялись — ${o.held}`);
        if (o.failed) parts.push(`не состоялись — ${o.failed}`);
        if (o.open) parts.push(`идёт приём заявок — ${o.open}`);
        if (parts.length) {
            rows.push(`<p class="text-caption text-tertiary" style="margin:0 0 8px;">Итоги по нашей базе (${th.outcomes_known_for} из ${th.count}): ${parts.join(', ')}.</p>`);
        }
    }

    // Registry-only facts (jerler): encumbrance and the registry's own appraised value.
    if (registry) {
        rows.push(geoRow('Обременения (аресты)', escapeHtml(registry.encumbrance_note || noData), { src: SRC_JERLER }));
        if (registry.appraised_value) {
            rows.push(geoRow('Оценочная стоимость', formatMoney(registry.appraised_value), { src: SRC_JERLER, cls: 'text-body font-mono-nums text-primary' }));
        }
    }

    // 4. Инженерные сети — 7 chips
    if (Object.keys(GEO_UTILITY_LABELS).some(key => utilities[key] === true || utilities[key] === false)) {
        const utilityChips = Object.keys(GEO_UTILITY_LABELS).map(key => _geoUtilityChipHtml(GEO_UTILITY_LABELS[key], utilities[key])).join(' ');
        rows.push(`<p class="text-caption text-secondary" style="margin-top:8px;">Инженерные сети <span class="text-micro text-tertiary report-geo-src">${SRC_GGK}</span></p>`);
        rows.push(`<div class="report-citation-chips">${utilityChips}</div>`);
    } else {
        pushUnknown('инженерные сети', null);
    }

    // 32.4: the unknown rows, grouped by reason (one line per reason; a lone item keeps its own wording)
    const byReason = {};
    unknownItems.forEach((it) => { (byReason[it.reason] = byReason[it.reason] || []).push(it.label); });
    Object.keys(byReason).forEach((reason) => {
        const labels = byReason[reason];
        rows.push(`<p class="text-caption text-secondary" style="margin:8px 0;">Нет данных: ${escapeHtml(labels.join(', '))} — ${escapeHtml(reason)}.</p>`);
    });

    // 5. Налоги и стоимость. Astana's real rate (gis.esaulet.kz) and cadastral value
    // only where the tax block has real values.
    const tax = ctx.tax;
    if (tax && (tax.land_tax_rate_per_m2 || tax.cadastral_value_per_m2)) {
        const uplift = tax.maslikhat_uplift_pct ? ` (+${tax.maslikhat_uplift_pct}%)` : '';
        if (tax.land_tax_rate_per_m2) {
            rows.push(geoRow('Ставка земельного налога', `${tax.land_tax_rate_per_m2} ₸/м²${uplift}`, { src: SRC_ASTANA, cls: 'text-body font-mono-nums text-primary' }));
        }
        if (tax.cadastral_value_per_m2) {
            const cadTotal = statedAreaM2 ? ` · ≈ ${formatMoney(Math.round(tax.cadastral_value_per_m2 * statedAreaM2))}` : '';
            rows.push(geoRow(isBuildingShared ? 'Кадастровая стоимость участка комплекса' : 'Кадастровая стоимость', `${tax.cadastral_value_per_m2} ₸/м²${cadTotal}`, { src: SRC_ASTANA, cls: 'text-body font-mono-nums text-primary' }));
        }
    }
    // Sale land lots: annual tax estimate, computed server-side by the SAME
    // function the finance model uses (finance/land_tax.py) and labelled by it.
    const taxEst = ctx.land_tax_estimate;
    if (taxEst && taxEst.amount_kzt) {
        rows.push(geoRow('Земельный налог в год (оценка)', formatMoney(taxEst.amount_kzt),
            { src: taxEst.source === 'astana' ? SRC_ASTANA : 'ст.577 НК РК', cls: 'text-body font-mono-nums text-primary' }));
        rows.push(`<p class="text-caption text-tertiary" style="margin:0 0 8px;">${escapeHtml(taxEst.label)}</p>`);
    }

    // 6. Footer
    // Absolute date: «на {дата}» -- fmtDate returns relative text («5 дн назад»).
    const fetchedDate = ctx.fetched_at ? new Date(ctx.fetched_at).toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit', year: 'numeric' }) : '';
    // TASK30 30.0: the date is the render's own context date -- report's
    // frozen one, or the lot's fresher one (ctx.geo_source === 'lot'); the
    // two are never mixed field-by-field (api_server._with_best_geo_context).
    rows.push(`<p class="text-caption text-tertiary" style="margin-top:12px;">${fetchedDate ? `Данные реестров на ${fetchedDate}. ` : ''}Источники: НИПД (map.gov4c.kz), ГГК, геопортал РК. Справочная информация, не заменяет официальную справку.</p>`);

    document.getElementById('uiGeoDetails').innerHTML = rows.join('');
    sectionEl.classList.remove('hidden');
    // 32.4 map defaults: satellite for land and land-lease lots; neighbours for parcels < 0.5 ha
    const lotAttrs = Object.assign({}, (state.currentLot && state.currentLot.attributes) || {}, report.attributes || {});
    initGeoMap(ctx, isBuildingShared, {
        landLike: lotAttrs.property_category === 'land' || lotAttrs.deal_type === 'lease',
        complexLot: isComplexLot,
        smallParcel: Boolean(statedAreaM2 && statedAreaM2 < 5000),
    });
}

// ---- TASK30 30.2: the parcel map in «Участок и градостроительство» ----------
// MapLibre GL JS (BSD) + OpenFreeMap vector tiles (commercial use allowed, no
// key). State layers (НИПД / ГГК) come ONLY through our own proxy
// (/api/geo/tile|feature, bot/geo/proxy.py) -- the browser never talks to a
// government server. Lazy: MapLibre is fetched only when the section
// scrolls into view AND the lot has a polygon. No WebGL / blocked script /
// dead style -> the wrap is hidden, the section keeps its rows.
const MAPLIBRE_VERSION = '5.24.0';
const MAPLIBRE_BASE = `https://cdnjs.cloudflare.com/ajax/libs/maplibre-gl/${MAPLIBRE_VERSION}/`;
const MAPLIBRE_SRI = {
    'maplibre-gl.js': 'sha384-5+cfbwT0iiub6VsQAdn6yz16nr6sDiQoHx6tm4O8OVYXHYOxcffFmCJBL0dgdvGp',
    'maplibre-gl.css': 'sha384-uTttxo/aOKbdE5RlD/SPzSDoDmNvGlUYPjONi2MN/b7c9HPSvW07OIuyP7uL6jxK',
};
const GEO_BASEMAP_STYLE = 'https://tiles.openfreemap.org/styles/positron';
const GEO_MAP_START_TIMEOUT_MS = 12000;
// Toggles: off by default except the parcel itself and red lines. `key` is a
// proxy whitelist key. minzoom keeps the map from asking a government server
// for tiles that would be unreadable anyway.
// `swatch` = the colour the government server itself paints that layer with
// (legend of EXTERNAL tiles -- data, not UI chrome, so not a design token).
const GEO_MAP_LAYERS = [
    { key: 'parcels', label: 'Соседние участки', legend: 'Границы соседних участков, НИПД (клик — данные участка)', swatch: '#1a7fe0', minzoom: 14, opacity: 0.9, on: false },
    { key: 'red_lines', label: 'Красные линии', legend: 'Красные линии, ГГК', swatch: '#a00000', minzoom: 12, opacity: 1, on: true },
    { key: 'genplan', label: 'Зоны генплана', legend: 'Зоны генплана, ГГК (цвет — по назначению зоны)', swatch: '#9fc8dc', minzoom: 11, opacity: 0.55, on: false },
    { key: 'pdp', label: 'ПДП', legend: 'Проекты детальной планировки, ГГК', swatch: '#c9a6d9', minzoom: 12, opacity: 0.6, on: false },
    { key: 'utilities', label: 'Сети', legend: 'Зоны инженерных сетей, ГГК', swatch: '#8fd19e', minzoom: 12, opacity: 0.6, on: false },
    // 32.1 Астана: ГИС Астаны layers through the same proxy (only offered when the context has them)
    { key: 'astana_regulation', label: 'Регламент', legend: 'Градостроительный регламент, ГИС Астаны', swatch: '#e6c27a', minzoom: 13, opacity: 0.55, on: false },
    { key: 'astana_red_projected', label: 'Красные линии: проект', legend: 'Проектируемые красные линии, ГИС Астаны', swatch: '#d9822b', minzoom: 13, opacity: 1, on: false },
    { key: 'astana_red_existing', label: 'Красные линии: сущ.', legend: 'Существующие красные линии, ГИС Астаны', swatch: '#a00000', minzoom: 13, opacity: 1, on: false },
    { key: 'astana_buildings', label: 'Здания', legend: 'Существующие здания, ГИС Астаны', swatch: '#8d8d8d', minzoom: 15, opacity: 0.7, on: false },
    { key: 'astana_pdp_buildings', label: 'Здания по ПДП', legend: 'Здания по ПДП (с этажностью), ГИС Астаны', swatch: '#6b8ae8', minzoom: 15, opacity: 0.7, on: false },
    { key: 'astana_water', label: 'Водоохранные (ГИС)', legend: 'Водоохранные зоны и полосы, ГИС Астаны', swatch: '#7fb2e6', minzoom: 12, opacity: 0.6, on: false },
];
let _maplibrePromise = null;
let _geoMap = null;
let _geoMapObserver = null;

// WebGL paint properties can't use var(): read the design tokens once.
function _geoToken(name, fallback) {
    try {
        return getComputedStyle(document.documentElement).getPropertyValue(name).trim() || fallback;
    } catch (e) {
        return fallback;
    }
}

function _geoWebglOk() {
    try {
        const c = document.createElement('canvas');
        return Boolean(c.getContext('webgl2') || c.getContext('webgl'));
    } catch (e) {
        return false;
    }
}

function _loadMapLibre() {
    if (window.maplibregl) return Promise.resolve(window.maplibregl);
    if (_maplibrePromise) return _maplibrePromise;
    _maplibrePromise = new Promise((resolve, reject) => {
        const css = document.createElement('link');
        css.rel = 'stylesheet';
        css.href = `${MAPLIBRE_BASE}maplibre-gl.css`;
        css.integrity = MAPLIBRE_SRI['maplibre-gl.css'];
        css.crossOrigin = 'anonymous';
        document.head.appendChild(css);
        const sc = document.createElement('script');
        sc.src = `${MAPLIBRE_BASE}maplibre-gl.js`;
        sc.integrity = MAPLIBRE_SRI['maplibre-gl.js'];
        sc.crossOrigin = 'anonymous';
        sc.onload = () => (window.maplibregl ? resolve(window.maplibregl) : reject(new Error('maplibre missing')));
        sc.onerror = () => { _maplibrePromise = null; reject(new Error('maplibre load failed')); };
        document.head.appendChild(sc);
    });
    return _maplibrePromise;
}

// [west, south, east, north] of any GeoJSON geometry; null when it has no coordinates.
function _geoBounds(geometry) {
    let w = Infinity, s = Infinity, e = -Infinity, n = -Infinity;
    const walk = (c) => {
        if (typeof c[0] === 'number') {
            if (c[0] < w) w = c[0]; if (c[0] > e) e = c[0];
            if (c[1] < s) s = c[1]; if (c[1] > n) n = c[1];
        } else {
            c.forEach(walk);
        }
    };
    try { walk(geometry.coordinates); } catch (err) { return null; }
    return Number.isFinite(w) ? [w, s, e, n] : null;
}

function _geoOutlineGeometry(ctx) {
    return (ctx.parcel && ctx.parcel.polygon) || (ctx.registry && ctx.registry.polygon) || null;
}

// 30.8: server decides (geo/report_fields.py::outline_kind); legacy payloads fall back to the polygon source
function _geoOutlineKind(ctx) {
    if (ctx.outline_kind) return ctx.outline_kind;
    return ctx.parcel && ctx.parcel.polygon ? 'parcel' : 'registry_contour';
}

// [lat, lon] of the place: registry centroid, else the polygon's bbox centre
function _geoPlaceCenter(ctx, bounds) {
    const c = (ctx.parcel && ctx.parcel.centroid) || (ctx.registry && ctx.registry.centroid);
    return c || [(bounds[1] + bounds[3]) / 2, (bounds[0] + bounds[2]) / 2];
}

function _geoFmtArea(m2) {
    if (!m2) return null;
    return m2 > 10000 ? `${(m2 / 10000).toFixed(1).replace('.', ',')} га` : `${Math.round(m2).toLocaleString('ru-RU')} м²`;
}

function _geoPopupContent(parcel, failed) {
    const box = document.createElement('div');
    const line = (label, value, mono) => {
        const row = document.createElement('div');
        row.className = 'report-geomap-popup-row text-caption';
        const l = document.createElement('span');
        l.className = 'text-secondary';
        l.textContent = label;
        const v = document.createElement('span');
        v.className = mono ? 'font-mono-nums text-primary' : 'text-primary';
        v.textContent = value;
        row.append(l, v);
        box.appendChild(row);
    };
    if (failed) {
        line('Реестр', 'не ответил, попробуйте позже');
    } else if (!parcel) {
        line('Участок', 'не найден');
    } else {
        line('Кад. номер', parcel.kad_nomer, true);
        if (parcel.purpose) line('Назначение', parcel.purpose);
        // «Земли населенных пунктов (городов, поселков и …)» -> the short head only
        if (parcel.category) line('Категория', parcel.category.replace(/\s*\(.*\)\s*$/, ''));
        const area = _geoFmtArea(parcel.area_m2);
        if (area) line('Площадь', area, true);
    }
    return box;
}

function _geoRenderLegend(legendEl, activeKeys, ourLabel) {
    legendEl.textContent = '';
    const add = (swatch, text) => {
        const item = document.createElement('span');
        item.className = 'report-geomap-legend-item';
        const sw = document.createElement('span');
        sw.className = 'report-geomap-swatch';
        sw.style.background = swatch;
        item.append(sw, document.createTextNode(text));
        legendEl.appendChild(item);
    };
    add(_geoToken('--accent', '#d9a441'), ourLabel);
    GEO_MAP_LAYERS.filter((l) => activeKeys.has(l.key)).forEach((l) => add(l.swatch, l.legend));  // activeKeys only holds offered layers
    if (activeKeys.has('water')) add('#7fb2e6', 'Водоохранные зоны и полосы, map.gov.kz');
}

function _geoRenderLinks(linksEl, lat, lon) {
    const links = [
        ['Открыть в Яндекс Картах', `https://yandex.kz/maps/?pt=${lon},${lat}&z=17&l=map`],
        ['2ГИС', `https://2gis.kz/?m=${lon},${lat}/17`],
        ['Google Картах', `https://www.google.com/maps/search/?api=1&query=${lat},${lon}`],
    ];
    linksEl.textContent = '';
    links.forEach(([text, href]) => {
        const a = document.createElement('a');
        a.href = href;
        a.target = '_blank';
        a.rel = 'noopener noreferrer';
        a.textContent = text;
        linksEl.appendChild(a);
    });
}

function _geoTeardownMap() {
    if (_geoMapObserver) { _geoMapObserver.disconnect(); _geoMapObserver = null; }
    if (_geoMap) { try { _geoMap.remove(); } catch (e) { /* already gone */ } _geoMap = null; }
}

// 32.4: a toggle/legend entry exists only for a layer that has data at this place
function _geoLayerHasData(key, ctx) {
    const unavail = ctx.unavailable || {};
    const planning = ctx.planning || {};
    if (key === 'genplan') return !unavail.genplan;
    if (key === 'red_lines') return !unavail.red_lines;  // the raster is ГГК's: none where ГГК keeps no red lines (an ЕГКН answer is a row, not this layer)
    if (key === 'utilities') return Object.values(planning.utilities || {}).some((v) => v === true || v === false);
    if (key.startsWith('astana_')) return Boolean(ctx.city_layers && ctx.city_layers.source === 'ГИС Астаны');
    return true;
}

async function _geoProbeSatelliteMaxZoom(lat, lon) {
    const z = 18;
    const n = 2 ** z;
    const x = Math.floor((lon + 180) / 360 * n);
    const y = Math.floor((1 - Math.asinh(Math.tan(lat * Math.PI / 180)) / Math.PI) / 2 * n);
    try {
        const resp = await fetch(`/api/geo/satellite/${z}/${x}/${y}`, { headers: IS_TELEGRAM ? { 'X-Telegram-Init-Data': tg.initData || '' } : {} });
        return resp.ok && !resp.headers.get('X-Geo-No-Tile') ? 19 : 17;
    } catch (e) {
        return 17;
    }
}

async function _geoStartMap(maplibregl, ctx, isBuildingShared, els, opts) {
    opts = opts || {};
    // 32.4 defaults: neighbours on for small parcels (< 0.5 ha); only layers with data are offered
    const layerDefs = GEO_MAP_LAYERS
        .map((l) => (l.key === 'parcels' && opts.smallParcel ? { ...l, on: true } : l))
        .filter((l) => _geoLayerHasData(l.key, ctx));
    const geometry = _geoOutlineGeometry(ctx);
    const kind0 = _geoOutlineKind(ctx);
    let bounds = _geoBounds(geometry);
    if (kind0 === 'registry_point') {  // a place, not a boundary: frame ~300 m around it
        const [clat, clon] = _geoPlaceCenter(ctx, bounds);
        bounds = [clon - 0.0025, clat - 0.0016, clon + 0.0025, clat + 0.0016];
    }
    const active = new Set(layerDefs.filter((l) => l.on).map((l) => l.key));
    const kind = kind0;
    const ourLabel = kind === 'registry_point'
        ? 'Место приблизительное: контур в реестре не совпадает с площадью, границы неизвестны'
        : kind === 'registry_contour' ? 'Контур по данным организатора торгов'
        : (isBuildingShared || opts.complexLot) ? 'Участок жилого комплекса' : 'Ваш участок';
    const satelliteOn = Boolean(ctx.map_options && ctx.map_options.satellite);
    // Esri imagery has zoom 18-19 only in cities (Семей tops out at 17): probe one z18 tile over the
    // parcel; where it is missing, cap the source at 17 so MapLibre overzooms instead of showing blanks.
    let satelliteMaxZoom = 19;
    if (satelliteOn) {
        const probeAt = _geoPlaceCenter(ctx, _geoBounds(geometry));
        satelliteMaxZoom = await _geoProbeSatelliteMaxZoom(probeAt[0], probeAt[1]);
    }
    const waterOblast = (ctx.map_options && ctx.map_options.water_oblast) || null;
    let started = false;
    const giveUp = () => { if (!started) { _geoTeardownMap(); els.wrap.classList.add('hidden'); } };
    const startTimer = setTimeout(giveUp, GEO_MAP_START_TIMEOUT_MS);

    const map = new maplibregl.Map({
        container: els.canvas,
        style: GEO_BASEMAP_STYLE,
        bounds: [[bounds[0], bounds[1]], [bounds[2], bounds[3]]],
        fitBoundsOptions: { padding: window.innerWidth < 640 ? 24 : 48, maxZoom: kind0 === 'registry_point' ? 16 : 18 },
        attributionControl: false,
        cooperativeGestures: true,
        dragRotate: false,
        fadeDuration: 0,
        renderWorldCopies: false,
        locale: {
            'CooperativeGesturesHandler.WindowsHelpText': 'Ctrl + прокрутка — масштаб карты',
            'CooperativeGesturesHandler.MacHelpText': 'Cmd + прокрутка — масштаб карты',
            'CooperativeGesturesHandler.MobileHelpText': 'Двигайте карту двумя пальцами',
        },
        // fetch() of an absolute URL bypasses the /api/ header patch above, so
        // the Mini App's signed initData is attached here (site = session cookie).
        transformRequest: (url) => (
            IS_TELEGRAM && url.includes('/api/geo/')
                ? { url, headers: { 'X-Telegram-Init-Data': tg.initData || '' } }
                : { url }
        ),
    });
    _geoMap = map;
    map.addControl(new maplibregl.AttributionControl({
        compact: true,
        customAttribution: [
            // OpenFreeMap's own attribution comes with its tiles (TileJSON); this adds
            // the OSM credit it asks for and the state layers.
            '© <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener">OpenStreetMap contributors</a>',
            'Слои: НИПД, ГГК',
            ...(satelliteOn ? ['Спутник: Esri, Vantor, Earthstar Geographics'] : []),
        ],
    }));
    map.addControl(new maplibregl.NavigationControl({ showCompass: false }), 'top-right');
    map.touchZoomRotate.disableRotation();

    map.on('error', (e) => {
        // Esri refused (expired key / quota): hide the toggle and the layer, never a grey layer
        if (started && e && e.sourceId === 'geo-satellite') {
            if (map.getLayer('geo-satellite')) map.setLayoutProperty('geo-satellite', 'visibility', 'none');
            const sat = els.toolbar.querySelector('[data-geo-satellite]');
            if (sat) sat.remove();
            return;
        }
        if (!started) { clearTimeout(startTimer); giveUp(); }
    });
    map.on('load', () => {
        started = true;
        clearTimeout(startTimer);
        els.canvas.classList.remove('is-loading');
        // MapLibre opens the compact attribution until the first map move; on a
        // phone that box covers a third of the map, so start it collapsed there.
        {
            const attrib = els.canvas.querySelector('.maplibregl-ctrl-attrib');
            if (attrib) { attrib.classList.remove('maplibregl-compact-show'); attrib.removeAttribute('open'); }
        }

        // Russian labels: name:ru, then the local name.
        (map.getStyle().layers || []).forEach((layer) => {
            const tf = layer.layout && layer.layout['text-field'];
            if (layer.type === 'symbol' && tf && JSON.stringify(tf).includes('"name')) {
                map.setLayoutProperty(layer.id, 'text-field', ['coalesce', ['get', 'name:ru'], ['get', 'name']]);
            }
        });

        const origin = window.location.origin;
        layerDefs.forEach((l) => {
            map.addSource(`geo-${l.key}`, {
                type: 'raster', tileSize: 512, minzoom: l.minzoom, maxzoom: 18,
                tiles: [`${origin}/api/geo/tile/${l.key}?bbox={bbox-epsg-3857}&size=512`],
            });
            map.addLayer({
                id: `geo-${l.key}`, type: 'raster', source: `geo-${l.key}`, minzoom: l.minzoom,
                layout: { visibility: l.on ? 'visible' : 'none' },
                paint: { 'raster-opacity': l.opacity, 'raster-fade-duration': 0 },
            });
        });
        if (waterOblast) {
            map.addSource('geo-water', {
                type: 'raster', tileSize: 512, minzoom: 11, maxzoom: 18,
                tiles: [`${origin}/api/geo/tile/water_zones?bbox={bbox-epsg-3857}&size=512&oblast=${encodeURIComponent(waterOblast)}`],
            });
            map.addLayer({ id: 'geo-water', type: 'raster', source: 'geo-water', minzoom: 11, layout: { visibility: 'none' }, paint: { 'raster-opacity': 0.6, 'raster-fade-duration': 0 } });
        }
        // 30.3 «Спутник»: only when the server has a key (ctx.map_options.satellite);
        // sits BELOW every state layer, above the base.
        if (satelliteOn) {
            map.addSource('geo-satellite', {
                type: 'raster', tileSize: 256, maxzoom: satelliteMaxZoom,
                tiles: [`${origin}/api/geo/satellite/{z}/{x}/{y}`],
            });
            map.addLayer({ id: 'geo-satellite', type: 'raster', source: 'geo-satellite', layout: { visibility: opts.landLike ? 'visible' : 'none' } }, 'geo-parcels');
        }
        // Our parcel on top: dark casing + gold line, so it reads on any base.
        const accent = _geoToken('--accent', '#d9a441');
        const ink = _geoToken('--bg-base', '#0b0e14');
        if (kind === 'registry_point') {
            const [plat, plon] = _geoPlaceCenter(ctx, _geoBounds(geometry));
            map.addSource('geo-own', { type: 'geojson', data: { type: 'Feature', geometry: { type: 'Point', coordinates: [plon, plat] }, properties: {} } });
            map.addLayer({ id: 'geo-own-halo', type: 'circle', source: 'geo-own', paint: { 'circle-radius': 42, 'circle-color': accent, 'circle-opacity': 0.14 } });
            map.addLayer({ id: 'geo-own-casing', type: 'circle', source: 'geo-own', paint: { 'circle-radius': 9, 'circle-color': ink, 'circle-opacity': 0.85 } });
            map.addLayer({ id: 'geo-own-line', type: 'circle', source: 'geo-own', paint: { 'circle-radius': 6, 'circle-color': accent } });
        } else {
            map.addSource('geo-own', { type: 'geojson', data: { type: 'Feature', geometry, properties: {} } });
            const dashed = kind === 'registry_contour';
            map.addLayer({ id: 'geo-own-fill', type: 'fill', source: 'geo-own', paint: { 'fill-color': accent, 'fill-opacity': dashed ? 0.08 : 0.16 } });
            map.addLayer({ id: 'geo-own-casing', type: 'line', source: 'geo-own', paint: { 'line-color': ink, 'line-width': 5, 'line-opacity': 0.85 } });
            map.addLayer({ id: 'geo-own-line', type: 'line', source: 'geo-own', paint: dashed ? { 'line-color': accent, 'line-width': 2.5, 'line-dasharray': [2, 2] } : { 'line-color': accent, 'line-width': 2.5 } });
        }
    });

    // Chips
    els.toolbar.textContent = '';
    layerDefs.forEach((l) => {
        const chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'report-geomap-chip';
        chip.textContent = l.label;
        chip.setAttribute('aria-pressed', l.on ? 'true' : 'false');
        chip.addEventListener('click', () => {
            const on = !active.has(l.key);
            if (on) active.add(l.key); else active.delete(l.key);
            chip.setAttribute('aria-pressed', on ? 'true' : 'false');
            if (map.getLayer(`geo-${l.key}`)) map.setLayoutProperty(`geo-${l.key}`, 'visibility', on ? 'visible' : 'none');
            if (l.key === 'parcels') map.getCanvas().style.cursor = on ? 'pointer' : '';
            _geoRenderLegend(els.legend, active, ourLabel);
        });
        els.toolbar.appendChild(chip);
    });
    if (satelliteOn) {
        const chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'report-geomap-chip';
        chip.textContent = 'Спутник';
        chip.setAttribute('data-geo-satellite', '1');
        chip.setAttribute('aria-pressed', opts.landLike ? 'true' : 'false');  // 32.4: land and land-lease lots start on satellite
        chip.addEventListener('click', () => {
            const on = chip.getAttribute('aria-pressed') !== 'true';
            chip.setAttribute('aria-pressed', on ? 'true' : 'false');
            if (map.getLayer('geo-satellite')) map.setLayoutProperty('geo-satellite', 'visibility', on ? 'visible' : 'none');
        });
        els.toolbar.appendChild(chip);
    }
    // 30.10: water-protection zones, only where the server found a polygon layer for the oblast
    if (waterOblast) {
        const chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'report-geomap-chip';
        chip.textContent = 'Водоохранные зоны';
        chip.setAttribute('aria-pressed', 'false');
        chip.addEventListener('click', () => {
            const on = chip.getAttribute('aria-pressed') !== 'true';
            chip.setAttribute('aria-pressed', on ? 'true' : 'false');
            if (map.getLayer('geo-water')) map.setLayoutProperty('geo-water', 'visibility', on ? 'visible' : 'none');
            if (on) active.add('water'); else active.delete('water');
            _geoRenderLegend(els.legend, active, ourLabel);
        });
        els.toolbar.appendChild(chip);
    }
    _geoRenderLegend(els.legend, active, ourLabel);

    // Click on a (neighbouring) parcel -> number / purpose / area, via our proxy.
    let popup = null;
    map.on('click', async (e) => {
        if (!active.has('parcels') || map.getZoom() < 15) return;
        const { lat, lng } = e.lngLat;
        let parcel = null;
        let failed = false;
        try {
            const resp = await fetch(`/api/geo/feature/parcels?lat=${lat.toFixed(6)}&lon=${lng.toFixed(6)}`);
            const data = resp.ok ? await resp.json() : null;
            if (data && data.ok) parcel = data.parcel; else failed = true;
        } catch (err) {
            failed = true;
        }
        if (popup) popup.remove();
        popup = new maplibregl.Popup({ closeButton: true, maxWidth: '260px' })
            .setLngLat(e.lngLat).setDOMContent(_geoPopupContent(parcel, failed)).addTo(map);
    });
}

// Render hook: called from renderGeoContextSection once per report render.
function initGeoMap(ctx, isBuildingShared, opts) {
    const wrap = document.getElementById('uiGeoMapWrap');
    if (!wrap) return;
    _geoTeardownMap();
    const geometry = _geoOutlineGeometry(ctx);
    if (!geometry || !_geoBounds(geometry) || !_geoWebglOk()) {
        wrap.classList.add('hidden');
        return;
    }
    const els = {
        wrap,
        canvas: document.getElementById('uiGeoMap'),
        toolbar: document.getElementById('uiGeoMapToolbar'),
        legend: document.getElementById('uiGeoMapLegend'),
        links: document.getElementById('uiGeoMapLinks'),
    };
    els.canvas.textContent = '';
    els.canvas.classList.add('is-loading');
    wrap.classList.remove('hidden');
    const b = _geoBounds(geometry);
    const center = _geoPlaceCenter(ctx, b);  // [lat, lon]
    _geoRenderLinks(els.links, Number(center[0]).toFixed(6), Number(center[1]).toFixed(6));

    const boot = () => {
        _loadMapLibre()
            .then((maplibregl) => _geoStartMap(maplibregl, ctx, isBuildingShared, els, opts))
            .catch(() => wrap.classList.add('hidden'));
    };
    if ('IntersectionObserver' in window) {
        _geoMapObserver = new IntersectionObserver((entries) => {
            if (entries.some((en) => en.isIntersecting)) {
                _geoMapObserver.disconnect();
                _geoMapObserver = null;
                boot();
            }
        }, { rootMargin: '200px' });
        _geoMapObserver.observe(wrap);
    } else {
        boot();
    }
}

// ---- Классический отчёт (владелец, 2026-10-27) ------------------------------------------------------------------------
// Прежняя разметка Mini App (REPORT_LEGACY_MARKUP) показывала часть данных ИИ как есть, и именно там жили прежние
// ошибки: подписи сценариев со своими ценами («Выкуп по 11 млн» при входе 9 млн), рынок «20 % / 60 % / 20 %» и три
// «рыночные» цены графика, придуманные моделью, обоснование цены со своей ценой рядом с максимальной ставкой движка,
// карточка риска из шаблонной строки ЭТП «Имеются обременения», разбивка оценки из 4 старых компонентов при балле,
// посчитанном по 6, нули в деньгах у аренды. classicReportData() — копия отчёта ТОЛЬКО для показа (currentAiReport, PDF
// и ссылка «поделиться» не меняются), где эти поля взяты у движка / писателя / выборки объявлений; classicAfterRender()
// дорисовывает то, что прежняя разметка не умела (разбивка по 6 компонентам, карточка денег аренды, маркер входа на
// шкале рынка).
const CLASSIC_TEMPLATE_ENCUMBRANCE = /^\s*имеются обременения[.,;]?\s*$/i;       // = finance/encumbrance_view.py::_TEMPLATE_LINE
const CLASSIC_SCENARIO_LABEL = { pessimistic: 'низ рынка', realistic: 'средняя цена', optimistic: 'верх рынка' };

let classicFinDashboardHtml = null;

// one entry point for both surfaces: the display copy -> the classic markup -> what the markup cannot say by itself
function renderClassicReport(report) {
    const dash = document.getElementById('uiFinDashboard');
    // classicMoneyCard() replaces the money tiles of a lease / rent lot; the next report (Mini App: another analysis in
    // the same sheet) needs the original nodes back
    if (dash) {
        if (classicFinDashboardHtml === null) classicFinDashboardHtml = dash.innerHTML;
        else dash.innerHTML = classicFinDashboardHtml;
    }
    const canvas = document.getElementById('financialChart');
    if (canvas && canvas.parentElement) canvas.parentElement.classList.remove('hidden');
    renderInAppReport(classicReportData(report));
    classicAfterRender(report);
}

// the land lot's area from the cadastre, formatted like «Участок и градостроительство» (null for a non-land lot, a building's shared parcel,
// a parcel that does not match the lot, or no cadastre data)
function classicLandAreaText(report) {
    const ctx = report && report.geo_context;
    const attr = (report && report.attributes) || {};
    const isLand = attr.property_category === 'land' || (state.currentLot && state.currentLot.category === 'участки');
    if (!isLand || !ctx || ctx.parcel_mismatch) return null;
    if (ctx.parcel && ctx.parcel.area_m2) return _geoFmtArea(ctx.parcel.area_m2);
    if (ctx.registry && ctx.registry.area_ga) return `${String(ctx.registry.area_ga).replace('.', ',')} га`;
    return null;
}

function classicMoneyKind(report) {
    const m = report.financial_model || {};
    const kind = report.ui && report.ui.main_number;
    if (['lease_price', 'rent_monthly', 'documents_only'].includes(kind)) return kind;
    if (m.mode === 'lease' || m.mode === 'lease_unsupported') return 'lease_price';
    if (m.mode === 'rent') return 'rent_monthly';
    if (v2Fact(report, 'quality', 'price_suspect') === true) return 'price_suspect';
    return m.mode === 'sale' && m.sale ? 'sale' : null;
}

// the scale of the market bar: below the engine's low sale price — green, low..high — yellow, above high — red
function classicMarketScale(low, high) {
    const pad = (high - low) * 0.25;
    const lo = Math.max(0, low - pad), hi = high + pad;
    return (x) => Math.max(0, Math.min(100, ((x - lo) / (hi - lo)) * 100));
}

function classicScenarioText(h, entry) {
    const cm = (v) => `${fmPriceCompactStrict(v)} ₸`;
    const repair = h.repair ? `ремонт и подготовка ${cm(h.repair)}` : 'без ремонта';
    return `Вход ${cm(entry)}, ${repair}, продажа за ${cm(h.sale)} (${CLASSIC_SCENARIO_LABEL[h.label] || 'расчёт'}). Налог и расходы уже вычтены.`;
}

function classicReportData(report) {
    if (!report || !REPORT_LEGACY_MARKUP) return report;
    const r = { ...report };
    const m = report.financial_model || null;
    const kind = classicMoneyKind(report);
    // TASK45 C3: the ETP template line is no evidence — also for reports the server does not re-read (no report.ui)
    if (Array.isArray(r.risks)) {
        r.risks = r.risks.filter((x) => !(x && x.risk_category === 'обременение_арест' && CLASSIC_TEMPLATE_ENCUMBRANCE.test(String(x.evidence_quote || ''))));
    }
    if (kind === 'sale') {
        const s = m.sale, entry = m.purchase && m.purchase.price;
        // the chart: the market bars are the engine's sale range, not three prices the model made up
        r.financials = { ...(r.financials || {}), market_prices: { ...((r.financials || {}).market_prices || {}),
            pessimistic_price: s.low, realistic_price: s.mid, optimistic_price: s.high } };
        // scenarios: numbers AND words from the engine's three headline cases
        const head = Object.fromEntries(((m.scenarios && m.scenarios.headline) || []).map((h) => [h.label, h]));
        r.investment_scenarios = (r.investment_scenarios || []).map((sc) => {
            const h = head[String(sc.scenario || '').toLowerCase()];
            return h && entry ? { ...sc, projected_profit: h.profit, roi_percent: Math.round(h.roi * 1000) / 10, description: classicScenarioText(h, entry) } : sc;
        });
        // market: one sentence from the market sample / the engine, the bar from the engine's range
        if (s.low != null && s.high != null && s.high > s.low) {
            const pos = classicMarketScale(s.low, s.high);
            const text = report.dossier ? v2MarketStatement(report).text
                : `Цена продажи по расчёту: обычно ${fmPriceCompactStrict(s.low)}–${fmPriceCompactStrict(s.high)} ₸, в среднем ${fmMoneyNb(s.mid)}.`;
            r.market_stats = { distribution_text: text,
                low_price_percent: pos(s.low), mid_price_percent: pos(s.high) - pos(s.low), high_price_percent: 100 - pos(s.high) };
        }
    } else if (kind) {
        // lease / rent / documents only / a suspect platform price: there is no resale economics to draw
        r.investment_scenarios = [];
        r.market_stats = r.market_stats ? { ...r.market_stats, distribution_text: report.dossier ? v2MarketStatement(report).text : r.market_stats.distribution_text } : r.market_stats;
    }
    // strategy: the engine's own numbers; the tactic only from the writer (it checks every number against the engine)
    if (r.strategy && m && m.results) {
        const res = m.results;
        const target = (report.verdict_engine && report.verdict_engine.margin_target_pct) || 20;
        const veto = ((report.verdict_engine && report.verdict_engine.vetoes) || [])[0];
        let rationale = '';
        if (kind === 'sale') {
            const parts = [];
            if (res.break_even_purchase) parts.push(`Безубыточная цена покупки — ${fmMoneyNb(res.break_even_purchase)}`);
            if (res.max_bid > 0) parts.push(`максимальная ставка, при которой доходность не ниже ${target} %, — ${fmMoneyNb(res.max_bid)}`);
            rationale = parts.length ? `${parts.join('; ')}.` : 'Максимальная ставка не рассчитана: данных для расчёта не хватает.';
        } else if (kind === 'lease_price') {
            const lr = m.rent || {};
            r.strategy = { ...r.strategy, recommended_max_bid: lr.max_bid || 0 };
            const mn = report.ui ? v2MainNumber(report) : null;
            rationale = (mn && (mn.caption || mn.value)) || 'Максимальный платёж за право аренды не рассчитан.';
        } else if (kind) {
            const mn = report.ui ? v2MainNumber(report) : null;
            rationale = (mn && (mn.caption || mn.value)) || '';
        }
        if (veto) rationale = `${rationale} ${veto}`.trim();
        rationale = classicNoEditorWords(rationale);
        r.strategy = { ...r.strategy, recommendation_rationale: rationale, auction_tactics: (report.writer && report.writer.tactics) || '' };
    }
    // TL;DR for lease / rent: the main number, no resale return
    if (kind && kind !== 'sale') {
        const lr = (m && m.rent) || {};
        const win = v2Fact(report, 'trades', 'expected_winning_price');
        const main = kind === 'lease_price' ? (lr.max_bid != null ? lr.max_bid : win) : undefined;
        // a lease without a computed payment shows «—», never the old resale «target price»
        r.financials = { ...(r.financials || {}), roi_percent: undefined,
            target_purchase_price: main != null ? main : (kind === 'lease_price' ? 0 : (r.financials || {}).target_purchase_price) };
    }
    return r;
}

function classicAfterRender(report) {
    if (!report || !REPORT_LEGACY_MARKUP) return;
    const m = report.financial_model || {};
    const kind = classicMoneyKind(report);
    const hide = (id, on = true) => { const el = document.getElementById(id); if (el) el.classList.toggle('hidden', on); };
    // «Заморозка капитала» (proportions made up) and the annualised return (a 60-day deal as «220 % годовых») are gone
    hide('uiFreezeTimeline'); hide('uiAnnualBenchmark');
    // the profit tile was always green, also for a loss
    const fin = report.financials || {};
    const neg = kind === 'sale' && m.results ? (m.results.profit_mid || 0) < 0 : (fin.projected_profit || 0) < 0;
    const profitEl = document.getElementById('uiProfit'), roiEl = document.getElementById('uiRoi');
    if (profitEl) profitEl.className = `text-lg font-bold font-mono-nums ${neg ? 'text-red-400' : 'text-green-400'}`;
    if (roiEl) roiEl.className = `text-[11px] font-bold font-mono-nums px-1.5 py-0.5 rounded mb-0.5 ${neg ? 'text-red-400 bg-red-500/20' : 'text-green-500 bg-green-500/20'}`;
    if (profitEl && profitEl.parentElement && profitEl.parentElement.parentElement) {
        const card = profitEl.parentElement.parentElement;
        card.className = `p-3 rounded-xl border relative overflow-hidden flex flex-col justify-center ${neg ? 'bg-red-500/10 border-red-500/20' : 'bg-green-500/10 border-green-500/20'}`;
        const lbl = card.firstElementChild;
        if (lbl) lbl.className = `text-[10px] uppercase font-bold mb-1 ${neg ? 'text-red-400/80' : 'text-green-400/80'}`;
        if (lbl) lbl.textContent = neg ? 'Убыток' : 'Чистая прибыль';
    }
    // tactics: only the writer's text (checked against the engine) — no box with the model's own prices
    const tactics = document.getElementById('uiTactics');
    if (tactics && tactics.parentElement) tactics.parentElement.classList.toggle('hidden', !(report.writer && report.writer.tactics));

    classicScoreBreakdown(report);
    classicMarketMarker(report, kind);
    // no resale market for a lease / rent / documents-only lot: the model's «низ / средняя / оверпрайс» bar is not shown, and
    // a land lease does not list land SALE prices as its «аналоги» (audit R9)
    const bar = document.getElementById('uiMarketBar');
    const nonSale = !!kind && kind !== 'sale' && kind !== 'price_suspect';
    if (bar) bar.classList.toggle('hidden', nonSale);
    const barLabels = document.getElementById('uiMarketBarLabels');
    if (barLabels) barLabels.classList.toggle('hidden', nonSale);
    const comps = document.getElementById('uiCompetitorsList');
    if (comps) {
        const noComps = kind === 'lease_price';
        comps.classList.toggle('hidden', noComps);
        if (comps.previousElementSibling) comps.previousElementSibling.classList.toggle('hidden', noComps);
    }
    if (kind && kind !== 'sale') classicMoneyCard(report, kind);
    if (kind === 'lease_price') classicLeaseLoad(report); else classicLease = null;
}

// «Разбивка оценки»: the components the score was actually computed from (verdict v2: 6, with their weights), each with
// its first reason; a component that vetoed or capped the verdict says so instead of looking like a good score
function classicScoreBreakdown(report) {
    const engine = report.verdict_engine;
    const list = document.getElementById('uiScoreBreakdownList');
    if (!list || !engine || !/^v2/.test(String(engine.rules_version || '')) || !engine.breakdown) return;
    const byComp = engine.component_reasons || {};
    const rows = v2VisibleComponents(engine);
    if (!rows.length) return;
    list.innerHTML = rows.map((c) => {
        const reasons = byComp[c.key] || [];
        const veto = reasons.some((x) => x.effect === 'veto'), cap = reasons.some((x) => x.effect === 'cap');
        const value = Math.round(c.value);
        const color = veto ? 'bg-[#f87171]' : scoreBarColor(value);
        const right = veto ? '<span class="text-red-400 font-bold">причина «нет»</span>'
            : `<span class="text-white font-bold font-mono-nums">${value}/100</span>${cap ? ' <span class="text-yellow-400 font-bold">· ограничивает</span>' : ''}`;
        return `
                <div>
                    <div class="flex justify-between text-[10px] mb-1">
                        <span class="text-gray-400 font-bold uppercase tracking-wide">${escapeHtml(c.label)}</span>
                        <span>${right}</span>
                    </div>
                    <div class="h-1.5 rounded-full bg-white/5 overflow-hidden">
                        <div class="h-full rounded-full score-bar-fill ${color}" style="width:${Math.max(0, Math.min(100, value))}%" data-target="${Math.max(0, Math.min(100, value))}"></div>
                    </div>
                    ${c.reason ? `<div class="mt-1 text-[10px] text-[#94a3b8] leading-snug">${escapeHtml(classicNoEditorWords(c.reason))}</div>` : ''}
                </div>`;
    }).join('');
    const block = document.getElementById('uiScoreBreakdownBlock');
    if (block) block.classList.remove('hidden');
}

// «Анализ рынка»: where the user's entry sits on the bar, in words under it
function classicMarketMarker(report, kind) {
    const bar = document.getElementById('uiMarketBar');
    if (!bar) return;
    bar.querySelectorAll('.classic-market-marker').forEach((el) => el.remove());
    const cap = document.getElementById('uiClassicMarketCaption');
    if (cap) cap.remove();
    const m = report.financial_model || {};
    const s = m.sale, entry = m.purchase && m.purchase.price;
    if (kind !== 'sale' || !s || s.low == null || s.high == null || !(s.high > s.low) || !entry) return;
    const x = classicMarketScale(s.low, s.high)(entry);
    bar.style.position = 'relative';
    bar.style.overflow = 'visible';
    bar.insertAdjacentHTML('beforeend', `<span class="classic-market-marker absolute top-1/2 w-1 h-5 -mt-2.5 -ml-0.5 rounded-full bg-white shadow" style="left:${x}%" title="Ваш вход"></span>`);
    const where = entry < s.low ? 'ниже обычных цен' : entry > s.high ? 'выше обычных цен' : 'в пределах обычных цен';
    bar.insertAdjacentHTML('afterend', `<p id="uiClassicMarketCaption" class="text-[10px] text-gray-300 mt-2 mb-1 font-medium"><span class="inline-block w-1 h-3 align-middle rounded-full bg-white mr-1.5"></span>Ваш вход <b class="font-mono-nums text-white">${fmPriceCompactStrict(entry)} ₸</b> — ${where} (${fmPriceCompactStrict(s.low)}–${fmPriceCompactStrict(s.high)} ₸)</p>`);
}

// The prior editor («Мои цифры») is gone from the classic report; the engine's texts still name it -- here it is the field below
function classicNoEditorWords(s) {
    return String(s || '').replace(/в «Мои цифры»/g, 'в поле ниже').replace(/«Мои цифры»/g, 'поле ниже');
}

// «Финансовая модель» of a lease / rent / documents-only lot or a suspect platform price: the engine's main number and
// its lines in the old tiles, instead of a resale calculation of zeros. A land lease keeps ONE input (owner, 2026-10-27, as
// TASK47 decided): S3 (build, then rent out) -- the building type when the purpose is generic + the construction cost per m²;
// S4 (temporary object) -- the expected monthly income. The engine recomputes (PUT /api/lot/<id>/model, the request the former
// editor sent) and the card says «по вашим цифрам»; without an input the engine's default stays.
let classicLease = null;     // {lotId, report, overrides, model} -- the user's own saved figures for THIS lot

function classicMoneyCard(report, kind, userModel = false) {
    const dash = document.getElementById('uiFinDashboard');
    if (!dash) return;
    let mn = report.ui ? v2MainNumber(report) : null;
    if (kind === 'price_suspect') {
        const chk = v2Fact(report, 'quality', 'price_check') || {};
        const bid = v2Fact(report, 'money', 'max_bid'), be = v2Fact(report, 'money', 'break_even_purchase');
        mn = { question: 'Цена на площадке похожа на ошибку', value: bid != null ? fmMoneyNb(bid) : 'Не рассчитана', valueLabel: 'максимальная ставка (не зависит от цены площадки)',
               caption: 'Стартовая цена на площадке похожа на опечатку, поэтому доходность от неё не считается.',
               lines: [['Безубыточность', be != null ? fmMoneyNb(be) : ''], ['Вероятная стартовая цена', chk.likely_price != null ? fmMoneyNb(chk.likely_price) : '']].filter(([, v]) => v) };
    }
    if (!mn) {
        mn = { question: kind === 'lease_price' ? 'Право аренды' : 'Деньги', value: 'Доходность для этого лота не рассчитывается', lines: [],
               caption: kind === 'lease_price' ? 'Лот — право аренды: перепродажи с прибылью здесь нет, смотрите максимальную ставку ниже.' : '' };
    }
    const tiles = (mn.lines || []).filter(([, v]) => v).slice(0, 6).map(([label, value]) => `
                        <div class="bg-white/5 p-2.5 rounded-xl border border-white/5 flex flex-col justify-center">
                            <div class="text-[9px] text-[#94a3b8] uppercase font-bold mb-1">${escapeHtml(label)}</div>
                            <div class="text-xs font-bold font-mono-nums text-gray-200">${escapeHtml(String(value))}</div>
                        </div>`).join('');
    const big = mn.value && /\d/.test(mn.value) && mn.value.length <= 16;
    const lr = (report.financial_model && report.financial_model.rent) || {};
    dash.innerHTML = `
                    <div class="bg-info/10 p-4 rounded-xl border border-info/20 relative">
                        <div class="flex justify-between items-start gap-2 mb-1">
                            <div class="text-[10px] text-blue-400 uppercase font-bold tracking-widest">${escapeHtml(mn.question || '')}</div>
                            ${userModel ? '<span class="text-[9px] font-bold text-yellow-400 bg-yellow-500/10 border border-yellow-500/30 px-1.5 py-0.5 rounded shrink-0">по вашим цифрам</span>' : ''}
                        </div>
                        <div class="${big ? 'text-2xl font-mono-nums' : 'text-base'} font-bold text-white">${escapeHtml(mn.value || '')}</div>
                        ${mn.valueLabel ? `<div class="text-[10px] text-blue-300/70 mt-0.5">${escapeHtml(mn.valueLabel)}</div>` : ''}
                        ${mn.caption ? `<div class="text-[11px] text-gray-300 mt-2 leading-relaxed">${escapeHtml(classicNoEditorWords(mn.caption))}</div>` : ''}
                    </div>
                    ${kind === 'lease_price' ? classicLeaseInputsHtml(lr) : ''}
                    ${tiles ? `<div class="grid grid-cols-2 gap-2">${tiles}</div>` : ''}`;
    // no resale chart for these lots
    const canvas = document.getElementById('financialChart');
    if (canvas && canvas.parentElement) canvas.parentElement.classList.add('hidden');
    if (userModel && lr.max_bid != null) {
        const bidEl = document.getElementById('uiMaxBid');
        if (bidEl) bidEl.innerText = formatMoney(lr.max_bid);
        const tldr = document.getElementById('uiTldrPrice');
        if (tldr) tldr.textContent = formatMoney(lr.max_bid);
    }
}

const CLASSIC_LEASE_TYPES = [['склад', 'Склад'], ['магазин', 'Магазин / торговое помещение'], ['офис', 'Офис'], ['сервис', 'АЗС / автосервис / автомойка'], ['общепит', 'Общепит']];
const CLASSIC_INPUT = 'w-full bg-white/5 border border-white/10 rounded-lg text-white text-xs font-bold p-2.5 outline-none mt-1 focus:border-blue-500/50';

function classicLeaseInputsHtml(lr) {
    const ov = (classicLease && classicLease.overrides) || {};
    const num = (v) => (v == null || v === '' ? '' : String(v));
    const label = (forId, text) => `<label for="${forId}" class="text-[9px] text-[#94a3b8] uppercase font-bold">${text}</label>`;
    let fields = '';
    if (lr.strategy === 'S3') {
        const generic = /назначение общее/.test(String(lr.not_computed_reason || '')) || !!ov.lease_building_type;
        if (generic) {
            const cur = ov.lease_building_type || '';
            fields += `<div>${label('classicLeaseType', 'Тип здания')}
                <select id="classicLeaseType" class="${CLASSIC_INPUT}" onchange="classicLeaseChange()">
                    <option value=""${cur ? '' : ' selected'}>Выберите тип здания</option>
                    ${CLASSIC_LEASE_TYPES.map(([v, l]) => `<option value="${v}"${cur === v ? ' selected' : ''}>${l}</option>`).join('')}
                </select></div>`;
        }
        fields += `<div>${label('classicLeaseCost', 'Ваша стоимость стройки, ₸ за м²')}
            <input id="classicLeaseCost" type="number" inputmode="numeric" min="0" class="${CLASSIC_INPUT}" value="${num(ov.lease_user_construction_cost_per_m2)}"
                placeholder="${lr.break_even_construction_cost_per_m2 != null ? `окупается до ${fmMoneyNb(lr.break_even_construction_cost_per_m2)}` : 'например, 150000'}" onchange="classicLeaseChange()"></div>`;
    } else if (lr.strategy === 'S4') {
        fields += `<div>${label('classicLeaseIncome', 'Ваш ожидаемый доход, ₸ в месяц')}
            <input id="classicLeaseIncome" type="number" inputmode="numeric" min="0" class="${CLASSIC_INPUT}" value="${num(ov.lease_user_monthly_income)}"
                placeholder="${lr.break_even_income_monthly != null ? `окупается от ${fmMoneyNb(lr.break_even_income_monthly)}` : 'например, 300000'}" onchange="classicLeaseChange()"></div>`;
    }
    if (!fields) return '';
    return `<div class="rounded-xl border border-blue-500/20 bg-blue-500/5 p-3 space-y-3">
                <p class="text-[10px] text-gray-400 leading-relaxed">Впишите свою цифру — движок пересчитает максимальный разовый платёж за право аренды. Вердикт и балл остаются расчётом по данным лота.</p>
                ${fields}
                <p id="classicLeaseStatus" class="hidden text-[10px] text-gray-400"></p>
            </div>`;
}

// the user's saved figures for this lot (a lease report opened again shows them, not the default)
async function classicLeaseLoad(report) {
    const lotId = state.currentLot && state.currentLot.id;
    classicLease = { lotId, report, overrides: {}, model: null };
    if (!lotId || !userId) return;
    try {
        const res = await fetch(`/api/lot/${lotId}/model?user_id=${userId}`);
        if (!res.ok) return;
        const data = await res.json();
        if (!classicLease || classicLease.lotId !== lotId) return;      // another report was opened meanwhile
        classicLease.overrides = data.overrides || {};
        if (data.source === 'user' && data.model) {
            classicLease.model = data.model;
            classicMoneyCard({ ...report, financial_model: data.model }, 'lease_price', true);
        } else {
            classicMoneyCard(report, 'lease_price');
        }
    } catch (e) {
        console.error('Не удалось загрузить ваши цифры аренды:', e);
    }
}

window.classicLeaseChange = async () => {
    if (!classicLease || !classicLease.lotId) return;
    const read = (id) => { const el = document.getElementById(id); return el ? el.value : undefined; };
    const ov = { ...classicLease.overrides };
    const put = (key, raw, asNumber) => {
        if (raw === undefined) return;
        const v = asNumber ? Number(String(raw).replace(/\s/g, '')) : raw;
        if (raw === '' || (asNumber && !(v > 0))) delete ov[key]; else ov[key] = v;
    };
    put('lease_building_type', read('classicLeaseType'), false);
    put('lease_user_construction_cost_per_m2', read('classicLeaseCost'), true);
    put('lease_user_monthly_income', read('classicLeaseIncome'), true);
    const status = document.getElementById('classicLeaseStatus');
    if (status) { status.textContent = 'Пересчитываем…'; status.classList.remove('hidden'); }
    try {
        const res = await fetch(`/api/lot/${classicLease.lotId}/model`, {
            method: 'PUT', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ user_id: userId, overrides: ov, platform_override_ack: false }),
        });
        const data = await res.json();
        if (!res.ok) {
            if (status) status.textContent = fmErrorMessage(res.status, data);
            return;
        }
        classicLease.overrides = data.overrides || {};
        classicLease.model = data.model;
        const userSet = Object.keys(classicLease.overrides).length > 0;
        classicMoneyCard({ ...classicLease.report, financial_model: userSet ? data.model : classicLease.report.financial_model }, 'lease_price', userSet);
    } catch (e) {
        console.error('Ошибка пересчёта аренды:', e);
        if (status) status.textContent = 'Не удалось пересчитать — проверьте соединение';
    }
};

function renderInAppReport(report) {
    if (!report) return;
    updateTldrStrip(report);

    // 🔥 1. Главное фото
    const mainImg = document.getElementById('uiMainImage');
    mainImg.alt = state.currentLot ? (formatLotTitle(state.currentLot).primary || 'Фото лота') : 'Фото лота';
    // a dead platform photo shows the category placeholder (§8.4), not the browser's broken-image box with the alt text
    const mainPlaceholder = getPlaceholderFor(state.currentLot && state.currentLot.category);
    mainImg.onerror = () => { mainImg.onerror = null; mainImg.src = mainPlaceholder; };
    if (state.currentLot && state.currentLot.image_url) {
        mainImg.src = proxyImg(state.currentLot.image_url, 960);
    } else {
        mainImg.src = mainPlaceholder;
    }

    // Соцдоказательство наверху отчёта (см. коммент у uiAnalysisSocialProof в
    // index.html) — те же view_count/weekly_analyzed_count, что и в карточке
    // лота, только state.currentLot тут может быть ещё не дозагружен (например,
    // если отчёт открыли раньше, чем ответ /api/lot/{id}), поэтому просто
    // тихо ничего не показываем в этом кадре — renderSocialProof это уже
    // обрабатывает (return при отсутствии lotData).
    renderSocialProof(state.currentLot, 'uiAnalysisSocialProof', 'uiAnalysisViewCount', 'uiAnalysisWeeklyCount');

    // Калькулятор "пересчитать под свои цифры" — надстройка над реальными
    // цифрами ЭТОГО отчёта, см. calcWhatIfInit() ниже.
    calcWhatIfInit(report);

    // Добавь это куда-нибудь после блока с описанием или датами:
    if (report.attributes) {
        const attr = report.attributes;
        let tagsHtml = '';
        
        if (attr.is_car) {
            if (attr.vin) tagsHtml += `<span class="bg-blue-500/20 text-blue-300 px-2 py-1 rounded text-[10px] font-mono border border-blue-500/30">VIN: ${attr.vin}</span>`;
            if (attr.year) tagsHtml += `<span class="bg-white/10 px-2 py-1 rounded text-[10px] text-gray-300">Год: ${attr.year}</span>`;
            if (attr.engine_volume) tagsHtml += `<span class="bg-white/10 px-2 py-1 rounded text-[10px] text-gray-300">Объем: ${attr.engine_volume}</span>`;
        } else {
            if (attr.cadastral_number) tagsHtml += `<span class="bg-purple-500/20 text-purple-300 px-2 py-1 rounded text-[10px] font-mono border border-purple-500/30">Кадастр: ${attr.cadastral_number}</span>`;
            if (attr.area_total) tagsHtml += `<span class="bg-white/10 px-2 py-1 rounded text-[10px] text-gray-300">Площадь: ${attr.area_total} м²</span>`;
            if (attr.build_year) tagsHtml += `<span class="bg-white/10 px-2 py-1 rounded text-[10px] text-gray-300">Постройка: ${attr.build_year}</span>`;
        }
        
        // Выведи tagsHtml в нужном месте (например, под заголовком лота)
    }

    // 🔥 2. Визуальный анализ (Галерея доп. фотографий)
    const galleryBlock = document.getElementById('uiGalleryBlock');
    const galleryGrid = document.getElementById('uiGalleryGrid');
    galleryGrid.innerHTML = '';
    let hasExtraImages = false;

    if (state.currentLot && state.currentLot.documents && Array.isArray(state.currentLot.documents)) {
        const imageDocs = state.currentLot.documents.filter(d => {
            const url = typeof d === 'string' ? d : (d.url || '');
            return url.match(/\.(jpeg|jpg|gif|png|webp|heic)$/i) && url !== state.currentLot.image_url;
        });
        
        if (imageDocs.length > 0) {
            hasExtraImages = true;
            galleryBlock.classList.remove('hidden');
            imageDocs.slice(0, 4).forEach((doc, idx) => {
                const url = typeof doc === 'string' ? doc : doc.url;
                galleryGrid.innerHTML += `
                    <a href="${url}" target="_blank" class="block h-24 rounded-lg overflow-hidden border border-white/10 active:scale-95 transition-transform">
                        <img src="${proxyImg(url, 240)}" alt="Дополнительное фото лота ${idx + 1}" class="w-full h-full object-cover">
                    </a>`;
            });
        }
    }
    if (!hasExtraImages) galleryBlock.classList.add('hidden');

    // 🔥 НОВОЕ: 2.1. Визуальные дефекты (От AI Vision)
    const defectsBlock = document.getElementById('uiVisualDefectsBlock');
    const defectsList = document.getElementById('uiVisualDefectsList');
    if (defectsBlock && defectsList) {
        if (report.visual_defects && report.visual_defects.length > 0) {
            defectsBlock.classList.remove('hidden');
            // TASK15 15.4: "linked to photos" -- visual_defects (ai/schemas.py)
            // is a plain List[str], no per-item photo index exists, so a
            // specific defect-to-photo pairing would be invented. Honest
            // version: each item gets a camera icon (source is visual
            // analysis of the gallery below, not a document/quote) and, when
            // the gallery has photos, a jump link to it -- see uiDefectsMeta
            // below for the anchor's existence check.
            defectsList.classList.toggle('report-defects-list--icons', !REPORT_LEGACY_MARKUP);
            defectsList.innerHTML = report.visual_defects.map((d) => REPORT_LEGACY_MARKUP
                ? `<li>${d}</li>`
                : `<li><i class="ph-bold ph-camera report-defect-icon"></i>${d}</li>`
            ).join('');
        } else {
            defectsBlock.classList.add('hidden');
        }
    }

    // TASK15 15.4: section-header count chip + jump link to the gallery,
    // once both blocks above have settled their own hidden/visible state.
    if (!REPORT_LEGACY_MARKUP) {
        const defectsMetaEl = document.getElementById('uiDefectsMeta');
        if (defectsMetaEl) {
            const nDefects = (report.visual_defects || []).length;
            const nPhotos = galleryGrid.children.length;
            const parts = [];
            if (nDefects) parts.push(`${nDefects} ${pluralizeRu(nDefects, 'дефект', 'дефекта', 'дефектов')}`);
            if (nPhotos) parts.push(nDefects
                ? `<a href="#uiGalleryBlock" class="report-defects-meta-link">${nPhotos} ${pluralizeRu(nPhotos, 'фото', 'фото', 'фото')}</a>`
                : `${nPhotos} ${pluralizeRu(nPhotos, 'фото', 'фото', 'фото')}`);
            defectsMetaEl.innerHTML = parts.join(' · ');
        }
    }

    // 🔥 3. Адаптивная Карта и Гео-данные (Только если НЕ машина)
    // Исправлен баг: было report.location_analytics (лишняя "y", несуществующее поле в
    // schemas.py — реальное поле называется location_analysis) — из-за этого блок
    // "Локация и Инфраструктура" в приложении всегда был скрыт. Та же опечатка
    // независимо нашлась и в report_template.html (публичная /share/ страница).
    const geoBlock = document.getElementById('uiGeoBlock');
    const isCar = report.attributes && report.attributes.is_car;
    const geoData = report.location_analysis;

    if (!isCar && geoData) {
        geoBlock.classList.remove('hidden');
        let geoHtml = '';

        // ИЗМЕНЕНО (TASK7 7.4, §5): IS_TELEGRAM — старая сборка (синие/зелёные/
        // красные плашки, uppercase-подписи) байт-в-байт; сайт — нейтральные
        // блоки, sentence case, плюсы/минусы остаются цветными ТОЛЬКО на
        // маркере списка (та же семантика, что sign-color прибыли).
        if (REPORT_LEGACY_MARKUP) {
            if (geoData.liquidity_verdict) {
                geoHtml += `<div class="mb-3 p-3 bg-blue-500/10 rounded-xl border border-blue-500/20 text-xs text-blue-300 font-medium leading-relaxed">
                    <b class="text-blue-400 uppercase text-[10px] block mb-1">Вердикт по локации:</b>
                    ${geoData.liquidity_verdict}
                </div>`;
            }
            if (geoData.geo_data_source === 'google_places' && geoData.nearby_competitors_count !== undefined && geoData.nearby_competitors_count !== null) {
                geoHtml += `<div class="mb-3 p-3 rounded-xl border border-white/10 bg-white/5 flex items-center justify-between">
                    <div>
                        <div class="text-[10px] text-gray-400 uppercase font-bold">Конкурентов рядом</div>
                        <div class="text-[9px] text-[#94a3b8] mt-0.5">По данным Google Places, радиус ${geoData.geo_search_radius_m}м — не оценка ИИ</div>
                    </div>
                    <div class="text-lg font-bold text-white">${geoData.nearby_competitors_count}</div>
                </div>`;
            }
            if (geoData.regional_growth_context && geoData.regional_growth_context.length > 0) {
                const growthItems = geoData.regional_growth_context.map(g => {
                    const link = g.source_url ? ` <a href="${g.source_url}" target="_blank" rel="noopener noreferrer" class="text-blue-400 hover:underline inline-flex items-center gap-1">источник <i class="ph-bold ph-arrow-square-out text-[10px]"></i></a>` : '';
                    return `<div class="text-[11px] text-gray-300 bg-white/5 p-2.5 rounded-lg border border-white/5 leading-relaxed mb-2">${g.claim}${link}</div>`;
                }).join('');
                geoHtml += `<div class="mb-4"><div class="text-[10px] text-[#94a3b8] uppercase font-bold mb-2 tracking-widest">Региональный контекст роста:</div>${growthItems}</div>`;
            }
            if (geoData.infrastructure && geoData.infrastructure.length > 0) {
                const infraTags = geoData.infrastructure.map(i => `<span class="inline-block px-2.5 py-1 bg-white/10 border border-white/5 rounded-lg text-[10px] text-gray-300 mr-1.5 mb-1.5">${i}</span>`).join('');
                geoHtml += `<div class="mb-4"><div class="text-[10px] text-[#94a3b8] uppercase font-bold mb-2 tracking-widest">Инфраструктура рядом:</div><div>${infraTags}</div></div>`;
            }
            geoHtml += `<div class="grid grid-cols-2 gap-3 mt-3">`;
            if (geoData.location_pros && geoData.location_pros.length > 0) {
                const pros = geoData.location_pros.map(p => `<li class="text-green-400 text-[11px] mb-1">${p}</li>`).join('');
                geoHtml += `<div class="bg-green-500/5 p-3 rounded-xl border border-green-500/10">
                    <div class="text-[9px] text-green-500 uppercase font-bold mb-2 flex items-center gap-1"><i class="ph-bold ph-plus"></i> Плюсы</div>
                    <ul class="pl-3 list-disc marker:text-green-500/50">${pros}</ul>
                </div>`;
            }
            if (geoData.location_cons && geoData.location_cons.length > 0) {
                const cons = geoData.location_cons.map(c => `<li class="text-red-400 text-[11px] mb-1">${c}</li>`).join('');
                geoHtml += `<div class="bg-red-500/5 p-3 rounded-xl border border-red-500/10">
                    <div class="text-[9px] text-red-500 uppercase font-bold mb-2 flex items-center gap-1"><i class="ph-bold ph-minus"></i> Минусы</div>
                    <ul class="pl-3 list-disc marker:text-red-500/50">${cons}</ul>
                </div>`;
            }
            geoHtml += `</div>`;
        } else {
            if (geoData.liquidity_verdict) {
                geoHtml += `<p class="text-body text-secondary" style="margin-bottom:12px;"><b class="text-primary">Вердикт по локации:</b> ${geoData.liquidity_verdict}</p>`;
            }
            if (geoData.geo_data_source === 'google_places' && geoData.nearby_competitors_count !== undefined && geoData.nearby_competitors_count !== null) {
                geoHtml += `<div class="report-fin-row"><span class="text-caption text-secondary">Конкурентов рядом (Google Places, радиус ${geoData.geo_search_radius_m}м)</span><span class="text-body font-mono-nums text-primary">${geoData.nearby_competitors_count}</span></div>`;
            }
            if (geoData.regional_growth_context && geoData.regional_growth_context.length > 0) {
                const growthItems = geoData.regional_growth_context.map(g => {
                    const link = g.source_url ? ` <a href="${g.source_url}" target="_blank" rel="noopener noreferrer" class="text-accent">источник ↗</a>` : '';
                    return `<p class="text-caption text-secondary" style="margin-top:8px;">${g.claim}${link}</p>`;
                }).join('');
                geoHtml += `<div style="margin-top:12px;"><span class="text-caption text-secondary">Региональный контекст роста</span>${growthItems}</div>`;
            }
            if (geoData.infrastructure && geoData.infrastructure.length > 0) {
                const infraTags = geoData.infrastructure.map(i => `<span class="report-chip">${i}</span>`).join('');
                geoHtml += `<div style="margin-top:12px;"><span class="text-caption text-secondary" style="display:block;margin-bottom:6px;">Инфраструктура рядом</span><div>${infraTags}</div></div>`;
            }
            if ((geoData.location_pros && geoData.location_pros.length) || (geoData.location_cons && geoData.location_cons.length)) {
                geoHtml += `<div style="margin-top:12px;display:grid;grid-template-columns:1fr 1fr;gap:16px;">`;
                const pros = (geoData.location_pros || []).map(p => `<li class="text-caption text-secondary" style="margin-top:4px;"><span class="text-pos">+</span> ${p}</li>`).join('');
                const cons = (geoData.location_cons || []).map(c => `<li class="text-caption text-secondary" style="margin-top:4px;"><span class="text-neg">−</span> ${c}</li>`).join('');
                geoHtml += `<ul style="list-style:none;">${pros}</ul><ul style="list-style:none;">${cons}</ul></div>`;
            }
        }

        document.getElementById('uiGeoText').innerHTML = geoHtml;
        
        if (report.map_url) {
            document.getElementById('uiMapImage').src = report.map_url;
            document.getElementById('uiMapImage').alt = 'Карта расположения лота';
            document.getElementById('uiMapImage').parentElement.classList.remove('hidden');
        } else {
            document.getElementById('uiMapImage').parentElement.classList.add('hidden');
        }
    } else {
        geoBlock.classList.add('hidden');
    }

    // TASK13 13.2b/13.3: the brief's own "unresolved -> section hidden,
    // «Локация» gets a muted explanatory line" -- every surface that shows
    // the site report (the Mini App does since 19a209f). Uses lookup.py's own ctx.warnings
    // text (already human-readable, e.g. "участок не определён: нет
    // кадастрового номера и точного адреса") rather than inventing new
    // copy here. Runs even when geoData itself was empty above (that
    // branch just hid geoBlock) -- an unresolved geo_context is still
    // worth surfacing on its own.
    if (!REPORT_LEGACY_MARKUP && !isCar) {
        const geoCtx = report.geo_context;
        const geoCtxHasParcel = geoCtx && geoCtx.parcel;
        const geoCtxHasPoint = geoCtx && geoCtx.registry && (geoCtx.registry.area_ga || geoCtx.registry.appraised_value);
        if (geoCtx && !geoCtxHasParcel && !geoCtxHasPoint && !geoCtx.lot_kad_raw && geoCtx.warnings && geoCtx.warnings.length) {
            geoBlock.classList.remove('hidden');
            const lastWarning = geoCtx.warnings[geoCtx.warnings.length - 1];
            document.getElementById('uiGeoText').insertAdjacentHTML('beforeend',
                `<p class="text-caption text-tertiary" style="margin-top:12px;">Кадастровые данные по участку недоступны: ${lastWarning}.</p>`);
        }
    }

    // TASK13 13.3: «Участок и градостроительство» -- cadastral/urban-
    // planning context (bot/geo/lookup.py, report.geo_context). Both
    // surfaces: the Mini App renders the site report (19a209f), so #sec-geo
    // (partials/screens/analysis.html, surface == 'site' markup) exists there
    // too. Not in /share/{token} or the PDF (report_template.html is
    // off-limits).
    const secGeo = document.getElementById('sec-geo');
    if (secGeo) renderGeoContextSection(report, secGeo);

    // 🔥 4. Кнопка "Перейти на рынок"
    const marketLink = document.getElementById('uiMarketLink');
    if (report.market_url) {
        marketLink.href = report.market_url;
        marketLink.classList.remove('hidden');
        document.getElementById('uiMarketBtnText').innerText = isCar ? 'Смотреть аналоги на Kolesa.kz' : 'Смотреть аналоги на Krisha.kz';
    } else {
        marketLink.classList.add('hidden');
    }

    // 🔥 5. Цветовая схема по вердикту и Резюме
    const bgMap = {
        'recommended': 'bg-green-500',
        'conditionally_recommended': 'bg-orange-500',
        'not_recommended': 'bg-red-500'
    };
    document.getElementById('uiVerdictBg').className = `absolute inset-0 opacity-10 ${bgMap[report.verdict_badge] || 'bg-blue-500'}`;
    document.getElementById('uiExecSummary').innerHTML = report.executive_summary || 'Анализ завершен.';
    
    // 🔥 6. ФИНАНСЫ (Новая детальная декомпозиция + Идеальная совместимость со старыми отчетами)
    if (report.financials) {
        const fmt = (num) => formatMoney(num || 0);
        const fin = report.financials;
        
        // 1. Извлекаем расходы (с поддержкой старого поля additional_costs)
        const repair = fin.estimated_repair_cost || 0;
        const taxes = fin.taxes_and_fees !== undefined ? fin.taxes_and_fees : (fin.additional_costs || 0);
        const guarantee = fin.guarantee_fee || 0;
        
        // 2. ЗАЩИТА МАТЕМАТИКИ: Если нового поля нет, высчитываем цену входа от обратного!
        let targetPrice = fin.target_purchase_price;
        if (targetPrice === undefined) {
            targetPrice = (fin.total_investment || 0) - repair - taxes;
            // Защита от минуса на всякий случай
            if (targetPrice < 0) targetPrice = fin.start_price || 0; 
        }
        
        // 3. Целевая цена и Тип торгов
        const auType = fin.auction_type || 'неизвестно';
        document.getElementById('uiAuctionType').innerText = `Вход (${auType})`;
        document.getElementById('uiTargetPrice').innerText = fmt(targetPrice);
        
        // Показываем бейдж "Порог", только если это аукцион на понижение и есть лимит
        const minDropBadge = document.getElementById('uiMinDropBadge');
        if (auType.toLowerCase().includes('понижение') && fin.min_drop_price) {
            minDropBadge.innerText = `Порог: ${fmt(fin.min_drop_price)}`;
            minDropBadge.classList.remove('hidden');
        } else {
            minDropBadge.classList.add('hidden');
        }
        
        // 4. Расходы
        document.getElementById('uiGuarantee').innerText = fmt(guarantee);
        document.getElementById('uiRepairCost').innerText = fmt(repair);
        document.getElementById('uiTaxes').innerText = fmt(taxes);

        // 4.1 Свежесть цены/гарантийного взноса ВЕРСУС свежесть анализа ИИ.
        // Цена (fin.start_price) и гарантийный взнос теперь берутся с площадки
        // (lots.start_price/guarantee_amount, см. analyzer.py — backend
        // перезаписывает guarantee_fee реальным числом), а не только оценкой
        // модели на момент генерации отчёта. Площадка может обновить эти
        // условия ПОСЛЕ того, как отчёт уже сформирован — раньше пользователь
        // видел только одну дату ("Отчёт сформирован: ...") в шапке и не мог
        // понять, что цена/взнос могли устареть отдельно от самого анализа.
        const freshEl = document.getElementById('uiPriceFreshness');
        if (freshEl) {
            const lotDate = fmtDateTime(state.currentLot && state.currentLot.updated_at);
            const aiDate = fmtDateTime(report.analysis_generated_at);
            const parts = [];
            if (lotDate) parts.push(`Цена/взнос с площадки на ${lotDate}`);
            if (aiDate) parts.push(`расчёт ИИ на ${aiDate}`);
            freshEl.innerText = parts.length ? `${emo('🕓 ')}${parts.join(' • ')}` : '';
        }

        // Дублируем как подсказку прямо на самой цифре гарантийного взноса —
        // узкая карточка (grid-cols-3) не помещает текст, но title виден по
        // наведению/долгому тапу.
        const guaranteeEl = document.getElementById('uiGuarantee');
        if (guaranteeEl && state.currentLot && state.currentLot.updated_at) {
            const guaranteeDate = fmtDateTime(state.currentLot.updated_at);
            if (guaranteeDate) guaranteeEl.title = `Данные с площадки на ${guaranteeDate}`;
        }

        // 5. Итоги — counter-up для крупных чисел (Phase 4), финальное значение
        // всегда отформатировано через toLocaleString('ru-RU') с разделителями
        // тысяч, независимо от того, сыграла анимация или сработал fallback.
        const tsFmt = (v) => formatMoney(v);
        const pctFmt = (v) => Math.round(v) + '%';
        animateCountUp(document.getElementById('uiTotalInvest'), fin.total_investment || 0, { formatFn: tsFmt });
        animateCountUp(document.getElementById('uiProfit'), fin.projected_profit || 0, { formatFn: tsFmt });
        animateCountUp(document.getElementById('uiRoi'), fin.roi_percent || 0, { formatFn: pctFmt });

        // ДОБАВЛЕНО (TASK7 7.3, §4, "Чистая прибыль — цвет по знаку"): #uiProfit/
        // #uiRoi в analysis.html без цвета намеренно (Telegram-ветка держит свой
        // статический class="text-green-400" в modals/analysis.html — не трогаю
        // его), красим ТОЛЬКО на сайте, добавляя класс, а не заменяя чужой.
        if (!REPORT_LEGACY_MARKUP) {
            const profitNeg = (fin.projected_profit || 0) < 0;
            const profitEl = document.getElementById('uiProfit');
            const roiValEl = document.getElementById('uiRoi');
            if (profitEl) { profitEl.classList.toggle('text-neg', profitNeg); profitEl.classList.toggle('text-pos', !profitNeg); }
            if (roiValEl) { roiValEl.classList.toggle('text-neg', profitNeg); roiValEl.classList.toggle('text-pos', !profitNeg); }
        }

        // Ликвидность и срок
        const uiLiquidity = document.getElementById('uiLiquidity');
        if(uiLiquidity) {
            const lq = fin.liquidity_rating || (report.location_analysis ? report.location_analysis.liquidity_verdict : null);
            uiLiquidity.innerText = lq ? lq : 'Неизвестно';
        }
        const uiSalesPeriod = document.getElementById('uiSalesPeriod');
        if(uiSalesPeriod) {
            if (fin.estimated_sales_period_days) {
                uiSalesPeriod.innerText = `~${fin.estimated_sales_period_days} дн.`;
            } else {
                uiSalesPeriod.innerText = fin.estimated_sales_period || 'Неизвестно';
            }
        }

        // Запас прочности (годовой ROI больше не дублируется тут отдельной крупной
        // цифрой без дисклеймера — см. uiAnnualBenchmark ниже, единственное место,
        // где теперь показывается аннуализированная доходность).
        const extraFinRow = document.getElementById('uiExtraFinRow');
        if (extraFinRow) {
            const hasMargin = fin.margin_of_safety_percent !== undefined && fin.margin_of_safety_percent !== null;
            if (hasMargin) {
                extraFinRow.classList.remove('hidden');
                const msEl = document.getElementById('uiMarginSafety');
                if (msEl) {
                    msEl.innerText = `${fin.margin_of_safety_percent}%`;
                    msEl.className = 'text-lg font-bold ' + (
                        fin.margin_of_safety_percent >= 20 ? 'text-green-400' :
                        fin.margin_of_safety_percent >= 8 ? 'text-yellow-400' : 'text-red-400'
                    );
                }
            } else {
                extraFinRow.classList.add('hidden');
            }
        }

        // Доходность и окупаемость аренды (только если объект реально сдаваем)
        const rentalRow = document.getElementById('uiRentalRow');
        const rentalNote = document.getElementById('uiRentalNote');
        if (rentalRow) {
            if (fin.cap_rate_percent !== undefined && fin.cap_rate_percent !== null) {
                rentalRow.classList.remove('hidden');
                const crEl = document.getElementById('uiCapRate');
                if (crEl) crEl.innerText = `${fin.cap_rate_percent}%`;
                const rpEl = document.getElementById('uiRentalPayback');
                if (rpEl) rpEl.innerText = fin.rental_payback_years ? `${fin.rental_payback_years} лет` : '—';
                if (rentalNote) {
                    if (fin.rental_income_monthly_estimate) {
                        rentalNote.innerText = `Оценка арендного дохода: ${formatNumber(fin.rental_income_monthly_estimate)} ₸/мес — справочно, не гарантия ставки аренды.`;
                        rentalNote.classList.remove('hidden');
                    } else {
                        rentalNote.classList.add('hidden');
                    }
                }
            } else {
                rentalRow.classList.add('hidden');
                if (rentalNote) rentalNote.classList.add('hidden');
            }
        }

        // Таймлайн заморозки капитала (только если известен ожидаемый срок продажи)
        const freezeTimeline = document.getElementById('uiFreezeTimeline');
        if (freezeTimeline) {
            if (fin.estimated_sales_period_days) {
                freezeTimeline.classList.remove('hidden');
            } else {
                freezeTimeline.classList.add('hidden');
            }
        }

        // Годовая доходность — единственное место, где показывается ROI годовых
        // (раньше дублировалась крупной цифрой выше в uiExtraFinRow без контекста).
        // Работает и без бенчмарка депозита: тогда просто прячем строку сравнения,
        // но сама цифра и дисклеймер остаются на месте — не теряем аннуализацию,
        // просто держим её визуально скромной и всегда подписанной "справочно".
        const annualBenchmark = document.getElementById('uiAnnualBenchmark');
        if (annualBenchmark) {
            const annualized = fin.roi_annualized_percent;
            const benchmark = report.risk_free_rate_percent;
            const benchmarkRow = document.getElementById('uiAnnualBenchmarkRow');
            if (annualized !== undefined && annualized !== null) {
                annualBenchmark.classList.remove('hidden');
                const hasBenchmark = !!benchmark;
                const maxScale = Math.max(Math.abs(annualized), hasBenchmark ? benchmark : 0) * 1.15 || 1;
                const valEl = document.getElementById('uiAnnualBenchmarkValue');
                if (valEl) valEl.innerText = `${annualized}%`;
                const dealBar = document.getElementById('uiAnnualBarDeal');
                if (dealBar) {
                    dealBar.style.width = `${(Math.abs(annualized) / maxScale) * 100}%`;
                    dealBar.className = 'h-full ' + (annualized >= 0 ? 'bg-blue-500' : 'bg-red-500');
                }
                if (benchmarkRow) benchmarkRow.classList.toggle('hidden', !hasBenchmark);
                if (hasBenchmark) {
                    const benchBar = document.getElementById('uiAnnualBarBenchmark');
                    if (benchBar) benchBar.style.width = `${(benchmark / maxScale) * 100}%`;
                    const rateEl = document.getElementById('uiAnnualBenchmarkRate');
                    if (rateEl) rateEl.innerText = `~${benchmark}%`;
                }
            } else {
                annualBenchmark.classList.add('hidden');
            }
        }

        // USD-эквивалент цены входа (курс НацБанка, считается в analyzer.py)
        const targetUsdEl = document.getElementById('uiTargetPriceUsd');
        if (targetUsdEl) {
            if (report.usd_rate && report.usd_rate > 0) {
                targetUsdEl.innerText = `≈ $${new Intl.NumberFormat('en-US').format(Math.round(targetPrice / report.usd_rate))}`;
            } else {
                targetUsdEl.innerText = '';
            }
        }

        // Передаем правильный targetPrice в график
        if(typeof initFinancialChart === 'function') initFinancialChart(fin, targetPrice); 
    }

    // 🔥 6.5 СЦЕНАРИИ ИНВЕСТИРОВАНИЯ
    const scenariosBlock = document.getElementById('uiScenariosBlock');
    const scenariosList = document.getElementById('uiScenariosList');
    
    if (scenariosBlock && scenariosList) {
        if (report.investment_scenarios && report.investment_scenarios.length > 0) {
            scenariosBlock.classList.remove('hidden');
            scenariosList.innerHTML = '';
            
            // Настройки цветов и иконок для разных сценариев
            const scenarioMap = {
                "Optimistic": { name: "Оптимистичный", color: "text-green-400", bg: "bg-green-500/10", border: "border-green-500/20", icon: "ph-trend-up" },
                "Realistic": { name: "Реалистичный", color: "text-yellow-400", bg: "bg-yellow-500/10", border: "border-yellow-500/20", icon: "ph-minus" },
                "Pessimistic": { name: "Пессимистичный", color: "text-red-400", bg: "bg-red-500/10", border: "border-red-500/20", icon: "ph-trend-down" }
            };

            report.investment_scenarios.forEach(sc => {
                const style = scenarioMap[sc.scenario] || scenarioMap["Realistic"];
                const profitFormatted = formatMoney(sc.projected_profit);

                // ИЗМЕНЕНО (TASK7 7.3, §4, "нейтральные карточки, цвет только на
                // прибыли по знаку"): IS_TELEGRAM-ветка — старая разметка байт-в-
                // байт (карточка красится целиком по типу сценария), сайт —
                // нейтральная карточка, цвет только на числе прибыли по знаку.
                if (REPORT_LEGACY_MARKUP) {
                    scenariosList.innerHTML += `
                        <div class="p-3 rounded-xl border ${style.border} ${style.bg} flex flex-col gap-2">
                            <div class="flex justify-between items-center">
                                <span class="font-bold text-[11px] uppercase tracking-wider ${style.color} flex items-center gap-1.5">
                                    <i class="ph-bold ${style.icon}"></i> ${style.name}
                                </span>
                                <div class="text-right flex flex-col items-end">
                                    <div class="font-bold text-sm text-white leading-none mb-1">${profitFormatted}</div>
                                    <div class="text-[9px] text-gray-400 font-mono bg-black/20 px-1.5 py-0.5 rounded">ROI: ${sc.roi_percent}%</div>
                                </div>
                            </div>
                            <div class="text-[11px] text-gray-300 font-medium leading-relaxed">
                                ${sc.description}
                            </div>
                        </div>
                    `;
                } else {
                    const profitClass = (sc.projected_profit || 0) < 0 ? 'text-neg' : 'text-pos';
                    scenariosList.innerHTML += `
                        <div class="report-panel report-scenario-card">
                            <span class="text-body text-primary">${style.name}</span>
                            <div class="report-scenario-profit font-mono-nums ${profitClass}">${profitFormatted}</div>
                            <div class="text-caption text-tertiary font-mono-nums">ROI: ${sc.roi_percent}%</div>
                            <p class="text-caption text-secondary">${sc.description}</p>
                        </div>
                    `;
                }
            });
        } else {
            scenariosBlock.classList.add('hidden');
        }
    }

    // 🔥 7. РИСКИ (Обновлено: добавлен источник документа)
    const risksContainer = document.getElementById('uiRisksContainer');
    risksContainer.innerHTML = '';
    if (report.risks && report.risks.length > 0) {
        const riskCategoryLabels = {
            'обременение_арест': 'Обременение/Арест',
            'незавершенная_приватизация': 'Незаверш. приватизация',
            'третьи_лица_прописаны': 'Прописаны третьи лица',
            'несовершеннолетние': 'Несовершеннолетние',
            'оспоримость_банкротство': 'Оспоримость (банкротство)',
            'неполный_пакет_документов': 'Неполный пакет документов',
            'финансовый_риск': 'Финансовый риск',
            'технический_риск': 'Технический риск',
            'иное': 'Иное'
        };
        report.risks.forEach(r => {
            const isCritical = r.severity === 'Critical' || r.severity === 'High';
            const catLabel = riskCategoryLabels[r.risk_category] || null;
            // Site branch below builds its own evidence block via
            // reportEvidenceHTML (TASK15 15.1/15.3) -- this stays the
            // Telegram-only shape, byte-identical to before.
            const quoteHtml = r.evidence_quote
                ? `<div class="mt-2 text-[10px] bg-black/20 p-2 rounded italic text-gray-400 border-l-2 border-current">«${r.evidence_quote}»</div>`
                : '';

            // ИЗМЕНЕНО (TASK7 7.4, §5, "риск — строка, без красных заливок,
            // серьёзность — статус-пилюля"): IS_TELEGRAM — старая карточка с
            // цветной заливкой/рамкой байт-в-байт; сайт — нейтральная строка,
            // severity пилюлей (.pill), категория — обычная подпись, не чип.
            if (REPORT_LEGACY_MARKUP) {
                const colorClass = isCritical ? 'bg-red-500/10 border-red-500/30 text-red-400' : 'bg-yellow-500/10 border-yellow-500/30 text-yellow-400';
                const icon = isCritical ? 'ph-warning-octagon' : 'ph-warning';
                risksContainer.innerHTML += `
                    <div class="glass-card p-4 rounded-xl border ${colorClass} relative">
                        <div class="flex items-start gap-3">
                            <i class="ph-fill ${icon} text-xl mt-0.5"></i>
                            <div class="w-full">
                                <div class="flex justify-between items-start gap-2">
                                    <h4 class="font-bold text-sm mb-1">${r.title}</h4>
                                    ${r.source_doc ? `<span class="text-[8px] px-1.5 py-0.5 bg-black/30 rounded border border-white/10 truncate max-w-[100px]" title="Источник: ${r.source_doc}"><i class="ph-fill ph-file-pdf"></i> ${r.source_doc}</span>` : ''}
                                </div>
                                ${catLabel ? `<span class="inline-block text-[8px] font-bold uppercase tracking-wide px-1.5 py-0.5 rounded bg-black/20 border border-white/10 mb-1.5">${catLabel}</span>` : ''}
                                <p class="text-xs text-gray-300 opacity-90 leading-relaxed">${r.description}</p>
                                ${quoteHtml}
                            </div>
                        </div>
                    </div>
                `;
            } else {
                // TASK15 15.3: severity rail (left border colour) + a
                // text-only status chip (reportStatusChipHTML, §7.4) --
                // replaces the coloured .pill fill above. reportEvidenceHTML
                // (15.1) replaces the ad-hoc quote block.
                const level = (r.severity || '').toLowerCase();
                const railClass = (level === 'critical' || level === 'high') ? 'report-risk-row--critical'
                    : level === 'medium' ? 'report-risk-row--medium' : '';
                // TASK15 15.4b item 1: the category already renders as its
                // own muted line below -- strip a leading "Категория:"
                // repeat from the title, but only when the title's own
                // prefix actually matches the category (e.g. "Риск
                // утильсбора" has no colon at all and stays untouched).
                const catFirstWord = catLabel ? catLabel.split('/')[0].trim().toLowerCase() : null;
                const cleanTitle = (catFirstWord && r.title.toLowerCase().startsWith(catFirstWord) && r.title.includes(':'))
                    ? r.title.replace(/^[^:]+:\s*/, '')
                    : r.title;
                risksContainer.innerHTML += `
                    <div class="report-risk-row ${railClass}">
                        <div class="report-risk-head">
                            <span class="text-body text-primary">${cleanTitle}</span>
                            ${reportStatusChipHTML(level)}
                        </div>
                        ${catLabel ? `<span class="text-micro text-tertiary">${catLabel}</span>` : ''}
                        <p class="text-caption text-secondary">${r.description}</p>
                        ${reportEvidenceHTML(r.evidence_quote, r.source_doc ? { label: r.source_doc } : null)}
                    </div>
                `;
            }
        });
    } else {
        risksContainer.innerHTML = '<div class="text-xs text-green-400 bg-green-500/10 p-3 rounded-xl border border-green-500/20">Критических рисков не выявлено</div>';
    }

    // 🔥 8. СТРАТЕГИЯ (Обновлено: добавлена Тактика)
    if (report.strategy) {
        document.getElementById('uiMaxBid').innerText = report.strategy.recommended_max_bid > 0 ? formatMoney(report.strategy.recommended_max_bid) : 'не рассчитана';
        document.getElementById('uiRationale').innerText = report.strategy.recommendation_rationale || 'Обоснование отсутствует';
        
        const uiTactics = document.getElementById('uiTactics');
        if(uiTactics) {
            uiTactics.innerText = report.strategy.auction_tactics || 'Действуйте по ситуации';
        }
    }

    // 🔥 9. ПОЛНЫЙ SWOT Анализ (Все 4 фактора) — квадрант с нумерованными пунктами,
    // мини-статистикой по количеству факторов и сводным "балансом" сделки.
    if (report.swot) {
        // Защита от старых форматов: проверяем, если пункт — строка или объект с description
        const toText = (i) => typeof i === 'string' ? i : (i && (i.description || i.text)) || '';
        // 🔥 SWOT-пункты теперь могут нести evidence_quote/source_doc — тот же
        // стандарт доказательности, что уже был у RiskFactor (см. цитаты под
        // рисками выше, r.evidence_quote). Раньше SWOT был просто текстом без
        // возможности проверить, откуда взят пункт; toQuote/toDoc безопасно
        // достают эти поля, если модель их заполнила (ai/schemas.py::SWOTPoint),
        // и ничего не ломают на старых отчётах, где пункт — просто строка.
        const toQuote = (i) => (i && typeof i === 'object' && i.evidence_quote) || '';
        const toDoc = (i) => (i && typeof i === 'object' && i.source_doc) || '';
        const renderList = (items) => {
            const clean = (items || []).filter(i => toText(i));
            if (clean.length === 0) return '<li class="swot-empty">Данных недостаточно</li>';
            return clean.map((item, idx) => {
                const text = toText(item);
                const quote = toQuote(item);
                const doc = toDoc(item);
                // TASK15 15.5: site quote now uses the shared evidence
                // block (reportEvidenceHTML, 15.1) instead of its own
                // one-off .report-quote markup -- same shape as risks/
                // legal/documents citations everywhere else in the report.
                // Telegram keeps the old inline markup unchanged.
                const quoteHtml = REPORT_LEGACY_MARKUP
                    ? (quote ? `<div class="mt-1 text-[10px] bg-black/20 p-1.5 rounded italic text-gray-400 border-l-2 border-current">«${quote}»${doc ? ` <span class="not-italic opacity-70">— ${doc}</span>` : ''}</div>` : '')
                    : reportEvidenceHTML(quote, doc ? { label: doc } : null);
                return `<li><span class="swot-cell__idx">${idx + 1}</span><span>${highlightFacts(text)}${quoteHtml}</span></li>`;
            }).join('');
        };

        const s = (report.swot.strengths || []).filter(i => toText(i));
        const w = (report.swot.weaknesses || []).filter(i => toText(i));
        const o = (report.swot.opportunities || []).filter(i => toText(i));
        const t = (report.swot.threats || []).filter(i => toText(i));

        document.getElementById('uiSwotS').innerHTML = renderList(s);
        document.getElementById('uiSwotW').innerHTML = renderList(w);
        if (document.getElementById('uiSwotO')) document.getElementById('uiSwotO').innerHTML = renderList(o);
        if (document.getElementById('uiSwotT')) document.getElementById('uiSwotT').innerHTML = renderList(t);

        const statsEl = document.getElementById('uiSwotStats');
        if (statsEl) {
            const stats = [
                { count: s.length, label: 'Сила', color: '#4ade80' },
                { count: w.length, label: 'Слабость', color: '#f87171' },
                { count: o.length, label: 'Возможности', color: '#60a5fa' },
                { count: t.length, label: 'Угрозы', color: '#fb923c' }
            ];
            statsEl.innerHTML = stats.map(st => `
                <div class="swot-stat">
                    <div class="swot-stat__count" style="color:${st.color}">${st.count}</div>
                    <div class="swot-stat__label">${st.label}</div>
                </div>
            `).join('');
        }

        const balanceEl = document.getElementById('uiSwotBalance');
        if (balanceEl) {
            const positive = s.length + o.length;
            const negative = w.length + t.length;
            let label = 'Баланс: нейтральный';
            if (positive > negative) label = 'Баланс: в пользу сделки';
            else if (negative > positive) label = 'Баланс: повышенный риск';
            // TASK15 15.5: site gets the §7.4 status chip (green/red text
            // only, no fill) instead of the old boxed expert-report badge;
            // Telegram keeps that badge markup unchanged.
            if (REPORT_LEGACY_MARKUP) {
                const cls = positive > negative ? 'balance-positive' : negative > positive ? 'balance-negative' : 'balance-neutral';
                balanceEl.className = `expert-report__badge ${cls}`;
            } else {
                const chipCls = positive > negative ? ' status-chip--ok' : negative > positive ? ' status-chip--critical' : '';
                balanceEl.className = `report-section-meta status-chip${chipCls}`;
            }
            balanceEl.innerText = label;
        }
    }

    // 🔥 10. Глубокие тексты (Документы и Юр. часть) — рендерятся как
    // "экспертное заключение": подразделы по лейблам '**Лейбл:** текст' от ИИ
    // (см. ai/schemas.py) + подсветка ключевых фактов (суммы, статьи, цитаты).
    // TASK15 15.3/15.4b: site gets label rows + citation chips/callout
    // (renderExpertRowsSite), Telegram keeps the old boxed card unchanged.
    // Документы: "Комплектность пакета" is skipped -- the checklist above
    // (renderDocChecklistSite, wired in renderInAppReportSite) replaces it,
    // not duplicates it.
    // 15.4c item 2 (BLOCKER fix): Юридический статус no longer skips
    // "Юридический статус"/"Обременения и аресты" -- the fact rows
    // (renderLegalFactRowsSite, prepended below) are purely ADDITIVE
    // (Собственник/Обременение/Организатор), they replace nothing. Found
    // live: the fact rows matched on only 2 of 103 lots, so on every other
    // lot skipLabelRe was silently deleting the LLM's own legal paragraph
    // with no replacement -- on sauda_338022092479000000 that dropped "На
    // квартиру наложено более 5 арестов..." entirely, the single most
    // important fact on the lot. Rule: never drop LLM text a structured
    // field didn't replace. "Риски и рекомендации" stays a checklist.
    document.getElementById('uiDocAnalysis').innerHTML = REPORT_LEGACY_MARKUP
        ? renderExpertSection(report.document_analysis_reasoning)
        : renderExpertRowsSite(report.document_analysis_reasoning, { skipLabelRe: /комплектность/i });
    document.getElementById('uiLegalAnalysis').innerHTML = REPORT_LEGACY_MARKUP
        ? renderExpertSection(report.legal_analysis_reasoning)
        : renderLegalFactRowsSite(report) + renderExpertRowsSite(report.legal_analysis_reasoning, {
            checklistLabelRe: /риски и рекомендации/i,
        });

    // TASK15 15.4c item 5 / 15.5 nit 1: build the market markers' own price
    // formatter from the FROZEN report (report.financial_model) -- the
    // ladder/sensitivity grid in the finance editor no longer read this;
    // they build their own from the CURRENT mode's live cells
    // (fmComputeCurrentPriceFormatter, near fmSensitivityCells), which can
    // genuinely differ from this frozen snapshot (owner review). Union =
    // the engine's own sensitivity cells + the engine's entry price + the
    // lot's start price -- the same prices the market markers below show.
    if (!REPORT_LEGACY_MARKUP) {
        const fmForSet = report.financial_model;
        const sensPricesForSet = ((fmForSet && fmForSet.scenarios && fmForSet.scenarios.sensitivity) || [])
            .map((c) => c.price).filter((p) => typeof p === 'number');
        const entryForSet = (fmForSet && fmForSet.purchase && typeof fmForSet.purchase.price === 'number') ? fmForSet.purchase.price : null;
        const startForSet = (state.currentLot && typeof state.currentLot.start_price === 'number') ? state.currentLot.start_price : null;
        reportPriceFormatter = buildDistinctPriceFormatter([...sensPricesForSet, entryForSet, startForSet]);
    }

    const confidenceMap = {
        'Высокая': { cls: 'conf-high', label: 'Высокая достоверность' },
        'Средняя': { cls: 'conf-medium', label: 'Средняя достоверность' },
        'Низкая': { cls: 'conf-low', label: 'Низкая достоверность' }
    };
    const confInfo = confidenceMap[report.confidence_level];
    ['uiDocConfidence', 'uiLegalConfidence'].forEach(id => {
        const el = document.getElementById(id);
        if (!el) return;
        if (confInfo) {
            el.className = `expert-report__badge ${confInfo.cls}`;
            el.innerText = confInfo.label;
            el.classList.remove('hidden');
        } else {
            el.classList.add('hidden');
        }
    });
    
    // Раньше здесь был перехват инъекции <font color='red'><b>...</b></font>,
    // которую прописывал Neo4j-детектив в final_verdict_reasoning (карточка
    // "Служба безопасности"). После выреза Neo4j эта инъекция больше не
    // появляется — блок был мёртвым кодом, удалён вместе с uiDetectiveAlert.
    document.getElementById('uiFinalVerdict').innerHTML = formatText(report.final_verdict_reasoning || '');

    // --- ОТРИСОВКА ИСТОРИЧЕСКИХ ТОРГОВ ---
    const histBlock = document.getElementById('uiHistoryBlock');
    const histContainer = document.getElementById('uiHistoricalSales');
    if (histBlock && histContainer) {
        // УДАЛЕНО (TASK9 9.1): клиентский фильтр мусора «2 ₸ · Упал на 100%»
        // (final_price ≤ 1000 ₸ / drop ≥ 99% / нет final_price) — жил только
        // на сайте с TASK7 7.4, Mini App продолжал видеть мусор. Теперь
        // _build_historical_context() (ai/analyzer.py) исключает такие
        // записи ДО того, как они попадут и в текст промпта модели, и в
        // report.historical_sales — на обеих площадках одинаково чисто,
        // фильтровать здесь больше нечего.
        const sales = report.historical_sales || [];
        if (sales.length > 0) {
            histBlock.classList.remove('hidden');
            histContainer.innerHTML = '';
            // TASK15 15.4b item 5: table header row + the class median
            // (site only). The median is the outcomes-curve population's
            // median drop for this exact site+auction_type+asset_class
            // (financial_model.curve.median_drop_pct, finance/model.py's
            // CurveSummary -- real sold-lot data, hundreds+ of lots), not
            // the median of just the 3 sales shown below (too small a
            // sample to call a "class" figure) -- hidden entirely when the
            // curve has no real median (too little data / lease branch).
            if (!REPORT_LEGACY_MARKUP) {
                histContainer.innerHTML += `
                    <div class="report-history-row report-history-head text-micro text-tertiary">
                        <span>Лот</span>
                        <span>Старт → продажа</span>
                    </div>
                `;
                const histMetaEl = document.getElementById('uiHistoryMeta');
                if (histMetaEl) {
                    const curve = report.financial_model && report.financial_model.curve;
                    const parts = [`${sales.length} ${pluralizeRu(sales.length, 'продажа', 'продажи', 'продаж')}`];
                    if (curve && typeof curve.median_drop_pct === 'number') {
                        // 15.4c self-found: 0 >= 0 is true, so a genuinely
                        // zero median (found live: sauda_338022092479000000,
                        // an ascending Sauda auction where "drop" is 0 for
                        // the class) printed "−0 %" -- no sign for exactly 0.
                        const sign = curve.median_drop_pct > 0 ? '−' : curve.median_drop_pct < 0 ? '+' : '';
                        // 15.4c item 3: ru-RU decimal comma (found live:
                        // "27.4" printed with a dot, not "27,4").
                        const pctText = Math.abs(curve.median_drop_pct).toLocaleString('ru-RU', { maximumFractionDigits: 1 });
                        parts.push(`медиана по классу ${sign}${pctText} %`);
                    }
                    histMetaEl.textContent = parts.join(' · ');
                }
            }
            const currentCategory = state.currentLot && state.currentLot.category;
            sales.forEach(sale => {

                // 🔥 Умная логика расчета тренда (Рост или Падение)
                let trendHtml = '';
                // ИИ может вернуть процент падения с минусом, если это был рост
                let dropVal = parseFloat(sale.drop_percent || 0);

                let titleText = sale.title || 'Сделка';
                const auTypeLabel = getAuctionTypeShort(sale.auction_type);
                const contextNote = getHistoricalContextNote(sale.auction_type, dropVal);

                // IS_TELEGRAM: старая разметка (цветные плашки-тренды) байт-в-
                // байт; сайт — нейтральная строка, знак только на числе % (§5).
                if (REPORT_LEGACY_MARKUP) {
                    // 2026-10-28 (user feedback): the green «Упал на 74%» read as
                    // good news about THIS lot, while it is the analog's own fall
                    // from its start to its sale. One neutral line instead:
                    // «Старт X → продано Y (−N%)». start_price is stored since
                    // 2026-10-28; older reports reconstruct it (≈, compact — the
                    // integer drop_percent gives no exact tenge, see 15.4c item 4).
                    const hasStart = typeof sale.start_price === 'number' && sale.start_price > 0;
                    const approxStart = (!hasStart && dropVal !== 0 && dropVal < 100 && typeof sale.final_price === 'number')
                        ? Math.round(sale.final_price / (1 - dropVal / 100)) : null;
                    const finalHtml = `<span class="font-bold text-white">${formatMoney(sale.final_price)}</span>`;
                    const changeText = dropVal > 0 ? ` (−${dropVal}%)` : dropVal < 0 ? ` (+${Math.abs(dropVal)}%)` : '';
                    if (dropVal === 0) {
                        trendHtml = `Продано по стартовой цене: ${finalHtml}`;
                    } else if (hasStart || approxStart !== null) {
                        const startText = hasStart ? formatMoney(sale.start_price) : `≈ ${fmPriceCompactStrict(approxStart)} ₸`;
                        trendHtml = `Старт ${startText} → продано ${finalHtml}${changeText}`;
                    } else {
                        trendHtml = `Продано ${finalHtml}${changeText}`;
                    }
                    histContainer.innerHTML += `
                        <div class="flex flex-col p-3 bg-white/5 rounded-xl border border-white/5 overflow-hidden">
                            <span class="text-xs text-blue-300 font-medium truncate">${titleText}</span>
                            <span class="text-[9px] text-[#94a3b8] mt-0.5 flex items-center gap-1">
                                <i class="ph-fill ph-check-circle text-gray-400"></i> ${auTypeLabel}
                            </span>
                            <span class="text-xs text-gray-300 mt-1.5">${trendHtml}</span>
                            ${contextNote ? `<span class="text-[9px] text-gray-400 mt-0.5 leading-snug">${contextNote}</span>` : ''}
                        </div>
                    `;
                } else {
                    // TASK15 15.4b item 5: title shortened per §8.3
                    // (historicalSaleTitleSite); per-row explanatory
                    // sentence (contextNote) dropped -- the Δ number
                    // already says it, per the brief. start_price isn't
                    // its own field on HistoricalSale (ai/schemas.py) --
                    // reconstructed from final_price/drop_percent, the
                    // same two fields the % below was always computed
                    // from, not a new figure.
                    const shortTitle = historicalSaleTitleSite(sale.title, currentCategory);
                    // 15.4c item 4: drop_percent is an INTEGER in 204/204
                    // stored historical_sales -- final/(1-drop/100) then
                    // gives a tenge-exact number that never existed (found
                    // live: "6 064 809 ₸" on sauda_338022092479000000, a
                    // price nobody ever quoted). Shown compact/approximate
                    // ("≈ 6,1 млн") instead of fake exact precision; the
                    // final price is real (from the record) and stays exact.
                    // TASK15 15.5 nit 2 (owner review): drop_percent === 0
                    // reconstructs start === final exactly (1 - 0/100 = 1)
                    // -- not fake precision numerically, but showing
                    // "≈ {compact} → {exact}" implies a DIFFERENT start
                    // that happens to round the same, when really nothing
                    // moved. Final price only in that case.
                    const startPrice = (dropVal !== 100 && dropVal !== 0 && typeof sale.final_price === 'number')
                        ? Math.round(sale.final_price / (1 - dropVal / 100))
                        : null;
                    const changeClass = dropVal > 0 ? 'text-pos' : dropVal < 0 ? 'text-neg' : 'text-tertiary';
                    const changeText = dropVal > 0 ? `−${dropVal}%` : dropVal < 0 ? `+${Math.abs(dropVal)}%` : '0%';
                    const priceLine = startPrice !== null
                        ? `<span class="text-caption text-tertiary">≈ ${fmPriceCompactStrict(startPrice)} → </span><span class="report-history-final-price">${formatMoney(sale.final_price)}</span>`
                        : `<span class="report-history-final-price">${formatMoney(sale.final_price)}</span>`;
                    histContainer.innerHTML += `
                        <div class="report-history-row">
                            <div class="report-history-row-main">
                                <span class="text-body text-primary">${shortTitle}</span>
                                <span class="text-caption text-tertiary">${auTypeLabel}</span>
                            </div>
                            <div class="report-history-row-value">
                                <span class="text-body font-mono-nums text-primary">${priceLine}</span>
                                <span class="text-caption font-mono-nums ${changeClass}">${changeText}</span>
                            </div>
                        </div>
                    `;
                }
            });
        } else {
            histBlock.classList.add('hidden');
        }
    }

    // 🔥 11. Участники (Детектив)
    const dName = report.debtor_name || 'Не указано';
    const chsiName = report.chsi_name || 'Не указано';
    
    document.getElementById('uiDebtorName').innerText = dName;
    // classic report (2026-10-27): the debtor's and the ЧСИ's ИИН are not put on the page at all
    document.getElementById('uiDebtorIin').innerText = REPORT_LEGACY_MARKUP ? '' : (report.debtor_iin ? `ИИН/БИН: ${report.debtor_iin}` : '---');
    
    document.getElementById('uiChsiName').innerText = chsiName;
    document.getElementById('uiChsiIin').innerText = REPORT_LEGACY_MARKUP ? '' : (report.chsi_iin ? `ИИН/БИН: ${report.chsi_iin}` : '---');
    
    const appraiserName = report.appraiser_name && report.appraiser_name.trim() !== '' ? report.appraiser_name : 'Независимая оценка не проводилась';
    document.getElementById('uiAppraiserName').innerText = appraiserName;
    
    // Если оценки нет, скрываем БИН и делаем текст тусклым
    const appraiserBinEl = document.getElementById('uiAppraiserBin');
    if (appraiserName === 'Независимая оценка не проводилась') {
        document.getElementById('uiAppraiserName').classList.replace('text-white', 'text-gray-400');
        appraiserBinEl.classList.add('hidden');
    } else {
        document.getElementById('uiAppraiserName').classList.replace('text-gray-400', 'text-white');
        appraiserBinEl.classList.remove('hidden');
        appraiserBinEl.innerText = report.appraiser_bin ? `БИН: ${report.appraiser_bin}` : 'БИН не указан';
    }

    // АДАПТИВНЫЕ ЗАГОЛОВКИ (Ультимативная логика: Гос.имущество / Банкроты / Банки / Суды)
    const debtorLabel = document.getElementById('uiDebtorLabel');
    const chsiLabel = document.getElementById('uiChsiLabel');
    
    if (debtorLabel && chsiLabel) {
        const dNameLower = dName.toLowerCase();
        const chsiNameLower = chsiName.toLowerCase();

        // ИЗМЕНЕНО (TASK7 7.7): className переписывался безусловно (raw hex
        // text-[#94a3b8] + text-purple-400/orange-400/green-400 по типу
        // должника) — видимо на сайте даже после 7.2 (та правка сняла только
        // uppercase, не цвет). IS_TELEGRAM — старые классы байт-в-байт; сайт —
        // всегда .text-caption.text-secondary, без цветовой классификации
        // (категория должника — не статус-семантика вроде прибыли/риска).
        if (REPORT_LEGACY_MARKUP) {
            debtorLabel.className = 'text-[9px] uppercase mb-1 font-bold text-[#94a3b8]';
            chsiLabel.className = 'text-[9px] uppercase mb-1 font-bold text-[#94a3b8]';

            if (dNameLower.includes('государств') || dNameLower.includes('балансодержатель') ||
                chsiNameLower.includes('спк ') || chsiNameLower.includes('акимат')) {
                debtorLabel.innerText = 'Собственник';
                debtorLabel.classList.replace('text-[#94a3b8]', 'text-purple-400');
                chsiLabel.innerText = 'Организатор торгов';
            } else if (chsiNameLower.includes('банкрот') || chsiNameLower.includes('управляющий') || chsiNameLower.includes('реализацион')) {
                debtorLabel.innerText = 'Банкрот (Должник)';
                chsiLabel.innerText = 'Банкротный управляющий';
                chsiLabel.classList.replace('text-[#94a3b8]', 'text-orange-400');
            } else if (chsiNameLower.includes('банк') || chsiNameLower.includes('bank') || chsiNameLower.includes('коллектор')) {
                debtorLabel.innerText = 'Залогодатель';
                chsiLabel.innerText = 'Кредитор / Банк';
                chsiLabel.classList.replace('text-[#94a3b8]', 'text-green-400');
            } else {
                debtorLabel.innerText = 'Должник';
                chsiLabel.innerText = 'Организатор (ЧСИ)';
            }
        } else {
            debtorLabel.className = 'text-caption text-secondary';
            chsiLabel.className = 'text-caption text-secondary';

            if (dNameLower.includes('государств') || dNameLower.includes('балансодержатель') ||
                chsiNameLower.includes('спк ') || chsiNameLower.includes('акимат')) {
                debtorLabel.innerText = 'Собственник';
                chsiLabel.innerText = 'Организатор торгов';
            } else if (chsiNameLower.includes('банкрот') || chsiNameLower.includes('управляющий') || chsiNameLower.includes('реализацион')) {
                debtorLabel.innerText = 'Банкрот (Должник)';
                chsiLabel.innerText = 'Банкротный управляющий';
            } else if (chsiNameLower.includes('банк') || chsiNameLower.includes('bank') || chsiNameLower.includes('коллектор')) {
                debtorLabel.innerText = 'Залогодатель';
                chsiLabel.innerText = 'Кредитор / Банк';
            } else {
                debtorLabel.innerText = 'Должник';
                chsiLabel.innerText = 'Организатор (ЧСИ)';
            }
        }
    }

    // 🔥 12. Отрисовка Score
    const score = report.investment_score || 0;
    const scoreRing = document.getElementById('uiScoreRing');

    // Цветовая логика (green/yellow/red по порогу) НЕ меняется — трогаем
    // только то, как цифра и само кольцо появляются на экране (Phase 4).
    if (score >= 70) {
        scoreRing.className = "w-14 h-14 rounded-full flex items-center justify-center font-bold text-xl font-mono-nums border-4 border-green-500 text-green-400 bg-green-500/10 shrink-0";
    } else if (score >= 40) {
        scoreRing.className = "w-14 h-14 rounded-full flex items-center justify-center font-bold text-xl font-mono-nums border-4 border-yellow-500 text-yellow-400 bg-yellow-500/10 shrink-0";
    } else {
        scoreRing.className = "w-14 h-14 rounded-full flex items-center justify-center font-bold text-xl font-mono-nums border-4 border-red-500 text-red-400 bg-red-500/10 shrink-0";
    }

    // Counter-up 0 → score (600-800ms) вместо мгновенной установки текста.
    animateCountUp(scoreRing, score, { duration: 0.7, ease: 'power2.out' });

    // Кольцо — обычный div с CSS border (не SVG), поэтому здесь достаточно
    // scale/opacity entrance, без stroke-dashoffset (это была бы избыточная
    // переработка разметки, которой сейчас нет).
    if (!REDUCE_MOTION && HAS_GSAP()) {
        try {
            gsap.from(scoreRing, { scale: 0.8, opacity: 0, duration: 0.5, ease: 'back.out(1.4)' });
        } catch (e) { /* ring остаётся видимым в финальном состоянии, ничего не ломается */ }
    }

    // 🔥 12.1 Отрисовка честной Точности (Confidence Level) с цветами
    const conf = report.confidence_level || 'Высокая';
    let confColor = 'bg-blue-500/80 text-white'; // По умолчанию
    if (conf === 'Средняя') confColor = 'bg-yellow-500/80 text-yellow-900';
    if (conf === 'Низкая') confColor = 'bg-red-500/80 text-white';
    
    const uiConf = document.getElementById('uiConfidence');
    if (uiConf) {
        uiConf.className = `text-[9px] px-1.5 py-0.5 rounded ${confColor} font-bold backdrop-blur-md shadow-sm`;
        uiConf.innerText = `Точность: ${conf}`;
    }

    // 🔥 12.1b Бейджи достоверности данных (рынок/юр. данные) + дата генерации отчёта
    const relBadges = document.getElementById('uiReliabilityBadges');
    if (relBadges) {
        let relHtml = '';
        const dr = report.data_reliability;
        if (dr) {
            if (dr.market_data_source === 'live') {
                relHtml += `<span class="text-[8px] px-1.5 py-0.5 rounded bg-green-500/20 text-green-300 border border-green-500/30 font-bold" title="Рыночные цены получены с живых объявлений">${emo('📡 ')}Рынок: live</span>`;
            } else if (dr.market_data_source === 'estimated') {
                relHtml += `<span class="text-[8px] px-1.5 py-0.5 rounded bg-yellow-500/20 text-yellow-300 border border-yellow-500/30 font-bold" title="Рыночные цены — оценка AI, без живых объявлений">${emo('🧠 ')}Рынок: оценка</span>`;
            }
            if (dr.legal_data_source === 'documents') {
                relHtml += `<span class="text-[8px] px-1.5 py-0.5 rounded bg-blue-500/20 text-blue-300 border border-blue-500/30 font-bold" title="Юр. анализ на основе загруженных документов">${emo('📄 ')}Юр: документы</span>`;
            } else if (dr.legal_data_source === 'no_documents') {
                relHtml += `<span class="text-[8px] px-1.5 py-0.5 rounded bg-red-500/20 text-red-300 border border-red-500/30 font-bold" title="Документы по лоту не были загружены/проанализированы">${emo('⚠️ ')}Юр: без документов</span>`;
            }
        }
        relBadges.innerHTML = relHtml;
    }
    const genDateEl = document.getElementById('uiGenDate');
    if (genDateEl) {
        const genDate = fmtDateTime(report.analysis_generated_at);
        genDateEl.innerText = genDate ? `Отчёт сформирован: ${genDate}` : '';
    }

    // 🔥 12.1c Разбивка оценки (score_breakdown)
    const scoreBreakdownBlock = document.getElementById('uiScoreBreakdownBlock');
    const scoreBreakdownList = document.getElementById('uiScoreBreakdownList');
    if (scoreBreakdownBlock && scoreBreakdownList) {
        const sb = report.score_breakdown;
        if (sb) {
            // Раньше полосы показывали только число (60/100) без единого слова о
            // том, что конкретно его так снизило — приходилось листать весь отчёт
            // в поисках причины. *_score_reason (ai/schemas.py::ScoreBreakdown)
            // теперь несёт одно предложение с конкретикой на каждую под-оценку;
            // reason выводится прямо под полосой, без клика/скролла.
            //
            // 🔥 ИСПРАВЛЕНО (аудит "цвет полос назначается по номеру строки, а не
            // по значению", 05.09.2026): раньше color был фиксирован ЗА КАЖДЫМ
            // label'ом (Финансы всегда синий, Юр.чистота всегда фиолетовый,
            // Ликвидность всегда индиго, Позиция на рынке всегда зелёный) —
            // независимо от самого value. На живом отчёте это давало 45/100
            // (плохо) зелёным и 95/100 (отлично) — нейтральным индиго: худшая
            // метрика лота красилась в цвет "всё хорошо". scoreBarColor() ниже
            // берёт цвет из ЗНАЧЕНИЯ, по тем же порогам (≥70/≥40/иначе), что и
            // кольцо оценки (scoreColor выше по файлу) и бар в "Базе AI"
            // (.score-good/.score-mid/.score-bad в dashboard.css) — та же
            // палитра #4ade80/#E8B84B/#f87171, просто как inline-класс, а не
            // scoped-под-таблицу CSS (этот блок рендерится и в Telegram, не
            // только в браузере).
            // TASK21 21.5 (owner review, item 3): market_position_score is
            // a stored int (ai/analyzer.py::_apply_verdict_engine's own
            // fallback to the LLM's raw guess whenever the engine's own
            // component is None, which it always is for a lease lot) --
            // it plays NO part in investment_score for a lease report
            // (finance/verdict.py::_decide_lease's own re-weighting drops
            // it entirely, see that function's own docstring), so showing
            // a number here claimed a precision the total score never
            // had. "—" (null, same as a report with no breakdown at all)
            // for this one row only, in both lease modes.
            const m = report.financial_model;
            const isLeaseReport = !!(m && (m.mode === 'lease' || m.mode === 'lease_unsupported'));
            const rows = [
                { label: 'Финансы', value: sb.financial_score, reason: sb.financial_score_reason },
                { label: 'Юридическая чистота', value: sb.legal_score, reason: sb.legal_score_reason },
                { label: 'Ликвидность', value: sb.liquidity_score, reason: sb.liquidity_score_reason },
                { label: 'Позиция на рынке', value: isLeaseReport ? null : sb.market_position_score, reason: sb.market_position_score_reason }
            ].map(row => ({ ...row, color: scoreBarColor(row.value) }));
            // ИЗМЕНЕНО (TASK7 7.7): scoreBarColor() (общая, не трогаю — см. её
            // же комментарий) отдаёт raw hex bg-[#4ade80]/bg-[#E8B84B]/
            // bg-[#f87171] — видимо на сайте даже после 7.2/7.4 (та правка
            // сняла uppercase с лейбла, не заливку бара и не text-[#94a3b8]
            // у reason). IS_TELEGRAM — старая строка байт-в-байт; сайт —
            // токен-классы .score-bar-fill.score-good/mid/bad (dashboard.css,
            // html.is-browser) + .text-caption.text-secondary/tertiary; балл
            // без «/100» — тот же принцип, что TL;DR (fmtScore() не трогаю,
            // просто не использую).
            const scoreToneClass = (v) => v == null ? '' : v >= 70 ? 'score-good' : v >= 40 ? 'score-mid' : 'score-bad';
            scoreBreakdownList.innerHTML = rows.map(row => REPORT_LEGACY_MARKUP ? `
                <div>
                    <div class="flex justify-between text-[10px] mb-1">
                        <span class="text-gray-400 font-bold uppercase tracking-wide">${row.label}</span>
                        <span class="text-white font-bold font-mono-nums">${fmtScore(row.value)}</span>
                    </div>
                    <div class="h-1.5 rounded-full bg-white/5 overflow-hidden">
                        <div class="h-full rounded-full score-bar-fill ${row.color}" style="width:0%" data-target="${row.value || 0}"></div>
                    </div>
                    ${row.reason ? `<div class="mt-1 text-[10px] text-[#94a3b8] leading-snug">${row.reason}</div>` : ''}
                </div>
            ` : `
                <div>
                    <div class="flex justify-between text-caption text-secondary" style="margin-bottom:4px;">
                        <span>${row.label}</span>
                        <span class="font-mono-nums text-primary">${typeof row.value === 'number' ? row.value : '—'}</span>
                    </div>
                    <div class="h-1.5 rounded-full bg-raised overflow-hidden">
                        <div class="h-full rounded-full score-bar-fill ${scoreToneClass(row.value)}" style="width:0%" data-target="${row.value || 0}"></div>
                    </div>
                    ${row.reason ? `<div class="text-caption text-tertiary" style="margin-top:4px;">${row.reason}</div>` : ''}
                </div>
            `).join('');
            scoreBreakdownBlock.classList.remove('hidden');
            // Плавно заполняем полосы после вставки в DOM (как и рыночные бары ниже) —
            // раньше ширина проставлялась сразу инлайн-стилем без анимации.
            requestAnimationFrame(() => {
                scoreBreakdownList.querySelectorAll('.score-bar-fill').forEach(el => {
                    el.style.width = (el.dataset.target || 0) + '%';
                });
            });
        } else {
            scoreBreakdownBlock.classList.add('hidden');
        }
    }

    // 🔥 12.1d Репутация организатора (ЧСИ) — история переторжек по прошлым лотам этого организатора
    const orgRepEl = document.getElementById('uiOrgReputation');
    if (orgRepEl) {
        const or = report.organizer_reputation;
        if (or && or.total_lots_seen) {
            const rate = or.reopened_rate_percent || 0;
            const rateColor = rate >= 30 ? 'text-red-400' : (rate >= 15 ? 'text-yellow-400' : 'text-green-400');
            orgRepEl.innerHTML = `<span class="${rateColor} font-bold">Переторжки: ${or.reopened_lots}/${or.total_lots_seen} (${rate}%)</span>`;
            orgRepEl.classList.remove('hidden');
        } else {
            orgRepEl.classList.add('hidden');
        }
    }

    // 🔥 12.2 Отрисовка скрытых AI-атрибутов (VIN, Кадастр, Площадь и т.д.)
    const attrContainer = document.getElementById('uiAiAttributes');
    if (attrContainer) {
        attrContainer.innerHTML = '';
        if (report.attributes) {
            const attr = report.attributes;
            let tagsHtml = '';
            
            if (attr.is_car) {
                if (attr.vin) tagsHtml += `<span class="bg-blue-500/20 text-blue-300 px-2 py-1 rounded text-[10px] font-mono border border-blue-500/30 backdrop-blur-md shadow-sm">VIN: ${attr.vin}</span>`;
                if (attr.year) tagsHtml += `<span class="bg-white/10 px-2 py-1 rounded text-[10px] text-gray-300 border border-white/5 backdrop-blur-md">Год: ${attr.year}</span>`;
                if (attr.engine_volume) tagsHtml += `<span class="bg-white/10 px-2 py-1 rounded text-[10px] text-gray-300 border border-white/5 backdrop-blur-md">Объем: ${attr.engine_volume}</span>`;
                if (attr.mileage_km) {
                    const title = attr.mileage_source_doc ? ` title="Источник: ${attr.mileage_source_doc}"` : '';
                    tagsHtml += `<span class="bg-white/10 px-2 py-1 rounded text-[10px] text-gray-300 border border-white/5 backdrop-blur-md"${title}>Пробег: ${formatNumber(Number(attr.mileage_km))} км</span>`;
                }
            } else {
                if (attr.cadastral_number) tagsHtml += `<span class="bg-purple-500/20 text-purple-300 px-2 py-1 rounded text-[10px] font-mono border border-purple-500/30 backdrop-blur-md shadow-sm">Кадастр: ${attr.cadastral_number}</span>`;
                // 2026-10-27 (report 4484): the model read «0,2500 га» as «25 м²»; a land lot's area is the cadastre's (NIPD contour, then the
                // registry), the model's figure only when the lot has neither -- the same sources «Участок и градостроительство» shows
                const areaText = classicLandAreaText(report) || (attr.area_total ? `${attr.area_total} м²` : '');
                if (areaText) tagsHtml += `<span class="bg-white/10 px-2 py-1 rounded text-[10px] text-gray-300 border border-white/5 backdrop-blur-md">Площадь: ${areaText}</span>`;
                if (attr.build_year) tagsHtml += `<span class="bg-white/10 px-2 py-1 rounded text-[10px] text-gray-300 border border-white/5 backdrop-blur-md">Год постройки: ${attr.build_year}</span>`;
            }
            attrContainer.innerHTML = tagsHtml;
        }

        // Пробег — тот же стандарт доказательности, что у рисков/SWOT: источник
        // показывается подписью под тегами, а расхождение между документами лота
        // (mileage_note) — явным предупреждением, а не тихо скрывается. Это то,
        // что позволило поймать реальный кейс: на одном прогоне анализ показал
        // 354 689 км, на другом — 216 000 км, хотя вторая цифра не подтверждалась
        // ни одним документом лота.
        const mileageSourceEl = document.getElementById('uiMileageSource');
        const mileageConflictEl = document.getElementById('uiMileageConflict');
        const attrForMileage = report.attributes;
        if (mileageSourceEl) {
            if (attrForMileage && attrForMileage.mileage_km && attrForMileage.mileage_source_doc) {
                mileageSourceEl.textContent = `Пробег по документу: ${attrForMileage.mileage_source_doc}`;
                mileageSourceEl.classList.remove('hidden');
            } else {
                mileageSourceEl.classList.add('hidden');
            }
        }
        if (mileageConflictEl) {
            if (attrForMileage && attrForMileage.mileage_note) {
                mileageConflictEl.innerHTML = `<i class="ph-fill ph-warning-circle"></i> ${attrForMileage.mileage_note}`;
                mileageConflictEl.classList.remove('hidden');
            } else {
                mileageConflictEl.classList.add('hidden');
            }
        }
    }

    // 🔥 13. ИСПРАВЛЕННЫЕ Конкуренты и Анализ Рынка
    if (report.market_stats) {
        document.getElementById('uiMarketText').innerText = report.market_stats.distribution_text || 'Распределение цен на рынке.';

        // ИЗМЕНЕНО (TASK7 7.4, §5): было 3 цветных сегмента (зелёный/жёлтый/
        // красный) по трём независимым процентам распределения цен — сайт
        // получает ОДИН нейтральный бар с теми же тремя сегментами (разные
        // оттенки --bg-raised/--border-subtle/--text-tertiary, тот же приём,
        // что уже в блоке "Заморозка капитала", 7.3) плюс маркер целевой
        // цены (--accent) на позиции между пессимистичной и оптимистичной
        // рыночной оценкой (financials.market_prices — те же поля, что и у
        // графика чуть выше; target_purchase_price — тот же фолбэк, что в
        // updateTldrStrip()/блоке финансов, локальные переменные того блока
        // здесь недоступны по области видимости). IS_TELEGRAM — старые 3
        // цветных сегмента байт-в-байт.
        setTimeout(() => {
            document.getElementById('uiBarLow').style.width = (report.market_stats.low_price_percent || 33) + '%';
            document.getElementById('uiBarMid').style.width = (report.market_stats.mid_price_percent || 34) + '%';
            document.getElementById('uiBarHigh').style.width = (report.market_stats.high_price_percent || 33) + '%';

            if (!REPORT_LEGACY_MARKUP) {
                const markerEl = document.getElementById('uiMarketMarker');
                const startMarkerEl = document.getElementById('uiMarketMarkerStart');
                const captionsEl = document.getElementById('uiMarketMarkerCaptions');
                const mp = report.financials && report.financials.market_prices;
                if (markerEl && mp && mp.pessimistic_price && mp.optimistic_price && mp.optimistic_price > mp.pessimistic_price) {
                    const range = mp.optimistic_price - mp.pessimistic_price;
                    // TASK15 15.4b item 4: entry price from the engine
                    // (financial_model.purchase.price) when it ran; the old
                    // target_purchase_price fallback chain stays for the
                    // legacy/off path.
                    const fm = report.financial_model;
                    let entryPrice = (fm && fm.purchase && typeof fm.purchase.price === 'number') ? fm.purchase.price : undefined;
                    if (entryPrice === undefined) {
                        const fin2 = report.financials;
                        let tp = fin2.target_purchase_price;
                        if (tp === undefined) {
                            const repair = fin2.estimated_repair_cost || 0;
                            const taxes = fin2.taxes_and_fees !== undefined ? fin2.taxes_and_fees : (fin2.additional_costs || 0);
                            tp = (fin2.total_investment || 0) - repair - taxes;
                            if (tp < 0) tp = fin2.start_price || 0;
                        }
                        entryPrice = tp;
                    }
                    const pctFor = (price) => ((price - mp.pessimistic_price) / range) * 100;
                    const entryPctRaw = pctFor(entryPrice);
                    const entryPct = Math.max(0, Math.min(100, entryPctRaw));
                    markerEl.style.left = `${entryPct}%`;
                    markerEl.classList.remove('hidden');

                    // Below the bar's low end -> pinned to the left edge with
                    // an explicit "ниже рынка на N %" label instead of a
                    // silently clamped marker that would otherwise look like
                    // the entry price sits AT the market low.
                    const belowMarket = entryPctRaw < 0;
                    const startPrice = state.currentLot && state.currentLot.start_price;
                    // TASK15 15.4c item 6: entry price === start price on 22
                    // of 62 live lots (strategy resolves to buying at the
                    // opening price) -- two markers at the identical % used
                    // to get two separate, always-adjacent-or-overlapping
                    // captions; one merged caption instead.
                    const mergeStartIntoEntry = typeof startPrice === 'number' && startPrice > 0 && entryPrice === startPrice;
                    const captions = [];
                    if (mergeStartIntoEntry) {
                        captions.push({ pct: entryPct, text: `▲ вход = старт ${reportPriceFormatter(entryPrice)}` });
                    } else {
                        // A below-market entry keeps its price -- the old
                        // version replaced "▲ вход {price}" outright with a
                        // bare "ниже рынка на N %", losing the number.
                        const belowSuffix = belowMarket ? ` · ниже рынка на ${Math.round((1 - entryPrice / mp.pessimistic_price) * 100)} %` : '';
                        captions.push({ pct: entryPct, text: `▲ вход ${reportPriceFormatter(entryPrice)}${belowSuffix}` });
                    }

                    if (startMarkerEl && typeof startPrice === 'number' && startPrice > 0) {
                        const startPctRaw = pctFor(startPrice);
                        const startPct = Math.max(0, Math.min(100, startPctRaw));
                        startMarkerEl.style.left = `${startPct}%`;
                        startMarkerEl.classList.remove('hidden');
                        if (!mergeStartIntoEntry) captions.push({ pct: startPct, text: `▲ старт ${reportPriceFormatter(startPrice)}` });
                    } else if (startMarkerEl) {
                        startMarkerEl.classList.add('hidden');
                    }

                    if (captionsEl) {
                        // Anchor: a caption whose CENTER sits within ~10% of
                        // either end still overflows the container once its
                        // own text width is added -- found live on a land
                        // lot whose start price (106,4 млн) is wide text near
                        // the bar's right end. left-anchor near 0%,
                        // right-anchor near 100%, center otherwise.
                        const anchorFor = (pct) => (pct <= 10 ? 'start' : pct >= 90 ? 'end' : 'middle');
                        captionsEl.innerHTML = captions.map((c) => {
                            const anchor = anchorFor(c.pct);
                            const transform = anchor === 'start' ? 'none' : anchor === 'end' ? 'translateX(-100%)' : 'translateX(-50%)';
                            return `<span style="left:${c.pct}%;top:0;transform:${transform}">${c.text}</span>`;
                        }).join('');
                        captionsEl.classList.remove('hidden');

                        // TASK15 15.4c item 6: stacking used to fire ONLY on
                        // an exactly equal %, which missed captions that are
                        // close but not equal (found live on 4 of 62 lots,
                        // e.g. 113466822: 0% / 6.3%) -- measure the actual
                        // rendered boxes and stack onto a second line when
                        // they sit closer than 8px apart, regardless of %.
                        const spans = [...captionsEl.querySelectorAll('span')];
                        let anyStacked = false;
                        if (spans.length > 1) {
                            const sorted = [...spans].sort((a, b) => a.getBoundingClientRect().left - b.getBoundingClientRect().left);
                            let prevRect = sorted[0].getBoundingClientRect();
                            for (let i = 1; i < sorted.length; i++) {
                                const rect = sorted[i].getBoundingClientRect();
                                if (rect.left - prevRect.right < 8) {
                                    sorted[i].style.top = '16px';
                                    anyStacked = true;
                                } else {
                                    prevRect = rect;
                                }
                            }
                        }
                        captionsEl.style.height = anyStacked ? '32px' : '14px';
                    }
                } else {
                    if (markerEl) markerEl.classList.add('hidden');
                    if (startMarkerEl) startMarkerEl.classList.add('hidden');
                    if (captionsEl) { captionsEl.classList.add('hidden'); captionsEl.innerHTML = ''; }
                }
            }
        }, 100);
    }

    const compContainer = document.getElementById('uiCompetitorsList');
    compContainer.innerHTML = '';
    compContainer.classList.toggle('report-comparables-grid', !REPORT_LEGACY_MARKUP);
    const compPlaceholder = getPlaceholderFor(state.currentLot && state.currentLot.category);

    if (report.competitors && report.competitors.length > 0) {
        report.competitors.forEach(comp => {
            // Исправлено: берем short_desc и condition_highlight вместо устаревших title и link
            const compDesc = comp.short_desc || 'Объявление с рынка';
            // ИЗМЕНЕНО (TASK7 7.4, §5, "40px строки: описание · подпись
            // состояния · цена моно"): IS_TELEGRAM — старая карточка байт-в-
            // байт, сайт — 40px строка, без uppercase/raw hex.
            if (REPORT_LEGACY_MARKUP) {
                const compTitleHtml = comp.url
                    ? `<a href="${comp.url}" target="_blank" rel="noopener noreferrer" class="text-xs text-indigo-400 font-medium hover:underline flex items-center gap-1">${compDesc} <i class="ph-bold ph-arrow-square-out text-[10px]"></i></a>`
                    : `<span class="text-xs text-indigo-400 font-medium">${compDesc}</span>`;
                compContainer.innerHTML += `
                    <div class="flex justify-between items-center p-3 bg-[#0f172a] hover:bg-white/10 rounded-xl border border-white/5 transition-colors group">
                        <div class="flex flex-col overflow-hidden pr-3">
                            ${compTitleHtml}
                            <span class="text-[9px] text-[#94a3b8] uppercase mt-0.5">${comp.condition_highlight || 'Аналог'}</span>
                        </div>
                        <span class="text-xs font-bold text-white whitespace-nowrap bg-white/5 px-2 py-1 rounded-lg border border-white/5">${formatMoney(comp.price)}</span>
                    </div>
                `;
            } else {
                // TASK15 15.4: comparables as cards. No photo field exists on
                // MarketSnippet (ai/schemas.py) -- a real per-listing photo
                // would have to be invented, so the card uses the lot's own
                // category placeholder (§8.4's established convention for
                // "no photo"), not a fabricated image.
                const compTitleHtml = comp.url
                    ? `<a href="${comp.url}" target="_blank" rel="noopener noreferrer" class="text-body text-primary report-competitor-link">${compDesc} <i class="ph-bold ph-arrow-square-out"></i></a>`
                    : `<span class="text-body text-primary">${compDesc}</span>`;
                compContainer.innerHTML += `
                    <div class="report-comparable-card">
                        <img src="${compPlaceholder}" alt="" class="report-comparable-card-img">
                        <div class="report-comparable-card-body">
                            ${compTitleHtml}
                            <span class="text-caption text-tertiary">${comp.condition_highlight || 'Аналог'}</span>
                            <span class="text-body font-mono-nums text-primary">${formatMoney(comp.price)}</span>
                        </div>
                    </div>
                `;
            }
        });
    } else {
        compContainer.innerHTML = REPORT_LEGACY_MARKUP
            ? '<div class="text-xs text-[#94a3b8] bg-white/5 p-3 rounded-xl text-center border border-white/5">Прямые аналоги не найдены</div>'
            : '<p class="text-caption text-tertiary">Прямые аналоги не найдены</p>';
    }

    // TASK15 15.4: section-header count chip, same pattern as the doc/legal
    // reliability chips (15.1) and the verdict/strategy meta (15.2).
    // TASK18 18.2: when the engine ran and produced a market_confidence
    // (report.verdict_engine present -- FINANCE_ENGINE was on for this
    // analysis), the chip states WHERE the market range actually came
    // from: a real structured Kolesa/Krisha sample ("data") or the LLM's
    // own estimate ("llm") -- same "по N аналогам" dative-plural phrasing
    // finance/verdict.py's own 16.8 cap reason already uses, kept fixed
    // regardless of N to match that existing precedent, not per-N
    // declined. Reports with no verdict_engine at all (engine was off,
    // or predate 16.5) keep the original plain analog-count chip -- there
    // is no confidence signal to report for those.
    const marketMetaEl = document.getElementById('uiMarketMeta');
    if (marketMetaEl) {
        const marketConfidence = report.verdict_engine && report.verdict_engine.market_confidence;
        if (marketConfidence === 'data' && report.market_sample && report.market_sample.n) {
            const sourceLabel = report.market_sample.source === 'kolesa' ? 'Kolesa'
                : report.market_sample.source === 'krisha' ? 'Krisha' : '';
            // TASK20 20.1: market_sample.widening -- the progressive-widening
            // steps actually applied to reach a usable sample (e.g. "год ±2",
            // "без фильтра пробега"), in order; empty/absent for a lot whose
            // strict search already had n >= 5. Shown in parentheses so the
            // header stays honest about what the N listings are actually
            // comparable to.
            const widening = report.market_sample.widening;
            const wideningLabel = widening && widening.length ? ` (${widening.join(', ')})` : '';
            marketMetaEl.textContent = `по ${report.market_sample.n} объявлениям${sourceLabel ? ' ' + sourceLabel : ''}${wideningLabel}`;
        } else if (marketConfidence) {
            marketMetaEl.textContent = 'оценка ИИ';
        } else {
            const n = (report.competitors || []).length;
            marketMetaEl.textContent = n ? `${n} ${pluralizeRu(n, 'аналог', 'аналога', 'аналогов')}` : '';
        }
    }
}

// ДОБАВЛЕНО (TASK7 «Отчёт», D-03): крошечный гейт эмодзи внутри ОБЩИХ
// рендереров (renderInAppReport и т.п.) — Mini App держит эмодзи как было
// (emo(s) на IS_TELEGRAM отдаёт s без изменений, байт-в-байт), сайт получает
// пустую строку вместо иконки-эмодзи. Не переименовывать/не убирать —
// единственная причина, по которой правка "никаких эмодзи в отчёте" не
// разъезжается с Mini App.
function emo(s) { return REPORT_LEGACY_MARKUP ? s : ''; }

// ДОБАВЛЕНО (TASK7 «Отчёт», §III.3 конституции, "Документ с оглавлением").
// Вызывается из loadAnalysisScreen() СРАЗУ после renderInAppReport(report)
// под !IS_TELEGRAM — те же report/state.currentLot, но HE переиспользует
// узлы, которые сайт скрывает (uiGenDate/uiConfidence/uiReliabilityBadges/
// uiScoreRing/uiAnalisysTitle/uiAnalisysPrice), а строит собственные
// site-only заголовок/подпись/оглавление напрямую из report — тот же приём,
// что #lotLegacyHidden на странице лота (Задача 6): значения re-derive, а
// не читаются из уже написанных общих узлов.
const REPORT_TOC_SECTIONS = [
    { id: 'sec-verdict', label: 'Вердикт' },
    { id: 'uiScoreBreakdownBlock', label: 'Разбивка оценки' },
    { id: 'sec-financials', label: 'Финансовая модель' },
    { id: 'uiScenariosBlock', label: 'Сценарии' },
    { id: 'sec-risks', label: 'Риски' },
    { id: 'uiHistoryBlock', label: 'История торгов' },
    { id: 'sec-market', label: 'Рынок и аналоги' },
    { id: 'sec-geo', label: 'Участок' },
    { id: 'sec-swot', label: 'SWOT' },
    { id: 'sec-defects', label: 'Дефекты и фото' },
    { id: 'sec-docs', label: 'Документы' },
    { id: 'sec-legal', label: 'Юридический статус' },
    { id: 'sec-participants', label: 'Участники' },
    { id: 'sec-strategy', label: 'Стратегия торгов' },
];
// TASK15 15.5: per-TOC-entry count ("Риски 3", "Документы 4") -- only for
// sections with an actual countable list, read from the DOM already
// rendered above (never invented/recomputed separately). Sections with no
// natural single count (Вердикт, Финансовая модель, SWOT's 4-way split,
// Юридический статус's mixed rows, Участники, Стратегия) get none.
const TOC_COUNT_GETTERS = {
    'sec-risks': () => document.querySelectorAll('#uiRisksContainer > .report-risk-row').length,
    'uiHistoryBlock': () => document.querySelectorAll('#uiHistoricalSales > .report-history-row:not(.report-history-head)').length,
    // self-found: '> *' also counted the "Прямые аналоги не найдены"
    // empty-state <p> as if it were 1 comparable -- only real cards.
    'sec-market': () => document.querySelectorAll('#uiCompetitorsList > .report-comparable-card').length,
    'sec-defects': () => document.querySelectorAll('#uiVisualDefectsList > li').length,
    // self-found: '> *' also counted the "— {type}: не найден" missing-
    // expected-document row as if it were an uploaded file -- exclude it,
    // it represents an ABSENCE, not a document.
    'sec-docs': () => document.querySelectorAll('#uiDocChecklist > .report-doc-item:not(.report-doc-item--missing)').length,
};
let reportTocObserver = null;

// TASK15 15.1 (DESIGN_MASTER_PROMPT.md §III.3/§7.4): shared report
// components -- 15.2/15.3/15.4 build each section's content with these,
// so every quote/status/warning in the report reads the same way. Site
// only (never called under IS_TELEGRAM); Mini App keeps its existing
// .expert-block/report-quote markup untouched.

// TASK15 15.4 (found while chasing regression-check's emoji fail): some
// evidence_quote values verbatim-quote backend prompt-context text that
// carries emoji markers meant for the LLM's own reading (ai/analyzer.py's
// historical_context builder, e.g. "📉 Падение: 42%") -- a backend/prompt
// concern, out of scope for a frontend design task, but "no emoji on
// site" (§8.2) is an absolute UI rule regardless of what upstream text
// contains, so it's stripped here rather than left to leak through a
// verbatim quote.
const EMOJI_RE = /[\u{1F300}-\u{1FAFF}\u{2600}-\u{27BF}]/gu;
function stripEmojiSite(s) {
    return REPORT_LEGACY_MARKUP ? s : String(s == null ? '' : s).replace(EMOJI_RE, '').replace(/ {2,}/g, ' ').trim();
}

// Evidence — quote + source, one shape everywhere (documents, photos,
// external sources). `source` = {label, url} | null; url absent -> plain
// text, no link/icon (§2's own rule: "when there is no link the source
// is plain text" -- never a fabricated link).
function reportEvidenceHTML(quote, source) {
    if (!quote) return '';
    const quoteHtml = `<p class="text-body report-evidence-quote">${escapeHtml(stripEmojiSite(quote))}</p>`;
    if (!source || !source.label) return `<div class="report-evidence">${quoteHtml}</div>`;
    const sourceHtml = source.url
        ? `<a href="${escapeHtml(source.url)}" target="_blank" rel="noopener" class="report-evidence-link"><span>${escapeHtml(source.label)}</span><i class="ph-bold ph-arrow-square-out"></i></a>`
        : `<span>${escapeHtml(source.label)}</span>`;
    return `<div class="report-evidence">${quoteHtml}<div class="text-caption text-tertiary report-evidence-source">${sourceHtml}</div></div>`;
}

// Status chip (§7.4): critical/high/medium/low/ok/unknown -- colour on
// the text only for critical/ok, everything else stays neutral (a
// "medium" severity is a fact, not a warning colour).
const REPORT_STATUS_CHIP_LABEL = {
    critical: 'критично', high: 'высокий', medium: 'умеренно',
    low: 'низкий', ok: 'в порядке', unknown: 'не ясно',
};
function reportStatusChipHTML(level) {
    const label = REPORT_STATUS_CHIP_LABEL[level];
    if (!label) return '';
    const cls = (level === 'critical' || level === 'ok') ? ` status-chip--${level}` : '';
    return `<span class="status-chip${cls}">${label}</span>`;
}

// Callout — a contradiction/warning surfaced INSIDE a section (never a
// coloured panel fill, §7.7 -- neutral panel + a warning-coloured rail).
function reportCalloutHTML(text) {
    if (!text) return '';
    return `<div class="report-callout"><i class="ph-fill ph-warning"></i><span class="text-caption report-callout-text">${escapeHtml(text)}</span></div>`;
}

// TASK15 15.3: article/law references already present in the text --
// "статья 74", "ст. 37 ГК РК" -- rendered as chips. Same regex as
// highlightFacts()'s cite-law branch; extracted (not just inline-
// highlighted) only for the "Правовые основания" block, and only ever
// from substrings the model actually wrote -- an empty result (both
// 113466233 and 113438789 say "точной нормы не нашлось") means no chip,
// never a placeholder.
const CITE_LAW_RE = /ст(?:атья|\.)?\s?№?\s?\d+[а-я0-9\-]*(?:\s(?:ГК\s?РК|Закона\s?РК))?/gi;
function extractCitationChips(text) {
    if (!text) return '';
    const seen = new Set();
    const chips = [];
    for (const m of text.matchAll(CITE_LAW_RE)) {
        const v = m[0].trim();
        const key = v.toLowerCase();
        if (!seen.has(key)) { seen.add(key); chips.push(v); }
    }
    if (!chips.length) return '';
    return `<div class="report-citation-chips">${chips.map((v) => `<span class="status-chip">${escapeHtml(v)}</span>`).join('')}</div>`;
}

// The model is explicitly instructed (ai/schemas.py's field description)
// to write exactly this phrasing when "Противоречия и нестыковки" found
// nothing -- reusing the model's own established convention instead of
// guessing at natural-language sentiment.
const CONTRADICTION_CLEAN_RE = /не\s+выявлен|не\s+обнаружен|не\s+найден|отсутствуют?\s+расхожд/i;

// TASK15 15.4b item 2: splits `body` into sentences for the "Риски и
// рекомендации" checklist -- period/!/? followed by whitespace + a
// capital letter (Cyrillic or Latin), which abbreviations like "п.41"
// don't produce (no capital right after). "Unreliable" per the brief
// ("never fabricate items") means: fewer than 2 sentences, or any
// fragment implausibly short (an abbreviation artifact, not a real
// sentence) -- caller falls back to one paragraph in either case.
function splitSentencesSite(text) {
    if (!text) return null;
    const parts = (text.match(/[^.!?]+[.!?]+(?=\s+[А-ЯЁA-Z]|\s*$)/g) || []).map((s) => s.trim()).filter(Boolean);
    if (parts.length < 2 || parts.some((s) => s.length < 8)) return null;
    return parts;
}

// Renders document_analysis_reasoning/legal_analysis_reasoning as label
// rows (§III.3/§7) instead of the old boxed "expert report" card +
// h4-subsection list -- replaces renderExpertSection() on site (TASK15
// 15.3). The "Правовые основания" row gets citation chips
// (extractCitationChips); a "Противоречия и нестыковки" row whose body
// doesn't use the model's own "не выявлено" clean phrasing is surfaced as
// a callout instead of a plain row -- everything else stays a plain row.
// `opts.skipLabelRe` drops matching blocks entirely (TASK15 15.4b item 2:
// legal's "Юридический статус"/"Обременения и аресты" are replaced by the
// fact rows above, not duplicated as paragraphs too); `opts.checklistLabelRe`
// renders a matching block as one checklist item per sentence instead of
// a paragraph, falling back to the paragraph when the split is unreliable.
function renderExpertRowsSite(text, opts) {
    const { skipLabelRe, checklistLabelRe } = opts || {};
    const blocks = splitExpertMarkers(text);
    if (!blocks.length) return '<p class="text-body text-secondary report-prose">Информация отсутствует</p>';
    return blocks.map(({ label, body }) => {
        if (!label) return `<p class="text-body text-secondary report-prose">${highlightFacts(body)}</p>`;
        if (skipLabelRe && skipLabelRe.test(label)) return '';
        const isGrounds = /основани/i.test(label);
        // Only "Противоречия и нестыковки" (document_analysis_reasoning) is
        // a contradiction callout -- "Обременения и аресты" is a normal
        // legal fact (present on nearly every auction lot), already
        // surfaced with its own severity in the Риски section, not a
        // "something's wrong here" callout.
        const isContradictionRow = /противоречи/i.test(label);
        if (isContradictionRow && body && !CONTRADICTION_CLEAN_RE.test(body)) {
            return `
                <div class="report-legal-row">
                    <span class="text-caption text-secondary report-legal-row-label">${escapeHtml(label)}</span>
                    ${reportCalloutHTML(body)}
                </div>
            `;
        }
        if (checklistLabelRe && checklistLabelRe.test(label)) {
            const items = splitSentencesSite(body);
            if (items) {
                return `
                    <div class="report-legal-row">
                        <span class="text-caption text-secondary report-legal-row-label">${escapeHtml(label)}</span>
                        <ul class="report-legal-checklist">${items.map((s) => `<li>${highlightFacts(s)}</li>`).join('')}</ul>
                    </div>
                `;
            }
        }
        return `
            <div class="report-legal-row">
                <span class="text-caption text-secondary report-legal-row-label">${escapeHtml(label)}</span>
                <p class="text-body text-secondary report-prose">${highlightFacts(body)}</p>
                ${isGrounds ? extractCitationChips(body) : ''}
            </div>
        `;
    }).join('');
}

// TASK15 15.4b item 2 / 15.4c item 1 (BLOCKER fix): legal fact rows
// (Собственник/Обременение/Организатор) from participants data
// (debtor_name/chsi_name, already used by the Участники section) plus a
// best-effort regex extraction of the creditor+БИН from
// legal_analysis_reasoning's own text -- not a structured field
// (ai/schemas.py has none for it), so the row is simply omitted when the
// pattern doesn't match rather than guessed at.
// REMOVED (15.4c item 1): "Исполнительное пр-во" row + PROCEEDING_RE.
// The regex matched the FIRST "№ X от dd.mm.yyyy" anywhere in the text,
// which is very often NOT an enforcement proceeding -- checked against
// all 114 stored engine-mode reports live: it matched 12 lots and only
// 1-2 were actually a proceeding number; the rest were a sale contract, a
// Minister's order, an akimat resolution, a registry certificate, a lease
// contract, a transfer contract and a tax authority resolution, each
// mislabelled "Исполнительное пр-во" -- a fabricated legal claim, not a
// best-effort extraction. No replacement regex is safe here (the pattern
// itself can't distinguish document types); a structured field is a
// later ai/schemas.py task, not a frontend regex fix.
const CREDITOR_RE = /(?:в\s+пользу|пользу)\s+([^.(]{2,80}?)\s*\(?\s*БИН\s*[:№]?\s*(\d{9,12})\)?/i;
function renderLegalFactRowsSite(report) {
    const legalText = report.legal_analysis_reasoning || '';
    const rows = [];
    if (report.debtor_name) rows.push(['Собственник', escapeHtml(report.debtor_name)]);
    const creditorMatch = legalText.match(CREDITOR_RE);
    if (creditorMatch) rows.push(['Обременение', `${escapeHtml(creditorMatch[1].trim())} (БИН ${escapeHtml(creditorMatch[2])})`]);
    if (report.chsi_name) rows.push(['Организатор', escapeHtml(report.chsi_name)]);
    if (!rows.length) return '';
    return rows.map(([label, value]) => `
        <div class="report-fin-row">
            <span class="text-caption text-secondary">${label}</span>
            <span class="text-body text-primary">${value}</span>
        </div>
    `).join('');
}

// TASK15 15.4b item 3: filename -> canonical Russian document-type label,
// first match wins. Best-effort only -- when a physical file bundles
// several logical documents (found live on 113438789: one merged PDF
// contains the appraisal report + acts + техпаспорт), its filename won't
// hint at any single type and the row falls back to a generic label with
// the real filename in the title attribute (never guessed from the LLM
// text across multiple candidate files -- that would risk labelling the
// WRONG file).
const DOC_TYPE_PATTERNS = [
    [/оценк/i, 'Отчёт об оценке'],
    [/постановлени/i, 'Постановление ЧСИ'],
    [/акт\s*диагностики/i, 'Акт диагностики'],
    [/акт\s*осмотра/i, 'Акт осмотра'],
    [/техпаспорт|технический\s*паспорт/i, 'Копия техпаспорта'],
    [/выписк/i, 'Выписка'],
    [/протокол/i, 'Протокол'],
];
function guessDocTypeSite(name) {
    for (const [re, label] of DOC_TYPE_PATTERNS) {
        if (re.test(name || '')) return label;
    }
    return null;
}
// Best-effort number/date/code enrichment for a matched type, read from
// document_analysis_reasoning's "Комплектность пакета" clause that
// mentions the same type keyword -- e.g. "отчет об оценке №113 от
// 24.06.2026" -> number "113", date "24.06.2026"; "техпаспорта (СРТС
// AK20153814)" has no date, falls back to the code-like token instead.
function extractDocDetailSite(docsText, typeRe) {
    if (!docsText) return { number: '', detail: '' };
    const clause = docsText.split(/,|\sи\s/).find((c) => typeRe.test(c));
    if (!clause) return { number: '', detail: '' };
    const numberMatch = clause.match(/№\s?([\wА-Яа-я\d/-]+)/);
    const dateMatch = clause.match(/\d{2}\.\d{2}\.\d{4}/);
    if (dateMatch) return { number: numberMatch ? numberMatch[1] : '', detail: dateMatch[0] };
    const codeMatch = clause.match(/\b([A-ZА-Я]{2,6}\s?[A-Z0-9]{4,15})\b/);
    return { number: '', detail: codeMatch ? codeMatch[1] : '' };
}

// TASK15 15.4c item 7: when no type matches (found live:
// sauda_338022092479000000 showed "Документ" four times, indistinguishable),
// the fallback label is the real filename, not a generic word -- strip the
// extension, turn _/- into spaces, cut at 60 chars with an ellipsis. The
// FULL name still lives in the row's title attribute (unchanged).
function filenameFallbackLabelSite(name) {
    const base = (name || '').replace(/\.[^./\\]+$/, '').replace(/[_-]+/g, ' ').trim();
    const text = base || 'Документ';
    return text.length > 60 ? `${text.slice(0, 60)}…` : text;
}

// Documents package checklist (TASK15 15.3/15.4b) -- the lot's actual
// uploaded documents (state.currentLot.documents, real names/urls from
// ETP), never an invented "required for this category" list. Photos
// (.jpeg/.png/...) are excluded -- they're not documents, same extension
// filter the gallery above already uses. `docsText` is
// document_analysis_reasoning's "Комплектность пакета" block, used only
// for the type/date enrichment and the missing-expected-document check
// (never to invent a row that isn't in `documents[]`). `expectedType` is
// {re, label} for this lot's category (техпаспорт for a car, an
// appraisal report otherwise) -- checked against docsText itself (not
// just filenames, since a bundled/merged file can hold it without its
// name hinting at it), so the "не найден" row only fires when the LLM's
// own package description never mentions that type either.
function renderDocChecklistSite(documents, docsText, expectedType) {
    const files = (documents || []).filter((d) => !/\.(jpeg|jpg|gif|png|webp|heic)$/i.test(d.url || ''));
    if (!files.length) return '';
    let foundExpected = false;
    const entries = files.map((d) => {
        const typeLabel = guessDocTypeSite(d.name);
        if (expectedType && typeLabel === expectedType.label) foundExpected = true;
        const typeRe = typeLabel ? DOC_TYPE_PATTERNS.find(([, l]) => l === typeLabel)[0] : null;
        const { number, detail } = typeRe ? extractDocDetailSite(docsText, typeRe) : { number: '', detail: '' };
        const label = typeLabel ? `${typeLabel}${number ? ` № ${number}` : ''}` : filenameFallbackLabelSite(d.name);
        return { d, label, detail };
    });
    // TASK15 15.5 nit 3 (owner review): two DIFFERENT uploaded files can
    // still land on the identical label (e.g. 113466197's three files all
    // fall back to "Фото", sauda_337931689539000000's two both read
    // "Жилой дом 11 155 (1)") -- still indistinguishable rows. Suffix
    // every occurrence after the first with " · N" (its own occurrence
    // index within that label); the first stays unsuffixed.
    const seen = new Map();
    entries.forEach((e) => {
        const n = (seen.get(e.label) || 0) + 1;
        seen.set(e.label, n);
        if (n > 1) e.label = `${e.label} · ${n}`;
    });
    const rows = entries.map(({ d, label, detail }) => `
        <a href="${escapeHtml(d.url)}" target="_blank" rel="noopener" class="report-doc-item" title="${escapeHtml(d.name)}">
            <i class="ph-bold ph-check-circle report-doc-item-icon"></i>
            <span class="text-body text-primary report-doc-item-name">${escapeHtml(label)}</span>
            ${detail ? `<span class="text-caption font-mono-nums text-tertiary report-doc-item-detail">${escapeHtml(detail)}</span>` : ''}
            <i class="ph-bold ph-arrow-square-out report-doc-item-link-icon"></i>
        </a>
    `);
    if (expectedType && !foundExpected && !expectedType.re.test(docsText || '')) {
        rows.push(`<div class="report-doc-item report-doc-item--missing">— ${escapeHtml(expectedType.label)}: не найден</div>`);
    }
    return rows.join('');
}

// TASK15 15.6: "Время до цены" -- minutes from a descending auction's
// start until the entry step, site only (Mini App/finance editor
// unchanged). One row per platform, source in the comment; moved into the
// finance constants table in phase C -- until then this is the only place
// the number lives.
const AUCTION_STEP_INTERVAL_MIN = {
    etp: { minutes: 5, verified: true },    // приказ МЮ РК №100, п. 38; k-й шаг — на (k − 1) × 5 мин (см. v2StepMinutes)
    sauda: { minutes: 2, verified: true },  // подтверждено таблицей владельца (TASK35 35.2): −5 % от текущей цены каждые 2 мин
};
function fmTimeToPriceLabel(minutes) {
    if (minutes < 60) return `${minutes} мин`;
    const h = Math.floor(minutes / 60);
    const rem = minutes % 60;
    return rem > 0 ? `${h} ч ${rem} мин` : `${h} ч`;
}
// TASK15 15.6b self-found: fmMoney's trailing "... ₸" uses a plain
// breakable space -- fine standalone, but the new below-floor/ascending-
// over sentences below put TWO long money amounts in one prose line for
// the first time here, and a stray "₸" wrapping alone onto its own line
// was enough to overflow the card by ~9px at 375px (found live on
// 113477487, a 9-digit floor price). Scoped to these two new sentences
// only -- fmMoney's hundreds of other call sites are untouched.
function fmMoneyNb(v) {
    return fmMoney(v).replace(/ ₸$/, ' ₸');
}

// TASK15 15.2: verdict card + strategy rules, driven entirely by the
// finance engine's own frozen numbers (report.financial_model) -- no LLM
// prose is parsed or reworded here. Field map:
//   uiVerdictMeta      <- report.verdict_badge, report.investment_score
//                         (same two fields + text/class map as updateTldrStrip())
//   uiVerdictCondition <- financial_model.results.max_bid (+ .purchase.step_k
//                         when the auction has a discrete step); when the
//                         "can't reach max_bid" branch fires (TASK16 16.5
//                         v1.2), the wording ALSO reads report.verdict_badge
//                         and report.verdict_engine.margin_target_pct --
//                         "Не интересен" only for not_recommended, "Ниже
//                         целевой маржи" otherwise, matching the code
//                         verdict rather than the raw auction-mechanics fact
//   uiVerdictNumbers   <- financial_model.purchase.{price,availability_pct},
//                         .results.{profit_mid,roi_mid}; lease branch (mode ==
//                         'lease_unsupported', no `results`) reads .rent.
//                         {lease_right_price,term_months} instead
//   uiStrategyRules    <- .results.{max_bid,break_even_purchase},
//                         .purchase.{step_k,price,availability_pct}
//   uiVerdictEngineReasons/uiVerdictEngineCaption (TASK16 16.5)
//                      <- report.verdict_engine.reasons (finance/verdict.py
//                         ::decide(), NOT financial_model) -- absent on
//                         engine failure/flag off/a pre-16.5 report.
// Off/pre-engine reports and the lease branch keep the original
// single-row stop-loss block + "Обоснование" paragraph unchanged.
// TASK18 18.5: report.lease_market (analyzer.py::_build_lease_market) --
// reference numbers for a lease lot, display only:
//   .outcomes  our own finished lease auctions: median/p25/p75 final/start
//              ratio, the level it rests on (oblast + designation / oblast /
//              all) and n, plus the implied final price for this lot;
//   .sale      land only: the Krisha land SALE sample (₸/сотка), 3 links;
//   .rent      premises only: the Krisha RENT sample (monthly), 3 links.
function leaseMarketHasData(lm) {
    return !!(lm && (lm.outcomes || lm.sale || lm.rent));
}

function fmRatioNum(v) {
    return new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 2 }).format(v);
}

function fmAreaNum(v) {
    return new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 1 }).format(v);
}

// TASK21 21.4: the real land-lease model's (mode == 'lease') own verdict-
// card sentences. §4b item 4's own rule -- npv is non-null ONLY when the
// user has entered a real construction cost (S3) / monthly income (S4),
// never for the by-construction break-even solve -- decides which of the
// two phrasings shows.
// «1 год», «2 года», «5 лет», «2,5 года» (TASK41 41.9)
function ruYears(v) {
    const x = Math.round(Number(v) * 10) / 10;
    if (!Number.isInteger(x)) return `${String(x).replace('.', ',')} года`;
    const n10 = x % 10, n100 = x % 100;
    return `${x} ${n10 === 1 && n100 !== 11 ? 'год' : (n10 >= 2 && n10 <= 4 && !(n100 >= 12 && n100 <= 14) ? 'года' : 'лет')}`;
}

function fmLeaseConditionSentence(rent) {
    if (!rent) return '';
    // TASK39 39.4: the main number is the MAX ONE-OFF PAYMENT (NPV = 0) once the user's cost / income is in; before that the break-even
    // cost (income) at the expected winning price; where nothing can be computed, the reason says why (no invented cost)
    const y = rent.expected_entry ? rent.expected_entry.price : rent.lease_right_price;
    const yTxt = y != null ? ` (ожидаемая цена победы ${fmMoney(y)})` : '';
    if (rent.not_computed_reason) return rent.not_computed_reason.charAt(0).toUpperCase() + rent.not_computed_reason.slice(1);
    if (rent.max_bid != null && (rent.user_construction_cost_per_m2 != null || rent.user_monthly_income != null)) {
        return `Платите не больше ${fmMoney(rent.max_bid)} разово${yTxt}`;
    }
    if (rent.strategy === 'S3' && rent.break_even_construction_cost_per_m2 != null) {
        const tot = rent.building_area_m2 ? ` (≈ ${fmMoney(Math.round(rent.break_even_construction_cost_per_m2 * rent.building_area_m2))} в целом на ${fmAreaNum(rent.building_area_m2)} м²)` : '';
        return `Окупится, если стройка обойдётся не дороже ${fmMoney(rent.break_even_construction_cost_per_m2)}/м²${tot}${yTxt}`;
    }
    if (rent.strategy === 'S4' && rent.break_even_income_monthly != null) {
        return `Окупится при доходе от ${fmMoney(rent.break_even_income_monthly)}/мес${yTxt}`;
    }
    if (rent.strategy === 'S3') {
        if (rent.npv != null && rent.user_construction_cost_per_m2 != null) {
            return `Окупается с вашей стоимостью стройки ${fmMoney(rent.user_construction_cost_per_m2)}/м²`;
        }
        if (rent.break_even_construction_cost_per_m2 != null) {
            return `Окупается при стоимости стройки до ${fmMoney(rent.break_even_construction_cost_per_m2)}/м²`;
        }
        // TASK21 21.5 (owner review): the hardcoded "укажите площадь
        // застройки" blamed the area whenever break-even was null, even
        // when the real blocker was something else (most often: the LLM
        // has no rental estimate for a bare plot earmarked for future
        // construction -- found live on sauda_337945399600000000, area
        // resolved fine via the geo registry fallback, no rental estimate
        // at all). The engine's own warning already names the real
        // reason -- show it verbatim instead of guessing.
        const reason = (rent.warnings || []).find((w) => w.includes('стоимость стройки'));
        return reason || 'Безубыточная стоимость стройки не рассчитана';
    }
    if (rent.strategy === 'S4') {
        if (rent.npv != null && rent.user_monthly_income != null) {
            return `Окупается с вашим доходом ${fmMoney(rent.user_monthly_income)}/мес`;
        }
        if (rent.break_even_income_monthly != null) {
            return `Окупается при доходе от ${fmMoney(rent.break_even_income_monthly)}/мес`;
        }
        const reason = (rent.warnings || []).find((w) => w.includes('безубыточный доход'));
        return reason || 'Безубыточный доход не рассчитан';
    }
    return '';
}

// Expected entry price (§4b item 2) with the low/high scenario range when
// our own lease-outcome ratio exists; falls back to the bare stated price
// (still correctly labelled, never silently wrong) when it doesn't.
function fmLeaseEntryLine(rent) {
    if (!rent) return '';
    const termText = rent.term_months != null ? ` · ${rent.term_months} мес.` : '';
    const e = rent.expected_entry;
    if (e) {
        return `Ожидаемая цена входа ${fmMoney(e.price)} (от ${fmMoney(e.low)} до ${fmMoney(e.high)})${termText}`;
    }
    return `Плата за право аренды ${fmMoney(rent.lease_right_price)}${termText}`;
}

// One link per listing: compact price and, when known, the listing's own
// area -- a bare total price says nothing next to a per-сотка / per-м² range.
function leaseMarketLinksHtml(listings, areaUnit) {
    const links = (listings || []).filter((l) => l && l.url).map((l) => {
        const area = l.area ? ` · ${fmAreaNum(l.area)} ${areaUnit}` : '';
        return `<a href="${escapeHtml(l.url)}" target="_blank" rel="noopener noreferrer" class="text-caption text-secondary report-competitor-link"><span class="font-mono-nums">${escapeHtml(`${fmPriceCompactStrict(l.price)} ₸${area}`)}</span> <i class="ph-bold ph-arrow-square-out"></i></a>`;
    });
    return links.length ? `<p class="report-lease-market-links">${links.join('')}</p>` : '';
}

function renderLeaseMarketSite(lm, elId) {
    const el = document.getElementById(elId || 'uiLeaseMarket');
    if (!el) return;
    if (!leaseMarketHasData(lm)) {
        el.innerHTML = '';
        el.classList.add('hidden');
        return;
    }
    // Non-breaking inside a value: «194,1 м²» or «5 714–8 108 ₸/м²» never
    // splits across lines at 375px.
    const num = (s) => `<span class="font-mono-nums">${escapeHtml(String(s).replace(/ /g, '\u00a0'))}</span>`;
    const nLabel = (n) => `n\u00a0=\u00a0${num(String(n))}`;
    const parts = [];
    const o = lm.outcomes;
    if (o) {
        const scope = o.level === 'all'
            ? (o.kind === 'advertising' ? 'все торги рекламных мест' : 'все торги аренды земли')
            : [o.band_label ? `старт ${o.band_label}` : null, o.level === 'band_oblast' ? o.oblast_label : null].filter(Boolean).join(', ');
        parts.push(`<p class="text-caption text-secondary">Похожие торги аренды (${escapeHtml(scope)}, ${nLabel(o.n)}): цена выросла в медиане в ${num(fmRatioNum(o.median_ratio))} раза, у половины — от ${num(`×${fmRatioNum(o.p25_ratio)}`)} до ${num(`×${fmRatioNum(o.p75_ratio)}`)}</p>`);
        if (o.implied_final_price) {
            // Rounded: a median of ratios is an estimate, not a price to the tenge.
            parts.push(`<p class="text-caption text-secondary">По медиане для этого лота — около ${num(`${fmPriceCompactStrict(o.implied_final_price)} ₸`)}</p>`);
        }
    }
    const s = lm.sale;
    if (s) {
        parts.push(`<p class="text-caption text-secondary">Купить похожий участок: ${num(`${fmThousands(s.p25)}–${fmThousands(s.p75)} ₸/сотка`)} (${nLabel(s.n)}, Krisha)</p>`);
        parts.push(leaseMarketLinksHtml(s.listings, 'сот.'));
    }
    const r = lm.rent;
    if (r) {
        const perArea = r.unit === '₸/м² в месяц' && r.quantity;
        const total = perArea ? ` · около ${num(`${fmPriceCompactStrict(r.p25 * r.quantity)}–${fmPriceCompactStrict(r.p75 * r.quantity)} ₸/мес`)} за ${num(`${fmAreaNum(r.quantity)} м²`)}` : '';
        parts.push(`<p class="text-caption text-secondary">Рыночная аренда: ${num(`${fmThousands(r.p25)}–${fmThousands(r.p75)} ${r.unit}`)} (${nLabel(r.n)}, Krisha)${total}</p>`);
        parts.push(leaseMarketLinksHtml(r.listings, 'м²'));
    }
    // The engine reason right below already says the lease yield is not
    // computed -- this caption only adds that these numbers don't feed it.
    parts.push('<p class="text-caption text-tertiary">Справочно: на вердикт не влияет</p>');
    el.innerHTML = parts.join('');
    el.classList.remove('hidden');
}

function renderVerdictAndStrategySite(report) {
    const m = report.financial_model;
    const verdictText = { recommended: 'Рекомендуется', conditionally_recommended: 'Условно', not_recommended: 'Не рекомендуется' };
    const verdictClass = { recommended: 'text-pos', conditionally_recommended: 'text-warn', not_recommended: 'text-neg' };
    // TASK16 16.5 v1.2: reports with a verdict_engine stored BEFORE this
    // change (v1.0/v1.1) don't have margin_target_pct on the object at all
    // -- it was a fixed 20% constant in RULES_V1 the whole time, never
    // actually variable, so this is a safe fallback, not a guess about an
    // unknown historical value.
    const marginTargetPct = (report.verdict_engine && report.verdict_engine.margin_target_pct != null)
        ? report.verdict_engine.margin_target_pct : 20;

    const metaEl = document.getElementById('uiVerdictMeta');
    if (metaEl) {
        const vLabel = reportVerdictLabel(report, report.verdict_badge, verdictText);
        const score = report.investment_score;
        const parts = [];
        if (vLabel) parts.push(vLabel);
        if (typeof score === 'number') parts.push(`скор ${Math.round(score)}`);
        metaEl.textContent = parts.join(' · ');
        metaEl.className = `report-section-meta text-caption ${parts.length ? (verdictClass[report.verdict_badge] || 'text-secondary') : 'text-secondary'}`;
    }

    const cardEl = document.getElementById('uiVerdictCard');
    const condEl = document.getElementById('uiVerdictCondition');
    const numEl = document.getElementById('uiVerdictNumbers');
    const hasSaleResults = !!(m && m.results && m.purchase);
    // TASK21 21.3: real lease lots run mode == 'lease' now; 'lease_unsupported'
    // stays as the defensive premises fallback (see fmIsLease's own comment).
    const isLeaseMode = !!(m && (m.mode === 'lease' || m.mode === 'lease_unsupported') && m.rent);

    if (cardEl && condEl && numEl) {
        if (hasSaleResults) {
            const r = m.results, p = m.purchase;
            // TASK15 15.6b (owner review, a 15.2 bug the 15.6 time phrase
            // inherited): the condition line used to name purchase.step_k
            // next to max_bid -- two UNRELATED numbers (step_k is the
            // engine's chosen ENTRY step under the active strategy;
            // max_bid is a separate continuous-bisection price), self-
            // contradicting whenever the named step's own price sat above
            // max_bid (41/64 sale reports, live-checked). Now named from
            // results.max_bid_step_k (finance/auction.py::max_bid_step_k,
            // the first step whose OWN price is <= max_bid) -- always
            // consistent with the number right next to it by construction.
            const timeCaptionEl = document.getElementById('uiVerdictTimeCaption');
            if (timeCaptionEl) { timeCaptionEl.textContent = ''; timeCaptionEl.classList.add('hidden'); }
            const isDescending = fmAuctionDirection() === 'down';
            if (r.max_bid == null) {
                // TASK41 41.2: no price reaches the target margin -- never print a number for the max bid
                condEl.textContent = 'Максимальная ставка не рассчитана: ни при какой цене покупки модель не даёт требуемой маржи';
            } else if (isDescending) {
                if (r.max_bid_step_k != null) {
                    // 15.6b card-wording nit: step 0 means the price is
                    // already at/below max_bid at the start of the descending
                    // ladder -- "с шага 0" reads like a typo/bug to an
                    // investor, not "right now". No stored report hits this
                    // today (16.5); new ones can.
                    condEl.textContent = r.max_bid_step_k === 0
                        ? `Интересен уже по стартовой цене`
                        : `Интересен ниже ${fmMoney(r.max_bid)} — с шага ${r.max_bid_step_k}`;
                    // "Время до цены" (15.6) -- from max_bid_step_k now,
                    // not purchase.step_k. Hidden at step 0 (never "0
                    // мин") or when this site has no interval row.
                    const interval = AUCTION_STEP_INTERVAL_MIN[(state.currentLot && state.currentLot.site) || ''];
                    const showTime = r.max_bid_step_k > 0 && interval;
                    if (showTime) {
                        const minutes = v2StepMinutes((state.currentLot && state.currentLot.site) || '', r.max_bid_step_k);
                        condEl.textContent += ` · ≈ ${fmTimeToPriceLabel(minutes)} после старта`;
                        if (timeCaptionEl && !interval.verified) {
                            // trade_date has no time component -- this
                            // caveat is about the INTERVAL being
                            // unverified, never a clock time.
                            timeCaptionEl.textContent = 'интервал шага Sauda не подтверждён';
                            timeCaptionEl.classList.remove('hidden');
                        }
                    }
                } else if (p.floor_price != null) {
                    // max_bid sits below even the auction's own floor --
                    // no step ever reaches it, the lot is a pass at any
                    // price the auction can legally land on. TASK16
                    // 16.0.1: on ETP that "floor" is last_step_price (the
                    // real terminal step), not the unreachable regulatory
                    // floor_price -- see fmFloorLabelPrice.
                    const { price: floorLabelPrice, isLastStep } = fmFloorLabelPrice(m);
                    const stepLabel = isLastStep ? 'на последнем шаге' : 'на полу';
                    // TASK16 16.5 v1.2 (owner review of task 3766/3767): the
                    // condition line must follow the CODE verdict, not just
                    // the raw "can't reach max_bid" auction fact -- that fact
                    // alone no longer means not_recommended (v1.2's own
                    // change, see finance/verdict.py::_margin_cap_reason).
                    // Only reworded when report.verdict_engine exists (a
                    // report without it renders exactly as before this item).
                    if (report.verdict_engine && report.verdict_badge !== 'not_recommended') {
                        condEl.textContent = `Ниже целевой маржи: даже ${stepLabel} ${fmMoneyNb(floorLabelPrice)} цена выше ставки для ${marginTargetPct}% (${fmMoneyNb(r.max_bid)}), доходность ${fmPct(r.roi_mid)}`;
                    } else {
                        condEl.textContent = `Не интересен: даже ${stepLabel} ${fmMoneyNb(floorLabelPrice)} цена выше максимальной ставки ${fmMoneyNb(r.max_bid)}`;
                    }
                } else {
                    // No floor concept either (e.g. a Sauda lot with
                    // unknown floor_pct) -- never invent a floor value;
                    // degrade to the bare max_bid line instead.
                    condEl.textContent = `Интересен ниже ${fmMoney(r.max_bid)}`;
                }
            } else {
                // Ascending/direct: no descending step ladder to name --
                // compare the lot's own start price (state.currentLot,
                // same field the market markers already read) against
                // max_bid instead.
                const startPrice = state.currentLot && typeof state.currentLot.start_price === 'number' ? state.currentLot.start_price : null;
                if (startPrice != null && startPrice > r.max_bid) {
                    // Same verdict-aware wording split as the descending
                    // floor branch above.
                    if (report.verdict_engine && report.verdict_badge !== 'not_recommended') {
                        condEl.textContent = `Ниже целевой маржи: старт ${fmMoneyNb(startPrice)} выше ставки для ${marginTargetPct}% (${fmMoneyNb(r.max_bid)}), доходность ${fmPct(r.roi_mid)}`;
                    } else {
                        condEl.textContent = `Не интересен: старт ${fmMoneyNb(startPrice)} выше максимальной ставки ${fmMoneyNb(r.max_bid)}`;
                    }
                } else {
                    condEl.textContent = `Ставка — не выше ${fmMoney(r.max_bid)}`;
                }
            }
            const availText = typeof p.availability_pct === 'number' && p.availability_pct < 100 ? ` · доступен с P = ${p.availability_pct} %` : '';
            numEl.textContent = `Цена входа ${fmMoney(p.price)}${availText} · прибыль ${fmMoney(r.profit_mid)} · ROI ${fmPct(r.roi_mid)}`;
            cardEl.classList.remove('hidden');
        } else if (isLeaseMode && m.mode === 'lease') {
            // TASK21 21.4: the real land-lease model (finance/lease.py) --
            // expected entry (§4b item 2) replaces the bare "Плата за право
            // аренды", the break-even sentence (S3 construction cost / S4
            // income, §4b item 4) is the condition line, same role
            // condEl plays for a sale lot's "Интересен ниже X".
            condEl.textContent = fmLeaseConditionSentence(m.rent);
            numEl.textContent = fmLeaseEntryLine(m.rent);
            cardEl.classList.remove('hidden');
        } else if (isLeaseMode) {
            const rent = m.rent;
            condEl.textContent = '';
            const termText = rent.term_months != null ? ` · ${rent.term_months} мес.` : '';
            // TASK18 18.5: with reference numbers below, the old «модель
            // перепродажи неприменима» tail is replaced by them; reports
            // without report.lease_market keep it.
            const hasLeaseMarket = leaseMarketHasData(report.lease_market);
            numEl.textContent = `Плата за право аренды ${fmMoney(rent.lease_right_price)}${termText}${hasLeaseMarket ? '' : ' · модель перепродажи неприменима'}`;
            cardEl.classList.remove('hidden');
        } else {
            cardEl.classList.add('hidden');
        }
        renderLeaseMarketSite(isLeaseMode ? report.lease_market : null);
    }

    // TASK16 16.5: verdict_engine.reasons -- plain rows under the badge,
    // plus one caption. Absent on engine failure, flag off, or a
    // pre-16.5 report -- both elements just stay hidden, the two
    // paragraphs above render exactly as they did before this item.
    const engineReasonsEl = document.getElementById('uiVerdictEngineReasons');
    const engineCaptionEl = document.getElementById('uiVerdictEngineCaption');
    if (engineReasonsEl && engineCaptionEl) {
        const reasons = report.verdict_engine && Array.isArray(report.verdict_engine.reasons) ? report.verdict_engine.reasons : null;
        if (reasons && reasons.length) {
            engineReasonsEl.innerHTML = reasons.map((reason) => `<li class="report-verdict-engine-reason">${escapeHtml(reason)}</li>`).join('');
            engineReasonsEl.classList.remove('hidden');
            // v1.2 fix: print the real rules_version, not a hardcoded "v1".
            const rulesVersion = (report.verdict_engine && report.verdict_engine.rules_version) || 'v1';
            engineCaptionEl.textContent = `Вердикт рассчитан по правилам ${rulesVersion} из цифр модели и фактов документов`;
            engineCaptionEl.classList.remove('hidden');
        } else {
            engineReasonsEl.innerHTML = '';
            engineReasonsEl.classList.add('hidden');
            engineCaptionEl.textContent = '';
            engineCaptionEl.classList.add('hidden');
        }
    }

    const rulesEl = document.getElementById('uiStrategyRules');
    const legacyEl = document.getElementById('uiStrategyLegacy');
    const rationaleRowEl = document.getElementById('uiRationaleRow');
    const stratMetaEl = document.getElementById('uiStrategyMeta');

    if (rulesEl && legacyEl) {
        if (hasSaleResults) {
            const r = m.results, p = m.purchase;
            const stepText = p.step_k != null ? `шаг ${p.step_k} · ${fmMoney(p.price)}` : fmMoney(p.price);
            const availText = typeof p.availability_pct === 'number' ? ` · P = ${p.availability_pct} %` : '';
            const rows = [
                { label: 'Не входить выше', value: fmMoney(r.max_bid) },
                { label: 'Целевой шаг', value: `${stepText}${availText}` },
                { label: 'Если уходит раньше', value: `выше ${fmMoney(r.max_bid)} — выходить из торгов` },
                { label: 'Безубыточность', value: fmMoney(r.break_even_purchase) },
            ];
            rulesEl.innerHTML = rows.map((row) => `
                <div class="report-strategy-rule">
                    <span class="text-caption report-strategy-rule-label">${escapeHtml(row.label)}</span>
                    <span class="text-body font-mono-nums text-primary report-strategy-rule-value">${escapeHtml(row.value)}</span>
                </div>
            `).join('');
            rulesEl.classList.remove('hidden');
            legacyEl.classList.add('hidden');
            if (rationaleRowEl) rationaleRowEl.classList.add('hidden');
            if (stratMetaEl) stratMetaEl.textContent = `макс. ставка ${fmMoney(r.max_bid)}`;
        } else {
            rulesEl.classList.add('hidden');
            legacyEl.classList.remove('hidden');
            if (rationaleRowEl) rationaleRowEl.classList.remove('hidden');
            if (stratMetaEl) stratMetaEl.textContent = '';
        }
    }
}

function renderInAppReportSite(report) {
    if (!report) return;
    const lot = state.currentLot;

    const headerTitleEl = document.getElementById('reportHeaderTitle');
    if (headerTitleEl && lot) headerTitleEl.textContent = `Анализ: ${formatLotTitleSite(lot).primary}`;

    // Фото-плейсхолдер по категории (§8.4) — populateLotDetail-эквивалент,
    // renderInAppReport() выше уже поставил общий PLACEHOLDER_LOT/onerror,
    // здесь переопределяем на категорийный, как на странице лота.
    const img = document.getElementById('uiMainImage');
    if (img && lot) {
        const fallback = getPlaceholderFor(lot.category);
        if (!lot.image_url) img.src = fallback;
        img.onerror = () => { img.onerror = null; img.src = fallback; };
    }

    // Строка происхождения под фото: дата отчёта · достоверность · факты
    // достоверности — словами, без иконок/эмодзи/чипов (D-03, D-07).
    const provEl = document.getElementById('reportProvenance');
    if (provEl) {
        const parts = [];
        const genDate = fmtDateTime(report.analysis_generated_at);
        if (genDate) parts.push(`Отчёт от ${genDate}`);
        if (report.confidence_level) parts.push(`достоверность: ${report.confidence_level.toLowerCase()}`);
        const dr = report.data_reliability;
        if (dr) {
            if (dr.market_data_source === 'live') parts.push('рынок: live');
            else if (dr.market_data_source === 'estimated') parts.push('рынок: оценка');
            if (dr.legal_data_source === 'documents') parts.push('юр: документы');
            else if (dr.legal_data_source === 'no_documents') parts.push('юр: без документов');
        }
        provEl.textContent = parts.join(' · ');
    }

    // TASK15 15.1: «Документы»/«Юридический статус» unified into variant A
    // -- the green «Высокая достоверность» confidence_level badge (still
    // set by the shared renderInAppReport() above, for Mini App) is
    // replaced on site by a reliability chip driven by data_reliability
    // (§7.4: "documents"/"no_documents" -> «документы»/«оценка», the
    // fact that actually varies block-to-block; confidence_level is one
    // number for the whole report and duplicated the TL;DR).
    const dr2 = report.data_reliability;
    const setReliabilityChip = (elId, sourceValue, presentLabel, absentLabel) => {
        const el = document.getElementById(elId);
        if (!el) return;
        if (sourceValue === undefined || sourceValue === null) { el.classList.add('hidden'); return; }
        const present = sourceValue === 'documents' || sourceValue === 'live';
        el.textContent = present ? presentLabel : absentLabel;
        el.classList.toggle('status-chip--ok', present);
        el.classList.remove('hidden');
    };
    setReliabilityChip('uiDocReliability', dr2 && dr2.legal_data_source, 'документы', 'оценка');
    setReliabilityChip('uiLegalReliability', dr2 && dr2.legal_data_source, 'документы', 'оценка');

    // TASK15 15.3/15.4b: documents package checklist -- the lot's real
    // uploaded files (lot.documents from ETP), not an invented
    // required-docs list. expectedType matches the brief's own two
    // examples (техпаспорт for a car, an appraisal report otherwise) --
    // not a general per-category document requirements list, which
    // doesn't exist anywhere in the data.
    const docChecklistEl = document.getElementById('uiDocChecklist');
    if (docChecklistEl) {
        const docs = lot && lot.documents;
        const isCarLot = report.attributes && report.attributes.is_car;
        const expectedType = isCarLot
            ? { re: /техпаспорт|технический\s*паспорт/i, label: 'Копия техпаспорта' }
            : { re: /оценк/i, label: 'Отчёт об оценке' };
        const html = renderDocChecklistSite(docs, report.document_analysis_reasoning, expectedType);
        docChecklistEl.innerHTML = html;
        docChecklistEl.classList.toggle('hidden', !html);
    }

    // TASK15 15.2: verdict card + strategy rules, built from the finance
    // engine's own numbers (report.financial_model, the frozen snapshot on
    // raw_report -- same source the fmEditor reads its ai_default_model
    // from). Off/pre-engine reports and the lease branch (mode ==
    // 'lease_unsupported', no `results`, see finance/model.py's own
    // comment on FinancialModel.mode) fall back to the legacy single-row
    // stop-loss block that already existed before this task.
    renderVerdictAndStrategySite(report);

    // «Дефекты и фото» — общая секция для двух независимо скрываемых блоков
    // (галерея/визуальные дефекты); если оба пусты, секция целиком не
    // рендерится ни на странице, ни в оглавлении (§8.5, "не рисуем пустое").
    const defectsSection = document.getElementById('sec-defects');
    if (defectsSection) {
        const galleryHidden = document.getElementById('uiGalleryBlock')?.classList.contains('hidden') ?? true;
        const defectsHidden = document.getElementById('uiVisualDefectsBlock')?.classList.contains('hidden') ?? true;
        defectsSection.classList.toggle('hidden', galleryHidden && defectsHidden);
    }

    // Оглавление — только реально отрисованные (не .hidden) секции.
    const toc = document.getElementById('reportToc');
    if (toc) {
        if (reportTocObserver) { reportTocObserver.disconnect(); reportTocObserver = null; }
        const visible = REPORT_TOC_SECTIONS.filter((s) => {
            const el = document.getElementById(s.id);
            return el && !el.classList.contains('hidden');
        });
        toc.innerHTML = visible.map((s) => {
            const getCount = TOC_COUNT_GETTERS[s.id];
            const count = getCount ? getCount() : 0;
            // self-found (2): a literal space here PLUS .report-toc-count's
            // own margin-left doubled the gap -- CSS owns the spacing, no
            // space character in the template.
            // self-found (3): hand-rolled font-family instead of the
            // canonical .font-mono-nums utility (§6.2 "numbers inside
            // report text are .font-mono-nums") -- missing tabular-nums/
            // font-feature-settings, the actual reason that class exists.
            const countHtml = count > 0 ? `<span class="text-caption font-mono-nums report-toc-count">${count}</span>` : '';
            return `<a href="#${s.id}" class="report-toc-link" data-target="${s.id}">${escapeHtml(s.label)}${countHtml}</a>`;
        }).join('');

        if (visible.length && 'IntersectionObserver' in window) {
            const links = new Map(visible.map((s) => [s.id, toc.querySelector(`[data-target="${s.id}"]`)]));
            reportTocObserver = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    const link = links.get(entry.target.id);
                    if (!link) return;
                    link.classList.toggle('active', entry.isIntersecting);
                });
            }, { rootMargin: '-96px 0px -70% 0px', threshold: 0 });
            visible.forEach((s) => {
                const el = document.getElementById(s.id);
                if (el) reportTocObserver.observe(el);
            });
        }
    }
}

// TASK35 35.0: report layout switch. v1 = the old ~17 sections (default); v2 = the seven-section report built on the
// dossier / verdict v2 / writer. v2 needs the data TASK33/34 store (raw_report.dossier, verdict_engine v2) AND the
// section config the server adds to the payload (raw_report.ui, finance/profiles.py::report_ui_config) -- older
// reports have none of it and always render v1. window.REPORT_LAYOUT comes from REPORT_LAYOUT in .env; an admin can
// preview with ?layout=v2 (or force the old one with ?layout=v1). The Mini App renders this same partial and JS.
function reportLayoutV2Active(report) {
    if (!report || !report.ui || !report.dossier || !report.verdict_engine) return false;
    if (!/^v2/.test(String(report.verdict_engine.rules_version || ''))) return false;
    // the configured v2 shows only reports that already have the writer's text (the rest stay v1 until the backfill);
    // the admin preview (?layout=v2) shows v2 whenever the data for it exists
    let layout = window.REPORT_LAYOUT === 'v2' && report.writer ? 'v2' : 'v1';
    try {
        const asked = new URLSearchParams(window.location.search).get('layout');
        if ((asked === 'v2' || asked === 'v1') && userProfile && userProfile.is_admin) layout = asked;
    } catch (e) { /* no URL API -> keep the configured layout */ }
    return layout === 'v2';
}

function applyReportLayout(report) {
    const root = document.getElementById('screen-analysis');
    if (!root) return;
    const v2 = reportLayoutV2Active(report);
    root.classList.toggle('report-v2', v2);
    root.dataset.reportLayout = v2 ? 'v2' : 'v1';
    if (v2) renderReportV2(report);
    renderStaleBanner(report);
}

// «Отчёт устарел» (2026-10-12): report.stale = {date, ended, can_refresh}, set by the server for a report stored before
// the finance engine. Banner with the analysis date; the free re-analysis button only when the auction has not happened yet.
function renderStaleBanner(report) {
    const el = document.getElementById('staleBanner');
    if (!el) return;
    const st = report && report.stale;
    if (!st) { el.innerHTML = ''; el.classList.add('hidden'); return; }
    const d = st.date ? st.date.split('-').reverse().join('.') : '';
    const text = `Отчёт устарел${d ? `: он создан ${d}` : ''}, до обновления методики расчёта. Цифры и вердикт могут отличаться от текущих.`
        + (st.ended ? ' Торги по лоту прошли, обновление не нужно.' : '');
    el.innerHTML = reportCalloutHTML(text)
        + (st.can_refresh ? '<div style="margin-top:12px;"><button type="button" class="btn-ghost" id="btnStaleRefresh" onclick="refreshStaleReport()"><i class="ph-bold ph-arrow-clockwise"></i><span>Обновить бесплатно</span></button></div>' : '');
    el.style.margin = '0 0 16px';
    el.classList.remove('hidden');
}

// Free re-analysis of a stale report: one per user per lot (the server enforces it). Same poll-then-reload as adminRerunAnalysis.
window.refreshStaleReport = async () => {
    if (!state.currentLot || !userId) return;
    const btn = document.getElementById('btnStaleRefresh');
    const label = btn && btn.querySelector('span');
    if (btn) { btn.disabled = true; label.textContent = 'В очереди…'; }
    try {
        const res = await fetch('/api/analysis/refresh-stale', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ user_id: userId, lot_id: state.currentLot.id }),
        });
        const data = await res.json().catch(() => ({}));
        if (!res.ok) {
            alert(data.message || data.detail || 'Не удалось запустить обновление');
            if (btn) { btn.disabled = false; label.textContent = 'Обновить бесплатно'; }
            return;
        }
        adminRerunPollLotId = state.currentLot.id;
        adminRerunPoll();
    } catch (e) {
        console.error('Ошибка обновления отчёта:', e);
        alert('Ошибка сети');
        if (btn) { btn.disabled = false; label.textContent = 'Обновить бесплатно'; }
    }
};

// ---- TASK35: the seven-section report (v2) ------------------------------------------------------------------------
// Everything here reads ONLY stored data: report.dossier (TASK33: facts with sources), report.verdict_engine (v2:
// breakdown, weights, ranked reasons), report.writer (TASK34: the text written after the verdict) and report.ui
// (the profile's section config, finance/profiles.py::report_ui_config) -- no profile `if`s of our own.

const V2_VERDICT_LABEL = { recommended: 'Рекомендуется', conditionally_recommended: 'Условно', not_recommended: 'Не рекомендуется' };
const V2_VERDICT_TONE = { recommended: 'pos', conditionally_recommended: 'warn', not_recommended: 'neg' };
const V2_SOURCE_LABEL = {
    'registry:nipd': 'НИПД', 'registry:egkn': 'ЕГКН', 'registry:ggk': 'ГГК', 'registry:jerler': 'реестр jerler',
    'registry:gis_astana': 'ГИС Астаны', 'registry:alag': 'alag.kz', documents: 'документы', market_sample: 'объявления',
    own_trades: 'свои торги', engine: 'расчёт', llm_estimate: 'оценка ИИ', platform: 'площадка',
};
const V2_COMPONENTS = [
    { key: 'money', label: 'Деньги' }, { key: 'trades', label: 'Торги' }, { key: 'market', label: 'Рынок' },
    { key: 'legal', label: 'Проверка объекта' }, { key: 'object', label: 'Участок / объект' }, { key: 'liquidity', label: 'Ликвидность' },
];
const V2_COMPONENT_EMPTY = {
    money: 'не оценивалось: расчёт доходности для этого лота не ведётся',
    trades: 'не оценивалось: нет данных о торгах',
    market: 'не оценивалось: рынок не определён или не применим',
    legal: 'не оценивалось: документы не проверены',
    object: 'не оценивалось: участок не оценивается по реестрам',
    liquidity: 'не оценивалось: мало данных',
};

// TASK45 45.1 (§7.13): THE builder of a report block's body -- one lead sentence, <= 4 stat tiles, at most one extra line, one «Подробнее».
// tiles: [{label, value, sub, tone: 'pos'|'warn'|'neg'}]; a tile with no value is not shown. more: {summary, html} (html is trusted markup built by the caller).
// 2026-10-24: the value carries ONE colour class -- with text-primary next to it, .text-primary (later in tailwind.build.css) beat .text-pos
// and .text-neg, so green and red tile values had always rendered white. A word is set in Manrope, never mono (§6.2, v2IsNumeric).
const V2_TILE_TONE = { pos: ' text-pos', warn: ' text-warn', neg: ' text-neg' };
// §6.2 (2026-10-24): mono is for numbers only. A value is a number when, without its units, no letters are left: «3 385 834 ₸», «6,8–8,0 млн ₸»,
// «шаг 35», «≈ 1 ч 4 мин», «25 %» are numbers; «не выявлено», «Hyundai H-1 2011», «не установлен в документах» are words (Manrope).
const V2_NUMBER_UNITS = /(?:млрд|млн|тыс|км|м²|м2|см³|га|сот\p{L}*|дн|мин|ч|лет|года?|г\.|до|раза?|шаг|п\.?\s?п|₸|%|×)/gu;
function v2IsNumeric(value) {
    const t = String(value == null ? '' : value);
    return /\d/.test(t) && !/\p{L}/u.test(t.replace(V2_NUMBER_UNITS, ''));
}
function v2Block({ lead, tiles, line, lineHtml, more }) {
    const shown = (tiles || []).filter((x) => x && x.value != null && x.value !== '').slice(0, 4);
    return [
        lead ? `<p class="text-lead text-primary v2-lead">${escapeHtml(lead)}</p>` : '',
        shown.length ? `<div class="v2-tiles">${shown.map((x) => `<div class="v2-tile"><div class="text-caption text-secondary">${escapeHtml(x.label)}</div>`
            + `<div class="${v2IsNumeric(x.value) ? 'font-mono-nums v2-tile-value' : 'v2-tile-value v2-tile-value--word'}${V2_TILE_TONE[x.tone] || ' text-primary'}"${String(x.value).length > V2_TILE_VALUE_MAX ? ` title="${escapeHtml(x.value)}"` : ''}>${escapeHtml(v2TileValue(x.value))}</div>`
            + `${x.sub ? `<div class="text-micro text-tertiary v2-tile-sub">${escapeHtml(x.sub)}</div>` : ''}</div>`).join('')}</div>` : '',
        line || lineHtml ? `<p class="text-body text-secondary v2-line">${lineHtml || escapeHtml(line)}</p>` : '',
        more && more.html ? `<details class="v2-more"><summary class="text-body text-secondary"><span>${escapeHtml(more.summary || 'Подробнее')}</span><i class="ph-bold ph-caret-down"></i></summary><div class="v2-more-body">${more.html}</div></details>` : '',
    ].join('');
}
// the browser's print dialog shows every «Подробнее» open (a closed <details> prints nothing); the state is put back afterwards
window.addEventListener('beforeprint', () => document.querySelectorAll('details.v2-more:not([open])').forEach((d) => { d.open = true; d.dataset.printOpened = '1'; }));
window.addEventListener('afterprint', () => document.querySelectorAll('details.v2-more[data-print-opened]').forEach((d) => { d.open = false; delete d.dataset.printOpened; }));

// TASK45 45.0 C7: the components that BEAR weight in the score and can say why -- sorted by weight. A component with no weight (not scored: «Участок / объект —»,
// «Ликвидность» outside the weights) or with a bare number and no reason («Участок / объект вес 58 % · 100») gets no bar.
// the first sentence of a reason (a decimal point or an abbreviation does not end it), cut at a word boundary: «почему так» is one line per component
// §7.13: a number is in full once -- inside the reasons of the card a full price («31 523 055 ₸») is written compact («31,5 млн ₸»)
function v2CompactNumbers(text) {
    return String(text || '').replace(/(\d{1,3}(?:[\s\u00a0]\d{3}){2,})(\s*₸)/g, (m, num, cur) => `${fmPriceCompactStrict(Number(num.replace(/[\s\u00a0]/g, '')))}${cur}`);
}
// a tile value that is a phrase (a land's purpose) is cut at a WORD boundary so it fills two lines at most; the full text is its tooltip and sits under «Подробнее»
const V2_TILE_VALUE_MAX = 28;
function v2TileValue(v) {
    const t = String(v == null ? '' : v);
    return t.length <= V2_TILE_VALUE_MAX ? t : `${t.slice(0, V2_TILE_VALUE_MAX).replace(/\s+\S*$/, '').replace(/[,;:\s]+$/, '')}…`;
}
function v2OneSentence(text, max) {
    const s = String(text || '').replace(/\s+/g, ' ').trim();
    const m = /^(.*?[.!?])(?:\s+(?=[А-ЯЁA-Z«"(])|$)/.exec(s);
    let out = m && !V2_SAY_ABBR.test(m[1]) ? m[1] : s;
    if (out.length > max) out = `${out.slice(0, max).replace(/\s+\S*$/, '').replace(/[,;:\s]+$/, '')}…`;
    return out;
}
const V2_COMPONENTS_MAX = 4;       // the budget: the four heaviest reasons are the answer to «почему так»
function v2VisibleComponents(engine) {
    const breakdown = engine.breakdown || {}, weights = engine.weights_used || {}, byComp = engine.component_reasons || {};
    return V2_COMPONENTS.map((c) => {
        const top = v2DedupeReasons(byComp[c.key] || [])[0];
        return { ...c, value: breakdown[c.key], weight: weights[c.key], top, reason: top ? v2CompactNumbers(v2OneSentence(top.text, 150)) : '' };
    }).filter((c) => c.value != null && c.weight > 0 && c.reason).sort((a, b) => b.weight - a.weight).slice(0, V2_COMPONENTS_MAX);
}

// one fact of the dossier: its value (undefined when the dossier doesn't know it)
function v2Fact(report, group, key) {
    const f = report.dossier && report.dossier[group] && report.dossier[group][key];
    return f ? f.value : undefined;
}
function v2Source(source) { return V2_SOURCE_LABEL[source] || ''; }
// the same fact must not be listed twice (a cap and a plain points row for one red line): keep the first (the stronger),
// compare by the first sentence of the text within one component
function v2DedupeReasons(list) {
    const seen = new Set();
    return list.filter((x) => {
        const key = `${x.component}|${String(x.text).split('.')[0].trim().toLowerCase()}`;
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
    });
}
function v2SourceChip(source) {
    const label = v2Source(source);
    return label ? `<span class="status-chip">${escapeHtml(label)}</span>` : '';
}
function v2Pct(fraction) { return fraction == null ? '' : `${Math.round(fraction * 100)} %`; }
function v2Date(iso) {
    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(iso || ''));
    return m ? `${m[3]}.${m[2]}.${m[1]}` : '';
}
// minutes from the start of the descending auction to ladder step k: ETP (k-1) x 5 min (owner table, review §11),
// Sauda k x 2 min (interval confirmed by the owner's table)
function v2StepMinutes(site, k) {
    if (k == null) return null;
    if (site === 'etp') return Math.max(0, k - 1) * 5;
    if (site === 'sauda') return k * 2;
    return null;
}
function v2Proseify(text) {
    return String(text || '').split(/\n{2,}/).map((t) => t.trim()).filter(Boolean)
        .map((t) => `<p class="text-body text-primary report-prose">${escapeHtml(t)}</p>`).join('');
}

// «главное число» of the profile -- {question, value, lines:[[label, value]], caption}
function v2MainNumber(report) {
    const kind = report.ui && report.ui.main_number;
    const m = report.financial_model || {};
    const r = m.results || {};
    const f = (g, k) => v2Fact(report, g, k);
    const money = (v) => (v == null ? null : fmMoneyNb(v));
    const lines = [];
    const add = (label, text) => { if (text != null && text !== '') lines.push([label, text]); };
    const site = (state.currentLot && state.currentLot.site) || '';
    if (kind === 'ladder_entry') {
        const k = r.max_bid_step_k;
        if (k != null) {
            const minutes = v2StepMinutes(site, k);
            add('С шага', k === 0 ? 'сразу, по стартовой цене' : String(k));
            if (k > 0 && minutes != null) add('Через', `≈ ${fmTimeToPriceLabel(minutes)} после старта`);
            add('Максимальная ставка', money(r.max_bid));
            add('Лот ещё не продан к этой цене', v2Pct(f('trades', 'availability_at_max_bid')));
            return { question: 'На каком шаге входить и успею ли?', value: k === 0 ? 'Интересен уже по стартовой цене' : `Интересен ниже ${fmMoneyNb(r.max_bid)}`, lines };
        }
        if (f('money', 'max_bid_below_floor') === true) {
            add('Максимальная ставка', money(r.max_bid));
            add('Самая низкая цена торгов', money(f('money', 'lowest_reachable_price')));
            return { question: 'На каком шаге входить и успею ли?', value: 'Интересен только ниже пола торгов', lines };
        }
        return { question: 'На каком шаге входить и успею ли?', value: 'Максимальная ставка не определена', lines };
    }
    if (kind === 'second_round') {
        const sr = f('trades', 'second_round');
        if (sr && sr.max_bid != null) {
            const k = sr.entry_step;
            add('Вторые торги не раньше', v2Date(sr.date_earliest));
            add('Обычно', sr.date_typical ? `${v2Date(sr.date_typical)} (через ~${(sr.delay_days || {}).median} дн.)` : '');
            add('Вторые торги проходят по', sr.p_held != null && (sr.p_held_n || 0) >= 30 ? `${Math.round(sr.p_held * 100)} % таких лотов (n = ${sr.p_held_n})` : 'вероятность не определена');
            if (!(sr.floor_price != null && sr.max_bid < sr.floor_price)) add('Лот ещё не продан к этой цене', v2Pct(sr.availability_at_max_bid));
            add('Пол вторых торгов', money(sr.floor_price));
            const belowFloor = sr.floor_price != null && sr.max_bid < sr.floor_price;      // the max bid is under the lowest price the ladder reaches
            return { question: 'На каком шаге вторых торгов входить и успею ли?',
                     value: `Интересен ниже ${fmMoneyNb(sr.max_bid)}`, numeric: true,
                     valueLabel: belowFloor ? 'вторые торги: ниже пола лестницы' : (k != null ? (k === 0 ? 'вторые торги: уже по стартовой цене' : `вторые торги: с шага ${k}${sr.entry_time_min ? `, ≈ ${fmTimeToPriceLabel(sr.entry_time_min)} после старта` : ''}`) : 'вторые торги'), lines,
                     caption: belowFloor ? 'Максимальная ставка по модели ниже пола вторых торгов: по такой цене лот не купить.' : '' };
        }
        const sold = f('trades', 'class_n_sold'), none = f('trades', 'class_n_no_bidders');
        const total = (sold || 0) + (none || 0);
        add('Первые торги такого класса', total ? `проданы ${sold} из ${total}` : '');
        add('Вторые торги не раньше', v2Date(f('trades', 'second_round_earliest_date')));
        add('Старт вторых торгов', money(f('trades', 'second_round_start_price')));
        add('Пол вторых торгов', money(f('trades', 'second_round_floor_price')));
        add('Максимальная ставка', money(r.max_bid));
        const floor2 = f('trades', 'second_round_floor_price');
        const below = r.max_bid != null && floor2 != null && r.max_bid < floor2;
        return { question: 'Будут ли торги вообще?', value: 'Первые торги почти не состоятся — ориентируйтесь на вторые', lines,
                 caption: below ? 'Максимальная ставка по модели ниже пола вторых торгов: по такой цене лот не купить.' : '' };
    }
    if (kind === 'winning_price') {
        const win = f('trades', 'expected_winning_price');
        add('Максимальная ставка', money(r.max_bid));
        add('Лот уйдёт не дороже макс. ставки', v2Pct(f('trades', 'sell_at_or_below_max_bid')));
        add('Стартовая цена', money(f('trades', 'start_price')));
        return { question: 'Сколько заплатит победитель?', value: win != null ? fmMoneyNb(win) : 'Ожидаемая цена победы не определена', numeric: win != null, valueLabel: win != null ? 'ожидаемая цена победы' : '', lines };
    }
    if (kind === 'lease_price') {
        const win = f('trades', 'expected_winning_price');
        const years = f('object', 'lease_term_years');
        add('Стартовая цена', money(f('trades', 'start_price')));
        // TASK45 45.0 C2: a resale of an existing right shows what the model prices -- the REMAINING term -- with the end year of the right,
        // the same words as «Характеристики» («до 2056 г. · осталось ≈ 30 лет»)
        const leaseOv = report.financial_platform_attrs_override || {};
        const rightEnd = leaseOv.lease_resale && leaseOv.passport_override ? leaseOv.passport_override.right_end_year : null;
        add(rightEnd ? 'Остаток срока права' : 'Срок аренды', years != null ? `${ruYears(years)}${rightEnd ? ` (до ${rightEnd} г.)` : ''}` : '');
        // TASK39 39.4: «Платите не больше X разово» once the max payment exists (the user's cost is in); before that the break-even cost
        // at the expected price; where it cannot be computed the reason is shown instead of a number
        const lr = (report.financial_model || {}).rent || {};
        const winTxt = win != null ? ` (ожидаемая цена победы ${fmMoneyNb(win)})` : '';
        add('Назначение', lr.purpose_label || '');
        add('Стратегия', FM_LEASE_STRATEGY_LABEL[lr.strategy] || '');
        add('Окупается при стоимости стройки не дороже', lr.break_even_construction_cost_per_m2 != null ? `${fmMoneyNb(lr.break_even_construction_cost_per_m2)}/м²` : '');
        add('Окупается при доходе от', lr.break_even_income_monthly != null ? `${fmMoneyNb(lr.break_even_income_monthly)}/мес` : '');
        if (lr.max_bid != null) {
            return { question: 'Сколько максимум заплатить за право аренды?', value: `Платите не больше ${fmMoneyNb(lr.max_bid)} разово${winTxt}`, numeric: true,
                     valueLabel: 'максимальный разовый платёж (NPV = 0 при ваших цифрах)', lines };
        }
        return { question: 'Сколько максимум заплатить за право аренды?', value: win != null ? fmMoneyNb(win) : 'Ожидаемая цена победы не определена', numeric: win != null,
                 valueLabel: win != null ? 'ожидаемая цена победы — разовый платёж за право на весь срок' : '', lines,
                 caption: lr.not_computed_reason ? (lr.not_computed_reason.charAt(0).toUpperCase() + lr.not_computed_reason.slice(1))
                     : (lr.break_even_construction_cost_per_m2 != null ? `Окупится, если стройка обойдётся не дороже ${fmMoneyNb(lr.break_even_construction_cost_per_m2)}/м²${lr.building_area_m2 ? ` (≈ ${fmMoneyNb(Math.round(lr.break_even_construction_cost_per_m2 * lr.building_area_m2))} в целом на ${fmAreaNum(lr.building_area_m2)} м²)` : ''}${winTxt}. Впишите свою стоимость в «Мои цифры» — покажем максимум разового платежа.`
                         : (lr.break_even_income_monthly != null ? `Окупится при доходе от ${fmMoneyNb(lr.break_even_income_monthly)}/мес${winTxt}. Впишите свой доход в «Мои цифры».` : '')) };
    }
    if (kind === 'rent_monthly') {
        const pay = f('money', 'monthly_payment'), be = f('money', 'rent_breakeven_per_m2');
        const vs = f('market', 'rent_breakeven_vs_market');
        const term = f('money', 'rent_term_months');
        add('Платёж в месяц', pay != null ? money(pay) : '');
        add('За весь срок', f('money', 'rent_total_payments') != null ? `${money(f('money', 'rent_total_payments'))}${term ? ` (${term} мес.)` : ''}` : '');
        add('Платёж за 1 м² в месяц', money(f('money', 'rent_per_m2')));
        add('Рыночная аренда за 1 м² (медиана)', money(f('market', 'rent_market_median')));
        if (vs != null) add('Безубыточная ставка к рынку', `${vs > 0 ? 'выше на' : (vs < 0 ? 'ниже на' : 'на уровне')}${vs !== 0 ? ` ${Math.abs(Math.round(vs * 100))} %` : ''}`);
        add('Гарантийный взнос', money(f('money', 'deposit_locked')));
        return { question: 'Сколько вы заплатите за срок аренды (в месяц и всего) и во сколько сдавать, чтобы выйти в ноль?',
                 value: be != null ? `${fmMoneyNb(be)} за м² в месяц` : (pay != null ? `${fmMoneyNb(pay)} в месяц` : 'Платёж не определён'), numeric: true,
                 valueLabel: be != null ? `безубыточная ставка субаренды${f('money', 'rent_fitout_unknown') ? ' (без стоимости отделки)' : ''}` : 'ожидаемый ежемесячный платёж', lines,
                 caption: vs == null ? 'Рынок аренды не определён: безубыточную ставку не с чем сравнить, вердикт не выше «условно».' : '' };
    }
    if (kind === 'documents_only') {
        return { question: 'Что можно сказать о лоте?', value: 'Доходность для этого вида лота не рассчитывается', lines,
                 caption: 'Оценка строится только по документам и торгам; вердикт не выше «условно».' };
    }
    return null;
}

// TASK45 45.2: the writer's answer for the card -- the first two sentences that say something, <= 40 words. A sentence that only restates the verdict
// («Условно рекомендую.») or the score («Итоговый балл — 65 из 100.») is skipped: the badge above already says it.
const V2_SAY_ABBR = /(?:^|\s)(?:г|гг|ул|д|кв|пр|им|обл|р-н|мкр|тыс|млн|млрд|руб|тг|п|стр|ст|т\.е|т\.д|№)\.$/i;
// a sentence that only repeats the card's main number (written in full once, in the main line) is not said again
function v2RestatesNumber(sentence, mainValue) {
    const nums = String(mainValue || '').match(/\d{1,3}(?:[\s\u00a0]\d{3})+/g) || [];
    return nums.some((n) => String(sentence).replace(/\u00a0/g, ' ').includes(n.replace(/\u00a0/g, ' ')));
}
// avoid: the reasons the card shows below; a sentence that repeats one of them (>= 70 % of its words) is not said twice
function v2WordSet(s) { return new Set(String(s || '').toLowerCase().replace(/[^а-яёa-z0-9]+/g, ' ').trim().split(' ').filter((w) => w.length > 2)); }
function v2Repeats(sentence, avoid) {
    const a = v2WordSet(sentence);
    if (!a.size) return false;
    return (avoid || []).some((r) => { const b = v2WordSet(r); let hit = 0; a.forEach((w) => { if (b.has(w)) hit++; }); return hit / a.size >= 0.7; });
}
function v2AnswerSay(text, avoid, mainValue) {
    // no look-behind: older Telegram WebViews (iOS < 16.4) fail to parse the whole script on it
    const parts = (String(text || '').replace(/\s+/g, ' ').trim().match(/(?:[^.!?]|\.(?=\d))+[.!?]+(?:\s+|$)|(?:[^.!?]|\.(?=\d))+$/g) || []).map((x) => x.trim()).filter(Boolean);
    const sentences = [];
    for (const p of parts) {
        if (sentences.length && V2_SAY_ABBR.test(sentences[sentences.length - 1])) sentences[sentences.length - 1] += ` ${p}`;
        else sentences.push(p);
    }
    const useful = sentences.filter((x) => x && !/^(?:условно\s+)?(?:не\s+)?(?:рекомендую|рекомендуется|рекомендован[оа]?)[.!]?$/i.test(x) && !/^условно[.!]?$/i.test(x) && !/^итоговый балл/i.test(x) && !v2Repeats(x, avoid) && !v2RestatesNumber(x, mainValue));
    let out = '', words = 0;
    for (const x of useful.slice(0, 2)) {
        const n = x.split(' ').length;
        if (words + n > 40) {
            if (!out) out = `${x.split(' ').slice(0, 40).join(' ').replace(/[,;:\s]+$/, '')}…`;
            break;
        }
        out += (out ? ' ' : '') + x;
        words += n;
    }
    return out;
}
// the one line under the main number: step, time, chance (rows that repeat a price shown elsewhere are not part of it)
function v2MainLine(lines) {
    const wanted = /шаг|через|продан|срок|вероятн|обычно|не раньше|проходят/i;      // the step / time / chance family; prices and the purpose live in their blocks
    const out = [];
    let words = 0;
    for (const [k, v] of (lines || []).filter(([k0]) => wanted.test(k0))) {
        const piece = `${k} ${v}`;
        const n = piece.split(' ').length;
        if (out.length && words + n > 20) break;      // one line: the first rows that fit
        out.push(piece); words += n;
        if (out.length === 3) break;
    }
    return out.join(' · ');
}

function renderV2Answer(report) {
    const sec = document.getElementById('v2-answer');
    const engine = report.verdict_engine;
    if (!sec || !engine) return;
    const writer = report.writer || null;

    // header: «Условно · 57»
    const meta = document.getElementById('v2AnswerMeta');
    const label = reportVerdictLabel(report, engine.verdict, V2_VERDICT_LABEL);
    // §III.3 (2026-10-24): «98 · Рекомендуется» as a status pill, and the ONE coloured edge of the page on this panel
    const verdictTone = label === 'Под вопросом' ? 'warn' : V2_VERDICT_TONE[engine.verdict];
    if (meta && label) {
        meta.innerHTML = `<span class="v2-pill v2-pill--${verdictTone || 'warn'}"><span class="font-mono-nums">${Math.round(engine.score)}</span>${escapeHtml(label)}</span>`;
        meta.className = 'report-section-meta';
    }
    if (sec) { if (verdictTone) sec.dataset.verdictTone = verdictTone; else delete sec.dataset.verdictTone; }

    // the profile's main number (TASK45 45.2): the value itself, and ONE line for the rest of the entry (step, time, chance) -- the other rows live in the blocks
    const main = v2MainNumber(report);
    const mainEl = document.getElementById('v2MainNumber');
    if (mainEl) {
        if (main) {
            const entryLine = v2MainLine(main.lines);
            mainEl.innerHTML = `
                <p class="${main.numeric ? 'text-display font-mono-nums' : 'text-title'} text-primary v2-main-value">${escapeHtml(main.value)}</p>
                ${main.valueLabel ? `<p class="text-caption text-secondary v2-main-label">${escapeHtml(main.valueLabel)}</p>` : ''}
                ${entryLine ? `<p class="text-body text-secondary v2-main-line">${escapeHtml(entryLine)}</p>` : ''}
                ${main.caption ? `<p class="text-caption text-tertiary v2-note">${escapeHtml(main.caption)}</p>` : ''}`;
            mainEl.classList.remove('hidden');
        } else {
            mainEl.classList.add('hidden');
        }
    }

    // the writer's answer, cut to what the card has room for (TASK45 45.2): <= 2 sentences, <= 40 words, no sentence that only restates the verdict
    const textEl = document.getElementById('v2AnswerText');
    if (textEl) {
        const say = writer ? v2AnswerSay(writer.answer || report.executive_summary, v2VisibleComponents(engine).map((c) => c.reason), main && main.value) : '';
        textEl.innerHTML = say ? `<p class="text-lead text-primary v2-answer-say">${escapeHtml(say)}</p>` : '';
    }

    // «Почему так»: the components that bear weight, each with its one-line reason, heaviest first (C7); the separate «Главные причины» list is gone
    const compEl = document.getElementById('v2Components');
    const comps = v2VisibleComponents(engine);
    if (compEl) {
        const tone = (v) => (v >= 80 ? 'score-good' : v >= 50 ? 'score-mid' : 'score-bad');
        const numTone = (v) => (v >= 80 ? 'text-primary' : v >= 50 ? 'text-warn' : 'text-neg');
        compEl.innerHTML = comps.length ? `<h4 class="text-caption text-secondary v2-block-title">Почему так</h4><div class="v2-components">${comps.map((c) => `<div class="v2-comp-row">
                <span class="text-body text-primary v2-comp-label">${escapeHtml(c.label)}</span>
                <span class="v2-comp-bar"><span class="score-bar-fill ${tone(c.value)}" style="width:0%" data-target="${Math.round(c.value)}"></span></span>
                <span class="text-body font-mono-nums ${numTone(c.value)} v2-comp-num">${Math.round(c.value)}</span>
                <span class="text-caption text-secondary v2-comp-reason">${escapeHtml(c.reason)}</span>
            </div>`).join('')}</div>` : '';
        compEl.classList.toggle('hidden', !comps.length);
        requestAnimationFrame(() => compEl.querySelectorAll('.score-bar-fill').forEach((el) => { el.style.width = `${el.dataset.target || 0}%`; }));
    }

    // what limits the verdict (a cap or a veto) -- only when no component bar already says it
    const reasonsEl = document.getElementById('v2Reasons');
    if (reasonsEl) {
        const said = comps.map((c) => c.reason);
        const limits = v2DedupeReasons((Array.isArray(engine.reasons) ? engine.reasons : []).filter((x) => x && x.text && (x.effect === 'cap' || x.effect === 'veto') && !v2Repeats(v2OneSentence(x.text, 150), said))).slice(0, 2);
        reasonsEl.innerHTML = limits.length ? `<ul class="v2-reasons">${limits.map((x) => `<li class="v2-reason${x.effect === 'veto' ? ' v2-reason--veto' : ' v2-reason--cap'}"><span class="text-body text-primary v2-reason-text">${escapeHtml(v2CompactNumbers(v2OneSentence(x.text, 150)))}</span></li>`).join('')}</ul>` : '';
        reasonsEl.classList.toggle('hidden', !limits.length);
    }

    // what to check before bidding: three items at most
    const checksEl = document.getElementById('v2Checks');
    const checks = writer && writer.check_before_bid ? String(writer.check_before_bid).split('\n').map((x) => x.trim()).filter(Boolean).slice(0, 3) : [];
    if (checksEl) {
        checksEl.innerHTML = checks.length ? `<h4 class="text-caption text-secondary v2-block-title">Проверить до торгов</h4><ol class="v2-checks text-body text-primary">${checks.map((x) => `<li>${escapeHtml(x)}</li>`).join('')}</ol>` : '';
        checksEl.classList.toggle('hidden', !checks.length);
    }
    sec.classList.remove('hidden');
}

// ---- v2 section «Торги» --------------------------------------------------------------------------------------------
function v2Row(label, value, note) {
    if (value == null || value === '') return '';
    return `<div class="report-fin-row"><span class="text-caption text-secondary">${escapeHtml(label)}${note ? ` <span class="text-tertiary">${escapeHtml(note)}</span>` : ''}</span><span class="text-body${v2IsNumeric(value) ? ' font-mono-nums' : ''} text-primary">${escapeHtml(value)}</span></div>`;
}
function v2Group(title, rowsHtml) {
    return rowsHtml.trim() ? `<h4 class="text-body text-primary v2-block-title">${escapeHtml(title)}</h4><div>${rowsHtml}</div>` : '';
}
// steps of a descending ladder from its prices: ETP takes step_pct of the START price each step, Sauda of the current one
function v2LadderSteps(start, last, stepPct, mode) {
    if (!start || !last || !stepPct || last >= start) return null;
    const k = mode === 'compound' ? Math.log(last / start) / Math.log(1 - stepPct / 100) : (1 - last / start) / (stepPct / 100);
    return Number.isFinite(k) ? Math.round(k) : null;
}
function v2RatioText(ratio) {
    if (ratio == null) return '';
    if (ratio >= 1) return `×${String(Math.round(ratio * 100) / 100).replace('.', ',')} от старта`;
    return `−${Math.round((1 - ratio) * 100)} % от старта`;
}
const V2_NOTE_COMPONENT = { note_trades: 'trades', note_money: 'money', note_market: 'market', note_check: 'legal', note_object: 'object' };
function v2Notes(report, key) {
    const w = report.writer && report.writer[key];
    if (!w) return '';
    // the section header already prints the component's top reason right under it -- never say the same thing twice
    const top = (((report.verdict_engine || {}).component_reasons || {})[V2_NOTE_COMPONENT[key]] || [])[0];
    const norm = (t) => String(t || '').replace(/\s+/g, ' ').trim().replace(/[.]$/, '');
    if (top && norm(top.text) && (norm(w) === norm(top.text) || norm(top.text).includes(norm(w)))) return '';
    return `<p class="text-body text-secondary report-prose v2-note">${escapeHtml(w)}</p>`;
}

// TASK38 38.5: ETP ascending lot -- first trades -> second trades -> the descending ladder with the user's entry step
function v2SecondRoundTimeline(report, sr, site) {
    const f = (k) => v2Fact(report, 'trades', k);
    const money = (v) => (v == null ? '' : fmMoneyNb(v));
    const sold = f('first_round_n_sold'), n1 = f('first_round_n'), ratio = f('first_round_ratio') || {};
    const d = sr.delay_days || {};
    const pHeld = sr.p_held != null && (sr.p_held_n || 0) >= 30 ? `${Math.round(sr.p_held * 100)} % таких лотов (по ${sr.p_held_n})` : 'вероятность не определена (мало данных)';
    const first = `<li><span class="text-body text-primary v2-step-title">Первые торги ${v2Date(f('trade_date'))}</span>
        <span class="text-caption text-secondary">Почти наверняка не состоятся${sold != null && n1 ? `: продаётся ${(sold / n1 * 100).toFixed(sold / n1 < 0.1 ? 0 : 0)} % (${sold} из ${String(n1).replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}${ratio.scope === 'all' ? ' по всем видам лотов' : ''})` : ''}, по стартовой цене не покупал никто.
        ${ratio.median ? `Если конкуренты появятся, лот обычно уходит на +${Math.round((ratio.p25 - 1) * 100)}…+${Math.round((ratio.median - 1) * 100)} % к старту.` : ''}</span></li>`;
    const second = `<li><span class="text-body text-primary v2-step-title">Вторые торги${sr.date_typical ? ` — обычно ${v2Date(sr.date_typical)}` : ''}</span>
        <span class="text-caption text-secondary">${d.median != null ? `Обычно через ~${d.median} дн. (${d.p25}–${d.p75}), ` : ''}не раньше ${v2Date(sr.date_earliest)}. Проходят по ${escapeHtml(pHeld)}. Торги на понижение от той же стартовой цены.</span></li>`;
    const k = sr.entry_step;
    const belowFloor = sr.max_bid != null && sr.floor_price != null && sr.max_bid < sr.floor_price;
    const entry = `<li><span class="text-body text-primary v2-step-title">${belowFloor ? 'Ваш вход по модели: ниже пола лестницы' : (k != null ? (k === 0 ? 'Вход по модели: сразу, по стартовой цене' : `Ваш вход по модели: шаг ${k}${sr.entry_time_min ? `, ≈ ${fmTimeToPriceLabel(sr.entry_time_min)} после старта` : ''}`) : 'Вход по модели не определён')}</span>
        <span class="text-caption text-secondary">${sr.max_bid != null ? `Интересен ниже ${fmMoneyNb(sr.max_bid)}. ` : ''}${belowFloor ? 'Это ниже самой низкой цены лестницы: по такой цене лот не купить.' : (sr.availability_at_max_bid != null ? `К этой цене лот ещё не продан с вероятностью ${Math.round(sr.availability_at_max_bid * 100)} %.` : '')}</span></li>`;
    let rows = v2Row('Старт вторых торгов', money(sr.start), 'та же цена, что у первых');
    rows += v2Row('Шаг лестницы', sr.step_pct != null ? `−${String(sr.step_pct).replace('.', ',')} % от старта каждые 5 мин` : '');
    rows += v2Row('Пол', money(sr.floor_price), `${sr.floor_pct} % от старта — последняя достижимая цена`);
    rows += v2Row('Ожидаемая итоговая цена', money(sr.expected_final), 'медиана итог/старт торгов на понижение этого класса');
    return `<h4 class="text-body text-primary v2-block-title">Как пойдут торги</h4><ol class="v2-steps">${first}${second}${entry}</ol>` + v2Group('Лестница вторых торгов', rows);
}

function renderV2Trades(report) {
    const sec = document.getElementById('v2-trades');
    const body = document.getElementById('v2TradesBody');
    if (!sec || !body) return;
    const variant = report.ui && report.ui.sections && report.ui.sections.trades;
    const f = (k) => v2Fact(report, 'trades', k);
    const m = report.financial_model || {};
    const r = m.results || {};
    const site = (state.currentLot && state.currentLot.site) || '';
    const money = (v) => (v == null ? '' : fmMoneyNb(v));
    const compact = (v) => (v == null ? '' : `${fmPriceCompactStrict(v)} ₸`);
    const interval = (AUCTION_STEP_INTERVAL_MIN[site] || {}).minutes;
    const stepPct = f('step_pct'), stepMode = f('step_mode');
    const sr = variant === 'second_round' ? f('second_round') : null;

    // lead: the mechanism in one sentence
    let lead;
    if (variant === 'ladder') {
        lead = `Торги на понижение: цена снижается на ${String(stepPct != null ? stepPct : '').replace('.', ',')} % ${stepMode === 'compound' ? 'от текущей цены' : 'от стартовой цены'}${interval ? ` каждые ${interval} мин` : ' с каждым шагом'}, побеждает первый, кто согласился.`;
    } else if (variant === 'second_round') {
        lead = 'Первые торги почти наверняка не состоятся; цена падает ступенями на вторых торгах от той же стартовой цены.';
    } else {
        lead = 'Торги на повышение: побеждает самая высокая ставка; цена не опускается ниже старта.';
    }

    // tiles
    const sold = f('class_n_sold'), none = f('class_n_no_bidders'), total = (sold || 0) + (none || 0);
    const last = f('ladder_floor') != null ? f('ladder_floor') : (f('last_step_price') != null ? f('last_step_price') : f('floor_price'));
    const tiles = [
        { label: 'Торги', value: f('trade_date') ? v2Date(f('trade_date')) : '', sub: f('application_deadline') ? `подача до ${v2Date(f('application_deadline'))}` : '' },
        { label: 'Старт', value: compact(f('start_price')), sub: f('deposit_pct') != null ? `задаток ${String(f('deposit_pct')).replace('.', ',')} %` : '' },
    ];
    if (variant === 'ladder') {
        // K1 (2026-10-24): the step under the floor price is the step of THAT price; the max-bid step («с шага N» in «Ответ») is another number
        const entryK = f('entry_step_k'), entryP = f('entry_price');
        tiles.push({ label: 'Пол лестницы', value: compact(last), sub: entryK != null && entryP != null && entryP === last ? `шаг ${entryK} · вход по модели` : 'последняя цена лестницы' });
    } else if (variant === 'second_round' && sr) {
        tiles.push({ label: 'Пол вторых торгов', value: compact(sr.floor_price), sub: sr.entry_step != null ? `ваш вход: шаг ${sr.entry_step}` : '' });
    } else if (variant === 'price_band') {
        tiles.push({ label: 'Ожидаемая цена', value: compact(f('expected_winning_price')), sub: '' });
    }
    tiles.push({ label: 'Продаётся', value: f('class_sale_rate') != null ? v2Pct(f('class_sale_rate')) : '', sub: total ? `${sold} из ${total} лотов класса` : '' });

    // first round (ETP second-round lots): ONE line with the link
    const firstRound = f('first_round_lot');
    let lineHtml = '';
    if (firstRound) {
        const bits = [firstRound.date ? `Первые торги ${v2Date(firstRound.date)}` : 'Первые торги', firstRound.result || ''].filter(Boolean).join(' — ');
        lineHtml = escapeHtml(bits) + (firstRound.lot_id ? ` · <a class="v2-link" href="/workspace/lot/${encodeURIComponent(firstRound.lot_id)}">открыть лот</a>` : '');
    } else if (f('first_round_not_found')) {
        lineHtml = 'Первые торги в документах и в базе не нашли.';
    }

    // «Подробнее»: the ladder / the second-round timeline / the price band, the outcome forecast, the history
    let more = v2Notes(report, 'note_trades');
    let core = '';
    if (variant === 'ladder') {
        const steps = v2LadderSteps(f('start_price'), last, stepPct, stepMode);
        core += v2Row('Пол торгов', money(last), site === 'sauda' ? 'минимальная цена лота' : 'последняя достижимая цена');
        if (steps != null) {
            const t = v2StepMinutes(site, steps);
            core += v2Row('Шагов до пола', String(steps), t != null ? `≈ ${fmTimeToPriceLabel(t)} после старта` : '');
        }
        // K1: the max bid and the model's entry are two prices on two steps -- each row names its own step
        const bidK = r.max_bid_step_k, bidT = bidK != null ? v2StepMinutes(site, bidK) : null;
        core += v2Row('Максимальная ставка', money(r.max_bid), bidK == null ? '' : (bidK === 0 ? 'уже по стартовой цене' : `с шага ${bidK}${bidT ? `, ≈ ${fmTimeToPriceLabel(bidT)} после старта` : ''}`));
        const entryK = f('entry_step_k'), entryP = f('entry_price');
        if (entryP != null) {
            core += v2Row('Вход по модели', money(entryP), entryK == null ? '' : (entryK === 0 ? 'по стартовой цене' : `шаг ${entryK}${entryP === last ? ' — пол лестницы' : ''}`));
        }
        core += v2Row('Лот ещё не продан к цене макс. ставки', v2Pct(f('availability_at_max_bid')), 'по истории класса');
        more += v2Group('Лестница цены', core);
    } else if (variant === 'second_round') {
        if (sr) {
            more += v2SecondRoundTimeline(report, sr, site);
        } else {
            core += v2Row('Вторые торги не раньше', v2Date(f('second_round_earliest_date')));
            core += v2Row('Старт вторых торгов', money(f('second_round_start_price')));
            core += v2Row('Пол вторых торгов', money(f('second_round_floor_price')));
            core += v2Row('Максимальная ставка', money(r.max_bid));
            more += v2Group('Вторые торги', core);
        }
    } else {
        const entry = m.rent && m.rent.expected_entry;
        core += v2Row('Ожидаемая цена победы', money(f('expected_winning_price')));
        if (entry && entry.low != null && entry.high != null) {
            core += v2Row('Диапазон', `${fmMoneyNb(entry.low)} — ${fmMoneyNb(entry.high)}`, entry.n ? `по ${entry.n} завершённым торгам аренды` : '');
        }
        core += v2Row('Максимальная ставка', money(r.max_bid));
        core += v2Row('Лот уйдёт не дороже макс. ставки', v2Pct(f('sell_at_or_below_max_bid')), 'по истории класса');
        more += v2Group('Ожидаемая цена', core);
    }
    let fc = v2Row('Обычно уходит за', v2RatioText(f('class_median_final_to_start')), 'медиана по классу');
    if (variant !== 'second_round') fc += v2Row('Перевыставлений этого лота', f('relistings') != null ? String(f('relistings')) : '');
    fc += v2Row('Перевыставления у организатора', f('organizer_reopened_rate_pct') != null ? `${String(f('organizer_reopened_rate_pct')).replace('.', ',')} %` : '',
                f('organizer_lots_seen') ? `по ${f('organizer_lots_seen')} лотам` : '');
    more += v2Group('Прогноз исхода по нашей истории', fc);

    const sales = (report.historical_sales || []).slice(0, 3);
    let hist = sales.map((x) => {
        const drop = typeof x.drop_percent === 'number' && x.drop_percent !== 0 ? `${x.drop_percent > 0 ? '−' : '+'}${Math.abs(Math.round(x.drop_percent))} %` : '';
        return v2Row(String(x.title || 'Лот').slice(0, 70), money(x.final_price), [x.auction_type, drop].filter(Boolean).join(' · '));
    }).join('');
    const th = report.geo_context && report.geo_context.trade_history;
    if (th && th.count) {
        const o = th.outcomes || {};
        const parts = [o.held ? `состоялись ${o.held}` : '', o.failed ? `не состоялись ${o.failed}` : ''].filter(Boolean).join(', ');
        hist += v2Row('Этот объект выставлялся на торги', `${th.count} ${pluralizeRu(th.count, 'раз', 'раза', 'раз')}`, parts);
    }
    more += v2Group('История: похожие продажи и этот объект', hist);
    const hs = report.history_scope;
    if (hs && !hs.enough) {
        const sz = hs.size ? ` по размеру (${[hs.size.rooms ? `комнат ${hs.size.rooms} ± 1` : '', hs.size.area_m2 ? `площадь ${fmAreaNum(hs.size.area_m2)} м² ± 25 %` : ''].filter(Boolean).join(' или ')})` : '';
        more += `<p class="text-caption text-tertiary v2-note">Похожих продаж${sz}${hs.place ? ` в месте лота (${escapeHtml(hs.place)})` : ''} меньше 3 — сравнение с другими городами и размерами не делаем.</p>`;
    }
    const inside = [variant === 'second_round' ? 'вторые торги' : variant === 'ladder' ? 'лестница цены' : 'ожидаемая цена', 'прогноз исхода', hist ? 'история похожих продаж' : ''].filter(Boolean);

    body.innerHTML = v2Block({ lead, tiles, lineHtml, more: more.trim() ? { summary: `Подробнее: ${inside.join(', ')}`, html: more } : null });
    sec.classList.toggle('hidden', false);
}

// ---- v2 section «Деньги» (the finance model + editor stay as they are; this adds the v2 frame around them) ------------
// TASK45 45.5: the «Деньги» block -- lead, four tiles, what is not counted, and ONE toggle that opens the editor / cost table / calculator
const V2_MONEY_NOT_COUNTED_MAX = 4;
function v2MoneyNotCounted(model, vinStatus) {
    let names = [];
    ((model && model.warnings) || []).forEach((w) => {
        const m = /^«([^»]+)»\s+не учтено/.exec(String(w));
        if (m) names.push(m[1].replace(/\s*\(.*\)\s*$/, '').toLowerCase());
    });
    // K2 (2026-10-24): an UNPAID fee is a known cost the profit leaves out -- say so plainly, not as one more «не учтены»
    // item. No amount: recycle.kz gives only paid/unpaid (TASK14 14.3f, owner decision -- never derive a figure).
    const unpaid = vinStatus === 'unpaid' ? 'Утильсбор по VIN не уплачен — прибыль посчитана без него, сумму уточните до торгов.' : '';
    if (unpaid) names = names.filter((n) => !/утилизац/.test(n));
    const rest = names.length ? `Не учтены: ${names.slice(0, V2_MONEY_NOT_COUNTED_MAX).join(', ')}${names.length > V2_MONEY_NOT_COUNTED_MAX ? ` и ещё ${names.length - V2_MONEY_NOT_COUNTED_MAX}` : ''}.` : '';
    return [unpaid, rest].filter(Boolean).join(' ');
}
function v2MoneySigned(v) { return v == null ? '' : `${v < 0 ? '−' : ''}${fmPriceCompactStrict(Math.abs(v))} ₸`; }
function v2MoneyTiles(report, variant) {
    const m = report.financial_model || {};
    const r = m.results || {};
    const f = (g, k) => v2Fact(report, g, k);
    const c = (v) => (v == null ? '' : `${fmPriceCompactStrict(v)} ₸`);
    if (variant === 'rent') {
        const vs = f('market', 'rent_vs_market');
        const perM2 = f('money', 'rent_per_m2');
        const vsText = vs == null ? '' : `${vs > 0 ? '+' : vs < 0 ? '−' : ''}${Math.abs(Math.round(vs * 100))} %`;
        const pay = f('money', 'monthly_payment');
        return {
            lead: pay != null ? `Платёж ${fmMoneyNb(pay)} в месяц${vs == null ? '; рыночной аренды для сравнения нет.' : `: ${Math.abs(Math.round(vs * 100))} % ${vs > 0 ? 'дороже' : 'дешевле'} рынка аренды.`}` : '',
            tiles: [
                { label: 'Платёж в месяц', value: c(pay), sub: 'при ожидаемой цене торгов' },
                { label: 'Задаток', value: c(f('money', 'deposit_locked')), sub: 'до договора' },
                { label: 'Платёж за м²', value: perM2 != null ? `${fmMoneyNb(perM2)}` : '', sub: 'в месяц' },
                { label: 'К рынку', value: vsText, sub: 'рыночная аренда', tone: vs == null ? '' : (vs > 0 ? 'neg' : 'pos') },
            ],
        };
    }
    if (m.mode === 'lease') {
        const rent = m.rent || {};
        const win = f('trades', 'expected_winning_price');
        const rightEnd = (report.financial_platform_attrs_override || {}).lease_resale && (report.financial_platform_attrs_override || {}).passport_override
            ? report.financial_platform_attrs_override.passport_override.right_end_year : null;
        const years = f('object', 'lease_term_years');
        const fee = rent.annual_fee || {};
        const feeByContract = /по действующему договору/.test(String(fee.label || fee.source || ''));
        return {
            lead: rent.not_computed_reason ? '' : String(fmLeaseConditionSentence(rent) || '').split(/\.\s/)[0].replace(/\.?$/, '.'),      // «Ответ» already says why nothing is computed     // one sentence; the rest of the reason lives in the editor
            tiles: [
                { label: 'Старт', value: c(f('trades', 'start_price')), sub: 'цена права' },
                rent.max_bid != null ? { label: 'Макс. платёж', value: c(rent.max_bid), sub: 'разово' } : { label: 'Ожидаемая цена', value: c(win), sub: 'по истории класса' },
                { label: rightEnd ? 'Остаток срока' : 'Срок права', value: years != null ? ruYears(years) : '', sub: rightEnd ? `до ${rightEnd} г.` : '' },
                { label: 'Годовая плата', value: fee.amount_kzt ? c(fee.amount_kzt) : (feeByContract ? 'по договору' : ''), sub: feeByContract ? 'запросите у продавца' : '' },
            ],
        };
    }
    const entry = (m.purchase || {}).price, sale = (m.sale || {}).mid, profit = r.profit_mid, roi = r.roi_mid;
    const lead = entry != null && sale != null && profit != null
        ? `Купили по ${fmPriceCompactStrict(entry)} ₸, продали за ${fmPriceCompactStrict(sale)} ₸ — ${profit >= 0 ? 'прибыль' : 'убыток'} ${fmPriceCompactStrict(Math.abs(profit))} ₸ после налога и расходов.` : '';
    return {
        lead,
        tiles: [
            { label: 'Вход', value: c(entry), sub: (m.purchase || {}).step_k != null ? (m.purchase.step_k === 0 ? 'по старту' : `шаг ${m.purchase.step_k}${m.purchase.floor_price != null && entry === m.purchase.floor_price ? ' · пол лестницы' : ''}`) : '' },
            { label: 'Продажа', value: c(sale), sub: (m.sale || {}).haircut_pct ? `скидка при продаже ${m.sale.haircut_pct} %` : '' },
            { label: 'Прибыль', value: v2MoneySigned(profit), sub: 'после налога и расходов', tone: profit == null ? '' : (profit >= 0 ? 'pos' : 'neg') },
            { label: 'На вложенное', value: roi != null ? `${roi > 0 ? '+' : roi < 0 ? '−' : ''}${Math.abs(Math.round(roi * 100))} %` : '', sub: r.payback_days ? `за ~${r.payback_days} дн.` : '', tone: roi == null ? '' : (roi >= 0 ? 'pos' : 'neg') },
        ],
    };
}
window.v2MoneyToggle = (open) => {
    const sec = document.getElementById('sec-financials');
    if (!sec) return;
    sec.classList.toggle('v2-money-open', open == null ? !sec.classList.contains('v2-money-open') : Boolean(open));
};
window.v2MoneyRecalc = () => {
    window.v2MoneyToggle(true);
    if (typeof fmSetMode === 'function') { try { fmSetMode('mine'); } catch (e) { /* the editor is not ready: it opens as it is */ } }
    const ed = document.getElementById('fmEditor') || document.getElementById('rentModelBox');
    if (ed) ed.scrollIntoView({ behavior: 'smooth', block: 'start' });
};
function renderV2MoneyBlock(report, variant, suspect) {
    const el = document.getElementById('v2MoneyBlock');
    const sec = document.getElementById('sec-financials');
    if (!el || !sec) return;
    sec.classList.remove('v2-money-open');
    if (variant === 'hidden') { el.innerHTML = ''; el.classList.add('hidden'); return; }
    const parts = suspect ? { lead: '', tiles: [] } : v2MoneyTiles(report, variant);
    // reports built before the K2 fix carry the VIN status only in financial_inputs_ai, not in the model
    const vinStatus = (report.financial_model || {}).utilization_fee_vin_status || (report.financial_inputs_ai || {}).utilization_fee_vin_status;
    const line = suspect ? '' : v2MoneyNotCounted(report.financial_model, vinStatus);
    const html = v2Block({ lead: parts.lead, tiles: parts.tiles, line });
    el.innerHTML = html + `<div class="v2-money-actions"><button type="button" class="btn-secondary" onclick="v2MoneyRecalc()">Пересчитать под свои цифры</button>`
        + `<button type="button" class="btn-ghost v2-money-toggle" onclick="v2MoneyToggle()"><span>Подробнее: все расходы</span><i class="ph-bold ph-caret-down"></i></button></div>`;
    el.classList.remove('hidden');
}

function renderV2Money(report) {
    const sec = document.getElementById('sec-financials');
    if (!sec) return;
    const variant = report.ui && report.ui.sections && report.ui.sections.money;
    sec.classList.toggle('v2-hidden', variant === 'hidden');           // «Прочее»: no ROI economics at all
    const title = sec.querySelector('.report-section-title');
    if (title) title.textContent = 'Деньги';

    // the writer's money paragraph replaces the old «Вывод по модели»
    const noteEl = document.getElementById('v2MoneyNote');
    if (noteEl) {
        const note = report.writer && report.writer.note_money;
        noteEl.innerHTML = note ? `<p class="text-body text-secondary report-prose">${escapeHtml(note)}</p>` : '';
        noteEl.classList.toggle('hidden', !note);
    }

    // price sanity (TASK28): a suspect platform price -> a warning, no economics derived from it, only the max bid
    const root = document.getElementById('screen-analysis');
    const suspect = v2Fact(report, 'quality', 'price_suspect') === true;
    if (root) root.classList.toggle('v2-price-suspect', suspect);
    // premise rent (TASK36): a monthly payment against the market rent -- no resale calculator, no sale economics
    if (root) root.classList.toggle('v2-rent', variant === 'rent');
    renderV2RentMoney(report, variant === 'rent');
    const warnEl = document.getElementById('v2MoneyWarn');
    if (warnEl) {
        if (suspect) {
            const chk = v2Fact(report, 'quality', 'price_check') || {};
            const likely = chk.likely_price != null ? chk.likely_price : null;
            const bid = v2Fact(report, 'money', 'max_bid'), be = v2Fact(report, 'money', 'break_even_purchase');
            const rows = [
                ['Максимальная ставка (не зависит от цены площадки)', bid != null ? fmMoneyNb(bid) : ''],
                ['Безубыточность', be != null ? fmMoneyNb(be) : ''],
                ['Вероятная стартовая цена', likely != null ? fmMoneyNb(likely) : ''],
            ].filter(([, v]) => v);
            warnEl.innerHTML = reportCalloutHTML(`Цена на площадке указана с ошибкой${chk.platform_price != null ? ` (${fmMoneyNb(chk.platform_price)})` : ''}. Расчёт доходности по ней не ведётся: ориентируйтесь на максимальную ставку и проверьте цену на площадке до участия.`)
                + (rows.length ? `<div class="report-panel" style="margin-top:12px;">${rows.map(([k, v]) => `<div class="report-fin-row"><span class="text-caption text-secondary">${escapeHtml(k)}</span><span class="text-body font-mono-nums text-primary">${escapeHtml(v)}</span></div>`).join('')}</div>` : '');
            warnEl.classList.remove('hidden');
        } else {
            warnEl.innerHTML = '';
            warnEl.classList.add('hidden');
        }
    }

    renderV2MoneyBlock(report, variant, suspect);

    // liquidity from DATA (class sale rate, listings in the sample), not the AI's word
    const liquidity = ((report.verdict_engine.component_reasons || {}).liquidity || [])[0];
    const liqEl = document.getElementById('uiLiquidity');
    if (liqEl && liquidity) liqEl.textContent = liquidity.text.replace(/^Ликвидность по данным:\s*/, '');
    const periodRow = document.getElementById('uiSalesPeriod');
    const periodLabel = periodRow && periodRow.parentElement && periodRow.parentElement.querySelector('.text-secondary');
    if (periodLabel && !/оценка ИИ/.test(periodLabel.textContent)) periodLabel.textContent = 'Ожидаемый срок продажи (оценка ИИ)';
}

// ---- the rent model editor (TASK37 37.0 п.7): «Оценка ИИ» / «Мои цифры» over GET/PUT/DELETE /api/lot/{id}/rent-model ----------
let rentModelState = null;      // {model, overrides, source, taxRates}
let rentModelTimer = null;
const RENT_SRC = { documents: 'документы', engine: 'расчёт', platform: 'площадка', default: 'по умолчанию', user: 'ваша цифра', none: 'нет данных' };

function rentSrcChip(input) {
    if (!input) return '';
    const label = RENT_SRC[input.source] || input.source;
    const title = input.quote ? ` title="${escapeHtml(input.quote)}"` : '';
    return `<span class="status-chip"${title}>${escapeHtml(label)}</span>`;
}

function renderV2RentMoney(report, active) {
    const el = document.getElementById('v2RentMoney');
    if (!el) return;
    if (!active) { el.innerHTML = ''; el.classList.add('hidden'); rentModelState = null; return; }
    const f = (g, k) => v2Fact(report, g, k);
    const money = (v) => (v == null ? '' : fmMoneyNb(v));
    let html = v2Group('Платёж', v2Row('Ежемесячный платёж', money(f('money', 'monthly_payment')), 'при ожидаемой цене торгов; стартовый платёж — самый низкий из возможных')
        + v2Row('Площадь помещения', f('object', 'premise_area_m2') != null ? `${String(f('object', 'premise_area_m2')).replace('.', ',')} м²` : '')
        + v2Row('Гарантийный взнос', money(f('money', 'deposit_locked')), 'замораживается до заключения договора; в стоимость не входит'));
    html += '<div id="rentModelBox"></div>';
    el.innerHTML = html;
    el.classList.remove('hidden');
    if (typeof userId !== 'undefined' && userId && state.currentLot) loadRentModel(state.currentLot.id);
    else document.getElementById('rentModelBox').innerHTML = reportCalloutHTML('Войдите, чтобы посчитать свою модель аренды: платежи за срок, отделку и безубыточную ставку субаренды.');
}

async function loadRentModel(lotId) {
    const box = document.getElementById('rentModelBox');
    try {
        const r = await fetch(`/api/lot/${encodeURIComponent(lotId)}/rent-model?user_id=${userId}`);
        if (!r.ok) throw new Error(String(r.status));
        const d = await r.json();
        rentModelState = { lotId, model: d.model, overrides: d.overrides || {}, source: d.source, taxRates: d.tax_rates || {} };
        renderRentModelEditor();
    } catch (e) {
        if (box) box.innerHTML = reportCalloutHTML('Модель аренды недоступна для этого отчёта.');
    }
}

function renderRentModelEditor() {
    const box = document.getElementById('rentModelBox');
    const st = rentModelState;
    if (!box || !st) return;
    const inp = st.model.inputs;
    const num = (v) => (v == null ? '' : String(v).replace('.', ','));
    const changed = Object.keys(st.overrides || {}).length;
    const field = (key, label, extra = {}) => {
        const i = inp[key] || {};
        const hint = extra.hint != null ? `<span class="text-caption text-tertiary">${escapeHtml(extra.hint)}</span>` : '';
        const note = i.note && extra.note !== false ? `<span class="text-caption text-tertiary">${escapeHtml(i.note)}</span>` : '';
        return `<div class="fm-field"><label class="text-caption text-secondary" for="rm_${key}">${escapeHtml(label)} ${rentSrcChip(i)}</label>
            <input type="text" inputmode="decimal" id="rm_${key}" class="fm-input font-mono-nums" value="${escapeHtml(num(i.value))}" placeholder="${escapeHtml(extra.placeholder || 'введите')}" oninput="rentModelInput('${key}', this.value)">${hint}${note}</div>`;
    };
    const taxMode = (inp.tax_mode || {}).value || 'none';
    const rates = st.taxRates || {};
    const taxField = `<div class="fm-field"><label class="text-caption text-secondary" for="rm_tax_mode">Налог на доход от субаренды ${rentSrcChip(inp.tax_mode)}</label>
        <select id="rm_tax_mode" class="fm-select" onchange="rentModelInput('tax_mode', this.value)">
            <option value="none"${taxMode === 'none' ? ' selected' : ''}>не учитывать</option>
            ${rates.ip_simplified != null ? `<option value="ip_simplified"${taxMode === 'ip_simplified' ? ' selected' : ''}>ИП упрощённый, ${String(rates.ip_simplified).replace('.', ',')} %</option>` : ''}
            ${rates.too_simplified != null ? `<option value="too_simplified"${taxMode === 'too_simplified' ? ' selected' : ''}>ТОО упрощённый, ${String(rates.too_simplified).replace('.', ',')} %</option>` : ''}
            <option value="custom"${taxMode === 'custom' ? ' selected' : ''}>своя ставка</option></select></div>`
        + (taxMode === 'custom' ? field('tax_rate_pct', 'Ставка налога, %', { placeholder: '0', note: false }) : '');
    const hint = inp.sublease_per_m2 && inp.sublease_per_m2.hint != null ? `по району ≈ ${fmMoneyNb(inp.sublease_per_m2.hint)} за м² — справочно, это не рынок этого помещения` : null;
    box.innerHTML = `<div class="fm-editor">
        <div class="fm-header"><div class="fm-toggle" role="tablist">
            <button type="button" class="fm-toggle-btn${changed ? '' : ' active'}" onclick="rentModelReset()">Оценка ИИ</button>
            <button type="button" class="fm-toggle-btn${changed ? ' active' : ''}" onclick="document.getElementById('rm_fitout_per_m2').focus()">Мои цифры</button></div>
            <div class="fm-header-meta">${changed ? `<span class="text-caption text-secondary">изменено: ${changed}</span><button type="button" class="btn-ghost fm-reset-btn" onclick="rentModelReset()">Сбросить</button>` : ''}</div></div>
        <div class="report-panel"><div class="fm-entry-controls">
            ${field('monthly_payment', 'Платёж в месяц, ₸', { note: false })}
            ${field('term_months', 'Срок аренды, мес.', { note: false })}
            ${field('fitout_per_m2', 'Отделка, ₸/м²')}
            ${field('sublease_per_m2', 'Субаренда, ₸/м² в месяц', { hint })}
            ${field('occupancy_pct', 'Загрузка, %', { note: false })}
            ${field('opex_per_month', 'Расходы в месяц, ₸')}
            ${taxField}</div></div>
        <div id="rentModelOut"></div></div>`;
    renderRentModelOutputs();
}

function renderRentModelOutputs() {
    const out = document.getElementById('rentModelOut');
    const st = rentModelState;
    if (!out || !st) return;
    const o = st.model.outputs || {};
    const m = (v) => (v == null ? '' : fmMoneyNb(v));
    const pos = (v) => (v == null ? '' : `${v >= 0 ? '+' : '−'}${fmMoneyNb(Math.abs(v))}`);
    let html = `<div class="v2-main"><p class="text-caption text-secondary">Сдавать дороже, чтобы выйти в ноль за срок</p>
        <p class="text-title font-mono-nums text-primary v2-main-value">${o.breakeven_sublease_per_m2 != null ? `${fmMoneyNb(o.breakeven_sublease_per_m2)} за м² в месяц` : '—'}</p>
        ${o.fitout_included ? '' : '<p class="text-caption text-tertiary">без стоимости отделки: введите её ₸/м² выше</p>'}</div>`;
    let rows = v2Row('Платежи за весь срок', m(o.total_payments), o.term_months ? `${o.term_months} мес.` : '')
        + v2Row('Отделка', o.fitout_total != null ? m(o.fitout_total) : 'не учтена')
        + v2Row('Расходы за срок', m(o.opex_total))
        + v2Row('Всего затрат', m(o.total_cost));
    if (o.sublease_income != null) {
        rows += v2Row('Доход от субаренды', m(o.sublease_income)) + (o.tax ? v2Row('Налог', m(o.tax), st.model.outputs.tax_note || '') : '')
            + v2Row('Прибыль за срок', pos(o.profit))
            + v2Row('Месяцев на окупаемость отделки', o.months_to_recover_fitout != null ? String(o.months_to_recover_fitout).replace('.', ',') : '');
    }
    html += v2Group('Итоги за срок', rows);
    if ((st.model.warnings || []).length) html += st.model.warnings.map((w) => reportCalloutHTML(w)).join('');
    out.innerHTML = html;
}

function rentModelInput(key, value) {
    const st = rentModelState;
    if (!st) return;
    const raw = String(value).replace(/\s/g, '').replace(',', '.');
    st.overrides = { ...st.overrides, [key]: key === 'tax_mode' ? value : (raw === '' ? null : Number(raw)) };
    if (key !== 'tax_mode' && raw !== '' && Number.isNaN(Number(raw))) return;
    clearTimeout(rentModelTimer);
    rentModelTimer = setTimeout(async () => {
        try {
            const r = await fetch(`/api/lot/${encodeURIComponent(st.lotId)}/rent-model`, {
                method: 'PUT', headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ user_id: userId, overrides: st.overrides }) });
            const d = await r.json().catch(() => ({}));
            if (!r.ok) return;
            const needsRedraw = key === 'tax_mode';
            rentModelState = { ...st, model: d.model, overrides: d.overrides || {}, source: d.source };
            if (needsRedraw) renderRentModelEditor(); else renderRentModelOutputs();
        } catch (e) { console.warn('rent-model PUT', e); }
    }, 500);
}

async function rentModelReset() {
    const st = rentModelState;
    if (!st) return;
    try {
        const r = await fetch(`/api/lot/${encodeURIComponent(st.lotId)}/rent-model?user_id=${userId}`, { method: 'DELETE' });
        if (!r.ok) return;
        const d = await r.json();
        rentModelState = { ...st, model: d.model, overrides: {}, source: 'ai_default' };
        renderRentModelEditor();
    } catch (e) { console.warn('rent-model DELETE', e); }
}

// ---- v2 section «Рынок» ----------------------------------------------------------------------------------------------
// Only what is real: listings of OUR OWN scrape (market_sample), our own trades, the appraisal from documents. The AI's
// distribution (20/60/20), its «comparables» and its location prose are gone; the reliability level is said plainly.
// TASK45 45.0 C4: the median is a PRICE PER UNIT (₸/м², ₸/сотка) and the total for THIS object is a separate number -- never a total labelled as per-m²
function v2MarketMedianText(sample, mid) {
    const unit = String(sample.unit || '');
    const per = unit.startsWith('₸/') ? unit.slice(2) : '';
    const qty = Number(sample.quantity);
    if (per === 'место' && sample.median != null) return `медиана ${fmMoneyNb(sample.median)} за место`;
    if (per && sample.median != null && qty > 0 && mid != null) {
        const noun = per === 'сотка' ? pluralizeRu(Math.round(qty), 'сотку', 'сотки', 'соток') : per;
        return `медиана ${fmPriceCompactStrict(sample.median)} ₸/${per} → ${fmPriceCompactStrict(mid)} ₸ за ${fmAreaNum(qty)} ${noun}`;
    }
    return mid != null ? `медиана ${fmMoneyNb(mid)}` : '';
}
function v2MarketStatement(report) {
    const rel = v2Fact(report, 'market', 'reliability');
    const n = v2Fact(report, 'market', 'real_sample_n') || 0;
    const sample = report.market_sample || {};
    const site = sample.source === 'kolesa' ? 'Kolesa' : 'Krisha';
    const mid = v2Fact(report, 'market', 'market_mid');
    // TASK36 36.4: parking / premises are priced by the lot's own building or street (or not at all)
    const scope = v2Fact(report, 'market', 'local_scope');
    const scopeNote = (report.dossier && report.dossier.market && report.dossier.market.local_scope && report.dossier.market.local_scope.note) || '';
    const districtMedian = v2Fact(report, 'market', 'local_district_median'), districtN = v2Fact(report, 'market', 'local_district_n');
    const noLocal = scope === 'none'
        ? ` ${scopeNote.charAt(0).toUpperCase() + scopeNote.slice(1)} (в доме: ${v2Fact(report, 'market', 'local_building_n') || 0}, на улице: ${v2Fact(report, 'market', 'local_street_n') || 0}, нужно не меньше 5).`
          + (districtMedian != null ? ` По району ${districtN} ${pluralizeRu(districtN, 'объявление', 'объявления', 'объявлений')}, медиана ${fmMoneyNb(districtMedian)} — справочно, это не рынок лота.` : '')
        : '';
    if (rel === 'data') {
        const median = v2MarketMedianText(sample, mid);
        if (scope === 'building' || scope === 'street') {
            return { text: `Рынок ${scopeNote || 'по объявлениям'} ${site}${median ? `: ${median}` : ''}.`, warn: false };
        }
        return { text: `Рынок по ${n} ${pluralizeRu(n, 'объявлению', 'объявлениям', 'объявлениям')} ${site}${median ? `: ${median}` : ''}.`, warn: false };
    }
    if (rel === 'documents') {
        const appr = v2Fact(report, 'market', 'appraisal_documents');
        return { text: `Оценка из документов${appr != null ? `: ${fmMoneyNb(appr)}` : ''}. Реальной выборки объявлений нет, поэтому это не рыночная цена.`, warn: false };
    }
    if (rel === 'llm') {
        return { text: `Оценка ИИ${n ? ` (найдено объявлений: ${n})` : ''} не подтверждена объявлениями.${noLocal} Вердикт при такой оценке — не выше «условно».`, warn: true };
    }
    return { text: `Рынок не определён: реальных объявлений нет, оценки в документах нет.${noLocal} Вердикт — не выше «условно».`, warn: true };
}

function v2RangeBar(low, mid, high, marks) {
    if (low == null || high == null || high <= low) return '';
    const cm = (v) => `${fmPriceCompactStrict(v)} ₸`;      // §7.13: a number is in full once; the bar speaks in compact form
    const pad = (high - low) * 0.15;
    const lo = Math.max(0, low - pad), hi = high + pad;
    const pos = (x) => Math.max(0, Math.min(100, ((x - lo) / (hi - lo)) * 100));
    const markHtml = marks.filter((x) => x.value != null).map((x) => `<span class="v2-range-mark${x.entry ? ' v2-range-mark--entry' : ''}" style="left:${pos(x.value)}%" title="${escapeHtml(x.label)}: ${escapeHtml(fmMoneyNb(x.value))}"></span>`).join('');
    const legend = marks.filter((x) => x.value != null).map((x) => `<span class="text-caption text-secondary"><span class="v2-dot${x.entry ? ' v2-dot--entry' : ''}"></span>${escapeHtml(x.label)} <span class="font-mono-nums text-primary">${escapeHtml(cm(x.value))}</span></span>`).join('');
    return `<div class="v2-range" role="img" aria-label="Диапазон рыночных цен">
            <span class="v2-range-span" style="left:${pos(low)}%;width:${pos(high) - pos(low)}%"></span>
            ${mid != null ? `<span class="v2-range-mid" style="left:${pos(mid)}%"></span>` : ''}${markHtml}</div>
        <div class="v2-range-captions text-micro font-mono-nums text-tertiary"><span>${escapeHtml(cm(low))}</span><span>${mid != null ? escapeHtml(cm(mid)) : ''}</span><span>${escapeHtml(cm(high))}</span></div>
        <div class="v2-legend">${legend}</div>`;
}

// a range in one unit: «86,6–117,8 млн ₸» (two separate compact numbers do not fit a phone tile)
function v2RangeCompact(low, high) {
    if (low == null || high == null) return '';
    if (Math.min(low, high) >= 1e6) {
        const n = (v) => (v / 1e6).toFixed(1).replace('.', ',');
        return `${n(low)}–${n(high)} млн ₸`;
    }
    return `${fmPriceCompactStrict(low)}–${fmPriceCompactStrict(high)}`;
}
function renderV2RentMarket(report, sec, body) {
    const rm = report.rent_market || {};
    const f = (k) => v2Fact(report, 'market', k);
    const scope = (report.dossier && report.dossier.market && report.dossier.market.rent_market_scope && report.dossier.market.rent_market_scope.note) || 'по городу';
    const n = f('rent_market_n') || 0;
    const data = f('reliability') === 'data';
    const per = (v) => (v == null ? '' : `${fmMoneyNb(Math.round(v))}`);
    let html = data ? '' : reportCalloutHTML(`Рынок аренды не определён: найдено объявлений аренды — ${n} (${scope}), нужно не меньше 5 однородных. Вердикт не выше «условно».`);
    const lead = data ? `Рынок аренды ${scope}: медиана ${fmMoneyNb(f('rent_market_median'))} за 1 м² в месяц.` : '';
    const tiles = data ? [
        { label: 'Медиана', value: per(f('rent_market_median')), sub: 'за м² в месяц' },
        { label: 'Диапазон', value: f('rent_market_p25') != null ? `${fmPriceCompactStrict(f('rent_market_p25'))}–${fmPriceCompactStrict(f('rent_market_p75'))}` : '', sub: 'p25–p75 за м²' },
        { label: 'Объявлений', value: String(n), sub: 'Krisha' },
    ] : [];
    let more = v2Notes(report, 'note_market');
    const listings = Array.isArray(rm.listings) ? rm.listings.filter((x) => x && x.url && x.price) : [];
    if (data && listings.length) {
        more += `<h4 class="text-body text-primary v2-block-title">Объявления из выборки</h4><div>${listings.map((x) => `<div class="v2-listing"><a href="${escapeHtml(x.url)}" target="_blank" rel="noopener" class="text-body">Krisha${x.area ? ` · ${escapeHtml(String(x.area).replace('.', ','))} м²` : ''}</a><span class="text-body font-mono-nums text-primary">${escapeHtml(fmMoneyNb(x.price))}</span></div>`).join('')}</div>`;
    }
    if (rm.query_url) more += `<p class="v2-note"><a href="${escapeHtml(rm.query_url)}" target="_blank" rel="noopener" class="btn-secondary">Открыть поиск аренды на Krisha <i class="ph-bold ph-arrow-square-out"></i></a></p>`;
    html += v2Block({ lead, tiles, more: more.trim() ? { summary: `Подробнее: ${listings.length ? 'объявления, ' : ''}ссылка на Krisha`, html: more } : null });
    body.innerHTML = html;
    body.classList.remove('hidden');
    const leaseEl = document.getElementById('v2LeaseMarket');
    if (leaseEl) { leaseEl.innerHTML = ''; leaseEl.classList.add('hidden'); }
}

function renderV2Market(report) {
    const sec = document.getElementById('sec-market');
    const body = document.getElementById('v2MarketBody');
    if (!sec || !body) return;
    const variant = report.ui && report.ui.sections && report.ui.sections.market;
    sec.classList.toggle('v2-hidden', variant === 'hidden');
    const title = sec.querySelector('.report-section-title');
    if (title) title.textContent = 'Рынок';
    if (variant === 'rent') { renderV2RentMarket(report, sec, body); return; }
    const f = (k) => v2Fact(report, 'market', k);
    const money = (v) => (v == null ? '' : fmMoneyNb(v));
    const st = v2MarketStatement(report);
    const rel = f('reliability');
    const sample = report.market_sample || {};
    const site = sample.source === 'kolesa' ? 'Kolesa' : 'Krisha';
    const low = f('market_low'), mid = f('market_mid'), high = f('market_high');
    const entry = v2Fact(report, 'trades', 'expected_winning_price') != null ? v2Fact(report, 'trades', 'expected_winning_price') : v2Fact(report, 'trades', 'entry_price');
    const disc = f('discount_to_market');
    const n = f('real_sample_n') || 0;
    // per-unit forms («607 тыс ₸/м²»), only where the sample is priced per unit and the object has a quantity (TASK45 45.0 C4)
    const per = String(sample.unit || '').startsWith('₸/') ? String(sample.unit).slice(2) : '';
    const qty = Number(sample.quantity);
    const unitOf = (v) => (per && per !== 'место' && qty > 0 && v != null ? `${fmPriceCompactStrict(v / qty)} ₸/${per}` : '');
    const c = (v) => (v == null ? '' : `${fmPriceCompactStrict(v)} ₸`);
    const real = variant !== 'lease' && rel === 'data' && mid != null && entry != null;
    // lead: the entry against the median (or what the market tier is, in words)
    let lead = '';
    let html = '';
    let warnFull = '';
    if (real) {
        lead = `Вход ${unitOf(entry) || c(entry)} — ${disc != null && disc < 0 ? `на ${Math.abs(Math.round(disc * 100))} % выше` : `на ${Math.abs(Math.round((disc != null ? disc : 1 - entry / mid) * 100))} % ниже`} медианы ${unitOf(mid) || c(mid)}${n ? ` (${n} ${pluralizeRu(n, 'объявление', 'объявления', 'объявлений')} ${site})` : ''}.`;
    } else if (st.warn) {
        // the default view says what the market IS and what it does to the verdict; the counts by building / street / district go to «Подробнее»
        const brief = `${v2OneSentence(st.text, 150)}${/не выше «условно»/.test(st.text) && !/не выше «условно»/.test(v2OneSentence(st.text, 150)) ? ' Вердикт — не выше «условно».' : ''}`;
        html += reportCalloutHTML(brief);
        warnFull = brief === st.text ? '' : `<p class="text-body text-secondary report-prose">${escapeHtml(st.text)}</p>`;
    } else {
        lead = st.text;
    }
    const tiles = [];
    if (variant !== 'lease' && rel && rel !== 'none') {
        tiles.push({ label: 'Вход', value: c(entry), sub: unitOf(entry) });
        tiles.push({ label: rel === 'data' ? 'Медиана' : 'Оценка', value: c(mid), sub: unitOf(mid) });
        tiles.push({ label: 'Диапазон', value: v2RangeCompact(low, high), sub: rel === 'data' ? 'p25–p75' : '' });
        if (rel === 'data') tiles.push({ label: 'Объявлений', value: String(n), sub: site });
    }
    html += v2Block({ lead, tiles });
    if (variant !== 'lease' && rel && rel !== 'none') {
        html += v2RangeBar(low, mid, high, [{ label: 'вход', value: entry, entry: true }, { label: 'старт', value: v2Fact(report, 'trades', 'start_price'), entry: false }]);
    }

    // «Подробнее»: the listings of the sample, the search link, our archive, competitors (never the AI's «comparables»)
    let more = warnFull + v2Notes(report, 'note_market');
    const listings = Array.isArray(sample.listings) ? sample.listings.filter((x) => x && x.url && x.price) : [];
    if (variant !== 'lease' && rel === 'data' && listings.length) {
        const sorted = listings.slice().sort((a, b) => (a.unit_price || a.price) - (b.unit_price || b.price));
        const pick = [0, 0.25, 0.5, 0.75, 1].map((q) => sorted[Math.min(sorted.length - 1, Math.round(q * (sorted.length - 1)))]);
        const uniq = pick.filter((x, i) => pick.indexOf(x) === i);
        more += `<h4 class="text-body text-primary v2-block-title">Объявления из выборки</h4><div>${uniq.map((x) => {
            const bits = [x.area ? `${String(x.area).replace('.', ',')} м²` : '', x.year || '', x.mileage_km ? `${x.mileage_km.toLocaleString('ru-RU')} км` : ''].filter(Boolean).join(' · ');
            return `<div class="v2-listing"><a href="${escapeHtml(x.url)}" target="_blank" rel="noopener" class="text-body">${site}${bits ? ` · ${escapeHtml(String(bits))}` : ''}</a><span class="text-body font-mono-nums text-primary">${escapeHtml(fmMoneyNb(x.price))}</span></div>`;
        }).join('')}</div>`;
        const how = [sample.target_label ? `подбор: ${sample.target_label}` : '', Array.isArray(sample.widening) && sample.widening.length ? `расширение: ${sample.widening.join('; ')}` : ''].filter(Boolean).join(' · ');
        if (how) more += `<p class="text-caption text-tertiary v2-note">${escapeHtml(how)}</p>`;
        if (sample.query_url) more += `<p class="v2-note"><a href="${escapeHtml(sample.query_url)}" target="_blank" rel="noopener" class="btn-secondary">Открыть поиск на ${site} <i class="ph-bold ph-arrow-square-out"></i></a></p>`;
    }
    // TASK45 45.0 C5: under 3 similar sales a «median» says nothing -- the line goes away
    const archiveN = f('own_trades_comparable_n');
    let extra = archiveN >= 3 ? v2Row('Похожие торги в нашем архиве', `${archiveN} шт.`, f('own_trades_comparable_median') ? `медиана ${fmMoneyNb(f('own_trades_comparable_median'))}` : '') : '';
    const la = report.location_analysis || {};
    if (la.geo_data_source === 'google_places' && la.nearby_competitors_count != null) {
        extra += v2Row('Конкурентов рядом', String(la.nearby_competitors_count), la.geo_search_radius_m ? `в радиусе ${la.geo_search_radius_m} м, Google Places` : 'Google Places');
    }
    more += v2Group('Что ещё известно', extra);
    const inside = [listings.length && rel === 'data' ? 'объявления' : '', sample.query_url && rel === 'data' ? `ссылка на ${site}` : '', extra ? 'архив торгов' : ''].filter(Boolean);
    html += v2Block({ more: more.trim() ? { summary: `Подробнее${inside.length ? `: ${inside.join(', ')}` : ''}`, html: more } : null });
    body.innerHTML = html;
    body.classList.remove('hidden');

    // the land-lease reference numbers (our own lease auctions, a sale/rent sample) -- display only
    const leaseEl = document.getElementById('v2LeaseMarket');
    if (leaseEl) {
        if (variant === 'lease') renderLeaseMarketSite(report.lease_market, 'v2LeaseMarket');
        else { leaseEl.innerHTML = ''; leaseEl.classList.add('hidden'); }
    }
}

// ---- v2 section «Проверка объекта» (risks + legal status + documents in one place) ---------------------------------
const V2_ENCUMBRANCE_TEXT = {
    'нет': 'не выявлено', 'залог': 'залог', 'арест': 'арест', 'залог_и_арест': 'залог и арест',
    'иное': 'имеется — характер уточняйте', 'не_установлено': 'не установлено документами',
};
const V2_OCCUPANTS_TEXT = { 'нет': 'не выявлено', 'прописаны_третьи_лица': 'прописаны третьи лица', 'несовершеннолетние': 'прописаны несовершеннолетние', 'не_установлено': 'не установлено документами' };
const V2_TITLE_TEXT = { 'нет': 'рисков не выявлено', 'незавершенная_приватизация': 'незавершённая приватизация', 'оспоримость_банкротство': 'риск оспаривания (банкротство)', 'иное': 'риск оспаривания (иное основание)', 'не_установлено': 'не установлено документами' };
const V2_DOCS_TEXT = { 'полный': 'полный', 'частичный': 'неполный', 'отсутствует': 'отсутствует' };
const V2_RISK_CATEGORY = {
    'обременение_арест': 'Обременение/Арест', 'незавершенная_приватизация': 'Незаверш. приватизация', 'третьи_лица_прописаны': 'Прописаны третьи лица',
    'несовершеннолетние': 'Несовершеннолетние', 'оспоримость_банкротство': 'Оспоримость (банкротство)', 'неполный_пакет_документов': 'Неполный пакет документов',
    'финансовый_риск': 'Финансовый риск', 'технический_риск': 'Технический риск', 'иное': 'Иное',
};

function v2FactRow(report, group, key, label, textMap) {
    const f = report.dossier && report.dossier[group] && report.dossier[group][key];
    // a fact the documents did not state is still a row (the verdict scored it as «не установлено»), just without a source
    if (!f || f.value == null) {
        return `<div class="report-fin-row"><span class="text-caption text-secondary">${escapeHtml(label)}</span><span class="text-body text-secondary">не установлено документами</span></div>`;
    }
    const text = textMap ? (textMap[f.value] || String(f.value).replace(/_/g, ' ')) : String(f.value);
    return `<div class="report-fin-row"><span class="text-caption text-secondary">${escapeHtml(label)}</span><span class="text-body text-primary">${escapeHtml(text)} ${v2SourceChip(f.source)}</span></div>`;
}

// TASK37 37.4: the list of encumbrances -- kind, who imposed it, amount, date, lifted after the sale (only when the document says
// so), the quote collapsed. More than 5 rows: the first 5, the rest behind «ещё N».
const V2_ENC_KIND = { 'арест': 'Арест', 'залог': 'Залог', 'действующая_аренда': 'Действующая аренда', 'запрет_сделок': 'Запрет сделок', 'сервитут': 'Сервитут', 'иное': 'Иное' };
const V2_ENC_AUTH = { 'чси_этого_производства': 'ЧСИ этих торгов', 'другой_чси': 'другой ЧСИ', 'суд': 'суд', 'налоговый': 'налоговый орган',
    'уголовное_дело': 'уголовное дело', 'банк': 'банк', 'иное': 'иной орган', 'не_установлено': 'не установлено' };

function v2EncRow(i) {
    const lifted = i.lifted_on_sale === 'да' ? 'да, по документу' : (i.lifted_on_sale === 'нет' ? 'нет, по документу' : 'не установлено');
    return `<div class="v2-enc-row"><div class="v2-enc-main"><span class="text-body text-primary">${escapeHtml(V2_ENC_KIND[i.kind] || i.kind)}</span>
        <span class="text-caption text-secondary">${escapeHtml(V2_ENC_AUTH[i.authority_kind] || '')}${i.basis === 'основание этих торгов' ? ' · основание этих торгов' : ''}</span></div>
        <div class="v2-enc-cells"><span class="text-caption font-mono-nums">${i.amount_kzt ? escapeHtml(fmMoneyNb(i.amount_kzt)) : '—'}</span>
        <span class="text-caption font-mono-nums">${i.date ? escapeHtml(v2Date(i.date)) : '—'}</span>
        <span class="text-caption text-secondary">снимается после продажи: ${escapeHtml(lifted)}</span></div>
        <details class="v2-enc-quote"><summary class="text-caption text-tertiary">цитата${i.source_doc ? ` · ${escapeHtml(i.source_doc)}` : ''}</summary>
        <div class="v2-fact-quote">${reportEvidenceHTML(i.quote, i.source_doc ? { label: i.source_doc } : null)}</div></details></div>`;
}

function v2EncumbranceTable(items) {
    const arrests = items.filter((i) => i.kind === 'арест');
    const sum = arrests.reduce((a, i) => a + (i.amount_kzt || 0), 0);
    const head = `${items.length} ${pluralizeRu(items.length, 'обременение', 'обременения', 'обременений')}${arrests.length ? `, арестов: ${arrests.length}` : ''}${sum ? `; суммы по постановлениям: ${fmMoneyNb(sum)}` : ''}`;
    const first = items.slice(0, 5).map(v2EncRow).join('');
    const rest = items.slice(5);
    const more = rest.length ? `<details class="v2-enc-more"><summary class="text-caption text-secondary">ещё ${rest.length}</summary>${rest.map(v2EncRow).join('')}</details>` : '';
    return `<h4 class="text-body text-primary v2-block-title">Обременения</h4><p class="text-caption text-secondary">${escapeHtml(head)}</p><div class="v2-enc-table">${first}${more}</div>`;
}

// TASK45 45.7: the four statuses of the check as tiles -- the value is coloured text (pos / warn / neg), the one-line detail under it
function v2CheckStatuses(report) {
    const ui = report.ui || {};
    const f = (k) => v2Fact(report, 'legal', k);
    const encView = report.encumbrance_view;
    const tiles = [];
    const enc = f('encumbrance');
    if (encView && encView.status) {
        tiles.push({ key: 'enc', label: 'Обременение', value: encView.status.split(' по описанию')[0].replace(/^./, (c0) => c0.toUpperCase()), sub: 'по описанию, документами не подтверждено', tone: 'warn' });
    } else {
        const known = { 'нет': ['не выявлено', 'pos'], 'залог': ['залог', 'neg'], 'арест': ['арест', 'neg'], 'залог_и_арест': ['залог и арест', 'neg'], 'иное': ['есть', 'neg'] }[enc];
        tiles.push({ key: 'enc', label: 'Обременение', value: known ? known[0] : 'нет данных', sub: known ? 'по документам' : 'документы молчат', tone: known ? known[1] : 'warn' });
    }
    if (ui.show_occupants) {
        const occ = f('occupants');
        const known = { 'нет': ['не выявлены', 'pos'], 'прописаны_третьи_лица': ['есть', 'neg'], 'несовершеннолетние': ['несовершеннолетние', 'neg'] }[occ];
        tiles.push({ key: 'occ', label: 'Прописанные', value: known ? known[0] : 'нет данных', sub: known ? 'по документам' : 'нужна адресная справка', tone: known ? known[1] : 'warn' });
    }
    const title = f('title_risk');
    const tk = { 'нет': ['без рисков', 'pos'], 'незавершенная_приватизация': ['есть риск', 'neg'], 'оспоримость_банкротство': ['есть риск', 'neg'], 'иное': ['есть риск', 'neg'] }[title];
    tiles.push({ key: 'title', label: 'Право', value: tk ? tk[0] : 'нет данных', sub: tk && tk[1] === 'neg' ? (V2_TITLE_TEXT[title] || '') : (tk ? 'по документам' : 'документы молчат'), tone: tk ? tk[1] : 'warn' });
    const docs = f('documents');
    const dk = { 'полный': ['полный', 'pos'], 'частичный': ['неполный', 'warn'], 'отсутствует': ['нет', 'neg'] }[docs];
    tiles.push({ key: 'docs', label: 'Документы', value: dk ? dk[0] : 'нет данных', sub: 'комплектность пакета', tone: dk ? dk[1] : 'warn' });
    return tiles;
}

function v2CheckLead(tiles) {
    const bad = tiles.filter((x) => x.tone === 'neg').map((x) => x.label.toLowerCase());
    const unknown = tiles.filter((x) => x.tone === 'warn').map((x) => x.label.toLowerCase());
    if (bad.length) return `Выявлено: ${bad.join(', ')}.${unknown.length ? ` Документами не подтверждено: ${unknown.join(', ')}.` : ''}`;
    if (unknown.length) return `Документами не подтверждено: ${unknown.join(', ')} — проверьте до заявки.`;
    return 'Документы не выявили обременений и рисков для права.';
}

function renderV2Check(report) {
    const sec = document.getElementById('v2-check');
    const body = document.getElementById('v2CheckBody');
    if (!sec || !body) return;
    let html = '';

    // documents were not read -> say it plainly, the legal component is then not scored
    if (v2Fact(report, 'legal', 'documents_present') === false) {
        html += reportCalloutHTML('Документы лота не проверены: юридическая оценка не выставлялась, вердикт не выше «условно».');
    }
    const tiles = v2CheckStatuses(report);

    // risks: only the high and the medium ones, one line each; the level is a status pill (never a card with a coloured border)
    const allRisks = Array.isArray(report.risks) ? report.risks : [];
    const rank = (r) => { const l = String(r.severity || '').toLowerCase(); return l === 'critical' ? 0 : l === 'high' ? 1 : l === 'medium' ? 2 : 3; };
    const mainAll = allRisks.filter((r) => rank(r) <= 2).sort((a, b) => rank(a) - rank(b));
    const main = mainAll.slice(0, 3);          // three lines at most in the default view; the rest are with the other risks under «Подробнее»
    const oneLine = (r) => {
        // the first SENTENCE (an abbreviation such as «стр.» does not end it), cut at a word boundary, never mid-word (§IV.2 #9)
        const first = v2OneSentence(r.description, Math.max(24, 76 - String(r.title || '').length)).replace(/\.$/, '');
        return `${r.title || ''}${first ? ` — ${first.charAt(0).toLowerCase()}${first.slice(1)}` : ''}`;
    };
    const risksHtml = main.length ? `<ul class="v2-risk-lines">${main.map((r) => {
        const lvl = rank(r) <= 1 ? ['высокий', 'v2-pill--neg'] : ['средний', 'v2-pill--warn'];
        return `<li><span class="v2-pill ${lvl[1]} v2-risk-level">${lvl[0]}</span><span class="text-body text-primary">${escapeHtml(oneLine(r))}</span></li>`;
    }).join('')}</ul>` : '';
    html += v2Block({ lead: v2CheckLead(tiles), tiles }) + risksHtml;

    // «Подробнее»: quotes from the documents, the encumbrance list, the other risks, the AI findings, the files, the organiser, the registry disclaimer
    let more = v2Notes(report, 'note_check');
    const reg = v2Fact(report, 'legal', 'encumbrance_registry');
    if (reg) more += `<div class="report-fin-row"><span class="text-caption text-secondary">Реестр земельного фонда</span><span class="text-body text-primary">обременений ${escapeHtml(reg === 'имеется' ? 'имеется' : 'не имеется')} ${v2SourceChip('registry:jerler')}</span></div>`;
    const encList = v2Fact(report, 'legal', 'encumbrances');
    if (Array.isArray(encList) && encList.length) more += v2EncumbranceTable(encList);
    const quotes = (((report.dossier.legal || {}).encumbrance || {}).evidence || []).slice(0, 3);
    if (quotes.length) more += quotes.map((q) => `<div class="v2-fact-quote">${reportEvidenceHTML(q, { label: 'документы лота' })}</div>`).join('');
    const rest = allRisks.filter((r) => !main.includes(r));
    if (rest.length) {
        more += `<h4 class="text-body text-primary v2-block-title">Прочие риски</h4><div class="report-risks">${rest.map((r) => `<div class="report-risk-row"><div class="report-risk-head"><span class="text-body text-primary">${escapeHtml(r.title || '')}</span></div>
            <p class="text-caption text-secondary">${escapeHtml(r.description || '')}</p>${reportEvidenceHTML(r.evidence_quote, r.source_doc ? { label: r.source_doc } : null)}</div>`).join('')}</div>`;
    }
    if (main.length) {
        more += `<h4 class="text-body text-primary v2-block-title">Основания рисков</h4><div class="report-risks">${main.map((r) => `<div class="report-risk-row"><div class="report-risk-head"><span class="text-body text-primary">${escapeHtml(r.title || '')}</span></div>
            <p class="text-caption text-secondary">${escapeHtml(r.description || '')}</p>${reportEvidenceHTML(r.evidence_quote, r.source_doc ? { label: r.source_doc } : null)}</div>`).join('')}</div>`;
    }
    const docsFind = report.document_analysis_reasoning ? renderExpertRowsSite(report.document_analysis_reasoning, { skipLabelRe: /комплектность/i }) : '';
    if (docsFind) more += `<h4 class="text-body text-primary v2-block-title">Находки в документах</h4>${docsFind}`;
    const lot = state.currentLot;
    const files = lot && lot.documents ? renderDocChecklistSite(lot.documents, report.document_analysis_reasoning, report.attributes && report.attributes.is_car
        ? { re: /техпаспорт|технический\s*паспорт/i, label: 'Копия техпаспорта' } : { re: /оценк/i, label: 'Отчёт об оценке' }) : '';
    if (files) more += `<h4 class="text-body text-primary v2-block-title">Файлы лота</h4><div class="report-doc-checklist">${files}</div>`;
    const rep = report.organizer_reputation;
    let org = '';
    if (report.chsi_name) org += `<div class="report-fin-row"><span class="text-caption text-secondary">Название</span><span class="text-body text-primary">${escapeHtml(report.chsi_name)}</span></div>`;
    if (rep && rep.total_lots_seen) {
        org += `<div class="report-fin-row"><span class="text-caption text-secondary">Перевыставлялись</span><span class="text-body font-mono-nums text-primary">${rep.reopened_lots} из ${rep.total_lots_seen} (${String(rep.reopened_rate_percent || 0).replace('.', ',')} %)</span></div>`;
    }
    more += v2Group('Организатор торгов', org);
    more += '<p class="text-caption text-tertiary v2-note">Аресты в ЕГКН не публичны: отсутствие записи в реестре не доказывает, что ареста нет.</p>';
    const inside = ['цитаты из документов', rest.length || main.length ? 'основания рисков' : '', docsFind ? 'находки ИИ' : '', 'организатор', 'ограничения ЕГКН'].filter(Boolean);
    html += v2Block({ more: { summary: `Подробнее: ${inside.join(', ')}`, html: more } });

    body.innerHTML = html;
    sec.classList.toggle('hidden', !html.trim());
}

// ---- v2 section «После победы» (payment and registration for THIS site and mechanism) ---------------------------------
function renderV2After(report) {
    const sec = document.getElementById('v2-after');
    const body = document.getElementById('v2AfterBody');
    if (!sec || !body) return;
    const ui = report.ui || {};
    const pay = ui.payment;
    const timeline = (report.financial_model && report.financial_model.timeline) || [];
    const flowDate = (re) => { const t = timeline.find((x) => re.test(String(x[2] || x.label || ''))); return t ? v2Date(t[0] || t.date) : ''; };
    const steps = [];
    if (pay && pay.kind === 'full') {
        const d = flowDate(/Оплата покупки/);
        steps.push(['Оплата', `Внесите всю сумму в течение ${pay.full_business_days} рабочих дней после торгов${d ? ` (по модели — до ${d})` : ''}. Гарантийный взнос засчитывается в оплату; просрочка — потеря взноса.`]);
    } else if (pay && pay.kind === 'two_part') {
        const d = flowDate(/Оплата покупки|Остаток/);
        const which = pay.lease ? 'после подписания договора' : 'после торгов';
        steps.push(['Оплата', `Аванс не менее ${String(pay.advance_pct).replace('.0', '')} % — в течение ${pay.advance_business_days} рабочих дней ${which}, остаток — в течение ${pay.balance_calendar_days} календарных дней${d ? ` (по модели полная оплата — ${d})` : ''}. Гарантийный взнос засчитывается в оплату.`]);
    } else {
        steps.push(['Оплата', 'Срок указан в протоколе торгов: внесите сумму вовремя, просрочка означает потерю гарантийного взноса.']);
    }
    const enc = v2Fact(report, 'legal', 'encumbrance');
    const riskEncumbrance = (report.risks || []).some((r) => r.risk_category === 'обременение_арест');
    const encumbered = (enc && enc !== 'нет' && enc !== 'не_установлено') || (!enc || enc === 'не_установлено') && (riskEncumbrance || !!report.encumbrance_view);
    steps.push(['Обременения', encumbered
        ? 'Арест или залог снимает организатор (ЧСИ или банк) после полной оплаты. Уточните порядок и сроки заранее: снятие может занять до нескольких месяцев, и до него распоряжаться активом нельзя.'
        : enc === 'нет'
            ? 'По документам обременений не выявлено, но перед оплатой запросите свежую выписку: аресты в реестре не публичны.'
            : 'Обременения по документам не установлены: перед оплатой запросите свежую выписку, аресты в реестре не публичны.']);
    const vehicle = ui.sections && ui.sections.object === 'vehicle';
    steps.push(['Регистрация', pay && pay.lease
        ? 'Подпишите договор аренды и зарегистрируйте право аренды в ЦОН (НАО «Правительство для граждан»).'
        : pay && pay.resale ? 'Зарегистрируйте переход права аренды на себя в ЦОН (НАО «Правительство для граждан») по протоколу торгов и документу об оплате.'
        : vehicle ? 'Зарегистрируйте автомобиль на себя (номера, свидетельство о регистрации) по протоколу торгов и документу об оплате.'
        : 'Зарегистрируйте право собственности в ЦОН (НАО «Правительство для граждан») по протоколу торгов и документу об оплате.']);
    steps.push(['Распоряжение', 'Продавать, сдавать в аренду или начинать существенный ремонт стоит только после регистрации: раньше — дополнительные юридические риски.']);

    // TASK45 45.8: the lead is the payment deadline and the deposit at risk; the whole order of steps is one «Подробнее»
    const deposit = v2Fact(report, 'money', 'deposit_locked');
    const atRisk = deposit != null ? ` Просрочка — потеря гарантийного взноса ${fmMoneyNb(deposit)}.` : ' Просрочка — потеря гарантийного взноса.';
    let lead;
    if (pay && pay.kind === 'full') lead = `Внесите всю сумму в течение ${pay.full_business_days} рабочих дней после торгов.${atRisk}`;
    else if (pay && pay.kind === 'two_part') lead = `Аванс не менее ${String(pay.advance_pct).replace('.0', '')} % — в течение ${pay.advance_business_days} рабочих дней ${pay.lease ? 'после подписания договора' : 'после торгов'}, остаток — в течение ${pay.balance_calendar_days} календарных дней.${atRisk}`;
    else lead = `Срок оплаты указан в протоколе торгов.${atRisk}`;
    const stepsHtml = v2Notes(report, 'note_after')
        + `<ol class="v2-steps">${steps.map(([t0, x]) => `<li><span class="text-body text-primary v2-step-title">${escapeHtml(t0)}</span><span class="text-caption text-secondary">${escapeHtml(x)}</span></li>`).join('')}</ol>`
        + '<p class="text-micro text-tertiary v2-note">Порядок и сроки зависят от площадки и организатора; это общая последовательность, а не инструкция для вашего случая.</p>';
    body.innerHTML = v2Block({ lead, more: { summary: 'Подробнее: оплата, обременения, регистрация, распоряжение', html: stepsHtml } });
    sec.classList.remove('hidden');
}

// ---- v2 section «Участок / объект» ---------------------------------------------------------------------------------
// ui.sections.object decides: 'cadastre' (land, lease, house, commercial with land) -> the existing cadastre block + map;
// 'building' (flat, parking, a premise in a building) -> the same block collapsed as «участок здания»; 'vehicle' ->
// the «Автомобиль» block; 'documents' ('Прочее') -> the description from the documents.
function renderV2Object(report) {
    const root = document.getElementById('screen-analysis');
    const variant = report.ui && report.ui.sections && report.ui.sections.object;
    if (root) root.dataset.v2Object = variant || '';
    const geoSec = document.getElementById('sec-geo');
    const geoTitle = geoSec && geoSec.querySelector('.report-section-title');
    if (geoTitle) geoTitle.textContent = variant === 'building' ? 'Участок здания' : 'Участок / объект';
    const note = report.writer && report.writer.note_object;
    const noteEl = document.getElementById('v2GeoNote');
    if (noteEl) {
        // TASK43 43.9: the parcel under a flat's building has a non-residential purpose -- one info line, no points
        const parcelNote = v2Fact(report, 'object', 'parcel_purpose_note');
        // the writer's sentence about a flat / parking (rooms, area, floor) repeats «Объект»: not said twice for the building's parcel
        const html = (variant === 'building' ? '' : v2Notes(report, 'note_object')) + (parcelNote ? `<p class="text-caption text-secondary v2-char-diff">${escapeHtml(parcelNote)}</p>` : '');
        noteEl.innerHTML = html;
        noteEl.classList.toggle('hidden', !html);
    }
    // TASK37 37.0 (8): a rent and a commercial premise show the cadastre OPEN -- the premise first, then the building's parcel
    // TASK45 45.7: no kind of object opens the cadastre by default -- tiles first, the map and the registry data behind one toggle
    const expanded = !!(report.ui && report.ui.object_expanded);
    if (geoSec) geoSec.classList.remove('v2-open');
    if (geoTitle && expanded) geoTitle.textContent = 'Помещение и участок здания';
    const toggle = document.getElementById('v2GeoToggle');
    if (toggle) {
        toggle.classList.toggle('hidden', variant !== 'building' && variant !== 'cadastre');
        toggle.textContent = variant === 'cadastre' ? 'Показать карту и кадастровые данные' : 'Показать на карте';
    }
    const geoBlock = document.getElementById('v2GeoBlock');
    if (geoBlock) {
        const of = (k) => v2Fact(report, 'object', k);
        const area = of('area_m2');
        const areaText = area == null ? '' : (area >= 10000 ? `${fmAreaNum(area / 10000)} га` : `${fmAreaNum(area)} м²`);
        const left = of('right_years_left'), rightEnd = of('right_end');
        const limits = [of('red_line_existing') && of('red_line_existing') !== 'none' ? 'красная линия' : '', of('water_protection') === true ? 'водоохранная зона' : ''].filter(Boolean);
        const tiles = variant === 'cadastre' || (variant === 'building' && expanded) ? [
            { label: 'Площадь', value: areaText, sub: of('cadastral_number') ? `кад. № ${of('cadastral_number')}` : '' },
            { label: 'Назначение', value: String(of('purpose') || '').slice(0, 40), sub: '' },
            { label: 'Право до', value: rightEnd ? v2Date(rightEnd) : '', sub: left != null ? `осталось ${ruYears(left)}` : '' },
            { label: 'Ограничения', value: limits.length ? limits.join(', ') : (area != null ? 'не найдено' : ''), sub: 'по реестрам' },
        ] : [];
        geoBlock.innerHTML = v2Block({ tiles });
        geoBlock.classList.toggle('hidden', !tiles.some((x) => x.value));
    }
    const premiseEl = document.getElementById('v2PremiseBlock');
    if (premiseEl) {
        const pf = (k) => v2Fact(report, 'object', k);
        let rows = '';
        if (expanded) {
            rows += v2Row('Кадастровый номер помещения', pf('premise_cadastral_number') || '');
            rows += v2Row('Функциональное назначение', pf('premise_purpose') || '');
            rows += v2Row('Площадь', pf('premise_area_m2') != null ? `${String(pf('premise_area_m2')).replace('.', ',')} м²` : '');
            rows += v2Row('Год постройки здания', pf('premise_year_built') != null ? String(pf('premise_year_built')) : '');
            rows += v2Row('Этаж', pf('premise_floor') != null ? String(pf('premise_floor')) : '');
        }
        premiseEl.innerHTML = rows ? v2Group('Помещение', rows) + '<h4 class="text-body text-primary v2-block-title">Участок здания</h4>' : '';
        premiseEl.classList.toggle('hidden', !rows);
    }

    // defects/photos only where they say something (cars, flats, houses)
    // TASK43 43.10: «Дефекты и фото» is removed from the v2 layout (v1 untouched); the condition lives in «Характеристики лота»
    const defects = document.getElementById('sec-defects');
    if (defects) defects.classList.add('v2-hidden');

    const sec = document.getElementById('v2-object');
    const body = document.getElementById('v2ObjectBody');
    if (!sec || !body) return;
    if (variant !== 'vehicle' && variant !== 'documents') { sec.classList.add('hidden'); return; }
    const a = report.attributes || {};
    let html = v2Notes(report, 'note_object');
    const lot = state.currentLot || {};
    if (variant === 'vehicle') {
        document.getElementById('v2ObjectTitle').textContent = 'Автомобиль';
        const car = [a.make, a.model, a.year].filter(Boolean).join(' ');
        let rows = v2Row('Автомобиль', car);
        rows += v2Row('Пробег', a.mileage_km != null ? `${a.mileage_km.toLocaleString('ru-RU')} км` : 'не установлен в документах', a.mileage_source_doc ? `источник: ${a.mileage_source_doc}` : '');
        html += `<div>${rows}</div>`;
        if (a.mileage_evidence_quote) html += `<div class="v2-fact-quote">${reportEvidenceHTML(a.mileage_evidence_quote, a.mileage_source_doc ? { label: a.mileage_source_doc } : null)}</div>`;
        if (a.mileage_note) html += reportCalloutHTML(a.mileage_note);
        if (a.mileage_km == null) html += '<p class="text-caption text-tertiary v2-note">Пробег в документах не найден: проверьте его при осмотре — вердикт это учитывает.</p>';
        const vin = (report.financial_model || {}).utilization_fee_vin_status;
        const vinText = { paid: 'уплачен', unpaid: 'не уплачен', unknown: 'проверить по VIN не удалось' }[vin];
        let more = v2Row('Утилизационный сбор', vinText || '', vin ? 'проверка по VIN' : '');
        const gbo = [...(report.risks || []).map((r) => `${r.title || ''} ${r.description || ''}`), ...(report.visual_defects || [])].find((t) => /ГБО|газобаллон/i.test(String(t)));
        if (gbo) more += v2Row('ГБО', 'упоминается', String(gbo).slice(0, 90));
        html += v2Group('Что проверить у автомобиля', more);
    } else {
        document.getElementById('v2ObjectTitle').textContent = 'Описание';
        const desc = String(lot.description || '').trim();
        html += desc ? `<h4 class="text-body text-primary v2-block-title">Описание из лота</h4><p class="text-body text-secondary report-prose">${escapeHtml(desc.slice(0, 900))}${desc.length > 900 ? '…' : ''}</p>`
            : '<p class="text-body text-secondary">Описание объекта в лоте не заполнено; смотрите документы лота.</p>';
    }
    body.innerHTML = html;
    sec.classList.toggle('hidden', !html.trim());
}

// ---- v2: header, TL;DR strip, table of contents, «влияние на вердикт» per section ---------------------------------------
const V2_IMPACT_COMPONENT_LABEL = { money: 'деньги', trades: 'торги', market: 'рынок', legal: 'проверка', object: 'участок', liquidity: 'ликвидность' };

function v2MarketSourceWord(report) {
    return { data: 'реальные объявления', documents: 'оценка из документов', llm: 'оценка ИИ, не проверена', none: 'не определён' }[v2Fact(report, 'market', 'reliability')] || '';
}

// the line under the photo: report date, what the legal part rests on, what the market rests on -- no AI self-rated «достоверность»
function renderV2Provenance(report) {
    const el = document.getElementById('reportProvenance');
    if (!el) return;
    const parts = [];
    const genDate = fmtDateTime(report.analysis_generated_at);
    if (genDate) parts.push(`Отчёт от ${genDate}`);
    const docs = v2Fact(report, 'legal', 'documents_present');
    if (docs != null) parts.push(docs ? 'юридическая часть: по документам' : 'юридическая часть: документы не проверены');
    const mk = v2MarketSourceWord(report);
    if (mk && (report.ui && report.ui.sections && report.ui.sections.market) !== 'hidden') parts.push(`рынок: ${mk}`);
    el.textContent = parts.join(' · ');
}

// sticky TL;DR: verdict, score, the profile's main number (not the AI's «целевая цена»), the engine's ROI, the deadline
// «на понижение» / «на повышение» from the profile mechanism (etp_down, sauda_up, ...); falls back to the lot's trade type text
function v2TradeDirection(mechanism, typeTrading) {
    const m = String(mechanism || '');
    if (/_down$/.test(m)) return 'на понижение';
    if (/_up$/.test(m)) return 'на повышение';
    const t = String(typeTrading || '').toLowerCase();
    if (/пониж/.test(t)) return 'на понижение';
    if (/повыш/.test(t)) return 'на повышение';
    return '';
}
// one extra TL;DR cell (+ its separator) before `before`, built once (the partial is shared by every surface); an empty value hides it
function v2TldrCell(id, before, label, valueClass, value) {
    let cell = document.getElementById(`${id}Cell`);
    if (!cell && before) {
        before.insertAdjacentHTML('beforebegin', `<div id="${id}Cell" class="report-tldr-cell"><span class="text-caption text-secondary">${escapeHtml(label)}</span><span id="${id}" class="${valueClass}"></span></div><div class="report-tldr-sep" id="${id}Sep"></div>`);
        cell = document.getElementById(`${id}Cell`);
    }
    if (!cell) return;
    document.getElementById(id).textContent = value || '';
    cell.classList.toggle('hidden', !value);
    document.getElementById(`${id}Sep`).classList.toggle('hidden', !value);
}
function renderV2Tldr(report) {
    const strip = document.getElementById('uiTldrStrip');
    if (!strip) return;
    // the partial's own five cells by position -- the cells added below (v2TldrCell, id «…Cell») must not shift the count on a second render
    const cells = strip.querySelectorAll('.report-tldr-cell:not([id$="Cell"])');
    const priceCell = cells[2], roiCell = cells[3];
    const kind = report.ui && report.ui.main_number;
    const m = report.financial_model || {};
    const f = (g, k) => v2Fact(report, g, k);
    const cmp = (v) => `${fmPriceCompactStrict(v)} ₸`;       // §7.13: the main number is written in full once (in «Ответ»); the strip speaks in compact form
    let label = 'Расчётная цена входа', value = '—';
    if (kind === 'ladder_entry') { label = 'Интересен ниже'; value = m.results && m.results.max_bid != null ? cmp(m.results.max_bid) : '—'; }
    else if (kind === 'second_round') {
        const sr = f('trades', 'second_round');
        if (sr && sr.max_bid != null) { label = 'Вторые торги: ниже'; value = cmp(sr.max_bid); }
        else { label = 'Вторые торги'; value = v2Date(f('trades', 'second_round_earliest_date')).slice(0, 5) ? `с ${v2Date(f('trades', 'second_round_earliest_date'))}` : '—'; }
    }
    else if (kind === 'winning_price' || kind === 'lease_price') { label = 'Ожидаемая цена победы'; value = f('trades', 'expected_winning_price') != null ? cmp(f('trades', 'expected_winning_price')) : '—'; }
    else if (kind === 'rent_monthly') { label = 'Платёж в месяц'; value = f('money', 'monthly_payment') != null ? cmp(f('money', 'monthly_payment')) : '—'; }
    else if (kind === 'documents_only') { label = 'Цена'; value = '—'; }
    if (priceCell) {
        const lab = priceCell.querySelector('.text-caption');
        if (lab) lab.textContent = label;
        const val = priceCell.querySelector('#uiTldrPrice');
        if (val) val.textContent = value;
    }
    // «Вид торгов» (owner 2026-10-24): down or up decides how to read «Интересен ниже» -- the cell sits right before the deadline, so on the
    // phone the two share the second row. The mechanism names the direction; a land-lease resale (sauda_lease) has none, the lot's own
    // trade type does. Built once per strip (the partial is shared, the cell is the same everywhere).
    const deadlineCell = cells[4];
    const direction = v2TradeDirection(f('trades', 'mechanism'), (state.currentLot || {}).type_trading);
    v2TldrCell('uiTldrTrade', deadlineCell, 'Вид торгов', 'text-body text-primary', direction);
    // «Старт» (owner 2026-10-24) next to the price cell, so the start and «Интересен ниже» read side by side
    const start = f('trades', 'start_price');
    v2TldrCell('uiTldrStart', priceCell, 'Старт', 'text-body font-mono-nums text-primary', start != null ? cmp(start) : '');
    // «Дата торгов» (owner 2026-10-24) only for an auction still ahead: an ended one already reads «Торги: прошли 15.10» in the deadline cell
    const tradeDate = String(f('trades', 'trade_date') || '');
    const kzToday = new Date(Date.now() + 5 * 3600 * 1000).toISOString().slice(0, 10);
    const tradeAhead = /^\d{4}-\d{2}-\d{2}/.test(tradeDate) && tradeDate.slice(0, 10) >= kzToday;
    v2TldrCell('uiTldrDate', deadlineCell, 'Дата торгов', 'text-body font-mono-nums text-primary', tradeAhead ? v2Date(tradeDate) : '');
    // an ended auction has no deadline countdown: say so (the writer's text says the same)
    if (deadlineCell && /^\d{4}-\d{2}-\d{2}/.test(tradeDate) && tradeDate.slice(0, 10) < kzToday) {
        const lab = deadlineCell.querySelector('.text-caption');
        if (lab) lab.textContent = 'Торги';
        const dl = document.getElementById('uiTldrDeadline');
        if (dl) { dl.textContent = `прошли ${v2Date(tradeDate).slice(0, 5)}`; dl.className = 'text-body text-secondary'; }
    }
    // ROI from the engine's own model (never the AI's financials block); none for a suspect price / lease / documents-only
    const roiEl = document.getElementById('uiTldrRoi');
    const roi = (m.results || {}).roi_mid;
    const noRoi = roi == null || v2Fact(report, 'quality', 'price_suspect') === true || (report.ui && report.ui.sections && report.ui.sections.money) !== 'full';
    if (roiEl) {
        if (noRoi) { roiEl.textContent = '—'; roiEl.className = 'text-xs font-mono-nums font-bold whitespace-nowrap text-tertiary'; }
        else { roiEl.textContent = `${roi >= 0 ? '+' : '−'}${Math.abs(Math.round(roi * 100))} %`; roiEl.className = `text-xs font-mono-nums font-bold whitespace-nowrap ${roi >= 0 ? 'text-pos' : 'text-neg'}`; }
    }
}

function v2VisibleSection(id) {
    const el = document.getElementById(id);
    return !!el && !el.classList.contains('hidden') && !el.classList.contains('v2-hidden') && getComputedStyle(el).display !== 'none';
}

function renderV2Toc(report) {
    const toc = document.getElementById('reportToc');
    if (!toc) return;
    if (reportTocObserver) { reportTocObserver.disconnect(); reportTocObserver = null; }
    const risks = Array.isArray(report.risks) ? report.risks.length : 0;
    // §III.3 (2026-10-24): each item carries its block's signed impact on the score; «Проверка объекта» its risk count instead
    const engine = report.verdict_engine || {};
    const items = [
        { id: 'v2-chars', label: 'Объект' }, { id: 'v2-answer', label: 'Ответ' }, { id: 'v2-trades', label: 'Торги', comp: 'trades' }, { id: 'sec-financials', label: 'Деньги', comp: 'money' },
        { id: 'sec-market', label: 'Рынок', comp: 'market' }, { id: 'v2-check', label: 'Проверка объекта', count: risks, comp: risks ? null : 'legal' },
        { id: 'sec-geo', label: (report.ui.sections.object === 'building') ? 'Участок здания' : 'Участок / объект', comp: 'object' },
        { id: 'v2-object', label: report.ui.sections.object === 'vehicle' ? 'Автомобиль' : 'Описание', comp: 'object' },
        { id: 'v2-after', label: 'После победы' },
    ].filter((x) => v2VisibleSection(x.id));
    const mark = (x) => {
        if (x.count) return `<span class="font-mono-nums text-warn report-toc-impact">${x.count}</span>`;
        const c = x.comp ? v2Contribution(engine, x.comp) : null;
        return c ? `<span class="font-mono-nums ${c > 0 ? 'text-pos' : 'text-neg'} report-toc-impact">${v2SignedInt(c)}</span>` : '';
    };
    toc.innerHTML = items.map((x) => `<a href="#${x.id}" class="report-toc-link" data-target="${x.id}">${escapeHtml(x.label)}${mark(x)}</a>`).join('');
    if (items.length && 'IntersectionObserver' in window) {
        const links = new Map(items.map((x) => [x.id, toc.querySelector(`[data-target="${x.id}"]`)]));
        reportTocObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => { const link = links.get(entry.target.id); if (link) link.classList.toggle('active', entry.isIntersecting); });
        }, { rootMargin: '-96px 0px -70% 0px', threshold: 0 });
        items.forEach((x) => reportTocObserver.observe(document.getElementById(x.id)));
    }
}

// «влияние на вердикт: +18» in each section header + the top reason right under it. Contribution = weight x (score - 50):
// how far the component pulled the verdict score above/below a neutral middle; a component without data does not count.
function v2Contribution(engine, comp) {
    const score = ((engine || {}).breakdown || {})[comp], weight = ((engine || {}).weights_used || {})[comp];
    return score == null || weight == null ? null : Math.round(weight * (score - 50));
}
function v2SignedInt(n) { return `${n > 0 ? '+' : '−'}${Math.abs(n)}`; }
function renderV2Impact(report) {
    const engine = report.verdict_engine || {};
    document.querySelectorAll('[data-v2-impact]').forEach((span) => {
        const comp = span.dataset.v2Impact;
        const section = span.closest('section');
        const top = ((engine.component_reasons || {})[comp] || [])[0];
        const contribution = v2Contribution(engine, comp);
        // §7.13 (2026-10-24): «+4 к оценке» is a status pill; a block that does not move the score says so in neutral words
        let html, pill = false;
        if (contribution == null) {
            html = (comp === 'object' && report.ui && report.ui.sections && report.ui.sections.object === 'building')
                ? 'не влияет на оценку: участок здания общий' : 'не влияет на оценку';
        } else if (contribution === 0) {
            html = 'не меняет оценку';
        } else {
            html = `<span class="v2-pill ${contribution > 0 ? 'v2-pill--pos' : 'v2-pill--neg'}"><span class="font-mono-nums">${v2SignedInt(contribution)}</span>к оценке</span>`;
            pill = true;
        }
        span.innerHTML = html;
        span.className = pill ? 'v2-only report-section-meta' : 'v2-only report-section-meta text-caption text-secondary';
        // the block's own lead sentence replaces the old grey reason line; only «Участок / объект» (no lead of its own) keeps it
        if (comp === 'object' && section && !section.querySelector(`.v2-impact-reason[data-comp="${comp}"]`)) {
            const header = section.querySelector('.report-section-header');
            if (header && top) header.insertAdjacentHTML('afterend', `<p class="v2-impact-reason text-caption text-secondary" data-comp="${comp}"></p>`);
        }
        const reasonEl = section && section.querySelector(`.v2-impact-reason[data-comp="${comp}"]`);
        if (reasonEl) reasonEl.textContent = top ? top.text : '';
    });
}

// The v2 sections are filled by 35.1-35.7 (one renderer each); this is the single entry point.
// ---- v2 section «Характеристики лота» (TASK43 43.1): the passport's exact data above «Ответ», each value with its source ---------------
function renderV2Characteristics(report) {
    const sec = document.getElementById('v2-chars');
    const body = document.getElementById('v2CharsBody');
    if (!sec || !body) return;
    const c = report.characteristics;
    if (!c || !(Array.isArray(c.rows) && c.rows.length || c.appraisal || c.missing)) { sec.classList.add('hidden'); return; }
    // TASK45 45.3: a grid of facts (3 columns, 2 on the phone, the address on a full row), the photo as a thumbnail; a source mark only on what the model read
    // from the documents, one legend line; a disagreement is one warn line under the grid
    const isNumeric = (v) => /^[\d\s.,:/₸×%-]+(?:\s*(?:м²|км|см³|га|лет|мес\.))?(?:\s*\(.*\))?$/.test(String(v));
    const isAi = (src) => /^ИИ/.test(String(src || ''));
    const fact = (label, value, source, wide) => `<div class="v2-fact${wide ? ' v2-fact--wide' : ''}"><div class="text-caption text-secondary">${escapeHtml(label)}</div>`
        + `<div class="text-body ${isNumeric(value) ? 'font-mono-nums ' : ''}text-primary v2-fact-value">${escapeHtml(value)}${isAi(source) ? '<span class="text-micro text-tertiary v2-char-src">ИИ</span>' : ''}</div></div>`;
    const a = c.appraisal;
    const facts = (c.rows || []).map((r) => fact(r.label, r.value, r.source, r.key === 'address'));
    if (a && a.value) {
        const bits = [fmMoneyNb(a.value)];
        if (a.per_m2) bits.push(`${fmMoneyNb(a.per_m2)}/м²`);
        if (a.date) bits.push(`на ${v2Date(a.date)}`);
        facts.push(fact('Оценка (не рынок)', bits.join(' · '), a.source, true));
    }
    const lot = state.currentLot || {};
    const thumbSrc = lot.image_url || getPlaceholderFor(lot.category);
    const thumbHref = IS_TELEGRAM ? thumbSrc : `/workspace/lot/${encodeURIComponent(lot.id || '')}`;
    const thumb = lot.id ? `<a class="v2-obj-thumb" href="${escapeHtml(thumbHref)}"${IS_TELEGRAM ? ' target="_blank" rel="noopener"' : ''} aria-label="Фото лота"><img src="${escapeHtml(thumbSrc)}" alt="Фото лота" referrerpolicy="no-referrer" loading="lazy" onerror="this.onerror=null;this.src='${getPlaceholderFor(lot.category)}'"></a>` : '';
    let html = `<div class="v2-obj"><div class="v2-obj-facts">${facts.join('')}</div>${thumb}</div>`;
    (c.disagreements || []).forEach((tx) => { html += `<p class="text-body text-secondary v2-char-diff">${escapeHtml(tx)}</p>`; });
    if ((c.rows || []).some((r) => isAi(r.source))) html += '<p class="text-micro text-tertiary v2-note">«ИИ» — прочитано в документах.</p>';
    if (c.missing) html += `<p class="text-caption text-tertiary v2-char-missing">${escapeHtml(c.missing)}</p>`;
    body.innerHTML = html;
    sec.classList.remove('hidden');
}

// TASK45 45.0 C6: words of the pipeline never reach the reader -- «не_установлено», «LOT RE-LISTING HISTORY», «раз(а)», snake_case between Russian words.
// Applied to the TEXT of the stored report (risks, reasons, the writer's text), never to its enum values (risk_category, severity, dossier facts).
const V2_RAW_PHRASES = [[/LOT RE-LISTING HISTORY/gi, 'История перевыставления лота'], [/LOT\s+HISTORY/gi, 'История лота']];
function v2RuText(s) {
    if (typeof s !== 'string') return s;
    let t = s;
    for (const [re, to] of V2_RAW_PHRASES) t = t.replace(re, to);
    t = t.replace(/(\d+)\s*раз\(а\)/g, (m, n) => `${n} ${pluralizeRu(Number(n), 'раз', 'раза', 'раз')}`);
    return t.replace(/([а-яёәіңғүұқөһ])_(?=[а-яёәіңғүұқөһ])/gi, '$1 ');
}
const V2_TEXT_SKIP_KEYS = new Set(['risk_category', 'severity', 'effect', 'component', 'source', 'kind', 'key', 'type', 'url', 'query_url', 'id', 'value', 'profile', 'verdict', 'rules_version']);
function v2RuDeep(node, key) {
    if (typeof node === 'string') return V2_TEXT_SKIP_KEYS.has(key) ? node : v2RuText(node);
    if (Array.isArray(node)) return node.map((x) => v2RuDeep(x, key));
    if (node && typeof node === 'object') {
        const out = {};
        for (const k of Object.keys(node)) out[k] = v2RuDeep(node[k], k);
        return out;
    }
    return node;
}
function v2NormalizeReport(report) {
    const out = { ...report };
    for (const k of ['risks', 'verdict_engine', 'writer', 'executive_summary', 'final_verdict_reasoning', 'legal_analysis_reasoning', 'document_analysis_reasoning', 'swot', 'characteristics']) {
        if (out[k] != null) out[k] = v2RuDeep(out[k], k);
    }
    // a quote that only says «not established» is no quote
    if (Array.isArray(out.risks)) out.risks = out.risks.map((r) => (r && /^\s*не установлено\s*$/i.test(r.evidence_quote || '') ? { ...r, evidence_quote: '' } : r));
    return out;
}

// TASK45 45.10: the page title is formatLotTitleSite (§8.3). A lot row often has no area of its own («Квартира, 127,1 м², Астана» needs it), so the
// area the dossier established stands in for it; the tab title follows the header.
function renderV2PageTitle(report) {
    const lot = state.currentLot;
    const headerTitleEl = document.getElementById('reportHeaderTitle');
    if (!lot || !headerTitleEl) return;
    const attrs = lot.attributes || {};
    // the area is read from the «Характеристики» row (the figure the reader sees), in the unit the category's title parser expects: m² for housing, hectares for land
    const rows = (report.characteristics && report.characteristics.rows) || [];
    const rowNum = (key, unit) => {
        const r = rows.find((x) => x.key === key);
        const m = r && new RegExp(`^\\s*([\\d\\s]+(?:[.,]\\d+)?)\\s*${unit}`).exec(String(r.value));
        return m ? m[1].replace(/\s/g, '').replace(',', '.') : '';
    };
    const area = attrs.area ? '' : (lot.category === 'квартиры' || lot.category === 'дома') ? rowNum('object_area_m2', 'м²') : lot.category === 'участки' ? (rowNum('parcel_area_m2', 'га') || (rowNum('parcel_area_m2', 'м²') ? (Number(rowNum('parcel_area_m2', 'м²')) / 10000).toFixed(2) : '')) : '';
    const primary = formatLotTitleSite(area ? { ...lot, attributes: { ...attrs, area } } : lot).primary;
    headerTitleEl.textContent = `Анализ: ${primary}`;
    if (!IS_TELEGRAM) document.title = `Анализ: ${primary} — Auction Detective`;
}

function renderReportV2(report) {
    report = v2NormalizeReport(report);
    renderV2PageTitle(report);
    renderV2Characteristics(report);
    renderV2Answer(report);
    renderV2Trades(report);
    renderV2Money(report);
    renderV2Market(report);
    renderV2Check(report);
    renderV2Object(report);
    renderV2After(report);
    renderV2Provenance(report);
    renderV2Tldr(report);
    renderV2Impact(report);
    renderV2Toc(report);   // last: it lists the sections that are actually visible
    v2MarkPanelFooters();
}

// §7.13 (2026-10-24): a panel whose last VISIBLE element is its «Подробнее» drops its bottom padding, so the <details> sits flush as the
// panel's footer. Measured on the rendered DOM: a hidden sibling after the <details> would fool a CSS :last-child rule.
function v2MarkPanelFooters() {
    const visible = (el) => el.offsetParent !== null;
    document.querySelectorAll('#screen-analysis .report-section').forEach((sec) => {
        let el = sec, footed = false;
        for (;;) {
            const kids = [...el.children].filter(visible);
            if (!kids.length) break;
            el = kids[kids.length - 1];
            if (el.matches('details.v2-more')) { footed = true; break; }
        }
        sec.classList.toggle('v2-panel-footed', footed);
    });
}

// ИЗМЕНЕНО (Stage 4): стала async — сама дожидается Chart.js, который
// больше не подключён тегом в <head> (см. комментарий в partials/base.html).
// Вызывающий код её не ждёт, и ждать не должен: график рисуется в уже
// отрисованный <canvas>, отчёт от этого не задерживается.
async function initFinancialChart(financials, targetPriceFallback = null) {
    const canvas = document.getElementById('financialChart');
    // Раньше отсутствие канваса роняло функцию на null.getContext. Пока она
    // была синхронной, это была обычная ошибка в консоли; у async-функции
    // это стало бы необработанным отказом промиса — поэтому выходим явно.
    if (!canvas) return;

    try {
        await loadScriptOnce(CHART_JS_URL);
    } catch (e) {
        // Нет сети или CDN недоступен — отчёт остаётся полностью читаемым,
        // просто без одной иллюстрации. Это не повод ничего не показывать.
        console.error('График финансовой модели не построен:', e);
        return;
    }

    const ctx = canvas.getContext('2d');

    // Уничтожаем старый график, если есть
    if (myFinancialChart) {
        myFinancialChart.destroy();
    }

    // Определяем, какую цену входа рисовать
    const entryPrice = targetPriceFallback !== null ? targetPriceFallback : (financials.target_purchase_price || financials.start_price || 0);

    // ИЗМЕНЕНО (TASK7 7.3, /dataviz, D-11): "Вход" — не факт без оценки, это
    // единственный акцентный бар (--accent, «сделка»), три бара "Рынок" —
    // не три разных вердикта, один и тот же показатель (диапазон оценки
    // цены перепродажи) на одном нейтральном токене (--text-tertiary,
    // «бенчмарк») с нарастающей непрозрачностью = нарастающей уверенностью;
    // различие категорий несёт подпись на оси X, не только цвет (dataviz:
    // "identity is never color-alone"). IS_TELEGRAM-ветка ниже: Mini App
    // держит СТАРЫЙ градиент/зелёную палитру байт-в-байт (общая функция —
    // initFinancialChart вызывается и из Mini App), сайт — токенизированную
    // плоскую заливку без градиентов (dataviz: "no gradients").
    let backgroundColor, tooltipBg, gridColor, tickColor, tickFontFamily, tooltipFontFamily, animation;
    if (REPORT_LEGACY_MARKUP) {
        const gradInvest = ctx.createLinearGradient(0, 0, 0, 400);
        gradInvest.addColorStop(0, 'rgba(154, 163, 178, 0.8)'); // --text-secondary
        const gradMin = ctx.createLinearGradient(0, 0, 0, 400);
        gradMin.addColorStop(0, 'rgba(52, 199, 123, 0.35)'); // --status-pos, низкая уверенность
        const gradReal = ctx.createLinearGradient(0, 0, 0, 400);
        gradReal.addColorStop(0, 'rgba(52, 199, 123, 0.65)'); // --status-pos, средняя уверенность
        const gradMax = ctx.createLinearGradient(0, 0, 0, 400);
        gradMax.addColorStop(0, 'rgba(52, 199, 123, 0.95)'); // --status-pos, высокая уверенность
        backgroundColor = [gradInvest, gradMin, gradReal, gradMax];
        tooltipBg = 'rgba(15, 23, 42, 0.9)';
        gridColor = 'rgba(255, 255, 255, 0.05)';
        tickColor = '#9AA3B2';
        tickFontFamily = undefined;
        tooltipFontFamily = undefined;
        animation = { duration: 1500, easing: 'easeOutQuart' };
    } else {
        const cssVar = (name) => getComputedStyle(document.documentElement).getPropertyValue(name).trim();
        const rgbaVar = (name, alpha) => {
            const parts = cssVar(name).split(/\s+/).map(Number);
            return `rgba(${parts[0]}, ${parts[1]}, ${parts[2]}, ${alpha})`;
        };
        backgroundColor = [rgbaVar('--accent-rgb', 1), rgbaVar('--text-tertiary-rgb', 0.35), rgbaVar('--text-tertiary-rgb', 0.6), rgbaVar('--text-tertiary-rgb', 0.9)];
        tooltipBg = rgbaVar('--bg-raised-rgb', 0.98);
        gridColor = rgbaVar('--border-subtle-rgb', 1);
        tickColor = cssVar('--text-secondary');
        tickFontFamily = "'JetBrains Mono', ui-monospace, monospace";
        tooltipFontFamily = "'JetBrains Mono', ui-monospace, monospace";
        // MUST NOT (§10): без анимаций >200мс на сайте (motion on money —
        // decoration); Mini App анимацию не трогаем.
        animation = { duration: 0 };
    }
    Chart.defaults.color = tickColor;
    Chart.defaults.font.family = "'Manrope', sans-serif";

    myFinancialChart = new Chart(ctx, {
        type: 'bar',
        data: {
            labels: ['Вход', 'Рынок (Мин)', 'Рынок (Реал)', 'Рынок (Макс)'],
            datasets: [{
                label: 'Цена (₸)',
                data: [
                    entryPrice,  // 🔥 Вот тут используем надежную переменную
                    financials.market_prices.pessimistic_price,
                    financials.market_prices.realistic_price,
                    financials.market_prices.optimistic_price
                ],
                backgroundColor,
                borderRadius: 6,
                borderSkipped: false
            }]
        },
        options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                legend: { display: false },
                tooltip: {
                    backgroundColor: tooltipBg,
                    titleFont: { size: 11, family: tooltipFontFamily },
                    bodyFont: { size: 13, weight: REPORT_LEGACY_MARKUP ? 'bold' : '600', family: tooltipFontFamily },
                    padding: 10,
                    callbacks: {
                        label: function(context) {
                            return formatMoney(context.raw);
                        }
                    }
                }
            },
            scales: {
                y: {
                    beginAtZero: true,
                    min: 0,
                    grid: { color: gridColor },
                    ticks: {
                        // ИЗМЕНЕНО (TASK7 7.4, кэрри-овер из 7.3): было "4.5M" —
                        // английское сокращение вне канона. fmtPriceCompact()
                        // (тот же форматтер, что везде на сайте) уже отдаёт
                        // "4,5 млн"/"500 тыс." под ru-RU. Mini App — старое "M".
                        // ИСПРАВЛЕНО (7.7): fmtPriceCompact(0) возвращает '' —
                        // `if (!price) return '';` в самой функции (не трогаю,
                        // общий форматтер) — нижний тик 0 рисовался пустым,
                        // выглядело как «ось не начинается с 0». min:0 гарантирует
                        // сам тик 0, явный 0-кейс — подпись "0".
                        callback: REPORT_LEGACY_MARKUP
                            ? function(value) { return (value / 1000000) + 'M'; }
                            : function(value) { return value === 0 ? '0' : fmtPriceCompact(value); },
                        font: { size: 10, family: tickFontFamily }
                    }
                },
                x: {
                    grid: { display: false },
                    ticks: { font: { size: 10, weight: REPORT_LEGACY_MARKUP ? 'bold' : '500', family: tickFontFamily } }
                }
            },
            animation
        }
    });
}

// ============================================================
// TASK14 14.3: finance-model editor (site only, html.is-browser) —
// GET/PUT/DELETE /api/lot/{id}/model over #fmEditor
// (partials/screens/analysis.html; absent from the Mini App's
// partials/modals/analysis.html, so every fm* function below no-ops
// there via the `if (!fmRoot) return` guard in initFinanceModelEditor).
// ============================================================

// Значения по умолчанию UserInputs (finance/inputs.py) — используются
// только для ПРЕДЗАПОЛНЕНИЯ полей ввода, когда у пользователя ещё нет
// собственного overrides для этого поля (само значение никогда не
// отправляется как override, пока пользователь его не тронет).
const FM_USER_DEFAULTS = { entity: 'individual', sale_channel: 'private', required_margin_pct: 20.0, own_share_pct: 100.0 };
const FM_SALE_LEVEL_LABEL = { low: 'пессимист.', mid: 'реалист.', high: 'оптимист.' };
const FM_HEADLINE_LABEL = { pessimistic: 'Пессимистичный', realistic: 'Реалистичный', optimistic: 'Оптимистичный' };
const FM_RATIO_LABEL_SHORT = { start: 'старт', p25: 'p25', median: 'медиана', p75: 'p75' };
// TASK14 14.3b (item 4): human sentences for cost lines the engine could
// not price, mapped by the STABLE key the backend already gives each
// line — never by parsing model.warnings' string (that string embeds
// the raw constants key, e.g. "«Нотариальное оформление» не учтено
// (notary_contract_fee)", exactly the internal-key leak the owner
// flagged). unverified_key (a specific constant not confirmed) takes
// priority over line.key (missing platform data) when both exist.
const FM_WARNING_BY_UNVERIFIED_KEY = {
    notary_contract_fee: 'Нотариус: тариф не подтверждён — не учтено',
    etp_operator_fee_winner_pct: 'Комиссия оператора ETP: не подтверждена — не учтено',
    sauda_operator_fee_pct: 'Комиссия оператора Sauda: не подтверждена — не учтено',
};
const FM_WARNING_BY_LINE_KEY = {
    holding_utilities: 'Коммунальные платежи: нет площади',
    property_tax: 'Налог на имущество: нет оценочной стоимости',
    land_tax: 'Земельный налог: нет площади и назначения участка',
};

let fmState = null;
let fmSaveTimer = null;
// TASK14 14.3f (item 1, blocking): found live -- both fresh reports
// (3575, 3576) had a user_lot_models row with overrides == exactly the
// AI default ({"strategy": "at_target"}), written at page-open time
// with no user action; every such report then showed «вывод ИИ
// относится к оценке ИИ» permanently. Root-cause-agnostic guard: no
// fmScheduleSave() call can fire while this flag is set, covering every
// caller (a native <select> restoring a value on load/bfcache and
// firing a spurious 'change' event is the leading suspect, but this
// guard closes the gap regardless of which one it turns out to be).
let fmInitializing = false;

// §8.1: real minus (U+2212, not the ASCII hyphen Intl.NumberFormat
// actually emits even under ru-RU -- checked live, it does not localize
// the sign), comma decimal (ru-RU already gives this), thin space before
// "%" (ru-RU's percent style already gives this too).
function fmMoney(v) {
    if (v === null || v === undefined) return 'нет оценки';
    return formatMoney(Math.round(v)).replace('-', '−');
}
function fmPct(v, digits) {
    if (v === null || v === undefined) return 'нет оценки';
    const d = digits === undefined ? 1 : digits;
    return new Intl.NumberFormat('ru-RU', { style: 'percent', minimumFractionDigits: d, maximumFractionDigits: d })
        .format(v).replace('-', '−');
}
function fmThousands(n) {
    if (n === null || n === undefined || n === '') return '';
    return new Intl.NumberFormat('ru-RU').format(Math.round(Number(n)));
}
// Signed delta for the ascending ladder's "+N % (p25)" labels -- same
// real-minus/thin-space discipline as fmPct, but the sign is explicit
// even for positive/zero (a bare percentile delta reads as "0" without it).
function fmSignedPctPoints(deltaPct) {
    const rounded = Math.round(deltaPct);
    if (rounded === 0) return `0 %`;
    const sign = rounded > 0 ? '+' : '−';
    return `${sign}${Math.abs(rounded)} %`;
}
window.fmFormatMoneyInputOnBlur = (el) => {
    const digits = el.value.replace(/\D/g, '');
    el.value = digits ? fmThousands(digits) : '';
};
window.fmOnMoneyFieldChange = (path, rawValue) => {
    fmOnFieldChange(path, rawValue.replace(/\D/g, ''));
};
// TASK29 29.5: «Цена продажи, ₸» — единственное поле, которое правится без
// предварительного «Мои цифры»: первый ввод сам переключает режим (значение
// кладётся в overrides ДО перерисовки, иначе fmRenderEntryControls() стёр бы
// введённое). Пересчёт — только сервером (PUT /api/lot/{id}/model).
window.fmOnSalePriceInput = (rawValue) => {
    if (!fmState) return;
    const digits = rawValue.replace(/\D/g, '');
    if (fmState.mode !== 'mine') {
        fmSetOverridePath('sale_price', digits === '' ? undefined : Number(digits));
        fmState.mode = 'mine';
        fmRender();
        fmScheduleSave();
        return;
    }
    fmOnFieldChange('sale_price', digits);
};

// TASK16 16.0.1: purchase.floor_price is the REGULATORY floor (75 %/50 %
// of appraisal) -- but 16.0 found ETP never actually reaches it (no
// floor-exact step: 263 sold descending ETP lots end at 76 %/52 %, 0 at
// 75 %/50 %). purchase.last_step_price (the real nominal last step) is
// what every "пол"/"последний шаг" label should show on ETP instead.
// Sauda keeps floor_price -- its own last step DOES close exactly there
// (14.3f, single-bidder verified) -- and so does any report stored
// before 16.0, where last_step_price is simply absent (undefined, not
// null, straight off an old raw_report -- `!= null` catches both).
function fmFloorLabelPrice(m) {
    const floorPrice = m.purchase && m.purchase.floor_price;
    const lastStepPrice = m.purchase && m.purchase.last_step_price;
    const site = state.currentLot && state.currentLot.site;
    const useLastStep = site === 'etp' && lastStepPrice != null && lastStepPrice !== floorPrice;
    return { price: useLastStep ? lastStepPrice : floorPrice, isLastStep: useLastStep };
}

// 'up' | 'down' | 'direct' -- from the LOT itself (already loaded for this
// report as state.currentLot), not from the finance model (a computed
// FinancialModel never carries platform.auction_type). Same substring
// match finance/inputs.py::from_lot uses server-side.
function fmAuctionDirection() {
    const t = ((state.currentLot && state.currentLot.type_trading) || '').toLowerCase();
    if (t.includes('понижен')) return 'down';
    if (t.includes('повышен')) return 'up';
    return 'direct';
}

async function initFinanceModelEditor(lotId) {
    const fmRoot = document.getElementById('fmEditor');
    if (!fmRoot || !userId) return; // Mini App (id absent) или гость — не наш случай на этом экране

    fmInitializing = true;
    try {
        const res = await fetch(`/api/lot/${lotId}/model?user_id=${userId}`);
        if (!res.ok) return;
        const data = await res.json();
        if (!data.is_owner || !data.model) return;

        fmState = {
            lotId,
            mode: 'ai',
            source: data.source,
            model: data.model,
            aiDefaultModel: data.source === 'user' ? data.ai_default_model : data.model,
            overrides: data.source === 'user' ? (data.overrides || {}) : {},
            explain: data.explain || {},
            narrative: (currentAiReport && currentAiReport.financial_narrative) || null,
            // item 2: placeholders/read-only-mode values come from the AI's
            // OWN raw estimates (repair_mid/market_mid/hidden_risk_reserve_pct),
            // not from cost_lines (already-computed ₸ amounts that can't be
            // reverse-derived back into a % for hidden_risk_reserve_pct).
            // Same object for every source branch -- financial_inputs_ai
            // never changes when the user saves overrides, only the
            // resulting model does.
            aiInputs: (currentAiReport && currentAiReport.financial_inputs_ai) || {},
        };

        fmRoot.classList.remove('hidden');
        document.getElementById('uiFinDashboard')?.classList.add('fm-legacy-hidden');
        document.getElementById('calcWhatIfBlock')?.classList.add('fm-legacy-hidden');
        // reportChartWrap — Chart.js "Вход vs Рынок" bar (initFinancialChart,
        // LLM-financials-based) sits as a SIBLING of #uiFinDashboard, not a
        // child, so hiding just the two above left it visibly bleeding in
        // right below the new editor (found live in the first screenshot
        // pass) — it's superseded by fmEditor's own ladder/scenario tiles.
        document.getElementById('reportChartWrap')?.classList.add('fm-legacy-hidden');
        document.querySelector('.report-chart-caption')?.classList.add('fm-legacy-hidden');
        // TASK14 14.6 (owner, live on report 3597): #uiScenariosBlock
        // ("Сценарии доходности", synced from the engine since 11.6a --
        // _sync_engine_narrative overwrites investment_scenarios from
        // model.scenarios.headline) duplicates fmEditor's own scenario
        // tiles once the editor renders -- same .fm-legacy-hidden
        // mechanism as the three blocks above (html.is-browser only, so
        // Mini App keeps it; the share page never runs this function at
        // all, so it's untouched there too).
        document.getElementById('uiScenariosBlock')?.classList.add('fm-legacy-hidden');

        fmRender();
        // item 3 (14.3d): single source of truth -- once the engine's own
        // AI-default model is in hand, overwrite the legacy TL;DR/«Финансы»/
        // «Ликвидность и сроки» numbers (painted earlier, synchronously, by
        // renderInAppReport() from report.financials -- frozen at analysis
        // time) with the SAME fresh numbers the editor now shows. Sync
        // once, off the AI default, NOT re-run on every toggle/edit -- the
        // legacy sections describe the report's own canonical numbers, not
        // whatever the user is currently trying out in "Мои цифры".
        fmSyncLegacyNumbers();
    } catch (e) {
        console.error('Ошибка загрузки финансовой модели:', e);
    } finally {
        // item 1: cleared on a delay, not synchronously -- absorbs any
        // DELAYED spurious event a native <select>'s load/bfcache-restore
        // can fire (the leading suspect for the phantom PUT), not just
        // ones that happen inside this function's own synchronous body.
        setTimeout(() => { fmInitializing = false; }, 300);
    }
}

// item 3 (14.3d): the legacy sections this overwrites are LLM/analysis-
// time snapshots (report.financials via renderInAppReport/updateTldrStrip,
// both already painted before this ever runs) -- once the engine's own
// fresh AI-default model is loaded, every financial NUMBER outside the
// editor should read the exact same figures the editor shows, not a
// frozen copy that can drift the moment 14.3c-style recompute changes
// anything (found live: after 14.3c, GET recomputes fresh on every load,
// so on a report analyzed even a day earlier the TL;DR/Ликвидность
// numbers and the editor's numbers started visibly disagreeing).
// item 5 (14.3f nit): Russian plural for «день» -- "74 дней" is wrong
// (74 % 10 == 4, 74 % 100 not in 11-14 -> "74 дня").
function fmDaysWord(n) {
    const mod10 = n % 10, mod100 = n % 100;
    if (mod10 === 1 && mod100 !== 11) return 'день';
    if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return 'дня';
    return 'дней';
}

function fmSyncLegacyNumbers() {
    if (!fmState) return;
    const m = fmState.aiDefaultModel;
    if (!m || m.mode === 'lease_unsupported' || !m.results) return; // nothing to sync -- see fmRenderNarrative's lease branch
    const r = m.results;
    const neg = (r.profit_mid || 0) < 0;

    // TASK35: in the v2 layout the TL;DR strip belongs to renderV2Tldr() (the profile's ONE main number, the engine's ROI) --
    // this late sync used to put the entry price next to «Интересен ниже» while the Ответ card said the max bid
    const v2Layout = (document.getElementById('screen-analysis') || {}).dataset && document.getElementById('screen-analysis').dataset.reportLayout === 'v2';
    const tldrRoi = document.getElementById('uiTldrRoi');
    if (tldrRoi && !v2Layout) {
        tldrRoi.textContent = fmPct(r.roi_mid, 0);
        tldrRoi.classList.toggle('text-neg', neg);
        tldrRoi.classList.toggle('text-pos', !neg);
    }
    const tldrPrice = document.getElementById('uiTldrPrice');
    if (tldrPrice && !v2Layout && m.purchase && m.purchase.price != null) tldrPrice.textContent = fmMoney(m.purchase.price);

    // #uiFinDashboard is hidden (.fm-legacy-hidden) but keep its own text
    // consistent defensively rather than leave stale numbers in the DOM.
    const uiProfit = document.getElementById('uiProfit');
    if (uiProfit) {
        uiProfit.textContent = fmMoney(r.profit_mid);
        uiProfit.classList.toggle('text-neg', neg);
        uiProfit.classList.toggle('text-pos', !neg);
    }
    const uiRoi = document.getElementById('uiRoi');
    if (uiRoi) uiRoi.textContent = fmPct(r.roi_mid);

    // «Ликвидность и сроки»: «Ожидаемый срок продажи» used to come from
    // report.financials.estimated_sales_period_days (the LLM's own guess,
    // frozen at analysis time) -- the same single-source rule as above
    // means it now reads the engine's own payback_days (derived from the
    // model's dated cashflow timeline), the SAME number the narrative
    // cites -- never two different "how long" figures on one page again.
    const salesPeriodEl = document.getElementById('uiSalesPeriod');
    if (salesPeriodEl && r.payback_days != null) {
        salesPeriodEl.textContent = `${r.payback_days} ${fmDaysWord(r.payback_days)}`;
    }

    // «Аннуализация — грубая линейная оценка (ROI × 365/срок)» predates
    // results.irr (dated-cashflow IRR, the actual right number) -- when
    // the engine is on, relabel+refill in place rather than leave both
    // the old approximation's wording AND a disagreeing value on screen.
    const benchmarkBlock = document.getElementById('uiAnnualBenchmark');
    if (benchmarkBlock && r.irr != null) {
        const dealLabel = benchmarkBlock.querySelector('.report-annual-row:first-child > span:first-child');
        if (dealLabel) dealLabel.textContent = 'IRR годовых';
        const dealValue = document.getElementById('uiAnnualBenchmarkValue');
        if (dealValue) {
            const irrNeg = r.irr < 0;
            dealValue.textContent = fmPct(r.irr);
            dealValue.classList.toggle('text-neg', irrNeg);
            dealValue.classList.toggle('text-pos', !irrNeg);
        }
        const caption = benchmarkBlock.querySelector('.text-micro');
        if (caption) caption.textContent = 'IRR по датированным потокам: гарантийный взнос → оплата → продажа.';
    }
}

window.fmSetMode = (mode) => {
    if (!fmState) return;
    fmState.mode = mode;
    fmRender();
};

window.fmOnFieldChange = (path, rawValue) => {
    if (!fmState || fmState.mode !== 'mine') return;
    fmSetOverridePath(path, rawValue === '' ? undefined : Number(rawValue));
    fmRenderChangedChip();
    fmScheduleSave();
};

window.fmOnLeaseTypeChange = (value) => {
    if (!fmState || fmState.mode !== 'mine') return;
    fmSetOverridePath('lease_building_type', value === '' ? undefined : value);
    fmRenderChangedChip();
    fmScheduleSave();
};

window.fmOnOwnShareChange = (rawValue) => {
    if (!fmState || fmState.mode !== 'mine') return;
    fmSetOverridePath('financing.own_share_pct', rawValue === '' ? undefined : Number(rawValue));
    fmRenderLoanFieldsVisibility();
    fmRenderChangedChip();
    fmScheduleSave();
};

function fmSetOverridePath(path, value) {
    if (path.startsWith('financing.')) {
        const sub = path.slice('financing.'.length);
        if (value === undefined) {
            if (fmState.overrides.financing) delete fmState.overrides.financing[sub];
            if (fmState.overrides.financing && Object.keys(fmState.overrides.financing).length === 0) delete fmState.overrides.financing;
        } else {
            fmState.overrides.financing = { ...(fmState.overrides.financing || {}), [sub]: value };
        }
        return;
    }
    if (value === undefined || value === '' || (typeof value === 'number' && Number.isNaN(value))) {
        delete fmState.overrides[path];
    } else {
        fmState.overrides[path] = value;
    }
}

function fmScheduleSave() {
    if (fmInitializing) return; // item 1: never PUT on init
    clearTimeout(fmSaveTimer);
    fmSaveTimer = setTimeout(fmSave, 600);
}

async function fmSave() {
    if (!fmState) return;
    const snapshotOverrides = JSON.parse(JSON.stringify(fmState.overrides));
    try {
        const res = await fetch(`/api/lot/${fmState.lotId}/model`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ user_id: userId, overrides: snapshotOverrides, platform_override_ack: false }),
        });
        const data = await res.json();
        if (!res.ok) {
            showToast(fmErrorMessage(res.status, data));
            return;
        }
        fmState.model = data.model;
        fmState.explain = data.explain || {};
        fmState.overrides = data.overrides || {};
        fmState.source = 'user';
        fmRender();
        // PUT's own response doesn't carry a full ai_default_model (only
        // the per-field `ai_default` for the overridden keys) -- without
        // this, switching back to "Оценка ИИ" after the FIRST save would
        // keep showing whatever aiDefaultModel was loaded at page-open
        // (for an older report, that's raw_report.financial_model, frozen
        // at analysis time -- missing any field added to the engine
        // since, e.g. ratio_label). One extra GET refreshes it from the
        // same source GET already uses, keeping both columns consistent.
        await fmRefreshAiDefaultModel();
        fmRender();
    } catch (e) {
        console.error('Ошибка сохранения финансовой модели:', e);
        showToast('Не удалось сохранить изменения — проверьте соединение');
    }
}

async function fmRefreshAiDefaultModel() {
    try {
        const res = await fetch(`/api/lot/${fmState.lotId}/model?user_id=${userId}`);
        if (!res.ok) return;
        const data = await res.json();
        fmState.aiDefaultModel = (data.source === 'user' ? data.ai_default_model : data.model) || fmState.aiDefaultModel;
    } catch (e) {
        console.error('Не удалось обновить оценку ИИ:', e);
    }
}

function fmErrorMessage(status, data) {
    const detail = data && data.detail;
    if (status === 409) return 'Отчёт создан до движка — запустите анализ заново';
    if (status === 422 && detail && detail.unknown_fields) return `Неизвестные поля: ${detail.unknown_fields.join(', ')}`;
    if (status === 422 && detail && detail.validation_errors) return detail.validation_errors.join('; ');
    if (typeof detail === 'string') return detail;
    return 'Не удалось сохранить изменения';
}

window.fmReset = async () => {
    if (!fmState) return;
    try {
        const res = await fetch(`/api/lot/${fmState.lotId}/model?user_id=${userId}`, { method: 'DELETE' });
        const data = await res.json();
        if (!res.ok) {
            showToast(fmErrorMessage(res.status, data));
            return;
        }
        fmState.model = data.model;
        fmState.aiDefaultModel = data.model;
        fmState.explain = data.explain || {};
        fmState.overrides = {};
        fmState.source = 'ai_default';
        fmRender();
        showToast('Модель сброшена к расчёту ИИ');
    } catch (e) {
        console.error('Ошибка сброса финансовой модели:', e);
        showToast('Не удалось сбросить модель');
    }
};

// item 1 (14.3d): mode == "lease_unsupported" on whichever model is
// currently the primary one for the active tab -- a saved override
// (source "user") could in principle carry a different mode than the AI
// default, but deal_type doesn't change per-override, so in practice
// both always agree; checking the primary one is enough.
function fmIsLease() {
    const m = fmState.mode === 'mine' ? fmState.model : fmState.aiDefaultModel;
    // TASK21 21.3: every real Sauda lease lot now runs the real land-lease
    // model (mode == 'lease'), not the old placeholder -- 'lease_unsupported'
    // is kept here too since it's still the defensive premises fallback
    // (finance/model.py::_lease_unsupported_model's own docstring).
    return m.mode === 'lease' || m.mode === 'lease_unsupported';
}

function fmRender() {
    if (!fmState) return;
    const isLease = fmIsLease();
    document.getElementById('fmEditor').classList.toggle('fm-lease-mode', isLease);
    fmRenderToggle();
    fmRenderChangedChip();
    fmRenderStrategySelect();
    fmRenderEntryControls();
    fmRenderLoanFieldsVisibility();
    fmRenderEntryPrice();
    // TASK15 15.5 nit 1: computed once per fmRender() pass so the ladder
    // and the sensitivity grid below both read the exact same formatter
    // instance for the exact same current-mode price set.
    fmState.priceFormatter = fmComputeCurrentPriceFormatter();
    fmRenderLadder();
    fmRenderCurveCaption();
    fmRenderDeposit(); // platform part -- shown in both lease and sale mode
    if (isLease) {
        // item 1: "the editor renders only the entry block + the
        // warning" -- repair/market/sale inputs, cost table, totals,
        // scenarios and sensitivity all hidden (dashboard.css's
        // .fm-lease-mode rules); the lease terms replace the flip-cost
        // entry controls.
        fmRenderLeaseTerms();
    } else {
        fmRenderTable();
        fmRenderWarnings();
        fmRenderTotals();
        fmRenderScenarios();
        fmRenderSensitivity();
    }
    fmRenderNarrative();
}

function fmRenderToggle() {
    document.querySelectorAll('.fm-toggle-btn').forEach(btn => {
        btn.classList.toggle('active', btn.dataset.fmMode === fmState.mode);
    });
    const editing = fmState.mode === 'mine';
    ['fmStrategy', 'fmCustomPrice', 'fmEntity', 'fmSaleChannel', 'fmMargin', 'fmOwnShare', 'fmLoanRate', 'fmLoanMonths', 'fmRepair', 'fmRiskReserve'].forEach(id => {
        const el = document.getElementById(id);
        if (el) el.disabled = !editing;
    });
    // item 6: "Оценка ИИ" = single read-only column, "Мои цифры" =
    // editable + ghost AI column -- one class on the root drives both
    // the cost table and the totals block (dashboard.css).
    document.getElementById('fmEditor').classList.toggle('fm-mode-ai', !editing);
    document.getElementById('fmEditor').classList.toggle('fm-mode-mine', editing);
}

// item 1 (14.3f): a submitted override key whose value happens to equal
// what the AI default already is isn't a REAL change -- counting it
// anyway is how the phantom-override bug first became visible («изменено
// 1 поле» with nothing actually different). Compares against the same
// defaults fmRenderEntryControls() itself uses (FM_USER_DEFAULTS for the
// user layer, fmState.aiInputs for the AI layer).
//
// 14.5 (owner, live): "strategy" needs a DIFFERENT comparison than every
// other field -- multiple strategy strings can resolve to the identical
// purchase. Found live: the owner picked «Дождаться пола» (at_step:24),
// the exact step at_target already resolves to on that lot -- comparing
// the raw string against 'at_target' counted it as a change and hid the
// narrative behind «Вывод ИИ относится к оценке ИИ» for no real reason.
// fmState.model/aiDefaultModel are both already the RESOLVED models (this
// function only ever runs after they're loaded), so comparing their own
// purchase.price/step_k is exact -- no extra request needed here, unlike
// the backend's equivalent fix (_resolved_diff_keys, api_server.py),
// which has to recompute the AI-default's purchase specially for this.
function fmActualOverrideKeys() {
    const ov = fmState.overrides;
    const ai = fmState.aiInputs || {};
    const userDefaultFor = {
        entity: FM_USER_DEFAULTS.entity, sale_channel: FM_USER_DEFAULTS.sale_channel,
        required_margin_pct: FM_USER_DEFAULTS.required_margin_pct,
    };
    return Object.keys(ov).filter(key => {
        if (key === 'platform_override_ack') return false;
        if (key === 'financing') {
            const def = { own_share_pct: FM_USER_DEFAULTS.own_share_pct, loan_rate_pct: null, loan_months: null };
            return Object.keys(ov.financing || {}).some(k => ov.financing[k] !== def[k]);
        }
        if (key === 'strategy') {
            const mine = fmState.model && fmState.model.purchase;
            const dflt = fmState.aiDefaultModel && fmState.aiDefaultModel.purchase;
            if (!mine || !dflt) return ov.strategy !== 'at_target';
            return mine.price !== dflt.price || mine.step_k !== dflt.step_k;
        }
        if (key === 'sale_price') {
            const sale = fmState.aiDefaultModel && fmState.aiDefaultModel.sale;
            return !sale || ov.sale_price !== (sale.default_mid ?? sale.mid);
        }
        const defaultVal = key in userDefaultFor ? userDefaultFor[key] : ai[key];
        return ov[key] !== defaultVal;
    });
}

function fmRenderChangedChip() {
    const n = fmActualOverrideKeys().length;
    const chip = document.getElementById('fmChangedChip');
    const resetBtn = document.getElementById('fmResetBtn');
    if (n > 0) {
        chip.textContent = `изменено ${n} ${n === 1 ? 'поле' : 'полей'}`;
        chip.classList.remove('hidden');
        resetBtn.classList.remove('hidden');
    } else {
        chip.classList.add('hidden');
        resetBtn.classList.add('hidden');
    }
}

// item 1 (11.6d semantics in the UI): the CURRENT model (mine in "Мои
// цифры", ai default in "Оценка ИИ") carries a `scenarios.sensitivity`
// list -- for a descending/ETP lot these are discrete auction STEPS
// (`ratio_label` absent), for a Sauda-ascending lot with enough observed
// data these are curve PERCENTILES (`ratio_label` = 'start'/'p25'/
// 'median'/'p75', see finance/scenarios.py::ascending_sensitivity_grid).
// Both the ladder and the sensitivity grid below read the SAME cells so
// they can never disagree with each other.
function fmSensitivityCells() {
    const m = fmState.mode === 'mine' ? fmState.model : fmState.aiDefaultModel;
    return m.scenarios?.sensitivity || [];
}
// TASK15 15.5 nit 1 (owner review): the ladder and sensitivity grid used
// to read reportPriceFormatter, built from the FROZEN report.financial_model
// -- but they render the CURRENT mode's model (the live-recomputed
// aiDefaultModel, or the user's own overridden model in "mine" mode),
// whose prices can genuinely differ from that frozen snapshot. Built
// fresh from THIS mode's own fmSensitivityCells() + its own entry price
// every time the ladder/grid render (fmRender(), before either), so both
// always agree with each other on the SAME current-mode formatter.
function fmComputeCurrentPriceFormatter() {
    const m = fmState.mode === 'mine' ? fmState.model : fmState.aiDefaultModel;
    const prices = fmSensitivityCells().map((c) => c.price).filter((p) => typeof p === 'number');
    if (m && m.purchase && typeof m.purchase.price === 'number') prices.push(m.purchase.price);
    return buildDistinctPriceFormatter(prices);
}
function fmIsAscendingGrid(cells) {
    return cells.length > 0 && cells[0].ratio_label != null;
}
// Descending: dedupe by step_k, sort ascending (a stable auction ladder).
// TASK14 14.5b: [k, price, availability_pct] -- the third element rides
// along for fmRenderLadder's "P N%" row (item 3); the other three callers
// only destructure [k, price] and are unaffected by the extra element.
function fmDescendingSteps(cells) {
    const seen = new Map();
    cells.forEach(c => { if (!seen.has(c.step_k)) seen.set(c.step_k, [c.price, c.availability_pct]); });
    return [...seen.entries()].sort((a, b) => a[0] - b[0]).map(([k, [price, pct]]) => [k, price, pct]);
}
// Ascending: dedupe by ratio_label, KEEP insertion order -- the backend
// already emits cells in ratio order (start, p25?, median, p75?, see
// ascending_sensitivity_grid) and that order is the only reliable way to
// tell "3 points" meaning "start/p25/median" apart from "start/median/p75"
// (both are 3 points; sorting by step_k or price can't disambiguate them).
function fmAscendingPoints(cells) {
    const seen = new Map();
    cells.forEach(c => { if (c.ratio_label && !seen.has(c.ratio_label)) seen.set(c.ratio_label, [c.price, c.availability_pct]); });
    return [...seen.entries()].map(([label, [price, pct]]) => [label, price, pct]);
}
function fmAscendingPointCaption(label, price, startPrice) {
    if (label === 'start' || !startPrice) return FM_RATIO_LABEL_SHORT[label] || label;
    const delta = fmSignedPctPoints((price / startPrice - 1) * 100);
    if (label === 'median') return `медиана ${delta}`;
    return `${delta} (${FM_RATIO_LABEL_SHORT[label] || label})`;
}

function fmRenderStrategySelect() {
    const sel = document.getElementById('fmStrategy');
    const customField = document.getElementById('fmCustomPrice');
    const m = fmState.mode === 'mine' ? fmState.model : fmState.aiDefaultModel;
    const current = fmState.mode === 'mine'
        ? (fmState.overrides.strategy || m.purchase?.strategy || 'at_target')
        : (m.purchase?.strategy || 'at_target');
    const cells = fmSensitivityCells();
    sel.innerHTML = '';
    if (fmAuctionDirection() === 'up' && fmIsAscendingGrid(cells)) {
        // item 1: no "дождаться шага" wording for ascending -- there is no
        // discrete step ladder to wait on once real competitive bidding
        // exists (finance/scenarios.py::ascending_sensitivity_grid's own
        // docstring: "a Sauda ascending sale can land anywhere").
        sel.add(new Option('Купить по старту', 'at_start'));
        sel.add(new Option('Ожидаемая цена (медиана)', 'at_target'));
    } else {
        sel.add(new Option('Оптимальная цена (по расчёту)', 'at_target'));
        sel.add(new Option('Купить по старту', 'at_start'));
        // item 2: the last step (Sauda descending) is the lot's own
        // floor -- single-bidder sales close exactly there (11.6c live
        // verification) -- labelled "Дождаться пола", not a bare step
        // number, so the investor recognises it as the floor. TASK16
        // 16.0.1: on ETP that terminal step is last_step_price, not the
        // unreachable floor_price -- see fmFloorLabelPrice.
        const { price: floorLabelPrice } = fmFloorLabelPrice(m);
        fmDescendingSteps(cells).forEach(([k, price]) => {
            const label = (floorLabelPrice != null && price === floorLabelPrice)
                ? `Дождаться пола — ${fmMoney(price)}`
                : `Дождаться шага ${k} — ${fmMoney(price)}`;
            sel.add(new Option(label, `at_step:${k}`));
        });
    }
    sel.add(new Option('Своя цена…', 'custom'));
    const isCustomPrice = /^at_price:/.test(current);
    sel.value = isCustomPrice ? 'custom' : ([...sel.options].some(o => o.value === current) ? current : 'at_target');
    customField.classList.toggle('hidden', !isCustomPrice);
    if (isCustomPrice) customField.value = fmThousands(current.split(':')[1]);
}

window.fmOnStrategyChange = (value) => {
    if (!fmState || fmState.mode !== 'mine') return;
    const customField = document.getElementById('fmCustomPrice');
    if (value === 'custom') {
        customField.classList.remove('hidden');
        customField.value = '';
        customField.focus();
        return; // ждём цену -- override пока не трогаем
    }
    customField.classList.add('hidden');
    fmSetOverridePath('strategy', value);
    fmRenderChangedChip();
    fmScheduleSave();
};
window.fmOnCustomPriceChange = (rawValue) => {
    if (!fmState || fmState.mode !== 'mine') return;
    const digits = rawValue.replace(/\D/g, '');
    fmSetOverridePath('strategy', digits ? `at_price:${digits}` : undefined);
    fmRenderChangedChip();
    fmScheduleSave();
};

function fmRenderEntryControls() {
    const mine = fmState.mode === 'mine';
    const ov = fmState.overrides;
    const ai = fmState.aiInputs || {};
    document.getElementById('fmEntity').value = mine ? (ov.entity || FM_USER_DEFAULTS.entity) : FM_USER_DEFAULTS.entity;
    document.getElementById('fmSaleChannel').value = mine ? (ov.sale_channel || FM_USER_DEFAULTS.sale_channel) : FM_USER_DEFAULTS.sale_channel;
    // item 6: "Оценка ИИ" shows the AI's OWN value (read-only), not an
    // empty ghost -- there is no "override" concept in that tab at all.
    // "Мои цифры" shows the saved override (editable) with the AI value
    // as a §7.2 ghost placeholder when no override is saved yet.
    const setPctField = (id, overrideVal, aiVal) => {
        const el = document.getElementById(id);
        if (!el) return;
        if (mine) {
            el.value = (overrideVal !== undefined && overrideVal !== null) ? overrideVal : '';
            el.placeholder = (aiVal === null || aiVal === undefined) ? '' : String(aiVal);
        } else {
            el.value = (aiVal === null || aiVal === undefined) ? '' : aiVal;
        }
    };
    const setMoneyField = (id, overrideVal, aiVal) => {
        const el = document.getElementById(id);
        if (!el) return;
        if (mine) {
            el.value = (overrideVal !== undefined && overrideVal !== null) ? fmThousands(overrideVal) : '';
            el.placeholder = (aiVal === null || aiVal === undefined) ? '' : fmThousands(aiVal);
        } else {
            el.value = (aiVal === null || aiVal === undefined) ? '' : fmThousands(aiVal);
        }
    };
    setPctField('fmMargin', ov.required_margin_pct, FM_USER_DEFAULTS.required_margin_pct);
    setPctField('fmOwnShare', ov.financing && ov.financing.own_share_pct, FM_USER_DEFAULTS.own_share_pct);
    setPctField('fmLoanRate', ov.financing && ov.financing.loan_rate_pct, null);
    setPctField('fmLoanMonths', ov.financing && ov.financing.loan_months, null);
    setMoneyField('fmRepair', ov.repair_mid, ai.repair_mid);
    setPctField('fmRiskReserve', ov.hidden_risk_reserve_pct, ai.hidden_risk_reserve_pct);
    // TASK29 29.5: «Цена продажи» — в обоих режимах пусто + placeholder с ценой
    // модели (не-фокусное поле не перезаписываем, пока по нему печатают).
    const saleEl = document.getElementById('fmSalePrice');
    if (saleEl) {
        const dflt = fmState.aiDefaultModel && fmState.aiDefaultModel.sale;
        const dfltMid = dflt ? (dflt.default_mid ?? dflt.mid) : null;
        saleEl.placeholder = dfltMid == null ? '' : fmThousands(dfltMid);
        const typed = mine && ov.sale_price != null ? fmThousands(ov.sale_price) : '';
        if (document.activeElement !== saleEl || saleEl.value.replace(/\D/g, '') !== String(ov.sale_price ?? '')) {
            saleEl.value = typed;
        }
    }
}

function fmRenderLoanFieldsVisibility() {
    const ownShare = (fmState.overrides.financing && fmState.overrides.financing.own_share_pct !== undefined)
        ? fmState.overrides.financing.own_share_pct : FM_USER_DEFAULTS.own_share_pct;
    const show = fmState.mode === 'mine' && ownShare < 100;
    document.getElementById('fmLoanRateField').classList.toggle('hidden', !show);
    document.getElementById('fmLoanMonthsField').classList.toggle('hidden', !show);
}

function fmRenderEntryPrice() {
    const m = fmState.mode === 'mine' ? fmState.model : fmState.aiDefaultModel;
    document.getElementById('fmEntryPrice').textContent = fmMoney(m.purchase?.price);
    const pct = m.purchase?.availability_pct;
    // item 1: hide P(available) when it's 1.0/undefined -- "always
    // available" carries no information, and for an ascending lot the
    // concept doesn't apply the same way a descending step's survival
    // probability does.
    const availEl = document.getElementById('fmEntryAvailability');
    if (pct === null || pct === undefined || pct >= 100) {
        availEl.textContent = '';
    } else {
        availEl.textContent = `доступен с вероятностью ${pct} %`;
    }
}

// Лестница — свой SVG (§9: без библиотек графиков). Descending: точки
// равномерно по оси X, подписаны шагом+ценой (fmDescendingSteps).
// Ascending (item 1): те же точки, но это percentile-цены старт/p25/
// медиана/p75 (fmAscendingPoints), подписаны соответствующей меткой, а
// не номером шага -- "шаг 0/1/2" не имеет смысла, когда цена может
// оказаться где угодно выше старта. "Выбранная" точка определяется по
// ТОЧНОМУ совпадению цены с purchase.price (работает одинаково в обоих
// режимах, а не только по step_k, который для ascending -- лишь
// "ближайший" шаг для отображения, не факт выбора).
// item 4 (14.3d, nit): "chosen" used to be price equality, which marks
// EVERY point that happens to share a price -- coincidence, not identity
// (start/p25/median frequently round to the same price, found live on
// 3534: 3 sensitivity rows all showed ◉). The chosen point is the one
// the STRATEGY actually resolved to, by index, never by which prices
// happen to coincide. Ascending: "at_start" is always exactly the
// 'start' point, "at_target" is always exactly the 'median' point
// (finance/scenarios.py::ascending_sensitivity_grid's own ratio order —
// at_target's price = round(start * median_ratio), see auction.py's
// 11.6d branch); a custom "at_price:X" has no ratio identity, so price
// match is the only option there. Descending: step_k is already unique
// per point, no ambiguity to fix.
function fmChosenPointIndex(points, ascending, m) {
    const strategy = (m.purchase && m.purchase.strategy) || '';
    if (ascending) {
        if (strategy === 'at_start') return points.findIndex(([label]) => label === 'start');
        if (strategy === 'at_target') return points.findIndex(([label]) => label === 'median');
        const price = m.purchase && m.purchase.price;
        return points.findIndex(([, p]) => p === price);
    }
    const stepK = m.purchase && m.purchase.step_k;
    return points.findIndex(([step]) => step === stepK);
}

function fmRenderLadder() {
    const wrap = document.getElementById('fmLadder');
    const m = fmState.mode === 'mine' ? fmState.model : fmState.aiDefaultModel;
    const cells = fmSensitivityCells();
    const ascending = fmAuctionDirection() === 'up' && fmIsAscendingGrid(cells);
    const points = ascending ? fmAscendingPoints(cells) : fmDescendingSteps(cells);
    if (!points.length) {
        // Пусто вместо угадывания шкалы: нет сетки чувствительности — нет
        // и лестницы. §8: "Empty AI ranges -> «нет оценки» not 0" -- то
        // же для лестницы.
        wrap.innerHTML = '<p class="text-caption text-tertiary">нет данных для лестницы цены по этому лоту</p>';
        return;
    }
    const chosenIndex = fmChosenPointIndex(points, ascending, m);
    const startPrice = ascending ? points[0][1] : null;
    // TASK16 16.0.1: ETP's terminal ladder point is last_step_price, not
    // the unreachable floor_price -- see fmFloorLabelPrice.
    const { price: floorLabelPrice } = fmFloorLabelPrice(m);
    const w = Math.max(480, points.length * 96);
    // item 3 (14.5b, owner: "P(available) under every ladder point... on
    // this lot it falls from ~95% at start to ~40% at the floor, which is
    // the whole decision") -- a third text row under the step/floor
    // caption; h/y grow to fit it without crowding the existing two rows.
    const h = 78;
    const y = 18;
    // item 4: the first/last labels used to clip against the SVG's own
    // edge under text-anchor="middle" (found live: "386 400" -> "86,4
    // тыс." with the leading digit cut off) -- anchor the first point's
    // text to "start" and the last to "end" so they grow INTO the
    // viewBox instead of half outside it; interior points keep "middle".
    const xAt = (i) => 24 + i * ((w - 48) / Math.max(1, points.length - 1));
    const anchorAt = (i) => (i === 0 ? 'start' : (i === points.length - 1 ? 'end' : 'middle'));
    let svg = `<svg viewBox="0 0 ${w} ${h}" xmlns="http://www.w3.org/2000/svg">`;
    svg += `<line x1="24" y1="${y}" x2="${w - 24}" y2="${y}" stroke="var(--border-subtle)" stroke-width="1"></line>`;
    points.forEach(([labelOrStep, price, availabilityPct], i) => {
        const x = xAt(i);
        const anchor = anchorAt(i);
        const chosen = i === chosenIndex;
        const isFloor = !ascending && floorLabelPrice != null && price === floorLabelPrice;
        const caption = ascending ? fmAscendingPointCaption(labelOrStep, price, startPrice) : (isFloor ? 'пол' : String(labelOrStep));
        svg += `<circle cx="${x}" cy="${y}" r="${chosen ? 5 : 3.5}" fill="${chosen ? 'var(--accent)' : 'var(--bg-surface)'}" stroke="${chosen ? 'var(--accent)' : 'var(--text-tertiary)'}" stroke-width="1.5"></circle>`;
        svg += `<text x="${x}" y="${y + 20}" text-anchor="${anchor}" font-size="10" font-family="var(--font-mono)" fill="${chosen ? 'var(--text-primary)' : 'var(--text-tertiary)'}">${caption}</text>`;
        if (availabilityPct != null) {
            svg += `<text x="${x}" y="${y + 33}" text-anchor="${anchor}" font-size="9" font-family="var(--font-mono)" fill="var(--text-tertiary)">P ${availabilityPct} %</text>`;
        }
        svg += `<text x="${x}" y="${y - 10}" text-anchor="${anchor}" font-size="10" font-family="var(--font-mono)" fill="${chosen ? 'var(--text-primary)' : 'var(--text-tertiary)'}">${fmState.priceFormatter(price)}<title>${fmMoney(price)}</title></text>`;
    });
    svg += '</svg>';
    wrap.innerHTML = svg;
    // TASK21 (owner review, 375px): .fm-ladder scrolls horizontally once
    // the ladder is wider than the screen (found live: the selected step
    // -- often «пол» -- opened off-screen, to the right of the visible
    // area). Centre the scroll on the chosen point's own x (in viewBox
    // units, scaled to the rendered scrollWidth) instead of defaulting
    // to the left edge.
    if (chosenIndex >= 0 && wrap.scrollWidth > wrap.clientWidth) {
        const chosenX = xAt(chosenIndex);
        const target = (chosenX / w) * wrap.scrollWidth - wrap.clientWidth / 2;
        wrap.scrollLeft = Math.max(0, Math.min(wrap.scrollWidth - wrap.clientWidth, target));
    }
}

function fmRenderCurveCaption() {
    const m = fmState.mode === 'mine' ? fmState.model : fmState.aiDefaultModel;
    // TASK35 35.2: ONE «пол» on the page = the last REACHABLE ladder price (76 % / 52 % on ETP), not the 75 % / 50 % rule value
    const { price: floor } = fmFloorLabelPrice(m);
    const el = document.getElementById('fmCurveCaption');
    el.textContent = (floor === null || floor === undefined) ? '' : `Пол торгов: ${fmMoney(floor)}`;
}

// TASK14 14.3 adaptation note (see commit message): cost_line-editing
// happens via the input controls above, NOT inline in this table — some
// editable fields (маржа/режим/своих денег) aren't cost lines at all, and
// the ones that are (repair_mid ₸, hidden_risk_reserve_pct %) have unit
// mismatches with their own cost_line.amount (a computed ₸ figure) that
// would make an inline ₸-input feeding a %-override actively misleading.
// This table is a pure computed comparison + "как посчитано" expander,
// exactly like the mockup's ghost column, just without letting a cell
// itself be the input.
// item 5: every cost row AND every result row gets a "как посчитано ▸"
// expander (the ⓘ IS the trigger) -- one shared builder so both
// fmRenderTable (per-cost-line .explain) and fmRenderTotals
// (fmState.explain's "results.*"/"capital.*" keys) produce the exact
// same markup/behaviour (mono, wraps, keyboard-accessible via a real
// <button> with aria-expanded).
let fmExplainSeq = 0;
function fmExplainTrigger(explainText) {
    if (!explainText) return '';
    const rowId = `fm-explain-${fmExplainSeq++}`;
    return {
        button: `<button type="button" class="fm-explain-toggle" onclick="fmToggleExplain('${rowId}', this)" aria-expanded="false" aria-controls="${rowId}" aria-label="как посчитано" title="как посчитано"><i class="ph-bold ph-info"></i></button>`,
        panel: `<div id="${rowId}" class="fm-explain hidden text-caption text-tertiary font-mono-nums">${explainText}</div>`,
    };
}
window.fmToggleExplain = (id, btn) => {
    const el = document.getElementById(id);
    if (!el) return;
    const nowHidden = el.classList.toggle('hidden');
    if (btn) btn.setAttribute('aria-expanded', String(!nowHidden));
};

// item 1 (14.3d): "platform part only (annual rate, term months if
// known, deposit, ladder with availability, total rent over the term)"
// -- deposit is rendered separately (fmRenderDeposit, shown in both
// modes); this covers the rest of model.rent.
// TASK14 14.3f (item 4b, owner correction): start_price/lease_rate for a
// lease lot is the ONE-OFF payment for the lease right over the whole
// term, not a ₸/year rate -- "Ставка аренды, ₸/год" / "Итого аренда за
// срок" (rate x term, 14.3d's wrong multiplication) are both gone.
//
// TASK21 21.4: extended for mode == 'lease' (finance/lease.py's real
// model) -- strategy + reason, expected entry (§4b item 2, low/high),
// payment schedule (п.48), annual fee with its own label (§4a, never a
// silent 0), the guarantee-excess refund line (§4b item 1, shown only
// when it exists), the S5 sublease/assignment facts, and the two editor
// inputs (§4b item 5) that turn the by-construction break-even sentence
// into a real NPV/IRR/payback/max_bid once the investor fills one in.
// mode == 'lease_unsupported' (the defensive premises fallback) keeps
// the original 3-row rendering below unchanged.
const FM_LEASE_STRATEGY_LABEL = {
    S3: 'Построить и сдать/использовать',
    S4: 'Временный объект',
    NONE: 'Не моделируется',
};

function fmLeaseMoneyInputHtml(id, path, label, currentValue, editing) {
    const val = currentValue != null ? fmThousands(currentValue) : '';
    return `<div class="fm-field">
        <label class="text-caption text-secondary" for="${id}">${label}</label>
        <input type="text" inputmode="numeric" id="${id}" class="fm-input font-mono-nums" value="${val}"
               ${editing ? '' : 'disabled'}
               oninput="fmOnMoneyFieldChange('${path}', this.value)" onblur="fmFormatMoneyInputOnBlur(this)">
    </div>`;
}

function fmRenderLeaseTerms() {
    const el = document.getElementById('fmLeaseTerms');
    const m = fmState.mode === 'mine' ? fmState.model : fmState.aiDefaultModel;
    const rent = m.rent || {};
    el.classList.remove('hidden');

    if (m.mode !== 'lease') {
        const termNote = rent.term_source === 'formula' ? ' (срок выведен из формулы платы за право аренды)' : '';
        const rows = [
            { label: 'Плата за право аренды (за весь срок)', value: rent.lease_right_price != null ? fmMoney(rent.lease_right_price) : 'нет данных' },
            { label: 'Срок аренды', value: rent.term_months != null ? `${rent.term_months} мес.${termNote}` : 'не указан в документах' },
            { label: 'Ежегодная арендная плата акимату', value: 'не учтена' },
        ];
        el.innerHTML = rows.map(r => `<div class="report-fin-row">
            <span class="text-caption text-secondary">${r.label}</span>
            <span class="text-body font-mono-nums text-primary">${r.value}</span>
        </div>`).join('');
        return;
    }

    const editing = fmState.mode === 'mine';
    const termNote = rent.term_source === 'formula' ? ' (срок выведен из формулы платы за право аренды)' : '';
    const rows = [];
    rows.push({ label: 'Стратегия', value: `${FM_LEASE_STRATEGY_LABEL[rent.strategy] || rent.strategy || '—'}` });
    if (rent.purpose_label) rows.push({ label: 'Назначение участка', value: rent.purpose_label });
    if (rent.max_bid != null) rows.push({ label: 'Максимальный разовый платёж', value: fmMoney(rent.max_bid) });
    if (rent.building_area_m2 != null) {
        const src = rent.building_area_source;
        const note = src === 'listings_p75'
            ? `площадь здания — как у сдаваемых помещений в выборке (p75 ${fmAreaNum(rent.rent_area_p75)} м²); для здания больше ставка за м² обычно ниже — укажите свою площадь в «Мои цифры»`
            : (src === 'user' ? 'площадь здания — ваша' : (rent.coverage_assumption ? `площадь здания — ${Math.round(rent.coverage_assumption * 100)} % участка` : ''));
        rows.push({ label: 'Площадь здания', value: `${fmAreaNum(rent.building_area_m2)} м²${note ? `<br><span class="text-caption text-tertiary">${escapeHtml(note)}</span>` : ''}` });
    }
    const e = rent.expected_entry;
    rows.push({
        label: 'Ожидаемая цена входа',
        value: e ? `${fmMoney(e.price)} (от ${fmMoney(e.low)} до ${fmMoney(e.high)})` : fmMoney(rent.lease_right_price),
    });
    rows.push({ label: 'Срок аренды', value: rent.term_months != null ? `${rent.term_months} мес.${termNote}` : 'не указан в документах' });
    if (rent.payment_schedule) {
        // TASK21 21.4 (owner review, item 3): 0 ₸ reads as "nothing owed"
        // when it usually means the deposit already covers this leg --
        // covered_by_deposit (finance/lease.py's own field) says so.
        const paymentValue = (leg) => leg.covered_by_deposit
            ? `покрыто гарантийным взносом · ${fmtDate(leg.date)}`
            : `${fmMoney(leg.amount)} · ${fmtDate(leg.date)}`;
        const ps = rent.payment_schedule;
        rows.push({ label: 'Аванс (50%, 2 раб. дня)', value: paymentValue(ps.advance) });
        rows.push({ label: 'Остаток (30 календ. дней)', value: paymentValue(ps.balance) });
    }
    if (rent.annual_fee) {
        rows.push({ label: 'Ежегодная плата за пользование участком', value: rent.annual_fee.amount_kzt != null ? fmMoney(rent.annual_fee.amount_kzt) : 'не учтена' });
    }
    if (rent.excess_refund) {
        rows.push({ label: 'Возврат излишка гарантийного взноса', value: `${fmMoney(rent.excess_refund.amount)} · ${fmtDate(rent.excess_refund.date)}` });
    }
    if (rent.sublease_disabled_reason) {
        rows.push({ label: 'Субаренда/переуступка', value: 'запрещена законом' });
    } else if (rent.assignment_fact && rent.assignment_fact !== 'не_установлено') {
        rows.push({ label: 'Переуступка права', value: rent.assignment_fact === 'разрешена' ? 'разрешена' : 'запрещена' });
    }

    let html = rows.map(r => `<div class="report-fin-row">
        <span class="text-caption text-secondary">${r.label}</span>
        <span class="text-body font-mono-nums text-primary">${r.value}</span>
    </div>`).join('');

    html += `<p class="text-caption text-primary fm-lease-condition">${escapeHtml(fmLeaseConditionSentence(rent))}</p>`;

    // §5.5 "honesty": every caveat the engine itself flagged (vacancy
    // assumption unverified, expected entry unresolved, why NPV/IRR are
    // hidden, why max_bid needs an income) -- shown, not swallowed.
    if (Array.isArray(rent.warnings) && rent.warnings.length) {
        html += `<ul class="fm-lease-warnings">${rent.warnings.map(w => `<li class="text-caption text-tertiary">${escapeHtml(w)}</li>`).join('')}</ul>`;
    }

    if (rent.strategy === 'S3' && (rent.break_even_construction_cost_per_m2 != null || rent.max_bid != null)) {
        // TASK39: the optimistic assumptions behind Z / the max payment, in plain words, right next to the number
        const vac = ((rent.warnings || []).map((w) => /простой\s+([\d.,]+)\s*%/i.exec(w)).find(Boolean) || [])[1] || '10';
        const right = rent.end_of_term_right && rent.end_of_term_right.quote
            ? `После срока здание считается за 0 ₸ — в описании лота есть «${escapeHtml(rent.end_of_term_right.quote)}», но условий (цена, срок) нет; свою оценку можно ввести ниже.`
            : 'После срока здание считается за 0 ₸: продление или выкуп в документах лота не указаны.';
        html += `<p class="text-caption text-primary" style="margin-top:12px;">Что делает расчёт оптимистичным:</p><ul class="fm-lease-warnings">`
            + `<li class="text-caption text-tertiary">Ставка аренды за м² взята из объявлений небольших помещений: большое здание обычно сдаётся дешевле за м² — поэтому площадь здания по умолчанию не больше типичной в выборке.</li>`
            + `<li class="text-caption text-tertiary">Простой ${escapeHtml(String(vac).replace('.', ','))} % времени — допущение, данными не подтверждено.</li>`
            + `<li class="text-caption text-tertiary">${right}</li></ul>`;
    }

    if (rent.strategy === 'S3') {
        // TASK39: a generic purpose names no building type -- the user picks one (no default); the server fetches that type's Krisha rent
        const typeVal = fmState.overrides.lease_building_type || '';
        const opt = (v, l) => `<option value="${v}"${typeVal === v ? ' selected' : ''}>${l}</option>`;
        html += `<div class="fm-lease-income-controls"><div class="fm-field">
            <label class="text-caption text-secondary" for="fmLeaseBuildingType">Тип здания (для аренды Krisha)</label>
            <select id="fmLeaseBuildingType" class="fm-select" ${editing ? '' : 'disabled'} onchange="fmOnLeaseTypeChange(this.value)">
                ${opt('', rent.not_computed_reason && rent.not_computed_reason.includes('назначение общее') ? 'Выберите тип здания' : 'По назначению лота')}
                ${opt('склад', 'Склад')}${opt('магазин', 'Магазин / торговое помещение')}${opt('офис', 'Офис')}${opt('сервис', 'АЗС / автосервис / автомойка')}${opt('общепит', 'Общепит')}
            </select></div></div>`;
        html += `<div class="fm-lease-income-controls">${fmLeaseMoneyInputHtml(
            'fmLeaseBuildingArea', 'lease_user_building_area_m2',
            'Площадь здания, м²', fmState.overrides.lease_user_building_area_m2, editing,
        )}${fmLeaseMoneyInputHtml(
            'fmLeaseConstructionCost', 'lease_user_construction_cost_per_m2',
            'Моя стоимость стройки, ₸/м²', fmState.overrides.lease_user_construction_cost_per_m2, editing,
        )}</div>`;
        // TASK39 39.2: the end-of-term value only where the lot's own text quotes a buy-out / extension right
        if (rent.end_of_term_right && rent.end_of_term_right.quote) {
            html += `<p class="text-caption text-tertiary">В описании лота: «${escapeHtml(rent.end_of_term_right.quote)}» — условия (цена, срок) в документах не указаны, введите свою оценку.</p>`
                + `<div class="fm-lease-income-controls">${fmLeaseMoneyInputHtml(
                    'fmLeaseResidual', 'lease_user_residual_kzt',
                    'С продлением / выкупом: стоимость объекта в конце срока, ₸', fmState.overrides.lease_user_residual_kzt, editing,
                )}</div>`;
        }
    } else if (rent.strategy === 'S4') {
        html += `<div class="fm-lease-income-controls">${fmLeaseMoneyInputHtml(
            'fmLeaseMonthlyIncome', 'lease_user_monthly_income',
            'Мой ожидаемый доход, ₸/мес', fmState.overrides.lease_user_monthly_income, editing,
        )}${fmLeaseMoneyInputHtml(
            'fmLeaseTempCost', 'lease_user_temp_object_cost',
            'Стоимость временного объекта, ₸', fmState.overrides.lease_user_temp_object_cost, editing,
        )}</div>`;
    }

    el.innerHTML = html;
}

function fmRenderDeposit() {
    const mine = fmState.model.cost_lines?.find(l => l.key === 'deposit');
    const ai = fmState.aiDefaultModel.cost_lines?.find(l => l.key === 'deposit');
    const el = document.getElementById('fmDeposit');
    if (!mine) { el.innerHTML = ''; return; }
    // item 8: capital locked into the deal, not a cost -- own label,
    // own block (dashboard.css .fm-deposit), never mixed into the cost
    // rows below.
    const explain = fmExplainTrigger(mine.explain);
    el.innerHTML = `
        <span class="fm-table-row-label text-body text-primary">Гарантийный взнос (в счёт оплаты)${explain ? ' ' + explain.button : ''}</span>
        <span class="fm-deposit-mine text-body font-mono-nums">${fmMoney(mine.amount)}</span>
        <span class="fm-deposit-ai text-body font-mono-nums">${ai ? fmMoney(ai.amount) : 'нет оценки'}</span>
        ${explain ? explain.panel : ''}
    `;
}

function fmRenderTable() {
    const body = document.getElementById('fmTableBody');
    const mine = fmState.model;
    const ai = fmState.aiDefaultModel;
    const aiByKey = new Map((ai.cost_lines || []).map(l => [l.key, l]));
    let html = '';
    (mine.cost_lines || []).filter(l => l.key !== 'deposit').forEach(line => {
        const aiLine = aiByKey.get(line.key);
        const explain = fmExplainTrigger(line.explain);
        html += `<div class="fm-table-row">
            <span class="fm-table-row-label text-body text-primary">${line.label}${explain ? ' ' + explain.button : ''}</span>
            <span class="fm-table-row-mine text-body font-mono-nums">${fmMoney(line.amount)}</span>
            <span class="fm-table-row-ai text-body font-mono-nums">${aiLine ? fmMoney(aiLine.amount) : 'нет оценки'}</span>
            ${explain ? explain.panel : ''}
        </div>`;
    });
    // Цена продажи — отдельная строка sale.mid, не входит в cost_lines.
    // TASK29 29.5: своя цена пользователя — без дисконта, подпись это говорит.
    const saleLabel = fmState.mode === 'mine' && mine.sale && mine.sale.user_set ? 'Цена продажи (ваша)' : 'Цена продажи (после дисконта)';
    html += `<div class="fm-table-row">
        <span class="fm-table-row-label text-body text-primary">${saleLabel}</span>
        <span class="fm-table-row-mine text-body font-mono-nums">${fmMoney(mine.sale?.mid)}</span>
        <span class="fm-table-row-ai text-body font-mono-nums">${fmMoney(ai.sale?.mid)}</span>
    </div>`;
    body.innerHTML = html;
}

// item 4: no internal keys in the warnings the investor reads. Human
// sentences mapped by the STABLE cost-line key in ONE place
// (FM_WARNING_BY_UNVERIFIED_KEY/FM_WARNING_BY_LINE_KEY, top of this
// file) -- built directly from cost_lines (amount === null), not by
// parsing model.warnings' own "«label» не учтено (key)" string. Other
// model.warnings entries (curve population, floor unknown, margin
// infeasible, VAT note...) are already clean human sentences and pass
// through unfiltered -- only the "«label» не учтено (...)" pattern is
// excluded here, to avoid showing the same fact twice.
const FM_UNACCOUNTED_PATTERN = /^«.*»\s+не учтено\s+\(.*\)$/;
// TASK14 14.3f (item 3): check_recycle_fee_by_vin only ever reports
// paid/unpaid -- never a KZT figure (see finance/inputs.py's
// utilization_fee_vin_status comment) -- so this is its own status line,
// never folded into the "«Утилизационный сбор» не учтено" cost warning.
// TASK14 14.6 (owner): "unknown" used to mean nothing rendered -- a real
// VIN check that came back inconclusive (service answered, but neither
// found:true/false nor any recognised status text -- see
// external_parsers.py::check_recycle_fee_by_vin) must say so, not go
// silent. `undefined`/no key (VIN absent from the description entirely,
// or the field predates 14.3f) still renders nothing -- see
// fmRenderWarnings' `|| null` fallback below, unchanged.
const FM_VIN_STATUS_HTML = {
    paid: '<span class="text-secondary">Утильсбор по VIN: оплачен</span>',
    unpaid: '<span class="text-warn">Утильсбор по VIN: не оплачен — сумма не рассчитана</span>',
    unknown: '<span class="text-secondary">Утильсбор по VIN: сервис не дал ответа</span>',
};
function fmRenderWarnings() {
    const el = document.getElementById('fmWarnings');
    const m = fmState.mode === 'mine' ? fmState.model : fmState.aiDefaultModel;
    const vinWarning = FM_VIN_STATUS_HTML[m.utilization_fee_vin_status] || null;
    const costWarnings = (m.cost_lines || [])
        .filter(l => l.amount === null)
        .map(l => FM_WARNING_BY_UNVERIFIED_KEY[l.unverified_key] || FM_WARNING_BY_LINE_KEY[l.key] || `«${l.label}»: не учтено`);
    const otherWarnings = (m.warnings || []).filter(w => !FM_UNACCOUNTED_PATTERN.test(w));
    el.innerHTML = [...(vinWarning ? [vinWarning] : []), ...costWarnings, ...otherWarnings].map(w => `<div>${w}</div>`).join('');
}

function fmRenderTotals() {
    const mine = fmState.model.results || {};
    const ai = fmState.aiDefaultModel.results || {};
    const mineNeg = (mine.profit_mid || 0) < 0;
    const aiNeg = (ai.profit_mid || 0) < 0;
    const cap = fmState.model.capital || {};
    const aiCap = fmState.aiDefaultModel.capital || {};
    // item 5: explain comes from fmState.explain (finance.explain.explain()
    // over the CURRENT/saved model -- see GET/PUT's own `explain` field);
    // there is no separate explain for the ai-default model, so in "Мои
    // цифры" mode with active overrides the trigger reflects the saved
    // model's own derivation, same limitation as the cost-row triggers
    // above (those use each line's own .explain, always accurate for the
    // primary column regardless of mode).
    const ex = fmState.explain || {};
    // TASK29 29.5: налог — тот же taxes.total, что уже вычтен в «Чистой
    // прибыли» (finance/model.py); подпись и формула — из модели на экране.
    const shown = fmState.mode === 'mine' ? fmState.model : fmState.aiDefaultModel;
    const mineTax = fmState.model.taxes || {};
    const aiTax = fmState.aiDefaultModel.taxes || {};
    const rows = [
        {
            label: (shown.taxes && shown.taxes.label) || 'Налог с дохода',
            explain: shown.taxes && shown.taxes.explain,
            mine: fmMoney(mineTax.total), ai: fmMoney(aiTax.total),
        },
        {
            label: 'Чистая прибыль', explain: ex['results.profit_mid'],
            mine: `<span class="${mineNeg ? 'text-neg' : 'text-pos'}">${fmMoney(mine.profit_mid)}</span>`,
            ai: `<span class="${aiNeg ? 'text-neg' : 'text-pos'}">${fmMoney(ai.profit_mid)}</span>`,
        },
        { label: 'ROI на капитал', explain: ex['results.roi_mid'], mine: fmPct(mine.roi_mid), ai: fmPct(ai.roi_mid) },
        { label: 'IRR годовых', explain: ex['results.irr'], mine: fmPct(mine.irr), ai: fmPct(ai.irr) },
        { label: 'Пик капитала', explain: ex['capital.peak'], mine: fmMoney(cap.peak), ai: fmMoney(aiCap.peak) },
        { label: 'Безубыточная цена входа', explain: ex['results.break_even_purchase'], mine: fmMoney(mine.break_even_purchase), ai: fmMoney(ai.break_even_purchase) },
        { label: 'Макс. ставка при заданной марже', explain: ex['results.max_bid'], mine: fmMoney(mine.max_bid), ai: fmMoney(ai.max_bid) },
    ];
    // Собраны через .fm-table-row (не .report-fin-row) -- те же классы,
    // что у строк затрат, чтобы наследовать и mobile-коллапс ghost-в-
    // подпись (item 7), и одноколоночный режим "Оценка ИИ" (item 6).
    document.getElementById('fmTotals').innerHTML = rows.map(r => {
        const explain = fmExplainTrigger(r.explain);
        return `<div class="fm-table-row">
        <span class="fm-table-row-label text-body text-primary">${r.label}${explain ? ' ' + explain.button : ''}</span>
        <span class="fm-table-row-mine text-body font-mono-nums">${r.mine}</span>
        <span class="fm-table-row-ai text-body font-mono-nums">${r.ai}</span>
        ${explain ? explain.panel : ''}
    </div>`;
    }).join('');
}

function fmRenderScenarios() {
    const m = fmState.mode === 'mine' ? fmState.model : fmState.aiDefaultModel;
    const headline = m.scenarios?.headline || [];
    const wrap = document.getElementById('fmScenarioTiles');
    wrap.innerHTML = headline.map(cell => {
        const neg = (cell.profit || 0) < 0;
        const label = FM_HEADLINE_LABEL[cell.label] || cell.label;
        return `<div class="fm-scenario-tile">
            <span class="text-caption text-secondary">${label}</span>
            <span class="fm-scenario-profit ${neg ? 'text-neg' : 'text-pos'}">${fmMoney(cell.profit)}</span>
            <span class="text-caption text-tertiary font-mono-nums">${fmPct(cell.roi)}</span>
        </div>`;
    }).join('');
}

function fmRenderSensitivity() {
    const cells = fmSensitivityCells();
    const grid = document.getElementById('fmSensitivityGrid');
    const panel = document.getElementById('fmSensitivityPanel');
    if (!cells.length) { panel.classList.add('hidden'); grid.innerHTML = ''; grid.style.gridTemplateColumns = ''; return; }
    panel.classList.remove('hidden');
    const m = fmState.mode === 'mine' ? fmState.model : fmState.aiDefaultModel;
    const levels = ['low', 'mid', 'high'];
    grid.style.gridTemplateColumns = `1fr repeat(${levels.length}, 1fr)`;
    let html = `<div class="fm-sensitivity-cell text-caption text-secondary">${fmIsAscendingGrid(cells) ? 'Точка' : 'Шаг'}</div>`;
    levels.forEach(lv => { html += `<div class="fm-sensitivity-cell text-caption text-secondary">${FM_SALE_LEVEL_LABEL[lv]}</div>`; });
    if (fmIsAscendingGrid(cells)) {
        // item 1: ascending rows are curve percentiles (start/p25/median/
        // p75), same points+order as the ladder above -- never "шаг K".
        const points = fmAscendingPoints(cells);
        const startPrice = points.length ? points[0][1] : null;
        const chosenIndex = fmChosenPointIndex(points, true, m);
        const byLabelLevel = new Map(cells.map(c => [`${c.ratio_label}:${c.sale_level}`, c]));
        points.forEach(([label, price], i) => {
            const chosenRow = i === chosenIndex;
            const caption = fmAscendingPointCaption(label, price, startPrice);
            html += `<div class="fm-sensitivity-cell font-mono-nums${chosenRow ? ' fm-sensitivity-row--chosen' : ''}">${caption}${chosenRow ? ' ◉' : ''}</div>`;
            levels.forEach(lv => {
                const cell = byLabelLevel.get(`${label}:${lv}`);
                const neg = cell && cell.profit < 0;
                html += `<div class="fm-sensitivity-cell font-mono-nums${chosenRow ? ' fm-sensitivity-row--chosen' : ''} ${neg ? 'text-neg' : ''}">${cell ? fmMoney(cell.profit) : '—'}</div>`;
            });
        });
    } else {
        const steps = fmDescendingSteps(cells);
        const byStepLevel = new Map(cells.map(c => [`${c.step_k}:${c.sale_level}`, c]));
        const chosenStep = m.purchase?.step_k;
        // TASK16 16.0.1: ETP's terminal step is last_step_price, not the
        // unreachable floor_price -- see fmFloorLabelPrice.
        const { price: floorLabelPrice } = fmFloorLabelPrice(m);
        steps.forEach(([k, price]) => {
            const chosenRow = k === chosenStep;
            // item 2: same floor labelling as the ladder above -- "пол",
            // not a bare step number, when this row's price is the floor.
            const stepLabel = (floorLabelPrice != null && price === floorLabelPrice) ? 'пол' : `шаг ${k}`;
            html += `<div class="fm-sensitivity-cell font-mono-nums${chosenRow ? ' fm-sensitivity-row--chosen' : ''}" title="${fmMoney(price)}">${stepLabel} · ${fmState.priceFormatter(price)}${chosenRow ? ' ◉' : ''}</div>`;
            levels.forEach(lv => {
                const cell = byStepLevel.get(`${k}:${lv}`);
                const neg = cell && cell.profit < 0;
                html += `<div class="fm-sensitivity-cell font-mono-nums${chosenRow ? ' fm-sensitivity-row--chosen' : ''} ${neg ? 'text-neg' : ''}">${cell ? fmMoney(cell.profit) : '—'}</div>`;
            });
        });
    }
    grid.innerHTML = html;
}

function fmRenderNarrative() {
    const panel = document.getElementById('fmNarrativePanel');
    const body = document.getElementById('fmNarrativeBody');
    const hasOverrides = fmActualOverrideKeys().length > 0;
    panel.classList.remove('hidden');
    // item 1 (14.3d): narrate_model is never called for a lease lot (no
    // numbers to narrate, see analyzer.py::_apply_finance_engine) -- the
    // section that would hold «Вывод по модели» shows the engine's own
    // warning instead of an empty/missing-narrative message.
    if (fmIsLease()) {
        const m = fmState.mode === 'mine' ? fmState.model : fmState.aiDefaultModel;
        if (m.mode === 'lease') {
            // TASK21 21.4 (owner review, item 4): the real land-lease
            // model has real numbers to summarise -- strategy, expected
            // entry, break-even -- not just a "perepродажа неприменима"
            // placeholder left over from the old lease_unsupported shape.
            const rent = m.rent;
            const strategyLabel = FM_LEASE_STRATEGY_LABEL[rent.strategy] || rent.strategy || '—';
            const entryLine = fmLeaseEntryLine(rent);
            const conditionLine = fmLeaseConditionSentence(rent);
            body.innerHTML = `<p class="text-body text-primary">Стратегия: ${escapeHtml(strategyLabel)}</p>`
                + `<p class="text-caption text-secondary font-mono-nums">${escapeHtml(entryLine)}</p>`
                + (conditionLine ? `<p class="text-caption text-secondary">${escapeHtml(conditionLine)}</p>` : '');
            return;
        }
        // mode === 'lease_unsupported' (the defensive premises fallback)
        // -- unchanged, no real numbers exist to summarise here.
        body.innerHTML = leaseMarketHasData(currentAiReport && currentAiReport.lease_market)
            ? `<p class="text-caption text-tertiary">Право аренды: модель перепродажи неприменима — рыночные ориентиры в блоке «Вердикт».</p>`
            : `<p class="text-caption text-tertiary">Право аренды: модель перепродажи неприменима — показаны только условия входа.</p>`;
        return;
    }
    // TASK16 16.0.1 item 2: a failed re-narrate (16.0's ETP entry-price
    // fix) leaves the OLD narrative in place, still quoting the pre-fix
    // price/profit -- financial_narrative_stale marks that explicitly.
    // Never show a narrative that contradicts the just-recomputed
    // numbers; hide it outright rather than caveat it (contrast
    // fmNarrativeStaleCaption below -- a softer divergence note for the
    // ordinary "recompute moved since analysis time" case, where a fresh
    // narrative still exists, just possibly behind current numbers).
    if (currentAiReport && currentAiReport.financial_narrative_stale) {
        body.innerHTML = `<p class="text-caption text-tertiary">Вывод по модели устарел после пересчёта и скрыт — цифры выше уже актуальны.</p>`;
        return;
    }
    // item 9: reports from before TASK14 14.2 have no stored
    // financial_narrative -- a muted explanatory line instead of hiding
    // the whole panel (silently missing content reads as broken, not
    // "not applicable yet").
    if (!fmState.narrative) {
        body.innerHTML = `<p class="text-caption text-tertiary">Вывод по модели появится в новых отчётах.</p>`;
        return;
    }
    if (hasOverrides) {
        body.innerHTML = `<p class="text-caption text-tertiary">Вывод ИИ относится к оценке ИИ — пересчитайте наблюдения самостоятельно по вашим цифрам выше.</p>`;
        return;
    }
    const n = fmState.narrative;
    body.innerHTML = `${fmNarrativeStaleCaption()}<p>${n.conclusion}</p><p class="text-caption text-secondary">${n.key_driver}</p><p class="text-caption text-tertiary">${n.watch_out}</p>`;
}

// TASK14 14.4 (owner addition to 14.3f's report): the stored narrative
// text is frozen at analysis time (narrate_model() runs once, see
// analyzer.py::_apply_finance_engine) -- if the engine/constants moved
// since (e.g. THIS session's 14.3f floor fix), the narrative can go on
// citing a purchase price the current recompute no longer agrees with.
// Found live: report 3576's narrative still said "10 971 891 ₸" after
// the floor fix made the recompute say "10 500 000". Pure numeric
// comparison against the stored `raw_report.financial_model` snapshot --
// no LLM call, and this never runs when overrides are active (that
// branch above already hides the AI narrative for a different reason).
function fmNarrativeStaleCaption() {
    const stored = currentAiReport && currentAiReport.financial_model;
    const current = fmState.aiDefaultModel;
    if (!stored || !current || !stored.purchase || !current.purchase) return '';
    const priceDiffers = stored.purchase.price !== current.purchase.price;
    const storedProfit = stored.results ? stored.results.profit_mid : null;
    const currentProfit = current.results ? current.results.profit_mid : null;
    const profitDiffers = (storedProfit ?? null) !== (currentProfit ?? null);
    if (!priceDiffers && !profitDiffers) return '';
    const dateStr = fmtDateTime(currentAiReport.analysis_generated_at) || 'момента анализа';
    return `<p class="text-caption text-tertiary fm-narrative-stale">Вывод сформирован по расчёту от ${dateStr}; текущий расчёт отличается — см. таблицу.</p>`;
}

// --- ADMIN: ПОЛНОЕ УДАЛЕНИЕ ТАРИФА ---


// Тумблеры "-50%" (глобальный/персональный) убраны вместе с их
// эндпоинтами на бэкенде. Единственная админская скидка кроме периода —
// users.active_discount_percent, отображаем её как read-only в карточке.

// 🔥 БАГ (было): дергали /api/billing/promo — старый Redis-эндпоинт для
// одноразовых промокодов, которые раньше создавались через /api/admin/promo
// (тоже писал в Redis). Админка давно переехала на "промокоды нового
// поколения" — создаёт их через /api/admin/promo/v2 в таблице promo_codes
// (Supabase), а этот редимпшен-хендлер на клиенте так и остался смотреть
// в Redis, где этих кодов никогда не было. Поэтому ЛЮБОЙ код, созданный в
// консоли, всегда отдавал "промокод недействителен или уже был использован".
// Исправлено: используем /api/billing/promo/v2 (RPC redeem_promo_code в
// Supabase — атомарно проверяет тег/лимит/срок). Ответ на успех теперь
// {success, discount_type, value} вместо старого {amount} — сообщение
// собираем по типу скидки.
window.redeemPromoCode = async (btnEl) => {
    const code = prompt("Введите промокод:");
    if (!code) return;

    try {
        await withButtonBusy(btnEl, 'Проверка...', async () => {
            const res = await fetch('/api/billing/promo/v2', {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({ user_id: userId, code: code.trim() })
            });
            const data = await res.json();

            if (res.ok) {
                const messages = {
                    fixed_credits: `✅ Успешно! Вам начислено ${data.value} вечных кредитов.`,
                    free_days: `✅ Успешно! Подписка продлена на ${data.value} дн.`,
                    percent: `✅ Успешно! Активирована скидка ${data.value}%.`,
                };
                tg.showAlert(messages[data.discount_type] || '✅ Промокод активирован.');
                authUser(); // Обновляем баланс
            } else {
                tg.showAlert(`❌ Ошибка: ${data.detail}`);
            }
        });
    } catch (e) {
        tg.showAlert("Ошибка соединения с сервером.");
    }
};

// ============================================================
// 🏷️ ТЕГИ, АВТОМАТИЗАЦИЯ, ПРОМОКОДЫ v2 (с таргетингом на тег)
// ============================================================

let allTagsCache = [];

function tagBadgeHtml(tag) {
    const color = tag.color || '#3b82f6';
    return `<span class="text-[10px] font-bold px-2 py-1 rounded-full" style="background:${color}22; color:${color}; border:1px solid ${color}55;">${tag.name}</span>`;
}





// ============================================================
// 💰 ВЫРУЧКА И ПЛАТЕЖИ (GOD MODE)
// ============================================================


const PAYMENT_STATUS_LABELS = {
    pending: { text: 'ожидает', color: '#f59e0b' },
    approved: { text: 'одобрено', color: '#10b981' },
    rejected: { text: 'отклонено', color: '#ef4444' },
};


